(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (setImmediate){
/*************************
 * Croppie
 * Copyright 2019
 * Foliotek
 * Version: 2.6.5
 *************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        module.exports = factory();
    } else {
        // Browser globals
        root.Croppie = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {

    /* Polyfills */
    if (typeof Promise !== 'function') {
        /*! promise-polyfill 3.1.0 */
        !function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!==typeof this)throw new TypeError("Promises must be constructed via new");if("function"!==typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"===typeof a||"function"===typeof a)){var c=a.then;if("function"===typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"===typeof a?a:null,this.onRejected="function"===typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j=setTimeout,k="function"===typeof setImmediate&&setImmediate||function(a){j(a,1)},l=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"===typeof g||"function"===typeof g)){var h=g.then;if("function"===typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"===typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},c._setImmediateFn=function(a){k=a},"undefined"!==typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)}(this);
    }

    if (typeof window !== 'undefined' && typeof window.CustomEvent !== "function") {
        (function(){
            function CustomEvent ( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: undefined };
                var evt = document.createEvent( 'CustomEvent' );
                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }
            CustomEvent.prototype = window.Event.prototype;
            window.CustomEvent = CustomEvent;
        }());
    }

    if (typeof HTMLCanvasElement !== 'undefined' && !HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function (callback, type, quality) {
                var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
                len = binStr.length,
                arr = new Uint8Array(len);

                for (var i=0; i<len; i++ ) {
                    arr[i] = binStr.charCodeAt(i);
                }

                callback( new Blob( [arr], {type: type || 'image/png'} ) );
            }
        });
    }
    /* End Polyfills */

    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
        emptyStyles = typeof document !== 'undefined' ? document.createElement('div').style : {},
        EXIF_NORM = [1,8,3,6],
        EXIF_FLIP = [2,7,4,5],
        CSS_TRANS_ORG,
        CSS_TRANSFORM,
        CSS_USERSELECT;

    function vendorPrefix(prop) {
        if (prop in emptyStyles) {
            return prop;
        }

        var capProp = prop[0].toUpperCase() + prop.slice(1),
            i = cssPrefixes.length;

        while (i--) {
            prop = cssPrefixes[i] + capProp;
            if (prop in emptyStyles) {
                return prop;
            }
        }
    }

    CSS_TRANSFORM = vendorPrefix('transform');
    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
    CSS_USERSELECT = vendorPrefix('userSelect');

    function getExifOffset(ornt, rotate) {
        var arr = EXIF_NORM.indexOf(ornt) > -1 ? EXIF_NORM : EXIF_FLIP,
            index = arr.indexOf(ornt),
            offset = (rotate / 90) % arr.length;// 180 = 2%4 = 2 shift exif by 2 indexes

        return arr[(arr.length + index + (offset % arr.length)) % arr.length];
    }

    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
    function deepExtend(destination, source) {
        destination = destination || {};
        for (var property in source) {
            if (source[property] && source[property].constructor && source[property].constructor === Object) {
                destination[property] = destination[property] || {};
                deepExtend(destination[property], source[property]);
            } else {
                destination[property] = source[property];
            }
        }
        return destination;
    }

    function clone(object) {
        return deepExtend({}, object);
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function dispatchChange(element) {
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            element.dispatchEvent(evt);
        }
        else {
            element.fireEvent("onchange");
        }
    }

    //http://jsperf.com/vanilla-css
    function css(el, styles, val) {
        if (typeof (styles) === 'string') {
            var tmp = styles;
            styles = {};
            styles[tmp] = val;
        }

        for (var prop in styles) {
            el.style[prop] = styles[prop];
        }
    }

    function addClass(el, c) {
        if (el.classList) {
            el.classList.add(c);
        }
        else {
            el.className += ' ' + c;
        }
    }

    function removeClass(el, c) {
        if (el.classList) {
            el.classList.remove(c);
        }
        else {
            el.className = el.className.replace(c, '');
        }
    }

    function setAttributes(el, attrs) {
        for (var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    function num(v) {
        return parseInt(v, 10);
    }

    /* Utilities */
    function loadImage(src, doExif) {
        if (!src) { throw 'Source image missing'; }
        
        var img = new Image();
        img.style.opacity = '0';
        return new Promise(function (resolve, reject) {
            function _resolve() {
                img.style.opacity = '1';
                setTimeout(function () {
                    resolve(img);
                }, 1);
            }

            img.removeAttribute('crossOrigin');
            if (src.match(/^https?:\/\/|^\/\//)) {
                img.setAttribute('crossOrigin', 'anonymous');
            }

            img.onload = function () {
                if (doExif) {
                    EXIF.getData(img, function () {
                        _resolve();
                    });
                }
                else {
                    _resolve();
                }
            };
            img.onerror = function (ev) {
                img.style.opacity = 1;
                setTimeout(function () {
                    reject(ev);
                }, 1);
            };
            img.src = src;
        });
    }

    function naturalImageDimensions(img, ornt) {
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        var orient = ornt || getExifOrientation(img);
        if (orient && orient >= 5) {
            var x= w;
            w = h;
            h = x;
        }
        return { width: w, height: h };
    }

    /* CSS Transform Prototype */
    var TRANSLATE_OPTS = {
        'translate3d': {
            suffix: ', 0px'
        },
        'translate': {
            suffix: ''
        }
    };
    var Transform = function (x, y, scale) {
        this.x = parseFloat(x);
        this.y = parseFloat(y);
        this.scale = parseFloat(scale);
    };

    Transform.parse = function (v) {
        if (v.style) {
            return Transform.parse(v.style[CSS_TRANSFORM]);
        }
        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
            return Transform.fromMatrix(v);
        }
        else {
            return Transform.fromString(v);
        }
    };

    Transform.fromMatrix = function (v) {
        var vals = v.substring(7).split(',');
        if (!vals.length || v === 'none') {
            vals = [1, 0, 0, 1, 0, 0];
        }

        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
    };

    Transform.fromString = function (v) {
        var values = v.split(') '),
            translate = values[0].substring(Croppie.globals.translate.length + 1).split(','),
            scale = values.length > 1 ? values[1].substring(6) : 1,
            x = translate.length > 1 ? translate[0] : 0,
            y = translate.length > 1 ? translate[1] : 0;

        return new Transform(x, y, scale);
    };

    Transform.prototype.toString = function () {
        var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
        return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
    };

    var TransformOrigin = function (el) {
        if (!el || !el.style[CSS_TRANS_ORG]) {
            this.x = 0;
            this.y = 0;
            return;
        }
        var css = el.style[CSS_TRANS_ORG].split(' ');
        this.x = parseFloat(css[0]);
        this.y = parseFloat(css[1]);
    };

    TransformOrigin.prototype.toString = function () {
        return this.x + 'px ' + this.y + 'px';
    };

    function getExifOrientation (img) {
        return img.exifdata && img.exifdata.Orientation ? num(img.exifdata.Orientation) : 1;
    }

    function drawCanvas(canvas, img, orientation) {
        var width = img.width,
            height = img.height,
            ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.save();
        switch (orientation) {
          case 2:
             ctx.translate(width, 0);
             ctx.scale(-1, 1);
             break;

          case 3:
              ctx.translate(width, height);
              ctx.rotate(180*Math.PI/180);
              break;

          case 4:
              ctx.translate(0, height);
              ctx.scale(1, -1);
              break;

          case 5:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90*Math.PI/180);
              ctx.scale(1, -1);
              break;

          case 6:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90*Math.PI/180);
              ctx.translate(0, -height);
              break;

          case 7:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(-90*Math.PI/180);
              ctx.translate(-width, height);
              ctx.scale(1, -1);
              break;

          case 8:
              canvas.width = height;
              canvas.height = width;
              ctx.translate(0, width);
              ctx.rotate(-90*Math.PI/180);
              break;
        }
        ctx.drawImage(img, 0,0, width, height);
        ctx.restore();
    }

    /* Private Methods */
    function _create() {
        var self = this,
            contClass = 'croppie-container',
            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
            boundary, img, viewport, overlay, bw, bh;

        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
        // Properties on class
        self.data = {};
        self.elements = {};

        boundary = self.elements.boundary = document.createElement('div');
        viewport = self.elements.viewport = document.createElement('div');
        img = self.elements.img = document.createElement('img');
        overlay = self.elements.overlay = document.createElement('div');

        if (self.options.useCanvas) {
            self.elements.canvas = document.createElement('canvas');
            self.elements.preview = self.elements.canvas;
        }
        else {
            self.elements.preview = img;
        }

        addClass(boundary, 'cr-boundary');
        boundary.setAttribute('aria-dropeffect', 'none');
        bw = self.options.boundary.width;
        bh = self.options.boundary.height;
        css(boundary, {
            width: (bw + (isNaN(bw) ? '' : 'px')),
            height: (bh + (isNaN(bh) ? '' : 'px'))
        });

        addClass(viewport, 'cr-viewport');
        if (customViewportClass) {
            addClass(viewport, customViewportClass);
        }
        css(viewport, {
            width: self.options.viewport.width + 'px',
            height: self.options.viewport.height + 'px'
        });
        viewport.setAttribute('tabindex', 0);

        addClass(self.elements.preview, 'cr-image');
        setAttributes(self.elements.preview, { 'alt': 'preview', 'aria-grabbed': 'false' });
        addClass(overlay, 'cr-overlay');

        self.element.appendChild(boundary);
        boundary.appendChild(self.elements.preview);
        boundary.appendChild(viewport);
        boundary.appendChild(overlay);

        addClass(self.element, contClass);
        if (self.options.customClass) {
            addClass(self.element, self.options.customClass);
        }

        _initDraggable.call(this);

        if (self.options.enableZoom) {
            _initializeZoom.call(self);
        }

        // if (self.options.enableOrientation) {
        //     _initRotationControls.call(self);
        // }

        if (self.options.enableResize) {
            _initializeResize.call(self);
        }
    }

    // function _initRotationControls () {
    //     var self = this,
    //         wrap, btnLeft, btnRight, iLeft, iRight;

    //     wrap = document.createElement('div');
    //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
    //     self.elements.orientationBtnRight = btnRight = document.createElement('button');

    //     wrap.appendChild(btnLeft);
    //     wrap.appendChild(btnRight);

    //     iLeft = document.createElement('i');
    //     iRight = document.createElement('i');
    //     btnLeft.appendChild(iLeft);
    //     btnRight.appendChild(iRight);

    //     addClass(wrap, 'cr-rotate-controls');
    //     addClass(btnLeft, 'cr-rotate-l');
    //     addClass(btnRight, 'cr-rotate-r');

    //     self.elements.boundary.appendChild(wrap);

    //     btnLeft.addEventListener('click', function () {
    //         self.rotate(-90);
    //     });
    //     btnRight.addEventListener('click', function () {
    //         self.rotate(90);
    //     });
    // }

    function _hasExif() {
        return this.options.enableExif && window.EXIF;
    }

    function _initializeResize () {
        var self = this;
        var wrap = document.createElement('div');
        var isDragging = false;
        var direction;
        var originalX;
        var originalY;
        var minSize = 50;
        var maxWidth;
        var maxHeight;
        var vr;
        var hr;

        addClass(wrap, 'cr-resizer');
        css(wrap, {
            width: this.options.viewport.width + 'px',
            height: this.options.viewport.height + 'px'
        });

        if (this.options.resizeControls.height) {
            vr = document.createElement('div');
            addClass(vr, 'cr-resizer-vertical');
            wrap.appendChild(vr);
        }

        if (this.options.resizeControls.width) {
            hr = document.createElement('div');
            addClass(hr, 'cr-resizer-horisontal');
            wrap.appendChild(hr);
        }

        function mouseDown(ev) {
            if (ev.button !== undefined && ev.button !== 0) return;

            ev.preventDefault();
            if (isDragging) {
                return;
            }

            var overlayRect = self.elements.overlay.getBoundingClientRect();

            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;
            direction = ev.currentTarget.className.indexOf('vertical') !== -1 ? 'v' : 'h';
            maxWidth = overlayRect.width;
            maxHeight = overlayRect.height;

            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }

            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
        }

        function mouseMove(ev) {
            var pageX = ev.pageX;
            var pageY = ev.pageY;

            ev.preventDefault();

            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }

            var deltaX = pageX - originalX;
            var deltaY = pageY - originalY;
            var newHeight = self.options.viewport.height + deltaY;
            var newWidth = self.options.viewport.width + deltaX;

            if (direction === 'v' && newHeight >= minSize && newHeight <= maxHeight) {
                css(wrap, {
                    height: newHeight + 'px'
                });

                self.options.boundary.height += deltaY;
                css(self.elements.boundary, {
                    height: self.options.boundary.height + 'px'
                });

                self.options.viewport.height += deltaY;
                css(self.elements.viewport, {
                    height: self.options.viewport.height + 'px'
                });
            }
            else if (direction === 'h' && newWidth >= minSize && newWidth <= maxWidth) {
                css(wrap, {
                    width: newWidth + 'px'
                });

                self.options.boundary.width += deltaX;
                css(self.elements.boundary, {
                    width: self.options.boundary.width + 'px'
                });

                self.options.viewport.width += deltaX;
                css(self.elements.viewport, {
                    width: self.options.viewport.width + 'px'
                });
            }

            _updateOverlay.call(self);
            _updateZoomLimits.call(self);
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalY = pageY;
            originalX = pageX;
        }

        function mouseUp() {
            isDragging = false;
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
        }

        if (vr) {
            vr.addEventListener('mousedown', mouseDown);
            vr.addEventListener('touchstart', mouseDown);
        }

        if (hr) {
            hr.addEventListener('mousedown', mouseDown);
            hr.addEventListener('touchstart', mouseDown);
        }

        this.elements.boundary.appendChild(wrap);
    }

    function _setZoomerVal(v) {
        if (this.options.enableZoom) {
            var z = this.elements.zoomer,
                val = fix(v, 4);

            z.value = Math.max(parseFloat(z.min), Math.min(parseFloat(z.max), val)).toString();
        }
    }

    function _initializeZoom() {
        var self = this,
            wrap = self.elements.zoomerWrap = document.createElement('div'),
            zoomer = self.elements.zoomer = document.createElement('input');

        addClass(wrap, 'cr-slider-wrap');
        addClass(zoomer, 'cr-slider');
        zoomer.type = 'range';
        zoomer.step = '0.0001';
        zoomer.value = '1';
        zoomer.style.display = self.options.showZoomer ? '' : 'none';
        zoomer.setAttribute('aria-label', 'zoom');

        self.element.appendChild(wrap);
        wrap.appendChild(zoomer);

        self._currentZoom = 1;

        function change() {
            _onZoom.call(self, {
                value: parseFloat(zoomer.value),
                origin: new TransformOrigin(self.elements.preview),
                viewportRect: self.elements.viewport.getBoundingClientRect(),
                transform: Transform.parse(self.elements.preview)
            });
        }

        function scroll(ev) {
            var delta, targetZoom;

            if(self.options.mouseWheelZoom === 'ctrl' && ev.ctrlKey !== true){
              return 0;
            } else if (ev.wheelDelta) {
                delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
            } else if (ev.deltaY) {
                delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
            } else if (ev.detail) {
                delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
            } else {
                delta = 0;
            }

            targetZoom = self._currentZoom + (delta * self._currentZoom);

            ev.preventDefault();
            _setZoomerVal.call(self, targetZoom);
            change.call(self);
        }

        self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
        self.elements.zoomer.addEventListener('change', change);

        if (self.options.mouseWheelZoom) {
            self.elements.boundary.addEventListener('mousewheel', scroll);
            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
        }
    }

    function _onZoom(ui) {
        var self = this,
            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview);

        function applyCss() {
            var transCss = {};
            transCss[CSS_TRANSFORM] = transform.toString();
            transCss[CSS_TRANS_ORG] = origin.toString();
            css(self.elements.preview, transCss);
        }

        self._currentZoom = ui ? ui.value : self._currentZoom;
        transform.scale = self._currentZoom;
        self.elements.zoomer.setAttribute('aria-valuenow', self._currentZoom);
        applyCss();

        if (self.options.enforceBoundary) {
            var boundaries = _getVirtualBoundaries.call(self, vpRect),
                transBoundaries = boundaries.translate,
                oBoundaries = boundaries.origin;

            if (transform.x >= transBoundaries.maxX) {
                origin.x = oBoundaries.minX;
                transform.x = transBoundaries.maxX;
            }

            if (transform.x <= transBoundaries.minX) {
                origin.x = oBoundaries.maxX;
                transform.x = transBoundaries.minX;
            }

            if (transform.y >= transBoundaries.maxY) {
                origin.y = oBoundaries.minY;
                transform.y = transBoundaries.maxY;
            }

            if (transform.y <= transBoundaries.minY) {
                origin.y = oBoundaries.maxY;
                transform.y = transBoundaries.minY;
            }
        }
        applyCss();
        _debouncedOverlay.call(self);
        _triggerUpdate.call(self);
    }

    function _getVirtualBoundaries(viewport) {
        var self = this,
            scale = self._currentZoom,
            vpWidth = viewport.width,
            vpHeight = viewport.height,
            centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
            centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
            imgRect = self.elements.preview.getBoundingClientRect(),
            curImgWidth = imgRect.width,
            curImgHeight = imgRect.height,
            halfWidth = vpWidth / 2,
            halfHeight = vpHeight / 2;

        var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
        var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));

        var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
        var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));

        var originMinX = (1 / scale) * halfWidth;
        var originMaxX = (curImgWidth * (1 / scale)) - originMinX;

        var originMinY = (1 / scale) * halfHeight;
        var originMaxY = (curImgHeight * (1 / scale)) - originMinY;

        return {
            translate: {
                maxX: maxX,
                minX: minX,
                maxY: maxY,
                minY: minY
            },
            origin: {
                maxX: originMaxX,
                minX: originMinX,
                maxY: originMaxY,
                minY: originMinY
            }
        };
    }

    function _updateCenterPoint(rotate) {
        var self = this,
            scale = self._currentZoom,
            data = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
            pc = new TransformOrigin(self.elements.preview),
            top = (vpData.top - data.top) + (vpData.height / 2),
            left = (vpData.left - data.left) + (vpData.width / 2),
            center = {},
            adj = {};

        if (rotate) {
            var cx = pc.x;
            var cy = pc.y;
            var tx = transform.x;
            var ty = transform.y;

            center.y = cx;
            center.x = cy;
            transform.y = tx;
            transform.x = ty;
        }
        else {
            center.y = top / scale;
            center.x = left / scale;

            adj.y = (center.y - pc.y) * (1 - scale);
            adj.x = (center.x - pc.x) * (1 - scale);

            transform.x -= adj.x;
            transform.y -= adj.y;
        }

        var newCss = {};
        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
        newCss[CSS_TRANSFORM] = transform.toString();
        css(self.elements.preview, newCss);
    }

    function _initDraggable() {
        var self = this,
            isDragging = false,
            originalX,
            originalY,
            originalDistance,
            vpRect,
            transform;

        function assignTransformCoordinates(deltaX, deltaY) {
            var imgRect = self.elements.preview.getBoundingClientRect(),
                top = transform.y + deltaY,
                left = transform.x + deltaX;

            if (self.options.enforceBoundary) {
                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
                    transform.y = top;
                }

                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
                    transform.x = left;
                }
            }
            else {
                transform.y = top;
                transform.x = left;
            }
        }

        function toggleGrabState(isDragging) {
          self.elements.preview.setAttribute('aria-grabbed', isDragging);
          self.elements.boundary.setAttribute('aria-dropeffect', isDragging? 'move': 'none');
        }

        function keyDown(ev) {
            var LEFT_ARROW  = 37,
                UP_ARROW    = 38,
                RIGHT_ARROW = 39,
                DOWN_ARROW  = 40;

            if (ev.shiftKey && (ev.keyCode === UP_ARROW || ev.keyCode === DOWN_ARROW)) {
                var zoom;
                if (ev.keyCode === UP_ARROW) {
                    zoom = parseFloat(self.elements.zoomer.value) + parseFloat(self.elements.zoomer.step)
                }
                else {
                    zoom = parseFloat(self.elements.zoomer.value) - parseFloat(self.elements.zoomer.step)
                }
                self.setZoom(zoom);
            }
            else if (self.options.enableKeyMovement && (ev.keyCode >= 37 && ev.keyCode <= 40)) {
                ev.preventDefault();
                var movement = parseKeyDown(ev.keyCode);

                transform = Transform.parse(self.elements.preview);
                document.body.style[CSS_USERSELECT] = 'none';
                vpRect = self.elements.viewport.getBoundingClientRect();
                keyMove(movement);
            }

            function parseKeyDown(key) {
                switch (key) {
                    case LEFT_ARROW:
                        return [1, 0];
                    case UP_ARROW:
                        return [0, 1];
                    case RIGHT_ARROW:
                        return [-1, 0];
                    case DOWN_ARROW:
                        return [0, -1];
                }
            }
        }

        function keyMove(movement) {
            var deltaX = movement[0],
                deltaY = movement[1],
                newCss = {};

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        function mouseDown(ev) {
            if (ev.button !== undefined && ev.button !== 0) return;

            ev.preventDefault();
            if (isDragging) return;
            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }
            toggleGrabState(isDragging);
            transform = Transform.parse(self.elements.preview);
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
            vpRect = self.elements.viewport.getBoundingClientRect();
        }

        function mouseMove(ev) {
            ev.preventDefault();
            var pageX = ev.pageX,
                pageY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }

            var deltaX = pageX - originalX,
                deltaY = pageY - originalY,
                newCss = {};

            if (ev.type === 'touchmove') {
                if (ev.touches.length > 1) {
                    var touch1 = ev.touches[0];
                    var touch2 = ev.touches[1];
                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));

                    if (!originalDistance) {
                        originalDistance = dist / self._currentZoom;
                    }

                    var scale = dist / originalDistance;

                    _setZoomerVal.call(self, scale);
                    dispatchChange(self.elements.zoomer);
                    return;
                }
            }

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            originalY = pageY;
            originalX = pageX;
        }

        function mouseUp() {
            isDragging = false;
            toggleGrabState(isDragging);
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        self.elements.overlay.addEventListener('mousedown', mouseDown);
        self.elements.viewport.addEventListener('keydown', keyDown);
        self.elements.overlay.addEventListener('touchstart', mouseDown);
    }

    function _updateOverlay() {
        if (!this.elements) return; // since this is debounced, it can be fired after destroy
        var self = this,
            boundRect = self.elements.boundary.getBoundingClientRect(),
            imgData = self.elements.preview.getBoundingClientRect();

        css(self.elements.overlay, {
            width: imgData.width + 'px',
            height: imgData.height + 'px',
            top: (imgData.top - boundRect.top) + 'px',
            left: (imgData.left - boundRect.left) + 'px'
        });
    }
    var _debouncedOverlay = debounce(_updateOverlay, 500);

    function _triggerUpdate() {
        var self = this,
            data = self.get();

        if (!_isVisible.call(self)) {
            return;
        }

        self.options.update.call(self, data);
        if (self.$ && typeof Prototype === 'undefined') {
            self.$(self.element).trigger('update.croppie', data);
        }
        else {
            var ev;
            if (window.CustomEvent) {
                ev = new CustomEvent('update', { detail: data });
            } else {
                ev = document.createEvent('CustomEvent');
                ev.initCustomEvent('update', true, true, data);
            }

            self.element.dispatchEvent(ev);
        }
    }

    function _isVisible() {
        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
    }

    function _updatePropertiesFromImage() {
        var self = this,
            initialZoom = 1,
            cssReset = {},
            img = self.elements.preview,
            imgData,
            transformReset = new Transform(0, 0, initialZoom),
            originReset = new TransformOrigin(),
            isVisible = _isVisible.call(self);

        if (!isVisible || self.data.bound) {// if the croppie isn't visible or it doesn't need binding
            return;
        }

        self.data.bound = true;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        cssReset[CSS_TRANS_ORG] = originReset.toString();
        cssReset['opacity'] = 1;
        css(img, cssReset);

        imgData = self.elements.preview.getBoundingClientRect();

        self._originalImageWidth = imgData.width;
        self._originalImageHeight = imgData.height;
        self.data.orientation = _hasExif.call(self) ? getExifOrientation(self.elements.img) : self.data.orientation;

        if (self.options.enableZoom) {
            _updateZoomLimits.call(self, true);
        }
        else {
            self._currentZoom = initialZoom;
        }

        transformReset.scale = self._currentZoom;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        css(img, cssReset);

        if (self.data.points.length) {
            _bindPoints.call(self, self.data.points);
        }
        else {
            _centerImage.call(self);
        }

        _updateCenterPoint.call(self);
        _updateOverlay.call(self);
    }

    function _updateZoomLimits (initial) {
        var self = this,
            minZoom = Math.max(self.options.minZoom, 0) || 0,
            maxZoom = self.options.maxZoom || 1.5,
            initialZoom,
            defaultInitialZoom,
            zoomer = self.elements.zoomer,
            scale = parseFloat(zoomer.value),
            boundaryData = self.elements.boundary.getBoundingClientRect(),
            imgData = naturalImageDimensions(self.elements.img, self.data.orientation),
            vpData = self.elements.viewport.getBoundingClientRect(),
            minW,
            minH;
        if (self.options.enforceBoundary) {
            minW = vpData.width / imgData.width;
            minH = vpData.height / imgData.height;
            minZoom = Math.max(minW, minH);
        }

        if (minZoom >= maxZoom) {
            maxZoom = minZoom + 1;
        }

        zoomer.min = fix(minZoom, 4);
        zoomer.max = fix(maxZoom, 4);

        if (!initial && (scale < zoomer.min || scale > zoomer.max)) {
            _setZoomerVal.call(self, scale < zoomer.min ? zoomer.min : zoomer.max);
        }
        else if (initial) {
            defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
            _setZoomerVal.call(self, initialZoom);
        }

        dispatchChange(zoomer);
    }

    function _bindPoints(points) {
        if (points.length !== 4) {
            throw "Croppie - Invalid number of points supplied: " + points;
        }
        var self = this,
            pointsWidth = points[2] - points[0],
            // pointsHeight = points[3] - points[1],
            vpData = self.elements.viewport.getBoundingClientRect(),
            boundRect = self.elements.boundary.getBoundingClientRect(),
            vpOffset = {
                left: vpData.left - boundRect.left,
                top: vpData.top - boundRect.top
            },
            scale = vpData.width / pointsWidth,
            originTop = points[1],
            originLeft = points[0],
            transformTop = (-1 * points[1]) + vpOffset.top,
            transformLeft = (-1 * points[0]) + vpOffset.left,
            newCss = {};

        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
        css(self.elements.preview, newCss);

        _setZoomerVal.call(self, scale);
        self._currentZoom = scale;
    }

    function _centerImage() {
        var self = this,
            imgDim = self.elements.preview.getBoundingClientRect(),
            vpDim = self.elements.viewport.getBoundingClientRect(),
            boundDim = self.elements.boundary.getBoundingClientRect(),
            vpLeft = vpDim.left - boundDim.left,
            vpTop = vpDim.top - boundDim.top,
            w = vpLeft - ((imgDim.width - vpDim.width) / 2),
            h = vpTop - ((imgDim.height - vpDim.height) / 2),
            transform = new Transform(w, h, self._currentZoom);

        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
    }

    function _transferImageToCanvas(customOrientation) {
        var self = this,
            canvas = self.elements.canvas,
            img = self.elements.img,
            ctx = canvas.getContext('2d');

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = img.width;
        canvas.height = img.height;

        var orientation = self.options.enableOrientation && customOrientation || getExifOrientation(img);
        drawCanvas(canvas, img, orientation);
    }

    function _getCanvas(data) {
        var self = this,
            points = data.points,
            left = num(points[0]),
            top = num(points[1]),
            right = num(points[2]),
            bottom = num(points[3]),
            width = right-left,
            height = bottom-top,
            circle = data.circle,
            canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d'),
            startX = 0,
            startY = 0,
            canvasWidth = data.outputWidth || width,
            canvasHeight = data.outputHeight || height;

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        if (data.backgroundColor) {
            ctx.fillStyle = data.backgroundColor;
            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        }

        // By default assume we're going to draw the entire
        // source image onto the destination canvas.
        var sx = left,
            sy = top,
            sWidth = width,
            sHeight = height,
            dx = 0,
            dy = 0,
            dWidth = canvasWidth,
            dHeight = canvasHeight;

        //
        // Do not go outside of the original image's bounds along the x-axis.
        // Handle translations when projecting onto the destination canvas.
        //

        // The smallest possible source x-position is 0.
        if (left < 0) {
            sx = 0;
            dx = (Math.abs(left) / width) * canvasWidth;
        }

        // The largest possible source width is the original image's width.
        if (sWidth + sx > self._originalImageWidth) {
            sWidth = self._originalImageWidth - sx;
            dWidth =  (sWidth / width) * canvasWidth;
        }

        //
        // Do not go outside of the original image's bounds along the y-axis.
        //

        // The smallest possible source y-position is 0.
        if (top < 0) {
            sy = 0;
            dy = (Math.abs(top) / height) * canvasHeight;
        }

        // The largest possible source height is the original image's height.
        if (sHeight + sy > self._originalImageHeight) {
            sHeight = self._originalImageHeight - sy;
            dHeight = (sHeight / height) * canvasHeight;
        }

        // console.table({ left, right, top, bottom, canvasWidth, canvasHeight, width, height, startX, startY, circle, sx, sy, dx, dy, sWidth, sHeight, dWidth, dHeight });

        ctx.drawImage(this.elements.preview, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
        if (circle) {
            ctx.fillStyle = '#fff';
            ctx.globalCompositeOperation = 'destination-in';
            ctx.beginPath();
            ctx.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();
        }
        return canvas;
    }

    function _getHtmlResult(data) {
        var points = data.points,
            div = document.createElement('div'),
            img = document.createElement('img'),
            width = points[2] - points[0],
            height = points[3] - points[1];

        addClass(div, 'croppie-result');
        div.appendChild(img);
        css(img, {
            left: (-1 * points[0]) + 'px',
            top: (-1 * points[1]) + 'px'
        });
        img.src = data.url;
        css(div, {
            width: width + 'px',
            height: height + 'px'
        });

        return div;
    }

    function _getBase64Result(data) {
        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
    }

    function _getBlobResult(data) {
        var self = this;
        return new Promise(function (resolve) {
            _getCanvas.call(self, data).toBlob(function (blob) {
                resolve(blob);
            }, data.format, data.quality);
        });
    }

    function _replaceImage(img) {
        if (this.elements.img.parentNode) {
            Array.prototype.forEach.call(this.elements.img.classList, function(c) { img.classList.add(c); });
            this.elements.img.parentNode.replaceChild(img, this.elements.img);
            this.elements.preview = img; // if the img is attached to the DOM, they're not using the canvas
        }
        this.elements.img = img;
    }

    function _bind(options, cb) {
        var self = this,
            url,
            points = [],
            zoom = null,
            hasExif = _hasExif.call(self);

        if (typeof (options) === 'string') {
            url = options;
            options = {};
        }
        else if (Array.isArray(options)) {
            points = options.slice();
        }
        else if (typeof (options) === 'undefined' && self.data.url) { //refreshing
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            return null;
        }
        else {
            url = options.url;
            points = options.points || [];
            zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
        }

        self.data.bound = false;
        self.data.url = url || self.data.url;
        self.data.boundZoom = zoom;

        return loadImage(url, hasExif).then(function (img) {
            _replaceImage.call(self, img);
            if (!points.length) {
                var natDim = naturalImageDimensions(img);
                var rect = self.elements.viewport.getBoundingClientRect();
                var aspectRatio = rect.width / rect.height;
                var imgAspectRatio = natDim.width / natDim.height;
                var width, height;

                if (imgAspectRatio > aspectRatio) {
                    height = natDim.height;
                    width = height * aspectRatio;
                }
                else {
                    width = natDim.width;
                    height = natDim.height / aspectRatio;
                }

                var x0 = (natDim.width - width) / 2;
                var y0 = (natDim.height - height) / 2;
                var x1 = x0 + width;
                var y1 = y0 + height;
                self.data.points = [x0, y0, x1, y1];
            }
            else if (self.options.relative) {
                points = [
                    points[0] * img.naturalWidth / 100,
                    points[1] * img.naturalHeight / 100,
                    points[2] * img.naturalWidth / 100,
                    points[3] * img.naturalHeight / 100
                ];
            }

            self.data.orientation = options.orientation || 1;
            self.data.points = points.map(function (p) {
                return parseFloat(p);
            });
            if (self.options.useCanvas) {
                _transferImageToCanvas.call(self, self.data.orientation);
            }
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            cb && cb();
        });
    }

    function fix(v, decimalPoints) {
        return parseFloat(v).toFixed(decimalPoints || 0);
    }

    function _get() {
        var self = this,
            imgData = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            x1 = vpData.left - imgData.left,
            y1 = vpData.top - imgData.top,
            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2, //border
            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
            scale = self._currentZoom;

        if (scale === Infinity || isNaN(scale)) {
            scale = 1;
        }

        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
        x1 = Math.max(max, x1 / scale);
        y1 = Math.max(max, y1 / scale);
        x2 = Math.max(max, x2 / scale);
        y2 = Math.max(max, y2 / scale);

        return {
            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
            zoom: scale,
            orientation: self.data.orientation
        };
    }

    var RESULT_DEFAULTS = {
            type: 'canvas',
            format: 'png',
            quality: 1
        },
        RESULT_FORMATS = ['jpeg', 'webp', 'png'];

    function _result(options) {
        var self = this,
            data = _get.call(self),
            opts = deepExtend(clone(RESULT_DEFAULTS), clone(options)),
            resultType = (typeof (options) === 'string' ? options : (opts.type || 'base64')),
            size = opts.size || 'viewport',
            format = opts.format,
            quality = opts.quality,
            backgroundColor = opts.backgroundColor,
            circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
            vpRect = self.elements.viewport.getBoundingClientRect(),
            ratio = vpRect.width / vpRect.height,
            prom;

        if (size === 'viewport') {
            data.outputWidth = vpRect.width;
            data.outputHeight = vpRect.height;
        } else if (typeof size === 'object') {
            if (size.width && size.height) {
                data.outputWidth = size.width;
                data.outputHeight = size.height;
            } else if (size.width) {
                data.outputWidth = size.width;
                data.outputHeight = size.width / ratio;
            } else if (size.height) {
                data.outputWidth = size.height * ratio;
                data.outputHeight = size.height;
            }
        }

        if (RESULT_FORMATS.indexOf(format) > -1) {
            data.format = 'image/' + format;
            data.quality = quality;
        }

        data.circle = circle;
        data.url = self.data.url;
        data.backgroundColor = backgroundColor;

        prom = new Promise(function (resolve) {
            switch(resultType.toLowerCase())
            {
                case 'rawcanvas':
                    resolve(_getCanvas.call(self, data));
                    break;
                case 'canvas':
                case 'base64':
                    resolve(_getBase64Result.call(self, data));
                    break;
                case 'blob':
                    _getBlobResult.call(self, data).then(resolve);
                    break;
                default:
                    resolve(_getHtmlResult.call(self, data));
                    break;
            }
        });
        return prom;
    }

    function _refresh() {
        _updatePropertiesFromImage.call(this);
    }

    function _rotate(deg) {
        if (!this.options.useCanvas || !this.options.enableOrientation) {
            throw 'Croppie: Cannot rotate without enableOrientation && EXIF.js included';
        }

        var self = this,
            canvas = self.elements.canvas;

        self.data.orientation = getExifOffset(self.data.orientation, deg);
        drawCanvas(canvas, self.elements.img, self.data.orientation);
        _updateCenterPoint.call(self, true);
        _updateZoomLimits.call(self);

        // Reverses image dimensions if the degrees of rotation is not divisible by 180.
        if ((Math.abs(deg) / 90) % 2 === 1) {
            var oldHeight = self._originalImageHeight;
            var oldWidth = self._originalImageWidth;
            self._originalImageWidth = oldHeight;
            self._originalImageHeight = oldWidth;
        }
    }

    function _destroy() {
        var self = this;
        self.element.removeChild(self.elements.boundary);
        removeClass(self.element, 'croppie-container');
        if (self.options.enableZoom) {
            self.element.removeChild(self.elements.zoomerWrap);
        }
        delete self.elements;
    }

    if (typeof window !== 'undefined' && window.jQuery) {
        var $ = window.jQuery;
        $.fn.croppie = function (opts) {
            var ot = typeof opts;

            if (ot === 'string') {
                var args = Array.prototype.slice.call(arguments, 1);
                var singleInst = $(this).data('croppie');

                if (opts === 'get') {
                    return singleInst.get();
                }
                else if (opts === 'result') {
                    return singleInst.result.apply(singleInst, args);
                }
                else if (opts === 'bind') {
                    return singleInst.bind.apply(singleInst, args);
                }

                return this.each(function () {
                    var i = $(this).data('croppie');
                    if (!i) return;

                    var method = i[opts];
                    if ($.isFunction(method)) {
                        method.apply(i, args);
                        if (opts === 'destroy') {
                            $(this).removeData('croppie');
                        }
                    }
                    else {
                        throw 'Croppie ' + opts + ' method not found';
                    }
                });
            }
            else {
                return this.each(function () {
                    var i = new Croppie(this, opts);
                    i.$ = $;
                    $(this).data('croppie', i);
                });
            }
        };
    }

    function Croppie(element, opts) {
        if (element.className.indexOf('croppie-container') > -1) {
            throw new Error("Croppie: Can't initialize croppie more than once");
        }
        this.element = element;
        this.options = deepExtend(clone(Croppie.defaults), opts);

        if (this.element.tagName.toLowerCase() === 'img') {
            var origImage = this.element;
            addClass(origImage, 'cr-original-image');
            setAttributes(origImage, {'aria-hidden' : 'true', 'alt' : '' });
            var replacementDiv = document.createElement('div');
            this.element.parentNode.appendChild(replacementDiv);
            replacementDiv.appendChild(origImage);
            this.element = replacementDiv;
            this.options.url = this.options.url || origImage.src;
        }

        _create.call(this);
        if (this.options.url) {
            var bindOpts = {
                url: this.options.url,
                points: this.options.points
            };
            delete this.options['url'];
            delete this.options['points'];
            _bind.call(this, bindOpts);
        }
    }

    Croppie.defaults = {
        viewport: {
            width: 100,
            height: 100,
            type: 'square'
        },
        boundary: { },
        orientationControls: {
            enabled: true,
            leftClass: '',
            rightClass: ''
        },
        resizeControls: {
            width: true,
            height: true
        },
        customClass: '',
        showZoomer: true,
        enableZoom: true,
        enableResize: false,
        mouseWheelZoom: true,
        enableExif: false,
        enforceBoundary: true,
        enableOrientation: false,
        enableKeyMovement: true,
        update: function () { }
    };

    Croppie.globals = {
        translate: 'translate3d'
    };

    deepExtend(Croppie.prototype, {
        bind: function (options, cb) {
            return _bind.call(this, options, cb);
        },
        get: function () {
            var data = _get.call(this);
            var points = data.points;
            if (this.options.relative) {
                points[0] /= this.elements.img.naturalWidth / 100;
                points[1] /= this.elements.img.naturalHeight / 100;
                points[2] /= this.elements.img.naturalWidth / 100;
                points[3] /= this.elements.img.naturalHeight / 100;
            }
            return data;
        },
        result: function (type) {
            return _result.call(this, type);
        },
        refresh: function () {
            return _refresh.call(this);
        },
        setZoom: function (v) {
            _setZoomerVal.call(this, v);
            dispatchChange(this.elements.zoomer);
        },
        rotate: function (deg) {
            _rotate.call(this, deg);
        },
        destroy: function () {
            return _destroy.call(this);
        }
    });
    return Croppie;
}));

}).call(this,require("timers").setImmediate)
},{"timers":11}],2:[function(require,module,exports){
/*
 * International Telephone Input v17.0.3
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

// wrap in UMD
(function(factory) {
    if (typeof module === "object" && module.exports) module.exports = factory(); else window.intlTelInput = factory();
})(function(undefined) {
    "use strict";
    return function() {
        // Array of country objects for the flag dropdown.
        // Here is the criteria for the plugin to support a given country/territory
        // - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        // - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
        // - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
        // - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml
        // Each country array has the following information:
        // [
        //    Country name,
        //    iso2 code,
        //    International dial code,
        //    Order (if >1 country with same dial code),
        //    Area codes
        // ]
        var allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1", 5, [ "684" ] ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1", 6, [ "264" ] ], [ "Antigua and Barbuda", "ag", "1", 7, [ "268" ] ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1", 8, [ "242" ] ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1", 9, [ "246" ] ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1", 10, [ "441" ] ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1", 11, [ "284" ] ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1, [ "3", "4", "7" ] ], [ "Cayman Islands", "ky", "1", 12, [ "345" ] ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2, [ "89164" ] ], [ "Cocos (Keeling) Islands", "cc", "61", 1, [ "89162" ] ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1", 13, [ "767" ] ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1", 14, [ "473" ] ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1", 15, [ "671" ] ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1, [ "1481", "7781", "7839", "7911" ] ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2, [ "1624", "74576", "7524", "7924", "7624" ] ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1", 4, [ "876", "658" ] ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3, [ "1534", "7509", "7700", "7797", "7829", "7937" ] ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1, [ "33", "7" ] ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1, [ "269", "639" ] ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1", 16, [ "664" ] ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1", 17, [ "670" ] ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1", 18, [ "869" ] ], [ "Saint Lucia", "lc", "1", 19, [ "758" ] ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1", 20, [ "784" ] ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1", 21, [ "721" ] ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1, [ "79" ] ], [ "Swaziland", "sz", "268" ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1", 22, [ "868" ] ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1", 23, [ "649" ] ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1", 24, [ "340" ] ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1, [ "06698" ] ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, [ "5288", "5289" ] ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1, [ "18" ] ] ];
        // loop over all of the countries above, restructuring the data to be objects with named keys
        for (var i = 0; i < allCountries.length; i++) {
            var c = allCountries[i];
            allCountries[i] = {
                name: c[0],
                iso2: c[1],
                dialCode: c[2],
                priority: c[3] || 0,
                areaCodes: c[4] || null
            };
        }
        "use strict";
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var intlTelInputGlobals = {
            getInstance: function getInstance(input) {
                var id = input.getAttribute("data-intl-tel-input-id");
                return window.intlTelInputGlobals.instances[id];
            },
            instances: {}
        };
        if (typeof window === "object") window.intlTelInputGlobals = intlTelInputGlobals;
        // these vars persist through all instances of the plugin
        var id = 0;
        var defaults = {
            // whether or not to allow the dropdown
            allowDropdown: true,
            // if there is just a dial code in the input: remove it on blur
            autoHideDialCode: true,
            // add a placeholder in the input with an example number for the selected country
            autoPlaceholder: "polite",
            // modify the parentClass
            customContainer: "",
            // modify the auto placeholder
            customPlaceholder: null,
            // append menu to specified element
            dropdownContainer: null,
            // don't display these countries
            excludeCountries: [],
            // format the input value during initialisation and on setNumber
            formatOnDisplay: true,
            // geoIp lookup function
            geoIpLookup: null,
            // inject a hidden input with this name, and on submit, populate it with the result of getNumber
            hiddenInput: "",
            // initial country
            initialCountry: "",
            // localized country names e.g. { 'de': 'Deutschland' }
            localizedCountries: null,
            // don't insert international dial codes
            nationalMode: true,
            // display only these countries
            onlyCountries: [],
            // number type to use for placeholders
            placeholderNumberType: "MOBILE",
            // the countries at the top of the list. defaults to united states and united kingdom
            preferredCountries: [ "us", "gb" ],
            // display the country dial code next to the selected flag so it's not part of the typed number
            separateDialCode: false,
            // specify the path to the libphonenumber script to enable validation/formatting
            utilsScript: ""
        };
        // https://en.wikipedia.org/wiki/List_of_North_American_Numbering_Plan_area_codes#Non-geographic_area_codes
        var regionlessNanpNumbers = [ "800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889" ];
        if (typeof window === "object") {
            // keep track of if the window.load event has fired as impossible to check after the fact
            window.addEventListener("load", function() {
                // UPDATE: use a public static field so we can fudge it in the tests
                window.intlTelInputGlobals.windowLoaded = true;
            });
        }
        // utility function to iterate over an object. can't use Object.entries or native forEach because
        // of IE11
        var forEachProp = function forEachProp(obj, callback) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length; i++) {
                callback(keys[i], obj[keys[i]]);
            }
        };
        // run a method on each instance of the plugin
        var forEachInstance = function forEachInstance(method) {
            forEachProp(window.intlTelInputGlobals.instances, function(key) {
                window.intlTelInputGlobals.instances[key][method]();
            });
        };
        // this is our plugin class that we will create an instance of
        // eslint-disable-next-line no-unused-vars
        var Iti = /*#__PURE__*/
        function() {
            function Iti(input, options) {
                var _this = this;
                _classCallCheck(this, Iti);
                this.id = id++;
                this.telInput = input;
                this.activeItem = null;
                this.highlightedItem = null;
                // process specified options / defaults
                // alternative to Object.assign, which isn't supported by IE11
                var customOptions = options || {};
                this.options = {};
                forEachProp(defaults, function(key, value) {
                    _this.options[key] = customOptions.hasOwnProperty(key) ? customOptions[key] : value;
                });
                this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
            }
            _createClass(Iti, [ {
                key: "_init",
                value: function _init() {
                    var _this2 = this;
                    // if in nationalMode, disable options relating to dial codes
                    if (this.options.nationalMode) this.options.autoHideDialCode = false;
                    // if separateDialCode then doesn't make sense to A) insert dial code into input
                    // (autoHideDialCode), and B) display national numbers (because we're displaying the country
                    // dial code next to them)
                    if (this.options.separateDialCode) {
                        this.options.autoHideDialCode = this.options.nationalMode = false;
                    }
                    // we cannot just test screen size as some smartphones/website meta tags will report desktop
                    // resolutions
                    // Note: for some reason jasmine breaks if you put this in the main Plugin function with the
                    // rest of these declarations
                    // Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
                    this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    if (this.isMobile) {
                        // trigger the mobile dropdown css
                        document.body.classList.add("iti-mobile");
                        // on mobile, we want a full screen dropdown, so we must append it to the body
                        if (!this.options.dropdownContainer) this.options.dropdownContainer = document.body;
                    }
                    // these promises get resolved when their individual requests complete
                    // this way the dev can do something like iti.promise.then(...) to know when all requests are
                    // complete
                    if (typeof Promise !== "undefined") {
                        var autoCountryPromise = new Promise(function(resolve, reject) {
                            _this2.resolveAutoCountryPromise = resolve;
                            _this2.rejectAutoCountryPromise = reject;
                        });
                        var utilsScriptPromise = new Promise(function(resolve, reject) {
                            _this2.resolveUtilsScriptPromise = resolve;
                            _this2.rejectUtilsScriptPromise = reject;
                        });
                        this.promise = Promise.all([ autoCountryPromise, utilsScriptPromise ]);
                    } else {
                        // prevent errors when Promise doesn't exist
                        this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {};
                        this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {};
                    }
                    // in various situations there could be no country selected initially, but we need to be able
                    // to assume this variable exists
                    this.selectedCountryData = {};
                    // process all the data: onlyCountries, excludeCountries, preferredCountries etc
                    this._processCountryData();
                    // generate the markup
                    this._generateMarkup();
                    // set the initial state of the input value and the selected flag
                    this._setInitialState();
                    // start all of the event listeners: autoHideDialCode, input keydown, selectedFlag click
                    this._initListeners();
                    // utils script, and auto country
                    this._initRequests();
                }
            }, {
                key: "_processCountryData",
                value: function _processCountryData() {
                    // process onlyCountries or excludeCountries array if present
                    this._processAllCountries();
                    // process the countryCodes map
                    this._processCountryCodes();
                    // process the preferredCountries
                    this._processPreferredCountries();
                    // translate countries according to localizedCountries option
                    if (this.options.localizedCountries) this._translateCountriesByLocale();
                    // sort countries by name
                    if (this.options.onlyCountries.length || this.options.localizedCountries) {
                        this.countries.sort(this._countryNameSort);
                    }
                }
            }, {
                key: "_addCountryCode",
                value: function _addCountryCode(iso2, countryCode, priority) {
                    if (countryCode.length > this.countryCodeMaxLen) {
                        this.countryCodeMaxLen = countryCode.length;
                    }
                    if (!this.countryCodes.hasOwnProperty(countryCode)) {
                        this.countryCodes[countryCode] = [];
                    }
                    // bail if we already have this country for this countryCode
                    for (var i = 0; i < this.countryCodes[countryCode].length; i++) {
                        if (this.countryCodes[countryCode][i] === iso2) return;
                    }
                    // check for undefined as 0 is falsy
                    var index = priority !== undefined ? priority : this.countryCodes[countryCode].length;
                    this.countryCodes[countryCode][index] = iso2;
                }
            }, {
                key: "_processAllCountries",
                value: function _processAllCountries() {
                    if (this.options.onlyCountries.length) {
                        var lowerCaseOnlyCountries = this.options.onlyCountries.map(function(country) {
                            return country.toLowerCase();
                        });
                        this.countries = allCountries.filter(function(country) {
                            return lowerCaseOnlyCountries.indexOf(country.iso2) > -1;
                        });
                    } else if (this.options.excludeCountries.length) {
                        var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
                            return country.toLowerCase();
                        });
                        this.countries = allCountries.filter(function(country) {
                            return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
                        });
                    } else {
                        this.countries = allCountries;
                    }
                }
            }, {
                key: "_translateCountriesByLocale",
                value: function _translateCountriesByLocale() {
                    for (var i = 0; i < this.countries.length; i++) {
                        var iso = this.countries[i].iso2.toLowerCase();
                        if (this.options.localizedCountries.hasOwnProperty(iso)) {
                            this.countries[i].name = this.options.localizedCountries[iso];
                        }
                    }
                }
            }, {
                key: "_countryNameSort",
                value: function _countryNameSort(a, b) {
                    return a.name.localeCompare(b.name);
                }
            }, {
                key: "_processCountryCodes",
                value: function _processCountryCodes() {
                    this.countryCodeMaxLen = 0;
                    // here we store just dial codes
                    this.dialCodes = {};
                    // here we store "country codes" (both dial codes and their area codes)
                    this.countryCodes = {};
                    // first: add dial codes
                    for (var i = 0; i < this.countries.length; i++) {
                        var c = this.countries[i];
                        if (!this.dialCodes[c.dialCode]) this.dialCodes[c.dialCode] = true;
                        this._addCountryCode(c.iso2, c.dialCode, c.priority);
                    }
                    // next: add area codes
                    // this is a second loop over countries, to make sure we have all of the "root" countries
                    // already in the map, so that we can access them, as each time we add an area code substring
                    // to the map, we also need to include the "root" country's code, as that also matches
                    for (var _i = 0; _i < this.countries.length; _i++) {
                        var _c = this.countries[_i];
                        // area codes
                        if (_c.areaCodes) {
                            var rootCountryCode = this.countryCodes[_c.dialCode][0];
                            // for each area code
                            for (var j = 0; j < _c.areaCodes.length; j++) {
                                var areaCode = _c.areaCodes[j];
                                // for each digit in the area code to add all partial matches as well
                                for (var k = 1; k < areaCode.length; k++) {
                                    var partialDialCode = _c.dialCode + areaCode.substr(0, k);
                                    // start with the root country, as that also matches this dial code
                                    this._addCountryCode(rootCountryCode, partialDialCode);
                                    this._addCountryCode(_c.iso2, partialDialCode);
                                }
                                // add the full area code
                                this._addCountryCode(_c.iso2, _c.dialCode + areaCode);
                            }
                        }
                    }
                }
            }, {
                key: "_processPreferredCountries",
                value: function _processPreferredCountries() {
                    this.preferredCountries = [];
                    for (var i = 0; i < this.options.preferredCountries.length; i++) {
                        var countryCode = this.options.preferredCountries[i].toLowerCase();
                        var countryData = this._getCountryData(countryCode, false, true);
                        if (countryData) this.preferredCountries.push(countryData);
                    }
                }
            }, {
                key: "_createEl",
                value: function _createEl(name, attrs, container) {
                    var el = document.createElement(name);
                    if (attrs) forEachProp(attrs, function(key, value) {
                        return el.setAttribute(key, value);
                    });
                    if (container) container.appendChild(el);
                    return el;
                }
            }, {
                key: "_generateMarkup",
                value: function _generateMarkup() {
                    // if autocomplete does not exist on the element and its form, then
                    // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can
                    // easily put the plugin in an inconsistent state e.g. the wrong flag selected for the
                    // autocompleted number, which on submit could mean wrong number is saved (esp in nationalMode)
                    if (!this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete"))) {
                        this.telInput.setAttribute("autocomplete", "off");
                    }
                    // containers (mostly for positioning)
                    var parentClass = "iti";
                    if (this.options.allowDropdown) parentClass += " iti--allow-dropdown";
                    if (this.options.separateDialCode) parentClass += " iti--separate-dial-code";
                    if (this.options.customContainer) {
                        parentClass += " ";
                        parentClass += this.options.customContainer;
                    }
                    var wrapper = this._createEl("div", {
                        "class": parentClass
                    });
                    this.telInput.parentNode.insertBefore(wrapper, this.telInput);
                    this.flagsContainer = this._createEl("div", {
                        "class": "iti__flag-container"
                    }, wrapper);
                    wrapper.appendChild(this.telInput);
                    // selected flag (displayed to left of input)
                    this.selectedFlag = this._createEl("div", {
                        "class": "iti__selected-flag",
                        role: "combobox",
                        "aria-owns": "iti-".concat(this.id, "__country-listbox"),
                        "aria-expanded": "false"
                    }, this.flagsContainer);
                    this.selectedFlagInner = this._createEl("div", {
                        "class": "iti__flag"
                    }, this.selectedFlag);
                    if (this.options.separateDialCode) {
                        this.selectedDialCode = this._createEl("div", {
                            "class": "iti__selected-dial-code"
                        }, this.selectedFlag);
                    }
                    if (this.options.allowDropdown) {
                        // make element focusable and tab navigable
                        this.selectedFlag.setAttribute("tabindex", "0");
                        this.dropdownArrow = this._createEl("div", {
                            "class": "iti__arrow"
                        }, this.selectedFlag);
                        // country dropdown: preferred countries, then divider, then all countries
                        this.countryList = this._createEl("ul", {
                            "class": "iti__country-list iti__hide",
                            id: "iti-".concat(this.id, "__country-listbox"),
                            role: "listbox"
                        });
                        if (this.preferredCountries.length) {
                            this._appendListItems(this.preferredCountries, "iti__preferred", true);
                            this._createEl("li", {
                                "class": "iti__divider",
                                role: "separator",
                                "aria-disabled": "true"
                            }, this.countryList);
                        }
                        this._appendListItems(this.countries, "iti__standard");
                        // create dropdownContainer markup
                        if (this.options.dropdownContainer) {
                            this.dropdown = this._createEl("div", {
                                "class": "iti iti--container"
                            });
                            this.dropdown.appendChild(this.countryList);
                        } else {
                            this.flagsContainer.appendChild(this.countryList);
                        }
                    }
                    if (this.options.hiddenInput) {
                        var hiddenInputName = this.options.hiddenInput;
                        var name = this.telInput.getAttribute("name");
                        if (name) {
                            var i = name.lastIndexOf("[");
                            // if input name contains square brackets, then give the hidden input the same name,
                            // replacing the contents of the last set of brackets with the given hiddenInput name
                            if (i !== -1) hiddenInputName = "".concat(name.substr(0, i), "[").concat(hiddenInputName, "]");
                        }
                        this.hiddenInput = this._createEl("input", {
                            type: "hidden",
                            name: hiddenInputName
                        });
                        wrapper.appendChild(this.hiddenInput);
                    }
                }
            }, {
                key: "_appendListItems",
                value: function _appendListItems(countries, className, preferred) {
                    // we create so many DOM elements, it is faster to build a temp string
                    // and then add everything to the DOM in one go at the end
                    var tmp = "";
                    // for each country
                    for (var i = 0; i < countries.length; i++) {
                        var c = countries[i];
                        var idSuffix = preferred ? "-preferred" : "";
                        // open the list item
                        tmp += "<li class='iti__country ".concat(className, "' tabIndex='-1' id='iti-").concat(this.id, "__item-").concat(c.iso2).concat(idSuffix, "' role='option' data-dial-code='").concat(c.dialCode, "' data-country-code='").concat(c.iso2, "'>");
                        // add the flag
                        tmp += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(c.iso2, "'></div></div>");
                        // and the country name and dial code
                        tmp += "<span class='iti__country-name'>".concat(c.name, "</span>");
                        tmp += "<span class='iti__dial-code'>+".concat(c.dialCode, "</span>");
                        // close the list item
                        tmp += "</li>";
                    }
                    this.countryList.insertAdjacentHTML("beforeend", tmp);
                }
            }, {
                key: "_setInitialState",
                value: function _setInitialState() {
                    var val = this.telInput.value;
                    var dialCode = this._getDialCode(val);
                    var isRegionlessNanp = this._isRegionlessNanp(val);
                    var _this$options = this.options, initialCountry = _this$options.initialCountry, nationalMode = _this$options.nationalMode, autoHideDialCode = _this$options.autoHideDialCode, separateDialCode = _this$options.separateDialCode;
                    // if we already have a dial code, and it's not a regionlessNanp, we can go ahead and set the
                    // flag, else fall back to the default country
                    if (dialCode && !isRegionlessNanp) {
                        this._updateFlagFromNumber(val);
                    } else if (initialCountry !== "auto") {
                        // see if we should select a flag
                        if (initialCountry) {
                            this._setFlag(initialCountry.toLowerCase());
                        } else {
                            if (dialCode && isRegionlessNanp) {
                                // has intl dial code, is regionless nanp, and no initialCountry, so default to US
                                this._setFlag("us");
                            } else {
                                // no dial code and no initialCountry, so default to first in list
                                this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;
                                if (!val) {
                                    this._setFlag(this.defaultCountry);
                                }
                            }
                        }
                        // if empty and no nationalMode and no autoHideDialCode then insert the default dial code
                        if (!val && !nationalMode && !autoHideDialCode && !separateDialCode) {
                            this.telInput.value = "+".concat(this.selectedCountryData.dialCode);
                        }
                    }
                    // NOTE: if initialCountry is set to auto, that will be handled separately
                    // format - note this wont be run after _updateDialCode as that's only called if no val
                    if (val) this._updateValFromNumber(val);
                }
            }, {
                key: "_initListeners",
                value: function _initListeners() {
                    this._initKeyListeners();
                    if (this.options.autoHideDialCode) this._initBlurListeners();
                    if (this.options.allowDropdown) this._initDropdownListeners();
                    if (this.hiddenInput) this._initHiddenInputListener();
                }
            }, {
                key: "_initHiddenInputListener",
                value: function _initHiddenInputListener() {
                    var _this3 = this;
                    this._handleHiddenInputSubmit = function() {
                        _this3.hiddenInput.value = _this3.getNumber();
                    };
                    if (this.telInput.form) this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
                }
            }, {
                key: "_getClosestLabel",
                value: function _getClosestLabel() {
                    var el = this.telInput;
                    while (el && el.tagName !== "LABEL") {
                        el = el.parentNode;
                    }
                    return el;
                }
            }, {
                key: "_initDropdownListeners",
                value: function _initDropdownListeners() {
                    var _this4 = this;
                    // hack for input nested inside label (which is valid markup): clicking the selected-flag to
                    // open the dropdown would then automatically trigger a 2nd click on the input which would
                    // close it again
                    this._handleLabelClick = function(e) {
                        // if the dropdown is closed, then focus the input, else ignore the click
                        if (_this4.countryList.classList.contains("iti__hide")) _this4.telInput.focus(); else e.preventDefault();
                    };
                    var label = this._getClosestLabel();
                    if (label) label.addEventListener("click", this._handleLabelClick);
                    // toggle country dropdown on click
                    this._handleClickSelectedFlag = function() {
                        // only intercept this event if we're opening the dropdown
                        // else let it bubble up to the top ("click-off-to-close" listener)
                        // we cannot just stopPropagation as it may be needed to close another instance
                        if (_this4.countryList.classList.contains("iti__hide") && !_this4.telInput.disabled && !_this4.telInput.readOnly) {
                            _this4._showDropdown();
                        }
                    };
                    this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag);
                    // open dropdown list if currently focused
                    this._handleFlagsContainerKeydown = function(e) {
                        var isDropdownHidden = _this4.countryList.classList.contains("iti__hide");
                        if (isDropdownHidden && [ "ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter" ].indexOf(e.key) !== -1) {
                            // prevent form from being submitted if "ENTER" was pressed
                            e.preventDefault();
                            // prevent event from being handled again by document
                            e.stopPropagation();
                            _this4._showDropdown();
                        }
                        // allow navigation from dropdown to input on TAB
                        if (e.key === "Tab") _this4._closeDropdown();
                    };
                    this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
                }
            }, {
                key: "_initRequests",
                value: function _initRequests() {
                    var _this5 = this;
                    // if the user has specified the path to the utils script, fetch it on window.load, else resolve
                    if (this.options.utilsScript && !window.intlTelInputUtils) {
                        // if the plugin is being initialised after the window.load event has already been fired
                        if (window.intlTelInputGlobals.windowLoaded) {
                            window.intlTelInputGlobals.loadUtils(this.options.utilsScript);
                        } else {
                            // wait until the load event so we don't block any other requests e.g. the flags image
                            window.addEventListener("load", function() {
                                window.intlTelInputGlobals.loadUtils(_this5.options.utilsScript);
                            });
                        }
                    } else this.resolveUtilsScriptPromise();
                    if (this.options.initialCountry === "auto") this._loadAutoCountry(); else this.resolveAutoCountryPromise();
                }
            }, {
                key: "_loadAutoCountry",
                value: function _loadAutoCountry() {
                    // 3 options:
                    // 1) already loaded (we're done)
                    // 2) not already started loading (start)
                    // 3) already started loading (do nothing - just wait for loading callback to fire)
                    if (window.intlTelInputGlobals.autoCountry) {
                        this.handleAutoCountry();
                    } else if (!window.intlTelInputGlobals.startedLoadingAutoCountry) {
                        // don't do this twice!
                        window.intlTelInputGlobals.startedLoadingAutoCountry = true;
                        if (typeof this.options.geoIpLookup === "function") {
                            this.options.geoIpLookup(function(countryCode) {
                                window.intlTelInputGlobals.autoCountry = countryCode.toLowerCase();
                                // tell all instances the auto country is ready
                                // TODO: this should just be the current instances
                                // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight
                                // away (e.g. if they have already done the geo ip lookup somewhere else). Using
                                // setTimeout means that the current thread of execution will finish before executing
                                // this, which allows the plugin to finish initialising.
                                setTimeout(function() {
                                    return forEachInstance("handleAutoCountry");
                                });
                            }, function() {
                                return forEachInstance("rejectAutoCountryPromise");
                            });
                        }
                    }
                }
            }, {
                key: "_initKeyListeners",
                value: function _initKeyListeners() {
                    var _this6 = this;
                    // update flag on keyup
                    this._handleKeyupEvent = function() {
                        if (_this6._updateFlagFromNumber(_this6.telInput.value)) {
                            _this6._triggerCountryChange();
                        }
                    };
                    this.telInput.addEventListener("keyup", this._handleKeyupEvent);
                    // update flag on cut/paste events (now supported in all major browsers)
                    this._handleClipboardEvent = function() {
                        // hack because "paste" event is fired before input is updated
                        setTimeout(_this6._handleKeyupEvent);
                    };
                    this.telInput.addEventListener("cut", this._handleClipboardEvent);
                    this.telInput.addEventListener("paste", this._handleClipboardEvent);
                }
            }, {
                key: "_cap",
                value: function _cap(number) {
                    var max = this.telInput.getAttribute("maxlength");
                    return max && number.length > max ? number.substr(0, max) : number;
                }
            }, {
                key: "_initBlurListeners",
                value: function _initBlurListeners() {
                    var _this7 = this;
                    // on blur or form submit: if just a dial code then remove it
                    this._handleSubmitOrBlurEvent = function() {
                        _this7._removeEmptyDialCode();
                    };
                    if (this.telInput.form) this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent);
                    this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
                }
            }, {
                key: "_removeEmptyDialCode",
                value: function _removeEmptyDialCode() {
                    if (this.telInput.value.charAt(0) === "+") {
                        var numeric = this._getNumeric(this.telInput.value);
                        // if just a plus, or if just a dial code
                        if (!numeric || this.selectedCountryData.dialCode === numeric) {
                            this.telInput.value = "";
                        }
                    }
                }
            }, {
                key: "_getNumeric",
                value: function _getNumeric(s) {
                    return s.replace(/\D/g, "");
                }
            }, {
                key: "_trigger",
                value: function _trigger(name) {
                    // have to use old school document.createEvent as IE11 doesn't support `new Event()` syntax
                    var e = document.createEvent("Event");
                    e.initEvent(name, true, true);
                    // can bubble, and is cancellable
                    this.telInput.dispatchEvent(e);
                }
            }, {
                key: "_showDropdown",
                value: function _showDropdown() {
                    this.countryList.classList.remove("iti__hide");
                    this.selectedFlag.setAttribute("aria-expanded", "true");
                    this._setDropdownPosition();
                    // update highlighting and scroll to active list item
                    if (this.activeItem) {
                        this._highlightListItem(this.activeItem, false);
                        this._scrollTo(this.activeItem, true);
                    }
                    // bind all the dropdown-related listeners: mouseover, click, click-off, keydown
                    this._bindDropdownListeners();
                    // update the arrow
                    this.dropdownArrow.classList.add("iti__arrow--up");
                    this._trigger("open:countrydropdown");
                }
            }, {
                key: "_toggleClass",
                value: function _toggleClass(el, className, shouldHaveClass) {
                    if (shouldHaveClass && !el.classList.contains(className)) el.classList.add(className); else if (!shouldHaveClass && el.classList.contains(className)) el.classList.remove(className);
                }
            }, {
                key: "_setDropdownPosition",
                value: function _setDropdownPosition() {
                    var _this8 = this;
                    if (this.options.dropdownContainer) {
                        this.options.dropdownContainer.appendChild(this.dropdown);
                    }
                    if (!this.isMobile) {
                        var pos = this.telInput.getBoundingClientRect();
                        // windowTop from https://stackoverflow.com/a/14384091/217866
                        var windowTop = window.pageYOffset || document.documentElement.scrollTop;
                        var inputTop = pos.top + windowTop;
                        var dropdownHeight = this.countryList.offsetHeight;
                        // dropdownFitsBelow = (dropdownBottom < windowBottom)
                        var dropdownFitsBelow = inputTop + this.telInput.offsetHeight + dropdownHeight < windowTop + window.innerHeight;
                        var dropdownFitsAbove = inputTop - dropdownHeight > windowTop;
                        // by default, the dropdown will be below the input. If we want to position it above the
                        // input, we add the dropup class.
                        this._toggleClass(this.countryList, "iti__country-list--dropup", !dropdownFitsBelow && dropdownFitsAbove);
                        // if dropdownContainer is enabled, calculate postion
                        if (this.options.dropdownContainer) {
                            // by default the dropdown will be directly over the input because it's not in the flow.
                            // If we want to position it below, we need to add some extra top value.
                            var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.offsetHeight;
                            // calculate placement
                            this.dropdown.style.top = "".concat(inputTop + extraTop, "px");
                            this.dropdown.style.left = "".concat(pos.left + document.body.scrollLeft, "px");
                            // close menu on window scroll
                            this._handleWindowScroll = function() {
                                return _this8._closeDropdown();
                            };
                            window.addEventListener("scroll", this._handleWindowScroll);
                        }
                    }
                }
            }, {
                key: "_getClosestListItem",
                value: function _getClosestListItem(target) {
                    var el = target;
                    while (el && el !== this.countryList && !el.classList.contains("iti__country")) {
                        el = el.parentNode;
                    }
                    // if we reached the countryList element, then return null
                    return el === this.countryList ? null : el;
                }
            }, {
                key: "_bindDropdownListeners",
                value: function _bindDropdownListeners() {
                    var _this9 = this;
                    // when mouse over a list item, just highlight that one
                    // we add the class "highlight", so if they hit "enter" we know which one to select
                    this._handleMouseoverCountryList = function(e) {
                        // handle event delegation, as we're listening for this event on the countryList
                        var listItem = _this9._getClosestListItem(e.target);
                        if (listItem) _this9._highlightListItem(listItem, false);
                    };
                    this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList);
                    // listen for country selection
                    this._handleClickCountryList = function(e) {
                        var listItem = _this9._getClosestListItem(e.target);
                        if (listItem) _this9._selectListItem(listItem);
                    };
                    this.countryList.addEventListener("click", this._handleClickCountryList);
                    // click off to close
                    // (except when this initial opening click is bubbling up)
                    // we cannot just stopPropagation as it may be needed to close another instance
                    var isOpening = true;
                    this._handleClickOffToClose = function() {
                        if (!isOpening) _this9._closeDropdown();
                        isOpening = false;
                    };
                    document.documentElement.addEventListener("click", this._handleClickOffToClose);
                    // listen for up/down scrolling, enter to select, or letters to jump to country name.
                    // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
                    // just hit down and hold it to scroll down (no keyup event).
                    // listen on the document because that's where key events are triggered if no input has focus
                    var query = "";
                    var queryTimer = null;
                    this._handleKeydownOnDropdown = function(e) {
                        // prevent down key from scrolling the whole page,
                        // and enter key from submitting a form etc
                        e.preventDefault();
                        // up and down to navigate
                        if (e.key === "ArrowUp" || e.key === "Up" || e.key === "ArrowDown" || e.key === "Down") _this9._handleUpDownKey(e.key); else if (e.key === "Enter") _this9._handleEnterKey(); else if (e.key === "Escape") _this9._closeDropdown(); else if (/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(e.key)) {
                            // jump to countries that start with the query string
                            if (queryTimer) clearTimeout(queryTimer);
                            query += e.key.toLowerCase();
                            _this9._searchForCountry(query);
                            // if the timer hits 1 second, reset the query
                            queryTimer = setTimeout(function() {
                                query = "";
                            }, 1e3);
                        }
                    };
                    document.addEventListener("keydown", this._handleKeydownOnDropdown);
                }
            }, {
                key: "_handleUpDownKey",
                value: function _handleUpDownKey(key) {
                    var next = key === "ArrowUp" || key === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
                    if (next) {
                        // skip the divider
                        if (next.classList.contains("iti__divider")) {
                            next = key === "ArrowUp" || key === "Up" ? next.previousElementSibling : next.nextElementSibling;
                        }
                        this._highlightListItem(next, true);
                    }
                }
            }, {
                key: "_handleEnterKey",
                value: function _handleEnterKey() {
                    if (this.highlightedItem) this._selectListItem(this.highlightedItem);
                }
            }, {
                key: "_searchForCountry",
                value: function _searchForCountry(query) {
                    for (var i = 0; i < this.countries.length; i++) {
                        if (this._startsWith(this.countries[i].name, query)) {
                            var listItem = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(this.countries[i].iso2));
                            // update highlighting and scroll
                            this._highlightListItem(listItem, false);
                            this._scrollTo(listItem, true);
                            break;
                        }
                    }
                }
            }, {
                key: "_startsWith",
                value: function _startsWith(a, b) {
                    return a.substr(0, b.length).toLowerCase() === b;
                }
            }, {
                key: "_updateValFromNumber",
                value: function _updateValFromNumber(originalNumber) {
                    var number = originalNumber;
                    if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
                        var useNational = !this.options.separateDialCode && (this.options.nationalMode || number.charAt(0) !== "+");
                        var _intlTelInputUtils$nu = intlTelInputUtils.numberFormat, NATIONAL = _intlTelInputUtils$nu.NATIONAL, INTERNATIONAL = _intlTelInputUtils$nu.INTERNATIONAL;
                        var format = useNational ? NATIONAL : INTERNATIONAL;
                        number = intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
                    }
                    number = this._beforeSetNumber(number);
                    this.telInput.value = number;
                }
            }, {
                key: "_updateFlagFromNumber",
                value: function _updateFlagFromNumber(originalNumber) {
                    // if we're in nationalMode and we already have US/Canada selected, make sure the number starts
                    // with a +1 so _getDialCode will be able to extract the area code
                    // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag
                    // from the number), that means we're initialising the plugin with a number that already has a
                    // dial code, so fine to ignore this bit
                    var number = originalNumber;
                    var selectedDialCode = this.selectedCountryData.dialCode;
                    var isNanp = selectedDialCode === "1";
                    if (number && this.options.nationalMode && isNanp && number.charAt(0) !== "+") {
                        if (number.charAt(0) !== "1") number = "1".concat(number);
                        number = "+".concat(number);
                    }
                    // update flag if user types area code for another country
                    if (this.options.separateDialCode && selectedDialCode && number.charAt(0) !== "+") {
                        number = "+".concat(selectedDialCode).concat(number);
                    }
                    // try and extract valid dial code from input
                    var dialCode = this._getDialCode(number, true);
                    var numeric = this._getNumeric(number);
                    var countryCode = null;
                    if (dialCode) {
                        var countryCodes = this.countryCodes[this._getNumeric(dialCode)];
                        // check if the right country is already selected. this should be false if the number is
                        // longer than the matched dial code because in this case we need to make sure that if
                        // there are multiple country matches, that the first one is selected (note: we could
                        // just check that here, but it requires the same loop that we already have later)
                        var alreadySelected = countryCodes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
                        var isRegionlessNanpNumber = selectedDialCode === "1" && this._isRegionlessNanp(numeric);
                        // only update the flag if:
                        // A) NOT (we currently have a NANP flag selected, and the number is a regionlessNanp)
                        // AND
                        // B) the right country is not already selected
                        if (!isRegionlessNanpNumber && !alreadySelected) {
                            // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first
                            // non-empty index
                            for (var j = 0; j < countryCodes.length; j++) {
                                if (countryCodes[j]) {
                                    countryCode = countryCodes[j];
                                    break;
                                }
                            }
                        }
                    } else if (number.charAt(0) === "+" && numeric.length) {
                        // invalid dial code, so empty
                        // Note: use getNumeric here because the number has not been formatted yet, so could contain
                        // bad chars
                        countryCode = "";
                    } else if (!number || number === "+") {
                        // empty, or just a plus, so default
                        countryCode = this.defaultCountry;
                    }
                    if (countryCode !== null) {
                        return this._setFlag(countryCode);
                    }
                    return false;
                }
            }, {
                key: "_isRegionlessNanp",
                value: function _isRegionlessNanp(number) {
                    var numeric = this._getNumeric(number);
                    if (numeric.charAt(0) === "1") {
                        var areaCode = numeric.substr(1, 3);
                        return regionlessNanpNumbers.indexOf(areaCode) !== -1;
                    }
                    return false;
                }
            }, {
                key: "_highlightListItem",
                value: function _highlightListItem(listItem, shouldFocus) {
                    var prevItem = this.highlightedItem;
                    if (prevItem) prevItem.classList.remove("iti__highlight");
                    this.highlightedItem = listItem;
                    this.highlightedItem.classList.add("iti__highlight");
                    if (shouldFocus) this.highlightedItem.focus();
                }
            }, {
                key: "_getCountryData",
                value: function _getCountryData(countryCode, ignoreOnlyCountriesOption, allowFail) {
                    var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
                    for (var i = 0; i < countryList.length; i++) {
                        if (countryList[i].iso2 === countryCode) {
                            return countryList[i];
                        }
                    }
                    if (allowFail) {
                        return null;
                    }
                    throw new Error("No country data for '".concat(countryCode, "'"));
                }
            }, {
                key: "_setFlag",
                value: function _setFlag(countryCode) {
                    var prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
                    // do this first as it will throw an error and stop if countryCode is invalid
                    this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
                    // update the defaultCountry - we only need the iso2 from now on, so just store that
                    if (this.selectedCountryData.iso2) {
                        this.defaultCountry = this.selectedCountryData.iso2;
                    }
                    this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(countryCode));
                    // update the selected country's title attribute
                    var title = countryCode ? "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : "Unknown";
                    this.selectedFlag.setAttribute("title", title);
                    if (this.options.separateDialCode) {
                        var dialCode = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
                        this.selectedDialCode.innerHTML = dialCode;
                        // offsetWidth is zero if input is in a hidden container during initialisation
                        var selectedFlagWidth = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
                        // add 6px of padding after the grey selected-dial-code box, as this is what we use in the css
                        this.telInput.style.paddingLeft = "".concat(selectedFlagWidth + 6, "px");
                    }
                    // and the input's placeholder
                    this._updatePlaceholder();
                    // update the active list item
                    if (this.options.allowDropdown) {
                        var prevItem = this.activeItem;
                        if (prevItem) {
                            prevItem.classList.remove("iti__active");
                            prevItem.setAttribute("aria-selected", "false");
                        }
                        if (countryCode) {
                            // check if there is a preferred item first, else fall back to standard
                            var nextItem = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(countryCode, "-preferred")) || this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(countryCode));
                            nextItem.setAttribute("aria-selected", "true");
                            nextItem.classList.add("iti__active");
                            this.activeItem = nextItem;
                            this.selectedFlag.setAttribute("aria-activedescendant", nextItem.getAttribute("id"));
                        }
                    }
                    // return if the flag has changed or not
                    return prevCountry.iso2 !== countryCode;
                }
            }, {
                key: "_getHiddenSelectedFlagWidth",
                value: function _getHiddenSelectedFlagWidth() {
                    // to get the right styling to apply, all we need is a shallow clone of the container,
                    // and then to inject a deep clone of the selectedFlag element
                    var containerClone = this.telInput.parentNode.cloneNode();
                    containerClone.style.visibility = "hidden";
                    document.body.appendChild(containerClone);
                    var flagsContainerClone = this.flagsContainer.cloneNode();
                    containerClone.appendChild(flagsContainerClone);
                    var selectedFlagClone = this.selectedFlag.cloneNode(true);
                    flagsContainerClone.appendChild(selectedFlagClone);
                    var width = selectedFlagClone.offsetWidth;
                    containerClone.parentNode.removeChild(containerClone);
                    return width;
                }
            }, {
                key: "_updatePlaceholder",
                value: function _updatePlaceholder() {
                    var shouldSetPlaceholder = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
                    if (window.intlTelInputUtils && shouldSetPlaceholder) {
                        var numberType = intlTelInputUtils.numberType[this.options.placeholderNumberType];
                        var placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
                        placeholder = this._beforeSetNumber(placeholder);
                        if (typeof this.options.customPlaceholder === "function") {
                            placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
                        }
                        this.telInput.setAttribute("placeholder", placeholder);
                    }
                }
            }, {
                key: "_selectListItem",
                value: function _selectListItem(listItem) {
                    // update selected flag and active list item
                    var flagChanged = this._setFlag(listItem.getAttribute("data-country-code"));
                    this._closeDropdown();
                    this._updateDialCode(listItem.getAttribute("data-dial-code"), true);
                    // focus the input
                    this.telInput.focus();
                    // put cursor at end - this fix is required for FF and IE11 (with nationalMode=false i.e. auto
                    // inserting dial code), who try to put the cursor at the beginning the first time
                    var len = this.telInput.value.length;
                    this.telInput.setSelectionRange(len, len);
                    if (flagChanged) {
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "_closeDropdown",
                value: function _closeDropdown() {
                    this.countryList.classList.add("iti__hide");
                    this.selectedFlag.setAttribute("aria-expanded", "false");
                    // update the arrow
                    this.dropdownArrow.classList.remove("iti__arrow--up");
                    // unbind key events
                    document.removeEventListener("keydown", this._handleKeydownOnDropdown);
                    document.documentElement.removeEventListener("click", this._handleClickOffToClose);
                    this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList);
                    this.countryList.removeEventListener("click", this._handleClickCountryList);
                    // remove menu from container
                    if (this.options.dropdownContainer) {
                        if (!this.isMobile) window.removeEventListener("scroll", this._handleWindowScroll);
                        if (this.dropdown.parentNode) this.dropdown.parentNode.removeChild(this.dropdown);
                    }
                    this._trigger("close:countrydropdown");
                }
            }, {
                key: "_scrollTo",
                value: function _scrollTo(element, middle) {
                    var container = this.countryList;
                    // windowTop from https://stackoverflow.com/a/14384091/217866
                    var windowTop = window.pageYOffset || document.documentElement.scrollTop;
                    var containerHeight = container.offsetHeight;
                    var containerTop = container.getBoundingClientRect().top + windowTop;
                    var containerBottom = containerTop + containerHeight;
                    var elementHeight = element.offsetHeight;
                    var elementTop = element.getBoundingClientRect().top + windowTop;
                    var elementBottom = elementTop + elementHeight;
                    var newScrollTop = elementTop - containerTop + container.scrollTop;
                    var middleOffset = containerHeight / 2 - elementHeight / 2;
                    if (elementTop < containerTop) {
                        // scroll up
                        if (middle) newScrollTop -= middleOffset;
                        container.scrollTop = newScrollTop;
                    } else if (elementBottom > containerBottom) {
                        // scroll down
                        if (middle) newScrollTop += middleOffset;
                        var heightDifference = containerHeight - elementHeight;
                        container.scrollTop = newScrollTop - heightDifference;
                    }
                }
            }, {
                key: "_updateDialCode",
                value: function _updateDialCode(newDialCodeBare, hasSelectedListItem) {
                    var inputVal = this.telInput.value;
                    // save having to pass this every time
                    var newDialCode = "+".concat(newDialCodeBare);
                    var newNumber;
                    if (inputVal.charAt(0) === "+") {
                        // there's a plus so we're dealing with a replacement (doesn't matter if nationalMode or not)
                        var prevDialCode = this._getDialCode(inputVal);
                        if (prevDialCode) {
                            // current number contains a valid dial code, so replace it
                            newNumber = inputVal.replace(prevDialCode, newDialCode);
                        } else {
                            // current number contains an invalid dial code, so ditch it
                            // (no way to determine where the invalid dial code ends and the rest of the number begins)
                            newNumber = newDialCode;
                        }
                    } else if (this.options.nationalMode || this.options.separateDialCode) {
                        // don't do anything
                        return;
                    } else {
                        // nationalMode is disabled
                        if (inputVal) {
                            // there is an existing value with no dial code: prefix the new dial code
                            newNumber = newDialCode + inputVal;
                        } else if (hasSelectedListItem || !this.options.autoHideDialCode) {
                            // no existing value and either they've just selected a list item, or autoHideDialCode is
                            // disabled: insert new dial code
                            newNumber = newDialCode;
                        } else {
                            return;
                        }
                    }
                    this.telInput.value = newNumber;
                }
            }, {
                key: "_getDialCode",
                value: function _getDialCode(number, includeAreaCode) {
                    var dialCode = "";
                    // only interested in international numbers (starting with a plus)
                    if (number.charAt(0) === "+") {
                        var numericChars = "";
                        // iterate over chars
                        for (var i = 0; i < number.length; i++) {
                            var c = number.charAt(i);
                            // if char is number (https://stackoverflow.com/a/8935649/217866)
                            if (!isNaN(parseInt(c, 10))) {
                                numericChars += c;
                                // if current numericChars make a valid dial code
                                if (includeAreaCode) {
                                    if (this.countryCodes[numericChars]) {
                                        // store the actual raw string (useful for matching later)
                                        dialCode = number.substr(0, i + 1);
                                    }
                                } else {
                                    if (this.dialCodes[numericChars]) {
                                        dialCode = number.substr(0, i + 1);
                                        // if we're just looking for a dial code, we can break as soon as we find one
                                        break;
                                    }
                                }
                                // stop searching as soon as we can - in this case when we hit max len
                                if (numericChars.length === this.countryCodeMaxLen) {
                                    break;
                                }
                            }
                        }
                    }
                    return dialCode;
                }
            }, {
                key: "_getFullNumber",
                value: function _getFullNumber() {
                    var val = this.telInput.value.trim();
                    var dialCode = this.selectedCountryData.dialCode;
                    var prefix;
                    var numericVal = this._getNumeric(val);
                    if (this.options.separateDialCode && val.charAt(0) !== "+" && dialCode && numericVal) {
                        // when using separateDialCode, it is visible so is effectively part of the typed number
                        prefix = "+".concat(dialCode);
                    } else {
                        prefix = "";
                    }
                    return prefix + val;
                }
            }, {
                key: "_beforeSetNumber",
                value: function _beforeSetNumber(originalNumber) {
                    var number = originalNumber;
                    if (this.options.separateDialCode) {
                        var dialCode = this._getDialCode(number);
                        // if there is a valid dial code
                        if (dialCode) {
                            // in case _getDialCode returned an area code as well
                            dialCode = "+".concat(this.selectedCountryData.dialCode);
                            // a lot of numbers will have a space separating the dial code and the main number, and
                            // some NANP numbers will have a hyphen e.g. +1 684-733-1234 - in both cases we want to get
                            // rid of it
                            // NOTE: don't just trim all non-numerics as may want to preserve an open parenthesis etc
                            var start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                            number = number.substr(start);
                        }
                    }
                    return this._cap(number);
                }
            }, {
                key: "_triggerCountryChange",
                value: function _triggerCountryChange() {
                    this._trigger("countrychange");
                }
            }, {
                key: "handleAutoCountry",
                value: function handleAutoCountry() {
                    if (this.options.initialCountry === "auto") {
                        // we must set this even if there is an initial val in the input: in case the initial val is
                        // invalid and they delete it - they should see their auto country
                        this.defaultCountry = window.intlTelInputGlobals.autoCountry;
                        // if there's no initial value in the input, then update the flag
                        if (!this.telInput.value) {
                            this.setCountry(this.defaultCountry);
                        }
                        this.resolveAutoCountryPromise();
                    }
                }
            }, {
                key: "handleUtils",
                value: function handleUtils() {
                    // if the request was successful
                    if (window.intlTelInputUtils) {
                        // if there's an initial value in the input, then format it
                        if (this.telInput.value) {
                            this._updateValFromNumber(this.telInput.value);
                        }
                        this._updatePlaceholder();
                    }
                    this.resolveUtilsScriptPromise();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    var form = this.telInput.form;
                    if (this.options.allowDropdown) {
                        // make sure the dropdown is closed (and unbind listeners)
                        this._closeDropdown();
                        this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag);
                        this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
                        // label click hack
                        var label = this._getClosestLabel();
                        if (label) label.removeEventListener("click", this._handleLabelClick);
                    }
                    // unbind hiddenInput listeners
                    if (this.hiddenInput && form) form.removeEventListener("submit", this._handleHiddenInputSubmit);
                    // unbind autoHideDialCode listeners
                    if (this.options.autoHideDialCode) {
                        if (form) form.removeEventListener("submit", this._handleSubmitOrBlurEvent);
                        this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent);
                    }
                    // unbind key events, and cut/paste events
                    this.telInput.removeEventListener("keyup", this._handleKeyupEvent);
                    this.telInput.removeEventListener("cut", this._handleClipboardEvent);
                    this.telInput.removeEventListener("paste", this._handleClipboardEvent);
                    // remove attribute of id instance: data-intl-tel-input-id
                    this.telInput.removeAttribute("data-intl-tel-input-id");
                    // remove markup (but leave the original input)
                    var wrapper = this.telInput.parentNode;
                    wrapper.parentNode.insertBefore(this.telInput, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                    delete window.intlTelInputGlobals.instances[this.id];
                }
            }, {
                key: "getExtension",
                value: function getExtension() {
                    if (window.intlTelInputUtils) {
                        return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
                    }
                    return "";
                }
            }, {
                key: "getNumber",
                value: function getNumber(format) {
                    if (window.intlTelInputUtils) {
                        var iso2 = this.selectedCountryData.iso2;
                        return intlTelInputUtils.formatNumber(this._getFullNumber(), iso2, format);
                    }
                    return "";
                }
            }, {
                key: "getNumberType",
                value: function getNumberType() {
                    if (window.intlTelInputUtils) {
                        return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
                    }
                    return -99;
                }
            }, {
                key: "getSelectedCountryData",
                value: function getSelectedCountryData() {
                    return this.selectedCountryData;
                }
            }, {
                key: "getValidationError",
                value: function getValidationError() {
                    if (window.intlTelInputUtils) {
                        var iso2 = this.selectedCountryData.iso2;
                        return intlTelInputUtils.getValidationError(this._getFullNumber(), iso2);
                    }
                    return -99;
                }
            }, {
                key: "isValidNumber",
                value: function isValidNumber() {
                    var val = this._getFullNumber().trim();
                    var countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
                    return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, countryCode) : null;
                }
            }, {
                key: "setCountry",
                value: function setCountry(originalCountryCode) {
                    var countryCode = originalCountryCode.toLowerCase();
                    // check if already selected
                    if (!this.selectedFlagInner.classList.contains("iti__".concat(countryCode))) {
                        this._setFlag(countryCode);
                        this._updateDialCode(this.selectedCountryData.dialCode, false);
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "setNumber",
                value: function setNumber(number) {
                    // we must update the flag first, which updates this.selectedCountryData, which is used for
                    // formatting the number before displaying it
                    var flagChanged = this._updateFlagFromNumber(number);
                    this._updateValFromNumber(number);
                    if (flagChanged) {
                        this._triggerCountryChange();
                    }
                }
            }, {
                key: "setPlaceholderNumberType",
                value: function setPlaceholderNumberType(type) {
                    this.options.placeholderNumberType = type;
                    this._updatePlaceholder();
                }
            } ]);
            return Iti;
        }();
        /********************
 *  STATIC METHODS
 ********************/
        // get the country data object
        intlTelInputGlobals.getCountryData = function() {
            return allCountries;
        };
        // inject a <script> element to load utils.js
        var injectScript = function injectScript(path, handleSuccess, handleFailure) {
            // inject a new script element into the page
            var script = document.createElement("script");
            script.onload = function() {
                forEachInstance("handleUtils");
                if (handleSuccess) handleSuccess();
            };
            script.onerror = function() {
                forEachInstance("rejectUtilsScriptPromise");
                if (handleFailure) handleFailure();
            };
            script.className = "iti-load-utils";
            script.async = true;
            script.src = path;
            document.body.appendChild(script);
        };
        // load the utils script
        intlTelInputGlobals.loadUtils = function(path) {
            // 2 options:
            // 1) not already started loading (start)
            // 2) already started loading (do nothing - just wait for the onload callback to fire, which will
            // trigger handleUtils on all instances, invoking their resolveUtilsScriptPromise functions)
            if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
                // only do this once
                window.intlTelInputGlobals.startedLoadingUtilsScript = true;
                // if we have promises, then return a promise
                if (typeof Promise !== "undefined") {
                    return new Promise(function(resolve, reject) {
                        return injectScript(path, resolve, reject);
                    });
                }
                injectScript(path);
            }
            return null;
        };
        // default options
        intlTelInputGlobals.defaults = defaults;
        // version
        intlTelInputGlobals.version = "17.0.3";
        // convenience wrapper
        return function(input, options) {
            var iti = new Iti(input, options);
            iti._init();
            input.setAttribute("data-intl-tel-input-id", iti.id);
            window.intlTelInputGlobals.instances[iti.id] = iti;
            return iti;
        };
    }();
});
},{}],3:[function(require,module,exports){
/**
 * Exposing intl-tel-input as a component
 */
module.exports = require("./build/js/intlTelInput");

},{"./build/js/intlTelInput":2}],4:[function(require,module,exports){
module.exports={
	"version": "2021e",
	"zones": [
		"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
		"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
		"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
		"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
		"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
		"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
		"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
		"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
		"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
		"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
		"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
		"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
		"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
		"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
		"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
		"Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
		"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
		"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
		"Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
		"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
		"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
		"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
		"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
		"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
		"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
		"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
		"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
		"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
		"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
		"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
		"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
		"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
		"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
		"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
		"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
		"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
		"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
		"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
		"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
		"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
		"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
		"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
		"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
		"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
		"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
		"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
		"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
		"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
		"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
		"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
		"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
		"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
		"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
		"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
		"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
		"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
		"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
		"America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
		"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
		"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
		"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
		"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
		"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
		"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
		"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
		"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
		"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
		"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
		"America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
		"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
		"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
		"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
		"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
		"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
		"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
		"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
		"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
		"America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
		"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
		"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
		"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
		"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
		"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
		"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
		"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
		"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
		"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
		"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
		"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
		"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
		"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
		"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
		"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
		"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
		"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
		"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
		"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
		"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
		"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
		"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
		"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
		"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
		"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
		"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
		"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
		"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
		"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
		"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
		"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
		"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
		"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
		"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
		"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
		"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
		"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
		"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
		"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
		"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
		"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
		"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
		"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
		"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
		"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
		"Pacific/Port_Moresby|+10|-a0|0||25e4",
		"Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1",
		"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
		"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
		"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
		"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
		"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
		"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
		"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
		"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
		"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
		"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5",
		"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
		"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
		"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
		"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
		"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
		"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
		"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
		"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
		"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
		"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
		"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
		"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
		"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
		"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
		"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
		"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
		"Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
		"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
		"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
		"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
		"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
		"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
		"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
		"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
		"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5",
		"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4",
		"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
		"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
		"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
		"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
		"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
		"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
		"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
		"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
		"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
		"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
		"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
		"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
		"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
		"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
		"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
		"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
		"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
		"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
		"Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
		"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
		"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
		"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
		"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
		"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
		"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
		"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
		"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
		"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
		"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
		"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
		"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
		"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
		"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
		"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
		"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
		"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
		"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
		"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
		"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
		"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
		"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
		"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
		"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
		"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
		"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
		"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
		"Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
		"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
		"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
		"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
		"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
		"Atlantic/South_Georgia|-02|20|0||30",
		"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
		"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
		"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
		"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
		"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
		"Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
		"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
		"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
		"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
		"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
		"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
		"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
		"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
		"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
		"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
		"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"EST|EST|50|0||",
		"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"Etc/GMT-0|GMT|0|0||",
		"Etc/GMT-1|+01|-10|0||",
		"Etc/GMT-11|+11|-b0|0||",
		"Pacific/Tarawa|+12|-c0|0||29e3",
		"Etc/GMT-13|+13|-d0|0||",
		"Etc/GMT-14|+14|-e0|0||",
		"Etc/GMT-2|+02|-20|0||",
		"Etc/GMT-3|+03|-30|0||",
		"Etc/GMT-4|+04|-40|0||",
		"Etc/GMT-5|+05|-50|0||",
		"Etc/GMT-6|+06|-60|0||",
		"Indian/Christmas|+07|-70|0||21e2",
		"Etc/GMT-8|+08|-80|0||",
		"Pacific/Palau|+09|-90|0||21e3",
		"Etc/GMT+1|-01|10|0||",
		"Etc/GMT+10|-10|a0|0||",
		"Etc/GMT+11|-11|b0|0||",
		"Etc/GMT+12|-12|c0|0||",
		"Etc/GMT+3|-03|30|0||",
		"Etc/GMT+4|-04|40|0||",
		"Etc/GMT+5|-05|50|0||",
		"Etc/GMT+6|-06|60|0||",
		"Etc/GMT+7|-07|70|0||",
		"Etc/GMT+8|-08|80|0||",
		"Etc/GMT+9|-09|90|0||",
		"Etc/UTC|UTC|0|0||",
		"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
		"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
		"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
		"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
		"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
		"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
		"Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
		"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
		"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
		"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
		"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
		"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
		"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
		"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
		"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
		"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
		"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
		"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
		"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
		"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
		"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
		"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
		"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
		"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
		"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
		"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
		"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
		"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
		"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
		"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
		"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
		"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
		"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
		"HST|HST|a0|0||",
		"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
		"Indian/Cocos|+0630|-6u|0||596",
		"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
		"Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3",
		"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
		"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
		"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
		"Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
		"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
		"MST|MST|70|0||",
		"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
		"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
		"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
		"Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
		"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
		"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
		"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
		"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
		"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
		"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
		"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
		"Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
		"Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
		"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
		"Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
		"Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
		"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
		"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
		"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
		"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
		"Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
		"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
		"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
		"Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
		"Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
		"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
		"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
		"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
	],
	"links": [
		"Africa/Abidjan|Africa/Accra",
		"Africa/Abidjan|Africa/Bamako",
		"Africa/Abidjan|Africa/Banjul",
		"Africa/Abidjan|Africa/Conakry",
		"Africa/Abidjan|Africa/Dakar",
		"Africa/Abidjan|Africa/Freetown",
		"Africa/Abidjan|Africa/Lome",
		"Africa/Abidjan|Africa/Nouakchott",
		"Africa/Abidjan|Africa/Ouagadougou",
		"Africa/Abidjan|Africa/Timbuktu",
		"Africa/Abidjan|Atlantic/St_Helena",
		"Africa/Cairo|Egypt",
		"Africa/Johannesburg|Africa/Maseru",
		"Africa/Johannesburg|Africa/Mbabane",
		"Africa/Lagos|Africa/Bangui",
		"Africa/Lagos|Africa/Brazzaville",
		"Africa/Lagos|Africa/Douala",
		"Africa/Lagos|Africa/Kinshasa",
		"Africa/Lagos|Africa/Libreville",
		"Africa/Lagos|Africa/Luanda",
		"Africa/Lagos|Africa/Malabo",
		"Africa/Lagos|Africa/Niamey",
		"Africa/Lagos|Africa/Porto-Novo",
		"Africa/Maputo|Africa/Blantyre",
		"Africa/Maputo|Africa/Bujumbura",
		"Africa/Maputo|Africa/Gaborone",
		"Africa/Maputo|Africa/Harare",
		"Africa/Maputo|Africa/Kigali",
		"Africa/Maputo|Africa/Lubumbashi",
		"Africa/Maputo|Africa/Lusaka",
		"Africa/Nairobi|Africa/Addis_Ababa",
		"Africa/Nairobi|Africa/Asmara",
		"Africa/Nairobi|Africa/Asmera",
		"Africa/Nairobi|Africa/Dar_es_Salaam",
		"Africa/Nairobi|Africa/Djibouti",
		"Africa/Nairobi|Africa/Kampala",
		"Africa/Nairobi|Africa/Mogadishu",
		"Africa/Nairobi|Indian/Antananarivo",
		"Africa/Nairobi|Indian/Comoro",
		"Africa/Nairobi|Indian/Mayotte",
		"Africa/Tripoli|Libya",
		"America/Adak|America/Atka",
		"America/Adak|US/Aleutian",
		"America/Anchorage|US/Alaska",
		"America/Argentina/Buenos_Aires|America/Buenos_Aires",
		"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
		"America/Argentina/Catamarca|America/Catamarca",
		"America/Argentina/Cordoba|America/Cordoba",
		"America/Argentina/Cordoba|America/Rosario",
		"America/Argentina/Jujuy|America/Jujuy",
		"America/Argentina/Mendoza|America/Mendoza",
		"America/Chicago|US/Central",
		"America/Denver|America/Shiprock",
		"America/Denver|Navajo",
		"America/Denver|US/Mountain",
		"America/Detroit|US/Michigan",
		"America/Edmonton|Canada/Mountain",
		"America/Fort_Wayne|America/Indiana/Indianapolis",
		"America/Fort_Wayne|America/Indianapolis",
		"America/Fort_Wayne|US/East-Indiana",
		"America/Godthab|America/Nuuk",
		"America/Halifax|Canada/Atlantic",
		"America/Havana|Cuba",
		"America/Indiana/Knox|America/Knox_IN",
		"America/Indiana/Knox|US/Indiana-Starke",
		"America/Jamaica|Jamaica",
		"America/Kentucky/Louisville|America/Louisville",
		"America/Los_Angeles|US/Pacific",
		"America/Manaus|Brazil/West",
		"America/Mazatlan|Mexico/BajaSur",
		"America/Mexico_City|Mexico/General",
		"America/New_York|US/Eastern",
		"America/Noronha|Brazil/DeNoronha",
		"America/Panama|America/Atikokan",
		"America/Panama|America/Cayman",
		"America/Panama|America/Coral_Harbour",
		"America/Phoenix|America/Creston",
		"America/Phoenix|US/Arizona",
		"America/Puerto_Rico|America/Anguilla",
		"America/Puerto_Rico|America/Antigua",
		"America/Puerto_Rico|America/Aruba",
		"America/Puerto_Rico|America/Blanc-Sablon",
		"America/Puerto_Rico|America/Curacao",
		"America/Puerto_Rico|America/Dominica",
		"America/Puerto_Rico|America/Grenada",
		"America/Puerto_Rico|America/Guadeloupe",
		"America/Puerto_Rico|America/Kralendijk",
		"America/Puerto_Rico|America/Lower_Princes",
		"America/Puerto_Rico|America/Marigot",
		"America/Puerto_Rico|America/Montserrat",
		"America/Puerto_Rico|America/Port_of_Spain",
		"America/Puerto_Rico|America/St_Barthelemy",
		"America/Puerto_Rico|America/St_Kitts",
		"America/Puerto_Rico|America/St_Lucia",
		"America/Puerto_Rico|America/St_Thomas",
		"America/Puerto_Rico|America/St_Vincent",
		"America/Puerto_Rico|America/Tortola",
		"America/Puerto_Rico|America/Virgin",
		"America/Regina|Canada/Saskatchewan",
		"America/Rio_Branco|America/Porto_Acre",
		"America/Rio_Branco|Brazil/Acre",
		"America/Santiago|Chile/Continental",
		"America/Sao_Paulo|Brazil/East",
		"America/St_Johns|Canada/Newfoundland",
		"America/Tijuana|America/Ensenada",
		"America/Tijuana|America/Santa_Isabel",
		"America/Tijuana|Mexico/BajaNorte",
		"America/Toronto|America/Montreal",
		"America/Toronto|America/Nassau",
		"America/Toronto|Canada/Eastern",
		"America/Vancouver|Canada/Pacific",
		"America/Whitehorse|Canada/Yukon",
		"America/Winnipeg|Canada/Central",
		"Asia/Ashgabat|Asia/Ashkhabad",
		"Asia/Bangkok|Asia/Phnom_Penh",
		"Asia/Bangkok|Asia/Vientiane",
		"Asia/Dhaka|Asia/Dacca",
		"Asia/Dubai|Asia/Muscat",
		"Asia/Ho_Chi_Minh|Asia/Saigon",
		"Asia/Hong_Kong|Hongkong",
		"Asia/Jerusalem|Asia/Tel_Aviv",
		"Asia/Jerusalem|Israel",
		"Asia/Kathmandu|Asia/Katmandu",
		"Asia/Kolkata|Asia/Calcutta",
		"Asia/Kuala_Lumpur|Asia/Singapore",
		"Asia/Kuala_Lumpur|Singapore",
		"Asia/Macau|Asia/Macao",
		"Asia/Makassar|Asia/Ujung_Pandang",
		"Asia/Nicosia|Europe/Nicosia",
		"Asia/Qatar|Asia/Bahrain",
		"Asia/Rangoon|Asia/Yangon",
		"Asia/Riyadh|Antarctica/Syowa",
		"Asia/Riyadh|Asia/Aden",
		"Asia/Riyadh|Asia/Kuwait",
		"Asia/Seoul|ROK",
		"Asia/Shanghai|Asia/Chongqing",
		"Asia/Shanghai|Asia/Chungking",
		"Asia/Shanghai|Asia/Harbin",
		"Asia/Shanghai|PRC",
		"Asia/Taipei|ROC",
		"Asia/Tehran|Iran",
		"Asia/Thimphu|Asia/Thimbu",
		"Asia/Tokyo|Japan",
		"Asia/Ulaanbaatar|Asia/Ulan_Bator",
		"Asia/Urumqi|Asia/Kashgar",
		"Atlantic/Faroe|Atlantic/Faeroe",
		"Atlantic/Reykjavik|Iceland",
		"Atlantic/South_Georgia|Etc/GMT+2",
		"Australia/Adelaide|Australia/South",
		"Australia/Brisbane|Australia/Queensland",
		"Australia/Broken_Hill|Australia/Yancowinna",
		"Australia/Darwin|Australia/North",
		"Australia/Hobart|Australia/Currie",
		"Australia/Hobart|Australia/Tasmania",
		"Australia/Lord_Howe|Australia/LHI",
		"Australia/Melbourne|Australia/Victoria",
		"Australia/Perth|Australia/West",
		"Australia/Sydney|Australia/ACT",
		"Australia/Sydney|Australia/Canberra",
		"Australia/Sydney|Australia/NSW",
		"Etc/GMT-0|Etc/GMT",
		"Etc/GMT-0|Etc/GMT+0",
		"Etc/GMT-0|Etc/GMT0",
		"Etc/GMT-0|Etc/Greenwich",
		"Etc/GMT-0|GMT",
		"Etc/GMT-0|GMT+0",
		"Etc/GMT-0|GMT-0",
		"Etc/GMT-0|GMT0",
		"Etc/GMT-0|Greenwich",
		"Etc/UTC|Etc/UCT",
		"Etc/UTC|Etc/Universal",
		"Etc/UTC|Etc/Zulu",
		"Etc/UTC|UCT",
		"Etc/UTC|UTC",
		"Etc/UTC|Universal",
		"Etc/UTC|Zulu",
		"Europe/Belgrade|Europe/Ljubljana",
		"Europe/Belgrade|Europe/Podgorica",
		"Europe/Belgrade|Europe/Sarajevo",
		"Europe/Belgrade|Europe/Skopje",
		"Europe/Belgrade|Europe/Zagreb",
		"Europe/Chisinau|Europe/Tiraspol",
		"Europe/Dublin|Eire",
		"Europe/Helsinki|Europe/Mariehamn",
		"Europe/Istanbul|Asia/Istanbul",
		"Europe/Istanbul|Turkey",
		"Europe/Lisbon|Portugal",
		"Europe/London|Europe/Belfast",
		"Europe/London|Europe/Guernsey",
		"Europe/London|Europe/Isle_of_Man",
		"Europe/London|Europe/Jersey",
		"Europe/London|GB",
		"Europe/London|GB-Eire",
		"Europe/Moscow|W-SU",
		"Europe/Oslo|Arctic/Longyearbyen",
		"Europe/Oslo|Atlantic/Jan_Mayen",
		"Europe/Prague|Europe/Bratislava",
		"Europe/Rome|Europe/San_Marino",
		"Europe/Rome|Europe/Vatican",
		"Europe/Warsaw|Poland",
		"Europe/Zurich|Europe/Busingen",
		"Europe/Zurich|Europe/Vaduz",
		"Indian/Christmas|Etc/GMT-7",
		"Pacific/Auckland|Antarctica/McMurdo",
		"Pacific/Auckland|Antarctica/South_Pole",
		"Pacific/Auckland|NZ",
		"Pacific/Chatham|NZ-CHAT",
		"Pacific/Chuuk|Pacific/Truk",
		"Pacific/Chuuk|Pacific/Yap",
		"Pacific/Easter|Chile/EasterIsland",
		"Pacific/Enderbury|Pacific/Kanton",
		"Pacific/Guam|Pacific/Saipan",
		"Pacific/Honolulu|Pacific/Johnston",
		"Pacific/Honolulu|US/Hawaii",
		"Pacific/Kwajalein|Kwajalein",
		"Pacific/Pago_Pago|Pacific/Midway",
		"Pacific/Pago_Pago|Pacific/Samoa",
		"Pacific/Pago_Pago|US/Samoa",
		"Pacific/Palau|Etc/GMT-9",
		"Pacific/Pohnpei|Pacific/Ponape",
		"Pacific/Port_Moresby|Antarctica/DumontDUrville",
		"Pacific/Port_Moresby|Etc/GMT-10",
		"Pacific/Tarawa|Etc/GMT-12",
		"Pacific/Tarawa|Pacific/Funafuti",
		"Pacific/Tarawa|Pacific/Wake",
		"Pacific/Tarawa|Pacific/Wallis"
	],
	"countries": [
		"AD|Europe/Andorra",
		"AE|Asia/Dubai",
		"AF|Asia/Kabul",
		"AG|America/Port_of_Spain America/Antigua",
		"AI|America/Port_of_Spain America/Anguilla",
		"AL|Europe/Tirane",
		"AM|Asia/Yerevan",
		"AO|Africa/Lagos Africa/Luanda",
		"AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
		"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
		"AS|Pacific/Pago_Pago",
		"AT|Europe/Vienna",
		"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
		"AW|America/Curacao America/Aruba",
		"AX|Europe/Helsinki Europe/Mariehamn",
		"AZ|Asia/Baku",
		"BA|Europe/Belgrade Europe/Sarajevo",
		"BB|America/Barbados",
		"BD|Asia/Dhaka",
		"BE|Europe/Brussels",
		"BF|Africa/Abidjan Africa/Ouagadougou",
		"BG|Europe/Sofia",
		"BH|Asia/Qatar Asia/Bahrain",
		"BI|Africa/Maputo Africa/Bujumbura",
		"BJ|Africa/Lagos Africa/Porto-Novo",
		"BL|America/Port_of_Spain America/St_Barthelemy",
		"BM|Atlantic/Bermuda",
		"BN|Asia/Brunei",
		"BO|America/La_Paz",
		"BQ|America/Curacao America/Kralendijk",
		"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
		"BS|America/Nassau",
		"BT|Asia/Thimphu",
		"BW|Africa/Maputo Africa/Gaborone",
		"BY|Europe/Minsk",
		"BZ|America/Belize",
		"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver",
		"CC|Indian/Cocos",
		"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
		"CF|Africa/Lagos Africa/Bangui",
		"CG|Africa/Lagos Africa/Brazzaville",
		"CH|Europe/Zurich",
		"CI|Africa/Abidjan",
		"CK|Pacific/Rarotonga",
		"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
		"CM|Africa/Lagos Africa/Douala",
		"CN|Asia/Shanghai Asia/Urumqi",
		"CO|America/Bogota",
		"CR|America/Costa_Rica",
		"CU|America/Havana",
		"CV|Atlantic/Cape_Verde",
		"CW|America/Curacao",
		"CX|Indian/Christmas",
		"CY|Asia/Nicosia Asia/Famagusta",
		"CZ|Europe/Prague",
		"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
		"DJ|Africa/Nairobi Africa/Djibouti",
		"DK|Europe/Copenhagen",
		"DM|America/Port_of_Spain America/Dominica",
		"DO|America/Santo_Domingo",
		"DZ|Africa/Algiers",
		"EC|America/Guayaquil Pacific/Galapagos",
		"EE|Europe/Tallinn",
		"EG|Africa/Cairo",
		"EH|Africa/El_Aaiun",
		"ER|Africa/Nairobi Africa/Asmara",
		"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
		"ET|Africa/Nairobi Africa/Addis_Ababa",
		"FI|Europe/Helsinki",
		"FJ|Pacific/Fiji",
		"FK|Atlantic/Stanley",
		"FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
		"FO|Atlantic/Faroe",
		"FR|Europe/Paris",
		"GA|Africa/Lagos Africa/Libreville",
		"GB|Europe/London",
		"GD|America/Port_of_Spain America/Grenada",
		"GE|Asia/Tbilisi",
		"GF|America/Cayenne",
		"GG|Europe/London Europe/Guernsey",
		"GH|Africa/Accra",
		"GI|Europe/Gibraltar",
		"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
		"GM|Africa/Abidjan Africa/Banjul",
		"GN|Africa/Abidjan Africa/Conakry",
		"GP|America/Port_of_Spain America/Guadeloupe",
		"GQ|Africa/Lagos Africa/Malabo",
		"GR|Europe/Athens",
		"GS|Atlantic/South_Georgia",
		"GT|America/Guatemala",
		"GU|Pacific/Guam",
		"GW|Africa/Bissau",
		"GY|America/Guyana",
		"HK|Asia/Hong_Kong",
		"HN|America/Tegucigalpa",
		"HR|Europe/Belgrade Europe/Zagreb",
		"HT|America/Port-au-Prince",
		"HU|Europe/Budapest",
		"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
		"IE|Europe/Dublin",
		"IL|Asia/Jerusalem",
		"IM|Europe/London Europe/Isle_of_Man",
		"IN|Asia/Kolkata",
		"IO|Indian/Chagos",
		"IQ|Asia/Baghdad",
		"IR|Asia/Tehran",
		"IS|Atlantic/Reykjavik",
		"IT|Europe/Rome",
		"JE|Europe/London Europe/Jersey",
		"JM|America/Jamaica",
		"JO|Asia/Amman",
		"JP|Asia/Tokyo",
		"KE|Africa/Nairobi",
		"KG|Asia/Bishkek",
		"KH|Asia/Bangkok Asia/Phnom_Penh",
		"KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
		"KM|Africa/Nairobi Indian/Comoro",
		"KN|America/Port_of_Spain America/St_Kitts",
		"KP|Asia/Pyongyang",
		"KR|Asia/Seoul",
		"KW|Asia/Riyadh Asia/Kuwait",
		"KY|America/Panama America/Cayman",
		"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
		"LA|Asia/Bangkok Asia/Vientiane",
		"LB|Asia/Beirut",
		"LC|America/Port_of_Spain America/St_Lucia",
		"LI|Europe/Zurich Europe/Vaduz",
		"LK|Asia/Colombo",
		"LR|Africa/Monrovia",
		"LS|Africa/Johannesburg Africa/Maseru",
		"LT|Europe/Vilnius",
		"LU|Europe/Luxembourg",
		"LV|Europe/Riga",
		"LY|Africa/Tripoli",
		"MA|Africa/Casablanca",
		"MC|Europe/Monaco",
		"MD|Europe/Chisinau",
		"ME|Europe/Belgrade Europe/Podgorica",
		"MF|America/Port_of_Spain America/Marigot",
		"MG|Africa/Nairobi Indian/Antananarivo",
		"MH|Pacific/Majuro Pacific/Kwajalein",
		"MK|Europe/Belgrade Europe/Skopje",
		"ML|Africa/Abidjan Africa/Bamako",
		"MM|Asia/Yangon",
		"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
		"MO|Asia/Macau",
		"MP|Pacific/Guam Pacific/Saipan",
		"MQ|America/Martinique",
		"MR|Africa/Abidjan Africa/Nouakchott",
		"MS|America/Port_of_Spain America/Montserrat",
		"MT|Europe/Malta",
		"MU|Indian/Mauritius",
		"MV|Indian/Maldives",
		"MW|Africa/Maputo Africa/Blantyre",
		"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
		"MY|Asia/Kuala_Lumpur Asia/Kuching",
		"MZ|Africa/Maputo",
		"NA|Africa/Windhoek",
		"NC|Pacific/Noumea",
		"NE|Africa/Lagos Africa/Niamey",
		"NF|Pacific/Norfolk",
		"NG|Africa/Lagos",
		"NI|America/Managua",
		"NL|Europe/Amsterdam",
		"NO|Europe/Oslo",
		"NP|Asia/Kathmandu",
		"NR|Pacific/Nauru",
		"NU|Pacific/Niue",
		"NZ|Pacific/Auckland Pacific/Chatham",
		"OM|Asia/Dubai Asia/Muscat",
		"PA|America/Panama",
		"PE|America/Lima",
		"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
		"PG|Pacific/Port_Moresby Pacific/Bougainville",
		"PH|Asia/Manila",
		"PK|Asia/Karachi",
		"PL|Europe/Warsaw",
		"PM|America/Miquelon",
		"PN|Pacific/Pitcairn",
		"PR|America/Puerto_Rico",
		"PS|Asia/Gaza Asia/Hebron",
		"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
		"PW|Pacific/Palau",
		"PY|America/Asuncion",
		"QA|Asia/Qatar",
		"RE|Indian/Reunion",
		"RO|Europe/Bucharest",
		"RS|Europe/Belgrade",
		"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
		"RW|Africa/Maputo Africa/Kigali",
		"SA|Asia/Riyadh",
		"SB|Pacific/Guadalcanal",
		"SC|Indian/Mahe",
		"SD|Africa/Khartoum",
		"SE|Europe/Stockholm",
		"SG|Asia/Singapore",
		"SH|Africa/Abidjan Atlantic/St_Helena",
		"SI|Europe/Belgrade Europe/Ljubljana",
		"SJ|Europe/Oslo Arctic/Longyearbyen",
		"SK|Europe/Prague Europe/Bratislava",
		"SL|Africa/Abidjan Africa/Freetown",
		"SM|Europe/Rome Europe/San_Marino",
		"SN|Africa/Abidjan Africa/Dakar",
		"SO|Africa/Nairobi Africa/Mogadishu",
		"SR|America/Paramaribo",
		"SS|Africa/Juba",
		"ST|Africa/Sao_Tome",
		"SV|America/El_Salvador",
		"SX|America/Curacao America/Lower_Princes",
		"SY|Asia/Damascus",
		"SZ|Africa/Johannesburg Africa/Mbabane",
		"TC|America/Grand_Turk",
		"TD|Africa/Ndjamena",
		"TF|Indian/Reunion Indian/Kerguelen",
		"TG|Africa/Abidjan Africa/Lome",
		"TH|Asia/Bangkok",
		"TJ|Asia/Dushanbe",
		"TK|Pacific/Fakaofo",
		"TL|Asia/Dili",
		"TM|Asia/Ashgabat",
		"TN|Africa/Tunis",
		"TO|Pacific/Tongatapu",
		"TR|Europe/Istanbul",
		"TT|America/Port_of_Spain",
		"TV|Pacific/Funafuti",
		"TW|Asia/Taipei",
		"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
		"UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
		"UG|Africa/Nairobi Africa/Kampala",
		"UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
		"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
		"UY|America/Montevideo",
		"UZ|Asia/Samarkand Asia/Tashkent",
		"VA|Europe/Rome Europe/Vatican",
		"VC|America/Port_of_Spain America/St_Vincent",
		"VE|America/Caracas",
		"VG|America/Port_of_Spain America/Tortola",
		"VI|America/Port_of_Spain America/St_Thomas",
		"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
		"VU|Pacific/Efate",
		"WF|Pacific/Wallis",
		"WS|Pacific/Apia",
		"YE|Asia/Riyadh Asia/Aden",
		"YT|Africa/Nairobi Indian/Mayotte",
		"ZA|Africa/Johannesburg",
		"ZM|Africa/Maputo Africa/Lusaka",
		"ZW|Africa/Maputo Africa/Harare"
	]
}
},{}],5:[function(require,module,exports){
var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));

},{"./data/packed/latest.json":4,"./moment-timezone":6}],6:[function(require,module,exports){
//! moment-timezone.js
//! version : 0.5.34
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.34",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));

},{"moment":7}],7:[function(require,module,exports){
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

},{}],8:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],9:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  typeof module === "object" ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

},{}],10:[function(require,module,exports){
(function (setImmediate,clearImmediate){
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.swal=e():t.swal=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=8)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o="swal-button";e.CLASS_NAMES={MODAL:"swal-modal",OVERLAY:"swal-overlay",SHOW_MODAL:"swal-overlay--show-modal",MODAL_TITLE:"swal-title",MODAL_TEXT:"swal-text",ICON:"swal-icon",ICON_CUSTOM:"swal-icon--custom",CONTENT:"swal-content",FOOTER:"swal-footer",BUTTON_CONTAINER:"swal-button-container",BUTTON:o,CONFIRM_BUTTON:o+"--confirm",CANCEL_BUTTON:o+"--cancel",DANGER_BUTTON:o+"--danger",BUTTON_LOADING:o+"--loading",BUTTON_LOADER:o+"__loader"},e.default=e.CLASS_NAMES},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=function(t){var e="."+t;return document.querySelector(e)},e.stringToNode=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},e.insertAfter=function(t,e){var n=e.nextSibling;e.parentNode.insertBefore(t,n)},e.removeNode=function(t){t.parentElement.removeChild(t)},e.throwErr=function(t){throw t=t.replace(/ +(?= )/g,""),"SweetAlert: "+(t=t.trim())},e.isPlainObject=function(t){if("[object Object]"!==Object.prototype.toString.call(t))return!1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype},e.ordinalSuffixOf=function(t){var e=t%10,n=t%100;return 1===e&&11!==n?t+"st":2===e&&12!==n?t+"nd":3===e&&13!==n?t+"rd":t+"th"}},function(t,e,n){"use strict";function o(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}Object.defineProperty(e,"__esModule",{value:!0}),o(n(25));var r=n(26);e.overlayMarkup=r.default,o(n(27)),o(n(28)),o(n(29));var i=n(0),a=i.default.MODAL_TITLE,s=i.default.MODAL_TEXT,c=i.default.ICON,l=i.default.FOOTER;e.iconMarkup='\n  <div class="'+c+'"></div>',e.titleMarkup='\n  <div class="'+a+'"></div>\n',e.textMarkup='\n  <div class="'+s+'"></div>',e.footerMarkup='\n  <div class="'+l+'"></div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1);e.CONFIRM_KEY="confirm",e.CANCEL_KEY="cancel";var r={visible:!0,text:null,value:null,className:"",closeModal:!0},i=Object.assign({},r,{visible:!1,text:"Cancel",value:null}),a=Object.assign({},r,{text:"OK",value:!0});e.defaultButtonList={cancel:i,confirm:a};var s=function(t){switch(t){case e.CONFIRM_KEY:return a;case e.CANCEL_KEY:return i;default:var n=t.charAt(0).toUpperCase()+t.slice(1);return Object.assign({},r,{text:n,value:t})}},c=function(t,e){var n=s(t);return!0===e?Object.assign({},n,{visible:!0}):"string"==typeof e?Object.assign({},n,{visible:!0,text:e}):o.isPlainObject(e)?Object.assign({visible:!0},n,e):Object.assign({},n,{visible:!1})},l=function(t){for(var e={},n=0,o=Object.keys(t);n<o.length;n++){var r=o[n],a=t[r],s=c(r,a);e[r]=s}return e.cancel||(e.cancel=i),e},u=function(t){var n={};switch(t.length){case 1:n[e.CANCEL_KEY]=Object.assign({},i,{visible:!1});break;case 2:n[e.CANCEL_KEY]=c(e.CANCEL_KEY,t[0]),n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t[1]);break;default:o.throwErr("Invalid number of 'buttons' in array ("+t.length+").\n      If you want more than 2 buttons, you need to use an object!")}return n};e.getButtonListOpts=function(t){var n=e.defaultButtonList;return"string"==typeof t?n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t):Array.isArray(t)?n=u(t):o.isPlainObject(t)?n=l(t):!0===t?n=u([!0,!0]):!1===t?n=u([!1,!1]):void 0===t&&(n=e.defaultButtonList),n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=n(0),a=i.default.MODAL,s=i.default.OVERLAY,c=n(30),l=n(31),u=n(32),f=n(33);e.injectElIntoModal=function(t){var e=o.getNode(a),n=o.stringToNode(t);return e.appendChild(n),n};var d=function(t){t.className=a,t.textContent=""},p=function(t,e){d(t);var n=e.className;n&&t.classList.add(n)};e.initModalContent=function(t){var e=o.getNode(a);p(e,t),c.default(t.icon),l.initTitle(t.title),l.initText(t.text),f.default(t.content),u.default(t.buttons,t.dangerMode)};var m=function(){var t=o.getNode(s),e=o.stringToNode(r.modalMarkup);t.appendChild(e)};e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r={isOpen:!1,promise:null,actions:{},timer:null},i=Object.assign({},r);e.resetState=function(){i=Object.assign({},r)},e.setActionValue=function(t){if("string"==typeof t)return a(o.CONFIRM_KEY,t);for(var e in t)a(e,t[e])};var a=function(t,e){i.actions[t]||(i.actions[t]={}),Object.assign(i.actions[t],{value:e})};e.setActionOptionsFor=function(t,e){var n=(void 0===e?{}:e).closeModal,o=void 0===n||n;Object.assign(i.actions[t],{closeModal:o})},e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(0),a=i.default.OVERLAY,s=i.default.SHOW_MODAL,c=i.default.BUTTON,l=i.default.BUTTON_LOADING,u=n(5);e.openModal=function(){o.getNode(a).classList.add(s),u.default.isOpen=!0};var f=function(){o.getNode(a).classList.remove(s),u.default.isOpen=!1};e.onAction=function(t){void 0===t&&(t=r.CANCEL_KEY);var e=u.default.actions[t],n=e.value;if(!1===e.closeModal){var i=c+"--"+t;o.getNode(i).classList.add(l)}else f();u.default.promise.resolve(n)},e.getState=function(){var t=Object.assign({},u.default);return delete t.promise,delete t.timer,t},e.stopLoading=function(){for(var t=document.querySelectorAll("."+c),e=0;e<t.length;e++){t[e].classList.remove(l)}}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(e){t.exports=e.sweetAlert=n(9)}).call(e,n(7))},function(t,e,n){(function(e){t.exports=e.swal=n(10)}).call(e,n(7))},function(t,e,n){"undefined"!=typeof window&&n(11),n(16);var o=n(23).default;t.exports=o},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={insertAt:"top"};r.transform=void 0;n(14)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){e=t.exports=n(13)(void 0),e.push([t.i,'.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button:not([disabled]):hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel:not([disabled]):hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger:not([disabled]):hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}',""])},function(t,e){function n(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=o(r);return[n].concat(r.sources.map(function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"})).concat([i]).join("\n")}return[n].join("\n")}function o(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var o=n(e,t);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=m[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],e))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],e));m[o.id]={id:o.id,refs:1,parts:a}}}}function r(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s=i[1],c=i[2],l=i[3],u={css:s,media:c,sourceMap:l};o[a]?o[a].parts.push(u):n.push(o[a]={id:a,parts:[u]})}return n}function i(t,e){var n=v(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=w[w.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),w.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=w.indexOf(t);e>=0&&w.splice(e,1)}function s(t){var e=document.createElement("style");return t.attrs.type="text/css",l(e,t.attrs),i(t,e),e}function c(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",l(e,t.attrs),i(t,e),e}function l(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function u(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=h++;n=g||(g=s(e)),o=f.bind(null,n,l,!1),r=f.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=c(e),o=p.bind(null,n,e),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(e),o=d.bind(null,n),r=function(){a(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}function f(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=x(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function d(t,e){var n=e.css,o=e.media;if(o&&t.setAttribute("media",o),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function p(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=y(o)),r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}var m={},b=function(t){var e;return function(){return void 0===e&&(e=t.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),v=function(t){var e={};return function(n){return void 0===e[n]&&(e[n]=t.call(this,n)),e[n]}}(function(t){return document.querySelector(t)}),g=null,h=0,w=[],y=n(15);t.exports=function(t,e){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=b()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=r(t,e);return o(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var s=n[a],c=m[s.id];c.refs--,i.push(c)}if(t){o(r(t,e),e)}for(var a=0;a<i.length;a++){var c=i[a];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete m[c.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return t;var i;return i=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:o+r.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(t,e,n){var o=n(17);"undefined"==typeof window||window.Promise||(window.Promise=o),n(21),String.prototype.includes||(String.prototype.includes=function(t,e){"use strict";return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(t,e){if(null==this)throw new TypeError('"this" is null or not defined');var n=Object(this),o=n.length>>>0;if(0===o)return!1;for(var r=0|e,i=Math.max(r>=0?r:o-Math.abs(r),0);i<o;){if(function(t,e){return t===e||"number"==typeof t&&"number"==typeof e&&isNaN(t)&&isNaN(e)}(n[i],t))return!0;i++}return!1}}),"undefined"!=typeof window&&function(t){t.forEach(function(t){t.hasOwnProperty("remove")||Object.defineProperty(t,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){this.parentNode.removeChild(this)}})})}([Element.prototype,CharacterData.prototype,DocumentType.prototype])},function(t,e,n){(function(e){!function(n){function o(){}function r(t,e){return function(){t.apply(e,arguments)}}function i(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(t,this)}function a(t,e){for(;3===t._state;)t=t._value;if(0===t._state)return void t._deferreds.push(e);t._handled=!0,i._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?s:c)(e.promise,t._value);var o;try{o=n(t._value)}catch(t){return void c(e.promise,t)}s(e.promise,o)})}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof i)return t._state=3,t._value=e,void l(t);if("function"==typeof n)return void f(r(n,e),t)}t._state=1,t._value=e,l(t)}catch(e){c(t,e)}}function c(t,e){t._state=2,t._value=e,l(t)}function l(t){2===t._state&&0===t._deferreds.length&&i._immediateFn(function(){t._handled||i._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function f(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,c(e,t))})}catch(t){if(n)return;n=!0,c(e,t)}}var d=setTimeout;i.prototype.catch=function(t){return this.then(null,t)},i.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new u(t,e,n)),n},i.all=function(t){var e=Array.prototype.slice.call(t);return new i(function(t,n){function o(i,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,function(t){o(i,t)},n)}e[i]=a,0==--r&&t(e)}catch(t){n(t)}}if(0===e.length)return t([]);for(var r=e.length,i=0;i<e.length;i++)o(i,e[i])})},i.resolve=function(t){return t&&"object"==typeof t&&t.constructor===i?t:new i(function(e){e(t)})},i.reject=function(t){return new i(function(e,n){n(t)})},i.race=function(t){return new i(function(e,n){for(var o=0,r=t.length;o<r;o++)t[o].then(e,n)})},i._immediateFn="function"==typeof e&&function(t){e(t)}||function(t){d(t,0)},i._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},i._setImmediateFn=function(t){i._immediateFn=t},i._setUnhandledRejectionFn=function(t){i._unhandledRejectionFn=t},void 0!==t&&t.exports?t.exports=i:n.Promise||(n.Promise=i)}(this)}).call(e,n(18).setImmediate)},function(t,e,n){function o(t,e){this._id=t,this._clearFn=e}var r=Function.prototype.apply;e.setTimeout=function(){return new o(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new o(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(19),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function o(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var o={callback:t,args:e};return l[c]=o,s(c),c++}function r(t){delete l[t]}function i(t){var e=t.callback,o=t.args;switch(o.length){case 0:e();break;case 1:e(o[0]);break;case 2:e(o[0],o[1]);break;case 3:e(o[0],o[1],o[2]);break;default:e.apply(n,o)}}function a(t){if(u)setTimeout(a,0,t);else{var e=l[t];if(e){u=!0;try{i(e)}finally{r(t),u=!1}}}}if(!t.setImmediate){var s,c=1,l={},u=!1,f=t.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(t);d=d&&d.setTimeout?d:t,"[object process]"==={}.toString.call(t.process)?function(){s=function(t){e.nextTick(function(){a(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&a(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),s=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){a(t.data)},s=function(e){t.port2.postMessage(e)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var t=f.documentElement;s=function(e){var n=f.createElement("script");n.onreadystatechange=function(){a(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){s=function(t){setTimeout(a,0,t)}}(),d.setImmediate=o,d.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(20))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(u===setTimeout)return setTimeout(t,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(t,0);try{return u(t,0)}catch(e){try{return u.call(null,t,0)}catch(e){return u.call(this,t,0)}}}function i(t){if(f===clearTimeout)return clearTimeout(t);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function a(){b&&p&&(b=!1,p.length?m=p.concat(m):v=-1,m.length&&s())}function s(){if(!b){var t=r(a);b=!0;for(var e=m.length;e;){for(p=m,m=[];++v<e;)p&&p[v].run();v=-1,e=m.length}p=null,b=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function l(){}var u,f,d=t.exports={};!function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(t){u=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(t){f=o}}();var p,m=[],b=!1,v=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];m.push(new c(t,e)),1!==m.length||b||r(s)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";n(22).polyfill()},function(t,e,n){"use strict";function o(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),o=1;o<arguments.length;o++){var r=arguments[o];if(void 0!==r&&null!==r)for(var i=Object.keys(Object(r)),a=0,s=i.length;a<s;a++){var c=i[a],l=Object.getOwnPropertyDescriptor(r,c);void 0!==l&&l.enumerable&&(n[c]=r[c])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:o})}t.exports={assign:o,polyfill:r}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(24),r=n(6),i=n(5),a=n(36),s=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if("undefined"!=typeof window){var n=a.getOpts.apply(void 0,t);return new Promise(function(t,e){i.default.promise={resolve:t,reject:e},o.default(n),setTimeout(function(){r.openModal()})})}};s.close=r.onAction,s.getState=r.getState,s.setActionValue=i.setActionValue,s.stopLoading=r.stopLoading,s.setDefaults=a.setDefaults,e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(0),i=r.default.MODAL,a=n(4),s=n(34),c=n(35),l=n(1);e.init=function(t){o.getNode(i)||(document.body||l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"),s.default(),a.default()),a.initModalContent(t),c.default(t)},e.default=e.init},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.MODAL;e.modalMarkup='\n  <div class="'+r+'" role="dialog" aria-modal="true"></div>',e.default=e.modalMarkup},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.OVERLAY,i='<div \n    class="'+r+'"\n    tabIndex="-1">\n  </div>';e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.ICON;e.errorIconMarkup=function(){var t=r+"--error",e=t+"__line";return'\n    <div class="'+t+'__x-mark">\n      <span class="'+e+" "+e+'--left"></span>\n      <span class="'+e+" "+e+'--right"></span>\n    </div>\n  '},e.warningIconMarkup=function(){var t=r+"--warning";return'\n    <span class="'+t+'__body">\n      <span class="'+t+'__dot"></span>\n    </span>\n  '},e.successIconMarkup=function(){var t=r+"--success";return'\n    <span class="'+t+"__line "+t+'__line--long"></span>\n    <span class="'+t+"__line "+t+'__line--tip"></span>\n\n    <div class="'+t+'__ring"></div>\n    <div class="'+t+'__hide-corners"></div>\n  '}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.CONTENT;e.contentMarkup='\n  <div class="'+r+'">\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.BUTTON_CONTAINER,i=o.default.BUTTON,a=o.default.BUTTON_LOADER;e.buttonMarkup='\n  <div class="'+r+'">\n\n    <button\n      class="'+i+'"\n    ></button>\n\n    <div class="'+a+'">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(2),i=n(0),a=i.default.ICON,s=i.default.ICON_CUSTOM,c=["error","warning","success","info"],l={error:r.errorIconMarkup(),warning:r.warningIconMarkup(),success:r.successIconMarkup()},u=function(t,e){var n=a+"--"+t;e.classList.add(n);var o=l[t];o&&(e.innerHTML=o)},f=function(t,e){e.classList.add(s);var n=document.createElement("img");n.src=t,e.appendChild(n)},d=function(t){if(t){var e=o.injectElIntoModal(r.iconMarkup);c.includes(t)?u(t,e):f(t,e)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),r=n(4),i=function(t){navigator.userAgent.includes("AppleWebKit")&&(t.style.display="none",t.offsetHeight,t.style.display="")};e.initTitle=function(t){if(t){var e=r.injectElIntoModal(o.titleMarkup);e.textContent=t,i(e)}},e.initText=function(t){if(t){var e=document.createDocumentFragment();t.split("\n").forEach(function(t,n,o){e.appendChild(document.createTextNode(t)),n<o.length-1&&e.appendChild(document.createElement("br"))});var n=r.injectElIntoModal(o.textMarkup);n.appendChild(e),i(n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(4),i=n(0),a=i.default.BUTTON,s=i.default.DANGER_BUTTON,c=n(3),l=n(2),u=n(6),f=n(5),d=function(t,e,n){var r=e.text,i=e.value,d=e.className,p=e.closeModal,m=o.stringToNode(l.buttonMarkup),b=m.querySelector("."+a),v=a+"--"+t;if(b.classList.add(v),d){(Array.isArray(d)?d:d.split(" ")).filter(function(t){return t.length>0}).forEach(function(t){b.classList.add(t)})}n&&t===c.CONFIRM_KEY&&b.classList.add(s),b.textContent=r;var g={};return g[t]=i,f.setActionValue(g),f.setActionOptionsFor(t,{closeModal:p}),b.addEventListener("click",function(){return u.onAction(t)}),m},p=function(t,e){var n=r.injectElIntoModal(l.footerMarkup);for(var o in t){var i=t[o],a=d(o,i,e);i.visible&&n.appendChild(a)}0===n.children.length&&n.remove()};e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r=n(4),i=n(2),a=n(5),s=n(6),c=n(0),l=c.default.CONTENT,u=function(t){t.addEventListener("input",function(t){var e=t.target,n=e.value;a.setActionValue(n)}),t.addEventListener("keyup",function(t){if("Enter"===t.key)return s.onAction(o.CONFIRM_KEY)}),setTimeout(function(){t.focus(),a.setActionValue("")},0)},f=function(t,e,n){var o=document.createElement(e),r=l+"__"+e;o.classList.add(r);for(var i in n){var a=n[i];o[i]=a}"input"===e&&u(o),t.appendChild(o)},d=function(t){if(t){var e=r.injectElIntoModal(i.contentMarkup),n=t.element,o=t.attributes;"string"==typeof n?f(e,n,o):e.appendChild(n)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=function(){var t=o.stringToNode(r.overlayMarkup);document.body.appendChild(t)};e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),r=n(6),i=n(1),a=n(3),s=n(0),c=s.default.MODAL,l=s.default.BUTTON,u=s.default.OVERLAY,f=function(t){t.preventDefault(),v()},d=function(t){t.preventDefault(),g()},p=function(t){if(o.default.isOpen)switch(t.key){case"Escape":return r.onAction(a.CANCEL_KEY)}},m=function(t){if(o.default.isOpen)switch(t.key){case"Tab":return f(t)}},b=function(t){if(o.default.isOpen)return"Tab"===t.key&&t.shiftKey?d(t):void 0},v=function(){var t=i.getNode(l);t&&(t.tabIndex=0,t.focus())},g=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l),n=e.length-1,o=e[n];o&&o.focus()},h=function(t){t[t.length-1].addEventListener("keydown",m)},w=function(t){t[0].addEventListener("keydown",b)},y=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l);e.length&&(h(e),w(e))},x=function(t){if(i.getNode(u)===t.target)return r.onAction(a.CANCEL_KEY)},_=function(t){var e=i.getNode(u);e.removeEventListener("click",x),t&&e.addEventListener("click",x)},k=function(t){o.default.timer&&clearTimeout(o.default.timer),t&&(o.default.timer=window.setTimeout(function(){return r.onAction(a.CANCEL_KEY)},t))},O=function(t){t.closeOnEsc?document.addEventListener("keyup",p):document.removeEventListener("keyup",p),t.dangerMode?v():g(),y(),_(t.closeOnClickOutside),k(t.timer)};e.default=O},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(37),a=n(38),s={title:null,text:null,icon:null,buttons:r.defaultButtonList,content:null,className:null,closeOnClickOutside:!0,closeOnEsc:!0,dangerMode:!1,timer:null},c=Object.assign({},s);e.setDefaults=function(t){c=Object.assign({},s,t)};var l=function(t){var e=t&&t.button,n=t&&t.buttons;return void 0!==e&&void 0!==n&&o.throwErr("Cannot set both 'button' and 'buttons' options!"),void 0!==e?{confirm:e}:n},u=function(t){return o.ordinalSuffixOf(t+1)},f=function(t,e){o.throwErr(u(e)+" argument ('"+t+"') is invalid")},d=function(t,e){var n=t+1,r=e[n];o.isPlainObject(r)||void 0===r||o.throwErr("Expected "+u(n)+" argument ('"+r+"') to be a plain object")},p=function(t,e){var n=t+1,r=e[n];void 0!==r&&o.throwErr("Unexpected "+u(n)+" argument ("+r+")")},m=function(t,e,n,r){var i=typeof e,a="string"===i,s=e instanceof Element;if(a){if(0===n)return{text:e};if(1===n)return{text:e,title:r[0]};if(2===n)return d(n,r),{icon:e};f(e,n)}else{if(s&&0===n)return d(n,r),{content:e};if(o.isPlainObject(e))return p(n,r),e;f(e,n)}};e.getOpts=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n={};t.forEach(function(e,o){var r=m(0,e,o,t);Object.assign(n,r)});var o=l(n);n.buttons=r.getButtonListOpts(o),delete n.button,n.content=i.getContentOpts(n.content);var u=Object.assign({},s,c,n);return Object.keys(u).forEach(function(t){a.DEPRECATED_OPTS[t]&&a.logDeprecation(t)}),u}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r={element:"input",attributes:{placeholder:""}};e.getContentOpts=function(t){var e={};return o.isPlainObject(t)?Object.assign(e,t):t instanceof Element?{element:t}:"input"===t?r:null}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.logDeprecation=function(t){var n=e.DEPRECATED_OPTS[t],o=n.onlyRename,r=n.replacement,i=n.subOption,a=n.link,s=o?"renamed":"deprecated",c='SweetAlert warning: "'+t+'" option has been '+s+".";if(r){c+=" Please use"+(i?' "'+i+'" in ':" ")+'"'+r+'" instead.'}var l="https://sweetalert.js.org";c+=a?" More details: "+l+a:" More details: "+l+"/guides/#upgrading-from-1x",console.warn(c)},e.DEPRECATED_OPTS={type:{replacement:"icon",link:"/docs/#icon"},imageUrl:{replacement:"icon",link:"/docs/#icon"},customClass:{replacement:"className",onlyRename:!0,link:"/docs/#classname"},imageSize:{},showCancelButton:{replacement:"buttons",link:"/docs/#buttons"},showConfirmButton:{replacement:"button",link:"/docs/#button"},confirmButtonText:{replacement:"button",link:"/docs/#button"},confirmButtonColor:{},cancelButtonText:{replacement:"buttons",link:"/docs/#buttons"},closeOnConfirm:{replacement:"button",subOption:"closeModal",link:"/docs/#button"},closeOnCancel:{replacement:"buttons",subOption:"closeModal",link:"/docs/#buttons"},showLoaderOnConfirm:{replacement:"buttons"},animation:{},inputType:{replacement:"content",link:"/docs/#content"},inputValue:{replacement:"content",link:"/docs/#content"},inputPlaceholder:{replacement:"content",link:"/docs/#content"},html:{replacement:"content",link:"/docs/#content"},allowEscapeKey:{replacement:"closeOnEsc",onlyRename:!0,link:"/docs/#closeonesc"},allowClickOutside:{replacement:"closeOnClickOutside",onlyRename:!0,link:"/docs/#closeonclickoutside"}}}])});
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"timers":11}],11:[function(require,module,exports){
(function (setImmediate,clearImmediate){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":8,"timers":11}],12:[function(require,module,exports){
(function (global){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

(function (factory) {
  window.cash = factory();
})(function () {
  var doc = document,
      win = window,
      ArrayProto = Array.prototype,
      slice = ArrayProto.slice,
      _filter = ArrayProto.filter,
      push = ArrayProto.push;

  var noop = function noop() {},
      isFunction = function isFunction(item) {
    return _typeof(item) === _typeof(noop) && item.call;
  },
      isString = function isString(item) {
    return _typeof(item) === _typeof("");
  };

  var idMatch = /^#[\w-]*$/,
      classMatch = /^\.[\w-]*$/,
      htmlMatch = /<.+>/,
      singlet = /^\w+$/;

  function _find(selector, context) {
    context = context || doc;
    var elems = classMatch.test(selector) ? context.getElementsByClassName(selector.slice(1)) : singlet.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
    return elems;
  }

  var frag;

  function parseHTML(str) {
    if (!frag) {
      frag = doc.implementation.createHTMLDocument(null);
      var base = frag.createElement("base");
      base.href = doc.location.href;
      frag.head.appendChild(base);
    }

    frag.body.innerHTML = str;
    return frag.body.childNodes;
  }

  function onReady(fn) {
    if (doc.readyState !== "loading") {
      fn();
    } else {
      doc.addEventListener("DOMContentLoaded", fn);
    }
  }

  function Init(selector, context) {
    if (!selector) {
      return this;
    } // If already a cash collection, don't do any further processing


    if (selector.cash && selector !== win) {
      return selector;
    }

    var elems = selector,
        i = 0,
        length;

    if (isString(selector)) {
      elems = idMatch.test(selector) ? // If an ID use the faster getElementById check
      doc.getElementById(selector.slice(1)) : htmlMatch.test(selector) ? // If HTML, parse it into real elements
      parseHTML(selector) : // else use `find`
      _find(selector, context); // If function, use as shortcut for DOM ready
    } else if (isFunction(selector)) {
      onReady(selector);
      return this;
    }

    if (!elems) {
      return this;
    } // If a single DOM element is passed in or received via ID, return the single element


    if (elems.nodeType || elems === win) {
      this[0] = elems;
      this.length = 1;
    } else {
      // Treat like an array and loop through each item.
      length = this.length = elems.length;

      for (; i < length; i++) {
        this[i] = elems[i];
      }
    }

    return this;
  }

  function cash(selector, context) {
    return new Init(selector, context);
  }

  var fn = cash.fn = cash.prototype = Init.prototype = {
    // jshint ignore:line
    cash: true,
    length: 0,
    push: push,
    splice: ArrayProto.splice,
    map: ArrayProto.map,
    init: Init
  };
  Object.defineProperty(fn, "constructor", {
    value: cash
  });
  cash.parseHTML = parseHTML;
  cash.noop = noop;
  cash.isFunction = isFunction;
  cash.isString = isString;

  cash.extend = fn.extend = function (target) {
    target = target || {};
    var args = slice.call(arguments),
        length = args.length,
        i = 1;

    if (args.length === 1) {
      target = this;
      i = 0;
    }

    for (; i < length; i++) {
      if (!args[i]) {
        continue;
      }

      for (var key in args[i]) {
        if (args[i].hasOwnProperty(key)) {
          target[key] = args[i][key];
        }
      }
    }

    return target;
  };

  function _each(collection, callback) {
    var l = collection.length,
        i = 0;

    for (; i < l; i++) {
      if (callback.call(collection[i], collection[i], i, collection) === false) {
        break;
      }
    }
  }

  function matches(el, selector) {
    var m = el && (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector);
    return !!m && m.call(el, selector);
  }

  function getCompareFunction(selector) {
    return (
      /* Use browser's `matches` function if string */
      isString(selector) ? matches :
      /* Match a cash element */
      selector.cash ? function (el) {
        return selector.is(el);
      } :
      /* Direct comparison */
      function (el, selector) {
        return el === selector;
      }
    );
  }

  function unique(collection) {
    return cash(slice.call(collection).filter(function (item, index, self) {
      return self.indexOf(item) === index;
    }));
  }

  cash.extend({
    merge: function merge(first, second) {
      var len = +second.length,
          i = first.length,
          j = 0;

      for (; j < len; i++, j++) {
        first[i] = second[j];
      }

      first.length = i;
      return first;
    },
    each: _each,
    matches: matches,
    unique: unique,
    isArray: Array.isArray,
    isNumeric: function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  });
  var uid = cash.uid = "_cash" + Date.now();

  function getDataCache(node) {
    return node[uid] = node[uid] || {};
  }

  function setData(node, key, value) {
    return getDataCache(node)[key] = value;
  }

  function getData(node, key) {
    var c = getDataCache(node);

    if (c[key] === undefined) {
      c[key] = node.dataset ? node.dataset[key] : cash(node).attr("data-" + key);
    }

    return c[key];
  }

  function _removeData(node, key) {
    var c = getDataCache(node);

    if (c) {
      delete c[key];
    } else if (node.dataset) {
      delete node.dataset[key];
    } else {
      cash(node).removeAttr("data-" + name);
    }
  }

  fn.extend({
    data: function data(name, value) {
      if (isString(name)) {
        return value === undefined ? getData(this[0], name) : this.each(function (v) {
          return setData(v, name, value);
        });
      }

      for (var key in name) {
        this.data(key, name[key]);
      }

      return this;
    },
    removeData: function removeData(key) {
      return this.each(function (v) {
        return _removeData(v, key);
      });
    }
  });
  var notWhiteMatch = /\S+/g;

  function getClasses(c) {
    return isString(c) && c.match(notWhiteMatch);
  }

  function _hasClass(v, c) {
    return v.classList ? v.classList.contains(c) : new RegExp("(^| )" + c + "( |$)", "gi").test(v.className);
  }

  function _addClass(v, c, spacedName) {
    if (v.classList) {
      v.classList.add(c);
    } else if (spacedName.indexOf(" " + c + " ")) {
      v.className += " " + c;
    }
  }

  function _removeClass(v, c) {
    if (v.classList) {
      v.classList.remove(c);
    } else {
      v.className = v.className.replace(c, "");
    }
  }

  fn.extend({
    addClass: function addClass(c) {
      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";

        _each(classes, function (c) {
          _addClass(v, c, spacedName);
        });
      }) : this;
    },
    attr: function attr(name, value) {
      if (!name) {
        return undefined;
      }

      if (isString(name)) {
        if (value === undefined) {
          return this[0] ? this[0].getAttribute ? this[0].getAttribute(name) : this[0][name] : undefined;
        }

        return this.each(function (v) {
          if (v.setAttribute) {
            v.setAttribute(name, value);
          } else {
            v[name] = value;
          }
        });
      }

      for (var key in name) {
        this.attr(key, name[key]);
      }

      return this;
    },
    hasClass: function hasClass(c) {
      var check = false,
          classes = getClasses(c);

      if (classes && classes.length) {
        this.each(function (v) {
          check = _hasClass(v, classes[0]);
          return !check;
        });
      }

      return check;
    },
    prop: function prop(name, value) {
      if (isString(name)) {
        return value === undefined ? this[0][name] : this.each(function (v) {
          v[name] = value;
        });
      }

      for (var key in name) {
        this.prop(key, name[key]);
      }

      return this;
    },
    removeAttr: function removeAttr(name) {
      return this.each(function (v) {
        if (v.removeAttribute) {
          v.removeAttribute(name);
        } else {
          delete v[name];
        }
      });
    },
    removeClass: function removeClass(c) {
      if (!arguments.length) {
        return this.attr("class", "");
      }

      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        _each(classes, function (c) {
          _removeClass(v, c);
        });
      }) : this;
    },
    removeProp: function removeProp(name) {
      return this.each(function (v) {
        delete v[name];
      });
    },
    toggleClass: function toggleClass(c, state) {
      if (state !== undefined) {
        return this[state ? "addClass" : "removeClass"](c);
      }

      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";

        _each(classes, function (c) {
          if (_hasClass(v, c)) {
            _removeClass(v, c);
          } else {
            _addClass(v, c, spacedName);
          }
        });
      }) : this;
    }
  });
  fn.extend({
    add: function add(selector, context) {
      return unique(cash.merge(this, cash(selector, context)));
    },
    each: function each(callback) {
      _each(this, callback);

      return this;
    },
    eq: function eq(index) {
      return cash(this.get(index));
    },
    filter: function filter(selector) {
      if (!selector) {
        return this;
      }

      var comparator = isFunction(selector) ? selector : getCompareFunction(selector);
      return cash(_filter.call(this, function (e) {
        return comparator(e, selector);
      }));
    },
    first: function first() {
      return this.eq(0);
    },
    get: function get(index) {
      if (index === undefined) {
        return slice.call(this);
      }

      return index < 0 ? this[index + this.length] : this[index];
    },
    index: function index(elem) {
      var child = elem ? cash(elem)[0] : this[0],
          collection = elem ? this : cash(child).parent().children();
      return slice.call(collection).indexOf(child);
    },
    last: function last() {
      return this.eq(-1);
    }
  });

  var camelCase = function () {
    var camelRegex = /(?:^\w|[A-Z]|\b\w)/g,
        whiteSpace = /[\s-_]+/g;
    return function (str) {
      return str.replace(camelRegex, function (letter, index) {
        return letter[index === 0 ? "toLowerCase" : "toUpperCase"]();
      }).replace(whiteSpace, "");
    };
  }();

  var getPrefixedProp = function () {
    var cache = {},
        doc = document,
        div = doc.createElement("div"),
        style = div.style;
    return function (prop) {
      prop = camelCase(prop);

      if (cache[prop]) {
        return cache[prop];
      }

      var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
          prefixes = ["webkit", "moz", "ms", "o"],
          props = (prop + " " + prefixes.join(ucProp + " ") + ucProp).split(" ");

      _each(props, function (p) {
        if (p in style) {
          cache[p] = prop = cache[prop] = p;
          return false;
        }
      });

      return cache[prop];
    };
  }();

  cash.prefixedProp = getPrefixedProp;
  cash.camelCase = camelCase;
  fn.extend({
    css: function css(prop, value) {
      if (isString(prop)) {
        prop = getPrefixedProp(prop);
        return arguments.length > 1 ? this.each(function (v) {
          return v.style[prop] = value;
        }) : win.getComputedStyle(this[0])[prop];
      }

      for (var key in prop) {
        this.css(key, prop[key]);
      }

      return this;
    }
  });

  function compute(el, prop) {
    return parseInt(win.getComputedStyle(el[0], null)[prop], 10) || 0;
  }

  _each(["Width", "Height"], function (v) {
    var lower = v.toLowerCase();

    fn[lower] = function () {
      return this[0].getBoundingClientRect()[lower];
    };

    fn["inner" + v] = function () {
      return this[0]["client" + v];
    };

    fn["outer" + v] = function (margins) {
      return this[0]["offset" + v] + (margins ? compute(this, "margin" + (v === "Width" ? "Left" : "Top")) + compute(this, "margin" + (v === "Width" ? "Right" : "Bottom")) : 0);
    };
  });

  function registerEvent(node, eventName, callback) {
    var eventCache = getData(node, "_cashEvents") || setData(node, "_cashEvents", {});
    eventCache[eventName] = eventCache[eventName] || [];
    eventCache[eventName].push(callback);
    node.addEventListener(eventName, callback);
  }

  function removeEvent(node, eventName, callback) {
    var events = getData(node, "_cashEvents"),
        eventCache = events && events[eventName],
        index;

    if (!eventCache) {
      return;
    }

    if (callback) {
      node.removeEventListener(eventName, callback);
      index = eventCache.indexOf(callback);

      if (index >= 0) {
        eventCache.splice(index, 1);
      }
    } else {
      _each(eventCache, function (event) {
        node.removeEventListener(eventName, event);
      });

      eventCache = [];
    }
  }

  fn.extend({
    off: function off(eventName, callback) {
      return this.each(function (v) {
        return removeEvent(v, eventName, callback);
      });
    },
    on: function on(eventName, delegate, callback, runOnce) {
      // jshint ignore:line
      var originalCallback;

      if (!isString(eventName)) {
        for (var key in eventName) {
          this.on(key, delegate, eventName[key]);
        }

        return this;
      }

      if (isFunction(delegate)) {
        callback = delegate;
        delegate = null;
      }

      if (eventName === "ready") {
        onReady(callback);
        return this;
      }

      if (delegate) {
        originalCallback = callback;

        callback = function callback(e) {
          var t = e.target;

          while (!matches(t, delegate)) {
            if (t === this || t === null) {
              return t = false;
            }

            t = t.parentNode;
          }

          if (t) {
            originalCallback.call(t, e);
          }
        };
      }

      return this.each(function (v) {
        var _finalCallback = callback;

        if (runOnce) {
          _finalCallback = function finalCallback() {
            callback.apply(this, arguments);
            removeEvent(v, eventName, _finalCallback);
          };
        }

        registerEvent(v, eventName, _finalCallback);
      });
    },
    one: function one(eventName, delegate, callback) {
      return this.on(eventName, delegate, callback, true);
    },
    ready: onReady,

    /**
     * Modified
     * Triggers browser event
     * @param String eventName
     * @param Object data - Add properties to event object
     */
    trigger: function trigger(eventName, data) {
      if (document.createEvent) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent(eventName, true, false);
        evt = this.extend(evt, data);
        return this.each(function (v) {
          return v.dispatchEvent(evt);
        });
      }
    }
  });

  function encode(name, value) {
    return "&" + encodeURIComponent(name) + "=" + encodeURIComponent(value).replace(/%20/g, "+");
  }

  function getSelectMultiple_(el) {
    var values = [];

    _each(el.options, function (o) {
      if (o.selected) {
        values.push(o.value);
      }
    });

    return values.length ? values : null;
  }

  function getSelectSingle_(el) {
    var selectedIndex = el.selectedIndex;
    return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
  }

  function getValue(el) {
    var type = el.type;

    if (!type) {
      return null;
    }

    switch (type.toLowerCase()) {
      case "select-one":
        return getSelectSingle_(el);

      case "select-multiple":
        return getSelectMultiple_(el);

      case "radio":
        return el.checked ? el.value : null;

      case "checkbox":
        return el.checked ? el.value : null;

      default:
        return el.value ? el.value : null;
    }
  }

  fn.extend({
    serialize: function serialize() {
      var query = "";

      _each(this[0].elements || this, function (el) {
        if (el.disabled || el.tagName === "FIELDSET") {
          return;
        }

        var name = el.name;

        switch (el.type.toLowerCase()) {
          case "file":
          case "reset":
          case "submit":
          case "button":
            break;

          case "select-multiple":
            var values = getValue(el);

            if (values !== null) {
              _each(values, function (value) {
                query += encode(name, value);
              });
            }

            break;

          default:
            var value = getValue(el);

            if (value !== null) {
              query += encode(name, value);
            }

        }
      });

      return query.substr(1);
    },
    val: function val(value) {
      if (value === undefined) {
        return getValue(this[0]);
      }

      return this.each(function (v) {
        return v.value = value;
      });
    }
  });

  function insertElement(el, child, prepend) {
    if (prepend) {
      var first = el.childNodes[0];
      el.insertBefore(child, first);
    } else {
      el.appendChild(child);
    }
  }

  function insertContent(parent, child, prepend) {
    var str = isString(child);

    if (!str && child.length) {
      _each(child, function (v) {
        return insertContent(parent, v, prepend);
      });

      return;
    }

    _each(parent, str ? function (v) {
      return v.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", child);
    } : function (v, i) {
      return insertElement(v, i === 0 ? child : child.cloneNode(true), prepend);
    });
  }

  fn.extend({
    after: function after(selector) {
      cash(selector).insertAfter(this);
      return this;
    },
    append: function append(content) {
      insertContent(this, content);
      return this;
    },
    appendTo: function appendTo(parent) {
      insertContent(cash(parent), this);
      return this;
    },
    before: function before(selector) {
      cash(selector).insertBefore(this);
      return this;
    },
    clone: function clone() {
      return cash(this.map(function (v) {
        return v.cloneNode(true);
      }));
    },
    empty: function empty() {
      this.html("");
      return this;
    },
    html: function html(content) {
      if (content === undefined) {
        return this[0].innerHTML;
      }

      var source = content.nodeType ? content[0].outerHTML : content;
      return this.each(function (v) {
        return v.innerHTML = source;
      });
    },
    insertAfter: function insertAfter(selector) {
      var _this = this;

      cash(selector).each(function (el, i) {
        var parent = el.parentNode,
            sibling = el.nextSibling;

        _this.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), sibling);
        });
      });
      return this;
    },
    insertBefore: function insertBefore(selector) {
      var _this2 = this;

      cash(selector).each(function (el, i) {
        var parent = el.parentNode;

        _this2.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), el);
        });
      });
      return this;
    },
    prepend: function prepend(content) {
      insertContent(this, content, true);
      return this;
    },
    prependTo: function prependTo(parent) {
      insertContent(cash(parent), this, true);
      return this;
    },
    remove: function remove() {
      return this.each(function (v) {
        if (!!v.parentNode) {
          return v.parentNode.removeChild(v);
        }
      });
    },
    text: function text(content) {
      if (content === undefined) {
        return this[0].textContent;
      }

      return this.each(function (v) {
        return v.textContent = content;
      });
    }
  });
  var docEl = doc.documentElement;
  fn.extend({
    position: function position() {
      var el = this[0];
      return {
        left: el.offsetLeft,
        top: el.offsetTop
      };
    },
    offset: function offset() {
      var rect = this[0].getBoundingClientRect();
      return {
        top: rect.top + win.pageYOffset - docEl.clientTop,
        left: rect.left + win.pageXOffset - docEl.clientLeft
      };
    },
    offsetParent: function offsetParent() {
      return cash(this[0].offsetParent);
    }
  });
  fn.extend({
    children: function children(selector) {
      var elems = [];
      this.each(function (el) {
        push.apply(elems, el.children);
      });
      elems = unique(elems);
      return !selector ? elems : elems.filter(function (v) {
        return matches(v, selector);
      });
    },
    closest: function closest(selector) {
      if (!selector || this.length < 1) {
        return cash();
      }

      if (this.is(selector)) {
        return this.filter(selector);
      }

      return this.parent().closest(selector);
    },
    is: function is(selector) {
      if (!selector) {
        return false;
      }

      var match = false,
          comparator = getCompareFunction(selector);
      this.each(function (el) {
        match = comparator(el, selector);
        return !match;
      });
      return match;
    },
    find: function find(selector) {
      if (!selector || selector.nodeType) {
        return cash(selector && this.has(selector).length ? selector : null);
      }

      var elems = [];
      this.each(function (el) {
        push.apply(elems, _find(selector, el));
      });
      return unique(elems);
    },
    has: function has(selector) {
      var comparator = isString(selector) ? function (el) {
        return _find(selector, el).length !== 0;
      } : function (el) {
        return el.contains(selector);
      };
      return this.filter(comparator);
    },
    next: function next() {
      return cash(this[0].nextElementSibling);
    },
    not: function not(selector) {
      if (!selector) {
        return this;
      }

      var comparator = getCompareFunction(selector);
      return this.filter(function (el) {
        return !comparator(el, selector);
      });
    },
    parent: function parent() {
      var result = [];
      this.each(function (item) {
        if (item && item.parentNode) {
          result.push(item.parentNode);
        }
      });
      return unique(result);
    },
    parents: function parents(selector) {
      var last,
          result = [];
      this.each(function (item) {
        last = item;

        while (last && last.parentNode && last !== doc.body.parentNode) {
          last = last.parentNode;

          if (!selector || selector && matches(last, selector)) {
            result.push(last);
          }
        }
      });
      return unique(result);
    },
    prev: function prev() {
      return cash(this[0].previousElementSibling);
    },
    siblings: function siblings(selector) {
      var collection = this.parent().children(selector),
          el = this[0];
      return collection.filter(function (i) {
        return i !== el;
      });
    }
  });
  return cash;
});

;

var Component = function () {
  /**
   * Generic constructor for all components
   * @constructor
   * @param {Element} el
   * @param {Object} options
   */
  function Component(classDef, el, options) {
    _classCallCheck(this, Component); // Display error if el is valid HTML Element


    if (!(el instanceof Element)) {
      console.error(Error(el + ' is not an HTML Element'));
    } // If exists, destroy and reinitialize in child


    var ins = classDef.getInstance(el);

    if (!!ins) {
      ins.destroy();
    }

    this.el = el;
    this.$el = cash(el);
  }
  /**
   * Initializes components
   * @param {class} classDef
   * @param {Element | NodeList | jQuery} els
   * @param {Object} options
   */


  _createClass(Component, null, [{
    key: "init",
    value: function init(classDef, els, options) {
      var instances = null;

      if (els instanceof Element) {
        instances = new classDef(els, options);
      } else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
        var instancesArr = [];

        for (var i = 0; i < els.length; i++) {
          instancesArr.push(new classDef(els[i], options));
        }

        instances = instancesArr;
      }

      return instances;
    }
  }]);

  return Component;
}();

; // Required for Meteor package, the use of window prevents export by Meteor

(function (window) {
  if (window.Package) {
    M = {};
  } else {
    window.M = {};
  } // Check for jQuery


  M.jQueryLoaded = !!window.jQuery;
})(window); // AMD


if (typeof define === 'function' && define.amd) {
  define('M', [], function () {
    return M;
  }); // Common JS
} else if (typeof exports !== 'undefined' && !exports.nodeType) {
  if (typeof module !== 'undefined' && !module.nodeType && module.exports) {
    exports = module.exports = M;
  }

  exports["default"] = M;
}

M.version = '1.0.0';
M.keys = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};
/**
 * TabPress Keydown handler
 */

M.tabPressed = false;
M.keyDown = false;

var docHandleKeydown = function docHandleKeydown(e) {
  M.keyDown = true;

  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = true;
  }
};

var docHandleKeyup = function docHandleKeyup(e) {
  M.keyDown = false;

  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = false;
  }
};

var docHandleFocus = function docHandleFocus(e) {
  if (M.keyDown) {
    document.body.classList.add('six-storage-keyboard-focused');
  }
};

var docHandleBlur = function docHandleBlur(e) {
  document.body.classList.remove('six-storage-keyboard-focused');
};

document.addEventListener('keydown', docHandleKeydown, true);
document.addEventListener('keyup', docHandleKeyup, true);
document.addEventListener('focus', docHandleFocus, true);
document.addEventListener('blur', docHandleBlur, true);
/**
 * Initialize jQuery wrapper for plugin
 * @param {Class} plugin  javascript class
 * @param {string} pluginName  jQuery plugin name
 * @param {string} classRef  Class reference name
 */

M.initializeJqueryWrapper = function (plugin, pluginName, classRef) {
  jQuery.fn[pluginName] = function (methodOrOptions) {
    // Call plugin method if valid method name is passed in
    if (plugin.prototype[methodOrOptions]) {
      var params = Array.prototype.slice.call(arguments, 1); // Getter methods

      if (methodOrOptions.slice(0, 3) === 'get') {
        var instance = this.first()[0][classRef];
        return instance[methodOrOptions].apply(instance, params);
      } // Void methods


      return this.each(function () {
        var instance = this[classRef];
        instance[methodOrOptions].apply(instance, params);
      }); // Initialize plugin if options or no argument is passed in
    } else if (_typeof(methodOrOptions) === 'object' || !methodOrOptions) {
      plugin.init(this, arguments[0]);
      return this;
    } // Return error if an unrecognized  method name is passed in


    jQuery.error("Method " + methodOrOptions + " does not exist on jQuery." + pluginName);
  };
};
/**
 * Automatically initialize components
 * @param {Element} context  DOM Element to search within for components
 */


M.AutoInit = function (context) {
  // Use document.body if no context is given
  var root = !!context ? context : document.body;
  var registry = {
    Autocomplete: root.querySelectorAll('.autocomplete:not(.no-autoinit)'),
    Carousel: root.querySelectorAll('.six-storage-carousel:not(.no-autoinit)'),
    Chips: root.querySelectorAll('.six-storage-chips:not(.no-autoinit)'),
    Collapsible: root.querySelectorAll('.six-storage-collapsible:not(.no-autoinit)'),
    Datepicker: root.querySelectorAll('.datepicker:not(.no-autoinit)'),
    Dropdown: root.querySelectorAll('.six-storage-dropdown-trigger:not(.no-autoinit)'),
    Materialbox: root.querySelectorAll('.six-storage-materialboxed:not(.no-autoinit)'),
    Modal: root.querySelectorAll('.six-storage-modal:not(.no-autoinit)'),
    Parallax: root.querySelectorAll('.six-storage-parallax:not(.no-autoinit)'),
    Pushpin: root.querySelectorAll('.pushpin:not(.no-autoinit)'),
    ScrollSpy: root.querySelectorAll('.scrollspy:not(.no-autoinit)'),
    FormSelect: root.querySelectorAll('select:not(.no-autoinit)'),
    Sidenav: root.querySelectorAll('.six-storage-sidenav:not(.no-autoinit)'),
    Tabs: root.querySelectorAll('.six-storage-tabs:not(.no-autoinit)'),
    TapTarget: root.querySelectorAll('.six-storage-tap-target:not(.no-autoinit)'),
    Timepicker: root.querySelectorAll('.timepicker:not(.no-autoinit)'),
    Tooltip: root.querySelectorAll('.six-storage-tooltipped:not(.no-autoinit)'),
    FloatingActionButton: root.querySelectorAll('.six-storage-fixed-action-btn:not(.no-autoinit)')
  };

  for (var pluginName in registry) {
    var plugin = M[pluginName];
    plugin.init(registry[pluginName]);
  }
};
/**
 * Generate approximated selector string for a jQuery object
 * @param {jQuery} obj  jQuery object to be parsed
 * @returns {string}
 */


M.objectSelectorString = function (obj) {
  var tagStr = obj.prop('tagName') || '';
  var idStr = obj.attr('id') || '';
  var classStr = obj.attr('class') || '';
  return (tagStr + idStr + classStr).replace(/\s/g, '');
}; // Unique Random ID


M.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };
}();
/**
 * Escapes hash from special characters
 * @param {string} hash  String returned from this.hash
 * @returns {string}
 */


M.escapeHash = function (hash) {
  return hash.replace(/(:|\.|\[|\]|,|=|\/)/g, '\\$1');
};

M.elementOrParentIsFixed = function (element) {
  var $element = $(element);
  var $checkElements = $element.add($element.parents());
  var isFixed = false;
  $checkElements.each(function () {
    if ($(this).css('position') === 'fixed') {
      isFixed = true;
      return false;
    }
  });
  return isFixed;
};
/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Escapes hash from special characters
 * @param {Element} container  Container element that acts as the boundary
 * @param {Bounding} bounding  element bounding that is being checked
 * @param {Number} offset  offset from edge that counts as exceeding
 * @returns {Edges}
 */


M.checkWithinContainer = function (container, bounding, offset) {
  var edges = {
    top: false,
    right: false,
    bottom: false,
    left: false
  };
  var containerRect = container.getBoundingClientRect(); // If body element is smaller than viewport, use viewport height instead.

  var containerBottom = container === document.body ? Math.max(containerRect.bottom, window.innerHeight) : containerRect.bottom;
  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;
  var scrolledX = bounding.left - scrollLeft;
  var scrolledY = bounding.top - scrollTop; // Check for container and viewport for each edge

  if (scrolledX < containerRect.left + offset || scrolledX < offset) {
    edges.left = true;
  }

  if (scrolledX + bounding.width > containerRect.right - offset || scrolledX + bounding.width > window.innerWidth - offset) {
    edges.right = true;
  }

  if (scrolledY < containerRect.top + offset || scrolledY < offset) {
    edges.top = true;
  }

  if (scrolledY + bounding.height > containerBottom - offset || scrolledY + bounding.height > window.innerHeight - offset) {
    edges.bottom = true;
  }

  return edges;
};

M.checkPossibleAlignments = function (el, container, bounding, offset) {
  var canAlign = {
    top: true,
    right: true,
    bottom: true,
    left: true,
    spaceOnTop: null,
    spaceOnRight: null,
    spaceOnBottom: null,
    spaceOnLeft: null
  };
  var containerAllowsOverflow = getComputedStyle(container).overflow === 'visible';
  var containerRect = container.getBoundingClientRect();
  var containerHeight = Math.min(containerRect.height, window.innerHeight);
  var containerWidth = Math.min(containerRect.width, window.innerWidth);
  var elOffsetRect = el.getBoundingClientRect();
  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;
  var scrolledX = bounding.left - scrollLeft;
  var scrolledYTopEdge = bounding.top - scrollTop;
  var scrolledYBottomEdge = bounding.top + elOffsetRect.height - scrollTop; // Check for container and viewport for left

  canAlign.spaceOnRight = !containerAllowsOverflow ? containerWidth - (scrolledX + bounding.width) : window.innerWidth - (elOffsetRect.left + bounding.width);

  if (canAlign.spaceOnRight < 0) {
    canAlign.left = false;
  } // Check for container and viewport for Right


  canAlign.spaceOnLeft = !containerAllowsOverflow ? scrolledX - bounding.width + elOffsetRect.width : elOffsetRect.right - bounding.width;

  if (canAlign.spaceOnLeft < 0) {
    canAlign.right = false;
  } // Check for container and viewport for Top


  canAlign.spaceOnBottom = !containerAllowsOverflow ? containerHeight - (scrolledYTopEdge + bounding.height + offset) : window.innerHeight - (elOffsetRect.top + bounding.height + offset);

  if (canAlign.spaceOnBottom < 0) {
    canAlign.top = false;
  } // Check for container and viewport for Bottom


  canAlign.spaceOnTop = !containerAllowsOverflow ? scrolledYBottomEdge - (bounding.height - offset) : elOffsetRect.bottom - (bounding.height + offset);

  if (canAlign.spaceOnTop < 0) {
    canAlign.bottom = false;
  }

  return canAlign;
};

M.getOverflowParent = function (element) {
  if (element == null) {
    return null;
  }

  if (element === document.body || getComputedStyle(element).overflow !== 'visible') {
    return element;
  }

  return M.getOverflowParent(element.parentElement);
};
/**
 * Gets id of component from a trigger
 * @param {Element} trigger  trigger
 * @returns {string}
 */


M.getIdFromTrigger = function (trigger) {
  var id = trigger.getAttribute('data-target');

  if (!id) {
    id = trigger.getAttribute('href');

    if (id) {
      id = id.slice(1);
    } else {
      id = '';
    }
  }

  return id;
};
/**
 * Multi browser support for document scroll top
 * @returns {Number}
 */


M.getDocumentScrollTop = function () {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};
/**
 * Multi browser support for document scroll left
 * @returns {Number}
 */


M.getDocumentScrollLeft = function () {
  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
};
/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Get time in ms
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @type {function}
 * @return {number}
 */


var getTime = Date.now || function () {
  return new Date().getTime();
};
/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 * `{leading: false}`. To disable execution on the trailing edge, ditto.
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @param {function} func
 * @param {number} wait
 * @param {Object=} options
 * @returns {Function}
 */


M.throttle = function (func, wait, options) {
  var context = void 0,
      args = void 0,
      result = void 0;
  var timeout = null;
  var previous = 0;
  options || (options = {});

  var later = function later() {
    previous = options.leading === false ? 0 : getTime();
    timeout = null;
    result = func.apply(context, args);
    context = args = null;
  };

  return function () {
    var now = getTime();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;

    if (remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
      context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }

    return result;
  };
};

;
/*
v2.2.0
2017 Julian Garnier
Released under the MIT license
*/

var $jscomp = {
  scope: {}
};
$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, r, p) {
  if (p.get || p.set) throw new TypeError("ES3 does not support getters and setters.");
  e != Array.prototype && e != Object.prototype && (e[r] = p.value);
};

$jscomp.getGlobal = function (e) {
  return "undefined" != typeof window && window === e ? e : "undefined" != typeof global && null != global ? global : e;
};

$jscomp.global = $jscomp.getGlobal(void 0);
$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";

$jscomp.initSymbol = function () {
  $jscomp.initSymbol = function () {};

  $jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
};

$jscomp.symbolCounter_ = 0;

$jscomp.Symbol = function (e) {
  return $jscomp.SYMBOL_PREFIX + (e || "") + $jscomp.symbolCounter_++;
};

$jscomp.initSymbolIterator = function () {
  $jscomp.initSymbol();
  var e = $jscomp.global.Symbol.iterator;
  e || (e = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));
  "function" != typeof Array.prototype[e] && $jscomp.defineProperty(Array.prototype, e, {
    configurable: !0,
    writable: !0,
    value: function value() {
      return $jscomp.arrayIterator(this);
    }
  });

  $jscomp.initSymbolIterator = function () {};
};

$jscomp.arrayIterator = function (e) {
  var r = 0;
  return $jscomp.iteratorPrototype(function () {
    return r < e.length ? {
      done: !1,
      value: e[r++]
    } : {
      done: !0
    };
  });
};

$jscomp.iteratorPrototype = function (e) {
  $jscomp.initSymbolIterator();
  e = {
    next: e
  };

  e[$jscomp.global.Symbol.iterator] = function () {
    return this;
  };

  return e;
};

$jscomp.array = $jscomp.array || {};

$jscomp.iteratorFromArray = function (e, r) {
  $jscomp.initSymbolIterator();
  e instanceof String && (e += "");
  var p = 0,
      m = {
    next: function next() {
      if (p < e.length) {
        var u = p++;
        return {
          value: r(u, e[u]),
          done: !1
        };
      }

      m.next = function () {
        return {
          done: !0,
          value: void 0
        };
      };

      return m.next();
    }
  };

  m[Symbol.iterator] = function () {
    return m;
  };

  return m;
};

$jscomp.polyfill = function (e, r, p, m) {
  if (r) {
    p = $jscomp.global;
    e = e.split(".");

    for (m = 0; m < e.length - 1; m++) {
      var u = e[m];
      u in p || (p[u] = {});
      p = p[u];
    }

    e = e[e.length - 1];
    m = p[e];
    r = r(m);
    r != m && null != r && $jscomp.defineProperty(p, e, {
      configurable: !0,
      writable: !0,
      value: r
    });
  }
};

$jscomp.polyfill("Array.prototype.keys", function (e) {
  return e ? e : function () {
    return $jscomp.iteratorFromArray(this, function (e) {
      return e;
    });
  };
}, "es6-impl", "es3");
var $jscomp$this = void 0;

(function (r) {
  M.anime = r();
})(function () {
  function e(a) {
    if (!h.col(a)) try {
      return document.querySelectorAll(a);
    } catch (c) {}
  }

  function r(a, c) {
    for (var d = a.length, b = 2 <= arguments.length ? arguments[1] : void 0, f = [], n = 0; n < d; n++) {
      if (n in a) {
        var k = a[n];
        c.call(b, k, n, a) && f.push(k);
      }
    }

    return f;
  }

  function p(a) {
    return a.reduce(function (a, d) {
      return a.concat(h.arr(d) ? p(d) : d);
    }, []);
  }

  function m(a) {
    if (h.arr(a)) return a;
    h.str(a) && (a = e(a) || a);
    return a instanceof NodeList || a instanceof HTMLCollection ? [].slice.call(a) : [a];
  }

  function u(a, c) {
    return a.some(function (a) {
      return a === c;
    });
  }

  function C(a) {
    var c = {},
        d;

    for (d in a) {
      c[d] = a[d];
    }

    return c;
  }

  function D(a, c) {
    var d = C(a),
        b;

    for (b in a) {
      d[b] = c.hasOwnProperty(b) ? c[b] : a[b];
    }

    return d;
  }

  function z(a, c) {
    var d = C(a),
        b;

    for (b in c) {
      d[b] = h.und(a[b]) ? c[b] : a[b];
    }

    return d;
  }

  function T(a) {
    a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (a, c, d, k) {
      return c + c + d + d + k + k;
    });
    var c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
    a = parseInt(c[1], 16);
    var d = parseInt(c[2], 16),
        c = parseInt(c[3], 16);
    return "rgba(" + a + "," + d + "," + c + ",1)";
  }

  function U(a) {
    function c(a, c, b) {
      0 > b && (b += 1);
      1 < b && --b;
      return b < 1 / 6 ? a + 6 * (c - a) * b : .5 > b ? c : b < 2 / 3 ? a + (c - a) * (2 / 3 - b) * 6 : a;
    }

    var d = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);
    a = parseInt(d[1]) / 360;
    var b = parseInt(d[2]) / 100,
        f = parseInt(d[3]) / 100,
        d = d[4] || 1;
    if (0 == b) f = b = a = f;else {
      var n = .5 > f ? f * (1 + b) : f + b - f * b,
          k = 2 * f - n,
          f = c(k, n, a + 1 / 3),
          b = c(k, n, a);
      a = c(k, n, a - 1 / 3);
    }
    return "rgba(" + 255 * f + "," + 255 * b + "," + 255 * a + "," + d + ")";
  }

  function y(a) {
    if (a = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a)) return a[2];
  }

  function V(a) {
    if (-1 < a.indexOf("translate") || "perspective" === a) return "px";
    if (-1 < a.indexOf("rotate") || -1 < a.indexOf("skew")) return "deg";
  }

  function I(a, c) {
    return h.fnc(a) ? a(c.target, c.id, c.total) : a;
  }

  function E(a, c) {
    if (c in a.style) return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
  }

  function J(a, c) {
    if (h.dom(a) && u(W, c)) return "transform";
    if (h.dom(a) && (a.getAttribute(c) || h.svg(a) && a[c])) return "attribute";
    if (h.dom(a) && "transform" !== c && E(a, c)) return "css";
    if (null != a[c]) return "object";
  }

  function X(a, c) {
    var d = V(c),
        d = -1 < c.indexOf("scale") ? 1 : 0 + d;
    a = a.style.transform;
    if (!a) return d;

    for (var b = [], f = [], n = [], k = /(\w+)\((.+?)\)/g; b = k.exec(a);) {
      f.push(b[1]), n.push(b[2]);
    }

    a = r(n, function (a, b) {
      return f[b] === c;
    });
    return a.length ? a[0] : d;
  }

  function K(a, c) {
    switch (J(a, c)) {
      case "transform":
        return X(a, c);

      case "css":
        return E(a, c);

      case "attribute":
        return a.getAttribute(c);
    }

    return a[c] || 0;
  }

  function L(a, c) {
    var d = /^(\*=|\+=|-=)/.exec(a);
    if (!d) return a;
    var b = y(a) || 0;
    c = parseFloat(c);
    a = parseFloat(a.replace(d[0], ""));

    switch (d[0][0]) {
      case "+":
        return c + a + b;

      case "-":
        return c - a + b;

      case "*":
        return c * a + b;
    }
  }

  function F(a, c) {
    return Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2));
  }

  function M(a) {
    a = a.points;

    for (var c = 0, d, b = 0; b < a.numberOfItems; b++) {
      var f = a.getItem(b);
      0 < b && (c += F(d, f));
      d = f;
    }

    return c;
  }

  function N(a) {
    if (a.getTotalLength) return a.getTotalLength();

    switch (a.tagName.toLowerCase()) {
      case "circle":
        return 2 * Math.PI * a.getAttribute("r");

      case "rect":
        return 2 * a.getAttribute("width") + 2 * a.getAttribute("height");

      case "line":
        return F({
          x: a.getAttribute("x1"),
          y: a.getAttribute("y1")
        }, {
          x: a.getAttribute("x2"),
          y: a.getAttribute("y2")
        });

      case "polyline":
        return M(a);

      case "polygon":
        var c = a.points;
        return M(a) + F(c.getItem(c.numberOfItems - 1), c.getItem(0));
    }
  }

  function Y(a, c) {
    function d(b) {
      b = void 0 === b ? 0 : b;
      return a.el.getPointAtLength(1 <= c + b ? c + b : 0);
    }

    var b = d(),
        f = d(-1),
        n = d(1);

    switch (a.property) {
      case "x":
        return b.x;

      case "y":
        return b.y;

      case "angle":
        return 180 * Math.atan2(n.y - f.y, n.x - f.x) / Math.PI;
    }
  }

  function O(a, c) {
    var d = /-?\d*\.?\d+/g,
        b;
    b = h.pth(a) ? a.totalLength : a;

    if (h.col(b)) {
      if (h.rgb(b)) {
        var f = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);
        b = f ? "rgba(" + f[1] + ",1)" : b;
      } else b = h.hex(b) ? T(b) : h.hsl(b) ? U(b) : void 0;
    } else f = (f = y(b)) ? b.substr(0, b.length - f.length) : b, b = c && !/\s/g.test(b) ? f + c : f;

    b += "";
    return {
      original: b,
      numbers: b.match(d) ? b.match(d).map(Number) : [0],
      strings: h.str(a) || c ? b.split(d) : []
    };
  }

  function P(a) {
    a = a ? p(h.arr(a) ? a.map(m) : m(a)) : [];
    return r(a, function (a, d, b) {
      return b.indexOf(a) === d;
    });
  }

  function Z(a) {
    var c = P(a);
    return c.map(function (a, b) {
      return {
        target: a,
        id: b,
        total: c.length
      };
    });
  }

  function aa(a, c) {
    var d = C(c);

    if (h.arr(a)) {
      var b = a.length;
      2 !== b || h.obj(a[0]) ? h.fnc(c.duration) || (d.duration = c.duration / b) : a = {
        value: a
      };
    }

    return m(a).map(function (a, b) {
      b = b ? 0 : c.delay;
      a = h.obj(a) && !h.pth(a) ? a : {
        value: a
      };
      h.und(a.delay) && (a.delay = b);
      return a;
    }).map(function (a) {
      return z(a, d);
    });
  }

  function ba(a, c) {
    var d = {},
        b;

    for (b in a) {
      var f = I(a[b], c);
      h.arr(f) && (f = f.map(function (a) {
        return I(a, c);
      }), 1 === f.length && (f = f[0]));
      d[b] = f;
    }

    d.duration = parseFloat(d.duration);
    d.delay = parseFloat(d.delay);
    return d;
  }

  function ca(a) {
    return h.arr(a) ? A.apply(this, a) : Q[a];
  }

  function da(a, c) {
    var d;
    return a.tweens.map(function (b) {
      b = ba(b, c);
      var f = b.value,
          e = K(c.target, a.name),
          k = d ? d.to.original : e,
          k = h.arr(f) ? f[0] : k,
          w = L(h.arr(f) ? f[1] : f, k),
          e = y(w) || y(k) || y(e);
      b.from = O(k, e);
      b.to = O(w, e);
      b.start = d ? d.end : a.offset;
      b.end = b.start + b.delay + b.duration;
      b.easing = ca(b.easing);
      b.elasticity = (1E3 - Math.min(Math.max(b.elasticity, 1), 999)) / 1E3;
      b.isPath = h.pth(f);
      b.isColor = h.col(b.from.original);
      b.isColor && (b.round = 1);
      return d = b;
    });
  }

  function ea(a, c) {
    return r(p(a.map(function (a) {
      return c.map(function (b) {
        var c = J(a.target, b.name);

        if (c) {
          var d = da(b, a);
          b = {
            type: c,
            property: b.name,
            animatable: a,
            tweens: d,
            duration: d[d.length - 1].end,
            delay: d[0].delay
          };
        } else b = void 0;

        return b;
      });
    })), function (a) {
      return !h.und(a);
    });
  }

  function R(a, c, d, b) {
    var f = "delay" === a;
    return c.length ? (f ? Math.min : Math.max).apply(Math, c.map(function (b) {
      return b[a];
    })) : f ? b.delay : d.offset + b.delay + b.duration;
  }

  function fa(a) {
    var c = D(ga, a),
        d = D(S, a),
        b = Z(a.targets),
        f = [],
        e = z(c, d),
        k;

    for (k in a) {
      e.hasOwnProperty(k) || "targets" === k || f.push({
        name: k,
        offset: e.offset,
        tweens: aa(a[k], d)
      });
    }

    a = ea(b, f);
    return z(c, {
      children: [],
      animatables: b,
      animations: a,
      duration: R("duration", a, c, d),
      delay: R("delay", a, c, d)
    });
  }

  function q(a) {
    function c() {
      return window.Promise && new Promise(function (a) {
        return p = a;
      });
    }

    function d(a) {
      return g.reversed ? g.duration - a : a;
    }

    function b(a) {
      for (var b = 0, c = {}, d = g.animations, f = d.length; b < f;) {
        var e = d[b],
            k = e.animatable,
            h = e.tweens,
            n = h.length - 1,
            l = h[n];
        n && (l = r(h, function (b) {
          return a < b.end;
        })[0] || l);

        for (var h = Math.min(Math.max(a - l.start - l.delay, 0), l.duration) / l.duration, w = isNaN(h) ? 1 : l.easing(h, l.elasticity), h = l.to.strings, p = l.round, n = [], m = void 0, m = l.to.numbers.length, t = 0; t < m; t++) {
          var x = void 0,
              x = l.to.numbers[t],
              q = l.from.numbers[t],
              x = l.isPath ? Y(l.value, w * x) : q + w * (x - q);
          p && (l.isColor && 2 < t || (x = Math.round(x * p) / p));
          n.push(x);
        }

        if (l = h.length) for (m = h[0], w = 0; w < l; w++) {
          p = h[w + 1], t = n[w], isNaN(t) || (m = p ? m + (t + p) : m + (t + " "));
        } else m = n[0];
        ha[e.type](k.target, e.property, m, c, k.id);
        e.currentValue = m;
        b++;
      }

      if (b = Object.keys(c).length) for (d = 0; d < b; d++) {
        H || (H = E(document.body, "transform") ? "transform" : "-webkit-transform"), g.animatables[d].target.style[H] = c[d].join(" ");
      }
      g.currentTime = a;
      g.progress = a / g.duration * 100;
    }

    function f(a) {
      if (g[a]) g[a](g);
    }

    function e() {
      g.remaining && !0 !== g.remaining && g.remaining--;
    }

    function k(a) {
      var k = g.duration,
          n = g.offset,
          w = n + g.delay,
          r = g.currentTime,
          x = g.reversed,
          q = d(a);

      if (g.children.length) {
        var u = g.children,
            v = u.length;
        if (q >= g.currentTime) for (var G = 0; G < v; G++) {
          u[G].seek(q);
        } else for (; v--;) {
          u[v].seek(q);
        }
      }

      if (q >= w || !k) g.began || (g.began = !0, f("begin")), f("run");
      if (q > n && q < k) b(q);else if (q <= n && 0 !== r && (b(0), x && e()), q >= k && r !== k || !k) b(k), x || e();
      f("update");
      a >= k && (g.remaining ? (t = h, "alternate" === g.direction && (g.reversed = !g.reversed)) : (g.pause(), g.completed || (g.completed = !0, f("complete"), "Promise" in window && (p(), m = c()))), l = 0);
    }

    a = void 0 === a ? {} : a;
    var h,
        t,
        l = 0,
        p = null,
        m = c(),
        g = fa(a);

    g.reset = function () {
      var a = g.direction,
          c = g.loop;
      g.currentTime = 0;
      g.progress = 0;
      g.paused = !0;
      g.began = !1;
      g.completed = !1;
      g.reversed = "reverse" === a;
      g.remaining = "alternate" === a && 1 === c ? 2 : c;
      b(0);

      for (a = g.children.length; a--;) {
        g.children[a].reset();
      }
    };

    g.tick = function (a) {
      h = a;
      t || (t = h);
      k((l + h - t) * q.speed);
    };

    g.seek = function (a) {
      k(d(a));
    };

    g.pause = function () {
      var a = v.indexOf(g);
      -1 < a && v.splice(a, 1);
      g.paused = !0;
    };

    g.play = function () {
      g.paused && (g.paused = !1, t = 0, l = d(g.currentTime), v.push(g), B || ia());
    };

    g.reverse = function () {
      g.reversed = !g.reversed;
      t = 0;
      l = d(g.currentTime);
    };

    g.restart = function () {
      g.pause();
      g.reset();
      g.play();
    };

    g.finished = m;
    g.reset();
    g.autoplay && g.play();
    return g;
  }

  var ga = {
    update: void 0,
    begin: void 0,
    run: void 0,
    complete: void 0,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    offset: 0
  },
      S = {
    duration: 1E3,
    delay: 0,
    easing: "easeOutElastic",
    elasticity: 500,
    round: 0
  },
      W = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
      H,
      h = {
    arr: function arr(a) {
      return Array.isArray(a);
    },
    obj: function obj(a) {
      return -1 < Object.prototype.toString.call(a).indexOf("Object");
    },
    pth: function pth(a) {
      return h.obj(a) && a.hasOwnProperty("totalLength");
    },
    svg: function svg(a) {
      return a instanceof SVGElement;
    },
    dom: function dom(a) {
      return a.nodeType || h.svg(a);
    },
    str: function str(a) {
      return "string" === typeof a;
    },
    fnc: function fnc(a) {
      return "function" === typeof a;
    },
    und: function und(a) {
      return "undefined" === typeof a;
    },
    hex: function hex(a) {
      return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
    },
    rgb: function rgb(a) {
      return /^rgb/.test(a);
    },
    hsl: function hsl(a) {
      return /^hsl/.test(a);
    },
    col: function col(a) {
      return h.hex(a) || h.rgb(a) || h.hsl(a);
    }
  },
      A = function () {
    function a(a, d, b) {
      return (((1 - 3 * b + 3 * d) * a + (3 * b - 6 * d)) * a + 3 * d) * a;
    }

    return function (c, d, b, f) {
      if (0 <= c && 1 >= c && 0 <= b && 1 >= b) {
        var e = new Float32Array(11);
        if (c !== d || b !== f) for (var k = 0; 11 > k; ++k) {
          e[k] = a(.1 * k, c, b);
        }
        return function (k) {
          if (c === d && b === f) return k;
          if (0 === k) return 0;
          if (1 === k) return 1;

          for (var h = 0, l = 1; 10 !== l && e[l] <= k; ++l) {
            h += .1;
          }

          --l;
          var l = h + (k - e[l]) / (e[l + 1] - e[l]) * .1,
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;

          if (.001 <= n) {
            for (h = 0; 4 > h; ++h) {
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;
              if (0 === n) break;
              var m = a(l, c, b) - k,
                  l = l - m / n;
            }

            k = l;
          } else if (0 === n) k = l;else {
            var l = h,
                h = h + .1,
                g = 0;

            do {
              m = l + (h - l) / 2, n = a(m, c, b) - k, 0 < n ? h = m : l = m;
            } while (1e-7 < Math.abs(n) && 10 > ++g);

            k = m;
          }

          return a(k, d, f);
        };
      }
    };
  }(),
      Q = function () {
    function a(a, b) {
      return 0 === a || 1 === a ? a : -Math.pow(2, 10 * (a - 1)) * Math.sin(2 * (a - 1 - b / (2 * Math.PI) * Math.asin(1)) * Math.PI / b);
    }

    var c = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
        d = {
      In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], a],
      Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function (b, c) {
        return 1 - a(1 - b, c);
      }],
      InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function (b, c) {
        return .5 > b ? a(2 * b, c) / 2 : 1 - a(-2 * b + 2, c) / 2;
      }]
    },
        b = {
      linear: A(.25, .25, .75, .75)
    },
        f = {},
        e;

    for (e in d) {
      f.type = e, d[f.type].forEach(function (a) {
        return function (d, f) {
          b["ease" + a.type + c[f]] = h.fnc(d) ? d : A.apply($jscomp$this, d);
        };
      }(f)), f = {
        type: f.type
      };
    }

    return b;
  }(),
      ha = {
    css: function css(a, c, d) {
      return a.style[c] = d;
    },
    attribute: function attribute(a, c, d) {
      return a.setAttribute(c, d);
    },
    object: function object(a, c, d) {
      return a[c] = d;
    },
    transform: function transform(a, c, d, b, f) {
      b[f] || (b[f] = []);
      b[f].push(c + "(" + d + ")");
    }
  },
      v = [],
      B = 0,
      ia = function () {
    function a() {
      B = requestAnimationFrame(c);
    }

    function c(c) {
      var b = v.length;

      if (b) {
        for (var d = 0; d < b;) {
          v[d] && v[d].tick(c), d++;
        }

        a();
      } else cancelAnimationFrame(B), B = 0;
    }

    return a;
  }();

  q.version = "2.2.0";
  q.speed = 1;
  q.running = v;

  q.remove = function (a) {
    a = P(a);

    for (var c = v.length; c--;) {
      for (var d = v[c], b = d.animations, f = b.length; f--;) {
        u(a, b[f].animatable.target) && (b.splice(f, 1), b.length || d.pause());
      }
    }
  };

  q.getValue = K;

  q.path = function (a, c) {
    var d = h.str(a) ? e(a)[0] : a,
        b = c || 100;
    return function (a) {
      return {
        el: d,
        property: a,
        totalLength: N(d) * (b / 100)
      };
    };
  };

  q.setDashoffset = function (a) {
    var c = N(a);
    a.setAttribute("stroke-dasharray", c);
    return c;
  };

  q.bezier = A;
  q.easings = Q;

  q.timeline = function (a) {
    var c = q(a);
    c.pause();
    c.duration = 0;

    c.add = function (d) {
      c.children.forEach(function (a) {
        a.began = !0;
        a.completed = !0;
      });
      m(d).forEach(function (b) {
        var d = z(b, D(S, a || {}));
        d.targets = d.targets || a.targets;
        b = c.duration;
        var e = d.offset;
        d.autoplay = !1;
        d.direction = c.direction;
        d.offset = h.und(e) ? b : L(e, b);
        c.began = !0;
        c.completed = !0;
        c.seek(d.offset);
        d = q(d);
        d.began = !0;
        d.completed = !0;
        d.duration > b && (c.duration = d.duration);
        c.children.push(d);
      });
      c.seek(0);
      c.reset();
      c.autoplay && c.restart();
      return c;
    };

    return c;
  };

  q.random = function (a, c) {
    return Math.floor(Math.random() * (c - a + 1)) + a;
  };

  return q;
});

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    accordion: true,
    onOpenStart: undefined,
    onOpenEnd: undefined,
    onCloseStart: undefined,
    onCloseEnd: undefined,
    inDuration: 300,
    outDuration: 300
  };
  /**
   * @class
   *
   */

  var Collapsible = function (_Component) {
    _inherits(Collapsible, _Component);
    /**
     * Construct Collapsible instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Collapsible(el, options) {
      _classCallCheck(this, Collapsible);

      var _this3 = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, Collapsible, el, options));

      _this3.el.M_Collapsible = _this3;
      /**
       * Options for the collapsible
       * @member Collapsible#options
       * @prop {Boolean} [accordion=false] - Type of the collapsible
       * @prop {Function} onOpenStart - Callback function called before collapsible is opened
       * @prop {Function} onOpenEnd - Callback function called after collapsible is opened
       * @prop {Function} onCloseStart - Callback function called before collapsible is closed
       * @prop {Function} onCloseEnd - Callback function called after collapsible is closed
       * @prop {Number} inDuration - Transition in duration in milliseconds.
       * @prop {Number} outDuration - Transition duration in milliseconds.
       */

      _this3.options = $.extend({}, Collapsible.defaults, options); // Setup tab indices

      _this3.$headers = _this3.$el.children('li').children('.six-storage-collapsible-header');

      _this3.$headers.attr('tabindex', 0);

      _this3._setupEventHandlers(); // Open first active


      var $activeBodies = _this3.$el.children('li.six-storage-active').children('.six-storage-collapsible-body');

      if (_this3.options.accordion) {
        // Handle Accordion
        $activeBodies.first().css('display', 'block');
      } else {
        // Handle Expandables
        $activeBodies.css('display', 'block');
      }

      return _this3;
    }

    _createClass(Collapsible, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.el.M_Collapsible = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this4 = this;

        this._handleCollapsibleClickBound = this._handleCollapsibleClick.bind(this);
        this._handleCollapsibleKeydownBound = this._handleCollapsibleKeydown.bind(this);
        this.el.addEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.addEventListener('keydown', _this4._handleCollapsibleKeydownBound);
        });
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this5 = this;

        this.el.removeEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.removeEventListener('keydown', _this5._handleCollapsibleKeydownBound);
        });
      }
      /**
       * Handle Collapsible Click
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleClick",
      value: function _handleCollapsibleClick(e) {
        var $header = $(e.target).closest('.six-storage-collapsible-header');

        if (e.target && $header.length) {
          var $collapsible = $header.closest('.six-storage-collapsible');

          if ($collapsible[0] === this.el) {
            var $collapsibleLi = $header.closest('li');
            var $collapsibleLis = $collapsible.children('li');
            var isActive = $collapsibleLi[0].classList.contains('six-storage-active');
            var index = $collapsibleLis.index($collapsibleLi);

            if (isActive) {
              this.close(index);
            } else {
              this.open(index);
            }
          }
        }
      }
      /**
       * Handle Collapsible Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleKeydown",
      value: function _handleCollapsibleKeydown(e) {
        if (e.keyCode === 13) {
          this._handleCollapsibleClickBound(e);
        }
      }
      /**
       * Animate in collapsible slide
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "_animateIn",
      value: function _animateIn(index) {
        var _this6 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);

        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.six-storage-collapsible-body');
          anim.remove($body[0]);
          $body.css({
            display: 'block',
            overflow: 'hidden',
            height: 0,
            paddingTop: '',
            paddingBottom: ''
          });
          var pTop = $body.css('padding-top');
          var pBottom = $body.css('padding-bottom');
          var finalHeight = $body[0].scrollHeight;
          $body.css({
            paddingTop: 0,
            paddingBottom: 0
          });
          anim({
            targets: $body[0],
            height: finalHeight,
            paddingTop: pTop,
            paddingBottom: pBottom,
            duration: this.options.inDuration,
            easing: 'easeInOutCubic',
            complete: function complete(anim) {
              $body.css({
                overflow: '',
                paddingTop: '',
                paddingBottom: '',
                height: ''
              }); // onOpenEnd callback

              if (typeof _this6.options.onOpenEnd === 'function') {
                _this6.options.onOpenEnd.call(_this6, $collapsibleLi[0]);
              }
            }
          });
        }
      }
      /**
       * Animate out collapsible slide
       * @param {Number} index - 0th index of slide to open
       */

    }, {
      key: "_animateOut",
      value: function _animateOut(index) {
        var _this7 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);

        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.six-storage-collapsible-body');
          anim.remove($body[0]);
          $body.css('overflow', 'hidden');
          anim({
            targets: $body[0],
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            duration: this.options.outDuration,
            easing: 'easeInOutCubic',
            complete: function complete() {
              $body.css({
                height: '',
                overflow: '',
                padding: '',
                display: ''
              }); // onCloseEnd callback

              if (typeof _this7.options.onCloseEnd === 'function') {
                _this7.options.onCloseEnd.call(_this7, $collapsibleLi[0]);
              }
            }
          });
        }
      }
      /**
       * Open Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "open",
      value: function open(index) {
        var _this8 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);

        if ($collapsibleLi.length && !$collapsibleLi[0].classList.contains('six-storage-active')) {
          // onOpenStart callback
          if (typeof this.options.onOpenStart === 'function') {
            this.options.onOpenStart.call(this, $collapsibleLi[0]);
          } // Handle accordion behavior


          if (this.options.accordion) {
            var $collapsibleLis = this.$el.children('li');
            var $activeLis = this.$el.children('li.six-storage-active');
            $activeLis.each(function (el) {
              var index = $collapsibleLis.index($(el));

              _this8.close(index);
            });
          } // Animate in


          $collapsibleLi[0].classList.add('six-storage-active');

          this._animateIn(index);
        }
      }
      /**
       * Close Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "close",
      value: function close(index) {
        var $collapsibleLi = this.$el.children('li').eq(index);

        if ($collapsibleLi.length && $collapsibleLi[0].classList.contains('six-storage-active')) {
          // onCloseStart callback
          if (typeof this.options.onCloseStart === 'function') {
            this.options.onCloseStart.call(this, $collapsibleLi[0]);
          } // Animate out


          $collapsibleLi[0].classList.remove('six-storage-active');

          this._animateOut(index);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Collapsible.__proto__ || Object.getPrototypeOf(Collapsible), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Collapsible;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Collapsible;
  }(Component);

  M.Collapsible = Collapsible;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Collapsible, 'collapsible', 'M_Collapsible');
  }
})(cash, M.anime);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    alignment: 'left',
    autoFocus: true,
    constrainWidth: true,
    container: null,
    coverTrigger: true,
    closeOnClick: true,
    hover: false,
    inDuration: 150,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onItemClick: null
  };
  /**
   * @class
   */

  var Dropdown = function (_Component2) {
    _inherits(Dropdown, _Component2);

    function Dropdown(el, options) {
      _classCallCheck(this, Dropdown);

      var _this9 = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, Dropdown, el, options));

      _this9.el.M_Dropdown = _this9;

      Dropdown._dropdowns.push(_this9);

      _this9.id = M.getIdFromTrigger(el);
      _this9.dropdownEl = document.getElementById(_this9.id);
      _this9.$dropdownEl = $(_this9.dropdownEl);
      /**
       * Options for the dropdown
       * @member Dropdown#options
       * @prop {String} [alignment='left'] - Edge which the dropdown is aligned to
       * @prop {Boolean} [autoFocus=true] - Automatically focus dropdown el for keyboard
       * @prop {Boolean} [constrainWidth=true] - Constrain width to width of the button
       * @prop {Element} container - Container element to attach dropdown to (optional)
       * @prop {Boolean} [coverTrigger=true] - Place dropdown over trigger
       * @prop {Boolean} [closeOnClick=true] - Close on click of dropdown item
       * @prop {Boolean} [hover=false] - Open dropdown on hover
       * @prop {Number} [inDuration=150] - Duration of open animation in ms
       * @prop {Number} [outDuration=250] - Duration of close animation in ms
       * @prop {Function} onOpenStart - Function called when dropdown starts opening
       * @prop {Function} onOpenEnd - Function called when dropdown finishes opening
       * @prop {Function} onCloseStart - Function called when dropdown starts closing
       * @prop {Function} onCloseEnd - Function called when dropdown finishes closing
       */

      _this9.options = $.extend({}, Dropdown.defaults, options);
      /**
       * Describes open/close state of dropdown
       * @type {Boolean}
       */

      _this9.isOpen = false;
      /**
       * Describes if dropdown content is scrollable
       * @type {Boolean}
       */

      _this9.isScrollable = false;
      /**
       * Describes if touch moving on dropdown content
       * @type {Boolean}
       */

      _this9.isTouchMoving = false;
      _this9.focusedIndex = -1;
      _this9.filterQuery = []; // Move dropdown-content after six-storage-dropdown-trigger

      if (!!_this9.options.container) {
        $(_this9.options.container).append(_this9.dropdownEl);
      } else {
        _this9.$el.after(_this9.dropdownEl);
      }

      _this9._makeDropdownFocusable();

      _this9._resetFilterQueryBound = _this9._resetFilterQuery.bind(_this9);
      _this9._handleDocumentClickBound = _this9._handleDocumentClick.bind(_this9);
      _this9._handleDocumentTouchmoveBound = _this9._handleDocumentTouchmove.bind(_this9);
      _this9._handleDropdownClickBound = _this9._handleDropdownClick.bind(_this9);
      _this9._handleDropdownKeydownBound = _this9._handleDropdownKeydown.bind(_this9);
      _this9._handleTriggerKeydownBound = _this9._handleTriggerKeydown.bind(_this9);

      _this9._setupEventHandlers();

      return _this9;
    }

    _createClass(Dropdown, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._resetDropdownStyles();

        this._removeEventHandlers();

        Dropdown._dropdowns.splice(Dropdown._dropdowns.indexOf(this), 1);

        this.el.M_Dropdown = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        // Trigger keydown handler
        this.el.addEventListener('keydown', this._handleTriggerKeydownBound); // Item click handler

        this.dropdownEl.addEventListener('click', this._handleDropdownClickBound); // Hover event handlers

        if (this.options.hover) {
          this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
          this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
          this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
          this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.addEventListener('mouseleave', this._handleMouseLeaveBound); // Click event handlers
        } else {
          this._handleClickBound = this._handleClick.bind(this);
          this.el.addEventListener('click', this._handleClickBound);
        }
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('keydown', this._handleTriggerKeydownBound);
        this.dropdownEl.removeEventListener('click', this._handleDropdownClickBound);

        if (this.options.hover) {
          this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
          this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        } else {
          this.el.removeEventListener('click', this._handleClickBound);
        }
      }
    }, {
      key: "_setupTemporaryEventHandlers",
      value: function _setupTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
        document.body.addEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.addEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_removeTemporaryEventHandlers",
      value: function _removeTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
        document.body.removeEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.removeEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_handleClick",
      value: function _handleClick(e) {
        e.preventDefault();
        this.open();
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.open();
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave(e) {
        var toEl = e.toElement || e.relatedTarget;
        var leaveToDropdownContent = !!$(toEl).closest('.six-storage-dropdown-content').length;
        var leaveToActiveDropdownTrigger = false;
        var $closestTrigger = $(toEl).closest('.six-storage-dropdown-trigger');

        if ($closestTrigger.length && !!$closestTrigger[0].M_Dropdown && $closestTrigger[0].M_Dropdown.isOpen) {
          leaveToActiveDropdownTrigger = true;
        } // Close hover dropdown if mouse did not leave to either active six-storage-dropdown-trigger or six-storage-dropdown-content


        if (!leaveToActiveDropdownTrigger && !leaveToDropdownContent) {
          this.close();
        }
      }
    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        var _this10 = this;

        var $target = $(e.target);

        if (this.options.closeOnClick && $target.closest('.six-storage-dropdown-content').length && !this.isTouchMoving) {
          // isTouchMoving to check if scrolling on mobile.
          setTimeout(function () {
            _this10.close();
          }, 0);
        } else if ($target.closest('.six-storage-dropdown-trigger').length || !$target.closest('.six-storage-dropdown-content').length) {
          setTimeout(function () {
            _this10.close();
          }, 0);
        }

        this.isTouchMoving = false;
      }
    }, {
      key: "_handleTriggerKeydown",
      value: function _handleTriggerKeydown(e) {
        // ARROW DOWN OR ENTER WHEN SELECT IS CLOSED - open Dropdown
        if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ENTER) && !this.isOpen) {
          e.preventDefault();
          this.open();
        }
      }
      /**
       * Handle Document Touchmove
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentTouchmove",
      value: function _handleDocumentTouchmove(e) {
        var $target = $(e.target);

        if ($target.closest('.six-storage-dropdown-content').length) {
          this.isTouchMoving = true;
        }
      }
      /**
       * Handle Dropdown Click
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownClick",
      value: function _handleDropdownClick(e) {
        // onItemClick callback
        if (typeof this.options.onItemClick === 'function') {
          var itemEl = $(e.target).closest('li')[0];
          this.options.onItemClick.call(this, itemEl);
        }
      }
      /**
       * Handle Dropdown Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownKeydown",
      value: function _handleDropdownKeydown(e) {
        if (e.which === M.keys.TAB) {
          e.preventDefault();
          this.close(); // Navigate down dropdown list
        } else if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) && this.isOpen) {
          e.preventDefault();
          var direction = e.which === M.keys.ARROW_DOWN ? 1 : -1;
          var newFocusedIndex = this.focusedIndex;
          var foundNewIndex = false;

          do {
            newFocusedIndex = newFocusedIndex + direction;

            if (!!this.dropdownEl.children[newFocusedIndex] && this.dropdownEl.children[newFocusedIndex].tabIndex !== -1) {
              foundNewIndex = true;
              break;
            }
          } while (newFocusedIndex < this.dropdownEl.children.length && newFocusedIndex >= 0);

          if (foundNewIndex) {
            this.focusedIndex = newFocusedIndex;

            this._focusFocusedItem();
          } // ENTER selects choice on focused item

        } else if (e.which === M.keys.ENTER && this.isOpen) {
          // Search for <a> and <button>
          var focusedElement = this.dropdownEl.children[this.focusedIndex];
          var $activatableElement = $(focusedElement).find('a, button').first(); // Click a or button tag if exists, otherwise click li tag

          if (!!$activatableElement.length) {
            $activatableElement[0].click();
          } else if (!!focusedElement) {
            focusedElement.click();
          } // Close dropdown on ESC

        } else if (e.which === M.keys.ESC && this.isOpen) {
          e.preventDefault();
          this.close();
        } // CASE WHEN USER TYPE LETTERS


        var letter = String.fromCharCode(e.which).toLowerCase(),
            nonLetters = [9, 13, 27, 38, 40];

        if (letter && nonLetters.indexOf(e.which) === -1) {
          this.filterQuery.push(letter);
          var string = this.filterQuery.join(''),
              newOptionEl = $(this.dropdownEl).find('li').filter(function (el) {
            return $(el).text().toLowerCase().indexOf(string) === 0;
          })[0];

          if (newOptionEl) {
            this.focusedIndex = $(newOptionEl).index();

            this._focusFocusedItem();
          }
        }

        this.filterTimeout = setTimeout(this._resetFilterQueryBound, 1000);
      }
      /**
       * Setup dropdown
       */

    }, {
      key: "_resetFilterQuery",
      value: function _resetFilterQuery() {
        this.filterQuery = [];
      }
    }, {
      key: "_resetDropdownStyles",
      value: function _resetDropdownStyles() {
        this.$dropdownEl.css({
          display: '',
          width: '',
          height: '',
          left: '',
          top: '',
          'transform-origin': '',
          transform: '',
          opacity: ''
        });
      }
    }, {
      key: "_makeDropdownFocusable",
      value: function _makeDropdownFocusable() {
        // Needed for arrow key navigation
        this.dropdownEl.tabIndex = 0; // Only set tabindex if it hasn't been set by user

        $(this.dropdownEl).children().each(function (el) {
          if (!el.getAttribute('tabindex')) {
            el.setAttribute('tabindex', 0);
          }
        });
      }
    }, {
      key: "_focusFocusedItem",
      value: function _focusFocusedItem() {
        if (this.focusedIndex >= 0 && this.focusedIndex < this.dropdownEl.children.length && this.options.autoFocus) {
          this.dropdownEl.children[this.focusedIndex].focus();
        }
      }
    }, {
      key: "_getDropdownPosition",
      value: function _getDropdownPosition() {
        var offsetParentBRect = this.el.offsetParent.getBoundingClientRect();
        var triggerBRect = this.el.getBoundingClientRect();
        var dropdownBRect = this.dropdownEl.getBoundingClientRect();
        var idealHeight = dropdownBRect.height;
        var idealWidth = dropdownBRect.width;
        var idealXPos = triggerBRect.left - dropdownBRect.left;
        var idealYPos = triggerBRect.top - dropdownBRect.top;
        var dropdownBounds = {
          left: idealXPos,
          top: idealYPos,
          height: idealHeight,
          width: idealWidth
        }; // Countainer here will be closest ancestor with overflow: hidden

        var closestOverflowParent = !!this.dropdownEl.offsetParent ? this.dropdownEl.offsetParent : this.dropdownEl.parentNode;
        var alignments = M.checkPossibleAlignments(this.el, closestOverflowParent, dropdownBounds, this.options.coverTrigger ? 0 : triggerBRect.height);
        var verticalAlignment = 'top';
        var horizontalAlignment = this.options.alignment;
        idealYPos += this.options.coverTrigger ? 0 : triggerBRect.height; // Reset isScrollable

        this.isScrollable = false;

        if (!alignments.top) {
          if (alignments.bottom) {
            verticalAlignment = 'bottom';
          } else {
            this.isScrollable = true; // Determine which side has most space and cutoff at correct height

            if (alignments.spaceOnTop > alignments.spaceOnBottom) {
              verticalAlignment = 'bottom';
              idealHeight += alignments.spaceOnTop;
              idealYPos -= alignments.spaceOnTop;
            } else {
              idealHeight += alignments.spaceOnBottom;
            }
          }
        } // If preferred horizontal alignment is possible


        if (!alignments[horizontalAlignment]) {
          var oppositeAlignment = horizontalAlignment === 'left' ? 'right' : 'left';

          if (alignments[oppositeAlignment]) {
            horizontalAlignment = oppositeAlignment;
          } else {
            // Determine which side has most space and cutoff at correct height
            if (alignments.spaceOnLeft > alignments.spaceOnRight) {
              horizontalAlignment = 'right';
              idealWidth += alignments.spaceOnLeft;
              idealXPos -= alignments.spaceOnLeft;
            } else {
              horizontalAlignment = 'left';
              idealWidth += alignments.spaceOnRight;
            }
          }
        }

        if (verticalAlignment === 'bottom') {
          idealYPos = idealYPos - dropdownBRect.height + (this.options.coverTrigger ? triggerBRect.height : 0);
        }

        if (horizontalAlignment === 'right') {
          idealXPos = idealXPos - dropdownBRect.width + triggerBRect.width;
        }

        return {
          x: idealXPos,
          y: idealYPos,
          verticalAlignment: verticalAlignment,
          horizontalAlignment: horizontalAlignment,
          height: idealHeight,
          width: idealWidth
        };
      }
      /**
       * Animate in dropdown
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this11 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: [0, 1],
            easing: 'easeOutQuad'
          },
          scaleX: [0.3, 1],
          scaleY: [0.3, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuint',
          complete: function complete(anim) {
            if (_this11.options.autoFocus) {
              _this11.dropdownEl.focus();
            } // onOpenEnd callback


            if (typeof _this11.options.onOpenEnd === 'function') {
              _this11.options.onOpenEnd.call(_this11, _this11.el);
            }
          }
        });
      }
      /**
       * Animate out dropdown
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this12 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: 0,
            easing: 'easeOutQuint'
          },
          scaleX: 0.3,
          scaleY: 0.3,
          duration: this.options.outDuration,
          easing: 'easeOutQuint',
          complete: function complete(anim) {
            _this12._resetDropdownStyles(); // onCloseEnd callback


            if (typeof _this12.options.onCloseEnd === 'function') {
              _this12.options.onCloseEnd.call(_this12, _this12.el);
            }
          }
        });
      }
      /**
       * Place dropdown
       */

    }, {
      key: "_placeDropdown",
      value: function _placeDropdown() {
        // Set width before calculating positionInfo
        var idealWidth = this.options.constrainWidth ? this.el.getBoundingClientRect().width : this.dropdownEl.getBoundingClientRect().width;
        this.dropdownEl.style.width = idealWidth + 'px';

        var positionInfo = this._getDropdownPosition();

        this.dropdownEl.style.left = positionInfo.x + 'px';
        this.dropdownEl.style.top = positionInfo.y + 'px';
        this.dropdownEl.style.height = positionInfo.height + 'px';
        this.dropdownEl.style.width = positionInfo.width + 'px';
        this.dropdownEl.style.transformOrigin = (positionInfo.horizontalAlignment === 'left' ? '0' : '100%') + " " + (positionInfo.verticalAlignment === 'top' ? '0' : '100%');
      }
      /**
       * Open Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true; // onOpenStart callback

        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        } // Reset styles


        this._resetDropdownStyles();

        this.dropdownEl.style.display = 'block';

        this._placeDropdown();

        this._animateIn();

        this._setupTemporaryEventHandlers();
      }
      /**
       * Close Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        this.focusedIndex = -1; // onCloseStart callback

        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this._animateOut();

        this._removeTemporaryEventHandlers();

        if (this.options.autoFocus) {
          this.el.focus();
        }
      }
      /**
       * Recalculate dimensions
       */

    }, {
      key: "recalculateDimensions",
      value: function recalculateDimensions() {
        if (this.isOpen) {
          this.$dropdownEl.css({
            width: '',
            height: '',
            left: '',
            top: '',
            'transform-origin': ''
          });

          this._placeDropdown();
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Dropdown.__proto__ || Object.getPrototypeOf(Dropdown), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Dropdown;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Dropdown;
  }(Component);
  /**
   * @static
   * @memberof Dropdown
   */


  Dropdown._dropdowns = [];
  M.Dropdown = Dropdown;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Dropdown, 'dropdown', 'M_Dropdown');
  }
})(cash, M.anime);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    opacity: 0.5,
    inDuration: 250,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true,
    dismissible: true,
    startingTop: '4%',
    endingTop: '10%'
  };
  /**
   * @class
   *
   */

  var Modal = function (_Component3) {
    _inherits(Modal, _Component3);
    /**
     * Construct Modal instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Modal(el, options) {
      _classCallCheck(this, Modal);

      var _this13 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, Modal, el, options));

      _this13.el.M_Modal = _this13;
      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [opacity=0.5] - Opacity of the modal overlay
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=250] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before modal is opened
       * @prop {Function} onOpenEnd - Callback function called after modal is opened
       * @prop {Function} onCloseStart - Callback function called before modal is closed
       * @prop {Function} onCloseEnd - Callback function called after modal is closed
       * @prop {Boolean} [dismissible=true] - Allow modal to be dismissed by keyboard or overlay click
       * @prop {String} [startingTop='4%'] - startingTop
       * @prop {String} [endingTop='10%'] - endingTop
       */

      _this13.options = $.extend({}, Modal.defaults, options);
      /**
       * Describes open/close state of modal
       * @type {Boolean}
       */

      _this13.isOpen = false;
      _this13.id = _this13.$el.attr('id');
      _this13._openingTrigger = undefined;
      _this13.$overlay = $('<div class="six-storage-modal-overlay"></div>');
      _this13.el.tabIndex = 0;
      _this13._nthModalOpened = 0;
      Modal._count++;

      _this13._setupEventHandlers();

      return _this13;
    }

    _createClass(Modal, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        Modal._count--;

        this._removeEventHandlers();

        this.el.removeAttribute('style');
        this.$overlay.remove();
        this.el.M_Modal = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleOverlayClickBound = this._handleOverlayClick.bind(this);
        this._handleModalCloseClickBound = this._handleModalCloseClick.bind(this);

        if (Modal._count === 1) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }

        this.$overlay[0].addEventListener('click', this._handleOverlayClickBound);
        this.el.addEventListener('click', this._handleModalCloseClickBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Modal._count === 0) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }

        this.$overlay[0].removeEventListener('click', this._handleOverlayClickBound);
        this.el.removeEventListener('click', this._handleModalCloseClickBound);
      }
      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.six-storage-modal-trigger');

        if ($trigger.length) {
          var modalId = M.getIdFromTrigger($trigger[0]);
          var modalInstance = document.getElementById(modalId).M_Modal;

          if (modalInstance) {
            modalInstance.open($trigger);
          }

          e.preventDefault();
        }
      }
      /**
       * Handle Overlay Click
       */

    }, {
      key: "_handleOverlayClick",
      value: function _handleOverlayClick() {
        if (this.options.dismissible) {
          this.close();
        }
      }
      /**
       * Handle Modal Close Click
       * @param {Event} e
       */

    }, {
      key: "_handleModalCloseClick",
      value: function _handleModalCloseClick(e) {
        var $closeTrigger = $(e.target).closest('.six-storage-modal-close');

        if ($closeTrigger.length) {
          this.close();
        }
      }
      /**
       * Handle Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleKeydown",
      value: function _handleKeydown(e) {
        // ESC key
        if (e.keyCode === 27 && this.options.dismissible) {
          this.close();
        }
      }
      /**
       * Handle Focus
       * @param {Event} e
       */

    }, {
      key: "_handleFocus",
      value: function _handleFocus(e) {
        // Only trap focus if this modal is the last model opened (prevents loops in nested modals).
        if (!this.el.contains(e.target) && this._nthModalOpened === Modal._modalsOpen) {
          this.el.focus();
        }
      }
      /**
       * Animate in modal
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this14 = this; // Set initial styles


        $.extend(this.el.style, {
          display: 'block',
          opacity: 0
        });
        $.extend(this.$overlay[0].style, {
          display: 'block',
          opacity: 0
        }); // Animate overlay

        anim({
          targets: this.$overlay[0],
          opacity: this.options.opacity,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        }); // Define modal animation options

        var enterAnimOptions = {
          targets: this.el,
          duration: this.options.inDuration,
          easing: 'easeOutCubic',
          // Handle modal onOpenEnd callback
          complete: function complete() {
            if (typeof _this14.options.onOpenEnd === 'function') {
              _this14.options.onOpenEnd.call(_this14, _this14.el, _this14._openingTrigger);
            }
          }
        }; // Bottom sheet animation

        if (this.el.classList.contains('six-storage-bottom-sheet')) {
          $.extend(enterAnimOptions, {
            bottom: 0,
            opacity: 1
          });
          anim(enterAnimOptions); // Normal modal animation
        } else {
          $.extend(enterAnimOptions, {
            top: [this.options.startingTop, this.options.endingTop],
            opacity: 1,
            scaleX: [0.8, 1],
            scaleY: [0.8, 1]
          });
          anim(enterAnimOptions);
        }
      }
      /**
       * Animate out modal
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this15 = this; // Animate overlay


        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuart'
        }); // Define modal animation options

        var exitAnimOptions = {
          targets: this.el,
          duration: this.options.outDuration,
          easing: 'easeOutCubic',
          // Handle modal ready callback
          complete: function complete() {
            _this15.el.style.display = 'none';

            _this15.$overlay.remove(); // Call onCloseEnd callback


            if (typeof _this15.options.onCloseEnd === 'function') {
              _this15.options.onCloseEnd.call(_this15, _this15.el);
            }
          }
        }; // Bottom sheet animation

        if (this.el.classList.contains('six-storage-bottom-sheet')) {
          $.extend(exitAnimOptions, {
            bottom: '-100%',
            opacity: 0
          });
          anim(exitAnimOptions); // Normal modal animation
        } else {
          $.extend(exitAnimOptions, {
            top: [this.options.endingTop, this.options.startingTop],
            opacity: 0,
            scaleX: 0.8,
            scaleY: 0.8
          });
          anim(exitAnimOptions);
        }
      }
      /**
       * Open Modal
       * @param {cash} [$trigger]
       */

    }, {
      key: "open",
      value: function open($trigger) {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        Modal._modalsOpen++;
        this._nthModalOpened = Modal._modalsOpen; // Set Z-Index based on number of currently open modals

        this.$overlay[0].style.zIndex = 1000 + Modal._modalsOpen * 2;
        this.el.style.zIndex = 1000 + Modal._modalsOpen * 2 + 1; // Set opening trigger, undefined indicates modal was opened by javascript

        this._openingTrigger = !!$trigger ? $trigger[0] : undefined; // onOpenStart callback

        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el, this._openingTrigger);
        }

        if (this.options.preventScrolling) {
          document.body.style.overflow = 'hidden';
        }

        this.el.classList.add('six-storage-open');
        this.el.insertAdjacentElement('afterend', this.$overlay[0]);

        if (this.options.dismissible) {
          this._handleKeydownBound = this._handleKeydown.bind(this);
          this._handleFocusBound = this._handleFocus.bind(this);
          document.addEventListener('keydown', this._handleKeydownBound);
          document.addEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        this._animateIn(); // Focus modal


        this.el.focus();
        return this;
      }
      /**
       * Close Modal
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        Modal._modalsOpen--;
        this._nthModalOpened = 0; // Call onCloseStart callback

        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this.el.classList.remove('six-storage-open'); // Enable body scrolling only if there are no more modals open.

        if (Modal._modalsOpen === 0) {
          document.body.style.overflow = '';
        }

        if (this.options.dismissible) {
          document.removeEventListener('keydown', this._handleKeydownBound);
          document.removeEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        this._animateOut();

        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Modal.__proto__ || Object.getPrototypeOf(Modal), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Modal;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Modal;
  }(Component);
  /**
   * @static
   * @memberof Modal
   */


  Modal._modalsOpen = 0;
  /**
   * @static
   * @memberof Modal
   */

  Modal._count = 0;
  M.Modal = Modal;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Modal, 'modal', 'M_Modal');
  }
})(cash, M.anime);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    inDuration: 275,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null
  };
  /**
   * @class
   *
   */

  var Materialbox = function (_Component4) {
    _inherits(Materialbox, _Component4);
    /**
     * Construct Materialbox instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Materialbox(el, options) {
      _classCallCheck(this, Materialbox);

      var _this16 = _possibleConstructorReturn(this, (Materialbox.__proto__ || Object.getPrototypeOf(Materialbox)).call(this, Materialbox, el, options));

      _this16.el.M_Materialbox = _this16;
      /**
       * Options for the modal
       * @member Materialbox#options
       * @prop {Number} [inDuration=275] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before materialbox is opened
       * @prop {Function} onOpenEnd - Callback function called after materialbox is opened
       * @prop {Function} onCloseStart - Callback function called before materialbox is closed
       * @prop {Function} onCloseEnd - Callback function called after materialbox is closed
       */

      _this16.options = $.extend({}, Materialbox.defaults, options);
      _this16.overlayActive = false;
      _this16.doneAnimating = true;
      _this16.placeholder = $('<div></div>').addClass('six-storage-material-placeholder');
      _this16.originalWidth = 0;
      _this16.originalHeight = 0;
      _this16.originInlineStyles = _this16.$el.attr('style');
      _this16.caption = _this16.el.getAttribute('data-caption') || ''; // Wrap

      _this16.$el.before(_this16.placeholder);

      _this16.placeholder.append(_this16.$el);

      _this16._setupEventHandlers();

      return _this16;
    }

    _createClass(Materialbox, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.el.M_Materialbox = undefined; // Unwrap image

        $(this.placeholder).after(this.el).remove();
        this.$el.removeAttr('style');
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMaterialboxClickBound = this._handleMaterialboxClick.bind(this);
        this.el.addEventListener('click', this._handleMaterialboxClickBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleMaterialboxClickBound);
      }
      /**
       * Handle Materialbox Click
       * @param {Event} e
       */

    }, {
      key: "_handleMaterialboxClick",
      value: function _handleMaterialboxClick(e) {
        // If already modal, return to original
        if (this.doneAnimating === false || this.overlayActive && this.doneAnimating) {
          this.close();
        } else {
          this.open();
        }
      }
      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        if (this.overlayActive) {
          this.close();
        }
      }
      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        if (this.overlayActive) {
          this.close();
        }
      }
      /**
       * Handle Window Resize
       * @param {Event} e
       */

    }, {
      key: "_handleWindowEscape",
      value: function _handleWindowEscape(e) {
        // ESC key
        if (e.keyCode === 27 && this.doneAnimating && this.overlayActive) {
          this.close();
        }
      }
      /**
       * Find ancestors with overflow: hidden; and make visible
       */

    }, {
      key: "_makeAncestorsOverflowVisible",
      value: function _makeAncestorsOverflowVisible() {
        this.ancestorsChanged = $();
        var ancestor = this.placeholder[0].parentNode;

        while (ancestor !== null && !$(ancestor).is(document)) {
          var curr = $(ancestor);

          if (curr.css('overflow') !== 'visible') {
            curr.css('overflow', 'visible');

            if (this.ancestorsChanged === undefined) {
              this.ancestorsChanged = curr;
            } else {
              this.ancestorsChanged = this.ancestorsChanged.add(curr);
            }
          }

          ancestor = ancestor.parentNode;
        }
      }
      /**
       * Animate image in
       */

    }, {
      key: "_animateImageIn",
      value: function _animateImageIn() {
        var _this17 = this;

        var animOptions = {
          targets: this.el,
          height: [this.originalHeight, this.newHeight],
          width: [this.originalWidth, this.newWidth],
          left: M.getDocumentScrollLeft() + this.windowWidth / 2 - this.placeholder.offset().left - this.newWidth / 2,
          top: M.getDocumentScrollTop() + this.windowHeight / 2 - this.placeholder.offset().top - this.newHeight / 2,
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function complete() {
            _this17.doneAnimating = true; // onOpenEnd callback

            if (typeof _this17.options.onOpenEnd === 'function') {
              _this17.options.onOpenEnd.call(_this17, _this17.el);
            }
          }
        }; // Override max-width or max-height if needed

        this.maxWidth = this.$el.css('max-width');
        this.maxHeight = this.$el.css('max-height');

        if (this.maxWidth !== 'none') {
          animOptions.maxWidth = this.newWidth;
        }

        if (this.maxHeight !== 'none') {
          animOptions.maxHeight = this.newHeight;
        }

        anim(animOptions);
      }
      /**
       * Animate image out
       */

    }, {
      key: "_animateImageOut",
      value: function _animateImageOut() {
        var _this18 = this;

        var animOptions = {
          targets: this.el,
          width: this.originalWidth,
          height: this.originalHeight,
          left: 0,
          top: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function complete() {
            _this18.placeholder.css({
              height: '',
              width: '',
              position: '',
              top: '',
              left: ''
            }); // Revert to width or height attribute


            if (_this18.attrWidth) {
              _this18.$el.attr('width', _this18.attrWidth);
            }

            if (_this18.attrHeight) {
              _this18.$el.attr('height', _this18.attrHeight);
            }

            _this18.$el.removeAttr('style');

            _this18.originInlineStyles && _this18.$el.attr('style', _this18.originInlineStyles); // Remove class

            _this18.$el.removeClass('six-storage-active');

            _this18.doneAnimating = true; // Remove overflow overrides on ancestors

            if (_this18.ancestorsChanged.length) {
              _this18.ancestorsChanged.css('overflow', '');
            } // onCloseEnd callback


            if (typeof _this18.options.onCloseEnd === 'function') {
              _this18.options.onCloseEnd.call(_this18, _this18.el);
            }
          }
        };
        anim(animOptions);
      }
      /**
       * Update open and close vars
       */

    }, {
      key: "_updateVars",
      value: function _updateVars() {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.caption = this.el.getAttribute('data-caption') || '';
      }
      /**
       * Open Materialbox
       */

    }, {
      key: "open",
      value: function open() {
        var _this19 = this;

        this._updateVars();

        this.originalWidth = this.el.getBoundingClientRect().width;
        this.originalHeight = this.el.getBoundingClientRect().height; // Set states

        this.doneAnimating = false;
        this.$el.addClass('six-storage-active');
        this.overlayActive = true; // onOpenStart callback

        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        } // Set positioning for placeholder


        this.placeholder.css({
          width: this.placeholder[0].getBoundingClientRect().width + 'px',
          height: this.placeholder[0].getBoundingClientRect().height + 'px',
          position: 'relative',
          top: 0,
          left: 0
        });

        this._makeAncestorsOverflowVisible(); // Set css on origin


        this.$el.css({
          position: 'absolute',
          'z-index': 1000,
          'will-change': 'left, top, width, height'
        }); // Change from width or height attribute to css

        this.attrWidth = this.$el.attr('width');
        this.attrHeight = this.$el.attr('height');

        if (this.attrWidth) {
          this.$el.css('width', this.attrWidth + 'px');
          this.$el.removeAttr('width');
        }

        if (this.attrHeight) {
          this.$el.css('width', this.attrHeight + 'px');
          this.$el.removeAttr('height');
        } // Add overlay


        this.$overlay = $('<div id="six-storage-materialbox-overlay"></div>').css({
          opacity: 0
        }).one('click', function () {
          if (_this19.doneAnimating) {
            _this19.close();
          }
        }); // Put before in origin image to preserve z-index layering.

        this.$el.before(this.$overlay); // Set dimensions if needed

        var overlayOffset = this.$overlay[0].getBoundingClientRect();
        this.$overlay.css({
          width: this.windowWidth + 'px',
          height: this.windowHeight + 'px',
          left: -1 * overlayOffset.left + 'px',
          top: -1 * overlayOffset.top + 'px'
        });
        anim.remove(this.el);
        anim.remove(this.$overlay[0]); // Animate Overlay

        anim({
          targets: this.$overlay[0],
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        }); // Add and animate caption if it exists

        if (this.caption !== '') {
          if (this.$photocaption) {
            anim.remove(this.$photoCaption[0]);
          }

          this.$photoCaption = $('<div class="six-storage-materialbox-caption"></div>');
          this.$photoCaption.text(this.caption);
          $('body').append(this.$photoCaption);
          this.$photoCaption.css({
            display: 'inline'
          });
          anim({
            targets: this.$photoCaption[0],
            opacity: 1,
            duration: this.options.inDuration,
            easing: 'easeOutQuad'
          });
        } // Resize Image


        var ratio = 0;
        var widthPercent = this.originalWidth / this.windowWidth;
        var heightPercent = this.originalHeight / this.windowHeight;
        this.newWidth = 0;
        this.newHeight = 0;

        if (widthPercent > heightPercent) {
          ratio = this.originalHeight / this.originalWidth;
          this.newWidth = this.windowWidth * 0.9;
          this.newHeight = this.windowWidth * 0.9 * ratio;
        } else {
          ratio = this.originalWidth / this.originalHeight;
          this.newWidth = this.windowHeight * 0.9 * ratio;
          this.newHeight = this.windowHeight * 0.9;
        }

        this._animateImageIn(); // Handle Exit triggers


        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        this._handleWindowEscapeBound = this._handleWindowEscape.bind(this);
        window.addEventListener('scroll', this._handleWindowScrollBound);
        window.addEventListener('resize', this._handleWindowResizeBound);
        window.addEventListener('keyup', this._handleWindowEscapeBound);
      }
      /**
       * Close Materialbox
       */

    }, {
      key: "close",
      value: function close() {
        var _this20 = this;

        this._updateVars();

        this.doneAnimating = false; // onCloseStart callback

        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        if (this.caption !== '') {
          anim.remove(this.$photoCaption[0]);
        } // disable exit handlers


        window.removeEventListener('scroll', this._handleWindowScrollBound);
        window.removeEventListener('resize', this._handleWindowResizeBound);
        window.removeEventListener('keyup', this._handleWindowEscapeBound);
        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function complete() {
            _this20.overlayActive = false;

            _this20.$overlay.remove();
          }
        });

        this._animateImageOut(); // Remove Caption + reset css settings on image


        if (this.caption !== '') {
          anim({
            targets: this.$photoCaption[0],
            opacity: 0,
            duration: this.options.outDuration,
            easing: 'easeOutQuad',
            complete: function complete() {
              _this20.$photoCaption.remove();
            }
          });
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Materialbox.__proto__ || Object.getPrototypeOf(Materialbox), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Materialbox;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Materialbox;
  }(Component);

  M.Materialbox = Materialbox;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Materialbox, 'materialbox', 'M_Materialbox');
  }
})(cash, M.anime);

;

(function ($) {
  'use strict';

  var _defaults = {
    responsiveThreshold: 0 // breakpoint for swipeable

  };

  var Parallax = function (_Component5) {
    _inherits(Parallax, _Component5);

    function Parallax(el, options) {
      _classCallCheck(this, Parallax);

      var _this21 = _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, Parallax, el, options));

      _this21.el.M_Parallax = _this21;
      /**
       * Options for the Parallax
       * @member Parallax#options
       * @prop {Number} responsiveThreshold
       */

      _this21.options = $.extend({}, Parallax.defaults, options);
      _this21._enabled = window.innerWidth > _this21.options.responsiveThreshold;
      _this21.$img = _this21.$el.find('img').first();

      _this21.$img.each(function () {
        var el = this;
        if (el.complete) $(el).trigger('load');
      });

      _this21._updateParallax();

      _this21._setupEventHandlers();

      _this21._setupStyles();

      Parallax._parallaxes.push(_this21);

      return _this21;
    }

    _createClass(Parallax, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        Parallax._parallaxes.splice(Parallax._parallaxes.indexOf(this), 1);

        this.$img[0].style.transform = '';

        this._removeEventHandlers();

        this.$el[0].M_Parallax = undefined;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleImageLoadBound = this._handleImageLoad.bind(this);
        this.$img[0].addEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          Parallax._handleScrollThrottled = M.throttle(Parallax._handleScroll, 5);
          window.addEventListener('scroll', Parallax._handleScrollThrottled);
          Parallax._handleWindowResizeThrottled = M.throttle(Parallax._handleWindowResize, 5);
          window.addEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.$img[0].removeEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          window.removeEventListener('scroll', Parallax._handleScrollThrottled);
          window.removeEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_setupStyles",
      value: function _setupStyles() {
        this.$img[0].style.opacity = 1;
      }
    }, {
      key: "_handleImageLoad",
      value: function _handleImageLoad() {
        this._updateParallax();
      }
    }, {
      key: "_updateParallax",
      value: function _updateParallax() {
        var containerHeight = this.$el.height() > 0 ? this.el.parentNode.offsetHeight : 500;
        var imgHeight = this.$img[0].offsetHeight;
        var parallaxDist = imgHeight - containerHeight;
        var bottom = this.$el.offset().top + containerHeight;
        var top = this.$el.offset().top;
        var scrollTop = M.getDocumentScrollTop();
        var windowHeight = window.innerHeight;
        var windowBottom = scrollTop + windowHeight;
        var percentScrolled = (windowBottom - top) / (containerHeight + windowHeight);
        var parallax = parallaxDist * percentScrolled;

        if (!this._enabled) {
          this.$img[0].style.transform = '';
        } else if (bottom > scrollTop && top < scrollTop + windowHeight) {
          this.$img[0].style.transform = "translate3D(-50%, " + parallax + "px, 0)";
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Parallax.__proto__ || Object.getPrototypeOf(Parallax), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Parallax;
      }
    }, {
      key: "_handleScroll",
      value: function _handleScroll() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];

          parallaxInstance._updateParallax.call(parallaxInstance);
        }
      }
    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];
          parallaxInstance._enabled = window.innerWidth > parallaxInstance.options.responsiveThreshold;
        }
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Parallax;
  }(Component);
  /**
   * @static
   * @memberof Parallax
   */


  Parallax._parallaxes = [];
  M.Parallax = Parallax;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Parallax, 'parallax', 'M_Parallax');
  }
})(cash);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    duration: 300,
    onShow: null,
    swipeable: false,
    responsiveThreshold: Infinity // breakpoint for swipeable

  };
  /**
   * @class
   *
   */

  var Tabs = function (_Component6) {
    _inherits(Tabs, _Component6);
    /**
     * Construct Tabs instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Tabs(el, options) {
      _classCallCheck(this, Tabs);

      var _this22 = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, Tabs, el, options));

      _this22.el.M_Tabs = _this22;
      /**
       * Options for the Tabs
       * @member Tabs#options
       * @prop {Number} duration
       * @prop {Function} onShow
       * @prop {Boolean} swipeable
       * @prop {Number} responsiveThreshold
       */

      _this22.options = $.extend({}, Tabs.defaults, options); // Setup

      _this22.$tabLinks = _this22.$el.children('li.six-storage-tab').children('a');
      _this22.index = 0;

      _this22._setupActiveTabLink(); // Setup tabs content


      if (_this22.options.swipeable) {
        _this22._setupSwipeableTabs();
      } else {
        _this22._setupNormalTabs();
      } // Setup tabs indicator after content to ensure accurate widths


      _this22._setTabsAndTabWidth();

      _this22._createIndicator();

      _this22._setupEventHandlers();

      return _this22;
    }

    _createClass(Tabs, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this._indicator.parentNode.removeChild(this._indicator);

        if (this.options.swipeable) {
          this._teardownSwipeableTabs();
        } else {
          this._teardownNormalTabs();
        }

        this.$el[0].M_Tabs = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        window.addEventListener('resize', this._handleWindowResizeBound);
        this._handleTabClickBound = this._handleTabClick.bind(this);
        this.el.addEventListener('click', this._handleTabClickBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        window.removeEventListener('resize', this._handleWindowResizeBound);
        this.el.removeEventListener('click', this._handleTabClickBound);
      }
      /**
       * Handle window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        this._setTabsAndTabWidth();

        if (this.tabWidth !== 0 && this.tabsWidth !== 0) {
          this._indicator.style.left = this._calcLeftPos(this.$activeTabLink) + 'px';
          this._indicator.style.right = this._calcRightPos(this.$activeTabLink) + 'px';
        }
      }
      /**
       * Handle tab click
       * @param {Event} e
       */

    }, {
      key: "_handleTabClick",
      value: function _handleTabClick(e) {
        var _this23 = this;

        var tab = $(e.target).closest('li.six-storage-tab');
        var tabLink = $(e.target).closest('a'); // Handle click on tab link only

        if (!tabLink.length || !tabLink.parent().hasClass('six-storage-tab')) {
          return;
        }

        if (tab.hasClass('six-storage-disabled')) {
          e.preventDefault();
          return;
        } // Act as regular link if target attribute is specified.


        if (!!tabLink.attr('target')) {
          return;
        } // Make the old tab inactive.


        this.$activeTabLink.removeClass('six-storage-active');
        var $oldContent = this.$content; // Update the variables with the new link and content

        this.$activeTabLink = tabLink;
        this.$content = $(M.escapeHash(tabLink[0].hash));
        this.$tabLinks = this.$el.children('li.six-storage-tab').children('a'); // Make the tab active.

        this.$activeTabLink.addClass('six-storage-active');
        var prevIndex = this.index;
        this.index = Math.max(this.$tabLinks.index(tabLink), 0); // Swap content

        if (this.options.swipeable) {
          if (this._tabsCarousel) {
            this._tabsCarousel.set(this.index, function () {
              if (typeof _this23.options.onShow === 'function') {
                _this23.options.onShow.call(_this23, _this23.$content[0]);
              }
            });
          }
        } else {
          if (this.$content.length) {
            this.$content[0].style.display = 'block';
            this.$content.addClass('six-storage-active');

            if (typeof this.options.onShow === 'function') {
              this.options.onShow.call(this, this.$content[0]);
            }

            if ($oldContent.length && !$oldContent.is(this.$content)) {
              $oldContent[0].style.display = 'none';
              $oldContent.removeClass('six-storage-active');
            }
          }
        } // Update widths after content is swapped (scrollbar bugfix)


        this._setTabsAndTabWidth(); // Update indicator


        this._animateIndicator(prevIndex); // Prevent the anchor's default click action


        e.preventDefault();
      }
      /**
       * Generate elements for tab indicator.
       */

    }, {
      key: "_createIndicator",
      value: function _createIndicator() {
        var _this24 = this;

        var indicator = document.createElement('li');
        indicator.classList.add('six-storage-indicator');
        this.el.appendChild(indicator);
        this._indicator = indicator;
        setTimeout(function () {
          _this24._indicator.style.left = _this24._calcLeftPos(_this24.$activeTabLink) + 'px';
          _this24._indicator.style.right = _this24._calcRightPos(_this24.$activeTabLink) + 'px';
        }, 0);
      }
      /**
       * Setup first active tab link.
       */

    }, {
      key: "_setupActiveTabLink",
      value: function _setupActiveTabLink() {
        // If the location.hash matches one of the links, use that as the active tab.
        this.$activeTabLink = $(this.$tabLinks.filter('[href="' + location.hash + '"]')); // If no match is found, use the first link or any with class 'active' as the initial active tab.

        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.six-storage-tab').children('a.six-storage-active').first();
        }

        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.six-storage-tab').children('a').first();
        }

        this.$tabLinks.removeClass('six-storage-active');
        this.$activeTabLink[0].classList.add('six-storage-active');
        this.index = Math.max(this.$tabLinks.index(this.$activeTabLink), 0);

        if (this.$activeTabLink.length) {
          this.$content = $(M.escapeHash(this.$activeTabLink[0].hash));
          this.$content.addClass('six-storage-active');
        }
      }
      /**
       * Setup swipeable tabs
       */

    }, {
      key: "_setupSwipeableTabs",
      value: function _setupSwipeableTabs() {
        var _this25 = this; // Change swipeable according to responsive threshold


        if (window.innerWidth > this.options.responsiveThreshold) {
          this.options.swipeable = false;
        }

        var $tabsContent = $();
        this.$tabLinks.each(function (link) {
          var $currContent = $(M.escapeHash(link.hash));
          $currContent.addClass('six-storage-carousel-item');
          $tabsContent = $tabsContent.add($currContent);
        });
        var $tabsWrapper = $('<div class="six-storage-tabs-content six-storage-carousel six-storage-carousel-slider"></div>');
        $tabsContent.first().before($tabsWrapper);
        $tabsWrapper.append($tabsContent);
        $tabsContent[0].style.display = ''; // Keep active tab index to set initial carousel slide

        var activeTabIndex = this.$activeTabLink.closest('.six-storage-tab').index();
        this._tabsCarousel = M.Carousel.init($tabsWrapper[0], {
          fullWidth: true,
          noWrap: true,
          onCycleTo: function onCycleTo(item) {
            var prevIndex = _this25.index;
            _this25.index = $(item).index();

            _this25.$activeTabLink.removeClass('six-storage-active');

            _this25.$activeTabLink = _this25.$tabLinks.eq(_this25.index);

            _this25.$activeTabLink.addClass('six-storage-active');

            _this25._animateIndicator(prevIndex);

            if (typeof _this25.options.onShow === 'function') {
              _this25.options.onShow.call(_this25, _this25.$content[0]);
            }
          }
        }); // Set initial carousel slide to active tab

        this._tabsCarousel.set(activeTabIndex);
      }
      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownSwipeableTabs",
      value: function _teardownSwipeableTabs() {
        var $tabsWrapper = this._tabsCarousel.$el;

        this._tabsCarousel.destroy(); // Unwrap


        $tabsWrapper.after($tabsWrapper.children());
        $tabsWrapper.remove();
      }
      /**
       * Setup normal tabs.
       */

    }, {
      key: "_setupNormalTabs",
      value: function _setupNormalTabs() {
        // Hide Tabs Content
        this.$tabLinks.not(this.$activeTabLink).each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));

            if ($currContent.length) {
              $currContent[0].style.display = 'none';
            }
          }
        });
      }
      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownNormalTabs",
      value: function _teardownNormalTabs() {
        // show Tabs Content
        this.$tabLinks.each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));

            if ($currContent.length) {
              $currContent[0].style.display = '';
            }
          }
        });
      }
      /**
       * set tabs and tab width
       */

    }, {
      key: "_setTabsAndTabWidth",
      value: function _setTabsAndTabWidth() {
        this.tabsWidth = this.$el.width();
        this.tabWidth = Math.max(this.tabsWidth, this.el.scrollWidth) / this.$tabLinks.length;
      }
      /**
       * Finds right attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcRightPos",
      value: function _calcRightPos(el) {
        return Math.ceil(this.tabsWidth - el.position().left - el[0].getBoundingClientRect().width);
      }
      /**
       * Finds left attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcLeftPos",
      value: function _calcLeftPos(el) {
        return Math.floor(el.position().left);
      }
    }, {
      key: "updateTabIndicator",
      value: function updateTabIndicator() {
        this._setTabsAndTabWidth();

        this._animateIndicator(this.index);
      }
      /**
       * Animates Indicator to active tab.
       * @param {Number} prevIndex
       */

    }, {
      key: "_animateIndicator",
      value: function _animateIndicator(prevIndex) {
        var leftDelay = 0,
            rightDelay = 0;

        if (this.index - prevIndex >= 0) {
          leftDelay = 90;
        } else {
          rightDelay = 90;
        } // Animate


        var animOptions = {
          targets: this._indicator,
          left: {
            value: this._calcLeftPos(this.$activeTabLink),
            delay: leftDelay
          },
          right: {
            value: this._calcRightPos(this.$activeTabLink),
            delay: rightDelay
          },
          duration: this.options.duration,
          easing: 'easeOutQuad'
        };
        anim.remove(this._indicator);
        anim(animOptions);
      }
      /**
       * Select tab.
       * @param {String} tabId
       */

    }, {
      key: "select",
      value: function select(tabId) {
        var tab = this.$tabLinks.filter('[href="#' + tabId + '"]');

        if (tab.length) {
          tab.trigger('click');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tabs.__proto__ || Object.getPrototypeOf(Tabs), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tabs;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Tabs;
  }(Component);

  M.Tabs = Tabs;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tabs, 'tabs', 'M_Tabs');
  }
})(cash, M.anime);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    exitDelay: 200,
    enterDelay: 0,
    html: null,
    margin: 5,
    inDuration: 250,
    outDuration: 200,
    position: 'bottom',
    transitionMovement: 10
  };
  /**
   * @class
   *
   */

  var Tooltip = function (_Component7) {
    _inherits(Tooltip, _Component7);
    /**
     * Construct Tooltip instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Tooltip(el, options) {
      _classCallCheck(this, Tooltip);

      var _this26 = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, Tooltip, el, options));

      _this26.el.M_Tooltip = _this26;
      _this26.options = $.extend({}, Tooltip.defaults, options);
      _this26.isOpen = false;
      _this26.isHovered = false;
      _this26.isFocused = false;

      _this26._appendTooltipEl();

      _this26._setupEventHandlers();

      return _this26;
    }

    _createClass(Tooltip, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        $(this.tooltipEl).remove();

        this._removeEventHandlers();

        this.el.M_Tooltip = undefined;
      }
    }, {
      key: "_appendTooltipEl",
      value: function _appendTooltipEl() {
        var tooltipEl = document.createElement('div');
        tooltipEl.classList.add('six-storage-material-tooltip');
        this.tooltipEl = tooltipEl;
        var tooltipContentEl = document.createElement('div');
        tooltipContentEl.classList.add('six-storage-tooltip-content');
        tooltipContentEl.innerHTML = this.options.html;
        tooltipEl.appendChild(tooltipContentEl);
        document.body.appendChild(tooltipEl);
      }
    }, {
      key: "_updateTooltipContent",
      value: function _updateTooltipContent() {
        this.tooltipEl.querySelector('.six-storage-tooltip-content').innerHTML = this.options.html;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
        this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
        this._handleFocusBound = this._handleFocus.bind(this);
        this._handleBlurBound = this._handleBlur.bind(this);
        this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.addEventListener('focus', this._handleFocusBound, true);
        this.el.addEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.removeEventListener('focus', this._handleFocusBound, true);
        this.el.removeEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "open",
      value: function open(isManual) {
        if (this.isOpen) {
          return;
        }

        isManual = isManual === undefined ? true : undefined; // Default value true

        this.isOpen = true; // Update tooltip content with HTML attribute options

        this.options = $.extend({}, this.options, this._getAttributeOptions());

        this._updateTooltipContent();

        this._setEnterDelayTimeout(isManual);
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isHovered = false;
        this.isFocused = false;
        this.isOpen = false;

        this._setExitDelayTimeout();
      }
      /**
       * Create timeout which delays when the tooltip closes
       */

    }, {
      key: "_setExitDelayTimeout",
      value: function _setExitDelayTimeout() {
        var _this27 = this;

        clearTimeout(this._exitDelayTimeout);
        this._exitDelayTimeout = setTimeout(function () {
          if (_this27.isHovered || _this27.isFocused) {
            return;
          }

          _this27._animateOut();
        }, this.options.exitDelay);
      }
      /**
       * Create timeout which delays when the toast closes
       */

    }, {
      key: "_setEnterDelayTimeout",
      value: function _setEnterDelayTimeout(isManual) {
        var _this28 = this;

        clearTimeout(this._enterDelayTimeout);
        this._enterDelayTimeout = setTimeout(function () {
          if (!_this28.isHovered && !_this28.isFocused && !isManual) {
            return;
          }

          _this28._animateIn();
        }, this.options.enterDelay);
      }
    }, {
      key: "_positionTooltip",
      value: function _positionTooltip() {
        var origin = this.el,
            tooltip = this.tooltipEl,
            originHeight = origin.offsetHeight,
            originWidth = origin.offsetWidth,
            tooltipHeight = tooltip.offsetHeight,
            tooltipWidth = tooltip.offsetWidth,
            newCoordinates = void 0,
            margin = this.options.margin,
            targetTop = void 0,
            targetLeft = void 0;
        this.xMovement = 0, this.yMovement = 0;
        targetTop = origin.getBoundingClientRect().top + M.getDocumentScrollTop();
        targetLeft = origin.getBoundingClientRect().left + M.getDocumentScrollLeft();

        if (this.options.position === 'top') {
          targetTop += -tooltipHeight - margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = -this.options.transitionMovement;
        } else if (this.options.position === 'right') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += originWidth + margin;
          this.xMovement = this.options.transitionMovement;
        } else if (this.options.position === 'left') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += -tooltipWidth - margin;
          this.xMovement = -this.options.transitionMovement;
        } else {
          targetTop += originHeight + margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = this.options.transitionMovement;
        }

        newCoordinates = this._repositionWithinScreen(targetLeft, targetTop, tooltipWidth, tooltipHeight);
        $(tooltip).css({
          top: newCoordinates.y + 'px',
          left: newCoordinates.x + 'px'
        });
      }
    }, {
      key: "_repositionWithinScreen",
      value: function _repositionWithinScreen(x, y, width, height) {
        var scrollLeft = M.getDocumentScrollLeft();
        var scrollTop = M.getDocumentScrollTop();
        var newX = x - scrollLeft;
        var newY = y - scrollTop;
        var bounding = {
          left: newX,
          top: newY,
          width: width,
          height: height
        };
        var offset = this.options.margin + this.options.transitionMovement;
        var edges = M.checkWithinContainer(document.body, bounding, offset);

        if (edges.left) {
          newX = offset;
        } else if (edges.right) {
          newX -= newX + width - window.innerWidth;
        }

        if (edges.top) {
          newY = offset;
        } else if (edges.bottom) {
          newY -= newY + height - window.innerHeight;
        }

        return {
          x: newX + scrollLeft,
          y: newY + scrollTop
        };
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._positionTooltip();

        this.tooltipEl.style.visibility = 'visible';
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 1,
          translateX: this.xMovement,
          translateY: this.yMovement,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 0,
          translateX: 0,
          translateY: 0,
          duration: this.options.outDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.isHovered = true;
        this.isFocused = false; // Allows close of tooltip when opened by focus.

        this.open(false);
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave() {
        this.isHovered = false;
        this.isFocused = false; // Allows close of tooltip when opened by focus.

        this.close();
      }
    }, {
      key: "_handleFocus",
      value: function _handleFocus() {
        if (M.tabPressed) {
          this.isFocused = true;
          this.open(false);
        }
      }
    }, {
      key: "_handleBlur",
      value: function _handleBlur() {
        this.isFocused = false;
        this.close();
      }
    }, {
      key: "_getAttributeOptions",
      value: function _getAttributeOptions() {
        var attributeOptions = {};
        var tooltipTextOption = this.el.getAttribute('data-tooltip');
        var positionOption = this.el.getAttribute('data-position');

        if (tooltipTextOption) {
          attributeOptions.html = tooltipTextOption;
        }

        if (positionOption) {
          attributeOptions.position = positionOption;
        }

        return attributeOptions;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tooltip.__proto__ || Object.getPrototypeOf(Tooltip), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tooltip;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Tooltip;
  }(Component);

  M.Tooltip = Tooltip;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tooltip, 'tooltip', 'M_Tooltip');
  }
})(cash, M.anime);

;
/*!
* Waves v0.6.4
* http://fian.my.id/Waves
*
* Copyright 2014 Alfiana E. Sibuea and other contributors
* Released under the MIT license
*/

;

(function (window) {
  'use strict';

  var Waves = Waves || {};
  var $$ = document.querySelectorAll.bind(document); // Find exact position of element

  function isWindow(obj) {
    return obj !== null && obj === obj.window;
  }

  function getWindow(elem) {
    return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
  }

  function offset(elem) {
    var docElem,
        win,
        box = {
      top: 0,
      left: 0
    },
        doc = elem && elem.ownerDocument;
    docElem = doc.documentElement;

    if (_typeof(elem.getBoundingClientRect) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
      box = elem.getBoundingClientRect();
    }

    win = getWindow(doc);
    return {
      top: box.top + win.pageYOffset - docElem.clientTop,
      left: box.left + win.pageXOffset - docElem.clientLeft
    };
  }

  function convertStyle(obj) {
    var style = '';

    for (var a in obj) {
      if (obj.hasOwnProperty(a)) {
        style += a + ':' + obj[a] + ';';
      }
    }

    return style;
  }

  var Effect = {
    // Effect delay
    duration: 750,
    show: function show(e, element) {
      // Disable right click
      if (e.button === 2) {
        return false;
      }

      var el = element || this; // Create ripple

      var ripple = document.createElement('div');
      ripple.className = 'six-storage-waves-ripple';
      el.appendChild(ripple); // Get click coordinate and element witdh

      var pos = offset(el);
      var relativeY = e.pageY - pos.top;
      var relativeX = e.pageX - pos.left;
      var scale = 'scale(' + el.clientWidth / 100 * 10 + ')'; // Support for touch devices

      if ('touches' in e) {
        relativeY = e.touches[0].pageY - pos.top;
        relativeX = e.touches[0].pageX - pos.left;
      } // Attach data to element


      ripple.setAttribute('data-hold', Date.now());
      ripple.setAttribute('data-scale', scale);
      ripple.setAttribute('data-x', relativeX);
      ripple.setAttribute('data-y', relativeY); // Set ripple position

      var rippleStyle = {
        'top': relativeY + 'px',
        'left': relativeX + 'px'
      };
      ripple.className = ripple.className + ' six-storage-waves-notransition';
      ripple.setAttribute('style', convertStyle(rippleStyle));
      ripple.className = ripple.className.replace('six-storage-waves-notransition', ''); // Scale the ripple

      rippleStyle['-webkit-transform'] = scale;
      rippleStyle['-moz-transform'] = scale;
      rippleStyle['-ms-transform'] = scale;
      rippleStyle['-o-transform'] = scale;
      rippleStyle.transform = scale;
      rippleStyle.opacity = '1';
      rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-moz-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-o-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-moz-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-o-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      ripple.setAttribute('style', convertStyle(rippleStyle));
    },
    hide: function hide(e) {
      TouchHandler.touchup(e);
      var el = this;
      var width = el.clientWidth * 1.4; // Get first ripple

      var ripple = null;
      var ripples = el.getElementsByClassName('six-storage-waves-ripple');

      if (ripples.length > 0) {
        ripple = ripples[ripples.length - 1];
      } else {
        return false;
      }

      var relativeX = ripple.getAttribute('data-x');
      var relativeY = ripple.getAttribute('data-y');
      var scale = ripple.getAttribute('data-scale'); // Get delay beetween mousedown and mouse leave

      var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
      var delay = 350 - diff;

      if (delay < 0) {
        delay = 0;
      } // Fade out ripple after delay


      setTimeout(function () {
        var style = {
          'top': relativeY + 'px',
          'left': relativeX + 'px',
          'opacity': '0',
          // Duration
          '-webkit-transition-duration': Effect.duration + 'ms',
          '-moz-transition-duration': Effect.duration + 'ms',
          '-o-transition-duration': Effect.duration + 'ms',
          'transition-duration': Effect.duration + 'ms',
          '-webkit-transform': scale,
          '-moz-transform': scale,
          '-ms-transform': scale,
          '-o-transform': scale,
          'transform': scale
        };
        ripple.setAttribute('style', convertStyle(style));
        setTimeout(function () {
          try {
            el.removeChild(ripple);
          } catch (e) {
            return false;
          }
        }, Effect.duration);
      }, delay);
    },
    // Little hack to make <input> can perform waves effect
    wrapInput: function wrapInput(elements) {
      for (var a = 0; a < elements.length; a++) {
        var el = elements[a];

        if (el.tagName.toLowerCase() === 'input') {
          var parent = el.parentNode; // If input already have parent just pass through

          if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('six-storage-waves-effect') !== -1) {
            continue;
          } // Put element class and style to the specified parent


          var wrapper = document.createElement('i');
          wrapper.className = el.className + ' six-storage-waves-input-wrapper';
          var elementStyle = el.getAttribute('style');

          if (!elementStyle) {
            elementStyle = '';
          }

          wrapper.setAttribute('style', elementStyle);
          el.className = 'six-storage-waves-button-input';
          el.removeAttribute('style'); // Put element as child

          parent.replaceChild(wrapper, el);
          wrapper.appendChild(el);
        }
      }
    }
  };
  /**
   * Disable mousedown event for 500ms during and after touch
   */

  var TouchHandler = {
    /* uses an integer rather than bool so there's no issues with
     * needing to clear timeouts if another touch event occurred
     * within the 500ms. Cannot mouseup between touchstart and
     * touchend, nor in the 500ms after touchend. */
    touches: 0,
    allowEvent: function allowEvent(e) {
      var allow = true;

      if (e.type === 'touchstart') {
        TouchHandler.touches += 1; //push
      } else if (e.type === 'touchend' || e.type === 'touchcancel') {
        setTimeout(function () {
          if (TouchHandler.touches > 0) {
            TouchHandler.touches -= 1; //pop after 500ms
          }
        }, 500);
      } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
        allow = false;
      }

      return allow;
    },
    touchup: function touchup(e) {
      TouchHandler.allowEvent(e);
    }
  };
  /**
   * Delegated click handler for .six-storage-waves-effect element.
   * returns null when .six-storage-waves-effect element not in "click tree"
   */

  function getWavesEffectElement(e) {
    if (TouchHandler.allowEvent(e) === false) {
      return null;
    }

    var element = null;
    var target = e.target || e.srcElement;

    while (target.parentNode !== null) {
      if (!(target instanceof SVGElement) && target.className.indexOf('six-storage-waves-effect') !== -1) {
        element = target;
        break;
      }

      target = target.parentNode;
    }

    return element;
  }
  /**
   * Bubble the click and show effect if .six-storage-waves-effect elem was found
   */


  function showEffect(e) {
    var element = getWavesEffectElement(e);

    if (element !== null) {
      Effect.show(e, element);

      if ('ontouchstart' in window) {
        element.addEventListener('touchend', Effect.hide, false);
        element.addEventListener('touchcancel', Effect.hide, false);
      }

      element.addEventListener('mouseup', Effect.hide, false);
      element.addEventListener('mouseleave', Effect.hide, false);
      element.addEventListener('dragend', Effect.hide, false);
    }
  }

  Waves.displayEffect = function (options) {
    options = options || {};

    if ('duration' in options) {
      Effect.duration = options.duration;
    } //Wrap input inside <i> tag


    Effect.wrapInput($$('.six-storage-waves-effect'));

    if ('ontouchstart' in window) {
      document.body.addEventListener('touchstart', showEffect, false);
    }

    document.body.addEventListener('mousedown', showEffect, false);
  };
  /**
   * Attach Waves to an input element (or any element which doesn't
   * bubble mouseup/mousedown events).
   *   Intended to be used with dynamically loaded forms/inputs, or
   * where the user doesn't want a delegated click handler.
   */


  Waves.attach = function (element) {
    //FUTURE: automatically add waves classes and allow users
    // to specify them with an options param? Eg. light/classic/button
    if (element.tagName.toLowerCase() === 'input') {
      Effect.wrapInput([element]);
      element = element.parentNode;
    }

    if ('ontouchstart' in window) {
      element.addEventListener('touchstart', showEffect, false);
    }

    element.addEventListener('mousedown', showEffect, false);
  };

  window.Waves = Waves;
  document.addEventListener('DOMContentLoaded', function () {
    Waves.displayEffect();
  }, false);
})(window);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    html: '',
    displayLength: 4000,
    inDuration: 300,
    outDuration: 375,
    classes: '',
    completeCallback: null,
    activationPercent: 0.8
  };

  var Toast = function () {
    function Toast(options) {
      _classCallCheck(this, Toast);
      /**
       * Options for the toast
       * @member Toast#options
       */


      this.options = $.extend({}, Toast.defaults, options);
      this.message = this.options.html;
      /**
       * Describes current pan state toast
       * @type {Boolean}
       */

      this.panning = false;
      /**
       * Time remaining until toast is removed
       */

      this.timeRemaining = this.options.displayLength;

      if (Toast._toasts.length === 0) {
        Toast._createContainer();
      } // Create new toast


      Toast._toasts.push(this);

      var toastElement = this._createToast();

      toastElement.M_Toast = this;
      this.el = toastElement;
      this.$el = $(toastElement);

      this._animateIn();

      this._setTimer();
    }

    _createClass(Toast, [{
      key: "_createToast",

      /**
       * Create toast and append it to toast container
       */
      value: function _createToast() {
        var toast = document.createElement('div');
        toast.classList.add('six-storage-toast'); // Add custom classes onto toast

        if (!!this.options.classes.length) {
          $(toast).addClass(this.options.classes);
        } // Set content


        if ((typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? this.message instanceof HTMLElement : this.message && _typeof(this.message) === 'object' && this.message !== null && this.message.nodeType === 1 && typeof this.message.nodeName === 'string') {
          toast.appendChild(this.message); // Check if it is jQuery object
        } else if (!!this.message.jquery) {
          $(toast).append(this.message[0]); // Insert as html;
        } else {
          toast.innerHTML = this.message;
        } // Append toasft


        Toast._container.appendChild(toast);

        return toast;
      }
      /**
       * Animate in toast
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        // Animate toast in
        anim({
          targets: this.el,
          top: 0,
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }
      /**
       * Create setInterval which automatically removes toast when timeRemaining >= 0
       * has been reached
       */

    }, {
      key: "_setTimer",
      value: function _setTimer() {
        var _this29 = this;

        if (this.timeRemaining !== Infinity) {
          this.counterInterval = setInterval(function () {
            // If toast is not being dragged, decrease its time remaining
            if (!_this29.panning) {
              _this29.timeRemaining -= 20;
            } // Animate toast out


            if (_this29.timeRemaining <= 0) {
              _this29.dismiss();
            }
          }, 20);
        }
      }
      /**
       * Dismiss toast with animation
       */

    }, {
      key: "dismiss",
      value: function dismiss() {
        var _this30 = this;

        window.clearInterval(this.counterInterval);
        var activationDistance = this.el.offsetWidth * this.options.activationPercent;

        if (this.wasSwiped) {
          this.el.style.transition = 'transform .05s, opacity .05s';
          this.el.style.transform = "translateX(" + activationDistance + "px)";
          this.el.style.opacity = 0;
        }

        anim({
          targets: this.el,
          opacity: 0,
          marginTop: -40,
          duration: this.options.outDuration,
          easing: 'easeOutExpo',
          complete: function complete() {
            // Call the optional callback
            if (typeof _this30.options.completeCallback === 'function') {
              _this30.options.completeCallback();
            } // Remove toast from DOM


            _this30.$el.remove();

            Toast._toasts.splice(Toast._toasts.indexOf(_this30), 1);

            if (Toast._toasts.length === 0) {
              Toast._removeContainer();
            }
          }
        });
      }
    }], [{
      key: "getInstance",

      /**
       * Get Instance
       */
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Toast;
      }
      /**
       * Append toast container and add event handlers
       */

    }, {
      key: "_createContainer",
      value: function _createContainer() {
        var container = document.createElement('div');
        container.setAttribute('id', 'six-storage-toast-container'); // Add event handler

        container.addEventListener('touchstart', Toast._onDragStart);
        container.addEventListener('touchmove', Toast._onDragMove);
        container.addEventListener('touchend', Toast._onDragEnd);
        container.addEventListener('mousedown', Toast._onDragStart);
        document.addEventListener('mousemove', Toast._onDragMove);
        document.addEventListener('mouseup', Toast._onDragEnd);
        document.body.appendChild(container);
        Toast._container = container;
      }
      /**
       * Remove toast container and event handlers
       */

    }, {
      key: "_removeContainer",
      value: function _removeContainer() {
        // Add event handler
        document.removeEventListener('mousemove', Toast._onDragMove);
        document.removeEventListener('mouseup', Toast._onDragEnd);
        $(Toast._container).remove();
        Toast._container = null;
      }
      /**
       * Begin drag handler
       * @param {Event} e
       */

    }, {
      key: "_onDragStart",
      value: function _onDragStart(e) {
        if (e.target && $(e.target).closest('.six-storage-toast').length) {
          var $toast = $(e.target).closest('.six-storage-toast');
          var toast = $toast[0].M_Toast;
          toast.panning = true;
          Toast._draggedToast = toast;
          toast.el.classList.add('six-storage-panning');
          toast.el.style.transition = '';
          toast.startingXPos = Toast._xPos(e);
          toast.time = Date.now();
          toast.xPos = Toast._xPos(e);
        }
      }
      /**
       * Drag move handler
       * @param {Event} e
       */

    }, {
      key: "_onDragMove",
      value: function _onDragMove(e) {
        if (!!Toast._draggedToast) {
          e.preventDefault();
          var toast = Toast._draggedToast;
          toast.deltaX = Math.abs(toast.xPos - Toast._xPos(e));
          toast.xPos = Toast._xPos(e);
          toast.velocityX = toast.deltaX / (Date.now() - toast.time);
          toast.time = Date.now();
          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          toast.el.style.transform = "translateX(" + totalDeltaX + "px)";
          toast.el.style.opacity = 1 - Math.abs(totalDeltaX / activationDistance);
        }
      }
      /**
       * End drag handler
       */

    }, {
      key: "_onDragEnd",
      value: function _onDragEnd() {
        if (!!Toast._draggedToast) {
          var toast = Toast._draggedToast;
          toast.panning = false;
          toast.el.classList.remove('six-storage-panning');
          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          var shouldBeDismissed = Math.abs(totalDeltaX) > activationDistance || toast.velocityX > 1; // Remove toast

          if (shouldBeDismissed) {
            toast.wasSwiped = true;
            toast.dismiss(); // Animate toast back to original position
          } else {
            toast.el.style.transition = 'transform .2s, opacity .2s';
            toast.el.style.transform = '';
            toast.el.style.opacity = '';
          }

          Toast._draggedToast = null;
        }
      }
      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       */

    }, {
      key: "_xPos",
      value: function _xPos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        } // mouse event


        return e.clientX;
      }
      /**
       * Remove all toasts
       */

    }, {
      key: "dismissAll",
      value: function dismissAll() {
        for (var toastIndex in Toast._toasts) {
          Toast._toasts[toastIndex].dismiss();
        }
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Toast;
  }();
  /**
   * @static
   * @memberof Toast
   * @type {Array.<Toast>}
   */


  Toast._toasts = [];
  /**
   * @static
   * @memberof Toast
   */

  Toast._container = null;
  /**
   * @static
   * @memberof Toast
   * @type {Toast}
   */

  Toast._draggedToast = null;
  M.Toast = Toast;

  M.toast = function (options) {
    return new Toast(options);
  };
})(cash, M.anime);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    edge: 'left',
    draggable: true,
    inDuration: 250,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true
  };
  /**
   * @class
   */

  var Sidenav = function (_Component8) {
    _inherits(Sidenav, _Component8);
    /**
     * Construct Sidenav instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Sidenav(el, options) {
      _classCallCheck(this, Sidenav);

      var _this31 = _possibleConstructorReturn(this, (Sidenav.__proto__ || Object.getPrototypeOf(Sidenav)).call(this, Sidenav, el, options));

      _this31.el.M_Sidenav = _this31;
      _this31.id = _this31.$el.attr('id');
      /**
       * Options for the Sidenav
       * @member Sidenav#options
       * @prop {String} [edge='left'] - Side of screen on which Sidenav appears
       * @prop {Boolean} [draggable=true] - Allow swipe gestures to open/close Sidenav
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Function called when sidenav starts entering
       * @prop {Function} onOpenEnd - Function called when sidenav finishes entering
       * @prop {Function} onCloseStart - Function called when sidenav starts exiting
       * @prop {Function} onCloseEnd - Function called when sidenav finishes exiting
       */

      _this31.options = $.extend({}, Sidenav.defaults, options);
      /**
       * Describes open/close state of Sidenav
       * @type {Boolean}
       */

      _this31.isOpen = false;
      /**
       * Describes if Sidenav is fixed
       * @type {Boolean}
       */

      _this31.isFixed = _this31.el.classList.contains('six-storage-sidenav-fixed');
      /**
       * Describes if Sidenav is being draggeed
       * @type {Boolean}
       */

      _this31.isDragged = false; // Window size variables for window resize checks

      _this31.lastWindowWidth = window.innerWidth;
      _this31.lastWindowHeight = window.innerHeight;

      _this31._createOverlay();

      _this31._createDragTarget();

      _this31._setupEventHandlers();

      _this31._setupClasses();

      _this31._setupFixed();

      Sidenav._sidenavs.push(_this31);

      return _this31;
    }

    _createClass(Sidenav, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this._enableBodyScrolling();

        this._overlay.parentNode.removeChild(this._overlay);

        this.dragTarget.parentNode.removeChild(this.dragTarget);
        this.el.M_Sidenav = undefined;
        this.el.style.transform = '';

        var index = Sidenav._sidenavs.indexOf(this);

        if (index >= 0) {
          Sidenav._sidenavs.splice(index, 1);
        }
      }
    }, {
      key: "_createOverlay",
      value: function _createOverlay() {
        var overlay = document.createElement('div');
        this._closeBound = this.close.bind(this);
        overlay.classList.add('six-storage-sidenav-overlay');
        overlay.addEventListener('click', this._closeBound);
        document.body.appendChild(overlay);
        this._overlay = overlay;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        if (Sidenav._sidenavs.length === 0) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }

        this._handleDragTargetDragBound = this._handleDragTargetDrag.bind(this);
        this._handleDragTargetReleaseBound = this._handleDragTargetRelease.bind(this);
        this._handleCloseDragBound = this._handleCloseDrag.bind(this);
        this._handleCloseReleaseBound = this._handleCloseRelease.bind(this);
        this._handleCloseTriggerClickBound = this._handleCloseTriggerClick.bind(this);
        this.dragTarget.addEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.addEventListener('touchend', this._handleDragTargetReleaseBound);

        this._overlay.addEventListener('touchmove', this._handleCloseDragBound);

        this._overlay.addEventListener('touchend', this._handleCloseReleaseBound);

        this.el.addEventListener('touchmove', this._handleCloseDragBound);
        this.el.addEventListener('touchend', this._handleCloseReleaseBound);
        this.el.addEventListener('click', this._handleCloseTriggerClickBound); // Add resize for side nav fixed

        if (this.isFixed) {
          this._handleWindowResizeBound = this._handleWindowResize.bind(this);
          window.addEventListener('resize', this._handleWindowResizeBound);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Sidenav._sidenavs.length === 1) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }

        this.dragTarget.removeEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.removeEventListener('touchend', this._handleDragTargetReleaseBound);

        this._overlay.removeEventListener('touchmove', this._handleCloseDragBound);

        this._overlay.removeEventListener('touchend', this._handleCloseReleaseBound);

        this.el.removeEventListener('touchmove', this._handleCloseDragBound);
        this.el.removeEventListener('touchend', this._handleCloseReleaseBound);
        this.el.removeEventListener('click', this._handleCloseTriggerClickBound); // Remove resize for side nav fixed

        if (this.isFixed) {
          window.removeEventListener('resize', this._handleWindowResizeBound);
        }
      }
      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.six-storage-sidenav-trigger');

        if (e.target && $trigger.length) {
          var sidenavId = M.getIdFromTrigger($trigger[0]);
          var sidenavInstance = document.getElementById(sidenavId).M_Sidenav;

          if (sidenavInstance) {
            sidenavInstance.open($trigger);
          }

          e.preventDefault();
        }
      }
      /**
       * Set variables needed at the beggining of drag
       * and stop any current transition.
       * @param {Event} e
       */

    }, {
      key: "_startDrag",
      value: function _startDrag(e) {
        var clientX = e.targetTouches[0].clientX;
        this.isDragged = true;
        this._startingXpos = clientX;
        this._xPos = this._startingXpos;
        this._time = Date.now();
        this._width = this.el.getBoundingClientRect().width;
        this._overlay.style.display = 'block';
        this._initialScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this._verticallyScrolling = false;
        anim.remove(this.el);
        anim.remove(this._overlay);
      }
      /**
       * Set variables needed at each drag move update tick
       * @param {Event} e
       */

    }, {
      key: "_dragMoveUpdate",
      value: function _dragMoveUpdate(e) {
        var clientX = e.targetTouches[0].clientX;
        var currentScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this.deltaX = Math.abs(this._xPos - clientX);
        this._xPos = clientX;
        this.velocityX = this.deltaX / (Date.now() - this._time);
        this._time = Date.now();

        if (this._initialScrollTop !== currentScrollTop) {
          this._verticallyScrolling = true;
        }
      }
      /**
       * Handles Dragging of Sidenav
       * @param {Event} e
       */

    }, {
      key: "_handleDragTargetDrag",
      value: function _handleDragTargetDrag(e) {
        // Check if draggable
        if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
          return;
        } // If not being dragged, set initial drag start variables


        if (!this.isDragged) {
          this._startDrag(e);
        } // Run touchmove updates


        this._dragMoveUpdate(e); // Calculate raw deltaX


        var totalDeltaX = this._xPos - this._startingXpos; // dragDirection is the attempted user drag direction

        var dragDirection = totalDeltaX > 0 ? 'right' : 'left'; // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction

        totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));

        if (this.options.edge === dragDirection) {
          totalDeltaX = 0;
        }
        /**
         * transformX is the drag displacement
         * transformPrefix is the initial transform placement
         * Invert values if Sidenav is right edge
         */


        var transformX = totalDeltaX;
        var transformPrefix = 'translateX(-100%)';

        if (this.options.edge === 'right') {
          transformPrefix = 'translateX(100%)';
          transformX = -transformX;
        } // Calculate open/close percentage of sidenav, with open = 1 and close = 0


        this.percentOpen = Math.min(1, totalDeltaX / this._width); // Set transform and opacity styles

        this.el.style.transform = transformPrefix + " translateX(" + transformX + "px)";
        this._overlay.style.opacity = this.percentOpen;
      }
      /**
       * Handle Drag Target Release
       */

    }, {
      key: "_handleDragTargetRelease",
      value: function _handleDragTargetRelease() {
        if (this.isDragged) {
          if (this.percentOpen > 0.2) {
            this.open();
          } else {
            this._animateOut();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }
      /**
       * Handle Close Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCloseDrag",
      value: function _handleCloseDrag(e) {
        if (this.isOpen) {
          // Check if draggable
          if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
            return;
          } // If not being dragged, set initial drag start variables


          if (!this.isDragged) {
            this._startDrag(e);
          } // Run touchmove updates


          this._dragMoveUpdate(e); // Calculate raw deltaX


          var totalDeltaX = this._xPos - this._startingXpos; // dragDirection is the attempted user drag direction

          var dragDirection = totalDeltaX > 0 ? 'right' : 'left'; // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction

          totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));

          if (this.options.edge !== dragDirection) {
            totalDeltaX = 0;
          }

          var transformX = -totalDeltaX;

          if (this.options.edge === 'right') {
            transformX = -transformX;
          } // Calculate open/close percentage of sidenav, with open = 1 and close = 0


          this.percentOpen = Math.min(1, 1 - totalDeltaX / this._width); // Set transform and opacity styles

          this.el.style.transform = "translateX(" + transformX + "px)";
          this._overlay.style.opacity = this.percentOpen;
        }
      }
      /**
       * Handle Close Release
       */

    }, {
      key: "_handleCloseRelease",
      value: function _handleCloseRelease() {
        if (this.isOpen && this.isDragged) {
          if (this.percentOpen > 0.8) {
            this._animateIn();
          } else {
            this.close();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }
      /**
       * Handles closing of Sidenav when element with class .six-storage-sidenav-close
       */

    }, {
      key: "_handleCloseTriggerClick",
      value: function _handleCloseTriggerClick(e) {
        var $closeTrigger = $(e.target).closest('.six-storage-sidenav-close');

        if ($closeTrigger.length && !this._isCurrentlyFixed()) {
          this.close();
        }
      }
      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        // Only handle horizontal resizes
        if (this.lastWindowWidth !== window.innerWidth) {
          if (window.innerWidth > 992) {
            this.open();
          } else {
            this.close();
          }
        }

        this.lastWindowWidth = window.innerWidth;
        this.lastWindowHeight = window.innerHeight;
      }
    }, {
      key: "_setupClasses",
      value: function _setupClasses() {
        if (this.options.edge === 'right') {
          this.el.classList.add('six-storage-right-aligned');
          this.dragTarget.classList.add('six-storage-right-aligned');
        }
      }
    }, {
      key: "_removeClasses",
      value: function _removeClasses() {
        this.el.classList.remove('six-storage-right-aligned');
        this.dragTarget.classList.remove('six-storage-right-aligned');
      }
    }, {
      key: "_setupFixed",
      value: function _setupFixed() {
        if (this._isCurrentlyFixed()) {
          this.open();
        }
      }
    }, {
      key: "_isCurrentlyFixed",
      value: function _isCurrentlyFixed() {
        return this.isFixed && window.innerWidth > 992;
      }
    }, {
      key: "_createDragTarget",
      value: function _createDragTarget() {
        var dragTarget = document.createElement('div');
        dragTarget.classList.add('six-storage-drag-target');
        document.body.appendChild(dragTarget);
        this.dragTarget = dragTarget;
      }
    }, {
      key: "_preventBodyScrolling",
      value: function _preventBodyScrolling() {
        var body = document.body;
        body.style.overflow = 'hidden';
      }
    }, {
      key: "_enableBodyScrolling",
      value: function _enableBodyScrolling() {
        var body = document.body;
        body.style.overflow = '';
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen === true) {
          return;
        }

        this.isOpen = true; // Run onOpenStart callback

        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        } // Handle fixed Sidenav


        if (this._isCurrentlyFixed()) {
          anim.remove(this.el);
          anim({
            targets: this.el,
            translateX: 0,
            duration: 0,
            easing: 'easeOutQuad'
          });

          this._enableBodyScrolling();

          this._overlay.style.display = 'none'; // Handle non-fixed Sidenav
        } else {
          if (this.options.preventScrolling) {
            this._preventBodyScrolling();
          }

          if (!this.isDragged || this.percentOpen != 1) {
            this._animateIn();
          }
        }
      }
    }, {
      key: "close",
      value: function close() {
        if (this.isOpen === false) {
          return;
        }

        this.isOpen = false; // Run onCloseStart callback

        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        } // Handle fixed Sidenav


        if (this._isCurrentlyFixed()) {
          var transformX = this.options.edge === 'left' ? '-105%' : '105%';
          this.el.style.transform = "translateX(" + transformX + ")"; // Handle non-fixed Sidenav
        } else {
          this._enableBodyScrolling();

          if (!this.isDragged || this.percentOpen != 0) {
            this._animateOut();
          } else {
            this._overlay.style.display = 'none';
          }
        }
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._animateSidenavIn();

        this._animateOverlayIn();
      }
    }, {
      key: "_animateSidenavIn",
      value: function _animateSidenavIn() {
        var _this32 = this;

        var slideOutPercent = this.options.edge === 'left' ? -1 : 1;

        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? slideOutPercent + this.percentOpen : slideOutPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", 0],
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function complete() {
            // Run onOpenEnd callback
            if (typeof _this32.options.onOpenEnd === 'function') {
              _this32.options.onOpenEnd.call(_this32, _this32.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayIn",
      value: function _animateOverlayIn() {
        var start = 0;

        if (this.isDragged) {
          start = this.percentOpen;
        } else {
          $(this._overlay).css({
            display: 'block'
          });
        }

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: [start, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        this._animateSidenavOut();

        this._animateOverlayOut();
      }
    }, {
      key: "_animateSidenavOut",
      value: function _animateSidenavOut() {
        var _this33 = this;

        var endPercent = this.options.edge === 'left' ? -1 : 1;
        var slideOutPercent = 0;

        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? endPercent + this.percentOpen : endPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", endPercent * 105 + "%"],
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function complete() {
            // Run onOpenEnd callback
            if (typeof _this33.options.onCloseEnd === 'function') {
              _this33.options.onCloseEnd.call(_this33, _this33.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayOut",
      value: function _animateOverlayOut() {
        var _this34 = this;

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function complete() {
            $(_this34._overlay).css('display', 'none');
          }
        });
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Sidenav.__proto__ || Object.getPrototypeOf(Sidenav), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Sidenav;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Sidenav;
  }(Component);
  /**
   * @static
   * @memberof Sidenav
   * @type {Array.<Sidenav>}
   */


  Sidenav._sidenavs = [];
  M.Sidenav = Sidenav;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Sidenav, 'sidenav', 'M_Sidenav');
  }
})(cash, M.anime);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    throttle: 100,
    scrollOffset: 200,
    // offset - 200 allows elements near bottom of page to scroll
    activeClass: 'six-storage-active',
    getActiveElement: function getActiveElement(id) {
      return 'a[href="#' + id + '"]';
    }
  };
  /**
   * @class
   *
   */

  var ScrollSpy = function (_Component9) {
    _inherits(ScrollSpy, _Component9);
    /**
     * Construct ScrollSpy instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function ScrollSpy(el, options) {
      _classCallCheck(this, ScrollSpy);

      var _this35 = _possibleConstructorReturn(this, (ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call(this, ScrollSpy, el, options));

      _this35.el.M_ScrollSpy = _this35;
      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [throttle=100] - Throttle of scroll handler
       * @prop {Number} [scrollOffset=200] - Offset for centering element when scrolled to
       * @prop {String} [activeClass='active'] - Class applied to active elements
       * @prop {Function} [getActiveElement] - Used to find active element
       */

      _this35.options = $.extend({}, ScrollSpy.defaults, options); // setup

      ScrollSpy._elements.push(_this35);

      ScrollSpy._count++;
      ScrollSpy._increment++;
      _this35.tickId = -1;
      _this35.id = ScrollSpy._increment;

      _this35._setupEventHandlers();

      _this35._handleWindowScroll();

      return _this35;
    }

    _createClass(ScrollSpy, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        ScrollSpy._elements.splice(ScrollSpy._elements.indexOf(this), 1);

        ScrollSpy._elementsInView.splice(ScrollSpy._elementsInView.indexOf(this), 1);

        ScrollSpy._visibleElements.splice(ScrollSpy._visibleElements.indexOf(this.$el), 1);

        ScrollSpy._count--;

        this._removeEventHandlers();

        $(this.options.getActiveElement(this.$el.attr('id'))).removeClass(this.options.activeClass);
        this.el.M_ScrollSpy = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var throttledResize = M.throttle(this._handleWindowScroll, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);
        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);

        if (ScrollSpy._count === 1) {
          window.addEventListener('scroll', this._handleWindowScrollBound);
          window.addEventListener('resize', this._handleThrottledResizeBound);
          document.body.addEventListener('click', this._handleTriggerClick);
        }
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (ScrollSpy._count === 0) {
          window.removeEventListener('scroll', this._handleWindowScrollBound);
          window.removeEventListener('resize', this._handleThrottledResizeBound);
          document.body.removeEventListener('click', this._handleTriggerClick);
        }
      }
      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target);

        for (var i = ScrollSpy._elements.length - 1; i >= 0; i--) {
          var scrollspy = ScrollSpy._elements[i];

          if ($trigger.is('a[href="#' + scrollspy.$el.attr('id') + '"]')) {
            e.preventDefault();
            var offset = scrollspy.$el.offset().top + 1;
            anim({
              targets: [document.documentElement, document.body],
              scrollTop: offset - scrollspy.options.scrollOffset,
              duration: 400,
              easing: 'easeOutCubic'
            });
            break;
          }
        }
      }
      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        // unique tick id
        ScrollSpy._ticks++; // viewport rectangle

        var top = M.getDocumentScrollTop(),
            left = M.getDocumentScrollLeft(),
            right = left + window.innerWidth,
            bottom = top + window.innerHeight; // determine which elements are in view

        var intersections = ScrollSpy._findElements(top, right, bottom, left);

        for (var i = 0; i < intersections.length; i++) {
          var scrollspy = intersections[i];
          var lastTick = scrollspy.tickId;

          if (lastTick < 0) {
            // entered into view
            scrollspy._enter();
          } // update tick id


          scrollspy.tickId = ScrollSpy._ticks;
        }

        for (var _i = 0; _i < ScrollSpy._elementsInView.length; _i++) {
          var _scrollspy = ScrollSpy._elementsInView[_i];
          var _lastTick = _scrollspy.tickId;

          if (_lastTick >= 0 && _lastTick !== ScrollSpy._ticks) {
            // exited from view
            _scrollspy._exit();

            _scrollspy.tickId = -1;
          }
        } // remember elements in view for next tick


        ScrollSpy._elementsInView = intersections;
      }
      /**
       * Find elements that are within the boundary
       * @param {number} top
       * @param {number} right
       * @param {number} bottom
       * @param {number} left
       * @return {Array.<ScrollSpy>}   A collection of elements
       */

    }, {
      key: "_enter",
      value: function _enter() {
        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);

          if (ScrollSpy._visibleElements[0][0].M_ScrollSpy && this.id < ScrollSpy._visibleElements[0][0].M_ScrollSpy.id) {
            ScrollSpy._visibleElements.unshift(this.$el);
          } else {
            ScrollSpy._visibleElements.push(this.$el);
          }
        } else {
          ScrollSpy._visibleElements.push(this.$el);
        }

        $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
      }
    }, {
      key: "_exit",
      value: function _exit() {
        var _this36 = this;

        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
          ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (el) {
            return el.attr('id') != _this36.$el.attr('id');
          });

          if (ScrollSpy._visibleElements[0]) {
            // Check if empty
            $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
          }
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_ScrollSpy;
      }
    }, {
      key: "_findElements",
      value: function _findElements(top, right, bottom, left) {
        var hits = [];

        for (var i = 0; i < ScrollSpy._elements.length; i++) {
          var scrollspy = ScrollSpy._elements[i];
          var currTop = top + scrollspy.options.scrollOffset || 200;

          if (scrollspy.$el.height() > 0) {
            var elTop = scrollspy.$el.offset().top,
                elLeft = scrollspy.$el.offset().left,
                elRight = elLeft + scrollspy.$el.width(),
                elBottom = elTop + scrollspy.$el.height();
            var isIntersect = !(elLeft > right || elRight < left || elTop > bottom || elBottom < currTop);

            if (isIntersect) {
              hits.push(scrollspy);
            }
          }
        }

        return hits;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return ScrollSpy;
  }(Component);
  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */


  ScrollSpy._elements = [];
  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */

  ScrollSpy._elementsInView = [];
  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<cash>}
   */

  ScrollSpy._visibleElements = [];
  /**
   * @static
   * @memberof ScrollSpy
   */

  ScrollSpy._count = 0;
  /**
   * @static
   * @memberof ScrollSpy
   */

  ScrollSpy._increment = 0;
  /**
   * @static
   * @memberof ScrollSpy
   */

  ScrollSpy._ticks = 0;
  M.ScrollSpy = ScrollSpy;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(ScrollSpy, 'scrollSpy', 'M_ScrollSpy');
  }
})(cash, M.anime);

;

(function ($) {
  'use strict';

  var _defaults = {
    data: {},
    // Autocomplete data set
    limit: Infinity,
    // Limit of results the autocomplete shows
    onAutocomplete: null,
    // Callback for when autocompleted
    minLength: 1,
    // Min characters before autocomplete starts
    sortFunction: function sortFunction(a, b, inputString) {
      // Sort function for sorting autocomplete results
      return a.indexOf(inputString) - b.indexOf(inputString);
    }
  };
  /**
   * @class
   *
   */

  var Autocomplete = function (_Component10) {
    _inherits(Autocomplete, _Component10);
    /**
     * Construct Autocomplete instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Autocomplete(el, options) {
      _classCallCheck(this, Autocomplete);

      var _this37 = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, Autocomplete, el, options));

      _this37.el.M_Autocomplete = _this37;
      /**
       * Options for the autocomplete
       * @member Autocomplete#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {number} shift
       * @prop {number} padding
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */

      _this37.options = $.extend({}, Autocomplete.defaults, options); // Setup

      _this37.isOpen = false;
      _this37.count = 0;
      _this37.activeIndex = -1;
      _this37.oldVal;
      _this37.$inputField = _this37.$el.closest('.six-storage-input-field');
      _this37.$active = $();
      _this37._mousedown = false;

      _this37._setupDropdown();

      _this37._setupEventHandlers();

      return _this37;
    }

    _createClass(Autocomplete, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this._removeDropdown();

        this.el.M_Autocomplete = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputBlurBound = this._handleInputBlur.bind(this);
        this._handleInputKeyupAndFocusBound = this._handleInputKeyupAndFocus.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleContainerMousedownAndTouchstartBound = this._handleContainerMousedownAndTouchstart.bind(this);
        this._handleContainerMouseupAndTouchendBound = this._handleContainerMouseupAndTouchend.bind(this);
        this.el.addEventListener('blur', this._handleInputBlurBound);
        this.el.addEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('click', this._handleInputClickBound);
        this.container.addEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.addEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.addEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.addEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('blur', this._handleInputBlurBound);
        this.el.removeEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.container.removeEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.removeEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.removeEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.removeEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }
      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this38 = this;

        this.container = document.createElement('ul');
        this.container.id = "six-storage-autocomplete-options-" + M.guid();
        $(this.container).addClass('six-storage-autocomplete-content six-storage-dropdown-content');
        this.$inputField.append(this.container);
        this.el.setAttribute('data-target', this.container.id);
        this.dropdown = M.Dropdown.init(this.el, {
          autoFocus: false,
          closeOnClick: false,
          coverTrigger: false,
          onItemClick: function onItemClick(itemEl) {
            _this38.selectOption($(itemEl));
          }
        }); // Sketchy removal of dropdown click handler

        this.el.removeEventListener('click', this.dropdown._handleClickBound);
      }
      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        this.container.parentNode.removeChild(this.container);
      }
      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        if (!this._mousedown) {
          this.close();

          this._resetAutocomplete();
        }
      }
      /**
       * Handle Input Keyup and Focus
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeyupAndFocus",
      value: function _handleInputKeyupAndFocus(e) {
        if (e.type === 'keyup') {
          Autocomplete._keydown = false;
        }

        this.count = 0;
        var val = this.el.value.toLowerCase(); // Don't capture enter or arrow key usage.

        if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
          return;
        } // Check if the input isn't empty
        // Check if focus triggered by tab


        if (this.oldVal !== val && (M.tabPressed || e.type !== 'focus')) {
          this.open();
        } // Update oldVal


        this.oldVal = val;
      }
      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Autocomplete._keydown = true; // Arrow keys and enter key usage

        var keyCode = e.keyCode,
            liElement = void 0,
            numItems = $(this.container).children('li').length; // select element on Enter

        if (keyCode === M.keys.ENTER && this.activeIndex >= 0) {
          liElement = $(this.container).children('li').eq(this.activeIndex);

          if (liElement.length) {
            this.selectOption(liElement);
            e.preventDefault();
          }

          return;
        } // Capture up and down key


        if (keyCode === M.keys.ARROW_UP || keyCode === M.keys.ARROW_DOWN) {
          e.preventDefault();

          if (keyCode === M.keys.ARROW_UP && this.activeIndex > 0) {
            this.activeIndex--;
          }

          if (keyCode === M.keys.ARROW_DOWN && this.activeIndex < numItems - 1) {
            this.activeIndex++;
          }

          this.$active.removeClass('six-storage-active');

          if (this.activeIndex >= 0) {
            this.$active = $(this.container).children('li').eq(this.activeIndex);
            this.$active.addClass('six-storage-active');
          }
        }
      }
      /**
       * Handle Input Click
       * @param {Event} e
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick(e) {
        this.open();
      }
      /**
       * Handle Container Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMousedownAndTouchstart",
      value: function _handleContainerMousedownAndTouchstart(e) {
        this._mousedown = true;
      }
      /**
       * Handle Container Mouseup and Touchend
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMouseupAndTouchend",
      value: function _handleContainerMouseupAndTouchend(e) {
        this._mousedown = false;
      }
      /**
       * Highlight partial match
       */

    }, {
      key: "_highlight",
      value: function _highlight(string, $el) {
        var img = $el.find('img');
        var matchStart = $el.text().toLowerCase().indexOf('' + string.toLowerCase() + ''),
            matchEnd = matchStart + string.length - 1,
            beforeMatch = $el.text().slice(0, matchStart),
            matchText = $el.text().slice(matchStart, matchEnd + 1),
            afterMatch = $el.text().slice(matchEnd + 1);
        $el.html("<span>" + beforeMatch + "<span class='six-storage-highlight'>" + matchText + "</span>" + afterMatch + "</span>");

        if (img.length) {
          $el.prepend(img);
        }
      }
      /**
       * Reset current element position
       */

    }, {
      key: "_resetCurrentElement",
      value: function _resetCurrentElement() {
        this.activeIndex = -1;
        this.$active.removeClass('six-storage-active');
      }
      /**
       * Reset autocomplete elements
       */

    }, {
      key: "_resetAutocomplete",
      value: function _resetAutocomplete() {
        $(this.container).empty();

        this._resetCurrentElement();

        this.oldVal = null;
        this.isOpen = false;
        this._mousedown = false;
      }
      /**
       * Select autocomplete option
       * @param {Element} el  Autocomplete option list item element
       */

    }, {
      key: "selectOption",
      value: function selectOption(el) {
        var text = el.text().trim();
        this.el.value = text;
        this.$el.trigger('change');

        this._resetAutocomplete();

        this.close(); // Handle onAutocomplete callback.

        if (typeof this.options.onAutocomplete === 'function') {
          this.options.onAutocomplete.call(this, text);
        }
      }
      /**
       * Render dropdown content
       * @param {Object} data  data set
       * @param {String} val  current input value
       */

    }, {
      key: "_renderDropdown",
      value: function _renderDropdown(data, val) {
        var _this39 = this;

        this._resetAutocomplete();

        var matchingData = []; // Gather all matching data

        for (var key in data) {
          if (data.hasOwnProperty(key) && key.toLowerCase().indexOf(val) !== -1) {
            // Break if past limit
            if (this.count >= this.options.limit) {
              break;
            }

            var entry = {
              data: data[key],
              key: key
            };
            matchingData.push(entry);
            this.count++;
          }
        } // Sort


        if (this.options.sortFunction) {
          var sortFunctionBound = function sortFunctionBound(a, b) {
            return _this39.options.sortFunction(a.key.toLowerCase(), b.key.toLowerCase(), val.toLowerCase());
          };

          matchingData.sort(sortFunctionBound);
        } // Render


        for (var i = 0; i < matchingData.length; i++) {
          var _entry = matchingData[i];
          var $autocompleteOption = $('<li></li>');

          if (!!_entry.data) {
            $autocompleteOption.append("<img src=\"" + _entry.data + "\" class=\"six-storage-right six-storage-circle\"><span>" + _entry.key + "</span>");
          } else {
            $autocompleteOption.append('<span>' + _entry.key + '</span>');
          }

          $(this.container).append($autocompleteOption);

          this._highlight(val, $autocompleteOption);
        }
      }
      /**
       * Open Autocomplete Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        var val = this.el.value.toLowerCase();

        this._resetAutocomplete();

        if (val.length >= this.options.minLength) {
          this.isOpen = true;

          this._renderDropdown(this.options.data, val);
        } // Open dropdown


        if (!this.dropdown.isOpen) {
          this.dropdown.open();
        } else {
          // Recalculate dropdown when its already open
          this.dropdown.recalculateDimensions();
        }
      }
      /**
       * Close Autocomplete Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        this.dropdown.close();
      }
      /**
       * Update Data
       * @param {Object} data
       */

    }, {
      key: "updateData",
      value: function updateData(data) {
        var val = this.el.value.toLowerCase();
        this.options.data = data;

        if (this.isOpen) {
          this._renderDropdown(data, val);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Autocomplete;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Autocomplete;
  }(Component);
  /**
   * @static
   * @memberof Autocomplete
   */


  Autocomplete._keydown = false;
  M.Autocomplete = Autocomplete;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Autocomplete, 'autocomplete', 'M_Autocomplete');
  }
})(cash);

;

(function ($) {
  // Function to update labels of text fields
  M.updateTextFields = function () {
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
    $(input_selector).each(function (element, index) {
      var $this = $(this);

      if (element.value.length > 0 || $(element).is(':focus') || element.autofocus || $this.attr('placeholder') !== null) {
        $this.siblings('label').addClass('six-storage-active');
      } else if (element.validity) {
        $this.siblings('label').toggleClass('six-storage-active', element.validity.badInput === true);
      } else {
        $this.siblings('label').removeClass('six-storage-active');
      }
    });
  };

  M.validate_field = function (object) {
    var hasLength = object.attr('data-length') !== null;
    var lenAttr = parseInt(object.attr('data-length'));
    var len = object[0].value.length;

    if (len === 0 && object[0].validity.badInput === false && !object.is(':required')) {
      if (object.hasClass('six-storage-validate')) {
        object.removeClass('six-storage-valid');
        object.removeClass('six-storage-invalid');
      }
    } else {
      if (object.hasClass('six-storage-validate')) {
        // Check for character counter attributes
        if (object.is(':valid') && hasLength && len <= lenAttr || object.is(':valid') && !hasLength) {
          object.removeClass('six-storage-invalid');
          object.addClass('six-storage-valid');
        } else {
          object.removeClass('six-storage-valid');
          object.addClass('six-storage-invalid');
        }
      }
    }
  };

  M.textareaAutoResize = function ($textarea) {
    // Wrap if native element
    if ($textarea instanceof Element) {
      $textarea = $($textarea);
    }

    if (!$textarea.length) {
      console.error('No textarea element found');
      return;
    } // Textarea Auto Resize


    var hiddenDiv = $('.six-storage-hiddendiv').first();

    if (!hiddenDiv.length) {
      hiddenDiv = $('<div class="six-storage-hiddendiv common"></div>');
      $('body').append(hiddenDiv);
    } // Set font properties of hiddenDiv


    var fontFamily = $textarea.css('font-family');
    var fontSize = $textarea.css('font-size');
    var lineHeight = $textarea.css('line-height'); // Firefox can't handle padding shorthand.

    var paddingTop = $textarea.css('padding-top');
    var paddingRight = $textarea.css('padding-right');
    var paddingBottom = $textarea.css('padding-bottom');
    var paddingLeft = $textarea.css('padding-left');

    if (fontSize) {
      hiddenDiv.css('font-size', fontSize);
    }

    if (fontFamily) {
      hiddenDiv.css('font-family', fontFamily);
    }

    if (lineHeight) {
      hiddenDiv.css('line-height', lineHeight);
    }

    if (paddingTop) {
      hiddenDiv.css('padding-top', paddingTop);
    }

    if (paddingRight) {
      hiddenDiv.css('padding-right', paddingRight);
    }

    if (paddingBottom) {
      hiddenDiv.css('padding-bottom', paddingBottom);
    }

    if (paddingLeft) {
      hiddenDiv.css('padding-left', paddingLeft);
    } // Set original-height, if none


    if (!$textarea.data('original-height')) {
      $textarea.data('original-height', $textarea.height());
    }

    if ($textarea.attr('wrap') === 'off') {
      hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
    }

    hiddenDiv.text($textarea[0].value + '\n');
    var content = hiddenDiv.html().replace(/\n/g, '<br>');
    hiddenDiv.html(content); // When textarea is hidden, width goes crazy.
    // Approximate with half of window size

    if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) {
      hiddenDiv.css('width', $textarea.width() + 'px');
    } else {
      hiddenDiv.css('width', window.innerWidth / 2 + 'px');
    }
    /**
     * Resize if the new height is greater than the
     * original height of the textarea
     */


    if ($textarea.data('original-height') <= hiddenDiv.innerHeight()) {
      $textarea.css('height', hiddenDiv.innerHeight() + 'px');
    } else if ($textarea[0].value.length < $textarea.data('previous-length')) {
      /**
       * In case the new height is less than original height, it
       * means the textarea has less text than before
       * So we set the height to the original one
       */
      $textarea.css('height', $textarea.data('original-height') + 'px');
    }

    $textarea.data('previous-length', $textarea[0].value.length);
  };

  $(document).ready(function () {
    // Text based inputs
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea'; // Add active if form auto complete

    $(document).on('change', input_selector, function () {
      if (this.value.length !== 0 || $(this).attr('placeholder') !== null) {
        $(this).siblings('label').addClass('six-storage-active');
      }

      M.validate_field($(this));
    }); // Add active if input element has been pre-populated on document ready

    $(document).ready(function () {
      M.updateTextFields();
    }); // HTML DOM FORM RESET handling

    $(document).on('reset', function (e) {
      var formReset = $(e.target);

      if (formReset.is('form')) {
        formReset.find(input_selector).removeClass('six-storage-valid').removeClass('six-storage-invalid');
        formReset.find(input_selector).each(function (e) {
          if (this.value.length) {
            $(this).siblings('label').removeClass('six-storage-active');
          }
        }); // Reset select (after native reset)

        setTimeout(function () {
          formReset.find('select').each(function () {
            // check if initialized
            if (this.M_FormSelect) {
              $(this).trigger('change');
            }
          });
        }, 0);
      }
    });
    /**
     * Add active when element has focus
     * @param {Event} e
     */

    document.addEventListener('focus', function (e) {
      if ($(e.target).is(input_selector)) {
        $(e.target).siblings('label, .six-storage-prefix').addClass('six-storage-active');
      }
    }, true);
    /**
     * Remove active when element is blurred
     * @param {Event} e
     */

    document.addEventListener('blur', function (e) {
      var $inputElement = $(e.target);

      if ($inputElement.is(input_selector)) {
        var selector = '.six-storage-prefix';

        if ($inputElement[0].value.length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === null) {
          selector += ', label';
        }

        $inputElement.siblings(selector).removeClass('six-storage-active');
        M.validate_field($inputElement);
      }
    }, true); // Radio and Checkbox focus class

    var radio_checkbox = 'input[type=radio], input[type=checkbox]';
    $(document).on('keyup', radio_checkbox, function (e) {
      // TAB, check if tabbing to radio or checkbox.
      if (e.which === M.keys.TAB) {
        $(this).addClass('six-storage-tabbed');
        var $this = $(this);
        $this.one('blur', function (e) {
          $(this).removeClass('six-storage-tabbed');
        });
        return;
      }
    });
    var text_area_selector = '.six-storage-materialize-textarea';
    $(text_area_selector).each(function () {
      var $textarea = $(this);
      /**
       * Resize textarea on document load after storing
       * the original height and the original length
       */

      $textarea.data('original-height', $textarea.height());
      $textarea.data('previous-length', this.value.length);
      M.textareaAutoResize($textarea);
    });
    $(document).on('keyup', text_area_selector, function () {
      M.textareaAutoResize($(this));
    });
    $(document).on('keydown', text_area_selector, function () {
      M.textareaAutoResize($(this));
    }); // File Input Path

    $(document).on('change', '.six-storage-file-field input[type="file"]', function () {
      var file_field = $(this).closest('.six-storage-file-field');
      var path_input = file_field.find('input.six-storage-file-path');
      var files = $(this)[0].files;
      var file_names = [];

      for (var i = 0; i < files.length; i++) {
        file_names.push(files[i].name);
      }

      path_input[0].value = file_names.join(', ');
      path_input.trigger('change');
    });
  }); // End of $(document).ready
})(cash);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    indicators: true,
    height: 400,
    duration: 500,
    interval: 6000
  };
  /**
   * @class
   *
   */

  var Slider = function (_Component11) {
    _inherits(Slider, _Component11);
    /**
     * Construct Slider instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Slider(el, options) {
      _classCallCheck(this, Slider);

      var _this40 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, Slider, el, options));

      _this40.el.M_Slider = _this40;
      /**
       * Options for the modal
       * @member Slider#options
       * @prop {Boolean} [indicators=true] - Show indicators
       * @prop {Number} [height=400] - height of slider
       * @prop {Number} [duration=500] - Length in ms of slide transition
       * @prop {Number} [interval=6000] - Length in ms of slide interval
       */

      _this40.options = $.extend({}, Slider.defaults, options); // setup

      _this40.$slider = _this40.$el.find('.six-storage-slides');
      _this40.$slides = _this40.$slider.children('li');
      _this40.activeIndex = _this40.$slides.filter(function (item) {
        return $(item).hasClass('six-storage-active');
      }).first().index();

      if (_this40.activeIndex != -1) {
        _this40.$active = _this40.$slides.eq(_this40.activeIndex);
      }

      _this40._setSliderHeight(); // Set initial positions of captions


      _this40.$slides.find('.caption').each(function (el) {
        _this40._animateCaptionIn(el, 0);
      }); // Move img src into background-image


      _this40.$slides.find('img').each(function (el) {
        var placeholderBase64 = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

        if ($(el).attr('src') !== placeholderBase64) {
          $(el).css('background-image', 'url("' + $(el).attr('src') + '")');
          $(el).attr('src', placeholderBase64);
        }
      });

      _this40._setupIndicators(); // Show active slide


      if (_this40.$active) {
        _this40.$active.css('display', 'block');
      } else {
        _this40.$slides.first().addClass('six-storage-active');

        anim({
          targets: _this40.$slides.first()[0],
          opacity: 1,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });
        _this40.activeIndex = 0;
        _this40.$active = _this40.$slides.eq(_this40.activeIndex); // Update indicators

        if (_this40.options.indicators) {
          _this40.$indicators.eq(_this40.activeIndex).addClass('six-storage-active');
        }
      } // Adjust height to current slide


      _this40.$active.find('img').each(function (el) {
        anim({
          targets: _this40.$active.find('.caption')[0],
          opacity: 1,
          translateX: 0,
          translateY: 0,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });
      });

      _this40._setupEventHandlers(); // auto scroll


      _this40.start();

      return _this40;
    }

    _createClass(Slider, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this.pause();

        this._removeIndicators();

        this._removeEventHandlers();

        this.el.M_Slider = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this41 = this;

        this._handleIntervalBound = this._handleInterval.bind(this);
        this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.addEventListener('click', _this41._handleIndicatorClickBound);
          });
        }
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this42 = this;

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.removeEventListener('click', _this42._handleIndicatorClickBound);
          });
        }
      }
      /**
       * Handle indicator click
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        var currIndex = $(e.target).index();
        this.set(currIndex);
      }
      /**
       * Handle Interval
       */

    }, {
      key: "_handleInterval",
      value: function _handleInterval() {
        var newActiveIndex = this.$slider.find('.six-storage-active').index();
        if (this.$slides.length === newActiveIndex + 1) newActiveIndex = 0; // loop to start
        else newActiveIndex += 1;
        this.set(newActiveIndex);
      }
      /**
       * Animate in caption
       * @param {Element} caption
       * @param {Number} duration
       */

    }, {
      key: "_animateCaptionIn",
      value: function _animateCaptionIn(caption, duration) {
        var animOptions = {
          targets: caption,
          opacity: 0,
          duration: duration,
          easing: 'easeOutQuad'
        };

        if ($(caption).hasClass('six-storage-center-align')) {
          animOptions.translateY = -100;
        } else if ($(caption).hasClass('six-storage-right-align')) {
          animOptions.translateX = 100;
        } else if ($(caption).hasClass('six-storage-left-align')) {
          animOptions.translateX = -100;
        }

        anim(animOptions);
      }
      /**
       * Set height of slider
       */

    }, {
      key: "_setSliderHeight",
      value: function _setSliderHeight() {
        // If fullscreen, do nothing
        if (!this.$el.hasClass('fullscreen')) {
          if (this.options.indicators) {
            // Add height if indicators are present
            this.$el.css('height', this.options.height + 40 + 'px');
          } else {
            this.$el.css('height', this.options.height + 'px');
          }

          this.$slider.css('height', this.options.height + 'px');
        }
      }
      /**
       * Setup indicators
       */

    }, {
      key: "_setupIndicators",
      value: function _setupIndicators() {
        var _this43 = this;

        if (this.options.indicators) {
          this.$indicators = $('<ul class="six-storage-indicators"></ul>');
          this.$slides.each(function (el, index) {
            var $indicator = $('<li class="six-storage-indicator-item"></li>');

            _this43.$indicators.append($indicator[0]);
          });
          this.$el.append(this.$indicators[0]);
          this.$indicators = this.$indicators.children('li.six-storage-indicator-item');
        }
      }
      /**
       * Remove indicators
       */

    }, {
      key: "_removeIndicators",
      value: function _removeIndicators() {
        this.$el.find('ul.six-storage-indicators').remove();
      }
      /**
       * Cycle to nth item
       * @param {Number} index
       */

    }, {
      key: "set",
      value: function set(index) {
        var _this44 = this; // Wrap around indices.


        if (index >= this.$slides.length) index = 0;else if (index < 0) index = this.$slides.length - 1; // Only do if index changes

        if (this.activeIndex != index) {
          this.$active = this.$slides.eq(this.activeIndex);
          var $caption = this.$active.find('.caption');
          this.$active.removeClass('six-storage-active');
          anim({
            targets: this.$active[0],
            opacity: 0,
            duration: this.options.duration,
            easing: 'easeOutQuad',
            complete: function complete() {
              _this44.$slides.not('.six-storage-active').each(function (el) {
                anim({
                  targets: el,
                  opacity: 0,
                  translateX: 0,
                  translateY: 0,
                  duration: 0,
                  easing: 'easeOutQuad'
                });
              });
            }
          });

          this._animateCaptionIn($caption[0], this.options.duration); // Update indicators


          if (this.options.indicators) {
            this.$indicators.eq(this.activeIndex).removeClass('six-storage-active');
            this.$indicators.eq(index).addClass('six-storage-active');
          }

          anim({
            targets: this.$slides.eq(index)[0],
            opacity: 1,
            duration: this.options.duration,
            easing: 'easeOutQuad'
          });
          anim({
            targets: this.$slides.eq(index).find('.caption')[0],
            opacity: 1,
            translateX: 0,
            translateY: 0,
            duration: this.options.duration,
            delay: this.options.duration,
            easing: 'easeOutQuad'
          });
          this.$slides.eq(index).addClass('six-storage-active');
          this.activeIndex = index; // Reset interval

          this.start();
        }
      }
      /**
       * Pause slider interval
       */

    }, {
      key: "pause",
      value: function pause() {
        clearInterval(this.interval);
      }
      /**
       * Start slider interval
       */

    }, {
      key: "start",
      value: function start() {
        clearInterval(this.interval);
        this.interval = setInterval(this._handleIntervalBound, this.options.duration + this.options.interval);
      }
      /**
       * Move to next slide
       */

    }, {
      key: "next",
      value: function next() {
        var newIndex = this.activeIndex + 1; // Wrap around indices.

        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;
        this.set(newIndex);
      }
      /**
       * Move to previous slide
       */

    }, {
      key: "prev",
      value: function prev() {
        var newIndex = this.activeIndex - 1; // Wrap around indices.

        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;
        this.set(newIndex);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Slider.__proto__ || Object.getPrototypeOf(Slider), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Slider;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Slider;
  }(Component);

  M.Slider = Slider;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Slider, 'slider', 'M_Slider');
  }
})(cash, M.anime);

;

(function ($, anim) {
  $(document).on('click', '.six-storage-card', function (e) {
    if ($(this).children('.six-storage-card-reveal').length) {
      var $card = $(e.target).closest('.six-storage-card');

      if ($card.data('initialOverflow') === undefined) {
        $card.data('initialOverflow', $card.css('overflow') === undefined ? '' : $card.css('overflow'));
      }

      var $cardReveal = $(this).find('.six-storage-card-reveal');

      if ($(e.target).is($('.six-storage-card-reveal .six-storage-card-title')) || $(e.target).is($('.six-storage-card-reveal .six-storage-card-title i'))) {
        // Make Reveal animate down and display none
        anim({
          targets: $cardReveal[0],
          translateY: 0,
          duration: 225,
          easing: 'easeInOutQuad',
          complete: function complete(anim) {
            var el = anim.animatables[0].target;
            $(el).css({
              display: 'none'
            });
            $card.css('overflow', $card.data('initialOverflow'));
          }
        });
      } else if ($(e.target).is($('.six-storage-card .six-storage-activator')) || $(e.target).is($('.six-storage-card .six-storage-activator i'))) {
        $card.css('overflow', 'hidden');
        $cardReveal.css({
          display: 'block'
        });
        anim({
          targets: $cardReveal[0],
          translateY: '-100%',
          duration: 300,
          easing: 'easeInOutQuad'
        });
      }
    }
  });
})(cash, M.anime);

;

(function ($) {
  'use strict';

  var _defaults = {
    data: [],
    placeholder: '',
    secondaryPlaceholder: '',
    autocompleteOptions: {},
    limit: Infinity,
    onChipAdd: null,
    onChipSelect: null,
    onChipDelete: null
  };
  /**
   * @typedef {Object} chip
   * @property {String} tag  chip tag string
   * @property {String} [image]  chip avatar image string
   */

  /**
   * @class
   *
   */

  var Chips = function (_Component12) {
    _inherits(Chips, _Component12);
    /**
     * Construct Chips instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Chips(el, options) {
      _classCallCheck(this, Chips);

      var _this45 = _possibleConstructorReturn(this, (Chips.__proto__ || Object.getPrototypeOf(Chips)).call(this, Chips, el, options));

      _this45.el.M_Chips = _this45;
      /**
       * Options for the modal
       * @member Chips#options
       * @prop {Array} data
       * @prop {String} placeholder
       * @prop {String} secondaryPlaceholder
       * @prop {Object} autocompleteOptions
       */

      _this45.options = $.extend({}, Chips.defaults, options);

      _this45.$el.addClass('six-storage-chips six-storage-input-field');

      _this45.chipsData = [];
      _this45.$chips = $();

      _this45._setupInput();

      _this45.hasAutocomplete = Object.keys(_this45.options.autocompleteOptions).length > 0; // Set input id

      if (!_this45.$input.attr('id')) {
        _this45.$input.attr('id', M.guid());
      } // Render initial chips


      if (_this45.options.data.length) {
        _this45.chipsData = _this45.options.data;

        _this45._renderChips(_this45.chipsData);
      } // Setup autocomplete if needed


      if (_this45.hasAutocomplete) {
        _this45._setupAutocomplete();
      }

      _this45._setPlaceholder();

      _this45._setupLabel();

      _this45._setupEventHandlers();

      return _this45;
    }

    _createClass(Chips, [{
      key: "getData",

      /**
       * Get Chips Data
       */
      value: function getData() {
        return this.chipsData;
      }
      /**
       * Teardown component
       */

    }, {
      key: "destroy",
      value: function destroy() {
        this._removeEventHandlers();

        this.$chips.remove();
        this.el.M_Chips = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleChipClickBound = this._handleChipClick.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputFocusBound = this._handleInputFocus.bind(this);
        this._handleInputBlurBound = this._handleInputBlur.bind(this);
        this.el.addEventListener('click', this._handleChipClickBound);
        document.addEventListener('keydown', Chips._handleChipsKeydown);
        document.addEventListener('keyup', Chips._handleChipsKeyup);
        this.el.addEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].addEventListener('focus', this._handleInputFocusBound);
        this.$input[0].addEventListener('blur', this._handleInputBlurBound);
        this.$input[0].addEventListener('keydown', this._handleInputKeydownBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleChipClickBound);
        document.removeEventListener('keydown', Chips._handleChipsKeydown);
        document.removeEventListener('keyup', Chips._handleChipsKeyup);
        this.el.removeEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].removeEventListener('focus', this._handleInputFocusBound);
        this.$input[0].removeEventListener('blur', this._handleInputBlurBound);
        this.$input[0].removeEventListener('keydown', this._handleInputKeydownBound);
      }
      /**
       * Handle Chip Click
       * @param {Event} e
       */

    }, {
      key: "_handleChipClick",
      value: function _handleChipClick(e) {
        var $chip = $(e.target).closest('.six-storage-chip');
        var clickedClose = $(e.target).is('.six-storage-close');

        if ($chip.length) {
          var index = $chip.index();

          if (clickedClose) {
            // delete chip
            this.deleteChip(index);
            this.$input[0].focus();
          } else {
            // select chip
            this.selectChip(index);
          } // Default handle click to focus on input

        } else {
          this.$input[0].focus();
        }
      }
      /**
       * Handle Chips Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputFocus",

      /**
       * Handle Input Focus
       */
      value: function _handleInputFocus() {
        this.$el.addClass('focus');
      }
      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        this.$el.removeClass('focus');
      }
      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Chips._keydown = true; // enter

        if (e.keyCode === 13) {
          // Override enter if autocompleting.
          if (this.hasAutocomplete && this.autocomplete && this.autocomplete.isOpen) {
            return;
          }

          e.preventDefault();
          this.addChip({
            tag: this.$input[0].value
          });
          this.$input[0].value = ''; // delete or left
        } else if ((e.keyCode === 8 || e.keyCode === 37) && this.$input[0].value === '' && this.chipsData.length) {
          e.preventDefault();
          this.selectChip(this.chipsData.length - 1);
        }
      }
      /**
       * Render Chip
       * @param {chip} chip
       * @return {Element}
       */

    }, {
      key: "_renderChip",
      value: function _renderChip(chip) {
        if (!chip.tag) {
          return;
        }

        var renderedChip = document.createElement('div');
        var closeIcon = document.createElement('i');
        renderedChip.classList.add('six-storage-chip');
        renderedChip.textContent = chip.tag;
        renderedChip.setAttribute('tabindex', 0);
        $(closeIcon).addClass('six-storage-material-icons six-storage-close');
        closeIcon.textContent = 'close'; // attach image if needed

        if (chip.image) {
          var img = document.createElement('img');
          img.setAttribute('src', chip.image);
          renderedChip.insertBefore(img, renderedChip.firstChild);
        }

        renderedChip.appendChild(closeIcon);
        return renderedChip;
      }
      /**
       * Render Chips
       */

    }, {
      key: "_renderChips",
      value: function _renderChips() {
        this.$chips.remove();

        for (var i = 0; i < this.chipsData.length; i++) {
          var chipEl = this._renderChip(this.chipsData[i]);

          this.$el.append(chipEl);
          this.$chips.add(chipEl);
        } // move input to end


        this.$el.append(this.$input[0]);
      }
      /**
       * Setup Autocomplete
       */

    }, {
      key: "_setupAutocomplete",
      value: function _setupAutocomplete() {
        var _this46 = this;

        this.options.autocompleteOptions.onAutocomplete = function (val) {
          _this46.addChip({
            tag: val
          });

          _this46.$input[0].value = '';

          _this46.$input[0].focus();
        };

        this.autocomplete = M.Autocomplete.init(this.$input[0], this.options.autocompleteOptions);
      }
      /**
       * Setup Input
       */

    }, {
      key: "_setupInput",
      value: function _setupInput() {
        this.$input = this.$el.find('input');

        if (!this.$input.length) {
          this.$input = $('<input></input>');
          this.$el.append(this.$input);
        }

        this.$input.addClass('input');
      }
      /**
       * Setup Label
       */

    }, {
      key: "_setupLabel",
      value: function _setupLabel() {
        this.$label = this.$el.find('label');

        if (this.$label.length) {
          this.$label.setAttribute('for', this.$input.attr('id'));
        }
      }
      /**
       * Set placeholder
       */

    }, {
      key: "_setPlaceholder",
      value: function _setPlaceholder() {
        if (this.chipsData !== undefined && !this.chipsData.length && this.options.placeholder) {
          $(this.$input).prop('placeholder', this.options.placeholder);
        } else if ((this.chipsData === undefined || !!this.chipsData.length) && this.options.secondaryPlaceholder) {
          $(this.$input).prop('placeholder', this.options.secondaryPlaceholder);
        }
      }
      /**
       * Check if chip is valid
       * @param {chip} chip
       */

    }, {
      key: "_isValid",
      value: function _isValid(chip) {
        if (chip.hasOwnProperty('tag') && chip.tag !== '') {
          var exists = false;

          for (var i = 0; i < this.chipsData.length; i++) {
            if (this.chipsData[i].tag === chip.tag) {
              exists = true;
              break;
            }
          }

          return !exists;
        }

        return false;
      }
      /**
       * Add chip
       * @param {chip} chip
       */

    }, {
      key: "addChip",
      value: function addChip(chip) {
        if (!this._isValid(chip) || this.chipsData.length >= this.options.limit) {
          return;
        }

        var renderedChip = this._renderChip(chip);

        this.$chips.add(renderedChip);
        this.chipsData.push(chip);
        $(this.$input).before(renderedChip);

        this._setPlaceholder(); // fire chipAdd callback


        if (typeof this.options.onChipAdd === 'function') {
          this.options.onChipAdd.call(this, this.$el, renderedChip);
        }
      }
      /**
       * Delete chip
       * @param {Number} chip
       */

    }, {
      key: "deleteChip",
      value: function deleteChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this.$chips.eq(chipIndex).remove();
        this.$chips = this.$chips.filter(function (el) {
          return $(el).index() >= 0;
        });
        this.chipsData.splice(chipIndex, 1);

        this._setPlaceholder(); // fire chipDelete callback


        if (typeof this.options.onChipDelete === 'function') {
          this.options.onChipDelete.call(this, this.$el, $chip[0]);
        }
      }
      /**
       * Select chip
       * @param {Number} chip
       */

    }, {
      key: "selectChip",
      value: function selectChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this._selectedChip = $chip;
        $chip[0].focus(); // fire chipSelect callback

        if (typeof this.options.onChipSelect === 'function') {
          this.options.onChipSelect.call(this, this.$el, $chip[0]);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Chips.__proto__ || Object.getPrototypeOf(Chips), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Chips;
      }
    }, {
      key: "_handleChipsKeydown",
      value: function _handleChipsKeydown(e) {
        Chips._keydown = true;
        var $chips = $(e.target).closest('.six-storage-chips');
        var chipsKeydown = e.target && $chips.length; // Don't handle keydown inputs on input and textarea

        if ($(e.target).is('input, textarea') || !chipsKeydown) {
          return;
        }

        var currChips = $chips[0].M_Chips; // backspace and delete

        if (e.keyCode === 8 || e.keyCode === 46) {
          e.preventDefault();
          var selectIndex = currChips.chipsData.length;

          if (currChips._selectedChip) {
            var index = currChips._selectedChip.index();

            currChips.deleteChip(index);
            currChips._selectedChip = null; // Make sure selectIndex doesn't go negative

            selectIndex = Math.max(index - 1, 0);
          }

          if (currChips.chipsData.length) {
            currChips.selectChip(selectIndex);
          } // left arrow key

        } else if (e.keyCode === 37) {
          if (currChips._selectedChip) {
            var _selectIndex = currChips._selectedChip.index() - 1;

            if (_selectIndex < 0) {
              return;
            }

            currChips.selectChip(_selectIndex);
          } // right arrow key

        } else if (e.keyCode === 39) {
          if (currChips._selectedChip) {
            var _selectIndex2 = currChips._selectedChip.index() + 1;

            if (_selectIndex2 >= currChips.chipsData.length) {
              currChips.$input[0].focus();
            } else {
              currChips.selectChip(_selectIndex2);
            }
          }
        }
      }
      /**
       * Handle Chips Keyup
       * @param {Event} e
       */

    }, {
      key: "_handleChipsKeyup",
      value: function _handleChipsKeyup(e) {
        Chips._keydown = false;
      }
      /**
       * Handle Chips Blur
       * @param {Event} e
       */

    }, {
      key: "_handleChipsBlur",
      value: function _handleChipsBlur(e) {
        if (!Chips._keydown) {
          var $chips = $(e.target).closest('.six-storage-chips');
          var currChips = $chips[0].M_Chips;
          currChips._selectedChip = null;
        }
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Chips;
  }(Component);
  /**
   * @static
   * @memberof Chips
   */


  Chips._keydown = false;
  M.Chips = Chips;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Chips, 'chips', 'M_Chips');
  }

  $(document).ready(function () {
    // Handle removal of static chips.
    $(document.body).on('click', '.six-storage-chip .close', function () {
      var $chips = $(this).closest('.six-storage-chips');

      if ($chips.length && $chips[0].M_Chips) {
        return;
      }

      $(this).closest('.six-storage-chip').remove();
    });
  });
})(cash);

;

(function ($) {
  'use strict';

  var _defaults = {
    top: 0,
    bottom: Infinity,
    offset: 0,
    onPositionChange: null
  };
  /**
   * @class
   *
   */

  var Pushpin = function (_Component13) {
    _inherits(Pushpin, _Component13);
    /**
     * Construct Pushpin instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Pushpin(el, options) {
      _classCallCheck(this, Pushpin);

      var _this47 = _possibleConstructorReturn(this, (Pushpin.__proto__ || Object.getPrototypeOf(Pushpin)).call(this, Pushpin, el, options));

      _this47.el.M_Pushpin = _this47;
      /**
       * Options for the modal
       * @member Pushpin#options
       */

      _this47.options = $.extend({}, Pushpin.defaults, options);
      _this47.originalOffset = _this47.el.offsetTop;

      Pushpin._pushpins.push(_this47);

      _this47._setupEventHandlers();

      _this47._updatePosition();

      return _this47;
    }

    _createClass(Pushpin, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this.el.style.top = null;

        this._removePinClasses();

        this._removeEventHandlers(); // Remove pushpin Inst


        var index = Pushpin._pushpins.indexOf(this);

        Pushpin._pushpins.splice(index, 1);
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        document.addEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        document.removeEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_updatePosition",
      value: function _updatePosition() {
        var scrolled = M.getDocumentScrollTop() + this.options.offset;

        if (this.options.top <= scrolled && this.options.bottom >= scrolled && !this.el.classList.contains('six-storage-pinned')) {
          this._removePinClasses();

          this.el.style.top = this.options.offset + "px";
          this.el.classList.add('six-storage-pinned'); // onPositionChange callback

          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'six-storage-pinned');
          }
        } // Add six-storage-pin-top (when scrolled position is above top)


        if (scrolled < this.options.top && !this.el.classList.contains('six-storage-pin-top')) {
          this._removePinClasses();

          this.el.style.top = 0;
          this.el.classList.add('six-storage-pin-top'); // onPositionChange callback

          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'six-storage-pin-top');
          }
        } // Add six-storage-pin-bottom (when scrolled position is below bottom)


        if (scrolled > this.options.bottom && !this.el.classList.contains('six-storage-pin-bottom')) {
          this._removePinClasses();

          this.el.classList.add('six-storage-pin-bottom');
          this.el.style.top = this.options.bottom - this.originalOffset + "px"; // onPositionChange callback

          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'six-storage-pin-bottom');
          }
        }
      }
    }, {
      key: "_removePinClasses",
      value: function _removePinClasses() {
        // IE 11 bug (can't remove multiple classes in one line)
        this.el.classList.remove('six-storage-pin-top');
        this.el.classList.remove('six-storage-pinned');
        this.el.classList.remove('six-storage-pin-bottom');
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Pushpin.__proto__ || Object.getPrototypeOf(Pushpin), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Pushpin;
      }
    }, {
      key: "_updateElements",
      value: function _updateElements() {
        for (var elIndex in Pushpin._pushpins) {
          var pInstance = Pushpin._pushpins[elIndex];

          pInstance._updatePosition();
        }
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Pushpin;
  }(Component);
  /**
   * @static
   * @memberof Pushpin
   */


  Pushpin._pushpins = [];
  M.Pushpin = Pushpin;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Pushpin, 'pushpin', 'M_Pushpin');
  }
})(cash);

;

(function ($, anim) {
  'use strict';

  var _defaults = {
    direction: 'top',
    hoverEnabled: true,
    toolbarEnabled: false
  };
  $.fn.reverse = [].reverse;
  /**
   * @class
   *
   */

  var FloatingActionButton = function (_Component14) {
    _inherits(FloatingActionButton, _Component14);
    /**
     * Construct FloatingActionButton instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function FloatingActionButton(el, options) {
      _classCallCheck(this, FloatingActionButton);

      var _this48 = _possibleConstructorReturn(this, (FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton)).call(this, FloatingActionButton, el, options));

      _this48.el.M_FloatingActionButton = _this48;
      /**
       * Options for the fab
       * @member FloatingActionButton#options
       * @prop {Boolean} [direction] - Direction fab menu opens
       * @prop {Boolean} [hoverEnabled=true] - Enable hover vs click
       * @prop {Boolean} [toolbarEnabled=false] - Enable toolbar transition
       */

      _this48.options = $.extend({}, FloatingActionButton.defaults, options);
      _this48.isOpen = false;
      _this48.$anchor = _this48.$el.children('a').first();
      _this48.$menu = _this48.$el.children('ul').first();
      _this48.$floatingBtns = _this48.$el.find('ul .six-storage-btn-floating');
      _this48.$floatingBtnsReverse = _this48.$el.find('ul .six-storage-btn-floating').reverse();
      _this48.offsetY = 0;
      _this48.offsetX = 0;

      _this48.$el.addClass("direction-" + _this48.options.direction);

      if (_this48.options.direction === 'top') {
        _this48.offsetY = 40;
      } else if (_this48.options.direction === 'right') {
        _this48.offsetX = -40;
      } else if (_this48.options.direction === 'bottom') {
        _this48.offsetY = -40;
      } else {
        _this48.offsetX = 40;
      }

      _this48._setupEventHandlers();

      return _this48;
    }

    _createClass(FloatingActionButton, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.el.M_FloatingActionButton = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleFABClickBound = this._handleFABClick.bind(this);
        this._handleOpenBound = this.open.bind(this);
        this._handleCloseBound = this.close.bind(this);

        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.addEventListener('mouseenter', this._handleOpenBound);
          this.el.addEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.addEventListener('click', this._handleFABClickBound);
        }
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.removeEventListener('mouseenter', this._handleOpenBound);
          this.el.removeEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.removeEventListener('click', this._handleFABClickBound);
        }
      }
      /**
       * Handle FAB Click
       */

    }, {
      key: "_handleFABClick",
      value: function _handleFABClick() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }
      /**
       * Handle Document Click
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest(this.$menu).length) {
          this.close();
        }
      }
      /**
       * Open FAB
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          this._animateInToolbar();
        } else {
          this._animateInFAB();
        }

        this.isOpen = true;
      }
      /**
       * Close FAB
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          window.removeEventListener('scroll', this._handleCloseBound, true);
          document.body.removeEventListener('click', this._handleDocumentClickBound, true);

          this._animateOutToolbar();
        } else {
          this._animateOutFAB();
        }

        this.isOpen = false;
      }
      /**
       * Classic FAB Menu open
       */

    }, {
      key: "_animateInFAB",
      value: function _animateInFAB() {
        var _this49 = this;

        this.$el.addClass('six-storage-active');
        var time = 0;
        this.$floatingBtnsReverse.each(function (el) {
          anim({
            targets: el,
            opacity: 1,
            scale: [0.4, 1],
            translateY: [_this49.offsetY, 0],
            translateX: [_this49.offsetX, 0],
            duration: 275,
            delay: time,
            easing: 'easeInOutQuad'
          });
          time += 40;
        });
      }
      /**
       * Classic FAB Menu close
       */

    }, {
      key: "_animateOutFAB",
      value: function _animateOutFAB() {
        var _this50 = this;

        this.$floatingBtnsReverse.each(function (el) {
          anim.remove(el);
          anim({
            targets: el,
            opacity: 0,
            scale: 0.4,
            translateY: _this50.offsetY,
            translateX: _this50.offsetX,
            duration: 175,
            easing: 'easeOutQuad',
            complete: function complete() {
              _this50.$el.removeClass('six-storage-active');
            }
          });
        });
      }
      /**
       * Toolbar transition Menu open
       */

    }, {
      key: "_animateInToolbar",
      value: function _animateInToolbar() {
        var _this51 = this;

        var scaleFactor = void 0;
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var btnRect = this.el.getBoundingClientRect();
        var backdrop = $('<div class="six-storage-fab-backdrop"></div>');
        var fabColor = this.$anchor.css('background-color');
        this.$anchor.append(backdrop);
        this.offsetX = btnRect.left - windowWidth / 2 + btnRect.width / 2;
        this.offsetY = windowHeight - btnRect.bottom;
        scaleFactor = windowWidth / backdrop[0].clientWidth;
        this.btnBottom = btnRect.bottom;
        this.btnLeft = btnRect.left;
        this.btnWidth = btnRect.width; // Set initial state

        this.$el.addClass('six-storage-active');
        this.$el.css({
          'text-align': 'center',
          width: '100%',
          bottom: 0,
          left: 0,
          transform: 'translateX(' + this.offsetX + 'px)',
          transition: 'none'
        });
        this.$anchor.css({
          transform: 'translateY(' + -this.offsetY + 'px)',
          transition: 'none'
        });
        backdrop.css({
          'background-color': fabColor
        });
        setTimeout(function () {
          _this51.$el.css({
            transform: '',
            transition: 'transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s'
          });

          _this51.$anchor.css({
            overflow: 'visible',
            transform: '',
            transition: 'transform .2s'
          });

          setTimeout(function () {
            _this51.$el.css({
              overflow: 'hidden',
              'background-color': fabColor
            });

            backdrop.css({
              transform: 'scale(' + scaleFactor + ')',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });

            _this51.$menu.children('li').children('a').css({
              opacity: 1
            }); // Scroll to close.


            _this51._handleDocumentClickBound = _this51._handleDocumentClick.bind(_this51);
            window.addEventListener('scroll', _this51._handleCloseBound, true);
            document.body.addEventListener('click', _this51._handleDocumentClickBound, true);
          }, 100);
        }, 0);
      }
      /**
       * Toolbar transition Menu close
       */

    }, {
      key: "_animateOutToolbar",
      value: function _animateOutToolbar() {
        var _this52 = this;

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var backdrop = this.$el.find('.six-storage-fab-backdrop');
        var fabColor = this.$anchor.css('background-color');
        this.offsetX = this.btnLeft - windowWidth / 2 + this.btnWidth / 2;
        this.offsetY = windowHeight - this.btnBottom; // Hide backdrop

        this.$el.removeClass('six-storage-active');
        this.$el.css({
          'background-color': 'transparent',
          transition: 'none'
        });
        this.$anchor.css({
          transition: 'none'
        });
        backdrop.css({
          transform: 'scale(0)',
          'background-color': fabColor
        });
        this.$menu.children('li').children('a').css({
          opacity: ''
        });
        setTimeout(function () {
          backdrop.remove(); // Set initial state.

          _this52.$el.css({
            'text-align': '',
            width: '',
            bottom: '',
            left: '',
            overflow: '',
            'background-color': '',
            transform: 'translate3d(' + -_this52.offsetX + 'px,0,0)'
          });

          _this52.$anchor.css({
            overflow: '',
            transform: 'translate3d(0,' + _this52.offsetY + 'px,0)'
          });

          setTimeout(function () {
            _this52.$el.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s'
            });

            _this52.$anchor.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });
          }, 20);
        }, 200);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FloatingActionButton;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return FloatingActionButton;
  }(Component);

  M.FloatingActionButton = FloatingActionButton;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FloatingActionButton, 'floatingActionButton', 'M_FloatingActionButton');
  }
})(cash, M.anime);

;

(function ($) {
  'use strict';

  var _defaults = {
    // Close when date is selected
    autoClose: false,
    // the default output format for the input field value
    format: 'mmm dd, yyyy',
    // Used to create date object from current input string
    parse: null,
    // The initial date to view when first opened
    defaultDate: null,
    // Make the `defaultDate` the initial selected value
    setDefaultDate: false,
    disableWeekends: false,
    disableDayFn: null,
    // First day of week (0: Sunday, 1: Monday etc)
    firstDay: 0,
    // The earliest date that can be selected
    minDate: null,
    // Thelatest date that can be selected
    maxDate: null,
    // Number of years either side, or array of upper/lower range
    yearRange: 10,
    // used internally (don't config outside)
    minYear: 0,
    maxYear: 9999,
    minMonth: undefined,
    maxMonth: undefined,
    startRange: null,
    endRange: null,
    isRTL: false,
    // Render the month after year in the calendar title
    showMonthAfterYear: false,
    // Render days of the calendar grid that fall in the next or previous month
    showDaysInNextAndPreviousMonths: false,
    // Specify a DOM element to render the calendar in
    container: null,
    // Show clear button
    showClearBtn: false,
    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok',
      previousMonth: '‹',
      nextMonth: '›',
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdaysAbbrev: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },
    // events array
    events: [],
    // callback function
    onSelect: null,
    onOpen: null,
    onClose: null,
    onDraw: null
  };
  /**
   * @class
   *
   */

  var Datepicker = function (_Component15) {
    _inherits(Datepicker, _Component15);
    /**
     * Construct Datepicker instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Datepicker(el, options) {
      _classCallCheck(this, Datepicker);

      var _this53 = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, Datepicker, el, options));

      _this53.el.M_Datepicker = _this53;
      _this53.options = $.extend({}, Datepicker.defaults, options); // make sure i18n defaults are not lost when only few i18n option properties are passed

      if (!!options && options.hasOwnProperty('i18n') && _typeof(options.i18n) === 'object') {
        _this53.options.i18n = $.extend({}, Datepicker.defaults.i18n, options.i18n);
      } // Remove time component from minDate and maxDate options


      if (_this53.options.minDate) _this53.options.minDate.setHours(0, 0, 0, 0);
      if (_this53.options.maxDate) _this53.options.maxDate.setHours(0, 0, 0, 0);
      _this53.id = M.guid();

      _this53._setupVariables();

      _this53._insertHTMLIntoDOM();

      _this53._setupModal();

      _this53._setupEventHandlers();

      if (!_this53.options.defaultDate) {
        _this53.options.defaultDate = new Date(Date.parse(_this53.el.value));
      }

      var defDate = _this53.options.defaultDate;

      if (Datepicker._isDate(defDate)) {
        if (_this53.options.setDefaultDate) {
          _this53.setDate(defDate, true);

          _this53.setInputValue();
        } else {
          _this53.gotoDate(defDate);
        }
      } else {
        _this53.gotoDate(new Date());
      }
      /**
       * Describes open/close state of datepicker
       * @type {Boolean}
       */


      _this53.isOpen = false;
      return _this53;
    }

    _createClass(Datepicker, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.modal.destroy();
        $(this.modalEl).remove();
        this.destroySelects();
        this.el.M_Datepicker = undefined;
      }
    }, {
      key: "destroySelects",
      value: function destroySelects() {
        var oldYearSelect = this.calendarEl.querySelector('.six-storage-orig-select-year');

        if (oldYearSelect) {
          M.FormSelect.getInstance(oldYearSelect).destroy();
        }

        var oldMonthSelect = this.calendarEl.querySelector('.six-storage-orig-select-month');

        if (oldMonthSelect) {
          M.FormSelect.getInstance(oldMonthSelect).destroy();
        }
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        if (this.options.showClearBtn) {
          $(this.clearBtn).css({
            visibility: ''
          });
          this.clearBtn.innerHTML = this.options.i18n.clear;
        }

        this.doneBtn.innerHTML = this.options.i18n.done;
        this.cancelBtn.innerHTML = this.options.i18n.cancel;

        if (this.options.container) {
          this.$modalEl.appendTo(this.options.container);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this54 = this;

        this.modalEl.id = 'modal-' + this.id;
        this.modal = M.Modal.init(this.modalEl, {
          onCloseEnd: function onCloseEnd() {
            _this54.isOpen = false;
          }
        });
      }
    }, {
      key: "toString",
      value: function toString(format) {
        var _this55 = this;

        format = format || this.options.format;

        if (!Datepicker._isDate(this.date)) {
          return '';
        }

        var formatArray = format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
        var formattedDate = formatArray.map(function (label) {
          if (_this55.formats[label]) {
            return _this55.formats[label]();
          }

          return label;
        }).join('');
        return formattedDate;
      }
    }, {
      key: "setDate",
      value: function setDate(date, preventOnSelect) {
        if (!date) {
          this.date = null;

          this._renderDateDisplay();

          return this.draw();
        }

        if (typeof date === 'string') {
          date = new Date(Date.parse(date));
        }

        if (!Datepicker._isDate(date)) {
          return;
        }

        var min = this.options.minDate,
            max = this.options.maxDate;

        if (Datepicker._isDate(min) && date < min) {
          date = min;
        } else if (Datepicker._isDate(max) && date > max) {
          date = max;
        }

        this.date = new Date(date.getTime());

        this._renderDateDisplay();

        Datepicker._setToStartOfDay(this.date);

        this.gotoDate(this.date);

        if (!preventOnSelect && typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.date);
        }
      }
    }, {
      key: "setInputValue",
      value: function setInputValue() {
        this.el.value = this.toString();
        this.$el.trigger('change', {
          firedBy: this
        });
      }
    }, {
      key: "_renderDateDisplay",
      value: function _renderDateDisplay() {
        var displayDate = Datepicker._isDate(this.date) ? this.date : new Date();
        var i18n = this.options.i18n;
        var day = i18n.weekdaysShort[displayDate.getDay()];
        var month = i18n.monthsShort[displayDate.getMonth()];
        var date = displayDate.getDate();
        this.yearTextEl.innerHTML = displayDate.getFullYear();
        this.dateTextEl.innerHTML = day + ", " + month + " " + date;
      }
      /**
       * change view to a specific date
       */

    }, {
      key: "gotoDate",
      value: function gotoDate(date) {
        var newCalendar = true;

        if (!Datepicker._isDate(date)) {
          return;
        }

        if (this.calendars) {
          var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
              lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
              visibleDate = date.getTime(); // get the end of the month

          lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
          lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
          newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
        }

        if (newCalendar) {
          this.calendars = [{
            month: date.getMonth(),
            year: date.getFullYear()
          }];
        }

        this.adjustCalendars();
      }
    }, {
      key: "adjustCalendars",
      value: function adjustCalendars() {
        this.calendars[0] = this.adjustCalendar(this.calendars[0]);
        this.draw();
      }
    }, {
      key: "adjustCalendar",
      value: function adjustCalendar(calendar) {
        if (calendar.month < 0) {
          calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
          calendar.month += 12;
        }

        if (calendar.month > 11) {
          calendar.year += Math.floor(Math.abs(calendar.month) / 12);
          calendar.month -= 12;
        }

        return calendar;
      }
    }, {
      key: "nextMonth",
      value: function nextMonth() {
        this.calendars[0].month++;
        this.adjustCalendars();
      }
    }, {
      key: "prevMonth",
      value: function prevMonth() {
        this.calendars[0].month--;
        this.adjustCalendars();
      }
    }, {
      key: "render",
      value: function render(year, month, randId) {
        var opts = this.options,
            now = new Date(),
            days = Datepicker._getDaysInMonth(year, month),
            before = new Date(year, month, 1).getDay(),
            data = [],
            row = [];

        Datepicker._setToStartOfDay(now);

        if (opts.firstDay > 0) {
          before -= opts.firstDay;

          if (before < 0) {
            before += 7;
          }
        }

        var previousMonth = month === 0 ? 11 : month - 1,
            nextMonth = month === 11 ? 0 : month + 1,
            yearOfPreviousMonth = month === 0 ? year - 1 : year,
            yearOfNextMonth = month === 11 ? year + 1 : year,
            daysInPreviousMonth = Datepicker._getDaysInMonth(yearOfPreviousMonth, previousMonth);

        var cells = days + before,
            after = cells;

        while (after > 7) {
          after -= 7;
        }

        cells += 7 - after;
        var isWeekSelected = false;

        for (var i = 0, r = 0; i < cells; i++) {
          var day = new Date(year, month, 1 + (i - before)),
              isSelected = Datepicker._isDate(this.date) ? Datepicker._compareDates(day, this.date) : false,
              isToday = Datepicker._compareDates(day, now),
              hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
              isEmpty = i < before || i >= days + before,
              dayNumber = 1 + (i - before),
              monthNumber = month,
              yearNumber = year,
              isStartRange = opts.startRange && Datepicker._compareDates(opts.startRange, day),
              isEndRange = opts.endRange && Datepicker._compareDates(opts.endRange, day),
              isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
              isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && Datepicker._isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);

          if (isEmpty) {
            if (i < before) {
              dayNumber = daysInPreviousMonth + dayNumber;
              monthNumber = previousMonth;
              yearNumber = yearOfPreviousMonth;
            } else {
              dayNumber = dayNumber - days;
              monthNumber = nextMonth;
              yearNumber = yearOfNextMonth;
            }
          }

          var dayConfig = {
            day: dayNumber,
            month: monthNumber,
            year: yearNumber,
            hasEvent: hasEvent,
            isSelected: isSelected,
            isToday: isToday,
            isDisabled: isDisabled,
            isEmpty: isEmpty,
            isStartRange: isStartRange,
            isEndRange: isEndRange,
            isInRange: isInRange,
            showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
          };
          row.push(this.renderDay(dayConfig));

          if (++r === 7) {
            data.push(this.renderRow(row, opts.isRTL, isWeekSelected));
            row = [];
            r = 0;
            isWeekSelected = false;
          }
        }

        return this.renderTable(opts, data, randId);
      }
    }, {
      key: "renderDay",
      value: function renderDay(opts) {
        var arr = [];
        var ariaSelected = 'false';

        if (opts.isEmpty) {
          if (opts.showDaysInNextAndPreviousMonths) {
            arr.push('six-storage-is-outside-current-month');
            arr.push('six-storage-is-selection-disabled');
          } else {
            return '<td class="six-storage-is-empty"></td>';
          }
        }

        if (opts.isDisabled) {
          arr.push('six-storage-is-disabled');
        }

        if (opts.isToday) {
          arr.push('six-storage-is-today');
        }

        if (opts.isSelected) {
          arr.push('six-storage-is-selected');
          ariaSelected = 'true';
        }

        if (opts.hasEvent) {
          arr.push('six-storage-has-event');
        }

        if (opts.isInRange) {
          arr.push('six-storage-is-inrange');
        }

        if (opts.isStartRange) {
          arr.push('six-storage-is-startrange');
        }

        if (opts.isEndRange) {
          arr.push('six-storage-is-endrange');
        }

        return "<td data-day=\"" + opts.day + "\" class=\"" + arr.join(' ') + "\" aria-selected=\"" + ariaSelected + "\">" + ("<button class=\"six-storage-datepicker-day-button\" type=\"button\" data-year=\"" + opts.year + "\" data-month=\"" + opts.month + "\" data-day=\"" + opts.day + "\">" + opts.day + "</button>") + '</td>';
      }
    }, {
      key: "renderRow",
      value: function renderRow(days, isRTL, isRowSelected) {
        return '<tr class="six-storage-datepicker-row' + (isRowSelected ? ' six-storage-is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
      }
    }, {
      key: "renderTable",
      value: function renderTable(opts, data, randId) {
        return '<div class="six-storage-datepicker-table-wrapper"><table cellpadding="0" cellspacing="0" class="six-storage-datepicker-table" role="grid" aria-labelledby="' + randId + '">' + this.renderHead(opts) + this.renderBody(data) + '</table></div>';
      }
    }, {
      key: "renderHead",
      value: function renderHead(opts) {
        var i = void 0,
            arr = [];

        for (i = 0; i < 7; i++) {
          arr.push("<th scope=\"col\"><abbr title=\"" + this.renderDayName(opts, i) + "\">" + this.renderDayName(opts, i, true) + "</abbr></th>");
        }

        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
      }
    }, {
      key: "renderBody",
      value: function renderBody(rows) {
        return '<tbody>' + rows.join('') + '</tbody>';
      }
    }, {
      key: "renderTitle",
      value: function renderTitle(instance, c, year, month, refYear, randId) {
        var i = void 0,
            j = void 0,
            arr = void 0,
            opts = this.options,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="six-storage-datepicker-controls" role="heading" aria-live="assertive">',
            monthHtml = void 0,
            yearHtml = void 0,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
          arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<select class="six-storage-datepicker-select six-storage-orig-select-month" tabindex="-1">' + arr.join('') + '</select>';

        if ($.isArray(opts.yearRange)) {
          i = opts.yearRange[0];
          j = opts.yearRange[1] + 1;
        } else {
          i = year - opts.yearRange;
          j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
          if (i >= opts.minYear) {
            arr.push("<option value=\"" + i + "\" " + (i === year ? 'selected="selected"' : '') + ">" + i + "</option>");
          }
        }

        yearHtml = "<select class=\"six-storage-datepicker-select six-storage-orig-select-year\" tabindex=\"-1\">" + arr.join('') + "</select>";
        var leftArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"six-storage-month-prev" + (prev ? '' : ' six-storage-is-disabled') + "\" type=\"button\">" + leftArrow + "</button>";
        html += '<div class="six-storage-selects-container">';

        if (opts.showMonthAfterYear) {
          html += yearHtml + monthHtml;
        } else {
          html += monthHtml + yearHtml;
        }

        html += '</div>';

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
          prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
          next = false;
        }

        var rightArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"six-storage-month-next" + (next ? '' : ' six-storage-is-disabled') + "\" type=\"button\">" + rightArrow + "</button>";
        return html += '</div>';
      }
      /**
       * refresh the HTML
       */

    }, {
      key: "draw",
      value: function draw(force) {
        if (!this.isOpen && !force) {
          return;
        }

        var opts = this.options,
            minYear = opts.minYear,
            maxYear = opts.maxYear,
            minMonth = opts.minMonth,
            maxMonth = opts.maxMonth,
            html = '',
            randId = void 0;

        if (this._y <= minYear) {
          this._y = minYear;

          if (!isNaN(minMonth) && this._m < minMonth) {
            this._m = minMonth;
          }
        }

        if (this._y >= maxYear) {
          this._y = maxYear;

          if (!isNaN(maxMonth) && this._m > maxMonth) {
            this._m = maxMonth;
          }
        }

        randId = 'datepicker-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

        for (var c = 0; c < 1; c++) {
          this._renderDateDisplay();

          html += this.renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId);
        }

        this.destroySelects();
        this.calendarEl.innerHTML = html; // Init Materialize Select

        var yearSelect = this.calendarEl.querySelector('.six-storage-orig-select-year');
        var monthSelect = this.calendarEl.querySelector('.six-storage-orig-select-month');
        M.FormSelect.init(yearSelect, {
          classes: 'six-storage-select-year',
          dropdownOptions: {
            container: document.body,
            constrainWidth: false
          }
        });
        M.FormSelect.init(monthSelect, {
          classes: 'six-storage-select-month',
          dropdownOptions: {
            container: document.body,
            constrainWidth: false
          }
        }); // Add change handlers for select

        yearSelect.addEventListener('change', this._handleYearChange.bind(this));
        monthSelect.addEventListener('change', this._handleMonthChange.bind(this));

        if (typeof this.options.onDraw === 'function') {
          this.options.onDraw(this);
        }
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleInputChangeBound = this._handleInputChange.bind(this);
        this._handleCalendarClickBound = this._handleCalendarClick.bind(this);
        this._finishSelectionBound = this._finishSelection.bind(this);
        this._handleMonthChange = this._handleMonthChange.bind(this);
        this._closeBound = this.close.bind(this);
        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('change', this._handleInputChangeBound);
        this.calendarEl.addEventListener('click', this._handleCalendarClickBound);
        this.doneBtn.addEventListener('click', this._finishSelectionBound);
        this.cancelBtn.addEventListener('click', this._closeBound);

        if (this.options.showClearBtn) {
          this._handleClearClickBound = this._handleClearClick.bind(this);
          this.clearBtn.addEventListener('click', this._handleClearClickBound);
        }
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        var _this56 = this;

        this.$modalEl = $(Datepicker._template);
        this.modalEl = this.$modalEl[0];
        this.calendarEl = this.modalEl.querySelector('.six-storage-datepicker-calendar');
        this.yearTextEl = this.modalEl.querySelector('.six-storage-year-text');
        this.dateTextEl = this.modalEl.querySelector('.six-storage-date-text');

        if (this.options.showClearBtn) {
          this.clearBtn = this.modalEl.querySelector('.six-storage-datepicker-clear');
        }

        this.doneBtn = this.modalEl.querySelector('.six-storage-datepicker-done');
        this.cancelBtn = this.modalEl.querySelector('.six-storage-datepicker-cancel');
        this.formats = {
          d: function d() {
            return _this56.date.getDate();
          },
          dd: function dd() {
            var d = _this56.date.getDate();

            return (d < 10 ? '0' : '') + d;
          },
          ddd: function ddd() {
            return _this56.options.i18n.weekdaysShort[_this56.date.getDay()];
          },
          dddd: function dddd() {
            return _this56.options.i18n.weekdays[_this56.date.getDay()];
          },
          m: function m() {
            return _this56.date.getMonth() + 1;
          },
          mm: function mm() {
            var m = _this56.date.getMonth() + 1;
            return (m < 10 ? '0' : '') + m;
          },
          mmm: function mmm() {
            return _this56.options.i18n.monthsShort[_this56.date.getMonth()];
          },
          mmmm: function mmmm() {
            return _this56.options.i18n.months[_this56.date.getMonth()];
          },
          yy: function yy() {
            return ('' + _this56.date.getFullYear()).slice(2);
          },
          yyyy: function yyyy() {
            return _this56.date.getFullYear();
          }
        };
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('change', this._handleInputChangeBound);
        this.calendarEl.removeEventListener('click', this._handleCalendarClickBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleCalendarClick",
      value: function _handleCalendarClick(e) {
        if (!this.isOpen) {
          return;
        }

        var $target = $(e.target);

        if (!$target.hasClass('six-storage-is-disabled')) {
          if ($target.hasClass('six-storage-datepicker-day-button') && !$target.hasClass('six-storage-is-empty') && !$target.parent().hasClass('six-storage-is-disabled')) {
            this.setDate(new Date(e.target.getAttribute('data-year'), e.target.getAttribute('data-month'), e.target.getAttribute('data-day')));

            if (this.options.autoClose) {
              this._finishSelection();
            }
          } else if ($target.closest('.six-storage-month-prev').length) {
            this.prevMonth();
          } else if ($target.closest('.six-storage-month-next').length) {
            this.nextMonth();
          }
        }
      }
    }, {
      key: "_handleClearClick",
      value: function _handleClearClick() {
        this.date = null;
        this.setInputValue();
        this.close();
      }
    }, {
      key: "_handleMonthChange",
      value: function _handleMonthChange(e) {
        this.gotoMonth(e.target.value);
      }
    }, {
      key: "_handleYearChange",
      value: function _handleYearChange(e) {
        this.gotoYear(e.target.value);
      }
      /**
       * change view to a specific month (zero-index, e.g. 0: January)
       */

    }, {
      key: "gotoMonth",
      value: function gotoMonth(month) {
        if (!isNaN(month)) {
          this.calendars[0].month = parseInt(month, 10);
          this.adjustCalendars();
        }
      }
      /**
       * change view to a specific full year (e.g. "2012")
       */

    }, {
      key: "gotoYear",
      value: function gotoYear(year) {
        if (!isNaN(year)) {
          this.calendars[0].year = parseInt(year, 10);
          this.adjustCalendars();
        }
      }
    }, {
      key: "_handleInputChange",
      value: function _handleInputChange(e) {
        var date = void 0; // Prevent change event from being fired when triggered by the plugin

        if (e.firedBy === this) {
          return;
        }

        if (this.options.parse) {
          date = this.options.parse(this.el.value, this.options.format);
        } else {
          date = new Date(Date.parse(this.el.value));
        }

        if (Datepicker._isDate(date)) {
          this.setDate(date);
        }
      }
    }, {
      key: "renderDayName",
      value: function renderDayName(opts, day, abbr) {
        day += opts.firstDay;

        while (day >= 7) {
          day -= 7;
        }

        return abbr ? opts.i18n.weekdaysAbbrev[day] : opts.i18n.weekdays[day];
      }
      /**
       * Set input value to the selected date and close Datepicker
       */

    }, {
      key: "_finishSelection",
      value: function _finishSelection() {
        this.setInputValue();
        this.close();
      }
      /**
       * Open Datepicker
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;

        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this);
        }

        this.draw();
        this.modal.open();
        return this;
      }
      /**
       * Close Datepicker
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;

        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this);
        }

        this.modal.close();
        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Datepicker.__proto__ || Object.getPrototypeOf(Datepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_isDate",
      value: function _isDate(obj) {
        return /Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
      }
    }, {
      key: "_isWeekend",
      value: function _isWeekend(date) {
        var day = date.getDay();
        return day === 0 || day === 6;
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }
    }, {
      key: "_getDaysInMonth",
      value: function _getDaysInMonth(year, month) {
        return [31, Datepicker._isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
      }
    }, {
      key: "_isLeapYear",
      value: function _isLeapYear(year) {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      }
    }, {
      key: "_compareDates",
      value: function _compareDates(a, b) {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Datepicker;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Datepicker;
  }(Component);

  Datepicker._template = ['<div class= "six-storage-modal six-storage-datepicker-modal">', '<div class="six-storage-modal-content six-storage-datepicker-container">', '<div class="six-storage-datepicker-date-display">', '<span class="six-storage-year-text"></span>', '<span class="six-storage-date-text"></span>', '</div>', '<div class="six-storage-datepicker-calendar-container">', '<div class="six-storage-datepicker-calendar"></div>', '<div class="six-storage-datepicker-footer">', '<button class="six-storage-btn-flat six-storage-datepicker-clear six-storage-waves-effect" style="visibility: hidden;" type="button"></button>', '<div class="six-storage-confirmation-btns">', '<button class="six-storage-btn-flat six-storage-datepicker-cancel six-storage-waves-effect" type="button"></button>', '<button class="six-storage-btn-flat six-storage-datepicker-done six-storage-waves-effect" type="button"></button>', '</div>', '</div>', '</div>', '</div>', '</div>'].join('');
  M.Datepicker = Datepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Datepicker, 'datepicker', 'M_Datepicker');
  }
})(cash);

;

(function ($) {
  'use strict';

  var _defaults = {
    dialRadius: 135,
    outerRadius: 105,
    innerRadius: 70,
    tickRadius: 20,
    duration: 350,
    container: null,
    defaultTime: 'now',
    // default time, 'now' or '13:14' e.g.
    fromNow: 0,
    // Millisecond offset from the defaultTime
    showClearBtn: false,
    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok'
    },
    autoClose: false,
    // auto close when minute is selected
    twelveHour: true,
    // change to 12 hour AM/PM clock from 24 hour
    vibrate: true,
    // vibrate the device when dragging clock hand
    // Callbacks
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onSelect: null
  };
  /**
   * @class
   *
   */

  var Timepicker = function (_Component16) {
    _inherits(Timepicker, _Component16);

    function Timepicker(el, options) {
      _classCallCheck(this, Timepicker);

      var _this57 = _possibleConstructorReturn(this, (Timepicker.__proto__ || Object.getPrototypeOf(Timepicker)).call(this, Timepicker, el, options));

      _this57.el.M_Timepicker = _this57;
      _this57.options = $.extend({}, Timepicker.defaults, options);
      _this57.id = M.guid();

      _this57._insertHTMLIntoDOM();

      _this57._setupModal();

      _this57._setupVariables();

      _this57._setupEventHandlers();

      _this57._clockSetup();

      _this57._pickerSetup();

      return _this57;
    }

    _createClass(Timepicker, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.modal.destroy();
        $(this.modalEl).remove();
        this.el.M_Timepicker = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleClockClickStartBound = this._handleClockClickStart.bind(this);
        this._handleDocumentClickMoveBound = this._handleDocumentClickMove.bind(this);
        this._handleDocumentClickEndBound = this._handleDocumentClickEnd.bind(this);
        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.plate.addEventListener('mousedown', this._handleClockClickStartBound);
        this.plate.addEventListener('touchstart', this._handleClockClickStartBound);
        $(this.spanHours).on('click', this.showView.bind(this, 'hours'));
        $(this.spanMinutes).on('click', this.showView.bind(this, 'minutes'));
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleClockClickStart",
      value: function _handleClockClickStart(e) {
        e.preventDefault();
        var clockPlateBR = this.plate.getBoundingClientRect();
        var offset = {
          x: clockPlateBR.left,
          y: clockPlateBR.top
        };
        this.x0 = offset.x + this.options.dialRadius;
        this.y0 = offset.y + this.options.dialRadius;
        this.moved = false;

        var clickPos = Timepicker._Pos(e);

        this.dx = clickPos.x - this.x0;
        this.dy = clickPos.y - this.y0; // Set clock hands

        this.setHand(this.dx, this.dy, false); // Mousemove on document

        document.addEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.addEventListener('touchmove', this._handleDocumentClickMoveBound); // Mouseup on document

        document.addEventListener('mouseup', this._handleDocumentClickEndBound);
        document.addEventListener('touchend', this._handleDocumentClickEndBound);
      }
    }, {
      key: "_handleDocumentClickMove",
      value: function _handleDocumentClickMove(e) {
        e.preventDefault();

        var clickPos = Timepicker._Pos(e);

        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;
        this.moved = true;
        this.setHand(x, y, false, true);
      }
    }, {
      key: "_handleDocumentClickEnd",
      value: function _handleDocumentClickEnd(e) {
        var _this58 = this;

        e.preventDefault();
        document.removeEventListener('mouseup', this._handleDocumentClickEndBound);
        document.removeEventListener('touchend', this._handleDocumentClickEndBound);

        var clickPos = Timepicker._Pos(e);

        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;

        if (this.moved && x === this.dx && y === this.dy) {
          this.setHand(x, y);
        }

        if (this.currentView === 'hours') {
          this.showView('minutes', this.options.duration / 2);
        } else if (this.options.autoClose) {
          $(this.minutesView).addClass('six-storage-timepicker-dial-out');
          setTimeout(function () {
            _this58.done();
          }, this.options.duration / 2);
        }

        if (typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.hours, this.minutes);
        } // Unbind mousemove event


        document.removeEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.removeEventListener('touchmove', this._handleDocumentClickMoveBound);
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        this.$modalEl = $(Timepicker._template);
        this.modalEl = this.$modalEl[0];
        this.modalEl.id = 'modal-' + this.id; // Append popover to input by default

        var containerEl = document.querySelector(this.options.container);

        if (this.options.container && !!containerEl) {
          this.$modalEl.appendTo(containerEl);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this59 = this;

        this.modal = M.Modal.init(this.modalEl, {
          onOpenStart: this.options.onOpenStart,
          onOpenEnd: this.options.onOpenEnd,
          onCloseStart: this.options.onCloseStart,
          onCloseEnd: function onCloseEnd() {
            if (typeof _this59.options.onCloseEnd === 'function') {
              _this59.options.onCloseEnd.call(_this59);
            }

            _this59.isOpen = false;
          }
        });
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        this.currentView = 'hours';
        this.vibrate = navigator.vibrate ? 'vibrate' : navigator.webkitVibrate ? 'webkitVibrate' : null;
        this._canvas = this.modalEl.querySelector('.six-storage-timepicker-canvas');
        this.plate = this.modalEl.querySelector('.six-storage-timepicker-plate');
        this.hoursView = this.modalEl.querySelector('.six-storage-timepicker-hours');
        this.minutesView = this.modalEl.querySelector('.six-storage-timepicker-minutes');
        this.spanHours = this.modalEl.querySelector('.six-storage-timepicker-span-hours');
        this.spanMinutes = this.modalEl.querySelector('.six-storage-timepicker-span-minutes');
        this.spanAmPm = this.modalEl.querySelector('.six-storage-timepicker-span-am-pm');
        this.footer = this.modalEl.querySelector('.six-storage-timepicker-footer');
        this.amOrPm = 'PM';
      }
    }, {
      key: "_pickerSetup",
      value: function _pickerSetup() {
        var $clearBtn = $("<button class=\"six-storage-btn-flat timepicker-clear six-storage-waves-effect\" style=\"visibility: hidden;\" type=\"button\" tabindex=\"" + (this.options.twelveHour ? '3' : '1') + "\">" + this.options.i18n.clear + "</button>").appendTo(this.footer).on('click', this.clear.bind(this));

        if (this.options.showClearBtn) {
          $clearBtn.css({
            visibility: ''
          });
        }

        var confirmationBtnsContainer = $('<div class="six-storage-confirmation-btns"></div>');
        $('<button class="six-storage-btn-flat six-storage-timepicker-close six-storage-waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.cancel + '</button>').appendTo(confirmationBtnsContainer).on('click', this.close.bind(this));
        $('<button class="six-storage-btn-flat six-storage-timepicker-close six-storage-waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.done + '</button>').appendTo(confirmationBtnsContainer).on('click', this.done.bind(this));
        confirmationBtnsContainer.appendTo(this.footer);
      }
    }, {
      key: "_clockSetup",
      value: function _clockSetup() {
        if (this.options.twelveHour) {
          this.$amBtn = $('<div class="am-btn">AM</div>');
          this.$pmBtn = $('<div class="pm-btn">PM</div>');
          this.$amBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
          this.$pmBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
        }

        this._buildHoursView();

        this._buildMinutesView();

        this._buildSVGClock();
      }
    }, {
      key: "_buildSVGClock",
      value: function _buildSVGClock() {
        // Draw clock hands and others
        var dialRadius = this.options.dialRadius;
        var tickRadius = this.options.tickRadius;
        var diameter = dialRadius * 2;

        var svg = Timepicker._createSVGEl('svg');

        svg.setAttribute('class', 'timepicker-svg');
        svg.setAttribute('width', diameter);
        svg.setAttribute('height', diameter);

        var g = Timepicker._createSVGEl('g');

        g.setAttribute('transform', 'translate(' + dialRadius + ',' + dialRadius + ')');

        var bearing = Timepicker._createSVGEl('circle');

        bearing.setAttribute('class', 'six-storage-timepicker-canvas-bearing');
        bearing.setAttribute('cx', 0);
        bearing.setAttribute('cy', 0);
        bearing.setAttribute('r', 4);

        var hand = Timepicker._createSVGEl('line');

        hand.setAttribute('x1', 0);
        hand.setAttribute('y1', 0);

        var bg = Timepicker._createSVGEl('circle');

        bg.setAttribute('class', 'six-storage-timepicker-canvas-bg');
        bg.setAttribute('r', tickRadius);
        g.appendChild(hand);
        g.appendChild(bg);
        g.appendChild(bearing);
        svg.appendChild(g);

        this._canvas.appendChild(svg);

        this.hand = hand;
        this.bg = bg;
        this.bearing = bearing;
        this.g = g;
      }
    }, {
      key: "_buildHoursView",
      value: function _buildHoursView() {
        var $tick = $('<div class="six-storage-timepicker-tick"></div>'); // Hours view

        if (this.options.twelveHour) {
          for (var i = 1; i < 13; i += 1) {
            var tick = $tick.clone();
            var radian = i / 6 * Math.PI;
            var radius = this.options.outerRadius;
            tick.css({
              left: this.options.dialRadius + Math.sin(radian) * radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(radian) * radius - this.options.tickRadius + 'px'
            });
            tick.html(i === 0 ? '00' : i);
            this.hoursView.appendChild(tick[0]); // tick.on(mousedownEvent, mousedown);
          }
        } else {
          for (var _i2 = 0; _i2 < 24; _i2 += 1) {
            var _tick = $tick.clone();

            var _radian = _i2 / 6 * Math.PI;

            var inner = _i2 > 0 && _i2 < 13;

            var _radius = inner ? this.options.innerRadius : this.options.outerRadius;

            _tick.css({
              left: this.options.dialRadius + Math.sin(_radian) * _radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(_radian) * _radius - this.options.tickRadius + 'px'
            });

            _tick.html(_i2 === 0 ? '00' : _i2);

            this.hoursView.appendChild(_tick[0]); // tick.on(mousedownEvent, mousedown);
          }
        }
      }
    }, {
      key: "_buildMinutesView",
      value: function _buildMinutesView() {
        var $tick = $('<div class="six-storage-timepicker-tick"></div>'); // Minutes view

        for (var i = 0; i < 60; i += 5) {
          var tick = $tick.clone();
          var radian = i / 30 * Math.PI;
          tick.css({
            left: this.options.dialRadius + Math.sin(radian) * this.options.outerRadius - this.options.tickRadius + 'px',
            top: this.options.dialRadius - Math.cos(radian) * this.options.outerRadius - this.options.tickRadius + 'px'
          });
          tick.html(Timepicker._addLeadingZero(i));
          this.minutesView.appendChild(tick[0]);
        }
      }
    }, {
      key: "_handleAmPmClick",
      value: function _handleAmPmClick(e) {
        var $btnClicked = $(e.target);
        this.amOrPm = $btnClicked.hasClass('am-btn') ? 'AM' : 'PM';

        this._updateAmPmView();
      }
    }, {
      key: "_updateAmPmView",
      value: function _updateAmPmView() {
        if (this.options.twelveHour) {
          this.$amBtn.toggleClass('six-storage-text-primary', this.amOrPm === 'AM');
          this.$pmBtn.toggleClass('six-storage-text-primary', this.amOrPm === 'PM');
        }
      }
    }, {
      key: "_updateTimeFromInput",
      value: function _updateTimeFromInput() {
        // Get the time
        var value = ((this.el.value || this.options.defaultTime || '') + '').split(':');

        if (this.options.twelveHour && !(typeof value[1] === 'undefined')) {
          if (value[1].toUpperCase().indexOf('AM') > 0) {
            this.amOrPm = 'AM';
          } else {
            this.amOrPm = 'PM';
          }

          value[1] = value[1].replace('AM', '').replace('PM', '');
        }

        if (value[0] === 'now') {
          var now = new Date(+new Date() + this.options.fromNow);
          value = [now.getHours(), now.getMinutes()];

          if (this.options.twelveHour) {
            this.amOrPm = value[0] >= 12 && value[0] < 24 ? 'PM' : 'AM';
          }
        }

        this.hours = +value[0] || 0;
        this.minutes = +value[1] || 0;
        this.spanHours.innerHTML = this.hours;
        this.spanMinutes.innerHTML = Timepicker._addLeadingZero(this.minutes);

        this._updateAmPmView();
      }
    }, {
      key: "showView",
      value: function showView(view, delay) {
        if (view === 'minutes' && $(this.hoursView).css('visibility') === 'visible') {// raiseCallback(this.options.beforeHourSelect);
        }

        var isHours = view === 'hours',
            nextView = isHours ? this.hoursView : this.minutesView,
            hideView = isHours ? this.minutesView : this.hoursView;
        this.currentView = view;
        $(this.spanHours).toggleClass('six-storage-text-primary', isHours);
        $(this.spanMinutes).toggleClass('six-storage-text-primary', !isHours); // Transition view

        hideView.classList.add('six-storage-timepicker-dial-out');
        $(nextView).css('visibility', 'visible').removeClass('six-storage-timepicker-dial-out'); // Reset clock hand

        this.resetClock(delay); // After transitions ended

        clearTimeout(this.toggleViewTimer);
        this.toggleViewTimer = setTimeout(function () {
          $(hideView).css('visibility', 'hidden');
        }, this.options.duration);
      }
    }, {
      key: "resetClock",
      value: function resetClock(delay) {
        var view = this.currentView,
            value = this[view],
            isHours = view === 'hours',
            unit = Math.PI / (isHours ? 6 : 30),
            radian = value * unit,
            radius = isHours && value > 0 && value < 13 ? this.options.innerRadius : this.options.outerRadius,
            x = Math.sin(radian) * radius,
            y = -Math.cos(radian) * radius,
            self = this;

        if (delay) {
          $(this.canvas).addClass('six-storage-timepicker-canvas-out');
          setTimeout(function () {
            $(self.canvas).removeClass('six-storage-timepicker-canvas-out');
            self.setHand(x, y);
          }, delay);
        } else {
          this.setHand(x, y);
        }
      }
    }, {
      key: "setHand",
      value: function setHand(x, y, roundBy5) {
        var _this60 = this;

        var radian = Math.atan2(x, -y),
            isHours = this.currentView === 'hours',
            unit = Math.PI / (isHours || roundBy5 ? 6 : 30),
            z = Math.sqrt(x * x + y * y),
            inner = isHours && z < (this.options.outerRadius + this.options.innerRadius) / 2,
            radius = inner ? this.options.innerRadius : this.options.outerRadius;

        if (this.options.twelveHour) {
          radius = this.options.outerRadius;
        } // Radian should in range [0, 2PI]


        if (radian < 0) {
          radian = Math.PI * 2 + radian;
        } // Get the round value


        var value = Math.round(radian / unit); // Get the round radian

        radian = value * unit; // Correct the hours or minutes

        if (this.options.twelveHour) {
          if (isHours) {
            if (value === 0) value = 12;
          } else {
            if (roundBy5) value *= 5;
            if (value === 60) value = 0;
          }
        } else {
          if (isHours) {
            if (value === 12) {
              value = 0;
            }

            value = inner ? value === 0 ? 12 : value : value === 0 ? 0 : value + 12;
          } else {
            if (roundBy5) {
              value *= 5;
            }

            if (value === 60) {
              value = 0;
            }
          }
        } // Once hours or minutes changed, vibrate the device


        if (this[this.currentView] !== value) {
          if (this.vibrate && this.options.vibrate) {
            // Do not vibrate too frequently
            if (!this.vibrateTimer) {
              navigator[this.vibrate](10);
              this.vibrateTimer = setTimeout(function () {
                _this60.vibrateTimer = null;
              }, 100);
            }
          }
        }

        this[this.currentView] = value;

        if (isHours) {
          this['spanHours'].innerHTML = value;
        } else {
          this['spanMinutes'].innerHTML = Timepicker._addLeadingZero(value);
        } // Set clock hand and others' position


        var cx1 = Math.sin(radian) * (radius - this.options.tickRadius),
            cy1 = -Math.cos(radian) * (radius - this.options.tickRadius),
            cx2 = Math.sin(radian) * radius,
            cy2 = -Math.cos(radian) * radius;
        this.hand.setAttribute('x2', cx1);
        this.hand.setAttribute('y2', cy1);
        this.bg.setAttribute('cx', cx2);
        this.bg.setAttribute('cy', cy2);
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;

        this._updateTimeFromInput();

        this.showView('hours');
        this.modal.open();
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        this.modal.close();
      }
      /**
       * Finish timepicker selection.
       */

    }, {
      key: "done",
      value: function done(e, clearValue) {
        // Set input value
        var last = this.el.value;
        var value = clearValue ? '' : Timepicker._addLeadingZero(this.hours) + ':' + Timepicker._addLeadingZero(this.minutes);
        this.time = value;

        if (!clearValue && this.options.twelveHour) {
          value = value + " " + this.amOrPm;
        }

        this.el.value = value; // Trigger change event

        if (value !== last) {
          this.$el.trigger('change');
        }

        this.close();
        this.el.focus();
      }
    }, {
      key: "clear",
      value: function clear() {
        this.done(null, true);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Timepicker.__proto__ || Object.getPrototypeOf(Timepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_addLeadingZero",
      value: function _addLeadingZero(num) {
        return (num < 10 ? '0' : '') + num;
      }
    }, {
      key: "_createSVGEl",
      value: function _createSVGEl(name) {
        var svgNS = 'http://www.w3.org/2000/svg';
        return document.createElementNS(svgNS, name);
      }
      /**
       * @typedef {Object} Point
       * @property {number} x The X Coordinate
       * @property {number} y The Y Coordinate
       */

      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       * @return {Point} x and y location
       */

    }, {
      key: "_Pos",
      value: function _Pos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return {
            x: e.targetTouches[0].clientX,
            y: e.targetTouches[0].clientY
          };
        } // mouse event


        return {
          x: e.clientX,
          y: e.clientY
        };
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Timepicker;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Timepicker;
  }(Component);

  Timepicker._template = ['<div class= "six-storage-modal six-storage-timepicker-modal">', '<div class="six-storage-modal-content six-storage-timepicker-container">', '<div class="six-storage-timepicker-digital-display">', '<div class="six-storage-timepicker-text-container">', '<div class="six-storage-timepicker-display-column">', '<span class="six-storage-timepicker-span-hours six-storage-text-primary"></span>', ':', '<span class="six-storage-timepicker-span-minutes"></span>', '</div>', '<div class="six-storage-timepicker-display-column six-storage-timepicker-display-am-pm">', '<div class="six-storage-timepicker-span-am-pm"></div>', '</div>', '</div>', '</div>', '<div class="six-storage-timepicker-analog-display">', '<div class="six-storage-timepicker-plate">', '<div class="six-storage-timepicker-canvas"></div>', '<div class="six-storage-timepicker-dial six-storage-timepicker-hours"></div>', '<div class="six-storage-timepicker-dial six-storage-timepicker-minutes six-storage-timepicker-dial-out"></div>', '</div>', '<div class="six-storage-timepicker-footer"></div>', '</div>', '</div>', '</div>'].join('');
  M.Timepicker = Timepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Timepicker, 'timepicker', 'M_Timepicker');
  }
})(cash);

;

(function ($) {
  'use strict';

  var _defaults = {};
  /**
   * @class
   *
   */

  var CharacterCounter = function (_Component17) {
    _inherits(CharacterCounter, _Component17);
    /**
     * Construct CharacterCounter instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function CharacterCounter(el, options) {
      _classCallCheck(this, CharacterCounter);

      var _this61 = _possibleConstructorReturn(this, (CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter)).call(this, CharacterCounter, el, options));

      _this61.el.M_CharacterCounter = _this61;
      /**
       * Options for the character counter
       */

      _this61.options = $.extend({}, CharacterCounter.defaults, options);
      _this61.isInvalid = false;
      _this61.isValidLength = false;

      _this61._setupCounter();

      _this61._setupEventHandlers();

      return _this61;
    }

    _createClass(CharacterCounter, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.el.CharacterCounter = undefined;

        this._removeCounter();
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleUpdateCounterBound = this.updateCounter.bind(this);
        this.el.addEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.addEventListener('input', this._handleUpdateCounterBound, true);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.removeEventListener('input', this._handleUpdateCounterBound, true);
      }
      /**
       * Setup counter element
       */

    }, {
      key: "_setupCounter",
      value: function _setupCounter() {
        this.counterEl = document.createElement('span');
        $(this.counterEl).addClass('six-storage-character-counter').css({
          "float": 'right',
          'font-size': '12px',
          height: 1
        });
        this.$el.parent().append(this.counterEl);
      }
      /**
       * Remove counter element
       */

    }, {
      key: "_removeCounter",
      value: function _removeCounter() {
        $(this.counterEl).remove();
      }
      /**
       * Update counter
       */

    }, {
      key: "updateCounter",
      value: function updateCounter() {
        var maxLength = +this.$el.attr('data-length'),
            actualLength = this.el.value.length;
        this.isValidLength = actualLength <= maxLength;
        var counterString = actualLength;

        if (maxLength) {
          counterString += '/' + maxLength;

          this._validateInput();
        }

        $(this.counterEl).html(counterString);
      }
      /**
       * Add validation classes
       */

    }, {
      key: "_validateInput",
      value: function _validateInput() {
        if (this.isValidLength && this.isInvalid) {
          this.isInvalid = false;
          this.$el.removeClass('six-storage-invalid');
        } else if (!this.isValidLength && !this.isInvalid) {
          this.isInvalid = true;
          this.$el.removeClass('six-storage-valid');
          this.$el.addClass('six-storage-invalid');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_CharacterCounter;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return CharacterCounter;
  }(Component);

  M.CharacterCounter = CharacterCounter;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(CharacterCounter, 'characterCounter', 'M_CharacterCounter');
  }
})(cash);

;

(function ($) {
  'use strict';

  var _defaults = {
    duration: 200,
    // ms
    dist: -100,
    // zoom scale TODO: make this more intuitive as an option
    shift: 0,
    // spacing for center image
    padding: 0,
    // Padding between non center items
    numVisible: 5,
    // Number of visible items in carousel
    fullWidth: false,
    // Change to full width styles
    indicators: false,
    // Toggle indicators
    noWrap: false,
    // Don't wrap around and cycle through items.
    onCycleTo: null // Callback for when a new slide is cycled to.

  };
  /**
   * @class
   *
   */

  var Carousel = function (_Component18) {
    _inherits(Carousel, _Component18);
    /**
     * Construct Carousel instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Carousel(el, options) {
      _classCallCheck(this, Carousel);

      var _this62 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));

      _this62.el.M_Carousel = _this62;
      /**
       * Options for the carousel
       * @member Carousel#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {Number} shift
       * @prop {Number} padding
       * @prop {Number} numVisible
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */

      _this62.options = $.extend({}, Carousel.defaults, options); // Setup

      _this62.hasMultipleSlides = _this62.$el.find('.six-storage-carousel-item').length > 1;
      _this62.showIndicators = _this62.options.indicators && _this62.hasMultipleSlides;
      _this62.noWrap = _this62.options.noWrap || !_this62.hasMultipleSlides;
      _this62.pressed = false;
      _this62.dragged = false;
      _this62.offset = _this62.target = 0;
      _this62.images = [];
      _this62.itemWidth = _this62.$el.find('.six-storage-carousel-item').first().innerWidth();
      _this62.itemHeight = _this62.$el.find('.six-storage-carousel-item').first().innerHeight();
      _this62.dim = _this62.itemWidth * 2 + _this62.options.padding || 1; // Make sure dim is non zero for divisions.

      _this62._autoScrollBound = _this62._autoScroll.bind(_this62);
      _this62._trackBound = _this62._track.bind(_this62); // Full Width carousel setup

      if (_this62.options.fullWidth) {
        _this62.options.dist = 0;

        _this62._setCarouselHeight(); // Offset fixed items when indicators.


        if (_this62.showIndicators) {
          _this62.$el.find('.six-storage-carousel-fixed-item').addClass('six-storage-with-indicators');
        }
      } // Iterate through slides


      _this62.$indicators = $('<ul class="six-storage-indicators"></ul>');

      _this62.$el.find('.six-storage-carousel-item').each(function (el, i) {
        _this62.images.push(el);

        if (_this62.showIndicators) {
          var $indicator = $('<li class="six-storage-indicator-item"></li>'); // Add active to first by default.

          if (i === 0) {
            $indicator[0].classList.add('six-storage-active');
          }

          _this62.$indicators.append($indicator);
        }
      });

      if (_this62.showIndicators) {
        _this62.$el.append(_this62.$indicators);
      }

      _this62.count = _this62.images.length; // Cap numVisible at count

      _this62.options.numVisible = Math.min(_this62.count, _this62.options.numVisible); // Setup cross browser string

      _this62.xform = 'transform';
      ['webkit', 'Moz', 'O', 'ms'].every(function (prefix) {
        var e = prefix + 'Transform';

        if (typeof document.body.style[e] !== 'undefined') {
          _this62.xform = e;
          return false;
        }

        return true;
      });

      _this62._setupEventHandlers();

      _this62._scroll(_this62.offset);

      return _this62;
    }

    _createClass(Carousel, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.el.M_Carousel = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this63 = this;

        this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
        this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
        this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
        this._handleCarouselClickBound = this._handleCarouselClick.bind(this);

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.addEventListener('touchstart', this._handleCarouselTapBound);
          this.el.addEventListener('touchmove', this._handleCarouselDragBound);
          this.el.addEventListener('touchend', this._handleCarouselReleaseBound);
        }

        this.el.addEventListener('mousedown', this._handleCarouselTapBound);
        this.el.addEventListener('mousemove', this._handleCarouselDragBound);
        this.el.addEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.addEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.addEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
          this.$indicators.find('.six-storage-indicator-item').each(function (el, i) {
            el.addEventListener('click', _this63._handleIndicatorClickBound);
          });
        } // Resize


        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);
        window.addEventListener('resize', this._handleThrottledResizeBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this64 = this;

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.removeEventListener('touchstart', this._handleCarouselTapBound);
          this.el.removeEventListener('touchmove', this._handleCarouselDragBound);
          this.el.removeEventListener('touchend', this._handleCarouselReleaseBound);
        }

        this.el.removeEventListener('mousedown', this._handleCarouselTapBound);
        this.el.removeEventListener('mousemove', this._handleCarouselDragBound);
        this.el.removeEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.removeEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.removeEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this.$indicators.find('.six-storage-indicator-item').each(function (el, i) {
            el.removeEventListener('click', _this64._handleIndicatorClickBound);
          });
        }

        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }
      /**
       * Handle Carousel Tap
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselTap",
      value: function _handleCarouselTap(e) {
        // Fixes firefox draggable image bug
        if (e.type === 'mousedown' && $(e.target).is('img')) {
          e.preventDefault();
        }

        this.pressed = true;
        this.dragged = false;
        this.verticalDragged = false;
        this.reference = this._xpos(e);
        this.referenceY = this._ypos(e);
        this.velocity = this.amplitude = 0;
        this.frame = this.offset;
        this.timestamp = Date.now();
        clearInterval(this.ticker);
        this.ticker = setInterval(this._trackBound, 100);
      }
      /**
       * Handle Carousel Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselDrag",
      value: function _handleCarouselDrag(e) {
        var x = void 0,
            y = void 0,
            delta = void 0,
            deltaY = void 0;

        if (this.pressed) {
          x = this._xpos(e);
          y = this._ypos(e);
          delta = this.reference - x;
          deltaY = Math.abs(this.referenceY - y);

          if (deltaY < 30 && !this.verticalDragged) {
            // If vertical scrolling don't allow dragging.
            if (delta > 2 || delta < -2) {
              this.dragged = true;
              this.reference = x;

              this._scroll(this.offset + delta);
            }
          } else if (this.dragged) {
            // If dragging don't allow vertical scroll.
            e.preventDefault();
            e.stopPropagation();
            return false;
          } else {
            // Vertical scrolling.
            this.verticalDragged = true;
          }
        }

        if (this.dragged) {
          // If dragging don't allow vertical scroll.
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
      /**
       * Handle Carousel Release
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselRelease",
      value: function _handleCarouselRelease(e) {
        if (this.pressed) {
          this.pressed = false;
        } else {
          return;
        }

        clearInterval(this.ticker);
        this.target = this.offset;

        if (this.velocity > 10 || this.velocity < -10) {
          this.amplitude = 0.9 * this.velocity;
          this.target = this.offset + this.amplitude;
        }

        this.target = Math.round(this.target / this.dim) * this.dim; // No wrap of items.

        if (this.noWrap) {
          if (this.target >= this.dim * (this.count - 1)) {
            this.target = this.dim * (this.count - 1);
          } else if (this.target < 0) {
            this.target = 0;
          }
        }

        this.amplitude = this.target - this.offset;
        this.timestamp = Date.now();
        requestAnimationFrame(this._autoScrollBound);

        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
        }

        return false;
      }
      /**
       * Handle Carousel CLick
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselClick",
      value: function _handleCarouselClick(e) {
        // Disable clicks if carousel was dragged.
        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        } else if (!this.options.fullWidth) {
          var clickedIndex = $(e.target).closest('.six-storage-carousel-item').index();
          var diff = this._wrap(this.center) - clickedIndex; // Disable clicks if carousel was shifted by click

          if (diff !== 0) {
            e.preventDefault();
            e.stopPropagation();
          }

          this._cycleTo(clickedIndex);
        }
      }
      /**
       * Handle Indicator CLick
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        e.stopPropagation();
        var indicator = $(e.target).closest('.six-storage-indicator-item');

        if (indicator.length) {
          this._cycleTo(indicator.index());
        }
      }
      /**
       * Handle Throttle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        if (this.options.fullWidth) {
          this.itemWidth = this.$el.find('.six-storage-carousel-item').first().innerWidth();
          this.imageHeight = this.$el.find('.six-storage-carousel-item.six-storage-active').height();
          this.dim = this.itemWidth * 2 + this.options.padding;
          this.offset = this.center * 2 * this.itemWidth;
          this.target = this.offset;

          this._setCarouselHeight(true);
        } else {
          this._scroll();
        }
      }
      /**
       * Set carousel height based on first slide
       * @param {Booleam} imageOnly - true for image slides
       */

    }, {
      key: "_setCarouselHeight",
      value: function _setCarouselHeight(imageOnly) {
        var _this65 = this;

        var firstSlide = this.$el.find('.six-storage-carousel-item.six-storage-active').length ? this.$el.find('.six-storage-carousel-item.six-storage-active').first() : this.$el.find('.six-storage-carousel-item').first();
        var firstImage = firstSlide.find('img').first();

        if (firstImage.length) {
          if (firstImage[0].complete) {
            // If image won't trigger the load event
            var imageHeight = firstImage.height();

            if (imageHeight > 0) {
              this.$el.css('height', imageHeight + 'px');
            } else {
              // If image still has no height, use the natural dimensions to calculate
              var naturalWidth = firstImage[0].naturalWidth;
              var naturalHeight = firstImage[0].naturalHeight;
              var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
              this.$el.css('height', adjustedHeight + 'px');
            }
          } else {
            // Get height when image is loaded normally
            firstImage.one('load', function (el, i) {
              _this65.$el.css('height', el.offsetHeight + 'px');
            });
          }
        } else if (!imageOnly) {
          var slideHeight = firstSlide.height();
          this.$el.css('height', slideHeight + 'px');
        }
      }
      /**
       * Get x position from event
       * @param {Event} e
       */

    }, {
      key: "_xpos",
      value: function _xpos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        } // mouse event


        return e.clientX;
      }
      /**
       * Get y position from event
       * @param {Event} e
       */

    }, {
      key: "_ypos",
      value: function _ypos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientY;
        } // mouse event


        return e.clientY;
      }
      /**
       * Wrap index
       * @param {Number} x
       */

    }, {
      key: "_wrap",
      value: function _wrap(x) {
        return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
      }
      /**
       * Tracks scrolling information
       */

    }, {
      key: "_track",
      value: function _track() {
        var now = void 0,
            elapsed = void 0,
            delta = void 0,
            v = void 0;
        now = Date.now();
        elapsed = now - this.timestamp;
        this.timestamp = now;
        delta = this.offset - this.frame;
        this.frame = this.offset;
        v = 1000 * delta / (1 + elapsed);
        this.velocity = 0.8 * v + 0.2 * this.velocity;
      }
      /**
       * Auto scrolls to nearest carousel item.
       */

    }, {
      key: "_autoScroll",
      value: function _autoScroll() {
        var elapsed = void 0,
            delta = void 0;

        if (this.amplitude) {
          elapsed = Date.now() - this.timestamp;
          delta = this.amplitude * Math.exp(-elapsed / this.options.duration);

          if (delta > 2 || delta < -2) {
            this._scroll(this.target - delta);

            requestAnimationFrame(this._autoScrollBound);
          } else {
            this._scroll(this.target);
          }
        }
      }
      /**
       * Scroll to target
       * @param {Number} x
       */

    }, {
      key: "_scroll",
      value: function _scroll(x) {
        var _this66 = this; // Track scrolling state


        if (!this.$el.hasClass('scrolling')) {
          this.el.classList.add('scrolling');
        }

        if (this.scrollingTimeout != null) {
          window.clearTimeout(this.scrollingTimeout);
        }

        this.scrollingTimeout = window.setTimeout(function () {
          _this66.$el.removeClass('scrolling');
        }, this.options.duration); // Start actual scroll

        var i = void 0,
            half = void 0,
            delta = void 0,
            dir = void 0,
            tween = void 0,
            el = void 0,
            alignment = void 0,
            zTranslation = void 0,
            tweenedOpacity = void 0,
            centerTweenedOpacity = void 0;
        var lastCenter = this.center;
        var numVisibleOffset = 1 / this.options.numVisible;
        this.offset = typeof x === 'number' ? x : this.offset;
        this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
        delta = this.offset - this.center * this.dim;
        dir = delta < 0 ? 1 : -1;
        tween = -dir * delta * 2 / this.dim;
        half = this.count >> 1;

        if (this.options.fullWidth) {
          alignment = 'translateX(0)';
          centerTweenedOpacity = 1;
        } else {
          alignment = 'translateX(' + (this.el.clientWidth - this.itemWidth) / 2 + 'px) ';
          alignment += 'translateY(' + (this.el.clientHeight - this.itemHeight) / 2 + 'px)';
          centerTweenedOpacity = 1 - numVisibleOffset * tween;
        } // Set indicator active


        if (this.showIndicators) {
          var diff = this.center % this.count;
          var activeIndicator = this.$indicators.find('.six-storage-indicator-item.six-storage-active');

          if (activeIndicator.index() !== diff) {
            activeIndicator.removeClass('six-storage-active');
            this.$indicators.find('.six-storage-indicator-item').eq(diff)[0].classList.add('six-storage-active');
          }
        } // center
        // Don't show wrapped items.


        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)]; // Add active class to center item.

          if (!$(el).hasClass('six-storage-active')) {
            this.$el.find('.six-storage-carousel-item').removeClass('six-storage-active');
            el.classList.add('six-storage-active');
          }

          var transformString = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween * i + "px) translateZ(" + this.options.dist * tween + "px)";

          this._updateItemStyle(el, centerTweenedOpacity, 0, transformString);
        }

        for (i = 1; i <= half; ++i) {
          // right side
          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 + tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
          } // Don't show wrapped items.


          if (!this.noWrap || this.center + i < this.count) {
            el = this.images[this._wrap(this.center + i)];

            var _transformString = alignment + " translateX(" + (this.options.shift + (this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";

            this._updateItemStyle(el, tweenedOpacity, -i, _transformString);
          } // left side


          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 - tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
          } // Don't show wrapped items.


          if (!this.noWrap || this.center - i >= 0) {
            el = this.images[this._wrap(this.center - i)];

            var _transformString2 = alignment + " translateX(" + (-this.options.shift + (-this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";

            this._updateItemStyle(el, tweenedOpacity, -i, _transformString2);
          }
        } // center
        // Don't show wrapped items.


        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)];

          var _transformString3 = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween + "px) translateZ(" + this.options.dist * tween + "px)";

          this._updateItemStyle(el, centerTweenedOpacity, 0, _transformString3);
        } // onCycleTo callback


        var $currItem = this.$el.find('.six-storage-carousel-item').eq(this._wrap(this.center));

        if (lastCenter !== this.center && typeof this.options.onCycleTo === 'function') {
          this.options.onCycleTo.call(this, $currItem[0], this.dragged);
        } // One time callback


        if (typeof this.oneTimeCallback === 'function') {
          this.oneTimeCallback.call(this, $currItem[0], this.dragged);
          this.oneTimeCallback = null;
        }
      }
      /**
       * Cycle to target
       * @param {Element} el
       * @param {Number} opacity
       * @param {Number} zIndex
       * @param {String} transform
       */

    }, {
      key: "_updateItemStyle",
      value: function _updateItemStyle(el, opacity, zIndex, transform) {
        el.style[this.xform] = transform;
        el.style.zIndex = zIndex;
        el.style.opacity = opacity;
        el.style.visibility = 'visible';
      }
      /**
       * Cycle to target
       * @param {Number} n
       * @param {Function} callback
       */

    }, {
      key: "_cycleTo",
      value: function _cycleTo(n, callback) {
        var diff = this.center % this.count - n; // Account for wraparound.

        if (!this.noWrap) {
          if (diff < 0) {
            if (Math.abs(diff + this.count) < Math.abs(diff)) {
              diff += this.count;
            }
          } else if (diff > 0) {
            if (Math.abs(diff - this.count) < diff) {
              diff -= this.count;
            }
          }
        }

        this.target = this.dim * Math.round(this.offset / this.dim); // Next

        if (diff < 0) {
          this.target += this.dim * Math.abs(diff); // Prev
        } else if (diff > 0) {
          this.target -= this.dim * diff;
        } // Set one time callback


        if (typeof callback === 'function') {
          this.oneTimeCallback = callback;
        } // Scroll


        if (this.offset !== this.target) {
          this.amplitude = this.target - this.offset;
          this.timestamp = Date.now();
          requestAnimationFrame(this._autoScrollBound);
        }
      }
      /**
       * Cycle to next item
       * @param {Number} [n]
       */

    }, {
      key: "next",
      value: function next(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center + n;

        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }

        this._cycleTo(index);
      }
      /**
       * Cycle to previous item
       * @param {Number} [n]
       */

    }, {
      key: "prev",
      value: function prev(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center - n;

        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }

        this._cycleTo(index);
      }
      /**
       * Cycle to nth item
       * @param {Number} [n]
       * @param {Function} callback
       */

    }, {
      key: "set",
      value: function set(n, callback) {
        if (n === undefined || isNaN(n)) {
          n = 0;
        }

        if (n > this.count || n < 0) {
          if (this.noWrap) {
            return;
          }

          n = this._wrap(n);
        }

        this._cycleTo(n, callback);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Carousel;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Carousel;
  }(Component);

  M.Carousel = Carousel;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Carousel, 'carousel', 'M_Carousel');
  }
})(cash);

;

(function ($) {
  'use strict';

  var _defaults = {
    onOpen: undefined,
    onClose: undefined
  };
  /**
   * @class
   *
   */

  var TapTarget = function (_Component19) {
    _inherits(TapTarget, _Component19);
    /**
     * Construct TapTarget instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function TapTarget(el, options) {
      _classCallCheck(this, TapTarget);

      var _this67 = _possibleConstructorReturn(this, (TapTarget.__proto__ || Object.getPrototypeOf(TapTarget)).call(this, TapTarget, el, options));

      _this67.el.M_TapTarget = _this67;
      /**
       * Options for the select
       * @member TapTarget#options
       * @prop {Function} onOpen - Callback function called when feature discovery is opened
       * @prop {Function} onClose - Callback function called when feature discovery is closed
       */

      _this67.options = $.extend({}, TapTarget.defaults, options);
      _this67.isOpen = false; // setup

      _this67.$origin = $('#' + _this67.$el.attr('data-target'));

      _this67._setup();

      _this67._calculatePositioning();

      _this67._setupEventHandlers();

      return _this67;
    }

    _createClass(TapTarget, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this.el.TapTarget = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
        this._handleTargetClickBound = this._handleTargetClick.bind(this);
        this._handleOriginClickBound = this._handleOriginClick.bind(this);
        this.el.addEventListener('click', this._handleTargetClickBound);
        this.originEl.addEventListener('click', this._handleOriginClickBound); // Resize

        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);
        window.addEventListener('resize', this._handleThrottledResizeBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleTargetClickBound);
        this.originEl.removeEventListener('click', this._handleOriginClickBound);
        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }
      /**
       * Handle Target Click
       * @param {Event} e
       */

    }, {
      key: "_handleTargetClick",
      value: function _handleTargetClick(e) {
        this.open();
      }
      /**
       * Handle Origin Click
       * @param {Event} e
       */

    }, {
      key: "_handleOriginClick",
      value: function _handleOriginClick(e) {
        this.close();
      }
      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        this._calculatePositioning();
      }
      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest('.six-storage-tap-target-wrapper').length) {
          this.close();
          e.preventDefault();
          e.stopPropagation();
        }
      }
      /**
       * Setup Tap Target
       */

    }, {
      key: "_setup",
      value: function _setup() {
        // Creating tap target
        this.wrapper = this.$el.parent()[0];
        this.waveEl = $(this.wrapper).find('.six-storage-tap-target-wave')[0];
        this.originEl = $(this.wrapper).find('.six-storage-tap-target-origin')[0];
        this.contentEl = this.$el.find('.six-storage-tap-target-content')[0]; // Creating wrapper

        if (!$(this.wrapper).hasClass('.six-storage-tap-target-wrapper')) {
          this.wrapper = document.createElement('div');
          this.wrapper.classList.add('six-storage-tap-target-wrapper');
          this.$el.before($(this.wrapper));
          this.wrapper.append(this.el);
        } // Creating content


        if (!this.contentEl) {
          this.contentEl = document.createElement('div');
          this.contentEl.classList.add('six-storage-tap-target-content');
          this.$el.append(this.contentEl);
        } // Creating foreground wave


        if (!this.waveEl) {
          this.waveEl = document.createElement('div');
          this.waveEl.classList.add('six-storage-tap-target-wave'); // Creating origin

          if (!this.originEl) {
            this.originEl = this.$origin.clone(true, true);
            this.originEl.addClass('six-storage-tap-target-origin');
            this.originEl.removeAttr('id');
            this.originEl.removeAttr('style');
            this.originEl = this.originEl[0];
            this.waveEl.append(this.originEl);
          }

          this.wrapper.append(this.waveEl);
        }
      }
      /**
       * Calculate positioning
       */

    }, {
      key: "_calculatePositioning",
      value: function _calculatePositioning() {
        // Element or parent is fixed position?
        var isFixed = this.$origin.css('position') === 'fixed';

        if (!isFixed) {
          var parents = this.$origin.parents();

          for (var i = 0; i < parents.length; i++) {
            isFixed = $(parents[i]).css('position') == 'fixed';

            if (isFixed) {
              break;
            }
          }
        } // Calculating origin


        var originWidth = this.$origin.outerWidth();
        var originHeight = this.$origin.outerHeight();
        var originTop = isFixed ? this.$origin.offset().top - M.getDocumentScrollTop() : this.$origin.offset().top;
        var originLeft = isFixed ? this.$origin.offset().left - M.getDocumentScrollLeft() : this.$origin.offset().left; // Calculating screen

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var centerX = windowWidth / 2;
        var centerY = windowHeight / 2;
        var isLeft = originLeft <= centerX;
        var isRight = originLeft > centerX;
        var isTop = originTop <= centerY;
        var isBottom = originTop > centerY;
        var isCenterX = originLeft >= windowWidth * 0.25 && originLeft <= windowWidth * 0.75; // Calculating tap target

        var tapTargetWidth = this.$el.outerWidth();
        var tapTargetHeight = this.$el.outerHeight();
        var tapTargetTop = originTop + originHeight / 2 - tapTargetHeight / 2;
        var tapTargetLeft = originLeft + originWidth / 2 - tapTargetWidth / 2;
        var tapTargetPosition = isFixed ? 'fixed' : 'absolute'; // Calculating content

        var tapTargetTextWidth = isCenterX ? tapTargetWidth : tapTargetWidth / 2 + originWidth;
        var tapTargetTextHeight = tapTargetHeight / 2;
        var tapTargetTextTop = isTop ? tapTargetHeight / 2 : 0;
        var tapTargetTextBottom = 0;
        var tapTargetTextLeft = isLeft && !isCenterX ? tapTargetWidth / 2 - originWidth : 0;
        var tapTargetTextRight = 0;
        var tapTargetTextPadding = originWidth;
        var tapTargetTextAlign = isBottom ? 'bottom' : 'top'; // Calculating wave

        var tapTargetWaveWidth = originWidth > originHeight ? originWidth * 2 : originWidth * 2;
        var tapTargetWaveHeight = tapTargetWaveWidth;
        var tapTargetWaveTop = tapTargetHeight / 2 - tapTargetWaveHeight / 2;
        var tapTargetWaveLeft = tapTargetWidth / 2 - tapTargetWaveWidth / 2; // Setting tap target

        var tapTargetWrapperCssObj = {};
        tapTargetWrapperCssObj.top = isTop ? tapTargetTop + 'px' : '';
        tapTargetWrapperCssObj.right = isRight ? windowWidth - tapTargetLeft - tapTargetWidth + 'px' : '';
        tapTargetWrapperCssObj.bottom = isBottom ? windowHeight - tapTargetTop - tapTargetHeight + 'px' : '';
        tapTargetWrapperCssObj.left = isLeft ? tapTargetLeft + 'px' : '';
        tapTargetWrapperCssObj.position = tapTargetPosition;
        $(this.wrapper).css(tapTargetWrapperCssObj); // Setting content

        $(this.contentEl).css({
          width: tapTargetTextWidth + 'px',
          height: tapTargetTextHeight + 'px',
          top: tapTargetTextTop + 'px',
          right: tapTargetTextRight + 'px',
          bottom: tapTargetTextBottom + 'px',
          left: tapTargetTextLeft + 'px',
          padding: tapTargetTextPadding + 'px',
          verticalAlign: tapTargetTextAlign
        }); // Setting wave

        $(this.waveEl).css({
          top: tapTargetWaveTop + 'px',
          left: tapTargetWaveLeft + 'px',
          width: tapTargetWaveWidth + 'px',
          height: tapTargetWaveHeight + 'px'
        });
      }
      /**
       * Open TapTarget
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        } // onOpen callback


        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this, this.$origin[0]);
        }

        this.isOpen = true;
        this.wrapper.classList.add('six-storage-open');
        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
      }
      /**
       * Close Tap Target
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        } // onClose callback


        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this, this.$origin[0]);
        }

        this.isOpen = false;
        this.wrapper.classList.remove('six-storage-open');
        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(TapTarget.__proto__ || Object.getPrototypeOf(TapTarget), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_TapTarget;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return TapTarget;
  }(Component);

  M.TapTarget = TapTarget;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(TapTarget, 'tapTarget', 'M_TapTarget');
  }
})(cash);

;

(function ($) {
  'use strict';

  var _defaults = {
    classes: '',
    dropdownOptions: {}
  };
  /**
   * @class
   *
   */

  var FormSelect = function (_Component20) {
    _inherits(FormSelect, _Component20);
    /**
     * Construct FormSelect instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function FormSelect(el, options) {
      _classCallCheck(this, FormSelect); // Don't init if browser default version


      var _this68 = _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).call(this, FormSelect, el, options));

      if (_this68.$el.hasClass('browser-default')) {
        return _possibleConstructorReturn(_this68);
      }

      _this68.el.M_FormSelect = _this68;
      /**
       * Options for the select
       * @member FormSelect#options
       */

      _this68.options = $.extend({}, FormSelect.defaults, options);
      _this68.isMultiple = _this68.$el.prop('multiple'); // Setup

      _this68.el.tabIndex = -1;
      _this68._keysSelected = {};
      _this68._valueDict = {}; // Maps key to original and generated option element.

      _this68._setupDropdown();

      _this68._setupEventHandlers();

      return _this68;
    }

    _createClass(FormSelect, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this._removeDropdown();

        this.el.M_FormSelect = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this69 = this;

        this._handleSelectChangeBound = this._handleSelectChange.bind(this);
        this._handleOptionClickBound = this._handleOptionClick.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.addEventListener('click', _this69._handleOptionClickBound);
        });
        this.el.addEventListener('change', this._handleSelectChangeBound);
        this.input.addEventListener('click', this._handleInputClickBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this70 = this;

        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.removeEventListener('click', _this70._handleOptionClickBound);
        });
        this.el.removeEventListener('change', this._handleSelectChangeBound);
        this.input.removeEventListener('click', this._handleInputClickBound);
      }
      /**
       * Handle Select Change
       * @param {Event} e
       */

    }, {
      key: "_handleSelectChange",
      value: function _handleSelectChange(e) {
        this._setValueToInput();
      }
      /**
       * Handle Option Click
       * @param {Event} e
       */

    }, {
      key: "_handleOptionClick",
      value: function _handleOptionClick(e) {
        e.preventDefault();
        var option = $(e.target).closest('li')[0];
        var key = option.id;

        if (!$(option).hasClass('six-storage-disabled') && !$(option).hasClass('optgroup') && key.length) {
          var selected = true;

          if (this.isMultiple) {
            // Deselect placeholder option if still selected.
            var placeholderOption = $(this.dropdownOptions).find('li.six-storage-disabled.six-storage-selected');

            if (placeholderOption.length) {
              placeholderOption.removeClass('six-storage-selected');
              placeholderOption.find('input[type="checkbox"]').prop('checked', false);

              this._toggleEntryFromArray(placeholderOption[0].id);
            }

            selected = this._toggleEntryFromArray(key);
          } else {
            $(this.dropdownOptions).find('li').removeClass('six-storage-selected');
            $(option).toggleClass('selected', selected);
          } // Set selected on original select option
          // Only trigger if selected state changed


          var prevSelected = $(this._valueDict[key].el).prop('selected');

          if (prevSelected !== selected) {
            $(this._valueDict[key].el).prop('selected', selected);
            this.$el.trigger('change');
          }
        }

        e.stopPropagation();
      }
      /**
       * Handle Input Click
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        if (this.dropdown && this.dropdown.isOpen) {
          this._setValueToInput();

          this._setSelectedStates();
        }
      }
      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this71 = this;

        this.wrapper = document.createElement('div');
        $(this.wrapper).addClass('six-storage-select-wrapper ' + this.options.classes);
        this.$el.before($(this.wrapper));
        this.wrapper.appendChild(this.el);

        if (this.el.disabled) {
          this.wrapper.classList.add('six-storage-disabled');
        } // Create dropdown


        this.$selectOptions = this.$el.children('option, optgroup');
        this.dropdownOptions = document.createElement('ul');
        this.dropdownOptions.id = "six-storage-select-options-" + M.guid();
        $(this.dropdownOptions).addClass('six-storage-dropdown-content six-storage-select-dropdown ' + (this.isMultiple ? 'six-storage-multiple-select-dropdown' : '')); // Create dropdown structure.

        if (this.$selectOptions.length) {
          this.$selectOptions.each(function (el) {
            if ($(el).is('option')) {
              // Direct descendant option.
              var optionEl = void 0;

              if (_this71.isMultiple) {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'multiple');
              } else {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el);
              }

              _this71._addOptionToValueDict(el, optionEl);
            } else if ($(el).is('optgroup')) {
              // Optgroup.
              var selectOptions = $(el).children('option');
              $(_this71.dropdownOptions).append($('<li class="optgroup"><span>' + el.getAttribute('label') + '</span></li>')[0]);
              selectOptions.each(function (el) {
                var optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'six-storage-optgroup-option');

                _this71._addOptionToValueDict(el, optionEl);
              });
            }
          });
        }

        this.$el.after(this.dropdownOptions); // Add input dropdown

        this.input = document.createElement('input');
        $(this.input).addClass('six-storage-select-dropdown six-storage-dropdown-trigger');
        this.input.setAttribute('type', 'text');
        this.input.setAttribute('readonly', 'true');
        this.input.setAttribute('data-target', this.dropdownOptions.id);

        if (this.el.disabled) {
          $(this.input).prop('disabled', 'true');
        }

        this.$el.before(this.input);

        this._setValueToInput(); // Add caret


        var dropdownIcon = $('<svg class="six-storage-caret" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
        this.$el.before(dropdownIcon[0]); // Initialize dropdown

        if (!this.el.disabled) {
          var dropdownOptions = $.extend({}, this.options.dropdownOptions); // Add callback for centering selected option when dropdown content is scrollable

          dropdownOptions.onOpenEnd = function (el) {
            var selectedOption = $(_this71.dropdownOptions).find('.six-storage-selected').first();

            if (selectedOption.length) {
              // Focus selected option in dropdown
              M.keyDown = true;
              _this71.dropdown.focusedIndex = selectedOption.index();

              _this71.dropdown._focusFocusedItem();

              M.keyDown = false; // Handle scrolling to selected option

              if (_this71.dropdown.isScrollable) {
                var scrollOffset = selectedOption[0].getBoundingClientRect().top - _this71.dropdownOptions.getBoundingClientRect().top; // scroll to selected option


                scrollOffset -= _this71.dropdownOptions.clientHeight / 2; // center in dropdown

                _this71.dropdownOptions.scrollTop = scrollOffset;
              }
            }
          };

          if (this.isMultiple) {
            dropdownOptions.closeOnClick = false;
          }

          this.dropdown = M.Dropdown.init(this.input, dropdownOptions);
        } // Add initial selections


        this._setSelectedStates();
      }
      /**
       * Add option to value dict
       * @param {Element} el  original option element
       * @param {Element} optionEl  generated option element
       */

    }, {
      key: "_addOptionToValueDict",
      value: function _addOptionToValueDict(el, optionEl) {
        var index = Object.keys(this._valueDict).length;
        var key = this.dropdownOptions.id + index;
        var obj = {};
        optionEl.id = key;
        obj.el = el;
        obj.optionEl = optionEl;
        this._valueDict[key] = obj;
      }
      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        $(this.wrapper).find('.six-storage-caret').remove();
        $(this.input).remove();
        $(this.dropdownOptions).remove();
        $(this.wrapper).before(this.$el);
        $(this.wrapper).remove();
      }
      /**
       * Setup dropdown
       * @param {Element} select  select element
       * @param {Element} option  option element from select
       * @param {String} type
       * @return {Element}  option element added
       */

    }, {
      key: "_appendOptionWithIcon",
      value: function _appendOptionWithIcon(select, option, type) {
        // Add disabled attr if disabled
        var setdisabledAttribute = option.disabled ? 'disabled ' : '';
        var disabledClass = option.disabled ? 'six-storage-disabled ' : '';
        var optgroupClass = type === 'optgroup-option' ? 'six-storage-optgroup-option ' : '';
        var multipleCheckbox = this.isMultiple ? "<label><input type=\"checkbox\"" + setdisabledAttribute + "\"/><span>" + option.innerHTML + "</span></label>" : option.innerHTML;
        var liEl = $('<li></li>');
        var spanEl = $('<span></span>');
        spanEl.html(multipleCheckbox);
        liEl.addClass(disabledClass + " " + optgroupClass);
        liEl.append(spanEl); // add icons

        var iconUrl = option.getAttribute('data-icon');

        if (!!iconUrl) {
          var imgEl = $("<img alt=\"\" src=\"" + iconUrl + "\">");
          liEl.prepend(imgEl);
        } // Check for multiple type.


        $(this.dropdownOptions).append(liEl[0]);
        return liEl[0];
      }
      /**
       * Toggle entry from option
       * @param {String} key  Option key
       * @return {Boolean}  if entry was added or removed
       */

    }, {
      key: "_toggleEntryFromArray",
      value: function _toggleEntryFromArray(key) {
        var notAdded = !this._keysSelected.hasOwnProperty(key);
        var $optionLi = $(this._valueDict[key].optionEl);

        if (notAdded) {
          this._keysSelected[key] = true;
        } else {
          delete this._keysSelected[key];
        }

        $optionLi.toggleClass('selected', notAdded); // Set checkbox checked value

        $optionLi.find('input[type="checkbox"]').prop('checked', notAdded); // use notAdded instead of true (to detect if the option is selected or not)

        $optionLi.prop('selected', notAdded);
        return notAdded;
      }
      /**
       * Set text value to input
       */

    }, {
      key: "_setValueToInput",
      value: function _setValueToInput() {
        var values = [];
        var options = this.$el.find('option');
        options.each(function (el) {
          if ($(el).prop('selected')) {
            var text = $(el).text();
            values.push(text);
          }
        });

        if (!values.length) {
          var firstDisabled = this.$el.find('option:disabled').eq(0);

          if (firstDisabled.length && firstDisabled[0].value === '') {
            values.push(firstDisabled.text());
          }
        }

        this.input.value = values.join(', ');
      }
      /**
       * Set selected state of dropdown to match actual select element
       */

    }, {
      key: "_setSelectedStates",
      value: function _setSelectedStates() {
        this._keysSelected = {};

        for (var key in this._valueDict) {
          var option = this._valueDict[key];
          var optionIsSelected = $(option.el).prop('selected');
          $(option.optionEl).find('input[type="checkbox"]').prop('checked', optionIsSelected);

          if (optionIsSelected) {
            this._activateOption($(this.dropdownOptions), $(option.optionEl));

            this._keysSelected[key] = true;
          } else {
            $(option.optionEl).removeClass('six-storage-selected');
          }
        }
      }
      /**
       * Make option as selected and scroll to selected position
       * @param {jQuery} collection  Select options jQuery element
       * @param {Element} newOption  element of the new option
       */

    }, {
      key: "_activateOption",
      value: function _activateOption(collection, newOption) {
        if (newOption) {
          if (!this.isMultiple) {
            collection.find('li.six-storage-selected').removeClass('six-storage-selected');
          }

          var option = $(newOption);
          option.addClass('six-storage-selected');
        }
      }
      /**
       * Get Selected Values
       * @return {Array}  Array of selected values
       */

    }, {
      key: "getSelectedValues",
      value: function getSelectedValues() {
        var selectedValues = [];

        for (var key in this._keysSelected) {
          selectedValues.push(this._valueDict[key].el.value);
        }

        return selectedValues;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FormSelect.__proto__ || Object.getPrototypeOf(FormSelect), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FormSelect;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return FormSelect;
  }(Component);

  M.FormSelect = FormSelect;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FormSelect, 'formSelect', 'M_FormSelect');
  }
})(cash);

;

(function ($, anim) {
  'use strict';

  var _defaults = {};
  /**
   * @class
   *
   */

  var Range = function (_Component21) {
    _inherits(Range, _Component21);
    /**
     * Construct Range instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */


    function Range(el, options) {
      _classCallCheck(this, Range);

      var _this72 = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, Range, el, options));

      _this72.el.M_Range = _this72;
      /**
       * Options for the range
       * @member Range#options
       */

      _this72.options = $.extend({}, Range.defaults, options);
      _this72._mousedown = false; // Setup

      _this72._setupThumb();

      _this72._setupEventHandlers();

      return _this72;
    }

    _createClass(Range, [{
      key: "destroy",

      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();

        this._removeThumb();

        this.el.M_Range = undefined;
      }
      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleRangeChangeBound = this._handleRangeChange.bind(this);
        this._handleRangeMousedownTouchstartBound = this._handleRangeMousedownTouchstart.bind(this);
        this._handleRangeInputMousemoveTouchmoveBound = this._handleRangeInputMousemoveTouchmove.bind(this);
        this._handleRangeMouseupTouchendBound = this._handleRangeMouseupTouchend.bind(this);
        this._handleRangeBlurMouseoutTouchleaveBound = this._handleRangeBlurMouseoutTouchleave.bind(this);
        this.el.addEventListener('change', this._handleRangeChangeBound);
        this.el.addEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.addEventListener('touchstart', this._handleRangeMousedownTouchstartBound);
        this.el.addEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.addEventListener('touchend', this._handleRangeMouseupTouchendBound);
        this.el.addEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }
      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('change', this._handleRangeChangeBound);
        this.el.removeEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.removeEventListener('touchstart', this._handleRangeMousedownTouchstartBound);
        this.el.removeEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.removeEventListener('touchend', this._handleRangeMouseupTouchendBound);
        this.el.removeEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }
      /**
       * Handle Range Change
       * @param {Event} e
       */

    }, {
      key: "_handleRangeChange",
      value: function _handleRangeChange() {
        $(this.value).html(this.$el.val());

        if (!$(this.thumb).hasClass('six-storage-active')) {
          this._showRangeBubble();
        }

        var offsetLeft = this._calcRangeOffset();

        $(this.thumb).addClass('six-storage-active').css('left', offsetLeft + 'px');
      }
      /**
       * Handle Range Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleRangeMousedownTouchstart",
      value: function _handleRangeMousedownTouchstart(e) {
        // Set indicator value
        $(this.value).html(this.$el.val());
        this._mousedown = true;
        this.$el.addClass('six-storage-active');

        if (!$(this.thumb).hasClass('six-storage-active')) {
          this._showRangeBubble();
        }

        if (e.type !== 'input') {
          var offsetLeft = this._calcRangeOffset();

          $(this.thumb).addClass('six-storage-active').css('left', offsetLeft + 'px');
        }
      }
      /**
       * Handle Range Input, Mousemove and Touchmove
       */

    }, {
      key: "_handleRangeInputMousemoveTouchmove",
      value: function _handleRangeInputMousemoveTouchmove() {
        if (this._mousedown) {
          if (!$(this.thumb).hasClass('six-storage-active')) {
            this._showRangeBubble();
          }

          var offsetLeft = this._calcRangeOffset();

          $(this.thumb).addClass('six-storage-active').css('left', offsetLeft + 'px');
          $(this.value).html(this.$el.val());
        }
      }
      /**
       * Handle Range Mouseup and Touchend
       */

    }, {
      key: "_handleRangeMouseupTouchend",
      value: function _handleRangeMouseupTouchend() {
        this._mousedown = false;
        this.$el.removeClass('six-storage-active');
      }
      /**
       * Handle Range Blur, Mouseout and Touchleave
       */

    }, {
      key: "_handleRangeBlurMouseoutTouchleave",
      value: function _handleRangeBlurMouseoutTouchleave() {
        if (!this._mousedown) {
          var paddingLeft = parseInt(this.$el.css('padding-left'));
          var marginLeft = 7 + paddingLeft + 'px';

          if ($(this.thumb).hasClass('six-storage-active')) {
            anim.remove(this.thumb);
            anim({
              targets: this.thumb,
              height: 0,
              width: 0,
              top: 10,
              easing: 'easeOutQuad',
              marginLeft: marginLeft,
              duration: 100
            });
          }

          $(this.thumb).removeClass('six-storage-active');
        }
      }
      /**
       * Setup dropdown
       */

    }, {
      key: "_setupThumb",
      value: function _setupThumb() {
        this.thumb = document.createElement('span');
        this.value = document.createElement('span');
        $(this.thumb).addClass('six-storage-thumb');
        $(this.value).addClass('value');
        $(this.thumb).append(this.value);
        this.$el.after(this.thumb);
      }
      /**
       * Remove dropdown
       */

    }, {
      key: "_removeThumb",
      value: function _removeThumb() {
        $(this.thumb).remove();
      }
      /**
       * morph thumb into bubble
       */

    }, {
      key: "_showRangeBubble",
      value: function _showRangeBubble() {
        var paddingLeft = parseInt($(this.thumb).parent().css('padding-left'));
        var marginLeft = -7 + paddingLeft + 'px'; // TODO: fix magic number?

        anim.remove(this.thumb);
        anim({
          targets: this.thumb,
          height: 30,
          width: 30,
          top: -30,
          marginLeft: marginLeft,
          duration: 300,
          easing: 'easeOutQuint'
        });
      }
      /**
       * Calculate the offset of the thumb
       * @return {Number}  offset in pixels
       */

    }, {
      key: "_calcRangeOffset",
      value: function _calcRangeOffset() {
        var width = this.$el.width() - 15;
        var max = parseFloat(this.$el.attr('max')) || 100; // Range default max

        var min = parseFloat(this.$el.attr('min')) || 0; // Range default min

        var percent = (parseFloat(this.$el.val()) - min) / (max - min);
        return percent * width;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Range.__proto__ || Object.getPrototypeOf(Range), "init", this).call(this, this, els, options);
      }
      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Range;
      }
    }, {
      key: "defaults",
      get: function get() {
        return _defaults;
      }
    }]);

    return Range;
  }(Component);

  M.Range = Range;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Range, 'range', 'M_Range');
  }

  Range.init($('input[type=range]'));
})(cash, M.anime);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helper = _interopRequireDefault(require("./helper.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Discountslider = /*#__PURE__*/function () {
  function Discountslider() {
    _classCallCheck(this, Discountslider);

    _defineProperty(this, "helper", new _helper["default"]());
  }

  _createClass(Discountslider, [{
    key: "getPromoDiscount",
    // M = {};
    // constructor(materialize) {
    //     M = materialize;
    // }
    value: function getPromoDiscount(storagetype, tenantType, invoiceperiod, Location) {
      var _this = this;

      var discounttype = "PROMO";
      var visibility = 1;
      var storageTypeID = storagetype;
      var tenantTypeId = tenantType;
      var period = invoiceperiod;
      var location = Location;
      var obj = {
        discounttype: typeof discounttype !== "undefined" && discounttype !== null ? discounttype : null,
        visibility: typeof visibility !== "undefined" && visibility !== null ? visibility : null,
        storagetypeId: typeof storageTypeID !== "undefined" && storageTypeID !== null ? storageTypeID : null,
        tenanttypeId: typeof tenantTypeId !== "undefined" && tenantTypeId !== null ? tenantTypeId : null,
        period: typeof period !== "undefined" && period !== null ? period : null,
        location: typeof location !== "undefined" && location !== null ? location : null
      };
      var formData = new FormData();
      formData.append("action", "six_storage_get_promo_discount");
      formData.append("discounttype", obj.discounttype);
      formData.append("visibility", obj.visibility);
      formData.append("storagetypeId", obj.storagetypeId);
      formData.append("tenanttypeId", obj.tenanttypeId);
      formData.append("period", obj.period);
      formData.append("location", obj.location);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var response = JSON.parse(data);

          if (typeof response.isSuccess !== 'undefined' && response !== null && response.isSuccess === true) {
            _this.constructpromodiscount(response);
          } else {
            document.getElementById('six-storage-promo_six-storage-discount_carousel').style.display = 'none';
          }
        } else {
          document.getElementById('six-storage-promo_six-storage-discount_carousel').style.display = 'none';
        }
      })["catch"](function (err) {
        document.getElementById('six-storage-promo_six-storage-discount_carousel').style.display = 'none';
        console.log(err);
        document.getElementById("six-storage-loading-container").innerHTML = _this.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "constructpromodiscount",
    value: function constructpromodiscount(discounts) {
      var discountresult = typeof discounts.result !== "undefined" && discounts.result !== null && discounts.result.length > 0 ? discounts.result.map(function (item, i) {
        return typeof item.description !== "undefined" && item.description !== null && item.description !== "" ? "<div class=\"six-storage-carousel-item six-storage-col cc six-storage-s12 six-storage-white-text cc six-storage-center six-storage-aligntext\">\n                        <p class=\"cc\" style=\"color:white;\">\n                        <i class=\"six-storage-material-icons notranslate cc six-storage-middle-indicator-text six-storage-slider-Officon\">local_offer</i> \n                            <b class=\"six-storage-promo-text\"> ".concat(item.description, " </b>\n                        </p>\n                    </div>") : "";
      }) : "";

      if (typeof discountresult !== 'undefined' && discountresult !== null && discountresult !== '') {
        var discountshtml = document.getElementById('six-storage-promo_six-storage-discount_carousel');
        discountshtml.innerHTML = "<div class=\"six-storage-carousel cc six-storage-row  six-storage-carousel-slider six-storage-center cc\" id=\"six-storage-discount_carousel\" data-indicators=\"true\">\n            <div class=\"six-storage-carousel-fixed-item six-storage-center cc six-storage-middle-indicator\">\n                <div class=\"six-storage-left cc\">\n                    <a href=\"#\" id=\"six-storage-movePrevCarousel\" class=\"cc six-storage-middle-indicator-text six-storage-content-indicator\"><i class=\"six-storage-material-icons notranslate six-storage-left cc six-storage-middle-indicator-text\">chevron_left</i></a>\n                </div>\n                <div class=\"six-storage-right cc\">\n                    <a href=\"#\" id=\"six-storage-moveNextCarousel\" class=\"cc six-storage-middle-indicator-text six-storage-content-indicator\"><i class=\"six-storage-material-icons notranslate cc six-storage-right six-storage-middle-indicator-text\">chevron_right</i></a>\n                </div>\n            </div>\n            ".concat(discountresult, "\n        </div>");
        document.getElementById('six-storage-promo_six-storage-discount_carousel').style.display = '';
        this.discountCarousel();
        var next = document.getElementById('six-storage-moveNextCarousel');
        next.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var elems = document.getElementById('six-storage-discount_carousel');
          var instance = M.Carousel.getInstance(elems);
          instance.next();
        });
        var prev = document.getElementById('six-storage-movePrevCarousel');
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var elems = document.getElementById('six-storage-discount_carousel');
          var instance = M.Carousel.getInstance(elems);
          instance.prev();
        });
      }

      M.AutoInit();
    }
  }, {
    key: "discountCarousel",
    value: function discountCarousel() {
      var elems = document.getElementById('six-storage-discount_carousel');
      var options = {
        dist: 0,
        padding: 50,
        noWrap: true,
        fullWidth: true,
        duration: 100
      };
      M.Carousel.init(elems, options);
      this.autoplay();
    }
  }, {
    key: "autoplay",
    value: function autoplay() {
      var elems = document.getElementById('six-storage-discount_carousel');
      var instance = M.Carousel.getInstance(elems);
      instance.prev();
      setInterval(this.autoplay, 5000);
    }
  }]);

  return Discountslider;
}();

var _default = Discountslider;
exports["default"] = _default;

},{"./helper.js":15}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sweetalert = _interopRequireDefault(require("sweetalert"));

require("regenerator-runtime/runtime");

var _helper = _interopRequireDefault(require("./helper.js"));

var _materialize = _interopRequireDefault(require("../materialize"));

var _Discountslider = _interopRequireDefault(require("./Discountslider"));

var _croppie = _interopRequireDefault(require("croppie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MoveInApp = /*#__PURE__*/function () {
  function MoveInApp() {
    _classCallCheck(this, MoveInApp);

    _defineProperty(this, "units", void 0);

    _defineProperty(this, "amenitiesarray", void 0);

    _defineProperty(this, "unitsSelected", void 0);

    _defineProperty(this, "discountBasedUnit", void 0);

    _defineProperty(this, "listedUnit", void 0);

    _defineProperty(this, "unitsSelectedInfo", void 0);

    _defineProperty(this, "unitsRentInformation", void 0);

    _defineProperty(this, "pageNumber", void 0);

    _defineProperty(this, "timeZones", void 0);

    _defineProperty(this, "currentStepNumber", void 0);

    _defineProperty(this, "additionalServices", void 0);

    _defineProperty(this, "merchItems", void 0);

    _defineProperty(this, "vehicleInfo", void 0);

    _defineProperty(this, "insuranceInfo", void 0);

    _defineProperty(this, "tentnantDetails", void 0);

    _defineProperty(this, "tentnantDetailsFinal", void 0);

    _defineProperty(this, "identityDocumentId", void 0);

    _defineProperty(this, "tentnantDetailsId", void 0);

    _defineProperty(this, "moveInData", void 0);

    _defineProperty(this, "identityTypes", void 0);

    _defineProperty(this, "signaturePad", void 0);

    _defineProperty(this, "wrapper", void 0);

    _defineProperty(this, "canvas", void 0);

    _defineProperty(this, "preferredStorage", void 0);

    _defineProperty(this, "moveinPreferredStorage", void 0);

    _defineProperty(this, "contactPreferences", void 0);

    _defineProperty(this, "moveinContactPreferences", void 0);

    _defineProperty(this, "identityModel", void 0);

    _defineProperty(this, "movein_date", void 0);

    _defineProperty(this, "moveinFieldSettings", void 0);

    _defineProperty(this, "groupBySize", void 0);

    _defineProperty(this, "selectedunitTypeId", void 0);

    _defineProperty(this, "selectedUnitTypes", void 0);

    _defineProperty(this, "rentSingleUnit", void 0);

    _defineProperty(this, "geteAccessInfo", void 0);

    _defineProperty(this, "promocodevalidate", void 0);

    _defineProperty(this, "paymentTransactionResponse", void 0);

    _defineProperty(this, "displayInclusiveofTax", void 0);

    _defineProperty(this, "unitRentInclusiveTax", void 0);

    _defineProperty(this, "clientConfig", void 0);

    _defineProperty(this, "paymentGateway", void 0);

    _defineProperty(this, "displayTimezones", void 0);

    _defineProperty(this, "queryParam", void 0);

    _defineProperty(this, "sixReckonerRedirection", void 0);

    _defineProperty(this, "loadSecondPage", void 0);

    _defineProperty(this, "loadingDiscounts", void 0);

    _defineProperty(this, "reInitiatePhoneNumber", void 0);

    _defineProperty(this, "reservationPayment", void 0);

    _defineProperty(this, "reservationUserDetails", void 0);

    _defineProperty(this, "unitinfoDetails", void 0);

    _defineProperty(this, "signUpReponse", void 0);

    _defineProperty(this, "reservesingleunit", void 0);

    _defineProperty(this, "enquiryEnabled", void 0);

    _defineProperty(this, "reservationEnabled", void 0);

    _defineProperty(this, "googleAnalyticsEnabled", void 0);

    _defineProperty(this, "termsandconditionValue", void 0);

    _defineProperty(this, "businessUserEnabled", void 0);

    _defineProperty(this, "esignEnabled", void 0);

    _defineProperty(this, "esignMandatory", void 0);

    _defineProperty(this, "fullDiscount", void 0);

    _defineProperty(this, "availablemerchStock", void 0);

    _defineProperty(this, "firstOfMonthEnabled", void 0);

    _defineProperty(this, "anniversaryenabled", void 0);

    _defineProperty(this, "hasMerchandise", void 0);

    _defineProperty(this, "hasInsurance", void 0);

    _defineProperty(this, "hasService", void 0);

    _defineProperty(this, "hasvehicleInformation", void 0);

    _defineProperty(this, "groupBasedUnitID", void 0);

    _defineProperty(this, "sepaPaymentclicked", void 0);

    _defineProperty(this, "currentSessionVal", void 0);

    _defineProperty(this, "ptwofourReservationfee", void 0);

    _defineProperty(this, "customFieldsResponse", void 0);

    _defineProperty(this, "customFieldsValues", void 0);

    _defineProperty(this, "customFieldPreviewValues", void 0);

    _defineProperty(this, "arrayOfUnitTypes", void 0);

    _defineProperty(this, "six_storage_online_fc_unit_type_toggle", void 0);

    _defineProperty(this, "six_storage_online_fc_unit_size_filter_toggle", void 0);

    _defineProperty(this, "sixStorageLoadUnitsPrice", void 0);

    _defineProperty(this, "unitBasedServiceSelected", void 0);

    _defineProperty(this, "savedCustomFieldValues", void 0);

    _defineProperty(this, "customTenantDetailValues", void 0);

    _defineProperty(this, "savedCustomTenantDetailValues", void 0);

    _defineProperty(this, "customEmgContactValues", void 0);

    _defineProperty(this, "savedCustomEmgContactValues", void 0);

    _defineProperty(this, "customUnitSpecificValues", void 0);

    _defineProperty(this, "savedCustomUnitSpecificValues", void 0);

    _defineProperty(this, "customVehicleDetailsValues", void 0);

    _defineProperty(this, "savedCustomVehicleDetailsValues", void 0);

    _defineProperty(this, "customInsuranceDetailsValues", void 0);

    _defineProperty(this, "savedCustomInsuranceDetailsValues", void 0);

    _defineProperty(this, "saveThirdPartyInsuranceDetailsValues", void 0);

    _defineProperty(this, "selectedThirdPartyInsurance", void 0);

    _defineProperty(this, "customThirdPartyInsuranceDetailsValues", void 0);

    _defineProperty(this, "saveDesiredMoveOutDateOnline", void 0);

    _defineProperty(this, "sixStorageSelectedUnitIdByUnitType", void 0);

    _defineProperty(this, "sixStorageUnitTypeIdFilterSelected", void 0);

    _defineProperty(this, "sixStorageOnlineSelectedInsuranceField", void 0);

    _defineProperty(this, "sixstorageStorageCategoryFilterResponse", void 0);

    _defineProperty(this, "sixstorageLocationFilterResponse", void 0);

    _defineProperty(this, "sixstorageBuildingFilterResponse", void 0);

    _defineProperty(this, "sixstorageUnitTypeFilterResponse", void 0);

    _defineProperty(this, "sixstorgaeAmenityFilterResponse", void 0);

    _defineProperty(this, "sixstoragePriceRangeResponse", void 0);

    _defineProperty(this, "sixStorageInitialowninsurance", void 0);

    _defineProperty(this, "sixstorageotherAPiCall", void 0);

    _defineProperty(this, "sixstorageSelectInsurance", void 0);

    _defineProperty(this, "autopaynotes", void 0);

    _defineProperty(this, "esignfile", void 0);

    _defineProperty(this, "notecarddetails", void 0);

    _defineProperty(this, "selectedunitTypeIdcounts", void 0);

    _defineProperty(this, "discountslider", new _Discountslider["default"](_materialize["default"]));

    _defineProperty(this, "helper", new _helper["default"]());

    this.sixStorageInitProperties(), this.sixStorageGetClientConfig();
    this.sixStorageGetSiteDetails();
    this.sixReckonerRedirection = {
      storageTypeID: this.helper.sixStorageGetParameterByName('storageTypeID'),
      unitTypeID: this.helper.sixStorageGetParameterByName('unitTypeID')
    };

    if (typeof this.sixReckonerRedirection["storageTypeID"] !== 'undefined' && this.sixReckonerRedirection["storageTypeID"] !== null && this.sixReckonerRedirection["storageTypeID"] !== "" && typeof this.sixReckonerRedirection["unitTypeID"] !== 'undefined' && this.sixReckonerRedirection["unitTypeID"] !== null && this.sixReckonerRedirection["unitTypeID"] !== "") {
      var storageTypeId = this.sixReckonerRedirection["storageTypeID"].split(',');
      var unitTypeId = this.sixReckonerRedirection["unitTypeID"].split(',');
      this.sixStorageGetUnits(null, [storageTypeId], [unitTypeId]);
    }

    this.queryParam = {
      unitTypeId: this.helper.sixStorageGetParameterByName("unitTypeId"),
      quantity: this.helper.sixStorageGetParameterByName("quantity"),
      price: this.helper.sixStorageGetParameterByName("price"),
      netAmount: this.helper.sixStorageGetParameterByName("netAmount"),
      businessUser: this.helper.sixStorageGetParameterByName("businessUser"),
      unitId: this.helper.sixStorageGetParameterByName("unitId")
    };

    if (typeof this.queryParam["businessUser"] !== 'undefined' && this.queryParam["businessUser"] !== null && this.queryParam["businessUser"] !== "") {
      var currentsession = sessionStorage.getItem("six_storage_sessionObject");
      document.getElementById("six-storage-tenant_type").value = this.queryParam["businessUser"];
      this.sixStorageChangeTenantType();
    }

    if (typeof this.queryParam["unitId"] !== 'undefined' && this.queryParam["unitId"] !== null && this.queryParam["unitId"] !== "") {
      if (typeof this.queryParam["businessUser"] !== 'undefined' && this.queryParam["businessUser"] !== null && this.queryParam["businessUser"] !== "" && typeof this.queryParam["unitId"] !== 'undefined' && this.queryParam["unitId"] !== null && this.queryParam["unitId"] !== "") {
        this.loadSecondPage = true;
        this.currentStepNumber += 1;
        this.sixStorageRenderStepHtml();
        this.unitsSelected.push(this.queryParam["unitId"]);
        this.sixStorageRentNow();
      }
    } else {
      if (typeof this.queryParam["unitTypeId"] !== 'undefined' && this.queryParam["unitTypeId"] !== null && this.queryParam["unitTypeId"] !== "" && typeof this.queryParam["quantity"] !== 'undefined' && this.queryParam["quantity"] !== null && this.queryParam["quantity"] !== "" && typeof this.queryParam["price"] !== 'undefined' && this.queryParam["price"] !== null && this.queryParam["price"] !== "" && typeof this.queryParam["businessUser"] !== 'undefined' && this.queryParam["businessUser"] !== null && this.queryParam["businessUser"] !== "") {
        this.loadSecondPage = true;
        this.currentStepNumber += 1;
        this.sixStorageRenderStepHtml();
        this.selectedUnitTypes.push({
          unitTypeId: this.queryParam["unitTypeId"],
          quantity: this.queryParam["quantity"],
          price: this.unitRentInclusiveTax === true ? this.queryParam["netAmount"] : this.queryParam["price"]
        });
        this.sixStorageGetAutoSelectedUnits(false);
      }
    }

    var sixstorageunitlistings = document.getElementById('six-storage-unit-lists');

    if (typeof this.queryParam.businessUser !== 'undefined' && this.queryParam.businessUser !== null && this.queryParam.businessUser !== '') {
      if (typeof sixstorageunitlistings !== "undefined" && sixstorageunitlistings !== null) {
        sixstorageunitlistings.style.display = 'none';
      }
    } else {
      if (typeof sixstorageunitlistings !== "undefined" && sixstorageunitlistings !== null) {
        sixstorageunitlistings.style.display = 'block';
      }

      if (typeof sixstorageunitlistings !== "undefined" && sixstorageunitlistings !== null) {
        sixstorageunitlistings.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }

    var sixstoragemoveInpageoneloadcontainer = document.getElementById('six-storage-moveIn-page-one-load-container');

    if (typeof sixstoragemoveInpageoneloadcontainer !== "undefined" && sixstoragemoveInpageoneloadcontainer !== null) {
      sixstoragemoveInpageoneloadcontainer.style.display = 'block';
    }

    _materialize["default"].AutoInit();
  }

  _createClass(MoveInApp, [{
    key: "sixStorageInitProperties",
    value: function sixStorageInitProperties() {
      var _this = this;

      this.paymentTransactionResponse = {};
      this.units = [];
      this.esignfile = [];
      this.unitsSelected = [];
      this.sixStorageSelectedUnitIdByUnitType = [];
      this.unitsSelectedInfo = [];
      this.unitsRentInformation = [];
      this.additionalServices = [];
      this.geteAccessInfo = [];
      this.pageNumber = 0;
      this.currentStepNumber = 1;
      this.merchItems = [];
      this.vehicleInfo = [];
      this.tentnantDetails = {};
      this.amenitiesarray = [];
      this.tentnantDetailsFinal = {};
      this.tentnantDetailsFinal["profileAddress"] = {};
      this.tentnantDetailsFinal["deliveryAddress"] = {};
      this.tentnantDetailsFinal["companyDetails"] = {};
      this.tentnantDetailsFinal["emergencyContact"] = [];
      this.identityDocumentId = null;
      this.tentnantDetailsId = null;
      this.insuranceInfo = [];
      this.discountBasedUnit = [];
      this.listedUnit = [];
      this.moveInData = {};
      this.clientConfig = {};
      this.preferredStorage = {};
      this.moveinPreferredStorage = {};
      this.contactPreferences = {};
      this.moveinContactPreferences = {};
      this.identityModel = {};
      this.moveinFieldSettings = [];
      this.selectedUnitTypes = [];
      this.promocodevalidate = false;
      this.autopaynotes = false;
      this.sixstorageSelectInsurance = false;
      this.reInitiatePhoneNumber = false;
      this.loadingDiscounts = false;
      this.reservationPayment = false;
      this.signUpReponse = {};
      this.reservationUserDetails = {};
      this.reservesingleunit = false;
      this.firstOfMonthEnabled = false;
      this.anniversaryenabled = false;
      this.availablemerchStock = false;
      this.hasMerchandise = false;
      this.hasInsurance = false;
      this.hasService = false;
      this.sixstorageotherAPiCall = true;
      this.hasvehicleInformation = false;
      this.sepaPaymentclicked = false;
      this.currentSessionVal = {};
      this.customFieldsValues = [];
      this.customFieldsResponse = {};
      this.customFieldPreviewValues = [];
      this.sixStorageLoadUnitsPrice = false;
      this.unitBasedServiceSelected = false;
      this.savedCustomFieldValues = [];
      this.customTenantDetailValues = [];
      this.customEmgContactValues = [];
      this.customUnitSpecificValues = [];
      this.savedCustomVehicleDetailsValues = [];
      this.customInsuranceDetailsValues = [];
      this.customVehicleDetailsValues = [];
      this.savedCustomVehicleDetailsValues = [];
      this.saveThirdPartyInsuranceDetailsValues = [];
      this.sixstorageStorageCategoryFilterResponse = [];
      this.sixstorageLocationFilterResponse = [];
      this.sixstorageBuildingFilterResponse = [];
      this.sixstorageUnitTypeFilterResponse = [];
      this.sixstorgaeAmenityFilterResponse = [];
      this.sixstoragePriceRangeResponse = [];
      this.selectedThirdPartyInsurance = false;
      this.customThirdPartyInsuranceDetailsValues = [];
      this.saveDesiredMoveOutDateOnline = [];
      this.promocodescroll = false;
      this.sixStorageUnitTypeIdFilterSelected = [];
      this.selectedunitTypeIdcounts = [];
      this.sixStorageOnlineSelectedInsuranceField = false;
      this.sixStorageInitialowninsurance = false;
      this.moveinWithoutPayment = false;
      this.notecarddetails = false;
      var formUrl = document.getElementById("six-storage-template-ajax-url");
      this.culture = formUrl.dataset.culture;
      this.helper.culture = this.culture;
      this.helper.dateFormat = formUrl.dataset.date_format;
      this.helper.currency = formUrl.dataset.currency_format;
      this.displayInclusiveofTax = typeof wordpress_vars.inclusive_tax !== 'undefined' && wordpress_vars.inclusive_tax !== null && wordpress_vars.inclusive_tax !== '1' && wordpress_vars.inclusive_tax !== "" && wordpress_vars.inclusive_tax !== true && wordpress_vars.inclusive_tax !== undefined ? false : true;
      this.displayTimezones = typeof wordpress_vars.timeZoneEnabled !== 'undefined' && wordpress_vars.timeZoneEnabled !== null && wordpress_vars.timeZoneEnabled !== '1' && wordpress_vars.timeZoneEnabled !== "" && wordpress_vars.timeZoneEnabled !== true && wordpress_vars.timeZoneEnabled !== undefined ? false : true;
      this.rentSingleUnit = typeof wordpress_vars.rentSingleUnit !== 'undefined' && wordpress_vars.rentSingleUnit !== true && wordpress_vars.rentSingleUnit !== '1' && wordpress_vars.rentSingleUnit !== null ? false : true;
      this.enquiryEnabled = typeof wordpress_vars.enquiryEnabled !== 'undefined' && wordpress_vars.enquiryEnabled !== true && wordpress_vars.enquiryEnabled !== '1' && wordpress_vars.enquiryEnabled !== null ? false : true;
      this.reservationEnabled = typeof wordpress_vars.reservationEnabled !== 'undefined' && wordpress_vars.reservationEnabled !== true && wordpress_vars.reservationEnabled !== '1' && wordpress_vars.enquiryEnabled !== null ? false : true;
      this.businessUserEnabled = typeof wordpress_vars.businessUserEnabled !== 'undefined' && wordpress_vars.businessUserEnabled !== true && wordpress_vars.businessUserEnabled !== '1' && wordpress_vars.businessUserEnabled !== null ? false : true;
      this.esignEnabled = typeof wordpress_vars.eSignatureEnabled !== 'undefined' && wordpress_vars.eSignatureEnabled !== true && wordpress_vars.eSignatureEnabled !== '1' && wordpress_vars.eSignatureEnabled !== null ? false : true;
      this.esignMandatory = typeof wordpress_vars.eSignatureRequired !== 'undefined' && wordpress_vars.eSignatureRequired !== true && wordpress_vars.eSignatureRequired !== '1' && wordpress_vars.eSignatureRequired !== null ? false : true;
      this.six_storage_online_fc_unit_size_filter_toggle = typeof wordpress_vars.six_storage_online_fc_unit_size_filter_toggle !== 'undefined' && wordpress_vars.six_storage_online_fc_unit_size_filter_toggle !== true && wordpress_vars.six_storage_online_fc_unit_size_filter_toggle !== '1' && wordpress_vars.six_storage_online_fc_unit_size_filter_toggle !== null ? false : true;
      this.six_storage_online_fc_amenity_toggle = typeof wordpress_vars.six_storage_online_fc_amenity_toggle !== 'undefined' && wordpress_vars.six_storage_online_fc_amenity_toggle !== true && wordpress_vars.six_storage_online_fc_amenity_toggle !== '1' && wordpress_vars.six_storage_online_fc_amenity_toggle !== null ? false : true;
      this.termsandconditionValue = typeof wordpress_vars.termsAndCondition !== 'undefined' && wordpress_vars.termsAndCondition !== null && wordpress_vars.termsAndCondition !== "" ? wordpress_vars.termsAndCondition.replace(/\\/g, "") : null;

      function addDays(days) {
        var result = new Date();
        result.setDate(result.getDate() + parseInt(days - 1));
        return result;
      }

      var moveInAfter = typeof wordpress_vars.six_storage_online_fc_move_in_after !== 'undefined' && wordpress_vars.six_storage_online_fc_move_in_after !== '' && wordpress_vars.six_storage_online_fc_move_in_after !== null && wordpress_vars.six_storage_online_fc_move_in_after > 0 ? wordpress_vars.six_storage_online_fc_move_in_after : 1;
      var moveInUpto = typeof wordpress_vars.six_storage_online_fc_move_in_upto !== 'undefined' && wordpress_vars.six_storage_online_fc_move_in_upto !== '' && wordpress_vars.six_storage_online_fc_move_in_upto !== null && wordpress_vars.six_storage_online_fc_move_in_upto > 0 ? wordpress_vars.six_storage_online_fc_move_in_upto : 30;
      var date = new Date();
      var moveinMinDate = addDays(moveInAfter);
      var moveinMaxDate = addDays(moveInUpto);
      setTimeout(function () {
        var config = sessionStorage.getItem("clientConfig");

        if (typeof config !== 'undefined' && config !== null && config !== '' && config !== undefined) {
          var data = JSON.parse(config);

          _this.sixStorageSetConfig(data);
        }
      }, 1000); //this.helper.sixStorageGetClientCulture();

      var sixStoragePayLater = document.getElementById("six-storage-paylater-book-now");

      if (sixStoragePayLater !== null && typeof sixStoragePayLater !== 'undefined') {
        sixStoragePayLater.addEventListener("click", function (event) {
          var canvasValue = document.getElementById('six-storage-signature-canvas');
          var esignatureFile = _this.signaturePad._data;

          if (_this.esignEnabled === true && typeof esignatureFile !== 'undefined' && esignatureFile !== null && esignatureFile !== "" && esignatureFile.length > 0) {
            var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
            var tenantId = currentSession.userId;
            canvasValue.toBlob(function (blob) {
              _this.esignfile = new File([blob], "ESIGN_".concat(tenantId, "_").concat(Date.now(), ".png"), {
                type: "image/png"
              });
              var fileName = "ESIGN_".concat(tenantId, "_").concat(Date.now(), ".png");

              _this.sixStorageUploadEsignatureFiles("ESIGN", _this.esignfile, fileName, true);
            }); // setTimeout(() => {
            //   this.sixStorageSaveMoveinDetails(true, null, true);
            // }, 1000);
          } else {
            _this.sixStorageSaveMoveinDetails(true, null, true);
          }
        });
      }

      var sixstoragePennilessMoveIn = document.getElementById("six-storage-PennilessMoveInNow");

      if (typeof sixstoragePennilessMoveIn !== "undefined" && sixstoragePennilessMoveIn !== null) {
        sixstoragePennilessMoveIn.addEventListener("click", function (event) {
          _this.sixStorageLoadPaymentForm(true);
        });
      } // document.getElementById("six-storage-PennilessMoveInNow").addEventListener("click", (event) => {
      //   this.sixStorageLoadPaymentForm(true);
      // });

    }
  }, {
    key: "sixStorageLoadAllApiCall",
    value: function () {
      var _sixStorageLoadAllApiCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([this.sixStorageGetFilter(), this.initForm()]);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sixStorageLoadAllApiCall() {
        return _sixStorageLoadAllApiCall.apply(this, arguments);
      }

      return sixStorageLoadAllApiCall;
    }()
  }, {
    key: "sixStorageAuthentication",
    value: function sixStorageAuthentication() {
      var _this2 = this;

      var formData = new FormData();
      formData.append("action", "six_storage_get_client_auth_details");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response = JSON.parse(data);

          if (typeof _response !== "undefined" && _response !== null && _response !== '') {
            if (typeof _response.result.userId !== 'undefined' && _response.result.userId !== null && _response.result.userId !== '' && _response.result.userId !== "00000000-0000-0000-0000-000000000000") {
              sessionStorage.setItem("six_storage_sessionObject", JSON.stringify(_response.result));
              sessionStorage.setItem("userId", _response.result.userId);

              _this2.sixStorageGetUserInfo(_response.result.userId, false, true);
            }
          } else {
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("firstName");
            sessionStorage.removeItem("lastName");
            sessionStorage.removeItem("email");
            sessionStorage.removeItem("phone");
            sessionStorage.removeItem("six_storage_sessionObject");
            sessionStorage.removeItem("six-storage-security_token");
            sessionStorage.removeItem("currentSessionVal");
            sessionStorage.removeItem("accessCode");
          }
        } else {
          sessionStorage.removeItem("userId");
          sessionStorage.removeItem("firstName");
          sessionStorage.removeItem("lastName");
          sessionStorage.removeItem("email");
          sessionStorage.removeItem("phone");
          sessionStorage.removeItem("six_storage_sessionObject");
          sessionStorage.removeItem("six-storage-security_token");
          sessionStorage.removeItem("currentSessionVal");
          sessionStorage.removeItem("accessCode");
        }
      })["catch"](function (error) {
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("firstName");
        sessionStorage.removeItem("lastName");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("phone");
        sessionStorage.removeItem("six_storage_sessionObject");
        sessionStorage.removeItem("six-storage-security_token");
        sessionStorage.removeItem("currentSessionVal");
        sessionStorage.removeItem("accessCode");
        console.error(error);
      });
    }
  }, {
    key: "sixStorageRemoveAuthentication",
    value: function sixStorageRemoveAuthentication() {
      var formData = new FormData();
      formData.append("action", "six_storage_remove_authentication_detail");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response2 = JSON.parse(data);

          if (typeof _response2 !== "undefined" && _response2 !== null && _response2 !== '') {
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("firstName");
            sessionStorage.removeItem("lastName");
            sessionStorage.removeItem("email");
            sessionStorage.removeItem("phone");
            sessionStorage.removeItem("six_storage_sessionObject");
            sessionStorage.removeItem("six-storage-security_token");
            sessionStorage.removeItem("currentSessionVal");
            sessionStorage.removeItem("accessCode");
          } else {
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("firstName");
            sessionStorage.removeItem("lastName");
            sessionStorage.removeItem("email");
            sessionStorage.removeItem("phone");
            sessionStorage.removeItem("six_storage_sessionObject");
            sessionStorage.removeItem("six-storage-security_token");
            sessionStorage.removeItem("currentSessionVal");
            sessionStorage.removeItem("accessCode");
          }
        } else {
          sessionStorage.removeItem("userId");
          sessionStorage.removeItem("firstName");
          sessionStorage.removeItem("lastName");
          sessionStorage.removeItem("email");
          sessionStorage.removeItem("phone");
          sessionStorage.removeItem("six_storage_sessionObject");
          sessionStorage.removeItem("six-storage-security_token");
          sessionStorage.removeItem("currentSessionVal");
          sessionStorage.removeItem("accessCode");
        }
      })["catch"](function (error) {
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("firstName");
        sessionStorage.removeItem("lastName");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("phone");
        sessionStorage.removeItem("six_storage_sessionObject");
        sessionStorage.removeItem("six-storage-security_token");
        sessionStorage.removeItem("currentSessionVal");
        sessionStorage.removeItem("accessCode");
        console.error(error);
      });
    }
  }, {
    key: "sixStoragePromoDiscounts",
    value: function sixStoragePromoDiscounts() {
      var tenant_type = document.getElementById("six-storage-tenant_type");
      var storagetype = document.getElementById("six-storage-storage-type").value;
      var location = document.getElementById("six-storage-location").value;
      var tenantType = typeof tenant_type !== "undefined" && tenant_type !== null && typeof tenant_type.value !== "undefined" && tenant_type.value !== null && tenant_type.value === "true" ? 2 : 3;
      var period = document.getElementById('six-storage-invoice-period-new').value;
      this.discountslider.getPromoDiscount(storagetype, tenantType, period, location);
    }
  }, {
    key: "sixStorageValidatePromocode",
    value: function sixStorageValidatePromocode() {
      var _this3 = this;

      var sixStorageUnitInfo = this.unitsRentInformation[0].unitInfo;
      var storagetype = sixStorageUnitInfo.storageType.id;
      var location = sixStorageUnitInfo.location.id;
      var promocode = document.getElementById('six-storage-promoCodetext').value; //const storagetype = document.getElementById("six-storage-storage-type").value;

      var tenant_type = document.getElementById("six-storage-tenant_type");
      var tenantType = typeof tenant_type !== "undefined" && tenant_type !== null && typeof tenant_type.value !== "undefined" && tenant_type.value !== null && tenant_type.value === "true" ? 2 : 3; //const location = document.getElementById("six-storage-location").value;

      var period = document.getElementById('six-storage-invoice-period-new').value;
      var visibility = 1;
      var additionalMonths = document.getElementById('six-storage-additional-months').value;

      if (promocode !== null && promocode !== 'undefined' && promocode !== "") {
        document.getElementById('six-storage-promoCodetextvalid-err').style.display = 'none';
      } else {
        document.getElementById('six-storage-promoCodetext-err').style.display = 'none';
        document.getElementById('six-storage-promoCodetextvalid-err').style.display = '';
        return;
      }

      var obj = {
        promocode: typeof promocode !== "undefined" && promocode !== null ? promocode : null,
        storagetypeId: typeof storagetype !== "undefined" && storagetype !== null ? storagetype : null,
        tenanttypeId: typeof tenantType !== "undefined" && tenantType !== null ? tenantType : null,
        period: typeof period !== "undefined" && period !== null ? period : null,
        location: typeof location !== "undefined" && location !== null ? location : null,
        visibility: typeof visibility !== "undefined" && visibility !== null ? visibility : null,
        additionalmonth: typeof additionalMonths !== "undefined" && additionalMonths !== null ? additionalMonths : null
      };
      var validPromocode = {
        storageTypeId: obj.storagetypeId,
        locationId: obj.location,
        tenantTypeId: obj.tenanttypeId,
        promocode: obj.promocode,
        period: obj.period,
        visibility: obj.visibility,
        additionalMonths: obj.additionalmonth
      };

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append("action", "six_storage_valid_promo_discount");
      formData.append("validpromocode", JSON.stringify(validPromocode));
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this3.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response3 = JSON.parse(data);

          if (typeof _response3.isSuccess !== 'undefined' && _response3 !== null && _response3.isSuccess === true) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders = document.getElementById("six-storage-loading-container");

              _initialloaders.style.display = 'none';
            }

            document.getElementById('six-storage-promoCodetext-err').style.display = 'none';

            _this3.sixStorageRenderFinalUnitDetails(true);

            document.getElementById("six-storage-payment-selection").style.display = 'none';
            document.getElementById("six-storage-payment-form-div").style.display = 'none';
            document.getElementById("six-storage-btnPromocodeRemove").style.display = 'block';
            document.getElementById("six-storage-promoCodetext").setAttribute("disabled", "disabled");
            document.getElementById("six-storage-btnPromocode").style.display = 'none';
            var paynowbtncheckbox = document.getElementById("six-storage-rdbtn_pay_now");

            if (typeof paynowbtncheckbox !== "undefined" && paynowbtncheckbox !== null && paynowbtncheckbox !== '') {
              paynowbtncheckbox.checked = false;
            }

            _this3.promocodevalidate = true;
            _this3.promocodescroll = true;
          } else {
            document.getElementById('six-storage-promoCodetext-err').style.display = '';
            document.getElementById('six-storage-promoCodetextvalid-err').style.display = 'none';
            _this3.promocodevalidate = false;

            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders2 = document.getElementById("six-storage-loading-container");

              _initialloaders2.style.display = 'none';
            }
          }
        } else {
          document.getElementById('six-storage-promoCodetext-err').style.display = '';
          document.getElementById('six-storage-promoCodetextvalid-err').style.display = 'none';
          _this3.promocodevalidate = false;
        }
      })["catch"](function (err) {
        document.getElementById('six-storage-promoCodetext-err').style.display = '';
        console.log(err);
        document.getElementById("six-storage-loading-container").innerHTML = _this3.helper.sixStorageShowBusyIndicator(false);
        _this3.promocodevalidate = false;
      });
    }
  }, {
    key: "sixStoragePromoRemove",
    value: function sixStoragePromoRemove() {
      this.sixStorageSaveLeaseProfile();
      document.getElementById("six-storage-btnPromocode").style.display = 'block';
      document.getElementById("six-storage-promoCodetext").removeAttribute("disabled");
      document.getElementById("six-storage-btnPromocodeRemove").style.display = 'none';
    } // sixStorageCheckPromocode() {
    //   document.getElementById('six-storage-promoCodetext').addEventListener('keydown', (event) => {
    //     if (this.promocodevalidate == true) {
    //       if (event.key === "Backspace" || event.key === "Delete") {
    //         this.sixStorageValidatePromocode();
    //       }
    //     }
    //   });
    // }

  }, {
    key: "initForm",
    value: function initForm() {
      var formUrl = document.getElementById("six-storage-template-ajax-url");
      this.wrapper = document.getElementById("six-storage-signature-pad");
      this.canvas = this.wrapper.querySelector("canvas");
      this.signaturePad = new SignaturePad(this.canvas, {
        backgroundColor: "rgb(255, 255, 255)"
      }); // if (this.loadSecondPage !== true) {
      //   //this.sixStorageShowUnitsMessage(true);
      //   document.getElementById("`six-storage-no-units-data`").style.display = "none";
      //   const storageType = document.getElementById("six-storage-storage-type");
      //   if (typeof storageType !== "undefined") {
      //     if (storageType.options.length > 1) {
      //       if (typeof storageType.value !== "undefined" && storageType.value !== null && storageType.value !== "") {
      //         //this.sixStorageChangeLocation();
      //       }
      //     } else {
      //       document.getElementById('six-storage-online-unit-collection-contianer').style.display = "none";
      //       document.getElementById("six-storage-no-units-data").style.display = "block";
      //       let emailid = sessionStorage.getItem('AdminEmail');
      //       if (typeof emailid !== 'undefined' && emailid !== null) {
      //         document.getElementById('six-storage-no-units').innerHTML = `${wordpress_vars.six_storage_email_messege_admin} <a class="six-storage-text-white six-storage-send-email" href="mailto:${emailid}">${emailid}</a>.`;
      //       } else {
      //         document.getElementById('six-storage-no-units').innerHTML = `${wordpress_vars.six_storage_no_units_availble_label_text}`;
      //       }
      //     }
      //   }
      // }

      this.groupBySize = typeof formUrl.dataset.group_sizes !== 'undefined' && formUrl.dataset.group_sizes !== null ? formUrl.dataset.group_sizes === "1" ? true : false : false;

      if (this.groupBySize) {
        document.querySelector('.six-storage-grid-btn').classList.add('six-storage-d-none');
        document.getElementById('six-storage-grid-list').style.display = "none";
        document.getElementById("six-storage-dvUnitType").style.display = "none";
      } // this.rentSingleUnit = (typeof formUrl.dataset.rent_single_unit !== 'undefined' && formUrl.dataset.rent_single_unit !== null)
      //   ? (formUrl.dataset.rent_single_unit === "1" ? true : false) : false;


      if (this.rentSingleUnit === true && this.groupBySize === true) {
        document.getElementById("six-storage-rent-now").style.display = "none";
        document.getElementById("six-storage-enquiry").style.display = "none";
        document.getElementById("six-storage-reserve-now").style.display = "none";
        document.getElementById("six-storage-top-container-buttons").style.display = 'none';
      } else if (this.rentSingleUnit === false && this.groupBySize === true) {
        document.getElementById("six-storage-enquiry").style.display = "none";
        document.getElementById("six-storage-reserve-now").style.display = "none";
        document.getElementById("six-storage-top-container-buttons").style.display = 'block';
      } else {
        document.getElementById("six-storage-top-container-buttons").style.display = 'block';
      }
    }
  }, {
    key: "sixStorageGetCustomFields",
    value: function sixStorageGetCustomFields() {
      var _this4 = this;

      var formData = new FormData();
      formData.append("action", "six_storage_get_custom_fields");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'none';
        initialloaders.innerHTML = this.helper.sixStorageShowBusyIndicator(false);
      }

      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response4 = JSON.parse(data);

          document.getElementsByTagName('body')[0].style.overflow = 'unset';
          _this4.customFieldsResponse = _response4;
          _this4.sixstorageotherAPiCall = false;
        }
      });
    }
  }, {
    key: "sixStorageVTwoCommon",
    value: function sixStorageVTwoCommon(page) {
      var _this5 = this;

      var formData = new FormData();
      formData.append("action", "six_storage_get_lead_config");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          _this5.sixstorageotherAPiCall = false;

          var _response5 = JSON.parse(data);

          if (typeof Storage !== "undefined") {
            sessionStorage.setItem("sixStorageleadConfig", JSON.stringify(_response5.result));

            if (typeof page !== 'undefined' && page !== '' && page !== null && page === "TENANTPAGE") {
              var leadsourcevtwohtml = _this5.sixStorageConstructTenLeadSource(_response5.result);

              document.getElementById('sixStorage-tenant-lead').innerHTML = leadsourcevtwohtml;
              var elems = document.querySelectorAll('select');

              _materialize["default"].FormSelect.init(elems);
            }
          }
        }
      });
    }
  }, {
    key: "sixStorageGetSiteDetails",
    value: function sixStorageGetSiteDetails() {
      var formData = new FormData();
      formData.append("action", "six_storage_get_Site_Details");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response6 = JSON.parse(data);

          if (typeof _response6.isSuccess !== "undefined" && _response6 !== null && _response6.isSuccess === true && typeof _response6.result !== 'undefined' && _response6.result !== null && _response6.result !== '') {
            var adminEmail = _response6.result.contactInformation.adminEmail;

            if (typeof adminEmail !== "undefined" || adminEmail !== null) {
              sessionStorage.setItem("adminEmail", adminEmail);
            }
          } else {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var initialloaders = document.getElementById("six-storage-loading-container");
              initialloaders.style.display = 'none';
            }
          }
        }
      });
    }
  }, {
    key: "sixStorageGetFilter",
    value: function sixStorageGetFilter() {
      var _this6 = this;

      var adminEmail = sessionStorage.getItem("adminEmail");
      var formData = new FormData();
      formData.append("action", "six_storage_getfilter");
      var header = {
        method: "POST",
        headers: {
          "processData": false
        },
        body: formData
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var result = JSON.parse(data);
          var _response7 = result.result;
          var return_msg = result;
          sessionStorage.removeItem("goback");

          if (return_msg.returnMessage === 'NO_RECORDS_FOUND') {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var initialloaders = document.getElementById("six-storage-loading-container");
              initialloaders.style.display = 'none';
            }

            if (typeof adminEmail !== "undefined" || adminEmail !== null) {
              //document.getElementById('six-storage-no-units-data').style.display = "block";
              var no_units_available = document.getElementById("six-storage-no-records-found");
              document.getElementById("six-storage-loading-container").innerHTML = _this6.helper.sixStorageShowBusyIndicator(false);
              no_units_available.innerHTML = "<div class=\"six-storage-grid-mt10 six-storage-tenant-content six-storage-primary-background-color six-storage-grid-d-flex six-storage-flex-column six-storage-justify-content-center six-storage-grid-pl30 six-storage-grid-pr30 six-storage-grid-pb20  six-storage-grid-pt20 six-storage-text-white\"><p>".concat(wordpress_vars.six_storage_email_messege_admin, " <a href= \"mailTo:").concat(adminEmail, "\">").concat(adminEmail, "</a></p></div>");
            }
          } else {
            document.getElementById('six-storage-no-records-found').style.display = "none";

            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders3 = document.getElementById("six-storage-loading-container");

              _initialloaders3.style.display = 'none';
            }
          }

          if (typeof _response7 !== "undefined" && _response7 !== null && _response7 !== "" && _response7.length > 0) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders4 = document.getElementById("six-storage-loading-container");

              _initialloaders4.style.display = 'none';
            }

            _response7.forEach(function (arrayresponse) {
              _this6.sixstorageStorageCategoryFilterResponse.push({
                storageTypeId: arrayresponse.storageTypeId,
                storageTypeName: arrayresponse.storageTypeName
              });

              var storagefacility = arrayresponse.facilities;
              var storagelocationfacilities = arrayresponse.facilities;
              var amenitieslistingArray = []; // Iterate over each location and building to extract the amenities

              if (typeof storagelocationfacilities !== "undefined" && storagelocationfacilities !== null && storagelocationfacilities.length > 0) {
                storagelocationfacilities.forEach(function (location) {
                  location.buildings.forEach(function (building) {
                    if (typeof building.amenities !== "undefined" && building.amenities !== null) {
                      amenitieslistingArray.push.apply(amenitieslistingArray, _toConsumableArray(building.amenities));
                    }
                  });
                });
              }

              if (typeof amenitieslistingArray !== 'undefined' && amenitieslistingArray !== null && amenitieslistingArray !== "" && amenitieslistingArray.length > 0) {
                amenitieslistingArray.forEach(function (amenityresponse) {
                  _this6.sixstorgaeAmenityFilterResponse.push({
                    storageTypeId: arrayresponse.storageTypeId,
                    id: amenityresponse.id,
                    name: amenityresponse.name,
                    buildingId: amenityresponse.buildingId
                  });
                });
              }

              var storageunitresponse = arrayresponse.unitTypes;

              if (typeof storagefacility !== "undefined" && storagefacility !== null && storagefacility !== "" && storagefacility.length > 0) {
                storagefacility.forEach(function (locationresponse) {
                  _this6.sixstorageLocationFilterResponse.push({
                    storageTypeId: arrayresponse.storageTypeId,
                    locationId: locationresponse.locationId,
                    locationName: locationresponse.locationName
                  });

                  var storagebuilding = locationresponse.buildings;

                  if (typeof storagebuilding !== "undefined" && storagebuilding !== null && storagebuilding !== "" && storagebuilding.length > 0) {
                    storagebuilding.forEach(function (storagebuildingresponse) {
                      _this6.sixstorageBuildingFilterResponse.push({
                        locationId: locationresponse.locationId,
                        storageTypeId: arrayresponse.storageTypeId,
                        buildingId: storagebuildingresponse.buildingId,
                        buildingName: storagebuildingresponse.buildingName
                      });
                    });
                  }
                });
              }

              if (typeof storageunitresponse !== "undefined" && storageunitresponse !== null && storageunitresponse !== "" && storageunitresponse.length > 0) {
                storageunitresponse.forEach(function (storageunitresponse) {
                  var price = storageunitresponse.price;

                  _this6.sixstorageUnitTypeFilterResponse.push({
                    storageTypeId: arrayresponse.storageTypeId,
                    unitTypeId: storageunitresponse.unitTypeId,
                    unitTypeName: storageunitresponse.unitTypeName,
                    unitMeasurement: storageunitresponse.unitMeasurement,
                    measurementType: storageunitresponse.measurementType
                  });

                  if (typeof price == 'undefined' || price == null || price == "") {
                    _this6.sixstoragePriceRangeResponse.push({
                      storageTypeId: arrayresponse.storageTypeId,
                      MinPrice: 0,
                      MaxPrice: 0
                    });
                  } else {
                    _this6.sixstoragePriceRangeResponse.push({
                      storageTypeId: arrayresponse.storageTypeId,
                      MinPrice: price.minPrice,
                      MaxPrice: price.maxPrice
                    });
                  }
                });
              }
            }); //for Storage Category


            if (typeof _this6.sixstorageStorageCategoryFilterResponse !== 'undefined' && _this6.sixstorageStorageCategoryFilterResponse !== null && _this6.sixstorageStorageCategoryFilterResponse.length == 1) {
              if (typeof wordpress_vars.six_storage_online_fc_hide_storage_category_toggle !== 'undefined' && wordpress_vars.six_storage_online_fc_hide_storage_category_toggle !== null && wordpress_vars.six_storage_online_fc_hide_storage_category_toggle !== '' && wordpress_vars.six_storage_online_fc_hide_storage_category_toggle === '1') {
                document.getElementById("six-storage-storage-type-input").style.display = "none"; //document.querySelector(".applyfilterbutton").style.display = "none";
              } else {
                document.getElementById("six-storage-storage-type-input").style.display = "block"; //document.querySelector(".applyfilterbutton").style.display = "block";
              }
            } else {
              document.getElementById("six-storage-storage-type-input").style.display = "";
            }

            document.getElementById('six-storage-applyfilter').disabled = true;

            if ((wordpress_vars.businessUserEnabled === '0' || wordpress_vars.businessUserEnabled == '') && (wordpress_vars.six_storage_online_fc_amenity_toggle === '0' || wordpress_vars.six_storage_online_fc_amenity_toggle == '' || wordpress_vars.six_storage_online_fc_amenity_toggle == null) && (wordpress_vars.six_storage_online_fc_building_toggle === '0' || wordpress_vars.six_storage_online_fc_building_toggle == '' || wordpress_vars.six_storage_online_fc_building_toggle == null) && wordpress_vars.six_storage_online_fc_hide_storage_category_toggle === '1' && _this6.sixstorageStorageCategoryFilterResponse.length == 1 && (wordpress_vars.six_storage_online_fc_location_toggle === '0' || wordpress_vars.six_storage_online_fc_location_toggle == '' || wordpress_vars.six_storage_online_fc_location_toggle == null) && (wordpress_vars.six_storage_online_fc_price_range_toggle === '0' || wordpress_vars.six_storage_online_fc_price_range_toggle == '' || wordpress_vars.six_storage_online_fc_price_range_toggle == null) && (wordpress_vars.six_storage_online_fc_sort_by_toggle === '0' || wordpress_vars.six_storage_online_fc_sort_by_toggle == '' || wordpress_vars.six_storage_online_fc_sort_by_toggle == null) && (wordpress_vars.six_storage_online_fc_unit_size_filter_toggle === '0' || wordpress_vars.six_storage_online_fc_unit_size_filter_toggle == '' || wordpress_vars.six_storage_online_fc_unit_size_filter_toggle == null) && (wordpress_vars.six_storage_online_fc_unit_type_toggle === '0' || wordpress_vars.six_storage_online_fc_unit_type_toggle == '' || wordpress_vars.six_storage_online_fc_unit_type_toggle == null)) {
              //document.querySelector(".applyfilterbutton").style.display = "none";
              document.getElementById("six-storage-applyfilter").style.display = "none";
            } else {
              //document.querySelector(".applyfilterbutton").style.display = "block";
              document.getElementById("six-storage-applyfilter").style.display = "inline-block";
              document.getElementById('six-storage-applyfilter').setAttribute("disabled", "disabled");
              document.getElementById("six-storage-tenant_type").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-storage-type").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-location").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-building").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-unit-type-dimensions").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-amenitytype").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-sorting").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-unit-type").addEventListener('change', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
              document.getElementById("six-storage-range-slider").addEventListener('click', function (event) {
                document.getElementById('six-storage-applyfilter').removeAttribute("disabled");
              });
            }

            _this6.sixStorageConstructStorageTypeOptions(_this6.sixstorageStorageCategoryFilterResponse);
          }
        }
      })["catch"](function (error) {
        console.log(error);
      });
      ;
    }
  }, {
    key: "checkStoragePriceRange",
    value: function checkStoragePriceRange(PriceRangeArray, storageCategoryValue) {
      var PriceArray = [];
      var NewPriceValue, minvalue, MaxValue;
      PriceRangeArray.map(function (array) {
        if (array.storageTypeId === storageCategoryValue) {
          PriceArray.push({
            storageTypeId: array.storageTypeId,
            MinPrice: array.MinPrice,
            MaxPrice: array.MaxPrice
          });
        }
      });
      minvalue = Math.min.apply(Math, PriceArray.map(function (o) {
        return o.MinPrice;
      }));

      if (minvalue == Infinity) {
        minvalue = 0;
      }

      MaxValue = Math.max.apply(Math, PriceArray.map(function (o) {
        return o.MaxPrice;
      }));

      if (MaxValue == -Infinity) {
        MaxValue = 0;
      }

      NewPriceValue = {
        "minPrice": minvalue,
        "maxPrice": MaxValue
      };

      if (storageCategoryValue == "") {
        minvalue = Math.min.apply(Math, PriceRangeArray.map(function (o) {
          return o.MinPrice;
        }));

        if (minvalue == Infinity) {
          minvalue = 0;
        }

        MaxValue = Math.max.apply(Math, PriceRangeArray.map(function (o) {
          return o.MaxPrice;
        }));

        if (MaxValue == -Infinity) {
          MaxValue = 0;
        }

        NewPriceValue = {
          "minPrice": minvalue,
          "maxPrice": MaxValue
        };
      }

      this.sixStorageConstructUnitPriceRange(NewPriceValue);
    }
  }, {
    key: "sixStorageConstructStorageTypeOptions",
    value: function sixStorageConstructStorageTypeOptions(storage) {
      var _this7 = this;

      var buildinglist;
      var locationselectId = sessionStorage.getItem("Locationlist");
      var StorageTypeId = sessionStorage.getItem("StorageTypeId");
      var storageTypename = sessionStorage.getItem("storageTypename");
      var select = document.getElementById("six-storage-storage-type");
      var sixstorageLocation = document.getElementById("six-storage-location");
      var sixstoragebuilding = document.getElementById("six-storage-building");
      var sixstorageamenitytype = document.getElementById("six-storage-amenitytype");
      var sixstorageunitype = document.getElementById("six-storage-unit-type");

      if (typeof this.sixstorageBuildingFilterResponse !== null && this.sixstorageBuildingFilterResponse.length > 0) {
        buildinglist = this.sixstorageBuildingFilterResponse.filter(function (obj, index) {
          return index === _this7.sixstorageBuildingFilterResponse.findIndex(function (o) {
            return obj.buildingId === o.buildingId && obj.buildingName === o.buildingName;
          });
        });
      }

      if (typeof select === "undefined" || select === null) {
        return;
      }

      if (typeof storage === "undefined" || storage === null) {
        return;
      }

      this.sixStorageClearSelect(select); // let emptyOption = document.createElement("option");
      // emptyOption.text = `${/*Select Storage Category*/ wordpress_vars.six_storage_online_mi_Select_Storage_Category}`;
      // emptyOption.value = "";
      // select.appendChild(emptyOption);

      if (storage.length > 1) {
        storage.unshift({
          storageTypeId: "",
          storageTypeName: "Select All"
        });
      }

      storage.forEach(function (item) {
        var option = document.createElement("option");

        if (item.storageTypeId === StorageTypeId && item.storageTypeName === storageTypename) {
          option.setAttribute("selected", "selected");
        }

        option.value = item.storageTypeId;
        option.text = item.storageTypeName;
        select.appendChild(option);
      });

      if (typeof storage !== "undefined" && storage !== null) {
        if (storage.length > 1 || storage.length == 1) {
          var Locationfilter = [];
          var Buildingfilter = [];
          var UnitTypefilter = [];
          var AmenityFilter = [];
          var PriceRangeFilter = [];

          if (!StorageTypeId) {
            select.value = storage[0]["storageTypeId"]; //Locationfilter = this.sixstorageLocationFilterResponse;

            Locationfilter = _toConsumableArray(new Map(this.sixstorageLocationFilterResponse.map(function (item) {
              return [item['locationId'], item];
            })).values()); //Buildingfilter = this.sixstorageBuildingFilterResponse;

            UnitTypefilter = this.sixstorageUnitTypeFilterResponse; //AmenityFilter = this.sixstorgaeAmenityFilterResponse;
            //PriceRangeFilter = this.sixstoragePriceRangeResponse;
          } else {
            Locationfilter = this.sixstorageLocationFilterResponse.filter(function (i) {
              return i.storageTypeId === select.value;
            });
            Buildingfilter = this.sixstorageBuildingFilterResponse.filter(function (i) {
              return i.storageTypeId === select.value;
            });
            UnitTypefilter = this.sixstorageUnitTypeFilterResponse.filter(function (i) {
              return i.storageTypeId === select.value;
            });
            AmenityFilter = this.sixstorgaeAmenityFilterResponse.filter(function (i) {
              return i.storageTypeId === select.value;
            }); //PriceRangeFilter = this.sixstoragePriceRangeResponse.filter(i => i.storageTypeID === select.value);
          }

          this.checkStoragePriceRange(this.sixstoragePriceRangeResponse, select.value);
          this.sixStorageSearchUnits();
          this.sixStorageConstructLocationOptions(Locationfilter);

          if (typeof Buildingfilter !== "undefined" && Buildingfilter !== null && Buildingfilter.length > 0) {
            this.sixStorageConstructBuildingOptions(Buildingfilter);
          } else {
            this.sixStorageConstructBuildingOptions(buildinglist);
          }

          this.sixStorageConstructUnitTypeOptions(UnitTypefilter);
          this.sixStorageConstructAmenitiesOptions(AmenityFilter);
        }
      }

      _materialize["default"].AutoInit();
    }
  }, {
    key: "sixStorageGetClientConfig",
    value: function sixStorageGetClientConfig() {
      var _this8 = this;

      var formData = new FormData();
      formData.append("isAjax", true);
      formData.append("action", "six_storage_get_client_config");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var initialloader = document.getElementById("six-storage-loading-container");

      if (typeof initialloader !== "undefined" && initialloader !== null && initialloader !== "") {
        initialloader.innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      }

      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response8 = JSON.parse(data);

          if (typeof Storage !== "undefined") {
            /**** End Invoice Recurring ***/
            var addDays = function addDays(days) {
              var result = new Date();
              result.setDate(result.getDate() + parseInt(days - 1));
              return result;
            };

            var cultureValues = _response8.result;

            if (_response8.returnMessage == "Invalid Auth Token.") {
              document.getElementById("six-storage-loading-container").innerHTML = _this8.helper.sixStorageShowBusyIndicator(false);
            }

            sessionStorage.setItem("SixStorageclientConfig", JSON.stringify(_response8.result));

            _this8.sixStorageInitializePriceRange();

            _this8.sixStorageSetConfig(cultureValues);

            _this8.helper.culture = cultureValues.culture.culture;
            _this8.helper.dateFormat = cultureValues.culture.shortDate;
            _this8.helper.currency = cultureValues.culture.currency;

            if (typeof cultureValues !== 'undefined' && cultureValues !== null && cultureValues !== "" && typeof cultureValues.autoPaymentsEnabled !== "undefined" && cultureValues.autoPaymentsEnabled === true && cultureValues.culture.isSavedCardsByDefault === false) {
              document.getElementById("six-storage-use-save-card-container").style.display = "block";
              document.getElementById("six-storage-save_card_autopay").checked = false;
              document.getElementById("six-storage-turn_on_autopay").checked = false;
            } else if (typeof cultureValues !== 'undefined' && cultureValues !== null && cultureValues !== "" && typeof cultureValues.autoPaymentsEnabled !== "undefined" && cultureValues.autoPaymentsEnabled === false && cultureValues.culture.isSavedCardsByDefault === false) {
              document.getElementById("six-storage-use-save-card-container").style.display = "none";
              document.getElementById("six-storage-save_card_autopay").checked = false;
              document.getElementById("six-storage-turn_on_autopay").checked = false;
            } else if (typeof cultureValues !== 'undefined' && cultureValues !== null && cultureValues !== "" && typeof cultureValues.autoPaymentsEnabled !== "undefined" && cultureValues.autoPaymentsEnabled === true && cultureValues.culture.isSavedCardsByDefault === true) {
              document.getElementById("six-storage-saveCardSection").style.display = "block";
              document.getElementById("six-storage-use-save-card-container").style.display = "none";
              document.getElementById("six-storage-save_card_autopay").checked = true;
              document.getElementById("six-storage-turn_on_autopay").checked = true;
            } else {
              document.getElementById("six-storage-saveCardSection").style.display = "block";
              document.getElementById("six-storage-use-save-card-container").style.display = "none";
            }

            var clientconfigvalue = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
            /**** Start Invoice Period ***/

            var invoiceperiodlistings = clientconfigvalue.invoicePeriods;

            if (invoiceperiodlistings.length <= 1) {
              document.getElementById("six-storage-invoice_period_hide").style.display = 'none';
            } else {
              document.getElementById("six-storage-invoice_period_hide").style.display = '';
            }

            var invoiceperiodnew = document.getElementById("six-storage-invoice-period-new");

            if (typeof invoiceperiodnew === "undefined" || invoiceperiodnew === null) {
              return;
            }

            _this8.sixStorageClearinvoiceSelect(invoiceperiodnew);

            if (typeof invoiceperiodlistings !== "undefined" && invoiceperiodlistings !== null && invoiceperiodlistings !== "") {
              invoiceperiodlistings.forEach(function (invocieperioditems) {
                var option = document.createElement("option");

                if (invocieperioditems.preferred) {
                  option.setAttribute("selected", "selected");
                }

                option.value = invocieperioditems.invoicePeriodId;
                option.text = invocieperioditems.invoicePeriod;
                invoiceperiodnew.appendChild(option);
              });
            }
            /**** End Invoice Period ***/

            /**** Start Invoice Recurring ***/


            var invoice_recurring_listing = clientconfigvalue.recurringTypes;

            if (invoice_recurring_listing.length <= 1) {
              document.getElementById("invoice_recurring_hide").style.display = 'none';
            } else {
              document.getElementById("invoice_recurring_hide").style.display = '';
            }

            var invoice_recurring_get = document.getElementById("six-storage-invoice-reccuring-new");

            _this8.sixStorageClearinvoiceSelect(invoice_recurring_get);

            if (typeof invoice_recurring_listing !== "undefined" && invoice_recurring_listing !== null && invoice_recurring_listing !== "") {
              invoice_recurring_listing.forEach(function (invoicerecurringitems) {
                var option = document.createElement("option");
                option.value = invoicerecurringitems.recurringTypeId;
                option.text = invoicerecurringitems.recurringLabel;
                invoice_recurring_get.appendChild(option);
              });
            }

            if (clientconfigvalue !== null && typeof clientconfigvalue !== "undefined" && clientconfigvalue !== "") {
              var recurringType = clientconfigvalue.recurringTypes;
              typeof recurringType !== 'undefined' && recurringType !== null && recurringType !== '' && recurringType.length > 0 ? recurringType.map(function (item, i) {
                if (typeof item.recurringTypeId !== 'undefined' && item.recurringTypeId !== null && item.recurringTypeId == '1') {
                  _this8.firstOfMonthEnabled = true;
                }

                if (typeof item.recurringTypeId !== 'undefined' && item.recurringTypeId !== null && item.recurringTypeId == '3') {
                  _this8.anniversaryenabled = true;
                }
              }) : '';
              var invoice_period = document.getElementById("six-storage-invoice-period-new");
              var invoice_recurring = document.getElementById("six-storage-invoice-reccuring-new");
              var additional_months = document.getElementById("six-storage-additional-months");
              var additional_months_div = document.getElementById("six-storage-additional-months-div");

              if (parseInt(invoice_period.value) <= 4) {
                if (_this8.anniversaryenabled === true) {
                  invoice_recurring.value = 3;
                  additional_months.value = 0;
                  additional_months.style.display = 'none';
                  additional_months_div.style.display = "none";
                  additional_months.setAttribute("disabled", "disabled");
                  invoice_recurring.setAttribute("disabled", "disabled");
                } else if (_this8.firstOfMonthEnabled === true) {
                  invoice_recurring.value = 1;
                  additional_months.value = 0;
                  additional_months.style.display = 'none';
                  additional_months_div.style.display = "none";
                  additional_months.setAttribute("disabled", "disabled");
                  invoice_recurring.setAttribute("disabled", "disabled");
                }
              }
            }

            var moveInAfter = typeof wordpress_vars.six_storage_online_fc_move_in_after !== 'undefined' && wordpress_vars.six_storage_online_fc_move_in_after !== '' && wordpress_vars.six_storage_online_fc_move_in_after !== null && wordpress_vars.six_storage_online_fc_move_in_after > 0 ? parseInt(wordpress_vars.six_storage_online_fc_move_in_after) + 1 : 1;
            var moveInUpto = typeof wordpress_vars.six_storage_online_fc_move_in_upto !== 'undefined' && wordpress_vars.six_storage_online_fc_move_in_upto !== '' && wordpress_vars.six_storage_online_fc_move_in_upto !== null && wordpress_vars.six_storage_online_fc_move_in_upto > 0 ? parseInt(wordpress_vars.six_storage_online_fc_move_in_upto) + 1 : 30;
            var date = new Date();
            var moveinMinDate = addDays(moveInAfter);
            var moveinMaxDate = addDays(moveInUpto);

            _this8.sixStorageInitDatepicker("#six-storage-dtmoveindate", moveinMinDate, moveinMaxDate, null, date);

            _this8.sixStorageInitDatepicker("#six-storage-movein-date", moveinMinDate, moveinMaxDate, null, date); // this.sixStorageChangeLocation();

          }
        }
      });
    }
  }, {
    key: "sixStorageInitializePriceRange",
    value: function sixStorageInitializePriceRange() {
      var priceRangeSlider = document.getElementById('six-storage-range-slider');
      var test = noUiSlider.create(priceRangeSlider, {
        start: [0, 100],
        connect: true,
        tooltips: false,
        step: 1,
        orientation: 'horizontal',
        // 'horizontal' or 'vertical'
        range: {
          'min': 0,
          'max': 10000000
        },
        format: wNumb({
          decimals: 2
        })
      });
      document.getElementById('six-storage-price-min').innerHTML = 0;
      document.getElementById('six-storage-price-max').innerHTML = 100;
      test.on('change', function () {
        var priceRange = document.getElementById("six-storage-range-slider");
        document.getElementById('six-storage-price-min').innerHTML = priceRange.noUiSlider.get()[0];
        document.getElementById('six-storage-price-max').innerHTML = priceRange.noUiSlider.get()[1];
      });
      this.sixStorageLoadAllApiCall();
    }
  }, {
    key: "sixStorageSetConfig",
    value: function sixStorageSetConfig(config) {
      if (typeof config !== 'undefined' && config !== null) {
        this.moveinFieldSettings = config['moveinFieldSettings'];
        this.timeZones = this.sixStorageConstructTimeZone(config['timezones']); // this.displayTimezones = config['displayTimezones'];

        this.identityTypes = config['identityFields']; // this.displayInclusiveofTax = config['inclusiveofTax'];

        this.unitRentInclusiveTax = config['unitRentInclusiveTax'];
        sessionStorage.setItem("moveinFieldSettings", JSON.stringify(this.moveinFieldSettings));
      }
    }
    /**
       * @param  {} title
       * @param  {} message
       * @param  {} type - warning, error, success, info
       * @param  {} isConfirm
       * @param  {} callback
       */

  }, {
    key: "sixStorageAlertMessage",
    value: function sixStorageAlertMessage(title, message, type, isConfirm, callback) {
      var alert = (0, _sweetalert["default"])({
        title: typeof title !== "undefined" && title !== null ? title : "",
        text: typeof message !== "undefined" && message !== null ? message : "",
        icon: typeof type !== "undefined" && type !== null ? type : "",
        buttons: {
          cancel: typeof isConfirm !== "undefined" && isConfirm !== null && isConfirm == true ? null : {
            text: "Cancel",
            value: null,
            visible: false,
            className: "",
            closeModal: true
          },
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        },
        closeOnClickOutside: typeof isConfirm !== "undefined" && isConfirm !== null && isConfirm == true ? false : true
      });

      if (typeof isConfirm !== "undefined" && isConfirm === true && typeof callback !== 'undefined' && callback !== null) {
        alert.then(function (value) {
          if (value) {
            callback(value);
          }
        });
      }
    }
  }, {
    key: "sixStorageDisplayDate",
    value: function sixStorageDisplayDate(date) {
      return this.helper.sixStorageDisplayDate(date);
    }
  }, {
    key: "sixStorageDisplayCurrency",
    value: function sixStorageDisplayCurrency(price) {
      return this.helper.sixStorageDisplayCurrency(price);
    }
  }, {
    key: "sixStorageUpdateUnitSelection",
    value: function sixStorageUpdateUnitSelection(unitId) {
      var _this9 = this;

      if (typeof unitId === "undefined" || unitId === null || unitId === "") {
        return;
      }

      document.getElementById("six-storage-rent-now-err").style.display = "none";
      var index = this.listedUnit.indexOf(unitId);

      if (index > -1) {
        this.listedUnit.splice(index, 1);
      } else {
        if (typeof this.listedUnit === "undefined" || this.listedUnit === null) {
          this.listedUnit = [];
        }

        this.listedUnit.push(unitId);
      }

      var units = this.units.filter(function (i) {
        return _this9.listedUnit.some(function (id) {
          return i.id === id;
        });
      });
      this.unitsSelectedInfo = [].concat(_toConsumableArray(this.unitsSelectedInfo), _toConsumableArray(units));
      this.unitsSelectedInfo = this.unitsSelectedInfo.filter(function (i) {
        return _this9.listedUnit.some(function (id) {
          return i.id === id;
        });
      });
      var keys = ["id"];
      this.unitsSelectedInfo = this.unitsSelectedInfo.filter(function (s) {
        return function (o) {
          return function (k) {
            return !s.has(k) && s.add(k);
          }(keys.map(function (k) {
            return o[k];
          }).join("|"));
        };
      }(new Set()));
      this.sixStorafeConstructUnitSelection(this.unitsSelectedInfo);
    }
  }, {
    key: "sixStorageDeSelectedUnits",
    value: function sixStorageDeSelectedUnits(unitId) {
      var checkbox = document.getElementById("six-storage-unit-selection-" + unitId);

      if (typeof checkbox !== "undefined" && checkbox !== null) {
        checkbox.checked = false;
      }

      this.sixStorageUpdateUnitSelection(unitId);
    }
  }, {
    key: "sixStorageRemoveUnit",
    value: function sixStorageRemoveUnit(unitId) {
      var _this10 = this;

      this.sixStorageDeSelectedUnits(unitId);
      this.unitsSelectedInfo.forEach(function (item, index) {
        if (item.id == unitId) {
          this.unitsSelectedInfo.splice(index, 1);
        }
      }.bind(this));
      this.unitsRentInformation.forEach(function (item, index) {
        if (item.unitInfo.id == unitId) {
          this.unitsRentInformation.splice(index, 1);
        }
      }.bind(this));

      if (this.unitsRentInformation.length == 0) {
        alert("Re-directing to Unit selection and Please select at least a unit");
        this.sixStorageGoBack();
      }

      var move_in_date = document.getElementById("six-storage-movein-date");
      var html = this.sixStorageConstructUnitDetails(this.unitsRentInformation);
      document.getElementById("six-storage-unit-details-container").innerHTML = html;
      var date = new Date();
      this.sixStorageInitDatepickerClassname("six-storage-date-control-custom-fields", new Date("".concat(date.getFullYear() - 60, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), new Date("".concat(date.getFullYear() + 20, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())));

      if (wordpress_vars.scheduledMoveOutEnabled === '1') {
        var addDays = function addDays(days) {
          var moveindate = _this10.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value);

          var result = new Date(moveindate);
          result.setDate(result.getDate() + parseInt(days));
          return result;
        }; // Change min date to next day of move-in date to avoid same move-in and move-out date
        // let six_storage_online_schedule_minimum_days = wordpress_vars.six_storage_online_fc_schedule_minimum_days_custom_word;
        // if(typeof six_storage_online_schedule_minimum_days !== "undefined" && six_storage_online_schedule_minimum_days !== null){
        //     if(six_storage_online_schedule_minimum_days == '0'){
        //       six_storage_online_schedule_minimum_days = '1';
        //     }
        // }


        var minDate = addDays(wordpress_vars.six_storage_online_fc_schedule_minimum_days_custom_word);
        var maxDate = addDays(wordpress_vars.six_storage_online_fc_schedule_maximum_days_custom_word);
        this.sixStorageInitDatepickerClassname("six-storage-date-control-desired-moveout", minDate, maxDate);
      } else {
        var _date = new Date();

        var momentDate = new Date(this.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value));
        momentDate.setDate(momentDate.getDate() + 1);
        this.sixStorageInitDatepickerClassname("six-storage-date-control-desired-moveout", momentDate, new Date("".concat(_date.getFullYear() + 20, "-").concat(_date.getMonth() + 1, "-").concat(_date.getDate())));
      }

      this.sixStorageHighlightInputLabel("six-storage-date-control-desired-moveout");

      _materialize["default"].AutoInit();
    }
  }, {
    key: "sixStorafeConstructUnitSelection",
    value: function sixStorafeConstructUnitSelection(data) {
      var html = "";
      data.forEach(function (item) {
        html += this.sixStorafeConstructUnitSelectionHTML(item);
      }.bind(this));
      document.getElementById("six-storage-selected-units-contianer").innerHTML = html;
      setTimeout(function () {
        document.querySelectorAll('.six-storage-chip').forEach(function (ele) {
          ele.classList.remove('six-storage-scale-out');
        });
      }, 100);
    }
  }, {
    key: "sixStorafeConstructUnitSelectionHTML",
    value: function sixStorafeConstructUnitSelectionHTML(data) {
      var unitNumber = typeof data.unitNumber !== "undefined" && data.unitNumber !== null ? data.unitNumber : "";
      var unitId = typeof data.id !== "undefined" && data.id !== null ? data.id : "";
      var html = '<div class="six-storage-chip cc six-storage-flexbox-important six-storage-grey six-storage-lighten-4 six-storage-align-items-center six-storage-grid-pr5 six-storage-scale-transition six-storage-scale-out"><span><b>' + unitNumber + " </b></span><i onclick=\"sixStorageDeSelectedUnits('" + unitId + "')\" class='six-storage-red-text six-storage-close six-storage-opacity-1  six-storage-grid-d-flex six-storage-align-items-center'><svg width='1em' height='1em' viewBox='0 0 16 16' class='bi bi-dash-circle six-storage-red-text' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>" + "<path fill-rule='evenodd' d='M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/>" + "<path fill-rule='evenodd' d='M3.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5z'/>" + "</svg ></i ></div > ";
      return html;
    }
  }, {
    key: "sixStorageFilterLocation",
    value: function sixStorageFilterLocation() {
      var _this11 = this;

      var sixstorageLocation = document.getElementById("six-storage-location");
      this.sixStorageClearSelect(sixstorageLocation);
      var sixstoragebuilding = document.getElementById("six-storage-building");
      this.sixStorageClearSelect(sixstoragebuilding);
      var sixstorageamenitytype = document.getElementById("six-storage-amenitytype");
      this.sixStorageClearSelect(sixstorageamenitytype);
      var sixstorageCategory = document.getElementById("six-storage-storage-type");
      var UnitType = document.getElementById("six-storage-unit-type");
      this.sixStorageClearSelect(UnitType);

      if (typeof this.sixstorageLocationFilterResponse !== "undefined" && this.sixstorageLocationFilterResponse !== null && this.sixstorageLocationFilterResponse.length > 0) {
        var Locationfilter = this.sixstorageLocationFilterResponse.filter(function (i) {
          return i.storageTypeId === sixstorageCategory.value;
        });

        if (sixstorageCategory.value == "") {
          Locationfilter = _toConsumableArray(new Map(this.sixstorageLocationFilterResponse.map(function (item) {
            return [item['locationId'], item];
          })).values());
        }

        sessionStorage.setItem("sixStorageLocationLength", Locationfilter.length);
        this.sixStorageConstructLocationOptions(Locationfilter);
      }

      if (typeof this.sixstorageBuildingFilterResponse !== "undefined" && this.sixstorageBuildingFilterResponse !== null && this.sixstorageBuildingFilterResponse.length > 0) {
        var Buildingfilter = this.sixstorageBuildingFilterResponse.filter(function (i) {
          return i.storageTypeId === sixstorageCategory.value;
        });

        if (sixstorageCategory.value == "") {
          //Buildingfilter = this.sixstorageBuildingFilterResponse;
          Buildingfilter = this.sixstorageBuildingFilterResponse.filter(function (obj, index) {
            return index === _this11.sixstorageBuildingFilterResponse.findIndex(function (o) {
              return obj.buildingId === o.buildingId && obj.buildingName === o.buildingName;
            });
          });
        }

        this.sixStorageConstructBuildingOptions(Buildingfilter);
      }

      if (typeof this.sixstorageUnitTypeFilterResponse !== "undefined" && this.sixstorageUnitTypeFilterResponse !== null && this.sixstorageUnitTypeFilterResponse.length > 0) {
        var UnitTypefilter = this.sixstorageUnitTypeFilterResponse.filter(function (i) {
          return i.storageTypeId === sixstorageCategory.value;
        });

        if (sixstorageCategory.value == "") {
          UnitTypefilter = this.sixstorageUnitTypeFilterResponse;
        }

        this.sixStorageConstructUnitTypeOptions(UnitTypefilter);
      }

      if (typeof this.sixstorgaeAmenityFilterResponse !== "undefined" && this.sixstorgaeAmenityFilterResponse !== null && this.sixstorgaeAmenityFilterResponse.length > 0) {
        var AmenityFilter = this.sixstorgaeAmenityFilterResponse.filter(function (i) {
          return i.storageTypeId === sixstorageCategory.value;
        }); //if(sixstorageCategory.value==""){
        //  AmenityFilter = this.sixstorgaeAmenityFilterResponse;
        //}

        this.sixStorageConstructAmenitiesOptions(AmenityFilter);
      } else {
        this.sixStorageConstructAmenitiesOptions();
      }

      this.checkStoragePriceRange(this.sixstoragePriceRangeResponse, sixstorageCategory.value);
    }
  }, {
    key: "sixStorageFilterLocationBuilding",
    value: function sixStorageFilterLocationBuilding() {
      var location = document.getElementById('six-storage-location');
      var locationid = location.options[location.selectedIndex].getAttribute("data-locationid");
      var storagetypeid = location.options[location.selectedIndex].getAttribute("data-storagetypeid");
      var Buildingfilter = this.sixstorageBuildingFilterResponse.filter(function (i) {
        return i.locationId === locationid && i.storageTypeId === storagetypeid;
      });
      var sixstoragebuilding = document.getElementById("six-storage-building");
      this.sixStorageClearSelect(sixstoragebuilding);
      this.sixStorageConstructBuildingOptions(Buildingfilter);
    }
  }, {
    key: "sixStorageChangeLocation",
    value: function sixStorageChangeLocation() {
      var _this12 = this;

      document.getElementById("six-storage-enquiry-container").style.display = "none";
      document.getElementById("six-storage-rent-now-container").style.display = "none";

      if (this.unitsSelectedInfo !== null && this.unitsSelectedInfo !== 'undefined' && this.unitsSelectedInfo.length > 0) {
        this.unitsSelectedInfo.map(function (item, i) {
          var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

          if (typeof checkbox !== "undefined" && checkbox !== null) {
            checkbox.checked = false;
          }

          _this12.sixStorageUpdateUnitSelection(item.id);
        });
      }

      document.getElementById("six-storage-rent-now-err").style.display = "none";
      this.selectedUnitTypes = [];

      if (this.unitsSelected.length > 0) {
        this.sixStorageresetUnitSelection();
        return;
      }

      var noUnitData = document.querySelector(".six-storage-no-unit-data").innerHTML;
      document.getElementById("six-storage-online-unit-collection-contianer").innerHTML = "";
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      this.sixStorageUpdateLoadMore(0);
      var storageType = document.getElementById("six-storage-storage-type");
      document.getElementById("six-storage-no-units-data").style.display = "none";
      var obj = {
        storageTypeId: typeof storageType !== 'undefined' && storageType !== null && storageType !== '' && typeof storageType.value !== 'undefined' && storageType.value !== null && storageType.value !== '' ? storageType.value : ''
      };
      var formData = new FormData();
      formData.append("action", "six_storage_change_location");
      formData.append("storageType", obj.storageTypeId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        var response = JSON.parse(data);

        if (typeof data !== "undefined" && data !== null) {
          if (typeof response.isSuccess !== "undefined" && response !== null && response.isSuccess === true && typeof response.result !== 'undefined' && response.result !== null && response.result !== '') {
            _this12.sixStorageConstructLocationOptions(response.result);
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this12.helper.sixStorageShowBusyIndicator(false);
            document.getElementById("six-storage-no-units-data").style.display = "block";
            document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;
            document.getElementById("six-storage-rent-now-container").style.display = "none";

            _this12.sixStorageShowUnitsMessage(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this12.helper.sixStorageShowBusyIndicator(false);
          document.getElementById("six-storage-no-units-data").style.display = "block";
          document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;
          document.getElementById("six-storage-rent-now-container").style.display = "none";

          _this12.sixStorageShowUnitsMessage(false);
        }

        _materialize["default"].AutoInit();
      })["catch"](function (err) {
        document.getElementById("six-storage-loading-container").innerHTML = _this12.helper.sixStorageShowBusyIndicator(false);
        document.getElementById("six-storage-no-units-data").style.display = "block";
        document.getElementById("six-storage-no-units").innerHTML = "".concat(
        /*Something went wrong please contact support team*/
        wordpress_vars.six_storage_online_fs_Something_went_wrong_please);
        document.getElementById("six-storage-rent-now-container").style.display = "none";

        _this12.sixStorageShowUnitsMessage(false);
      });
    }
  }, {
    key: "sixStorageChangeBuilding",
    value: function sixStorageChangeBuilding() {
      var _this13 = this;

      document.getElementById("six-storage-enquiry-container").style.display = "none";
      document.getElementById("six-storage-rent-now-container").style.display = "none";

      if (this.unitsSelectedInfo !== null && this.unitsSelectedInfo !== 'undefined' && this.unitsSelectedInfo.length > 0) {
        this.unitsSelectedInfo.map(function (item, i) {
          var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

          if (typeof checkbox !== "undefined" && checkbox !== null) {
            checkbox.checked = false;
          }

          _this13.sixStorageUpdateUnitSelection(item.id);
        });
      }

      document.getElementById("six-storage-online-unit-collection-contianer").innerHTML = "";
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      document.getElementById("six-storage-rent-now-err").style.display = "none";
      this.selectedUnitTypes = [];
      this.sixStorageUpdateLoadMore(0); // this.sixStorageClearSelect(select);
      //this.sixStorageShowUnitsMessage(true);

      document.getElementById("six-storage-no-units-data").style.display = "none";
      var storageType = document.getElementById("six-storage-storage-type");
      var locationObj = document.getElementById("six-storage-location");
      var obj = {
        storageTypeId: typeof storageType !== 'undefined' && storageType !== null && storageType !== '' && typeof storageType.value !== 'undefined' && storageType.value !== null && storageType.value !== '' ? storageType.value : '',
        locationId: typeof locationObj !== 'undefined' && locationObj !== null && locationObj !== '' && typeof locationObj.value !== 'undefined' && locationObj.value !== null && locationObj.value !== '' ? locationObj.value : ''
      };
      var formData = new FormData();
      formData.append("action", "six_storage_change_building");
      formData.append("storageType", obj.storageTypeId);
      formData.append("location", obj.locationId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        var response = JSON.parse(data); //document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          if (typeof response.isSuccess !== "undefined" && response !== null && response.isSuccess === true && typeof response.result !== 'undefined' && response.result !== null && response.result !== '') {
            _this13.sixStorageConstructBuildingOptions(response.result);
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this13.helper.sixStorageShowBusyIndicator(false);
            document.getElementById("six-storage-no-units-data").style.display = "block";
            document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;
            document.getElementById("six-storage-rent-now-container").style.display = "none";

            _this13.sixStorageShowUnitsMessage(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this13.helper.sixStorageShowBusyIndicator(false);
          document.getElementById("six-storage-no-units-data").style.display = "block";
          document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;
          document.getElementById("six-storage-rent-now-container").style.display = "none";

          _this13.sixStorageShowUnitsMessage(false);
        }

        _materialize["default"].AutoInit();
      })["catch"](function (err) {
        document.getElementById("six-storage-loading-container").innerHTML = _this13.helper.sixStorageShowBusyIndicator(false);
        document.getElementById("six-storage-no-units-data").style.display = "block";
        document.getElementById("six-storage-no-units").innerHTML = "".concat(
        /*Something went wrong please contact support team*/
        wordpress_vars.six_storage_online_fs_Something_went_wrong_please);
        document.getElementById("six-storage-rent-now-container").style.display = "none";

        _this13.sixStorageShowUnitsMessage(false);
      });
      ;
    }
  }, {
    key: "sixstorageChangeLocationFilter",
    value: function sixstorageChangeLocationFilter() {
      var locationObj = document.getElementById("six-storage-location");
      var obj = {
        locationId: typeof locationObj !== 'undefined' && locationObj !== null && locationObj !== '' && typeof locationObj.value !== 'undefined' && locationObj.value !== null && locationObj.value !== '' ? locationObj.value : ''
      };
    }
  }, {
    key: "sixStorageChangeAmenity",
    value: function sixStorageChangeAmenity() {
      var _this14 = this;

      document.getElementById("six-storage-enquiry-container").style.display = "none";
      document.getElementById("six-storage-rent-now-container").style.display = "none";

      if (this.unitsSelectedInfo !== null && this.unitsSelectedInfo !== 'undefined' && this.unitsSelectedInfo.length > 0) {
        this.unitsSelectedInfo.map(function (item, i) {
          var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

          if (typeof checkbox !== "undefined" && checkbox !== null) {
            checkbox.checked = false;
          }

          _this14.sixStorageUpdateUnitSelection(item.id);
        });
      }

      document.getElementById("six-storage-online-unit-collection-contianer").innerHTML = "";
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      document.getElementById("six-storage-rent-now-err").style.display = "none";
      this.selectedUnitTypes = [];
      this.sixStorageUpdateLoadMore(0); //const select = document.getElementById("six-storage-amenity");
      // this.sixStorageClearSelect(select);
      //this.sixStorageShowUnitsMessage(true);

      document.getElementById("six-storage-no-units-data").style.display = "none";
      var storageType = document.getElementById("six-storage-storage-type");
      var locationObj = document.getElementById("six-storage-location");
      var buildingObj = document.getElementById("six-storage-building");
      var obj = {
        storageTypeId: typeof storageType !== 'undefined' && storageType !== null && storageType !== '' && typeof storageType.value !== 'undefined' && storageType.value !== null && storageType.value !== '' ? storageType.value : '',
        locationId: typeof locationObj !== 'undefined' && locationObj !== null && locationObj !== '' && typeof locationObj.value !== 'undefined' && locationObj.value !== null && locationObj.value !== '' ? locationObj.value : '',
        buildingId: typeof buildingObj !== 'undefined' && buildingObj !== null && buildingObj !== '' && typeof buildingObj.value !== 'undefined' && buildingObj.value !== null && buildingObj.value !== '' ? buildingObj.value : ''
      };
      var formData = new FormData();
      formData.append("action", "six_storage_change_amenity");
      formData.append("storageType", obj.storageTypeId);
      formData.append("location", obj.locationId);
      formData.append("building", obj.buildingId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        //document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
        if (typeof data !== "undefined" && data !== null) {
          var _response9 = JSON.parse(data);

          if (typeof _response9.isSuccess !== "undefined" && _response9 !== null && _response9.isSuccess === true) {
            _this14.sixStorageConstructAmenitiesOptions(_response9.result);
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this14.helper.sixStorageShowBusyIndicator(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this14.helper.sixStorageShowBusyIndicator(false);
        }

        _materialize["default"].AutoInit();
      })["catch"](function (err) {
        document.getElementById("six-storage-loading-container").innerHTML = _this14.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageChangePrice",
    value: function sixStorageChangePrice() {
      var _this15 = this;

      var storageType = document.getElementById("six-storage-storage-type");
      var locationObj = document.getElementById("six-storage-location");
      var buildingObj = document.getElementById("six-storage-building");
      var obj = {
        storageTypeId: typeof storageType !== 'undefined' && storageType !== null && storageType !== '' && typeof storageType.value !== 'undefined' && storageType.value !== null && storageType.value !== '' ? storageType.value : '',
        locationId: typeof locationObj !== 'undefined' && locationObj !== null && locationObj !== '' && typeof locationObj.value !== 'undefined' && locationObj.value !== null && locationObj.value !== '' ? locationObj.value : '',
        buildingId: typeof buildingObj !== 'undefined' && buildingObj !== null && buildingObj !== '' && typeof buildingObj.value !== 'undefined' && buildingObj.value !== null && buildingObj.value !== '' ? buildingObj.value : ''
      };
      var formData = new FormData();
      formData.append("action", "six_storage_change_unitPrice");
      formData.append("storageType", obj.storageTypeId);
      formData.append("location", obj.locationId);
      formData.append("building", obj.buildingId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response10 = JSON.parse(data);

          if (typeof _response10.isSuccess !== "undefined" && _response10 !== null && _response10.isSuccess === true) {
            _this15.sixStorageConstructUnitPriceRange(_response10.result);
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this15.helper.sixStorageShowBusyIndicator(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this15.helper.sixStorageShowBusyIndicator(false);
        }

        _materialize["default"].AutoInit();
      })["catch"](function (err) {
        document.getElementById("six-storage-loading-container").innerHTML = _this15.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageConstructUnitPriceRange",
    value: function sixStorageConstructUnitPriceRange(data) {
      //initial calling 
      if (data.minPrice !== data.maxPrice) {
        document.getElementById('six-storage-price-range-div').style.display = '';
        var priceRangeSlider = document.getElementById('six-storage-range-slider');

        if (typeof priceRangeSlider !== "undefined" && priceRangeSlider !== null) {
          priceRangeSlider.noUiSlider.updateOptions({
            start: [data.minPrice, data.maxPrice],
            range: {
              'min': data.minPrice,
              'max': data.maxPrice
            }
          });
        }

        document.getElementById('six-storage-price-min').innerHTML = data.minPrice;
        document.getElementById('six-storage-price-max').innerHTML = data.maxPrice;
      } else {
        document.getElementById('six-storage-price-range-div').style.display = 'none';

        var _priceRangeSlider = document.getElementById('six-storage-range-slider');

        if (typeof _priceRangeSlider !== "undefined" && _priceRangeSlider !== null) {
          _priceRangeSlider.noUiSlider.updateOptions({
            start: [0, 10000000000],
            range: {
              'min': 0,
              'max': 10000000000
            }
          });
        }
      } // this.sixStorageSearchUnits(data);

    }
  }, {
    key: "sixStorageChangeUnitType",
    value: function sixStorageChangeUnitType() {
      var _this16 = this;

      document.getElementById("six-storage-enquiry-container").style.display = "none";
      document.getElementById("six-storage-rent-now-container").style.display = "none";

      if (this.unitsSelectedInfo !== null && this.unitsSelectedInfo !== 'undefined' && this.unitsSelectedInfo.length > 0) {
        this.unitsSelectedInfo.map(function (item, i) {
          var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

          if (typeof checkbox !== "undefined" && checkbox !== null) {
            checkbox.checked = false;
          }

          _this16.sixStorageUpdateUnitSelection(item.id);
        });
      }

      document.getElementById("six-storage-online-unit-collection-contianer").innerHTML = "";
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      document.getElementById("six-storage-rent-now-err").style.display = "none";
      this.selectedUnitTypes = [];
      this.sixStorageUpdateLoadMore(0); // const select = document.getElementById("six-storage-unit-type");
      // this.sixStorageClearSelect(select);

      var locationObj = document.getElementById("six-storage-location");
      var buildingObj = document.getElementById("six-storage-building");
      var storageType = document.getElementById("six-storage-storage-type"); //this.sixStorageShowUnitsMessage(true);

      document.getElementById("six-storage-no-units-data").style.display = "none";
      var obj = {
        storageTypeId: typeof storageType !== 'undefined' && storageType !== null && storageType !== '' && typeof storageType.value !== 'undefined' && storageType.value !== null && storageType.value !== '' ? storageType.value : '',
        buildingId: typeof buildingObj !== 'undefined' && buildingObj !== null && buildingObj !== '' && typeof buildingObj.value !== 'undefined' && buildingObj.value !== null && buildingObj.value !== '' ? buildingObj.value : '',
        locationId: typeof locationObj !== 'undefined' && locationObj !== null && locationObj !== '' && typeof locationObj.value !== 'undefined' && locationObj.value !== null && locationObj.value !== '' ? locationObj.value : ''
      };
      var formData = new FormData();
      formData.append("action", "six_storage_change_unit_type");
      formData.append("building", obj.buildingId);
      formData.append("storageType", obj.storageTypeId);
      formData.append("location", obj.locationId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        //document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
        if (typeof data !== "undefined" && data !== null) {
          var _response11 = JSON.parse(data);

          if (typeof _response11.isSuccess !== "undefined" && _response11 !== null && _response11.isSuccess === true && typeof _response11.result !== 'undefined' && _response11.result !== null && _response11.result !== '') {
            _this16.sixStorageConstructUnitTypeOptions(_response11.result);

            _this16.arrayOfUnitTypes = _response11.result;
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this16.helper.sixStorageShowBusyIndicator(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this16.helper.sixStorageShowBusyIndicator(false);
        }
      })["catch"](function (err) {
        document.getElementById("six-storage-loading-container").innerHTML = _this16.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageChangeUnits",
    value: function sixStorageChangeUnits() {
      var _this17 = this;

      document.getElementById("six-storage-enquiry-container").style.display = "none";
      document.getElementById("six-storage-rent-now-container").style.display = "none";

      if (this.unitsSelectedInfo !== null && this.unitsSelectedInfo !== 'undefined' && this.unitsSelectedInfo.length > 0) {
        this.unitsSelectedInfo.map(function (item, i) {
          var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

          if (typeof checkbox !== "undefined" && checkbox !== null) {
            checkbox.checked = false;
          }

          _this17.sixStorageUpdateUnitSelection(item.id);
        });
      }

      document.getElementById('six-storage-enquiry-container').style.display = 'none';
    }
  }, {
    key: "sixStorageShowUnitsMessage",
    value: function sixStorageShowUnitsMessage(flag) {
      var noUnitData = document.getElementById("six-storage-initial-msg").innerHTML;
      var unitsHtmlContainer = document.getElementById("six-storage-online-unit-collection-contianer");
      unitsHtmlContainer.innerHTML = flag == false ? "" : noUnitData;
      this.sixStorageGridRemove();
    }
  }, {
    key: "sixStorageresetUnitSelection",
    value: function sixStorageresetUnitSelection() {
      if (this.unitsSelected.length > 0) {
        this.unitsSelectedInfo = [];
        this.unitsSelected = [];
        this.sixStorafeConstructUnitSelection(this.unitsSelectedInfo);
        this.sixStorageAlertMessage(null, "".concat(
        /*Selecting another storage type will unselect the previously selected one's!*/
        wordpress_vars.six_storage_online_changing_location_alert_message));
      }
    }
  }, {
    key: "sixStorageChangeTenantType",
    value: function sixStorageChangeTenantType() {
      var _this18 = this;

      if (this.unitsSelectedInfo !== null && this.unitsSelectedInfo !== 'undefined' && this.unitsSelectedInfo.length > 0) {
        this.unitsSelectedInfo.map(function (item, i) {
          var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

          if (typeof checkbox !== "undefined" && checkbox !== null) {
            checkbox.checked = false;
          }

          _this18.sixStorageUpdateUnitSelection(item.id);
        });
      }

      var storageType = document.getElementById("six-storage-storage-type");
      var location = document.getElementById("six-storage-location");
      var building = document.getElementById("six-storage-building");
      var unitType = document.getElementById("six-storage-unit-type");
      var error_count = 0;
      var obj = {
        storageType: typeof storageType !== "undefined" && storageType !== null && typeof storageType.value !== "undefined" && storageType.value !== null ? storageType.value : null,
        location: typeof location !== "undefined" && location !== null && typeof location.value !== "undefined" && location.value !== null && location.value !== "" ? location.value : null,
        building: typeof building !== "undefined" && building !== null && typeof building.value !== "undefined" && building.value !== null && building.value !== "" ? building.value : null,
        unitType: typeof unitType !== "undefined" && unitType !== null && typeof unitType.value !== "undefined" && unitType.value !== null && unitType.value !== "" ? unitType.value : null
      };

      if (this.helper.sixStorageGetTenantType()) {
        document.getElementById("six-storage-company-details").style.display = "";
      } else {
        document.getElementById("six-storage-company-details").style.display = "none";
      }

      Object.entries(obj).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (value == null || value == "") {
          if (key === "unitType" && _this18.groupBySize === true) {
            error_count = error_count;
          } else {
            error_count = error_count + 1;
          }
        }
      });

      if (error_count === 0) {
        document.getElementById('six-storage-enquiry-container').style.display = 'none';
      }
    }
  }, {
    key: "sixStorageGetUnits",
    value: function sixStorageGetUnits(flag, storageTypeId, unitTypeId, PageNumber, countsval) {
      var _this19 = this;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var locationselectedId = sessionStorage.getItem("Locationlist");
      var StorageTypeId = sessionStorage.getItem("StorageTypeId");
      document.getElementById("six-storage-promo_six-storage-discount_carousel").style.display = "none";
      document.getElementById("six-storage-tenantType-err").style.display = "none";
      var storageType = document.getElementById("six-storage-storage-type");
      var locations = document.getElementById("six-storage-location");
      var building = document.getElementById("six-storage-building"); //const unitType = document.getElementById("six-storage-unit-type-dimensions");

      var amenity = document.getElementById("six-storage-amenitytype");
      var sortBy = document.getElementById("six-storage-sorting");
      var sortDirection = document.getElementById("six-storage-sort-icon");
      var priceRange = document.getElementById("six-storage-range-slider");
      setTimeout(function () {
        sessionStorage.removeItem("Locationlist");
        sessionStorage.removeItem("StorageTypeId");
      }, "3000"); // document.getElementById("six-storage-no-units-data").style.display = "none";

      var obj = {
        storageType: typeof storageType !== "undefined" && storageType !== null && typeof storageType.value !== "undefined" && storageType.value !== null ? storageType.value : null,
        locations: typeof locations !== "undefined" && locations !== null && locations !== "" && typeof locations.value !== "undefined" && locations.value !== null && locations.value !== "" ? locations.value : "",
        building: typeof building !== "undefined" && building !== null && typeof building.value !== "undefined" && building.value !== null ? building.value : null,
        unitType: typeof this.sixStorageUnitTypeIdFilterSelected !== "undefined" && this.sixStorageUnitTypeIdFilterSelected !== null && this.sixStorageUnitTypeIdFilterSelected.length > 0 ? this.sixStorageUnitTypeIdFilterSelected : [],
        amenity: typeof amenity !== "undefined" && amenity !== null && typeof amenity.value !== "undefined" && amenity.value !== null ? amenity.value : null,
        sortBy: typeof sortBy !== "undefined" && sortBy !== null && typeof sortBy.value !== "undefined" && sortBy.value !== null ? sortBy.value : null,
        minValue: typeof priceRange !== "undefined" && priceRange !== null && priceRange !== '' && typeof priceRange.noUiSlider !== 'undefined' && priceRange.noUiSlider !== null && priceRange.noUiSlider !== '' && typeof priceRange.noUiSlider.get() !== 'undefined' && priceRange.noUiSlider.get() !== null && priceRange.noUiSlider.get() !== '' && priceRange.noUiSlider.get().length > 0 ? priceRange.noUiSlider.get()[0] : '',
        maxValue: typeof priceRange !== "undefined" && priceRange !== null && priceRange !== '' && typeof priceRange.noUiSlider !== 'undefined' && priceRange.noUiSlider !== null && priceRange.noUiSlider !== '' && typeof priceRange.noUiSlider.get() !== 'undefined' && priceRange.noUiSlider.get() !== null && priceRange.noUiSlider.get() !== '' && priceRange.noUiSlider.get().length > 0 ? priceRange.noUiSlider.get()[1] : '',
        action: "six_storage_move_in_unit_search"
      };
      var formData = new FormData();
      formData.append("action", "six_storage_move_in_unit_search");
      formData.append("isBusinessUser", this.helper.sixStorageGetTenantType());
      formData.append("pageNumber", PageNumber ? PageNumber : this.pageNumber);
      formData.append("pageSize", 10);
      formData.append("building", obj.building);
      formData.append("amenity", obj.amenity);

      if (wordpress_vars.six_storage_grouping_enable === "1") {
        formData.append("sortBy", obj.sortBy !== "" ? obj.sortBy : "UnitPrice");
      } else {
        formData.append("sortBy", obj.sortBy);
      }

      formData.append("sortDirection", sortDirection.dataset.sortvalue);
      formData.append("isBusinessUser", this.helper.sixStorageGetTenantType());
      formData.append("minValue", obj.minValue);
      formData.append("maxValue", obj.maxValue);

      if (typeof storageTypeId !== 'undefined' && storageTypeId !== null && storageTypeId !== '' && typeof unitTypeId !== 'undefined' && unitTypeId !== null && unitTypeId !== '') {
        formData.append("storageType", storageTypeId);
        formData.append("unitType", unitTypeId);
      } else {
        formData.append("storageType", obj.storageType);
        formData.append("unitType", obj.unitType);
      }

      if (typeof this.sixstorageLocationFilterResponse !== "undefined" && this.sixstorageLocationFilterResponse !== null && this.sixstorageLocationFilterResponse !== "" && this.sixstorageLocationFilterResponse.length === 1) {
        var selectLocationId = this.sixstorageLocationFilterResponse[0].locationId;
        formData.append("location", selectLocationId);
      } else if (typeof locationselectedId !== "undefined" && locationselectedId !== null && locationselectedId !== "") {
        formData.append("location", locationselectedId);
      } else {
        formData.append("location", obj.locations);
      }

      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      var unitsHtmlContainer = document.getElementById("six-storage-online-unit-collection-contianer");
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true); //this.sixStorageUpdateLoadMore(0);
      //if (flag !== "LOADMORE") unitsHtmlContainer.innerHTML = "";
      // document.getElementById("six-storage-no-units-data").style.display = "none";

      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        var response = JSON.parse(data);
        document.getElementById("six-storage-loading-container").innerHTML = _this19.helper.sixStorageShowBusyIndicator(false);

        if (_this19.sixstorageotherAPiCall === true) {
          _this19.sixStorageVTwoCommon();

          _this19.sixStorageGetCustomFields();
        }

        if (typeof response.isSuccess !== "undefined" && response !== null && response.isSuccess === true) {
          if (wordpress_vars.six_storage_online_setup_preloader === "0") {
            var _initialloaders5 = document.getElementById("six-storage-loading-container");

            _initialloaders5.style.display = 'block';
          }

          if (response.result && response.result.length > 0) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders6 = document.getElementById("six-storage-loading-container");

              _initialloaders6.style.display = 'none';
            }

            if (typeof wordpress_vars.six_storage_google_analytics_integrated !== "undefined" && wordpress_vars.six_storage_google_analytics_integrated !== null && wordpress_vars.six_storage_google_analytics_integrated !== "" && wordpress_vars.six_storage_google_analytics_integrated === "1") {
              gtag('event', 'page_view', {
                page_title: 'Rent Now - Self Storage',
                page_location: 'Rent Now',
                page_path: '/rent-now#SelfStorage',
                send_to: "".concat(wordpress_vars.six_storage_google_analytics_input_key)
              });
            }

            document.getElementById("six-storage-no-units-available-here").style.display = 'none';

            if (_this19.pageNumber === 0) {
              _this19.units = response.result;
            } else {
              // this.units = [...this.units, ...response.result];
              _this19.units = response.result;
            }

            document.getElementById("six-storage-rent-now-container").style.display = "";

            _this19.sixStoragePromoDiscounts();

            document.querySelector(".six-storage-header-action-wrapper").classList.add('six-storage-grid-shadow-sm');

            if (_this19.groupBySize === true) {
              unitsHtmlContainer.innerHTML = "";
              unitsHtmlContainer.innerHTML = _this19.sixStorageConstructUnitGroupCollection(response.result);
              unitsHtmlContainer.style.display = 'block';
              document.getElementById("six-storage-top-container-buttons").style.display = 'block';

              if (_this19.rentSingleUnit === true) {
                var unitscount = response.result.length;
                var nocount = response.totalCount - _this19.units.length;

                if (response.totalCount > 10) {
                  _this19.sixStoragenocountLoadMore(nocount);
                } else {
                  document.getElementById("six-storage-load-more-container").style.display = 'none';
                }

                if (unitscount < 10) {
                  document.getElementById("six-storage-load-more-container").style.display = 'none';
                } else {
                  document.getElementById("six-storage-load-more-container").style.display = 'block';
                }

                document.getElementById("six-storage-top-container-buttons").classList.remove("six-storage-grid-shadow-sm");
              } else {
                var _unitscount = response.result.length;
                var nocountsingle = response.totalCount - _this19.units.length;

                if (response.totalCount > 10) {
                  _this19.sixStoragenocountLoadMore(nocountsingle);
                } else {
                  document.getElementById("six-storage-load-more-container").style.display = 'none';
                }

                if (_unitscount < 10) {
                  document.getElementById("six-storage-load-more-container").style.display = 'none';
                } else {
                  document.getElementById("six-storage-load-more-container").style.display = 'block';
                }

                document.getElementById("six-storage-top-container-buttons").classList.add("six-storage-grid-shadow-sm");
              }
            } else {
              unitsHtmlContainer.innerHTML = "";
              unitsHtmlContainer.innerHTML = _this19.sixStorageConstructUnitCollection(response.result);
              unitsHtmlContainer.style.display = 'block';
              document.getElementById("six-storage-top-container-buttons").style.display = 'block';

              if (_this19.rentSingleUnit === true) {
                document.getElementById("six-storage-top-container-buttons").classList.remove("six-storage-grid-shadow-sm");
              } else {
                document.getElementById("six-storage-top-container-buttons").classList.add("six-storage-grid-shadow-sm");
              }
            }

            var count = response.totalCount - _this19.units.length;
            var totalpagecount = Math.ceil(response.totalCount / 10);
            var leastcount = Math.ceil(response.totalCount % 10);

            if (typeof flag !== "undefined" && flag === "LOADMORE") {
              if (PageNumber === totalpagecount) {
                _this19.sixStorageUpdateLoadMore(0, PageNumber, leastcount);
              } else {
                _this19.sixStorageUpdateLoadMore(countsval, PageNumber, leastcount);
              }
            } else if (typeof flag !== "undefined" && flag === "PREVIOUS") {
              var previousNum = document.getElementById("sixstoragepreviousbutton");
              var datacount = previousNum.getAttribute("data-count");
              var leastdatacount = previousNum.getAttribute("data-leastcount");
              var previouscount = Number(datacount);
              var previousdata = Number(leastdatacount);

              if (previouscount !== 0) {
                if (PageNumber === 1) {
                  _this19.sixStoragepreviousbutton(count, PageNumber, leastcount);
                } else {
                  _this19.sixStoragepreviousbutton(countsval, PageNumber, leastcount);
                }
              } else {
                if (PageNumber === 1) {
                  _this19.sixStoragepreviousbutton(countsval, PageNumber, leastcount);
                } else {
                  _this19.sixStoragepreviousbutton(countsval, PageNumber, leastcount);
                }
              }
            } else {
              _this19.sixStorageUpdateLoadMore(count, _this19.pageNumber, leastcount); // this.sixStoragepreviousbutton(count, this.pageNumber, leastcount);

            }

            _this19.sixStorageLoadUnitsPrice = true;

            _materialize["default"].AutoInit();

            var isMovable = storageType.options[storageType.selectedIndex].dataset.movable;

            if (typeof isMovable !== "undefined" && isMovable === true) {
              _this19.sixStorageGetBufferTime();
            }

            _this19.loadingDiscounts = true;
          } else {
            //document.getElementById("six-storage-no-units-data").style.display = "block";
            // document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders7 = document.getElementById("six-storage-loading-container");

              _initialloaders7.style.display = 'none';
            }

            document.getElementById("six-storage-rent-now-container").style.display = "none";
            document.getElementById("six-storage-no-units-available-here").style.display = "block";
            document.getElementById("six-storage-no-records-found").style.display = "none";
            var no_units_available_here = document.getElementById("six-storage-no-units-available-here");
            no_units_available_here.innerHTML = "<div class=\"six-storage-grid-mt10 six-storage-tenant-content six-storage-primary-background-color six-storage-grid-d-flex six-storage-flex-column six-storage-justify-content-center six-storage-grid-pl30 six-storage-grid-pr30 six-storage-grid-pb20  six-storage-grid-pt20 six-storage-text-white\"><h1>".concat(wordpress_vars.six_storage_no_units_availble_label_text, "</h1></div>");
            document.getElementById("six-storage-rent-now-container").style.display = "none";

            _this19.sixStorageShowUnitsMessage(false);

            _this19.sixStorageUpdateLoadMore(0);
          }
        } else {
          if (wordpress_vars.six_storage_online_setup_preloader === "0") {
            var _initialloaders8 = document.getElementById("six-storage-loading-container");

            _initialloaders8.style.display = 'block';
          }

          _this19.sixStorageShowUnitsMessage(false);

          _this19.sixStorageUpdateLoadMore(0);
        }
      })["catch"](function (err) {
        document.getElementById("six-storage-rent-now-container").style.display = "none"; // document.getElementById("six-storage-no-units-available-here").style.display = "block";
        //  var no_units_available_here = document.getElementById("six-storage-no-units-available-here");
        //  no_units_available_here.innerHTML =  `<div class="six-storage-grid-mt10 six-storage-tenant-content six-storage-primary-background-color six-storage-grid-d-flex six-storage-flex-column six-storage-justify-content-center six-storage-grid-pl30 six-storage-grid-pr30 six-storage-grid-pb20  six-storage-grid-pt20 six-storage-text-white"><h1>${wordpress_vars.six_storage_no_units_availble_label_text}</h1></div>`;

        unitsHtmlContainer.innerHTML = _this19.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageConstructUnitTypeOptions",
    value: function sixStorageConstructUnitTypeOptions(unitTypes) {
      var _this20 = this;

      var select = document.getElementById("six-storage-unit-type");
      this.arrayOfUnitTypes = unitTypes;

      if (typeof select === "undefined" || select === null) {
        return;
      }

      if (typeof unitTypes !== "undefined" && unitTypes !== null && unitTypes.length > 0) {
        this.sixStorageClearSelect(select);
        var emptyOption = document.createElement("option");
        emptyOption.text = "".concat(
        /*Select Unit Type*/
        wordpress_vars.six_storage_online_mi_Select_Unit_Type);
        emptyOption.value = ""; // emptyOption.setAttribute('disabled', '');

        select.appendChild(emptyOption);
        var unitTypesarr = Object.values(unitTypes.reduce(function (acc, cur) {
          return Object.assign(acc, _defineProperty({}, cur.unitTypeName, cur));
        }, {}));
        unitTypesarr.forEach(function (item) {
          {
            var unitMesurement = typeof item.unitMeasurement !== 'undefined' && item.unitMeasurement !== null && item.unitMeasurement !== '' ? _this20.helper.sixStorageDisplayMeasurementSize(item.unitMeasurement, item.measurementType) : '';
            var unitMeasurementType = typeof item.measurementType !== 'undefined' && item.measurementType !== null && item.measurementType !== '' ? _this20.helper.sixStorageMeasurementDisplayFormat(item.measurementType) : '';
          }
          select.innerHTML += "<option data-unittype_name=\"".concat(item.unitTypeName, "\" value=\"").concat(item.unitTypeId, "\">").concat(item.unitTypeName, "</option>");
        });

        if (unitTypes.length > 0) {
          if (unitTypes.length === 1) {
            select.value = unitTypes[0]["unitTypeId"];
            this.sixStorageUnitTypeIdFilterSelected = unitTypes[0]["unitTypeId"];
            document.getElementById('six-storage-enquiry-container').style.display = 'none';
            document.getElementById("six-storage-unit-type-dimensionsdv").style.display = "none";
          } else {
            this.sixStorageUnitTypeIdFilterSelected = [];
          }
        } else {
          this.sixStorageUnitTypeIdFilterSelected = []; //document.getElementById("six-storage-no-units-data").style.display = "block";
        }

        if (this.groupBySize == true) {
          document.getElementById("six-storage-dvUnitType").style.display = "none";
        }
      } else {// if (optionvalueLength === 1) {
        //   document.getElementById('six-storage-unit-type-dimensionsdv').style.display = 'none';
        // }
        // select.append(html);
      }

      _materialize["default"].AutoInit();
    }
  }, {
    key: "sixStorageOnOptionSelect",
    value: function sixStorageOnOptionSelect(unitType, unitTypeId) {
      var _this21 = this;

      this.sixStorageUnitTypeIdFilterSelected = [];

      if (this.six_storage_online_fc_unit_size_filter_toggle === true) {
        document.getElementById("six-storage-unit-type-dimensionsdv").style.display = "block";
      }

      var select = document.getElementById("six-storage-unit-type-dimensions");
      this.sixStorageClearSelect(select);
      var emptyOption = document.createElement("option");
      emptyOption.text = "".concat(
      /*Select Unit Type*/
      wordpress_vars.six_storage_online_mi_Select_your_unit_dimension);
      emptyOption.value = "";
      select.appendChild(emptyOption);
      var html = "";
      var optionvalueLength = 0;
      this.arrayOfUnitTypes.forEach(function (item) {
        if (Object.values(item).includes(unitType)) {
          optionvalueLength = optionvalueLength + 1;
          var unitMesurement = typeof item.unitMeasurement !== 'undefined' && item.unitMeasurement !== null && item.unitMeasurement !== '' ? _this21.helper.sixStorageDisplayMeasurementSize(item.unitMeasurement, item.measurementType) : '';
          var unitMeasurementType = typeof item.measurementType !== 'undefined' && item.measurementType !== null && item.measurementType !== '' ? _this21.helper.sixStorageMeasurementDisplayFormat(item.measurementType) : '';

          _this21.sixStorageUnitTypeIdFilterSelected.push(item.unitTypeId);

          var _emptyOption = document.createElement("option");

          _emptyOption.innerHTML = "".concat(unitMesurement, " ").concat(unitMeasurementType);
          _emptyOption.value = "".concat(item.unitTypeId);
          select.appendChild(_emptyOption); // html += `<option  value="${item.unitTypeId}">${unitMesurement} ${unitMeasurementType}</option>`;
        }
      });
      var unitDimension = document.getElementById('six-storage-unit-type-dimensions');

      _materialize["default"].FormSelect.init(unitDimension); // if (optionvalueLength === 1) {
      //   document.getElementById('six-storage-unit-type-dimensionsdv').style.display = 'none';
      // }
      // select.append(html);


      var appending = document.getElementById("six-storage-unit-type-dimensions"); // if (wordpress_vars.six_storage_online_fc_unit_size_filter_toggle !== 1 && wordpress_vars.six_storage_online_fc_unit_size_filter_toggle !== '1') {
      //   this.sixStorageGetUnits('', '', unitTypeId);
      // }
      //console.log(this.sixStorageUnitTypeIdFilterSelected);
    }
  }, {
    key: "sixStorageOnChangeDimensionValue",
    value: function sixStorageOnChangeDimensionValue() {
      this.sixStorageUnitTypeIdFilterSelected = [];
      var selectDimention = document.getElementById("six-storage-unit-type-dimensions");
      var obj = {
        dimensionValue: typeof selectDimention !== 'undefined' && selectDimention !== null && selectDimention !== '' && typeof selectDimention.value !== 'undefined' && selectDimention.value !== '' && selectDimention.value !== null ? [selectDimention.value] : []
      };
      this.sixStorageUnitTypeIdFilterSelected = obj.dimensionValue;
    }
  }, {
    key: "sixStorageLocationFieldValidate",
    value: function sixStorageLocationFieldValidate() {
      var sixStorageLocationsValue = sessionStorage.getItem("sixStorageLocationLength");

      if (sixStorageLocationsValue != '' && sixStorageLocationsValue != null && typeof sixStorageLocationsValue != "undefined" && sixStorageLocationsValue > 1) {
        var sixStorageSelectedLocation = document.getElementById("six-storage-location").value;

        if (sixStorageLocationsValue > 1) {
          if ((wordpress_vars.six_storage_online_fc_location_toggle != null || wordpress_vars.six_storage_online_fc_location_toggle != "" || typeof wordpress_vars.six_storage_online_fc_location_toggle != "undefined") && wordpress_vars.six_storage_online_fc_location_toggle == '0') {
            if (sixStorageLocationsValue <= 1) {
              document.getElementById("six-storage-tenantLocation-err").style.display = "none";
            } else {
              if (sixStorageSelectedLocation != "" && sixStorageSelectedLocation != null && typeof sixStorageSelectedLocation != "undefined" && sixStorageLocationsValue > 1) {
                var sixStorageFocusElement = document.getElementById('six-storage-location');
                var y = sixStorageFocusElement.offsetTop;
                window.scrollTo(0, y);
                document.getElementById("six-storage-tenantLocation-err").style.display = "block";
                return;
              } else {
                document.getElementById("six-storage-tenantLocation-err").style.display = "none";
              }
            }
          } else {
            if (sixStorageSelectedLocation != "" && sixStorageSelectedLocation != null && typeof sixStorageSelectedLocation != "undefined" && sixStorageLocationsValue > 1) {
              document.getElementById("six-storage-tenantLocation-err").style.display = "none";
            } else {
              var _sixStorageFocusElement = document.getElementById('six-storage-location');

              var _y = _sixStorageFocusElement.offsetTop;
              window.scrollTo(0, _y);
              document.getElementById("six-storage-tenantLocation-err").style.display = "block";
              return;
            }
          }
        }
      }
    }
  }, {
    key: "sixStorageConstructLocationOptions",
    value: function sixStorageConstructLocationOptions(locations) {
      var select = document.getElementById("six-storage-location"); //this.sixStorageGetUnits();

      sessionStorage.setItem("sixStorageLocationLength", locations.length);
      var Locationlist = sessionStorage.getItem("Locationlist");

      if (typeof select === "undefined" || select === null) {
        return;
      }

      this.sixStorageClearSelect(select);
      var emptyOption = document.createElement("option");
      emptyOption.text = "".concat(
      /*Select Location*/
      wordpress_vars.six_storage_online_mi_Select_Location);
      emptyOption.value = ""; // emptyOption.setAttribute('disabled', '');

      select.appendChild(emptyOption);
      locations.forEach(function (item) {
        var option = document.createElement("option");

        if (item.locationId === Locationlist) {
          option.setAttribute("selected", "selected");
        }

        option.value = item.locationId;
        option.text = item.locationName;
        option.dataset.storagetypeid = item.storageTypeId;
        option.dataset.locationid = item.locationId;
        select.appendChild(option);
      });

      if (typeof locations !== "undefined" && locations !== null) {
        if (locations.length === 1) {
          //document.getElementById("six-storage-dvLocation").style.display = "";
          select.value = locations[0]["locationId"];
        } else {//document.getElementById("six-storage-dvLocation").style.display = "none";
        }
      }

      _materialize["default"].AutoInit();
    }
  }, {
    key: "sixStorageConstructBuildingOptions",
    value: function sixStorageConstructBuildingOptions(buildings) {
      var filterbuilding;
      var locationlist = document.getElementById("six-storage-location");
      var locationid = sessionStorage.getItem("Locationlist");
      var select = document.getElementById("six-storage-building");

      if (typeof select === "undefined" || select === null) {
        return;
      } // if (typeof buildings === "undefined" || buildings === null) {
      //   return;
      // }


      this.sixStorageClearSelect(select);
      var emptyOption = document.createElement("option");
      emptyOption.text = "".concat(
      /*Select Building*/
      wordpress_vars.six_storage_online_mi_Select_Building);
      emptyOption.value = ""; // emptyOption.setAttribute('disabled', '');

      select.appendChild(emptyOption);

      if (typeof locationlist !== null && typeof locationlist.value !== "undefined" && locationlist.value !== null && locationlist.value !== "") {
        if (typeof buildings !== "undefined" && buildings !== null && buildings.length > 0) {
          filterbuilding = buildings.filter(function (i) {
            return i.locationId === locationlist.value || locationid;
          });
        }
      } else {
        if (typeof buildings !== "undefined" && buildings !== null && buildings.length > 0) {
          filterbuilding = buildings;
        }
      }

      if (typeof filterbuilding !== "undefined" && filterbuilding !== null && filterbuilding.length > 0) {
        filterbuilding.forEach(function (item) {
          var option = document.createElement("option");
          option.value = item.buildingId;
          option.text = item.buildingName;
          option.dataset.storagetypeid = item.storageTypeId;
          select.appendChild(option);
        });
      }

      if (typeof filterbuilding !== "undefined" && filterbuilding !== null) {
        if (filterbuilding.length === 1) {
          select.value = buildings[0]["buildingId"];

          if (this.groupBySize) {
            document.getElementById('six-storage-enquiry-container').style.display = 'none';
          }
        } else {// this.sixStorageChangeAmenity();
          //document.getElementById("six-storage-dvBuilding").style.display = "none";
        }
      }

      _materialize["default"].AutoInit();
    }
  }, {
    key: "sixStoargeFilterbody",
    value: function sixStoargeFilterbody() {
      var filterbody = document.getElementById("six-stoarge-filter-body");

      if (filterbody.style.display === "none") {
        filterbody.style.display = "block";
      } else {
        filterbody.style.display = "none";
      }
    }
  }, {
    key: "sixStorageConstructAmenitiesOptions",
    value: function sixStorageConstructAmenitiesOptions(amenities) {
      var _this22 = this;

      var sixstorageCategory = document.getElementById("six-storage-storage-type");
      var sixstoragebuilding = document.getElementById("six-storage-building").value; // let AmenityFilter = this.sixstorgaeAmenityFilterResponse.filter(i => i.storageTypeId === sixstorageCategory.value);

      var select = document.getElementById("six-storage-amenitytype");

      if (typeof select === "undefined" || select === null) {
        return;
      }

      if (typeof this.sixstorgaeAmenityFilterResponse !== "undefined" && this.sixstorgaeAmenityFilterResponse !== null && this.sixstorgaeAmenityFilterResponse.length > 0) {
        this.sixStorageClearSelect(select);
        var amenitieslist = this.sixstorgaeAmenityFilterResponse.filter(function (obj, index) {
          return index === _this22.sixstorgaeAmenityFilterResponse.findIndex(function (o) {
            return obj.id === o.id && obj.name === o.name;
          });
        });
        var emptyOption = document.createElement("option");
        emptyOption.text = "".concat(
        /*Select Amenity*/
        wordpress_vars.six_storage_online_mi_Select_Amenity);
        emptyOption.value = ""; // emptyOption.setAttribute('disabled', '');

        select.appendChild(emptyOption);

        if (typeof sixstoragebuilding !== "undefined" && sixstoragebuilding !== "" && sixstoragebuilding !== null) {
          if (typeof this.sixstorgaeAmenityFilterResponse !== "undefined" && this.sixstorgaeAmenityFilterResponse !== null && this.sixstorgaeAmenityFilterResponse.length > 0) {
            var amenitiestduplicatelist = this.sixstorgaeAmenityFilterResponse.filter(function (obj, index) {
              return index === _this22.sixstorgaeAmenityFilterResponse.findIndex(function (o) {
                return obj.id === o.id && obj.name === o.name;
              });
            });
            amenitiestduplicatelist.forEach(function (item) {
              var option = document.createElement("option");

              if (typeof sixstoragebuilding !== "undefined" && sixstoragebuilding !== "") {
                if (item.buildingId === sixstoragebuilding) {
                  option.value = item.id;
                  option.text = item.name;
                  select.appendChild(option);
                } else {
                  option.value = "";
                  option.text = "";
                }
              } else {
                option.value = item.id;
                option.text = item.name;
                select.appendChild(option);
              } // console.log(item)

            });
          }
        } else {
          if (typeof amenitieslist !== "undefined" && amenitieslist !== null && amenitieslist.length > 0) {
            amenitieslist.forEach(function (item) {
              var option = document.createElement("option");

              if (typeof sixstoragebuilding !== "undefined" && sixstoragebuilding !== "") {
                if (item.buildingId === sixstoragebuilding) {
                  option.value = item.id;
                  option.text = item.name;
                  select.appendChild(option);
                } else {
                  option.value = "";
                  option.text = "";
                }
              } else {
                option.value = item.id;
                option.text = item.name;
                select.appendChild(option);
              } // console.log(item)

            });
          }
        }
      } else {
        this.sixStorageClearSelect(select);

        var _emptyOption2 = document.createElement("option");

        _emptyOption2.text = "".concat(
        /*Select Amenity*/
        wordpress_vars.six_storage_online_mi_Select_Amenity);
        _emptyOption2.value = ""; // emptyOption.setAttribute('disabled', '');

        select.appendChild(_emptyOption2);
      }

      _materialize["default"].AutoInit();
    }
  }, {
    key: "sixStorageConstructUnitCollection",
    value: function sixStorageConstructUnitCollection(data) {
      var _this23 = this;

      var noUnitData = document.querySelector(".six-storage-no-unit-data").innerHTML;
      var html = "";
      html += "<div class=\" six-storage-grid-d-flex six-storage-flex-wrap six-storage-grid-ml15 six-storage-col cc six-storage-s12 six-storage-grid-p0 six-storage-min-height-75\"><p class=\"six-storage-note-box six-storage-grey-text six-storage-text-darken-3 cc six-storage-font-size-18  six-storage-grid-p15 six-storage-grid-pr20 six-storage-grid-pl20 six-storage-grid-mt10 six-storage-grey six-storage-lighten-4 six-storage-text-white six-storage-rounded-10 six-storage-grid-d-flex six-storage-align-items-center\"><i class=\"six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grid-mr10\">house_siding</i>".concat(
      /*Select your storage(s) */
      wordpress_vars.six_storage_online_select_your_storage_custom_word, "</p> </div><div class=\"six-storage-row cc\">");

      if (data.length !== 0) {
        data.forEach(function (item, index) {
          var isSelected = _this23.unitsSelected.indexOf(item.unitTypeId) > -1;
          html += _this23.sixStorageConstructUnitHTML(item, isSelected);
        }.bind(this));
        html += "</div>";
        document.querySelector('.six-storage-grid-btn').classList.remove('six-storage-d-none');
      } else {
        html = noUnitData;
        this.sixStorageUpdateLoadMore(0);
        this.sixStorageGridRemove();
      }

      return html;
    }
  }, {
    key: "sixStorageConstructUnitGroupCollection",
    value: function sixStorageConstructUnitGroupCollection(data) {
      var noUnitData = document.querySelector(".six-storage-no-unit-data").innerHTML;
      var html = "";
      var h = 0;

      if (data.length > 0) {
        html = '';
        html += "<div class='six-storage-grid-d-flex six-storage-flex-wrap six-storage-row cc six-storage-grid-m0'><div class='six-storage-col six-storage-m12 six-storage-s12 six-storage-grid-ml0 six-storage-grid-d-flex six-storage-flex-wrap'><h6 class='six-storage-note-box six-storage-grey-text six-storage-text-darken-3 cc six-storage-font-size-18  six-storage-grid-p15 six-storage-grid-pr20 six-storage-grid-pl20  six-storage-grid-mt10 six-storage-grey six-storage-lighten-4 six-storage-text-white six-storage-rounded-10 six-storage-grid-d-flex six-storage-align-items-center'><i class='six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grid-mr10'>house_siding</i>".concat(
        /*Select your storage(s) */
        wordpress_vars.six_storage_online_select_your_storage_custom_word, "</h6> </div>");
        data.forEach(function (item, index) {
          var _this24 = this;

          var taxamount = item.taxAmount;
          var taxInformation = "";
          var taxSplitup = "";
          var valueIsStatus = item.isOccpied;
          var unitLocation = item.location['name'];
          var UnitStorageCategory = item.storageType['name'];
          var enableEnquiry = typeof wordpress_vars.enquiryEnabled !== 'undefined' && wordpress_vars.enquiryEnabled !== true && wordpress_vars.enquiryEnabled !== '1' ? "style=\"display:none;\"" : "";
          var enableRentNow = typeof wordpress_vars.rentNowEnabled !== 'undefined' && wordpress_vars.rentNowEnabled !== true && wordpress_vars.rentNowEnabled !== '1' ? "style=\"display:none;\"" : "";
          var enableReservation = typeof wordpress_vars.reservationEnabled !== 'undefined' && wordpress_vars.reservationEnabled !== true && wordpress_vars.reservationEnabled !== '1' ? "style=\"display:none;\"" : "";
          var enableDescription = typeof wordpress_vars.unitDescriptionEnabled !== 'undefined' && wordpress_vars.unitDescriptionEnabled !== true && wordpress_vars.unitDescriptionEnabled !== '1' ? "style=\"display:none;\"" : "";
          var vacancyCountEnabled = typeof wordpress_vars.vacancyCountEnabled !== 'undefined' && wordpress_vars.vacancyCountEnabled !== true && wordpress_vars.vacancyCountEnabled !== '1' ? "style=\"display:none;\"" : "";
          var displayUnitImage = typeof wordpress_vars.six_storage_online_fc_unit_image_toggle !== 'undefined' && wordpress_vars.six_storage_online_fc_unit_image_toggle !== true && wordpress_vars.six_storage_online_fc_unit_image_toggle !== '1' ? "style=\"display:none;\"" : "";
          var unitDescription = typeof item.description !== "undefined" && item.description !== null && item.description !== "" ? "".concat(item.description) : "";
          var unitSizeEnabled = typeof wordpress_vars.unitSizeEnabled !== 'undefined' && wordpress_vars.unitSizeEnabled !== true && wordpress_vars.unitSizeEnabled !== '1' ? "style=\"display:none;\"" : "";
          var unitTypeNameEnabled = typeof wordpress_vars.unitTypeNameEnabled !== 'undefined' && wordpress_vars.unitTypeNameEnabled !== true && wordpress_vars.unitTypeNameEnabled !== '1' ? "style=\"display:none;\"" : "";
          var discountlist = typeof item.discounts !== "undefined" && item.discounts !== null && item.discounts.length > 0 ? item.discounts.map(function (item, i) {
            return typeof item.description !== "undefined" && item.description !== null && item.description !== "" ? "<i class=\"six-storage-material-icons notranslate cc six-storage-discount-icon\">local_offer </i><span class=\"cc six-storage-Unitdetail-offtxt\">".concat(item.description, "</span><br/>") : "";
          }) : "";
          discountlist = typeof discountlist !== "undefined" && discountlist !== null && discountlist !== "" ? "<p class=\"six-storage-font-size-12 six-storage-grid-d-flex\"> ".concat(discountlist.join(''), " </p>") : "";
          var discountBasedUnit = typeof item.discountBasedUnitIds !== "undefined" && item.discountBasedUnitIds !== null && item.discountBasedUnitIds.length > 0 ? item.discountBasedUnitIds[0].unitId : null;
          var unitBasedUnitId = typeof item.unitIds !== "undefined" && item.unitIds !== null && item.unitIds.length > 0 ? item.unitIds[0] : null;
          var list = typeof item.amenities !== "undefined" && item.amenities !== null && item.amenities.length > 0 ? item.amenities.map(function (data, i) {
            // setTimeout(() => {
            //   let amentyTooltip = document.querySelectorAll(`.six-storage-amenity-tooltip_${i}_${h}`);
            //   M.Tooltip.init(amentyTooltip, {
            //     html: `${data.name} - ${data.description}`
            //   });
            // }, 120);
            return typeof data.imageUrl !== "undefined" && data.imageUrl !== null && data.imageUrl !== "" ? "<img id=\"six-storage-amenity-tooltip_".concat(i, "_").concat(h, "\" data-position=\"top\" data-tooltip=\"").concat(data.name, " - ").concat(data.description, "\" src=\"").concat(data.imageUrl, "\"  alt=\"").concat(data.name, "\" width=\"30\"  class=\"six-storage-border six-storage-amenity-tooltip_").concat(i, "_").concat(h, " cc six-storage-rounded-10 six-storage-cursor-pointer six-storage-tooltipped six-storage-carousel-item six-storage-grid-p5\">") : "";
          }) : "";
          list = typeof list !== "undefined" && list !== null && list !== "" ? "<div class=\"six-storage-carousel-amenities six-storage-amenities-lists six-storage-grid-d-flex six-storage-align-items-center six-storage-flex-wrap\">".concat(list.join(''), "</div>") : "";
          var serviceList = typeof item.services !== "undefined" && item.services !== null && item.services.length > 0 ? item.services.map(function (item, i) {
            return typeof item.description !== "undefined" && item.description !== null && item.description !== "" ? "<i class=\"six-storage-material-icons notranslate cc six-storage-discount-icon\">check</i><span class=\"cc six-storage-Unitdetail-offtxt\">".concat(item.serviceName, " - ").concat(item.description, "</span><br/>") : "";
          }) : "";
          serviceList = typeof serviceList !== "undefined" && serviceList !== null && serviceList !== "" ? "<p class=\"six-storage-font-size-12 six-storage-grid-d-flex\"> ".concat(serviceList.join(''), " </p>") : "";
          var hasDiscount = typeof item.discountBasedUnitIds !== "undefined" && item.discountBasedUnitIds !== null && item.discountBasedUnitIds.length > 0 ? true : false;
          var unitTaxDetails = typeof item.taxes !== 'undefined' && item.taxes !== null && item.taxes.length > 0 ? item.taxes.map(function (item, i) {
            return typeof item.name !== 'undefined' && item.name !== null && item.name !== '' && typeof item.value !== 'undefined' && item.value !== null && item.value !== '' ? "".concat(item.name, " ").concat(_this24.helper.sixStorageDisplayPercent(item.value)) : "";
          }) : "";
          unitTaxDetails = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' && unitTaxDetails.length > 1 ? unitTaxDetails.join('+') : unitTaxDetails;

          if (taxamount > 0) {
            if (this.displayInclusiveofTax === true) {
              taxSplitup = "<span class=\"six-storage-font-size-12 six-storage-grid-d-flex\"><span>".concat(
              /*Rent*/
              wordpress_vars.six_storage_online_fc_Rent, "&#58; </span>&nbsp;").concat(this.helper.sixStorageDisplayCurrency(item.unitPrice), "</span>\n                          <span class=\"six-storage-font-size-12 six-storage-grid-d-flex\"><span>").concat(
              /*Tax*/
              wordpress_vars.six_storage_online_fs_Tax, "&nbsp;&#40;</span>").concat(this.helper.sixStorageDisplayPercent(item.taxPercentage), "<span>&#41;&#58;</span>&nbsp;").concat(this.helper.sixStorageDisplayCurrency(item.taxAmount), "</span>");
              taxInformation = unitTaxDetails !== '' ? "<p class=\"six-storage-grid-m0 six-storage-grid-p0  six-storage-six-storage-font-size-15 six-storage-grey-text\">Price includes tax</p>" : "";
            } else {
              taxInformation = unitTaxDetails !== '' ? "<p class=\"six-storage-grid-m0 six-storage-grid-p0 six-storage-six-storage-font-size-15 six-storage-grey-text\">".concat(
              /*Excl. of*/
              wordpress_vars.six_storage_online_mi_Excl_of, " (").concat(unitTaxDetails, ")</p>") : "";
            }
          }

          var unitImage = "".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/cranes-storage-type.png");

          if (typeof item.imageUrl !== 'undefined' && item.imageUrl !== null && item.imageUrl !== "" && item.imageUrl !== "null") {
            unitImage = item.imageUrl;
          }

          html += "<div class=\"six-storage-col six-storage-l4 six-storage-m6 six-storage-s12 six-storage-grid-d-flex six-storage-grid-m0\">\n          <div class=\"six-storage-unit-box-details six-storage-grid-p15 six-storage-gridshadow  six-storage-grid-mb10 six-storage-grid-mt10 six-storage-unitDetails-info six-storage-white six-storage-flex-column six-storage-align-items-start info-rent-now-unitDetails\">\n            <div class=\"six-storage-unit-details six-storage-flex-grow-1 six-storage-grid-p0 six-storage-grid-mb20 unit-details-flex\">\n                <h5 class=\"cc six-storage-grid-m0\">\n                <span class=\"six-storage-font-size-14 six-storage-grey-text six-storage-unt-measurement-size six-storage-title-text\" ".concat(unitSizeEnabled, "><span>").concat(this.helper.sixStorageDisplayMeasurementSize(item.unitMeasurement, item.measurementType), "</span><span> ").concat(this.helper.sixStorageMeasurementDisplayFormat(item.measurementType), "</span></span>\n                <span class=\"six-storage-unt-divider six-storage-rentsingleUnit\">&nbsp;</span>                \n                <span class=\"six-storage-unit-no six-storage-six-storage-font-size-15 six-storage-grid-pr5 six-storage-font-weight-light six-storage-grey-text six-storage-text-darken-3 six-storage-unt-category six-storage-tag-text\">").concat(UnitStorageCategory, "</span><br>\n                <span class=\"six-storage-unit-no six-storage-six-storage-font-size-15 six-storage-grid-pr5 six-storage-font-weight-light six-storage-grey-text six-storage-text-darken-3 six-storage-unt-subcategory six-storage-capatilize \" ").concat(unitTypeNameEnabled, ">(").concat(item.unitTypeName, ")</span><br>\n                <span class=\"six-storage-unit-no six-storage-six-storage-font-size-15 six-storage-grid-pr5 six-storage-font-weight-light six-storage-grey-text six-storage-text-darken-3 six-storage-capatilize\" >Location: ").concat(unitLocation, "</span>\n                </h5>\n                </div>\n                <div id=\"six-storage-unit-image\" class=\"six-storage-grid-text-center six-storage-grid-p0\" ").concat(displayUnitImage, ">\n                <img src=\"").concat(unitImage, "\" /> \n              </div>\n            <div class=\"six-storage-pricing\">\n              <div class=\"six-storage-price-detail six-storage-grid-d-flex six-storage-grid-mb0 six-storage-grid-mt15 six-storage-flex-column\">\n                  <h5 class=\"six-storage-current-price cc six-storage-grid-mb0 six-storage-grid-mt0\">\n                     <span class=\"six-storage-grey-text six-storage-text-darken-3 six-storage-text-capitalize\"> <b>").concat(this.helper.sixStorageDisplayCurrency(this.displayInclusiveofTax === true ? item.netAmount : item.unitPrice), "</b></span>\n                      ").concat(this.displayInclusiveofTax == true && taxInformation != "" ? "<span class=\"six-storage-tax-detail-tooltip\" id=\"six-storage-tax-tooltip-".concat(index, "\" ><i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-tiny six-storage-grey-text six-storage-text-darken-1 six-storage-grid-ml5\">info_outline</i></span>") : '', "\n                  </h5>\n                  ").concat(taxInformation, "\n              </div>\n              <div class=\"six-storage-available-stock\" ").concat(vacancyCountEnabled, "> ");

          if (valueIsStatus === true) {
            html = html + "<p class=\"six-storage-red-text six-storage-grid-mt0 six-storage-font-size-12 six-storage-grid-mb15\" ".concat(vacancyCountEnabled, ">").concat(
            /*Call for Availability*/
            wordpress_vars.six_storage_online_fs_call_for_availability, " </p>");
          } else {
            html = html + "<p class=\"six-storage-red-text six-storage-grid-mt0 six-storage-font-size-12 six-storage-grid-mb15\" ".concat(vacancyCountEnabled, ">").concat(
            /*Hurry just*/
            wordpress_vars.six_storage_online_fs_Hurry_just, " <b>").concat(item.vacancy, "</b> ").concat(
            /*unit(s) left*/
            wordpress_vars.six_storage_online_mi_unit_left, " </p>");
          }

          html = html + "</div>\n              <div class=\"six-storage-units-description\" ".concat(enableDescription, ">\n                <p class=\"six-storage-units-description-cont six-storage-grid-mt0 six-storage-font-size-12 six-storage-grid-mb15 six-storage-subtext\">").concat(unitDescription, "</p>\n              </div>\n              <div class=\"six-storage-unitTypeDiscount\">\n                ").concat(discountlist, "\n              </div>\n              ").concat(list, "\n              ").concat(serviceList, "\n            </div>\n          ");

          if (this.rentSingleUnit === true && this.groupBySize === true) {
            if (valueIsStatus === true) {
              html = html + "<div class=\"six-storage-fs-title\">\n                            <div class=\"six-storage-grid-d-flex six-storage-grid-mb10\">\n                              <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn six-storage-primary-background-color cc six-storage-rentsingleUnit rent-now-block-button\" id=\"six-storage-enquiry-now-single\" ".concat(enableEnquiry, " onclick=\"return sixStorageNewEnquiryModal('").concat(item.unitTypeId, "');\" >").concat(
              /*Inquire*/
              wordpress_vars.six_storage_online_fs_Inquiry, "</button>\n                            </div>\n                          </div></div>\n                        </div>");
            } else {
              html = html + "<div class=\"six-storage-fs-title\">\n                            <div class=\"six-storage-grid-d-flex six-storage-grid-mb10\">\n                              <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn six-storage-primary-background-color cc six-storage-rentsingleUnit rent-now-block-button\" id=\"six-storage-enquiry-now-single\" ".concat(enableEnquiry, " onclick=\"return sixStorageNewEnquiryModal('").concat(item.unitTypeId, "');\" >").concat(
              /*Inquire*/
              wordpress_vars.six_storage_online_fs_Inquiry, "</button>\n                              <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn six-storage-primary-background-color cc six-storage-rentsingleUnit rent-now-block-button\" id=\"six-storage-rent-now-single\" ").concat(enableRentNow, " onclick=\"return sixStorageRentSingleUnitGetSelected(").concat(index, ",'").concat(item.unitTypeId, "',").concat(item.vacancy, ",'").concat(unitBasedUnitId, "',true);\">").concat(
              /*Rent Now*/
              wordpress_vars.six_storage_online_fs_Rent_Now, "</button>\n                              <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn six-storage-primary-background-color cc six-storage-rentsingleUnit rent-now-block-button\" id=\"six-storage-reserve-now-single\" ").concat(enableReservation, " onclick=\"return sixStorageReserveSingleUnit('").concat(item.unitTypeId, "','").concat(item.unitPrice, "','").concat(unitBasedUnitId, "');\">").concat(
              /*Reserve*/
              wordpress_vars.six_storage_online_fs_Reserve, "</button>\n                            </div>\n                          </div></div>\n                        </div>");
            }
          } else {
            html = html + "<div class=\"six-storage-shopping-counter six-storage-mx-auto\">\n        <div class=\"six-storage-counter six-storage-rounded-30 six-storage-grid-d-flex six-storage-align-items-center six-storage-justify-content-center six-storage-grid-shadow-lg\">\n            <button class=\"six-storage-minus six-storage-waves-effect six-storage-waves-light six-storage-shadow-none six-storage-secondary-background-color six-storage-btn cc\" onclick=\"return sixStorageRemoveUnitCount('".concat(index, "','").concat(item.unitTypeId, "',").concat(hasDiscount, ");\">\n              <i class=\"six-storage-material-icons notranslate\">remove</i>\n            </button>\n            <div class=\"six-storage-count six-storage-grid-pl15 six-storage-grid-pr15\" id=\"six-storage-unitCount_").concat(index, "\">\n              0\n            </div>\n            <button class=\"six-storage-plus six-storage-waves-effect six-storage-waves-light six-storage-shadow-none six-storage-btn six-storage-secondary-background-color cc \" onclick=\"return sixStorageAddUnitCount(").concat(index, ",'").concat(item.unitTypeId, "',").concat(item.vacancy, ",").concat(hasDiscount, ");\">\n            <i class=\"six-storage-material-icons notranslate\">add</i>\n            </button>\n        </div>\n    </div></div>\n    </div>");
          }

          if (this.displayInclusiveofTax == true) {
            setTimeout(function () {
              var taxTooltip = document.querySelector("#six-storage-tax-tooltip-".concat(index));

              _materialize["default"].Tooltip.init(taxTooltip, {
                html: taxSplitup
              });
            }, 100);
          }
        }.bind(this));
        html += "</div>";
      } else {
        html = noUnitData;
        this.sixStorageUpdateLoadMore(0);
      }

      return html;
    }
  }, {
    key: "sixStorageConstructUnitHTML",
    value: function sixStorageConstructUnitHTML(data, isSelected) {
      var _this25 = this;

      if (typeof data === "undefined" || data === null) {
        return "";
      }

      var checked = typeof isSelected !== "undefined" && isSelected !== null && isSelected ? "checked" : "";
      var imagePath = _typeof(data.imageUrl) != undefined && data.imageUrl != null && data.imageUrl != "" ? data.imageUrl : "".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/cranes-storage-type.png");
      var imageAltText = typeof data.unitNumber !== "undefined" || data.unitNumber !== null || data.unitNumber !== "" ? data.unitNumber : "";
      var unitId = typeof data.id !== "undefined" && data.id !== null ? data.id : "";
      var unitNumber = typeof data.unitNumber !== "undefined" && data.unitNumber !== null ? data.unitNumber : "";
      var measurementType = typeof data.measurementType !== "undefined" && data.measurementType !== null ? this.helper.sixStorageMeasurementDisplayFormat(data.measurementType) : "";
      var unitMeasurement = typeof data.unitMeasurement !== "undefined" && data.unitMeasurement !== null ? this.helper.sixStorageDisplayMeasurementSize(data.unitMeasurement, data.measurementType) : "";
      var unitType = typeof data.unitType.name !== "undefined" && data.unitType.name !== null ? data.unitType.name : "";
      var locationName = typeof data.location.name !== "undefined" && data.location.name !== null ? data.location.name : "";
      var buildingName = typeof data.building.name !== "undefined" && data.building.name !== null ? data.building.name : "";
      var unitDescription = typeof data.description !== "undefined" && data.description !== null ? data.description : "";
      var unitPrice = typeof data.unitPrice !== "undefined" && data.unitPrice !== null ? data.unitPrice : "";
      var unitTaxInfo = typeof data.taxPercentage !== "undefined" && data.taxPercentage !== null ? data.taxPercentage > 0 ? "".concat(this.helper.sixStorageDisplayPercent(data.taxPercentage)) : "" : "";
      var unitDescriptionHtml = '&nbsp;&nbsp;';

      if (unitDescription.length > 35) {
        unitDescriptionHtml = "<span>".concat(unitDescription.substring(0, 28), "...<span><span class=\"six-storage-tax-detail-tooltip\" id=\"six-storage-description-tooltip-").concat(unitId, "\" ><i class=\"six-storage-material-icons six-storage-font-size-18 notranslate six-storage-cursor-pointer six-storage-tiny\">info</i></span>");
        var descriptionTool = "<div class=\"six-storage-grid-p20\">".concat(unitDescription, "</div>");
        setTimeout(function () {
          var descTooltip = document.querySelector("#six-storage-description-tooltip-".concat(unitId));

          _materialize["default"].Tooltip.init(descTooltip, {
            html: descriptionTool
          });
        }, 120);
      } else {
        unitDescriptionHtml = "<span>".concat(unitDescription, "</span>");
      }

      var list = typeof data.amenityInfoList !== "undefined" && data.amenityInfoList !== null && data.amenityInfoList.length > 0 ? data.amenityInfoList.map(function (item, i) {
        setTimeout(function () {
          var amentyTooltip = document.querySelector("#six-storage-amenity-tooltip-".concat(unitId, "-").concat(i));

          _materialize["default"].Tooltip.init(amentyTooltip, {
            html: "".concat(item.name, " - ").concat(item.description),
            outDuration: 0,
            inDuration: 200,
            enterDelay: 200
          });
        }, 50);
        return typeof item.imageUrl !== "undefined" && item.imageUrl !== null && item.imageUrl !== "" ? "<img id=\"six-storage-amenity-tooltip-".concat(unitId, "-").concat(i, "\" data-position=\"top\" src=\"").concat(item.imageUrl, "\"  alt=\"").concat(item.name, "\" width=\"30\"  class=\"six-storage-border cc six-storage-rounded-10 six-storage-cursor-pointer six-storage-carousel-item six-storage-grid-p5\">") : "";
      }) : "";
      list = typeof list !== "undefined" && list !== null && list !== "" ? "<div class=\"six-storage-carousel-amenities six-storage-amenities-lists six-storage-grid-d-flex six-storage-align-items-center six-storage-flex-wrap\">".concat(list.join(''), "</div>") : "<div><p>&nbsp;&nbsp;</p></div>";
      var serviceListHtml = typeof data.discounts !== "undefined" && data.discounts !== null && data.discounts.length > 0 ? data.discounts.map(function (item, i) {}) : "";
      var discountlist = typeof data.discounts !== "undefined" && data.discounts !== null && data.discounts.length > 0 ? data.discounts.map(function (item, i) {
        return typeof item.description !== "undefined" && item.description !== null && item.description !== "" ? "<i class=\"six-storage-material-icons notranslate cc six-storage-discount-icon\">local_offer </i><span class=\"cc six-storage-Unitdetail-offtxt\">".concat(item.description, "</span><br/>") : "";
      }) : "";
      discountlist = typeof discountlist !== "undefined" && discountlist !== null && discountlist !== "" ? "<p class=\"six-storage-font-size-12 six-storage-grid-m0 six-storage-grid-d-flex\"> ".concat(discountlist.join(''), " </p>") : "&nbsp;&nbsp;";
      var enableDescription = typeof wordpress_vars.unitDescriptionEnabled !== 'undefined' && wordpress_vars.unitDescriptionEnabled !== true && wordpress_vars.unitDescriptionEnabled !== '1' ? "style=\"display:none;\"" : "";
      var unitTypeNameEnabled = typeof wordpress_vars.unitTypeNameEnabled !== 'undefined' && wordpress_vars.unitTypeNameEnabled !== true && wordpress_vars.unitTypeNameEnabled !== '1' ? "style=\"display:none;\"" : "";
      var unitSizeEnabled = typeof wordpress_vars.unitSizeEnabled !== 'undefined' && wordpress_vars.unitSizeEnabled !== true && wordpress_vars.unitSizeEnabled !== '1' ? "style=\"display:none;\"" : "";
      var displayUnitImage = typeof wordpress_vars.six_storage_online_fc_unit_image_toggle !== 'undefined' && wordpress_vars.six_storage_online_fc_unit_image_toggle !== true && wordpress_vars.six_storage_online_fc_unit_image_toggle !== '1' ? "style=\"display:none;\"" : "";
      var unitTaxDetails = typeof data.taxes !== 'undefined' && data.taxes !== null && data.taxes.length > 0 ? data.taxes.map(function (item, i) {
        return typeof item.name !== 'undefined' && item.name !== null && item.name !== '' && typeof item.value !== 'undefined' && item.value !== null && item.value !== '' ? "".concat(item.name, " ").concat(_this25.helper.sixStorageDisplayPercent(item.value)) : null;
      }) : null;
      unitTaxDetails = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' && unitTaxDetails.length > 1 ? unitTaxDetails.join('+') : unitTaxDetails;
      var taxamount = data.taxAmount;
      var taxInformation = "";

      if (taxamount > 0) {
        if (this.displayInclusiveofTax === true) {
          var taxSplitup = "<span class=\"six-storage-grid-d-flex\"><span>".concat(
          /*Rent*/
          wordpress_vars.six_storage_online_fc_Rent, "</span>&#58; ").concat(this.helper.sixStorageDisplayCurrency(data.unitPrice), "</span>\n                          <span class=\"six-storage-grid-d-flex\"><span>").concat(
          /*Tax*/
          wordpress_vars.six_storage_online_fs_Tax, "&nbsp;&#40;</span>").concat(this.helper.sixStorageDisplayPercent(data.taxPercentage), "<span>&#41;&#58;&nbsp;</span> ").concat(this.helper.sixStorageDisplayCurrency(data.taxAmount), "</span>");
          taxInformation = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' ? "".concat(
          /*Incl. of*/
          wordpress_vars.six_storage_online_mi_Incl_of) : "";
          setTimeout(function () {
            var taxTooltip = document.querySelector("#six-storage-tax-tooltip-".concat(unitId));

            _materialize["default"].Tooltip.init(taxTooltip, {
              html: taxSplitup
            });
          }, 120);
          unitPrice = data.netAmount;
        } else {
          taxInformation = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' ? "".concat(
          /*Excl. of*/
          wordpress_vars.six_storage_online_mi_Excl_of, " (").concat(unitTaxDetails, ")") : "";
        }
      }

      return "<div class=\"six-storage-col six-storage-l4 six-storage-m6 six-storage-s12 six-storage-grid-d-flex six-storage-grid-m0\">\n    <div class=\"six-storage-unit-box-details  six-storage-grid-p15 six-storage-gridshadow  six-storage-grid-mb10 six-storage-grid-mt10 six-storage-unitDetails-info six-storage-white six-storage-flex-column six-storage-align-items-start\">\n        <div  id=\"six-storage-unit-image\">\n          <label class=\"cc six-storage-grid-m0 six-storage-grid-p10 six-storage-cursor-pointer\">\n              <input id=\"six-storage-unit-selection-".concat(unitId, "\" ").concat(checked, " onclick=\"sixStorageSelectedUnits('").concat(unitId, "')\" class = \"six-storage-select-units cc\" type=\"checkbox\" value=\"").concat(unitId, "\">\n              <span></span>\n              <img src=\"").concat(imagePath, "\" alt=\"").concat(imageAltText, "\" ").concat(displayUnitImage, " class=\"six-storage-grid-img-fluid cc six-storage-unitImg\">\n          </label>\n        </div>\n        <div class=\"six-storage-unit-details\">\n          <h6 class=\"cc\"><span class=\"six-storage-unit-no six-storage-six-storage-font-size-15 six-storage-pr-20 cc six-storage-text-blue\"><b>").concat(unitNumber, "</b></span>\n          <span class='six-storage-font-size-14 six-storage-grey-text six-storage-font-weight-bold'>\n          <span ").concat(unitSizeEnabled, "><span>").concat(unitMeasurement, "</span>&nbsp;&nbsp;\n          <span>").concat(measurementType, "</span></span>&nbsp;&nbsp;\n          <span ").concat(unitTypeNameEnabled, ">(").concat(unitType, ")</span></span></h6>\n          <h6 class=\"six-storage-location-building cc\"><span class=\"six-storage-location-name six-storage-grid-d-inline-block six-storage-pr-10\">").concat(locationName, "</span>| <span class=\"building-name six-storage-pl-10\">").concat(buildingName, "</span></h6>\n            <div class=\"six-storage-unit-description six-storage-units-description-cont\" ").concat(enableDescription, "><span style=\"min-width:100px;padding: 15px 5px;display: table-cell;vertical-align: middle;\">").concat(unitDescriptionHtml, "</span></div>\n            <div class=\"six-storage-unit-discount\" id=\"six-storage-unit_discount\">").concat(discountlist, "</div>\n            ").concat(list, "\n        </div>\n        <div class=\"six-storage-secondary-background-color six-storage-grid-p20 six-storage-text-white six-storage-grid-text-center six-storage-right-side-grid\">\n            <div >\n                <h4 class=\"six-storage-price-detail six-storage-white-text\">").concat(this.helper.sixStorageDisplayCurrency(unitPrice), " \n                  ").concat(this.displayInclusiveofTax == true && taxInformation != "" ? "<span class=\" six-storage-tax-detail-tooltip\" id=\"six-storage-tax-tooltip-".concat(unitId, "\" ><i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-tiny six-storage-grey-text six-storage-text-lighten-5\">info_outline</i></span>") : '', "\n                </h4>\n                <p class=\"six-storage-grid-m0 cc six-storage-white-text\">").concat(taxInformation, "</p>\n            </div>\n        </div>\n    </div></div>");
    }
  }, {
    key: "sixStorageSearchUnits",
    value: function sixStorageSearchUnits(reservationstatus) {
      var _this26 = this;

      this.pageNumber = 1;
      this.units = [];
      this.discountBasedUnit = [];
      this.selectedUnitTypes = [];
      this.units = [];
      this.unitsSelected = [];

      if (this.unitsSelectedInfo !== null && typeof this.unitsSelectedInfo !== 'undefined' && this.unitsSelectedInfo.length > 0) {
        this.unitsSelectedInfo.map(function (item, i) {
          var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

          if (typeof checkbox !== "undefined" && checkbox !== null) {
            checkbox.checked = false;
          }

          _this26.sixStorageUpdateUnitSelection(item.id);
        });
      }

      document.getElementById("six-storage-rent-now-err").style.display = "none";

      if (typeof reservationstatus !== "undefined" && reservationstatus !== null && reservationstatus !== "" && reservationstatus === true) {
        setTimeout(function () {
          _this26.sixStorageGetUnits();
        }, "5000");
      } else {
        this.sixStorageGetUnits();
      }
    }
  }, {
    key: "sixStorageClearSelect",
    value: function sixStorageClearSelect(item) {
      if (typeof item === "undefined" && item === null) {
        return;
      }

      item.innerHTML = "";
    }
  }, {
    key: "sixStoragepreviousbutton",
    value: function sixStoragepreviousbutton(count, pageNumber, leastcount) {
      var container = document.getElementById("six-storage-load-more-container");
      var previousbuttoncontainer = document.getElementById("six-storage-prevous-button-container");

      if (typeof count !== "undefined" && count !== null && count > 0) {
        container.innerHTML = "<button id=\"six-storage-load-more\" data-count = ".concat(count, " data-page = ").concat(pageNumber, " data-leastcount = ").concat(leastcount, "  class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color cc\" onclick=\"sixStorageLoadMoreUnits('LOADMORE')\">").concat(
        /*Show*/
        wordpress_vars.six_storage_online_mi_Show, " ") + "<span id = \"hide-count\"> ".concat(count, "</span>") + " ".concat(
        /*more units*/
        wordpress_vars.six_storage_online_mi_more_units, "</button>");
      } else {
        container.innerHTML = "";
      }

      if (typeof pageNumber !== "undefined" && pageNumber !== null && pageNumber > 1) {
        previousbuttoncontainer.innerHTML = "<button id = \"sixstoragepreviousbutton\" data-leastcount = ".concat(leastcount, " data-count = ").concat(count, " data-page = ").concat(pageNumber, " class = \"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color cc\" onclick =\"sixStoragePreviousbtn('PREVIOUS')\">").concat(
        /*Previous*/
        wordpress_vars.six_storage_online_mi_previous, "</button>");
      } else {
        previousbuttoncontainer.innerHTML = "";
      }

      if (this.groupBySize === true || this.rentSingleUnit === true) {
        var sixstorageshowmore = document.getElementById("hide-count");

        if (typeof sixstorageshowmore !== "undefined" && sixstorageshowmore !== null) {
          sixstorageshowmore.style.display = "none";
        }
      }
    }
  }, {
    key: "sixStorageUpdateLoadMore",
    value: function sixStorageUpdateLoadMore(count, pageNumber, leastcount) {
      var container = document.getElementById("six-storage-load-more-container");
      var previousbuttoncontainer = document.getElementById("six-storage-prevous-button-container");

      if (typeof count !== "undefined" && count !== null && count > 0) {
        container.innerHTML = "<button id=\"six-storage-load-more\" data-count = ".concat(count, "  data-page = ").concat(pageNumber, " data-leastcount = ").concat(leastcount, " class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color cc\" onclick=\"sixStorageLoadMoreUnits('LOADMORE')\">").concat(
        /*Show*/
        wordpress_vars.six_storage_online_mi_Show, " ") + "<span id = \"hide-count\"> ".concat(count, "</span>") + " ".concat(
        /*more units*/
        wordpress_vars.six_storage_online_mi_more_units, "</button>");
      } else {
        container.innerHTML = "";
      }

      if (typeof pageNumber !== "undefined" && pageNumber !== null && pageNumber > 1) {
        previousbuttoncontainer.innerHTML = "<button id = \"sixstoragepreviousbutton\" data-count = ".concat(count, " data-page = ").concat(pageNumber, " data-leastcount = ").concat(leastcount, " class = \"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color cc\" onclick =\"sixStoragePreviousbtn('PREVIOUS','").concat(pageNumber, "')\">").concat(
        /*Previous*/
        wordpress_vars.six_storage_online_mi_previous, "</button>");
      } else {
        previousbuttoncontainer.innerHTML = "";
      }

      if (this.groupBySize === true || this.rentSingleUnit === true) {
        var sixstorageshowmore = document.getElementById("hide-count");

        if (typeof sixstorageshowmore !== "undefined" && sixstorageshowmore !== null) {
          sixstorageshowmore.style.display = "none";
        }
      }
    }
  }, {
    key: "sixStoragenocountLoadMore",
    value: function sixStoragenocountLoadMore(nocount) {
      var nocountcontainer = document.getElementById("six-storage-load-more-container");

      if (typeof nocount !== "undefined" && nocount !== null && nocount !== "") {
        nocountcontainer.innerHTML = "<button id=\"six-storage-load-more\" class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color cc\" onclick=\"sixStorageLoadMoreUnits('LOADMORE')\">".concat(
        /*Show*/
        wordpress_vars.six_storage_online_mi_Show, " ") + " ".concat(
        /*more units*/
        wordpress_vars.six_storage_online_mi_more_units, "</button>");
      } else {
        nocountcontainer.innerHTML = "";
      }
    }
  }, {
    key: "sixStorageGetTimeZone",
    value: function sixStorageGetTimeZone() {
      var _this27 = this;

      var formData = new FormData();
      formData.append("action", "six_storage_get_time_zone");
      formData.append("isAjax", true);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url; //document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);

      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this27.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response12 = JSON.parse(data);

          if (typeof _response12.isSuccess !== "undefined" && _response12 !== null && _response12.isSuccess === true && _response12.result.length > 0) {
            _this27.timeZones = _this27.sixStorageConstructTimeZone(_response12.result);
          }
        }
      })["catch"](function (error) {
        //document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
        console.log(error);
      });
      ;
    }
  }, {
    key: "sixStorageConstructTimeZone",
    value: function sixStorageConstructTimeZone(data) {
      if (typeof data === "undefined" || data === null) {
        return;
      }

      var html = "";
      data.forEach(function (item) {
        if (item.defaultInCustomerPortal === true) {
          html += "<option selected provider=\"".concat(item.provider, "\" value=\"").concat(item.id, "\">").concat(item.timeZone, "</option>");
        } else {
          html += "<option  provider=\"".concat(item.provider, "\" value=\"").concat(item.id, "\">").concat(item.timeZone, "</option>");
        }
      });
      return html;
    }
  }, {
    key: "sixStorageRentNow",
    value: function sixStorageRentNow() {
      var _this28 = this;

      if (this.listedUnit.length > 0) {
        this.unitsSelected = this.listedUnit;
      } // if (this.unitsSelected.length > 1) {
      //   this.helper.sixStorageShowMessage(`${/*Please Select One Unit To Rent*/ wordpress_vars.six_storage_online_fc_please_select_one_unit_to_rent}`, true);
      //   return;
      // }


      if (this.unitsSelected.length == 0) {
        //document.getElementById("six-storage-rent-now-err").innerHTML = `${/*Please Select Units To Rent*/ wordpress_vars.six_storage_online_fs_Please_Select_Units_To_Rent}`;
        this.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_fs_Please_Select_Units_To_Rent), true);
        document.getElementById("six-storage-rent-now-err").style.display = "";
      } else {
        document.getElementById("six-storage-rent-now-err").style.display = "none";
        var units = this.unitsSelected.filter(function (id) {
          return !_this28.unitsRentInformation.some(function (e) {
            return e.id === id;
          });
        });
        var move_in_date = document.getElementById("six-storage-movein-date");
        var dtmoveindate = document.getElementById("six-storage-dtmoveindate").value;
        move_in_date.value = dtmoveindate;

        if (units.length > 0) {
          var invoice_period = document.getElementById("six-storage-invoice-period-new");
          var invoice_reccuring = document.getElementById("six-storage-invoice-reccuring-new");
          var additional_months = document.getElementById("six-storage-additional-months");
          this.sixStorageGenerateUnitsInfo(units, move_in_date, invoice_period, invoice_reccuring, additional_months);

          if (this.loadSecondPage !== true && typeof this.loadSecondPage !== "undefined") {
            this.currentStepNumber += 1;
          }
        } else {
          if (typeof this.unitsRentInformation !== "undefined" && this.unitsRentInformation !== null) {
            var html = this.sixStorageConstructUnitDetails(this.unitsRentInformation);
            document.getElementById("six-storage-unit-details-container").innerHTML = html;
            var date = new Date();
            this.sixStorageInitDatepickerClassname("six-storage-date-control-custom-fields", new Date("".concat(date.getFullYear() - 60, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), new Date("".concat(date.getFullYear() + 20, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())));

            if (this.loadSecondPage !== true && typeof this.loadSecondPage !== "undefined") {
              this.currentStepNumber += 1;
              this.sixStorageRenderStepHtml();
            } else {
              var numberFields = document.getElementsByClassName("number");
              Array.prototype.forEach.call(numberFields, function (element) {
                element.oninput = _this28.helper.sixStorageCheckNumber;
              });
            }

            if (wordpress_vars.scheduledMoveOutEnabled === '1') {
              var addDays = function addDays(days) {
                var moveindate = _this28.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value);

                var result = new Date(moveindate);
                result.setDate(result.getDate() + parseInt(days));
                return result;
              }; // Change min date to next day of move-in date to avoid same move-in and move-out date
              // let six_storage_online_schedule_minimum_days = wordpress_vars.six_storage_online_fc_schedule_minimum_days_custom_word;
              // if(typeof six_storage_online_schedule_minimum_days !== "undefined" && six_storage_online_schedule_minimum_days !== null){
              //     if(six_storage_online_schedule_minimum_days == '0'){
              //       six_storage_online_schedule_minimum_days = '1';
              //     }
              // }


              var minDate = addDays(wordpress_vars.six_storage_online_fc_schedule_minimum_days_custom_word);
              var maxDate = addDays(wordpress_vars.six_storage_online_fc_schedule_maximum_days_custom_word);
              this.sixStorageInitDatepickerClassname("six-storage-date-control-desired-moveout", minDate, maxDate);
            } else {
              var _date2 = new Date();

              var momentDate = new Date(this.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value));
              momentDate.setDate(momentDate.getDate() + 1);
              this.sixStorageInitDatepickerClassname("six-storage-date-control-desired-moveout", momentDate, new Date("".concat(_date2.getFullYear() + 20, "-").concat(_date2.getMonth() + 1, "-").concat(_date2.getDate())));
            }

            this.sixStorageHighlightInputLabel("six-storage-date-control-desired-moveout");

            _materialize["default"].AutoInit();
          }
        }
      }
    }
  }, {
    key: "sixStorageChangeSelectedUnits",
    value: function sixStorageChangeSelectedUnits() {
      var units = this.unitsSelected; ////console.log(units);

      var move_in_date = document.getElementById("six-storage-movein-date");
      var invoice_period = document.getElementById("six-storage-invoice-period-new");
      var invoice_reccuring = document.getElementById("six-storage-invoice-reccuring-new");
      var additional_months = document.getElementById("six-storage-additional-months");

      if (typeof additional_months.value === 'undefined' || additional_months.value === "" || additional_months.value === null) {
        additional_months.value = 0;

        _materialize["default"].updateTextFields();
      }

      document.getElementById("six-storage-dtmoveindate").value = move_in_date.value;
      window.sixStorageGenerateUnitsInfo(units, move_in_date, invoice_period, invoice_reccuring, additional_months, true);
      window.allInputHighlight;
    }
  }, {
    key: "sixStorageGenerateUnitsInfo",
    value: function sixStorageGenerateUnitsInfo(units, move_in_date, invoice_period, invoice_reccuring, additional_months, change) {
      var _this29 = this;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var noUnitData = document.querySelector(".six-storage-no-unit-data").innerHTML;

      if (typeof units === "undefined" || units === null) {
        units = this.unitsSelected;
      }

      var unitValue = units.map(function (element) {
        return element.toLowerCase();
      });
      this.sixStorageSelectedUnitIdByUnitType.push(unitValue);
      var obj = {
        units: typeof units !== "undefined" && units !== null ? units : null,
        move_in_date: typeof move_in_date !== "undefined" && move_in_date !== null && typeof move_in_date.value !== "undefined" && move_in_date.value !== null ? move_in_date.value : null,
        invoice_period: typeof invoice_period !== "undefined" && invoice_period !== null && typeof invoice_period.value !== "undefined" && invoice_period.value !== null ? invoice_period.value : null,
        invoice_reccuring: typeof invoice_reccuring !== "undefined" && invoice_reccuring !== null && typeof invoice_reccuring.value !== "undefined" && invoice_reccuring.value !== null ? invoice_reccuring.value : null,
        additional_months: typeof additional_months !== "undefined" && additional_months !== null && typeof additional_months.value !== "undefined" && additional_months.value !== null ? additional_months.value : 0
      };

      if (typeof obj.units === 'undefined' || obj.units === null || obj.units.length === 0) {
        return;
      }

      var moveinDate = this.helper.sixStorageReadDate(obj.move_in_date);
      var formData = new FormData();
      formData.append("action", "six_storage_units_info_by_id");

      if (wordpress_vars.six_storage_grouping_enable === "1" && wordpress_vars.six_storage_grouping_single_units !== "1") {
        formData.append("unitId", this.discountBasedUnit);
      } else {
        formData.append("unitId", obj.units);
      }

      formData.append("move_in_date", moveinDate);
      formData.append("invoice_period", obj.invoice_period);
      formData.append("invoice_reccuring", obj.invoice_reccuring);
      formData.append("additional_months", obj.additional_months);
      formData.append("isBusinessUser", this.helper.sixStorageGetTenantType());
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response13 = JSON.parse(data);

          if (typeof _response13.isSuccess !== "undefined" && _response13 !== null && _response13.isSuccess === true) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders9 = document.getElementById("six-storage-loading-container");

              _initialloaders9.style.display = 'none';
            }

            if (_response13.result.length > 1) {
              var storageTypeArr = [];

              for (var i = 0; i < _response13.result.length; i++) {
                var storageTypeId = _response13.result[i]['unitInfo']['storageType']['id'];
                storageTypeArr.push(storageTypeId);
              }

              var storageTypeUniqueArr = storageTypeArr.filter(function (el, index, arr) {
                return index == arr.indexOf(el);
              });

              if (storageTypeUniqueArr.length > 1) {
                _this29.helper.sixStorageShowMessage("".concat(
                /*Please Select Units From Same Storage Category*/
                wordpress_vars.six_storage_online_fc_please_select_units_from_same_storage_category), true);

                document.getElementById("six-storage-loading-container").innerHTML = _this29.helper.sixStorageShowBusyIndicator(false);
                return;
              }
            }

            if (typeof wordpress_vars.six_storage_google_analytics_integrated !== "undefined" && wordpress_vars.six_storage_google_analytics_integrated !== null && wordpress_vars.six_storage_google_analytics_integrated !== "" && wordpress_vars.six_storage_google_analytics_integrated === "1") {
              gtag('event', 'page_view', {
                page_title: 'Rent Now - Selected Storage',
                page_location: 'Rent Now',
                page_path: '/rent-now#SelectedStorage',
                send_to: "".concat(wordpress_vars.six_storage_google_analytics_input_key)
              });
            }

            if (change === true) {
              _this29.unitsRentInformation = _response13.result;
            } else {
              _this29.unitsRentInformation = _response13.result;
            }

            var html = _this29.sixStorageConstructUnitDetails(_this29.unitsRentInformation);

            document.getElementById("six-storage-unit-lists").style.display = "none";
            document.getElementById("six-storage-unit-details").style.display = "block";
            document.getElementById("six-storage-loading-container").innerHTML = _this29.helper.sixStorageShowBusyIndicator(false);
            document.getElementById("six-storage-unit-details-container").innerHTML = html;

            _this29.unitsSelected.forEach(function (unit) {
              var data = _this29.saveDesiredMoveOutDateOnline.filter(function (res) {
                return res.unitId === unit;
              });

              if (data.length > 0) {
                var desiredMoveoutDate = document.getElementById("six-storage-desired-moveout-date_".concat(data[0].unitId));
                desiredMoveoutDate.value = data[0].desiredMoveOut;
              }
            });

            if (_this29.geteAccessInfo.length > 0) {
              _this29.unitsSelected.forEach(function (unit) {
                _this29.geteAccessInfo.forEach(function (item) {
                  if (item.unitId.toUpperCase() === unit.toUpperCase()) {
                    if (typeof document.getElementById("six-storage-timezone_".concat(item.unitId)) !== 'undefined' && document.getElementById("six-storage-timezone_".concat(item.unitId)) !== null) {
                      document.getElementById("six-storage-timezone_".concat(item.unitId)).value = item.timeZoneId;
                    }
                  }
                });
              });
            }

            var date = new Date();

            _this29.sixStorageInitDatepickerClassname("six-storage-date-control-custom-fields", new Date("".concat(date.getFullYear() - 60, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), new Date("".concat(date.getFullYear() + 20, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())));

            if (_this29.loadSecondPage !== true && typeof _this29.loadSecondPage !== "undefined") {
              _this29.sixStorageRenderStepHtml();
            } else {
              var numberFields = document.getElementsByClassName("number");
              Array.prototype.forEach.call(numberFields, function (element) {
                element.oninput = _this29.helper.sixStorageCheckNumber;
              });
            }

            if (wordpress_vars.scheduledMoveOutEnabled === '1') {
              var addDays = function addDays(days) {
                var moveindate = _this29.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value);

                var result = new Date(moveindate);
                result.setDate(result.getDate() + parseInt(days));
                return result;
              }; // Change min date to next day of move-in date to avoid same move-in and move-out date
              // let six_storage_online_schedule_minimum_days = wordpress_vars.six_storage_online_fc_schedule_minimum_days_custom_word;
              // if(typeof six_storage_online_schedule_minimum_days !== "undefined" && six_storage_online_schedule_minimum_days !== null){
              //     if(six_storage_online_schedule_minimum_days == '0'){
              //       six_storage_online_schedule_minimum_days = '1';
              //     }
              // }


              var minDate = addDays(wordpress_vars.six_storage_online_fc_schedule_minimum_days_custom_word);
              var maxDate = addDays(wordpress_vars.six_storage_online_fc_schedule_maximum_days_custom_word);

              _this29.sixStorageInitDatepickerClassname("six-storage-date-control-desired-moveout", minDate, maxDate);
            } else {
              var _date3 = new Date();

              var momentDate = new Date(_this29.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value));
              momentDate.setDate(momentDate.getDate() + 1);

              _this29.sixStorageInitDatepickerClassname("six-storage-date-control-desired-moveout", momentDate, new Date("".concat(_date3.getFullYear() + 20, "-").concat(_date3.getMonth() + 1, "-").concat(_date3.getDate())));
            }

            _this29.sixStorageHighlightInputLabel("six-storage-date-control-desired-moveout");

            _materialize["default"].AutoInit();
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this29.helper.sixStorageShowBusyIndicator(false);
            document.getElementById("six-storage-unit-details-container").innerHTML = noUnitData;

            _this29.sixStorageGridRemove();
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this29.helper.sixStorageShowBusyIndicator(false);
          document.getElementById("six-storage-unit-details-container").innerHTML = noUnitData;

          _this29.sixStorageGridRemove();
        }
      })["catch"](function (error) {
        document.getElementById("six-storage-loading-container").innerHTML = _this29.helper.sixStorageShowBusyIndicator(false);
        console.log(error);
      });
    }
  }, {
    key: "sixStorageConstructUnitDetails",
    value: function sixStorageConstructUnitDetails(data) {
      var getbackOption = sessionStorage.getItem("goback");

      if (getbackOption !== "false") {
        this.currentStepNumber += 1;
      }

      this.sixStorageGetCustomFields();
      var html = "";
      data.forEach(function (item, index) {
        html += this.sixStorageConstructUnitDetailsHTML(item, index);
      }.bind(this));

      _materialize["default"].AutoInit();

      return html;
    }
  }, {
    key: "sixStorageConstructUnitDetailsHTML",
    value: function sixStorageConstructUnitDetailsHTML(data, index) {
      var _this30 = this;

      if (typeof data === "undefined" || data === null) {
        return "";
      }

      var imagePath = typeof data.unitInfo.imageUrl !== "undefined" || data.unitInfo.imageUrl !== null ? data.unitInfo.imageUrl : "".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/dummy-img-circle.png");
      var imageAltText = "";
      var unitId = typeof data.unitInfo.id !== "undefined" && data.unitInfo.id !== null ? data.unitInfo.id : "";
      var unitNumber = typeof data.unitInfo.unitNumber !== "undefined" && data.unitInfo.unitNumber !== null ? data.unitInfo.unitNumber : "";
      var measurementType = typeof data.unitInfo.measurementType !== "undefined" && data.unitInfo.measurementType !== null ? this.helper.sixStorageMeasurementDisplayFormat(data.unitInfo.measurementType) : "";
      var unitMeasurement = typeof data.unitInfo.unitMeasurement !== "undefined" && data.unitInfo.unitMeasurement !== null ? this.helper.sixStorageDisplayMeasurementSize(data.unitInfo.unitMeasurement, data.unitInfo.measurementType) : "";
      var unitType = typeof data.unitInfo.unitType.name !== "undefined" && data.unitInfo.unitType.name !== null ? data.unitInfo.unitType.name : "";
      var locationName = typeof data.unitInfo.location.name !== "undefined" && data.unitInfo.location.name !== null ? data.unitInfo.location.name : "";
      var buildingName = typeof data.unitInfo.building.name !== "undefined" && data.unitInfo.building.name !== null ? data.unitInfo.building.name : "";
      var storageType = typeof data.unitInfo.storageType.name !== "undefined" && data.unitInfo.storageType.name !== null ? data.unitInfo.storageType.name : "";
      var discountCount = typeof data.unitInfo.discounts !== "undefined" && data.unitInfo.discounts !== null ? data.unitInfo.discounts : "";
      var unitDescription = typeof data.unitInfo.description !== "undefined" && data.unitInfo.description !== null ? data.unitInfo.description : "";
      var unitPrice = typeof data.unitInfo.unitPrice !== "undefined" && data.unitInfo.unitPrice !== null ? data.unitInfo.unitPrice : "";
      var taxPercentage = typeof data.unitInfo.taxPercentage !== "undefined" && data.unitInfo.taxPercentage !== null ? data.unitInfo.taxPercentage : "";
      var securityDeposit = typeof data.unitInfo.securityDeposit !== "undefined" && data.unitInfo.securityDeposit !== null ? data.unitInfo.securityDeposit : "";
      var depositRefundable = typeof data.unitInfo.isDepositRefundable !== "undefined" && data.unitInfo.isDepositRefundable !== null ? data.unitInfo.isDepositRefundable : ""; // const grossAmount =
      //   typeof data.unitInfo.grossAmount !== "undefined" &&
      //     data.unitInfo.grossAmount !== null
      //     ? data.unitInfo.grossAmount
      //     : "";

      var sessionObj = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var checkSixSecurity = sessionObj.securityGateName;
      var taxAmount = 0;
      var netAmount = 0;
      var grossAmount = 0;
      var rentAmount = 0;
      var serviceCharges = 0;
      var deposit = 0;
      var discount = 0;
      var periodfrom = "";
      var periodto = "";
      var hasGateAccess = false;
      var hasTimeZone = false;
      var gateAccessCode = "";
      var showTimezone = "display:none";
      var hidetimezone = false;
      var hidegateaccess = false;
      var showRemoveButton = "";
      var gridClass = "six-storage-col six-storage-l6 six-storage-m12";
      var rentaltextClass = "six-storage-m12";

      if (this.unitsRentInformation.length === 1 || this.groupBySize === true) {
        showRemoveButton = "display:none";
        gridClass = "six-storage-m12 six-storage-l8";
        rentaltextClass = "six-storage-m12 six-storage-l8";
      }

      if (typeof data.unitInfo.securityGates !== "undefined" && data.unitInfo.securityGates !== null) {
        hasGateAccess = typeof data.unitInfo.securityGates.hasGateAccess !== "undefined" && data.unitInfo.securityGates.hasGateAccess !== null ? data.unitInfo.securityGates.hasGateAccess : "";
        hasTimeZone = typeof data.unitInfo.securityGates.hasTimeZone !== "undefined" && data.unitInfo.securityGates.hasTimeZone !== null ? data.unitInfo.securityGates.hasTimeZone : "";
        gateAccessCode = typeof data.unitInfo.gateAccessCode !== "undefined" && data.unitInfo.gateAccessCode !== null ? data.unitInfo.gateAccessCode : "";
      }

      if (this.geteAccessInfo.length !== 0) {
        this.geteAccessInfo.forEach(function (item) {
          if (item.unitId === unitId) {
            gateAccessCode = item.gateAccessCode;
          }
        });
      }

      if (data.estimation !== null) {
        taxAmount = typeof data.estimation.taxAmount !== "undefined" && data.estimation.taxAmount !== null ? data.estimation.taxAmount : "";
        netAmount = typeof data.estimation.netAmount !== "undefined" && data.estimation.netAmount !== null ? data.estimation.netAmount : "";
        grossAmount = typeof data.estimation.grossAmount !== "undefined" && data.estimation.grossAmount !== null ? data.estimation.grossAmount : "";
        rentAmount = typeof data.estimation.rentAmount !== "undefined" && data.estimation.rentAmount !== null ? data.estimation.rentAmount : "";
        serviceCharges = typeof data.estimation.serviceCharges !== "undefined" && data.estimation.serviceCharges !== null && data.estimation.serviceCharges !== 0 ? data.estimation.serviceCharges : ""; // deposit =
        //   typeof data.estimation.deposit !== "undefined" &&
        //     data.estimation.deposit !== null &&
        //     data.estimation.deposit !== 0
        //     ? data.estimation.deposit
        //     : "";

        discount = typeof data.estimation.discount !== "undefined" && data.estimation.discount !== null && data.estimation.discount !== 0 ? data.estimation.discount : "";
        periodfrom = typeof data.estimation.startsOn !== "undefined" && data.estimation.startsOn !== null && data.estimation.startsOn !== 0 ? data.estimation.startsOn : "";
        periodto = typeof data.estimation.endsOn !== "undefined" && data.estimation.endsOn !== null && data.estimation.endsOn !== 0 ? data.estimation.endsOn : "";
      }

      var unitTaxDetails = typeof data.unitInfo.taxes !== 'undefined' && data.unitInfo.taxes !== null && data.unitInfo.taxes.length > 0 ? data.unitInfo.taxes.map(function (item, i) {
        return typeof item.name !== 'undefined' && item.name !== null && item.name !== '' && typeof item.value !== 'undefined' && item.value !== null && item.value !== '' && item.value > 0 ? "<span><b>".concat(item.name, ": </b> <span>").concat(_this30.helper.sixStorageDisplayPercent(item.value), "</span></span><br/>") : "";
      }) : "";
      var unitTaxDetailstooltip = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' && unitTaxDetails.length > 0 && unitTaxDetails !== undefined ? "<i class=\"six-storage-material-icons six-storage-icon-align notranslate six-storage-cursor-pointer six-storage-tiny multipleTax six-storage-tooltipped\">info_outline</i>" : '';

      if (typeof unitTaxDetailstooltip !== 'undefined' && unitTaxDetailstooltip !== null && unitTaxDetailstooltip !== '') {
        setTimeout(function () {
          var taxTooltip = document.querySelectorAll('.multipleTax');

          _materialize["default"].Tooltip.init(taxTooltip, {
            html: unitTaxDetails.join('')
          });
        }, 120);
      }

      var taxAmountHtml = typeof taxAmount !== 'undefined' && taxAmount !== null && taxAmount !== '' && taxAmount > 0 ? "<tr class=\"cc\">\n      <td class=\"cc\" colspan=\"2\">".concat(
      /*Tax*/
      wordpress_vars.six_storage_online_fs_Tax, "&nbsp;").concat(typeof taxPercentage !== 'undefined' && taxPercentage !== '' && taxPercentage !== null && taxPercentage > 0 ? "(".concat(this.helper.sixStorageDisplayPercent(taxPercentage), ")") : '').concat(unitTaxDetailstooltip, "</td>\n      <td class=\"cc six-storage-text-right\"><div class=\"six-storage-amount-div\">").concat(this.helper.sixStorageDisplayCurrency(taxAmount), "</div></td>\n   </tr>") : '';
      var serviceHtml = serviceCharges !== "" && serviceCharges !== "0" ? "<tr class=\"cc six-storage-grid-bg-light\"><td class=\"cc\" colspan=\"2\">".concat(
      /*Services*/
      wordpress_vars.six_storage_online_Services, "</td>\n        <td class=\"cc six-storage-text-right\"><div class=\"six-storage-amount-div\">").concat(this.helper.sixStorageDisplayCurrency(serviceCharges), "</div></td></tr>") : "";
      var discountHtml = discount !== "" && discount !== "0" ? "<tr class=\"cc six-storage-grid-bg-light\"><td class=\"cc\" colspan=\"2\">".concat(
      /*Discount*/
      wordpress_vars.six_storage_online_fc_Discount, "</td><td class=\"six-storage-text-right\"><div class=\"six-storage-amount-div\">").concat(this.helper.sixStorageDisplayCurrency(discount), "</div></td></tr>") : "";

      if (discountCount !== null && discountCount !== "" && discountCount !== "undefined" && discountCount.length > 0) {
        var discountTooltip = typeof discountCount !== null && discountCount !== 'undefined' && discountCount.length > 0 ? discountCount.map(function (item, i) {
          return "<span class=\"six-storage-grid-d-flex\">".concat(item.description, "</span>");
        }) : "";
        setTimeout(function () {
          var discounttooltip = document.querySelectorAll("#discount-offers-".concat(unitNumber));

          _materialize["default"].Tooltip.init(discounttooltip, {
            html: "".concat(discountTooltip.join(''))
          });
        }, 120);
      }

      var constructDiscountCount = typeof discountCount.length !== null && discountCount.length !== 'undefined' && discountCount.length > 0 ? "<i class=\"six-storage-material-icons notranslate cc six-storage-discount-icon\" >local_offer </i><span class=\"cc mb5 six-storage-grey-text six-storage-Unitdetail-offtxt\"><b>".concat(discountCount.length).concat(
      /*Offers*/
      wordpress_vars.six_storage_online_Offers, " ").concat(
      /*Available*/
      wordpress_vars.six_storage_online_fc_Available, "</b></span>") : "";
      var discountCountHtml = typeof constructDiscountCount !== null && constructDiscountCount !== 'undefined' && constructDiscountCount !== "" && constructDiscountCount.length > 0 ? "<div class=\"six-storage-row\" id=\"six-storage-discountCountHtml\">\n          <div class=\"six-storage-col six-storage-s12\">\n            <label class=\"cc\">\n              <span class=\"six-storage-flow-text six-storage-tooltipped\" id=\"discount-offers-".concat(unitNumber, "\"  data-position=\"right\"> ").concat(constructDiscountCount, " </span>\n            </label>\n          </div>\n        </div>") : ""; // const depositHtml =
      //   deposit !== "" && deposit !== "0"
      //     ? `<tr class="cc"><td class="cc" colspan="2">Deposit</td><td class="cc six-storage-text-right"><div class="six-storage-amount-div">${this.helper.sixStorageDisplayCurrency(deposit)}</div></td></tr>` : "";

      var isDepositRefundable = depositRefundable !== "" && depositRefundable !== "undefined" && depositRefundable == true ? "(".concat(
      /*Refundable*/
      wordpress_vars.six_storage_online_mi_Refundable, ")") : "";
      var securityDepositHtml = securityDeposit !== "" && securityDeposit !== 0 ? "<tr class=\"cc\"><td class=\"cc\" colspan=\"2\"> ".concat(
      /*Security Deposit*/
      wordpress_vars.six_storage_online_fc_Security_Deposit, " ").concat(isDepositRefundable, "</td><td class=\"cc six-storage-text-right\"><div class=\"six-storage-amount-div\">").concat(this.helper.sixStorageDisplayCurrency(securityDeposit), "</div></td></tr>") : "";
      var shownetAmount = serviceHtml === '' && taxAmountHtml === '' && securityDepositHtml === '' || serviceHtml === null && taxAmountHtml === null && securityDepositHtml === null ? 'six-storage-d-none' : '';
      var html = "<div class=\"".concat(gridClass, " six-storage-col six-storage-grid-mb10 six-storage-grid-ml0 six-storage-grid-mr0 six-storage-online-margin-auto\">\n                             <div class=\"six-storage-bordertable six-storage-grid-six-storage-position-relative six-storage-grid-pt30 six-storage-grid-mb0 six-storage-white\">\n                              ").concat(discountCountHtml, "\n                                <button onclick=\"sixStorageRemoveUnit('").concat(unitId, "')\" id=\"").concat(unitId, "\" type=\"button\" class=\"six-storage-deleteunit-btn cc\" style=\"").concat(showRemoveButton, "\"><span class=\"text-danger\">&times;</span></button>\n                                <div class=\"six-storage-row  cc six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-bold\">\n                                  <div class=\"six-storage-l4 six-storage-col six-storage-s12 six-storage-text-center six-storage-six-storage-font-size-15\"><span>").concat(storageType, "</span> - ").concat(unitNumber, ", (").concat(unitMeasurement, " ").concat(measurementType, ")</div>\n                                  <div class=\"six-storage-l4 six-storage-col six-storage-s12 six-storage-text-center six-storage-six-storage-font-size-15\"><span>").concat(
      /*Location*/
      wordpress_vars.six_storage_online_fs_Location, "</span> - ").concat(locationName, "</div>\n                                  <div class=\"six-storage-l4 six-storage-col six-storage-s12 six-storage-text-center six-storage-six-storage-font-size-15\"><span>").concat(
      /*Building*/
      wordpress_vars.six_storage_online_fs_Building, "</span> - ").concat(buildingName, "</div>\n                                </div>\n                                <table class=\"cc six-storage-grid-table six-storage-grid-table-borderless six-storage-select-unit-table six-storage-grid-mb0\">\n                                   <tbody>\n                                        <tr class=\"cc\">\n                                            <td class=\"cc\" colspan=\"2\">").concat(
      /*Rent for the payment period*/
      wordpress_vars.six_storage_online_fs_Rent_for_the_payment_period, "</td>\n                                            <td class=\"cc six-storage-text-right\"><div class=\"six-storage-amount-div\">").concat(this.helper.sixStorageDisplayCurrency(rentAmount), "</div></td>\n                                        </tr>\n                                        <tr class=\"cc six-storage-grid-bg-light\"></tr>\n                                        ").concat(serviceHtml, "\n                                        ").concat(taxAmountHtml, "\n                                      ").concat(securityDepositHtml, "\n                                      <tr class=\"six-storage-grid-bg-light\">\n                                      <td colspan=\"2\" class=\"cc six-storage-font-weight-600\">").concat(
      /*Total rent for the payment period*/
      wordpress_vars.six_storage_online_fs_Total_rent_for_the_payment_period, " </td>\n                                         <td class=\"cc six-storage-text-right six-storage-font-weight-600\"><div class=\"six-storage-amount-div\">").concat(this.helper.sixStorageDisplayCurrency(netAmount), "</div></td>\n                                      </tr>\n                                      ").concat(discountHtml, "\n                                      <tr class=\"cc six-storage-grid-bg-light\">\n                                      <td colspan=\"2\" class=\"cc six-storage-font-weight-600\">").concat(
      /*Total Due*/
      wordpress_vars.six_storage_online_fs_Total_Due, "</td>\n                                         <td class=\"cc six-storage-text-right six-storage-font-weight-600\"><div class=\"six-storage-amount-div\">").concat(this.helper.sixStorageDisplayCurrency(grossAmount), "</div></td>\n                                      </tr>\n                                   </tbody>\n                                   </table>"); // if (wordpress_vars.six_storage_online_fs_ti_gateaccesscode_toggle == 1) {
      //   hidegateaccess = false;
      // } else {
      //   hidegateaccess = true;
      // }

      if (wordpress_vars.six_storage_online_fs_ti_timezone_is_mandatory == 1) {
        var requiredtimezone = "data-element_required=\"true\"";
      } else {
        requiredtimezone = "data-element_required=\"'false'\"";
      }

      var timezoneMandatoryicon = "<span class=\"six-storage-text-danger\">*</span>";

      if (wordpress_vars.six_storage_online_fs_ti_timezone_is_mandatory === "0") {
        timezoneMandatoryicon = "";
      }

      html += "<div class=\"six-storage-row cc six-storage-grid-border-top six-storage-grid-mt20 six-storage-border-none six-storage-customfield-root-align\">"; // let gateAccessEnabled = this.moveinFieldSettings.filter(x => x.fieldName === "Gateaccesscode" && x.customerPortal.isEnabled === true);

      if (hasGateAccess === true && checkSixSecurity !== '6SECURITY' && checkSixSecurity !== 'LOCKT' && checkSixSecurity !== 'UN-KNOWN GATES') {
        html += "<div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 cc\" id=\"six-storage-gateAccessCodeDiv\">\n      <span><i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-tiny \" id=\"six-storage-gate-tooltip\">help_outline</i></span>\n                                      <input class=\"cc number six-storage-gateaccess six-storage-grid-mb0 \" type=\"text\" placeholder=\"\" data-hasGateAccess=\"".concat(hasGateAccess, "\" data-unitId=\"").concat(unitId, "\" id=\"six-storage-gateAccessCode_").concat(unitId, "\" value=\"").concat(gateAccessCode, "\" maxlength=\"10\"/ >\n                                      <label class=\"cc\">").concat(
        /*Gate Access Code*/
        wordpress_vars.six_storage_online_fs_ti_gate_access_code, "<span class=\"six-storage-text-danger\">*</span></label>\n                                      <div style=\"display: none;\" id=\"six-storage-gateAccessCode_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_ti_please_enter_gate_access_code, "</div>\n                                   </div>");
        setTimeout(function () {
          var sixStoragegateaccesstooltip = "<span style=\"font-size:12px\">".concat(
          /*Gate Access Tooltip Message*/
          wordpress_vars.six_storage_online_su_gate_access_tooltip_msg, ".</span>");
          var sisStoragegatetooltip = document.querySelector('#six-storage-gate-tooltip');

          _materialize["default"].Tooltip.init(sisStoragegatetooltip, {
            html: "".concat(sixStoragegateaccesstooltip)
          });
        }, 120); // document.getElementById('six-storage-gate-tooltip').innerHTML = `${sixStoragegatetooltip}`;
      } else if (hasGateAccess === true && checkSixSecurity !== '6SECURITY' && checkSixSecurity === 'UN-KNOWN GATES' && checkSixSecurity !== 'LOCKT') {
        html += "<div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 cc\" id=\"six-storage-gateAccessCodeDiv\">\n      <span><i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-tiny \" id=\"six-storage-gate-tooltip\">help_outline</i></span>\n                                      <input class=\"cc six-storage-gateaccess six-storage-grid-mb0\" oninput=\"sixStorageCheckOnlyAlphaNumeric(event)\" type=\"text\" placeholder=\"\" data-hasGateAccess=\"".concat(hasGateAccess, "\" data-unitId=\"").concat(unitId, "\" id=\"six-storage-gateAccessCode_").concat(unitId, "\" value=\"").concat(gateAccessCode, "\" maxlength=\"10\" / >\n                                      <label class=\"cc\">").concat(
        /*Gate Access Code*/
        wordpress_vars.six_storage_online_fs_ti_gate_access_code, "<span class=\"six-storage-text-danger\">*</span></label>\n                                      <div style=\"display: none;\" id=\"six-storage-gateAccessCode_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_ti_please_enter_gate_access_code, "</div>\n                                   </div>");
        setTimeout(function () {
          var sixStoragegateaccesstooltip = "<span style=\"font-size:12px\">".concat(
          /*Gate Access Tooltip Message*/
          wordpress_vars.six_storage_online_su_gate_access_tooltip_msg, ".</span>");
          var sisStoragegatetooltip = document.querySelector('#six-storage-gate-tooltip');

          _materialize["default"].Tooltip.init(sisStoragegatetooltip, {
            html: "".concat(sixStoragegateaccesstooltip)
          });
        }, 120);
      }

      var sixStorageCustomFieldHtml = this.sixStorageCustomFieldsDetails('Unit specific details', unitId);

      if (typeof sixStorageCustomFieldHtml !== 'undefined' && sixStorageCustomFieldHtml !== null && sixStorageCustomFieldHtml !== '') {
        html += sixStorageCustomFieldHtml;
      }

      if (hasGateAccess === true && checkSixSecurity !== '6SECURITY' && checkSixSecurity !== 'LOCKT' && sessionObj.timezones.length !== 0) {
        html += "<div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0\" id=\"six-storage-time_zone_hide\" ".concat(requiredtimezone, ">\n                  <select class=\"cc six-storage-timezone\" id=\"six-storage-timezone_").concat(unitId, "\" data-hasTimeZone=\"").concat(hasTimeZone, "\" data-unitId=\"").concat(unitId, "\" ").concat(requiredtimezone, ">\n                    ").concat(this.timeZones, "\n                  </select>\n                  <label class=\"cc\">").concat(
        /*Time Zone*/
        wordpress_vars.six_storage_online_fs_Time_Zone, " ").concat(timezoneMandatoryicon, " </label>\n                  <div style=\"display: none;\" id=\"six-storage-timezone_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
        /*Please Select Timezone*/
        wordpress_vars.six_storage_online_fs_Please_Select_Timezone, "</div>\n              </div>");
      }

      if (typeof sessionObj.timezones !== "undefined" && sessionObj.timezones !== null && sessionObj.timezones !== "") {
        var TimeZone; //if (sessionObj.timezones.length === 0 && wordpress_vars.six_storage_online_fs_ti_timezone_toggle === "0" || sessionObj.timezones.length === 0 && wordpress_vars.six_storage_online_fs_ti_timezone_toggle === "1") {

        if (sessionObj.timezones.length == 0 || wordpress_vars.six_storage_online_fs_ti_timezone_toggle == "0") {
          setTimeout(function () {
            TimeZone = document.getElementById("six-storage-time_zone_hide");

            if (typeof TimeZone !== "undefined" && TimeZone !== null && TimeZone !== "") {
              TimeZone.style.display = 'none';
              TimeZone.remove();
            }
          }, 50);
        } else {
          TimeZone = document.getElementById("six-storage-time_zone_hide");

          if (typeof TimeZone !== "undefined" && TimeZone !== null && TimeZone !== "") {
            TimeZone.style.display = 'block';
          }
        }
      }

      if (wordpress_vars.six_storage_online_fs_of_schedule_move_out_date_toggle == 1) {
        var hidemoveoutdate = "data-element_hidden=\"false\"";
      } else {
        hidemoveoutdate = "data-element_hidden=\"'true'\"";
      }

      if (wordpress_vars.six_storage_online_fs_of_schedule_move_out_date_is_mandatory == 1) {
        var requiredmoveoutdate = "data-element_required=\"'true'\"";
      } else {
        requiredmoveoutdate = "data-element_required=\"false\"";
      }

      html += "<div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 six-storage-unit-Moveout\" ".concat(hidemoveoutdate, " ").concat(requiredmoveoutdate, ">\n                                        <i class=\"six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text\" style=\"font-size: 22px;opacity: 1;\">date_range</i>\n                                       <input class=\"cc six-storage-date-control-desired-moveout\" readonly=\"readonly\" id=\"six-storage-desired-moveout-date_").concat(unitId, "\" type=\"text\" placeholder=\"").concat(this.helper.dateFormat.toUpperCase(), "\" ").concat(hidemoveoutdate, " ").concat(requiredmoveoutdate, " data-unitId=\"").concat(unitId, "\"/>\n                                       <label class=\"six-storage-active cc\" style=\"white-space:nowrap;\">").concat(
      /*Desired Move Out Date*/
      wordpress_vars.six_storage_online_fs_of_Desired_move_out_date, "</label>\n                                       <span style=\"display: none;\" id=\"six-storage-desired-moveout-date_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_of_schedule_move_out_date_validation, "</span>\n                               </div>\n                           </div>\n                       </div></div> ");
      document.getElementById("six-storage-stepping-buttons").style.display = "flex";
      document.getElementById("six-storage-cancel-movein").style.display = "none";
      var gateaccesscodefield = document.querySelector(".six-storage-gateaccess");

      if (typeof gateaccesscodefield !== "undefined" && gateaccesscodefield !== null) {
        if (gateaccesscodefield.value !== "") {
          var gateaccesslabel = document.getElementById("six-storage-gateaccess-label");
          gateaccesslabel.classList.add("six-storage-active");
        }
      }

      var rentalPeriodText = document.getElementById("six-storage-moveinstep-rental-period");

      if (periodfrom !== "" && periodto !== "") {
        rentalPeriodText.innerHTML = "<div class=\"six-storage-grid-ml0 six-storage-text-right six-storage-grid-mb15 six-storage-col ".concat(rentaltextClass, "\"><span class=\"six-storage-grey six-storage-lighten-4 six-storage-grid-p10 six-storage-white-space-nowrap six-storage-grid-ml-auto six-storage-border-left-primary-5 six-storage-rental-period-div six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-600\"><span>").concat(
        /*Payment Period*/
        wordpress_vars.six_storage_online_mi_Payment_Period, ":</span>&nbsp;<span>").concat(this.helper.sixStorageDisplayDate(new Date(periodfrom)), "</span>&nbsp;<span id=\"before_to\">").concat(
        /*to*/
        wordpress_vars.six_storage_online_mi_to, "</span>&nbsp;<span id=\"after_to\">").concat(this.helper.sixStorageDisplayDate(new Date(periodto)), "</span></span></div>");
      } else {
        rentalPeriodText.innerHTML = "";
      }

      this.sixStorageHighlightInputLabel("six-storage-date-control-desired-moveout");
      return html;
    }
  }, {
    key: "sixStorageClearinvoiceSelect",
    value: function sixStorageClearinvoiceSelect(item) {
      if (typeof item === "undefined" && item === null) {
        return;
      }

      item.innerHTML = "";
    }
  }, {
    key: "sixStorageRenderAddons",
    value: function sixStorageRenderAddons() {
      var sixStorageMoveinFlowNote = wordpress_vars.six_storage_online_move_in_flow_note_toggle;
      var html = "<div class=\"six-storage-row cc six-storage-grid-w-100 six-storage-grid-mb30\"><div class=\"six-storage-col six-storage-l12 six-storage-s12\"><h5 class=\"cc six-storage-fs-title six-storage-grid-mt20 six-storage-text-center six-storage-grid-w-100\">".concat(
      /*Addons*/
      wordpress_vars.six_storage_online_addons_custom_word, "</h5>\n    <hr class=\"six-storage-secondary-border-bottom-color six-storage-grid-d-flex six-storage-grid-title-hr\">\n      <p class= \"six-storage-text-center six-storage-note-box six-storage-grey-text six-storage-text-darken-3 cc six-storage-font-size-18  six-storage-grid-p15 six-storage-grid-pr20 six-storage-grid-pl20  six-storage-grid-mt10 six-storage-text-white six-storage-move-in-flow-note-msg six-storage-align-items-center\" > \n        ").concat(sixStorageMoveinFlowNote != '' && sixStorageMoveinFlowNote != null && typeof sixStorageMoveinFlowNote != 'undefined' && sixStorageMoveinFlowNote == '1' ? wordpress_vars.six_storage_online_addons_details : '', " \n      </p> \n      </div>\n      <div class=\" six-storage-grid-d-flex six-storage-flex-wrap six-storage-col cc six-storage-s12 six-storage-grid-p0 six-storage-justify-content-center six-storage-grid-mt15\">\n    <p class=\"cc six-storage-note-box six-storage-grey-text six-storage-text-darken-3  six-storage-font-size-18  six-storage-grid-p15 six-storage-grid-pr20 six-storage-grid-pl20  six-storage-grid-mt10 six-storage-grey six-storage-lighten-4 six-storage-text-white six-storage-rounded-10 six-storage-grid-d-flex six-storage-align-items-center\"><i class=\"six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grid-mr10\">add_shopping_cart</i>\n    ").concat(
      /*Please choose your addons like Insurance, Additional Services or Merchandise*/
      wordpress_vars.six_storage_online_please_choose_your_addons_custom_word, "\n    </p>\n    </div>\n    </div>");
      var addonsDomContent = "";
      this.unitsRentInformation.forEach(function (item) {
        addonsDomContent += this.sixStorageConstructAddonHtml(item);
      }.bind(this));

      if (typeof addonsDomContent !== 'undefined' && addonsDomContent !== null && addonsDomContent !== "") {
        html = html + addonsDomContent;
      } else {
        return "";
      }

      return html;
    }
  }, {
    key: "sixStorageConstructAddonHtml",
    value: function sixStorageConstructAddonHtml(data) {
      var html = "";
      var gridClass = "six-storage-col six-storage-l6 six-storage-m12 six-storage-s12";

      if (typeof data === "undefined" || data === null) {
        return "";
      }

      if (this.unitsRentInformation.length === 1) {
        gridClass = "six-storage-col six-storage-l8 six-storage-m12 six-storage-s12 six-storage-float-none";
      }

      if (typeof data.addOns.merchandise !== 'undefined' && data.addOns.merchandise !== null && data.addOns.merchandise.length > 0) {
        this.hasMerchandise = true;
      } else {
        this.hasMerchandise = false;
      }

      if (typeof data.addOns.insurance !== "undefined" && data.addOns.insurance !== null && data.addOns.insurance.length > 0) {
        this.hasInsurance = true;
      } else {
        this.hasInsurance = false;
      }

      if (typeof data.addOns.services !== "undefined" && data.addOns.services !== null && data.addOns.services.length > 0) {
        this.hasService = true;
      } else {
        this.hasService = false;
      }

      if (typeof data.unitInfo.isMovable !== 'undefined' && data.unitInfo.isMovable !== null && data.unitInfo.isMovable !== true) {
        this.hasvehicleInformation = true;
      } else {
        this.hasvehicleInformation = false;
      }

      if (data && typeof data.estimation !== "undefined" && data.estimation !== null) {
        var periodfrom = typeof data.estimation.startsOn !== "undefined" && data.estimation.startsOn !== null ? this.helper.sixStorageDisplayDate(new Date(data.estimation.startsOn)) : "";
        var periodto = typeof data.estimation.endsOn !== "undefined" && data.estimation.endsOn !== null ? this.helper.sixStorageDisplayDate(new Date(data.estimation.endsOn)) : "";
        html = "<div class=\"".concat(gridClass, " six-storage-grid-mb25 six-storage-grid-border-bottom six-storage-grid-pb20 six-storage-addonGrid-3 six-storage-float-none six-storage-mx-auto\">\n            <div class=\"six-storage-unitselectedgrid six-storage-white\">\n          <table class=\"cc six-storage-grid-table six-storage-grid-table-borderless six-storage-grid-bg-light six-storage-table-sm-block-data\">\n          <thead>\n          <tr class=\"cc\">\n          <th class=\"cc six-storage-text-center six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-bold six-storage-six-storage-font-size-15\" colspan=\"4\"><span>").concat(data.unitInfo.storageType.name, "</span> - ").concat(data.unitInfo.unitNumber, "</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr class=\"cc\">\n          <td class=\"cc six-storage-grid-text-center\">").concat(data.unitInfo.unitMeasurement, " ").concat(data.unitInfo.measurementType, "</td>\n          <td class=\"cc six-storage-grid-text-center\"><span>").concat(
        /*Rent*/
        wordpress_vars.six_storage_online_fc_Rent, "</span> - ").concat(this.helper.sixStorageDisplayCurrency(data.estimation.netAmount), "</td>\n          <td class=\"cc six-storage-grid-text-center\"><span>").concat(
        /*Location*/
        wordpress_vars.six_storage_online_fs_Location, "</span> - ").concat(data.unitInfo.location.name, "</td>\n          <td class=\"cc six-storage-grid-text-center\">").concat(
        /*Building*/
        wordpress_vars.six_storage_online_fs_six_storage_online_fs_Building, " - ").concat(data.unitInfo.building.name, "</td>\n          </tr>\n          </tbody>\n          </table>\n          <div class=\"six-storage-unit-accordion six-storage-grid-w-100\" id=\"six-storage-online-custom-addons\"><ul class=\"six-storage-collapsible cc  six-storage-addon-collapsible\">");
        var addonHtml = "";

        if (data.addOns) {
          addonHtml = "";
          var insuranceHtml = typeof data.addOns.insurance !== "undefined" && data.addOns.insurance !== null && wordpress_vars.six_storage_online_fs_ad_insurance_toggle === '1' && data.addOns.insurance.length > 0 ? this.sixStorageRenderInsurance(data.addOns.insurance, data.unitInfo.id, periodfrom, periodto) : data.addOns.insurance === null && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle == '1' ? this.sixStorageOwnInsuranceOnly(data.unitInfo.id) : null;
          var serviceHtml = typeof data.addOns.services !== "undefined" && data.addOns.services !== null && data.addOns.services.length > 0 && wordpress_vars.six_storage_online_fs_ad_services_toggle === '1' ? this.sixStorageRenderServices(data.addOns.services, data.unitInfo.id, data.unitInfo) : null;
          var merchandiseHtml = typeof data.addOns.merchandise !== "undefined" && data.addOns.merchandise !== null && data.addOns.merchandise.length > 0 && wordpress_vars.six_storage_online_fs_ad_merchandise_toggle === '1' ? this.sixStorageRenderMerchandise(data.addOns.merchandise, data.unitInfo.id) : null;
          var vehicleHtml = data.unitInfo.isMovable === false && wordpress_vars.six_storage_online_fs_ad_vehicle_info_toggle === '1' ? this.sixStorageRenderVehicleInformation(data, data.unitInfo.id) : null;
          addonHtml = addonHtml + (insuranceHtml !== undefined && insuranceHtml !== null ? insuranceHtml : "");
          addonHtml = addonHtml + (serviceHtml !== undefined && serviceHtml !== null ? serviceHtml : "");
          addonHtml = addonHtml + (merchandiseHtml !== undefined && merchandiseHtml !== null ? merchandiseHtml : "");
          addonHtml = addonHtml + (vehicleHtml !== undefined && vehicleHtml !== null ? vehicleHtml : "");

          if (addonHtml === "") {
            return addonHtml;
          } else {
            addonHtml = addonHtml === "" ? "No Addons Found." : html + addonHtml;
          }
        }

        html = addonHtml + "</ul></div></div></div>";
      }

      return html;
    }
  }, {
    key: "sixStorageRenderInsurance",
    value: function sixStorageRenderInsurance(data, unitId, fromDate, toDate) {
      var _this31 = this;

      var insHtml = "";

      if (typeof data === "undefined" || data === null) {
        return "";
      }

      if (wordpress_vars.six_storage_online_fs_ad_insurance_toggle == 1) {
        var hideinsurance = "data-element_hidden=\"false\"";
      } else {
        var hideinsurance = "data-element_hidden=\"'true'\"";
      }

      var insurancemandat = "data-element_required=\"false\"";

      if (wordpress_vars.insuranceMandatory == '1') {
        insurancemandat = "data-element_required=\"'true'\"";
      }

      var taxes = data[0].taxes;
      var unitTaxDetails = typeof taxes !== 'undefined' && taxes !== null && taxes !== '' && taxes.length > 0 ? taxes.map(function (item, i) {
        return typeof item.name !== 'undefined' && item.name !== null && item.name !== '' && typeof item.value !== 'undefined' && item.value !== null && item.value !== '' ? "<span><b>".concat(item.name, ": </b> <span>").concat(_this31.helper.sixStorageDisplayPercent(item.value), "</span></span><br/>") : "";
      }) : "";
      var unitTaxDetailstooltip = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' && unitTaxDetails.length > 0 && unitTaxDetails !== undefined ? "<i class=\"six-storage-material-icons six-storage-icon-align notranslate six-storage-cursor-pointer six-storage-tiny multipleIPTTax six-storage-tooltipped six-storage-six-storage-font-size-15\">info_outline</i>" : '';

      if (typeof unitTaxDetailstooltip !== 'undefined' && unitTaxDetailstooltip !== null && unitTaxDetailstooltip !== '') {
        setTimeout(function () {
          var taxTooltip = document.querySelectorAll('.multipleIPTTax');

          _materialize["default"].Tooltip.init(taxTooltip, {
            html: unitTaxDetails.join('')
          });
        }, 120);
      }

      insHtml = "<li ".concat(hideinsurance, "  ").concat(insurancemandat, " class=\"cc six-storage-active\">\n    <div class=\"six-storage-collapsible-header cc six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-bold six-storage-justify-content-between six-storage-align-items-center six-storage-grey six-storage-lighten-5 six-storage-grid-mb0\">\n    <label class=\"cc\">").concat(
      /*Insurance*/
      wordpress_vars.six_storage_online_insurance_word, "</label> \n    \n    <svg width=\"1.5em\"  height=\"1.5em\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n\n    <path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/>\n</svg></div>\n      <div class=\"six-storage-collapsible-body cc six-storage-leasetab \">\n      <div class=\"six-storage-grid-table-responsive six-storage-custom-scroller six-storage-leasetab six-storage-movein-insurance\">\n      <table class=\"six-storage-grid-table cc six-storage-grid-table-borderless six-storage-grid-mt20\">\n      <thead class=\"six-storage-grid-thead-light six-storage-grey six-storage-lighten-4\">\n      <tr class=\"cc\">\n      <th  class=\"cc six-storage-grid-text-center\"> ").concat(
      /*Select Insurance*/
      wordpress_vars.six_storage_online_fs_ad_select_insurance, "</th>\n      <th  class=\"cc six-storage-grid-text-center\" style=\"white-space:nowrap;\"> ").concat(
      /*Insurance Name*/
      wordpress_vars.six_storage_online_fs_ad_insurance_name, "</th>\n      <th class=\"cc six-storage-grid-text-center\"> ").concat(
      /*Coverage*/
      wordpress_vars.six_storage_online_fs_ad_Coverage, " </th>\n      <th class=\"cc six-storage-grid-text-center\"> ").concat(
      /*IPT*/
      wordpress_vars.six_storage_online_fs_ad_ipt, " <span>").concat(unitTaxDetailstooltip, "</span> </th>\n      <th class=\"cc six-storage-grid-text-center six-storage-min-w-120\"> ").concat(
      /*Period*/
      wordpress_vars.six_storage_online_fs_ad_Period, " </th>\n      <th class=\"cc six-storage-grid-text-center\"> ").concat(
      /*Premium(With Tax)*/
      wordpress_vars.six_storage_online_fs_ad_insurance_premium, " </th>\n      </tr>\n      </thead>\n      <tbody>");
      var pos = this.insuranceInfo.map(function (e) {
        return e.unitId;
      }).indexOf(unitId);
      var insuranceForUnit = this.insuranceInfo[pos];

      for (var i = 0; i < data.length; i++) {
        var insuranceSelected = "";
        var insuranceIndex = typeof insuranceForUnit !== 'undefined' && insuranceForUnit !== null ? insuranceForUnit["insurancePlans"].indexOf(data[i].id) : -1;

        if (insuranceIndex > -1) {
          insuranceSelected = "checked";
        }

        insHtml = insHtml + "<tr class=\"cc\" onclick=\"sixStorageCheckedRadioInsurance(this);\" >\n          <td class=\"cc six-storage-grid-text-center\"><div><label class=\"cc\">\n          <input class=\"six-storage-select-units six-storage-insurance-selection six-storage-input-field cc six-storage-with-gap\" type=\"radio\" name=\"six-storage-rbnInsurance_".concat(unitId, "\" ").concat(insuranceSelected, "\n          value=\"").concat(unitId, "_").concat(i, "\" onchange=\"sixStorageInsuranceSelectionChange('").concat(unitId, "','").concat(data[i].id, "','").concat(data[i].planName, "(").concat(data[i].provider.name, ")')\"/>\n          <span ></span>\n          </label></div></td>\n          <td class=\"cc six-storage-grid-text-center\"><input type=\"hidden\" class=\"insurance_").concat(unitId, "\" id=\"insurance_").concat(unitId, "_").concat(i, "\"\n          value=\"").concat(data[i].id, "\"/>").concat(data[i].planName, "(").concat(data[i].provider.name, ")</td>\n          <td class=\"cc six-storage-grid-text-center\">").concat(this.helper.sixStorageDisplayCurrency(data[i].coverage), "</td>\n          <td class=\"cc six-storage-grid-text-center\">").concat(this.helper.sixStorageDisplayPercent(data[i].premium.domestic.taxPerCentage), "</td>\n          <td class=\"cc six-storage-grid-text-center\">").concat(fromDate, " to ").concat(toDate, "</td>\n          <td class=\"cc six-storage-grid-text-center\">").concat(this.helper.sixStorageDisplayCurrency(data[i].premium.domestic.netAmount), "</td>\n          </tr>");
      }

      if (typeof wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== null && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== '' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== '0' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle === '1') {
        insHtml = insHtml + "<tr class=\" cc six-storage-i-have-my-own-ins\"  onclick=\"sixStorageCheckedRadioInsurance(this);\"><td class=\"cc six-storage-grid-text-center\"><div class=\"cc\"><label class=\"cc\">\n            <input class=\"six-storage-select-units six-storage-input-field cc six-storage-with-gap\" type=\"radio\" name=\"six-storage-rbnInsurance_".concat(unitId, "\" value=\"\" onchange=\"sixStorageThirdPartyInsurnaceSelected('").concat(unitId, "')\"/><span></span>\n            </label></div></td><td colspan=\"5\" class=\"cc six-storage-grid-text-center\">").concat(
        /*I have my own insurance*/
        wordpress_vars.six_storage_online_I_have_my_own_insurance, "</td></tr>\n            <tr class=\"six-storage-thirdparty-insurance-form\"><td colspan=\"6\" style=\"padding-top:0;\"><div id=\"six-storage-thirdparty-insurance_").concat(unitId, "\" style=\"disaply:none;\"></div></td></tr>\n            ");
      }

      var sixStorageCustomFieldHtml = this.sixStorageCustomFieldsDetails('Insurance Details');

      if (typeof sixStorageCustomFieldHtml !== 'undefined' && sixStorageCustomFieldHtml !== null && sixStorageCustomFieldHtml !== '') {
        insHtml = insHtml + "<div id=\"six-storage-customfield-insurance\" style=\"disaply:none;\">\n              <div id=\"six-storage-customfield-insurance-fields\"></div>\n              </div>";
      }

      if (data.length > 0) {
        if (wordpress_vars.six_storage_online_fs_ad_no_insurance_toggle == 1) {
          insHtml = insHtml + "<tr class=\"cc\" onclick=\"sixStorageCheckedRadioInsurance(this);\"><td class=\"cc six-storage-grid-text-center\"><div class=\"cc\"><label class=\"cc\">\n            <input class=\"six-storage-select-units six-storage-input-field cc six-storage-with-gap\" type=\"radio\" name=\"six-storage-rbnInsurance_".concat(unitId, "\" value=\"\" onchange=\"sixStorageInsuranceSelectionChange('").concat(unitId, "','','')\"/><span></span>\n            </label></div></td><td colspan=\"5\" class=\"cc six-storage-grid-text-center six-storage-noinsurance-addons\">").concat(
          /*No Insurance*/
          wordpress_vars.six_storage_online_fs_No_Insurance, "</td></tr>");
        }
      } else {
        insHtml = insHtml + "<tr class=\"cc\"><td class=\"cc\" colspan=\"4\">".concat(
        /*No insurance plans available*/
        wordpress_vars.six_storage_online_fs_No_insurance_plans_available, "</td></tr>");
      }

      insHtml = insHtml + "</tbody></table></div></div></li>";

      _materialize["default"].AutoInit();

      return insHtml;
    }
  }, {
    key: "sixStorageCheckedRadioInsurance",
    value: function sixStorageCheckedRadioInsurance(tr) {
      var insradioButton = tr.querySelector('input[type="radio"]');

      if (insradioButton) {
        insradioButton.checked = true;
        var event = new Event('change');
        insradioButton.dispatchEvent(event);
      }
    }
  }, {
    key: "sixStorageOwnInsuranceOnly",
    value: function sixStorageOwnInsuranceOnly(unitId) {
      this.sixStorageInitialowninsurance = true;
      var insHtml = "";

      if (wordpress_vars.six_storage_online_fs_ad_insurance_toggle == 1) {
        var hideinsurance = "data-element_hidden=\"false\"";
      } else {
        var hideinsurance = "data-element_hidden=\"'true'\"";
      }

      var insurancemandat = "data-element_required=\"false\"";

      if (wordpress_vars.insuranceMandatory == '1') {
        insurancemandat = "data-element_required=\"'true'\"";
      }

      var unitTaxDetailstooltip = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' && unitTaxDetails.length > 0 && unitTaxDetails !== undefined ? "<i class=\"six-storage-material-icons six-storage-icon-align notranslate six-storage-cursor-pointer six-storage-tiny multipleIPTTax six-storage-tooltipped six-storage-six-storage-font-size-15\">info_outline</i>" : '';

      if (typeof unitTaxDetailstooltip !== 'undefined' && unitTaxDetailstooltip !== null && unitTaxDetailstooltip !== '') {
        setTimeout(function () {
          var taxTooltip = document.querySelectorAll('.multipleIPTTax');

          _materialize["default"].Tooltip.init(taxTooltip, {
            html: unitTaxDetails.join('')
          });
        }, 120);
      }

      insHtml = "<li ".concat(hideinsurance, "  ").concat(insurancemandat, " class=\"cc six-storage-active\">\n    <div class=\"six-storage-collapsible-header cc six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-bold six-storage-justify-content-between six-storage-align-items-center six-storage-grey six-storage-lighten-5 six-storage-grid-mb0\">\n    <label class=\"cc\">").concat(
      /*Insurance*/
      wordpress_vars.six_storage_online_insurance_word, "</label> \n    <svg width=\"1.5em\"  height=\"1.5em\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/>\n</svg></div>\n      <div class=\"six-storage-collapsible-body cc six-storage-leasetab \">\n      <div class=\"six-storage-grid-table-responsive six-storage-custom-scroller six-storage-leasetab six-storage-movein-insurance\">\n      <table class=\"six-storage-grid-table cc six-storage-grid-table-borderless six-storage-grid-mt20\">\n      <thead class=\"six-storage-grid-thead-light six-storage-grey six-storage-lighten-4\">\n      <tr class=\"cc\">\n      <th  class=\"cc six-storage-grid-text-center\"> ").concat(
      /*Select Insurance*/
      wordpress_vars.six_storage_online_fs_ad_select_insurance, "</th>\n      <th  class=\"cc six-storage-grid-text-center\" style=\"white-space:nowrap;\"> ").concat(
      /*Insurance Name*/
      wordpress_vars.six_storage_online_fs_ad_insurance_name, "</th>\n      <th class=\"cc six-storage-grid-text-center\"> ").concat(
      /*Coverage*/
      wordpress_vars.six_storage_online_fs_ad_Coverage, " </th>\n      <th class=\"cc six-storage-grid-text-center\"> ").concat(
      /*IPT*/
      wordpress_vars.six_storage_online_fs_ad_ipt, " <span>").concat(unitTaxDetailstooltip, "</span> </th>\n      <th class=\"cc six-storage-grid-text-center six-storage-min-w-120\"> ").concat(
      /*Period*/
      wordpress_vars.six_storage_online_fs_ad_Period, " </th>\n      <th class=\"cc six-storage-grid-text-center\"> ").concat(
      /*Premium(With Tax)*/
      wordpress_vars.six_storage_online_fs_ad_insurance_premium, " </th>\n      </tr>\n      </thead>\n      <tbody>");

      if (typeof wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== null && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== '' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== '0' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle === '1') {
        insHtml = insHtml + "<tr class=\" cc six-storage-i-have-my-own-ins\"  onclick=\"sixStorageCheckedRadioInsurance(this);\"><td class=\"cc six-storage-grid-text-center\"><div class=\"cc\"><label class=\"cc\">\n            <input class=\"six-storage-select-units six-storage-input-field cc six-storage-with-gap\" type=\"radio\" name=\"six-storage-rbnInsurance_".concat(unitId, "\" value=\"\" onchange=\"sixStorageThirdPartyInsurnaceSelected('").concat(unitId, "')\"/><span></span>\n            </label></div></td><td colspan=\"5\" class=\"cc six-storage-grid-text-center\">").concat(
        /*I have my own insurance*/
        wordpress_vars.six_storage_online_I_have_my_own_insurance, "</td></tr>\n            <tr class=\"six-storage-thirdparty-insurance-form\"><td colspan=\"6\" style=\"padding-top:0;\"><div id=\"six-storage-thirdparty-insurance_").concat(unitId, "\" style=\"disaply:none;\"></div></td></tr>\n            ");
      }

      if (wordpress_vars.six_storage_online_fs_ad_no_insurance_toggle == 1) {
        insHtml = insHtml + "<tr class=\"cc\" onclick=\"sixStorageCheckedRadioInsurance(this);\"><td class=\"cc six-storage-grid-text-center\"><div class=\"cc\"><label class=\"cc\">\n          <input class=\"six-storage-select-units six-storage-input-field cc six-storage-with-gap\" type=\"radio\" name=\"six-storage-rbnInsurance_".concat(unitId, "\" value=\"\" onchange=\"sixStorageInsuranceSelectionChange('").concat(unitId, "','','')\"/><span></span>\n          </label></div></td><td colspan=\"5\" class=\"cc six-storage-grid-text-center six-storage-noinsurance-addons\">").concat(
        /*No Insurance*/
        wordpress_vars.six_storage_online_fs_No_Insurance, "</td></tr>");
      }

      var sixStorageCustomFieldHtml = this.sixStorageCustomFieldsDetails('Insurance Details');

      if (typeof sixStorageCustomFieldHtml !== 'undefined' && sixStorageCustomFieldHtml !== null && sixStorageCustomFieldHtml !== '') {
        insHtml = insHtml + "<div id=\"six-storage-customfield-insurance\" style=\"disaply:none;\">\n              <div id=\"six-storage-customfield-insurance-fields\"></div>\n              </div>";
      }

      insHtml = insHtml + "</tbody></table></div></div></li>";

      _materialize["default"].AutoInit();

      return insHtml;
    }
  }, {
    key: "sixStorageThirdPartyInsurnaceSelected",
    value: function sixStorageThirdPartyInsurnaceSelected(unitId) {
      this.insuranceInfo = [];
      this.selectedThirdPartyInsurance = true;
      this.sixStorageOnlineSelectedInsuranceField = true;
      document.getElementById("six-storage-thirdparty-insurance_".concat(unitId)).style.display = 'block';
      var sixStorageCustomFieldHtml = this.sixStorageCustomFieldsDetails('Insurance Third Party', unitId); // sixStorageCustomFieldHtml = typeof sixStorageCustomFieldHtml !== 'undefined' && sixStorageCustomFieldHtml !== null
      // sixStorageCustomFieldHtml !== '' ? sixStorageCustomFieldHtml : '';

      var displayProviderName = 'none';

      if (wordpress_vars.six_storage_online_insurance_policy_providername_toggle == '1') {
        displayProviderName = '';
      }

      var providerNameMandatory = 'false';

      if (wordpress_vars.six_storage_online_insurance_policy_providername_is_mandatory == '1') {
        providerNameMandatory = "'true'";
      }

      var displayPolicyNumber = 'none';

      if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_policy_number_toggle == '1') {
        displayPolicyNumber = '';
      }

      var policyNumberMandatory = 'false';

      if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_policy_number_is_mandatory == '1') {
        policyNumberMandatory = "'true'";
      }

      var displayPolicyPhoneNumber = 'none';

      if (wordpress_vars.six_storage_online_insurance_policy_phonenumber_toggle == '1') {
        displayPolicyPhoneNumber = '';
      }

      var policyPhoneNumberMandatory = 'false';

      if (wordpress_vars.six_storage_online_insurance_policy_phonenumber_is_mandatory == '1') {
        policyPhoneNumberMandatory = "'true'";
      }

      var displayInsuranceEffectiveFromDate = 'none';

      if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_start_date_toggle == '1') {
        displayInsuranceEffectiveFromDate = '';
      }

      var insuranceEffectiveFromMandatory = 'false';

      if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_start_date_is_mandatory == '1') {
        insuranceEffectiveFromMandatory = "'true'";
      }

      var displayInsuranceEffectiveEndDate = 'none';

      if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_end_date_toggle == '1') {
        displayInsuranceEffectiveEndDate = '';
      }

      var insuranceEffectiveEndMandatory = 'false';

      if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_end_date_is_mandatory == '1') {
        insuranceEffectiveEndMandatory = "'true'";
      }

      var thirdpatyFieldHtml = "\n    \n    <div class=\"six-storage-grid-form-row six-storage-text-left six-storage-grid-p30\" id=\"six-storage-thirdpartyInsurance\">\n        <div class=\"six-storage-row cc\">\n            <div class=\"six-storage-input-field  six-storage-col six-storage-m6\" style=\"display:".concat(displayProviderName, "\" data-element_required=\"").concat(providerNameMandatory, "\" >\n                <input class=\"cc six-storage-vehicle-info\" type=\"text\" placeholder=\" \" data-unitId=\"").concat(unitId, "\" data-element_required=\"").concat(providerNameMandatory, "\" id=\"six_storage_insurance_provider_name_").concat(unitId, "\" style=\"margin:0;\"/>\n                <label class=\"cc\">").concat(wordpress_vars.six_storage_Policy_Provider_Name, "</label>\n                <div style=\"display: none;\" id=\"six_storage_insurance_provider_name_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_Please_Enter_Policy_Provider_Name, "</div>\n            </div>\n            <div class=\"six-storage-input-field  six-storage-col six-storage-m6\" style=\"display:").concat(displayPolicyNumber, "\" data-element_required=\"").concat(policyNumberMandatory, "\">\n                <input class=\"cc six-storage-vehicle-info\" type=\"text\" placeholder=\" \" data-unitId=\"").concat(unitId, "\" data-element_required=\"").concat(policyNumberMandatory, "\" id=\"six_storage_insurance_policy_number_").concat(unitId, "\" />\n                <label class=\"cc\">").concat(wordpress_vars.six_storage_Policy_Number, "</label>\n                <div style=\"display: none;\" id=\"six_storage_insurance_policy_number_").concat(unitId, "-err\" data-unitId=\"").concat(unitId, "\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_Please_Enter_Policy_Number, "</div>\n            </div>\n            <div class=\"six-storage-input-field  six-storage-col six-storage-m6\" style=\"display:").concat(displayPolicyPhoneNumber, "\" data-element_required=\"").concat(policyPhoneNumberMandatory, "\">\n                <input class=\"cc six-storage-vehicle-info\" type=\"text\" placeholder=\" \" data-unitId=\"").concat(unitId, "\" data-element_required=\"").concat(policyPhoneNumberMandatory, "\" id=\"six_storage_insurance_policy_phone_number_").concat(unitId, "\" />\n                <label class=\"cc\">").concat(wordpress_vars.six_storage_Policy_Phone_Number, "</label>\n                <div style=\"display: none;\" id=\"six_storage_insurance_policy_phone_number_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_Please_Enter_Policy_Phone_Number, "</div>\n            </div>\n            <div class=\"six-storage-input-field  six-storage-col six-storage-m6\" data-element_required=\"").concat(insuranceEffectiveFromMandatory, "\" style=\"display:").concat(displayInsuranceEffectiveFromDate, "\" >\n                <i class=\"six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text\">date_range</i>\n                <input class=\"cc six-storage-vehicle-info\" type=\"text\" placeholder=\" \" data-unitId=\"").concat(unitId, "\" data-element_required=\"").concat(insuranceEffectiveFromMandatory, "\" id=\"six_storage_insurance_effective_from_date_").concat(unitId, "\" />\n                <label class=\"cc\">").concat(wordpress_vars.six_storage_Effective_From_Date, "</label>\n                <div style=\"display: none;\" id=\"six_storage_insurance_effective_from_date_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_Please_Select_Effective_From_Date, "</div>\n            </div>\n            <div class=\"six-storage-input-field six-storage-col six-storage-m6\" data-element_required=\"").concat(insuranceEffectiveEndMandatory, "\" style=\"display:").concat(displayInsuranceEffectiveEndDate, "\" >\n                <i class=\"six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text\">date_range</i>\n                <input class=\"cc six-storage-vehicle-info\" type=\"text\" placeholder=\" \" data-unitId=\"").concat(unitId, "\" data-element_required=\"").concat(insuranceEffectiveEndMandatory, "\" id=\"six_storage_insurance_effective_to_date_").concat(unitId, "\"  />\n                <label class=\"cc\">").concat(wordpress_vars.six_storage_Effective_to_Date, "</label>\n                <div style=\"display: none;\" id=\"six_storage_insurance_effective_to_date_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_Please_Select_Effective_to_Date, "</div>\n               </div>\n            ").concat(sixStorageCustomFieldHtml, "\n        </div>\n    </div>\n    ");
      document.getElementById("six-storage-thirdparty-insurance_".concat(unitId)).innerHTML = "".concat(thirdpatyFieldHtml);
      var date = new Date();
      this.sixStorageInitDatepicker("#six_storage_insurance_effective_from_date_".concat(unitId), null, null, null);
      this.sixStorageInitDatepicker("#six_storage_insurance_effective_to_date_".concat(unitId), date, new Date("".concat(date.getFullYear() + 50, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), null);
    }
  }, {
    key: "sixStorageInsuranceSelectionChange",
    value: function sixStorageInsuranceSelectionChange(unitId, insuranceId, planName) {
      if (typeof wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== null && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== '' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle !== '0' && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle === '1') {
        document.getElementById("six-storage-thirdparty-insurance_".concat(unitId)).style.display = 'none';
      }

      this.selectedThirdPartyInsurance = false;
      this.sixstorageSelectInsurance = true; //document.getElementById('six-storage-customfield-insurance').style.display = "none";

      var sixStorageCustomFieldHtml = this.sixStorageCustomFieldsDetails('Insurance Details', unitId);

      if (typeof sixStorageCustomFieldHtml !== 'undefined' && sixStorageCustomFieldHtml !== '' && sixStorageCustomFieldHtml !== null) {
        document.getElementById('six-storage-customfield-insurance').style.display = "";
        document.getElementById('six-storage-customfield-insurance').innerHTML = sixStorageCustomFieldHtml;
      }

      var pos = this.insuranceInfo.map(function (e) {
        return e.unitId;
      }).indexOf(unitId);

      if (pos >= 0) {
        if (insuranceId == "") {
          this.insuranceInfo.splice(pos, 1);
          document.querySelectorAll("six-storage-insurance-selection").forEach(function (ele) {
            ele.checked = false;
            ele.removeAttribute("checked");
          });
        } else {
          this.insuranceInfo[pos].insurancePlans[0] = insuranceId;
        }
      } else if (insuranceId !== "" && insuranceId !== null) {
        this.sixStorageOnlineSelectedInsuranceField = true;
        this.insuranceInfo.push({
          unitId: unitId,
          insurancePlans: [insuranceId]
        });
      }
    }
  }, {
    key: "sixStorageServicesSelected",
    value: function sixStorageServicesSelected(unitId, serviceId) {
      var pos = this.additionalServices.map(function (e) {
        return e.unitId;
      }).indexOf(unitId);

      if (pos >= 0) {
        var addedPos = this.additionalServices[pos].services.indexOf(serviceId);

        if (addedPos >= 0) {
          this.additionalServices[pos].services.splice(addedPos, 1);
        } else {
          this.additionalServices[pos].services.push(serviceId);
        }
      } else {
        this.additionalServices.push({
          unitId: unitId,
          services: [serviceId]
        });
      }
    }
  }, {
    key: "sixStorageRenderServices",
    value: function sixStorageRenderServices(data, unitId, item) {
      var _this32 = this;

      var serHtml = "";

      if (typeof data === "undefined" || data === null) {
        return "";
      }

      if (wordpress_vars.six_storage_online_fs_ad_services_toggle == 1) {
        var hideservices = "data-element_hidden=\"false\"";
      } else {
        var hideservices = "data-element_hidden=\"'true'\"";
      }

      var servicemandatory = "data-element_required=\"false\"";

      if (wordpress_vars.six_storage_online_fs_ad_services_is_mandatory == '1') {
        servicemandatory = "data-element_required=\"'true'\"";
      }

      var unitTaxDetails = typeof item.taxes !== 'undefined' && item.taxes !== null && item.taxes.length > 0 ? item.taxes.map(function (data, i) {
        return typeof data.name !== 'undefined' && data.name !== null && data.name !== '' && typeof data.value !== 'undefined' && data.value !== null && data.value !== '' ? "<span><b>".concat(data.name, ": </b> <span>").concat(_this32.helper.sixStorageDisplayPercent(data.value), "</span></span><br/>") : "";
      }) : "";
      var unitTaxDetailstooltip = typeof unitTaxDetails !== 'undefined' && unitTaxDetails !== null && unitTaxDetails !== '' && unitTaxDetails.length > 0 && unitTaxDetails !== undefined ? "<i class=\"six-storage-material-icons six-storage-icon-align notranslate six-storage-cursor-pointer six-storage-tiny six-storage-multipleTax six-storage-tooltipped\">info_outline</i>" : '';

      if (typeof unitTaxDetailstooltip !== 'undefined' && unitTaxDetailstooltip !== null && unitTaxDetailstooltip !== '') {
        setTimeout(function () {
          var taxTooltip = document.querySelectorAll('.six-storage-multipleTax');

          _materialize["default"].Tooltip.init(taxTooltip, {
            html: unitTaxDetails.join('')
          });
        }, 120);
      }

      serHtml = "<li ".concat(hideservices, " ").concat(servicemandatory, " class=\"cc\" ><div class=\"six-storage-collapsible-header cc six-storage-grey-text six-storage-font-weight-bold six-storage-text-darken-3 six-storage-justify-content-between six-storage-align-items-center six-storage-grey six-storage-lighten-5 six-storage-grid-mb0\" data-settings_name=\"\">\n     <label class=\"cc\"> ").concat(
      /*Services*/
      wordpress_vars.six_storage_online_Services, "</label>\n    <svg width=\"1.5em\"  height=\"1.5em\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/>\n</svg></div>\n      <div class=\"six-storage-collapsible-body cc\">\n      <div class=\"six-storage-grid-table-responsive six-storage-custom-scroller six-storage-leasetab\">\n      <table class=\"six-storage-grid-table cc six-storage-grid-table-borderless six-storage-grid-mt20\">\n      <thead class=\"six-storage-grid-thead-light six-storage-grey six-storage-lighten-4\">\n      <tr class=\"cc\">\n      <th class=\"cc\">").concat(
      /*Select Service*/
      wordpress_vars.six_storage_online_fs_Select_Service, "</th>\n      <th  class=\"cc six-storage-grid-text-center\">").concat(
      /*Service Name*/
      wordpress_vars.six_storage_online_fs_Service_Name, "</th>\n      <th class=\"cc six-storage-grid-text-center\">").concat(
      /*Price*/
      wordpress_vars.six_storage_online_fs_Price, "</th>\n      <th class=\"cc six-storage-grid-text-center\">").concat(
      /*Net Cost*/
      wordpress_vars.six_storage_online_fs_Net_Cost, " (").concat(
      /*With Tax*/
      wordpress_vars.six_storage_online_mi_With_Tax, ")").concat(unitTaxDetailstooltip, "</th>\n      </tr>\n      </thead>\n      <tbody>");
      var pos = this.additionalServices.map(function (e) {
        return e.unitId;
      }).indexOf(unitId);

      for (var i = 0; i < data.length; i++) {
        var isSelected = "";
        var disableSelection = "";
        var index = typeof this.additionalServices[pos] !== 'undefined' && this.additionalServices[pos] !== null ? this.additionalServices[pos]["services"].indexOf(data[i].id) : -1;

        if (index > -1 || data[i].isMandatory === true) {
          this.unitBasedServiceSelected = true;
          isSelected = "checked";
        }

        if (data[i].isMandatory === true) {
          disableSelection = "disabled";
        }

        serHtml = serHtml + "<tr class=\"cc\">\n          <td class=\"cc six-storage-grid-text-center\">\n          <div>\n          <label class=\"cc\">\n          <input class=\"six-storage-select-units cc six-storage-input-field\" type=\"checkbox\" name=\"six-storage-services_".concat(data[i].unitId, "\" value=\"").concat(data[i].unitId, "\"\n          onchange=\"sixStorageServicesSelected('").concat(unitId, "','").concat(data[i].id, "')\" ").concat(isSelected, " ").concat(disableSelection, "/><span></span>\n          </label></div></td>\n          <td class=\"cc six-storage-grid-text-center\"><input type=\"hidden\" class=\"six-storage-services_").concat(data[i].unitId, "\" id=\"six-storage-services_").concat(data[i].unitId, "_").concat(i, "\"\n          value=\"").concat(data[i].id, "\"/>").concat(data[i].serviceName, "</td>\n          <td class=\"cc six-storage-grid-text-center\">").concat(this.helper.sixStorageDisplayCurrency(data[i].serviceCharge.price), "</td>\n          <td class=\"cc six-storage-grid-text-center\">").concat(this.helper.sixStorageDisplayCurrency(data[i].serviceCharge.netAmount), "</td>\n          </tr>");
      }

      if (data.length > 0) {//TODO
      } else {
        serHtml = serHtml + "<tr class=\"cc\"><td class=\"cc\" colspan=\"4\">".concat(
        /*No extra services available*/
        wordpress_vars.six_storage_online_fs_No_extra_services_available, "</td></tr>");
      }

      serHtml = serHtml + "</tbody>\n      </table></div>\n      </div></li>";
      return serHtml;
    }
  }, {
    key: "sixStorageRenderMerchandise",
    value: function sixStorageRenderMerchandise(data, unitId) {
      var merchHtml = "";

      if (typeof data === "undefined" || data === null) {
        return "";
      }

      var pos = -1;
      var res = -1;
      var addedMerchandise = [];
      var merchCartValue = 0;
      var qntyty = 0;

      if (this.merchItems.length > 0) {
        pos = this.merchItems.map(function (e) {
          return e.unitId;
        }).indexOf(unitId);
        addedMerchandise = typeof this.merchItems[pos] !== 'undefined' && typeof this.merchItems[pos]["merchandise"] !== 'undefined' && this.merchItems[pos]["merchandise"] !== null ? this.merchItems[pos]["merchandise"] : [];
        res = this.merchItems.map(function (e) {
          return e.unitId;
        }).indexOf(unitId);
        merchCartValue = typeof this.merchItems[res] !== 'undefined' && typeof this.merchItems[res]["merchandise"] !== 'undefined' && this.merchItems[res]["merchandise"] !== null ? this.merchItems[res]["merchandise"].forEach(function (e) {
          qntyty = e.qnty + qntyty;
        }) : 0;
      }

      if (wordpress_vars.six_storage_online_fs_ad_merchandise_toggle == 1) {
        var hidemerchandise = "data-element_hidden=\"false\"";
      } else {
        var hidemerchandise = "data-element_hidden=\"'true'\"";
      }

      var merchandisemandatory = "data-element_required = \"false\"";

      if (wordpress_vars.merchandiseMandatory == '1') {
        merchandisemandatory = "data-element_required = \"'true'\"";
      }

      merchHtml = "<li class=\"cc\" ".concat(hidemerchandise, " ").concat(merchandisemandatory, "><div class=\"six-storage-collapsible-header cc six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-bold six-storage-justify-content-between six-storage-align-items-center six-storage-grey six-storage-lighten-5 six-storage-grid-mb0\">\n    \n    <label class =\"cc\">").concat(
      /*Merchandise*/
      wordpress_vars.six_storage_online_fs_Merchandise, "</label>\n    \n    <svg width=\"1.5em\"  height=\"1.5em\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/>\n</svg></div>\n          <div class=\"six-storage-collapsible-body cc\">\n              <div class=\"six-storage-grid-row six-storage-grid-mb20\">\n                  <h5 class=\"cc six-storage-fs-title six-storage-text-center six-storage-h-5 six-storage-grid-w-100 six-storage-font-size-14 six-storage-grey-text six-storage-text-darken-3\">").concat(
      /*Select Products*/
      wordpress_vars.six_storage_online_fs_Select_Products, "</h5>\n              </div>\n              \n              <div class=\"six-storage-row cc six-storage-grid-mt15\">\n              <div class=\"six-storage-grid-alert six-storage-s12 six-storage-grey six-storage-lighten-3 six-storage-font-size-14 six-storage-grey-text six-storage-text-darken-3\">\n              <div class=\"six-storage-row cc six-storage-grid-mt15 six-storage-grid-mb10\">\n                  <p class=\"six-storage-grid-mb0\"><b>").concat(
      /*Note*/
      wordpress_vars.six_storage_online_mi_Note, "</b>: ").concat(
      /*Selected product(s) will be delivered to delivery address entered in next step.*/
      wordpress_vars.six_storage_online_mi_Selected_product_will_be_delivered_to_delivery_address, "</p>\n                </div>\n                    <div class=\"six-storage-grid-row six-storage-grid-p15 six-storage-grey six-storage-lighten-3 six-storage-flexbox-important six-storage-justify-content-end six-storage-flex-wrap\" style=\"margin-left:auto;\">\n              <div>\n              <div class=\"six-storage-grid-input-group \" style=\"display:none;\">\n\t<input type=\"text\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom\" id=\"\" placeholder=\"").concat(
      /*Search*/
      wordpress_vars.six_storage_online_mi_Search, "\" aria-describedby=\"six-storage-inputGroupPrepend\" />\n\t<div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white six-storage-merSearch\">\n\t\t<span class=\"six-storage-grid-input-group-text six-storage-secondary-color six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"fa fa-search\"></i></span>\n\t</div>\n</div>\n              </div>\n              <div class=\"six-storage-grid-d-flex six-storage-merCart\">\n                  <div class=\"six-storage-addcart six-storage-grid-ml-auto\" >\n                      <input type=\"hidden\" id=\"six-storage-addedProductCount_").concat(unitId, "\" name=\"six-storage-addedProductCount_").concat(unitId, "\" value=\"").concat(qntyty, "\">\n                      <div class=\"six-storage-cart-items\" id=\"six-storage-cartItems_").concat(unitId, "\">\n                          ").concat(qntyty, "\n                      </div>\n                      <p class=\"six-storage-font-weight-bold six-storage-grid-mb0 six-storage-grid-d-flex six-storage-font-size-14 six-storage-grey-text six-storage-text-darken-3\">\n                      <i class=\"six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grey-text six-storage-grid-mr5\">shopping_cart</i>\n                      ").concat(
      /*Cart*/
      wordpress_vars.six_storage_online_mi_Cart, "</p>\n                  </div>\n                </div>\n              </div>\n              </div>\n              <div class=\"six-storage-row cc six-storage-flexbox-important six-storage-flex-wrap six-storage-align-items-center six-storage-justify-content-start\">");

      for (var i = 0; i < data.length; i++) {
        var selectedCount = 0;

        if (pos > -1) {
          var currentItemIndex = typeof addedMerchandise !== 'undefined' && addedMerchandise !== null ? addedMerchandise.map(function (e) {
            return e.itemId;
          }).indexOf(data[i].id) : 0;
          var currentItem = addedMerchandise[currentItemIndex];

          if (typeof currentItem !== 'undefined' && currentItem !== null) {
            selectedCount = addedMerchandise[currentItemIndex]["qnty"];
          }
        }

        var availabilitymerch = data[i].availableStock;

        if (this.merchItems.length > 0) {
          availabilitymerch = data[i].availableStock - selectedCount;
        }

        var imageUrl = typeof data[i].imageUrl === "undefined" || data[i].imageUrl === null || data[i].imageUrl === "" ? "".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/dummy-img-circle.png") : data[i].imageUrl;
        merchHtml = merchHtml + "<div class=\"six-storage-col six-storage-m4 six-storage-s6 six-storage-text-center six-storage-grid-ml0\">\n          <div class=\"six-storage-img-container\">\n          <div class=\"six-storage-img-box-div ".concat(data[i].productName, "\" style=\"background-image:url('").concat(encodeURI(imageUrl), "')\" ></div>\n          <div class=\"six-storage-middle\">\n          <div class=\"six-storage-text six-storage-addPrdouct six-storage-grid-p0 six-storage-text-center six-storage-grid-d-flex six-storage-flex-column six-storage-justify-content-center six-storage-align-items-center\">\n          <a href=\"javascript:void(0)\" onclick=\"sixStorageIncreaseQuantity('").concat(unitId, "','").concat(data[i].id, "','").concat(data[i].productName, "','").concat(encodeURI(imageUrl), "',").concat(data[i].availableStock, ");\">\n            <i class=\"six-storage-material-icons top-plus-icon notranslate six-storage-grey-text\">add_circle_outline</i>\n          </a>\n          <input type=\"hidden\" id=\"six-storage-availableproduct_").concat(data[i].id, "\" name=\"six-storage-availableproduct_").concat(data[i].id, "\" value=\"").concat(availabilitymerch, "\">\n          <input type=\"text\" name=\"text\" class=\"six-storage-grid-form-control  six-storage-text-center six-storage-font-weight-bold six-storage-count-col six-storage-grid-mt15 six-storage-grid-mb15 number\"\n          id=\"six-storage-merchandiseQnty_").concat(unitId, "_").concat(data[i].id, "\" min=\"0\" max=\"1000\" maxlength=\"3\"\n          onchange=\"sixStorageAddMerchandiseCart('").concat(unitId, "','").concat(data[i].id, "','").concat(data[i].productName, "','").concat(encodeURI(imageUrl), "');\" value=\"").concat(selectedCount, "\" readonly/>\n          <a href=\"javascript:void(0)\" onclick=\"sixStorageReduceQuantity('").concat(unitId, "','").concat(data[i].id, "','").concat(data[i].productName, "','").concat(encodeURI(imageUrl), "');\">\n            <i class=\"six-storage-material-icons six-storage-bottom-plus-icon notranslate six-storage-grey-text\">remove_circle_outline</i>\n          </a>\n          </div>\n          </div>\n          </div>\n          <h6 class=\"cc six-storage-grid-mt10 six-storage-six-storage-font-size-15 six-storage-grey-text six-storage-text-darken-3\">").concat(data[i].productName, "</h6>\n          <h6 class=\"cc six-storage-grid-mt0 six-storage-six-storage-font-size-15 six-storage-grey-text\">").concat(this.helper.sixStorageDisplayCurrency(data[i].price.netAmount), "</h6>\n          </div>");
      }

      merchHtml = merchHtml + "</div></div></li>";
      return merchHtml;
    }
  }, {
    key: "sixStorageRenderVehicleInformation",
    value: function sixStorageRenderVehicleInformation(data, unitId) {
      var html = "";

      if (typeof unitId === "undefined" || unitId === null) {
        return "";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_info_toggle == 0) {
        var hidevehicleinfo = "data-element_hidden=\"true\"";
      } else {
        hidevehicleinfo = "data-element_hidden=\"false\"";
      } //Vehicle Type


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_type_toggle == 1) {
        var hidevehicleType = "data-element_hidden=\"'false'\"";
        var displayvehicleType = "style=\"\";";
      } else {
        hidevehicleType = "data-element_hidden=\"'true'\"";
        displayvehicleType = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_type_is_mandatory == 1) {
        var requiredvehicleType = "data-element_required=\"'true'\"";
      } else {
        requiredvehicleType = "data-element_required=\"'false'\"";
      }

      var vechicleinfomandatory = "data-element_required = \"'false'\"";

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_info_is_mandatory == '1') {
        vechicleinfomandatory = "data-element_required = \"'true'\"";
      } //Vehicle Manufactured Year


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_manufactured_year_toggle == 1) {
        var hidevehicleyear = "data-element_hidden=\"'false'\"";
        var displayvehicleyear = "style=\"\";";
      } else {
        hidevehicleyear = "data-element_hidden=\"'true'\"";
        displayvehicleyear = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_manufactured_year_is_mandatory == 1) {
        var requiredvehicleyear = "data-element_required=\"'true'\"";
      } else {
        requiredvehicleyear = "data-element_required=\"'false'\"";
      } //Vehicle Brand


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_brand_toggle == 1) {
        var hidevehiclebrand = "data-element_hidden=\"'false'\"";
        var displayvehiclebrand = "style=\"\";";
      } else {
        hidevehiclebrand = "data-element_hidden=\"'true'\"";
        displayvehiclebrand = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_brand_is_mandatory == 1) {
        var requiredvehiclebrand = "data-element_required=\"'true'\"";
      } else {
        requiredvehiclebrand = "data-element_required=\"'false'\"";
      } //Vehicle Model


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_model_toggle == 1) {
        var hidevehiclemodel = "data-element_hidden=\"'false'\"";
        var displayvehiclemodel = "style=\"\";";
      } else {
        hidevehiclemodel = "data-element_hidden=\"'true'\"";
        displayvehiclemodel = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_model_is_mandatory == 1) {
        var requiredvehiclemodel = "data-element_required=\"'true'\"";
      } else {
        requiredvehiclemodel = "data-element_required=\"'false'\"";
      } //Vehicle Make Color


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_make_color_toggle == 1) {
        var hidevehiclecolor = "data-element_hidden=\"'false'\"";
        var displayvehiclecolor = "style=\"\";";
      } else {
        hidevehiclecolor = "data-element_hidden=\"'true'\"";
        displayvehiclecolor = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_make_color_is_mandatory == 1) {
        var requiredvehiclecolor = "data-element_required=\"'true'\"";
      } else {
        requiredvehiclecolor = "data-element_required=\"'false'\"";
      } //Vehicle Licence State


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_licence_state_toggle == 1) {
        var hidevehiclestate = "data-element_hidden=\"'false'\"";
        var displayvehiclestate = "style=\"\";";
      } else {
        hidevehiclestate = "data-element_hidden=\"'true'\"";
        displayvehiclestate = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_licence_state_is_mandatory == 1) {
        var requiredvehiclestate = "data-element_required=\"'true'\"";
      } else {
        requiredvehiclestate = "data-element_required=\"'false'\"";
      } //Vehicle Registration Number


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_registration_number_toggle == 1) {
        var hidevehicleregno = "data-element_hidden=\"'false'\"";
        var displayvehicleregno = "style=\"\";";
      } else {
        hidevehicleregno = "data-element_hidden=\"'true'\"";
        displayvehicleregno = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_registration_number_is_mandatory == 1) {
        var requiredvehicleregno = "data-element_required=\"'true'\"";
      } else {
        requiredvehicleregno = "data-element_required=\"'false'\"";
      } //Vehicle Licence Number


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_licence_number_toggle == 1) {
        var hidevehiclelicenceno = "data-element_hidden=\"'false'\"";
        var displayvehiclelicenceno = "style=\"\";";
      } else {
        hidevehiclelicenceno = "data-element_hidden=\"'true'\"";
        displayvehiclelicenceno = "style=\"display:none\";";
      }

      if (wordpress_vars.six_storage_online_fs_ad_vehicle_licence_number_is_mandatory == 1) {
        var requiredvehiclelicenceno = "data-element_required=\"'true'\"";
      } else {
        requiredvehiclelicenceno = "data-element_required=\"'false'\"";
      }

      var sixStorageCustomFields = this.sixStorageCustomFieldsDetails('Vehicle Details', unitId);
      sixStorageCustomFields = typeof sixStorageCustomFields !== 'undefined' && sixStorageCustomFields !== '' && sixStorageCustomFields !== null ? sixStorageCustomFields : '';
      var customvehicleFieldheadtable = "";

      if (typeof sixStorageCustomFields !== 'undefined' && sixStorageCustomFields !== '' && sixStorageCustomFields !== null) {
        this.customFieldsResponse.result.forEach(function (item, index) {
          if (item.matadata.displayOn === 'Vehicle Details') {
            customvehicleFieldheadtable += "<th class=\"cc\">".concat(item.fieldName, "</th>");
          }
        });
      }

      var yearHtml = this.helper.sixStorageGetYearList(new Date().getFullYear() - 100, new Date().getFullYear() + 1);
      html = "<li class=\"six-storage-vehicle-info-tab cc\" ".concat(hidevehicleinfo, " ").concat(vechicleinfomandatory, " data-unitId=\"").concat(unitId, "\">\n    <div class=\"six-storage-collapsible-header cc six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-bold six-storage-justify-content-between six-storage-align-items-center six-storage-grey six-storage-lighten-5 six-storage-grid-mb10\" id=\"six-storage-vehicleInfo_").concat(unitId, "\">\n   \n    <label class =\"cc\"> ").concat(
      /*Vehicle Details */
      wordpress_vars.six_storage_online_fs_ad_vehicle_details, " </label>\n    \n    <svg width=\"1.5em\" height=\"1.5em\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\" />\n        </svg></div>\n    <div class=\"six-storage-collapsible-body cc\">\n        <h6 class=\"six-storage-grid-w-100 six-storage-text-left cc\" id=\"six-storage-vehicleInformation-head").concat(unitId, "\" style=\"display:none;\">").concat(
      /*Added Vehicles*/
      wordpress_vars.six_storage_online_mi_Added_Vehicles, "</h6>\n        <div class=\"six-storage-grid-table-responsive six-storage-custom-scroller six-storage-leasetab\">\n        <table class=\"six-storage-word-break-table six-storage-addedvehicles cc six-storage-text-center six-storage-grid-table six-storage-grid-table-borderless six-storage-grid-mt20\" id=\"six-storage-vehicleInformation-table").concat(unitId, "\" style=\"display:none;\">\n            <thead class=\"six-storage-grid-thead-light six-storage-grey six-storage-lighten-4\" style=\"white-space: nowrap;\">\n                <tr class=\"cc\">\n                    <th class=\"cc\" ").concat(displayvehicleType, ">").concat(
      /*Vehicle Type*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_type_custom_word, "</th>\n                    <th class=\"cc\" ").concat(displayvehiclebrand, ">").concat(
      /*Brand*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_brand_custom_word, "</th>\n                    <th class=\"cc\" ").concat(displayvehiclemodel, ">").concat(
      /*Model*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_model_custom_word, "</th>\n                    <th class=\"cc\" ").concat(displayvehicleregno, ">").concat(
      /*Registration #*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_registration_number_custom_word, "</th>\n                    <th class=\"cc\" ").concat(displayvehiclelicenceno, ">").concat(
      /*License #*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_license_number_custom_word, "</th>\n                    <th class=\"cc\" ").concat(displayvehicleyear, ">").concat(
      /*Year*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_license_year_custom_word, "</th>\n                    <th class=\"cc\" ").concat(displayvehiclecolor, ">").concat(
      /*Color*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_license_Color_custom_word, "</th>\n                    <th class=\"cc\" ").concat(displayvehiclestate, ">").concat(
      /*State*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_license_State_custom_word, "</th>\n                    ").concat(customvehicleFieldheadtable, "\n                    <th class=\"cc\">").concat(
      /*Action*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_Action_custom_word, "</th>\n                </tr>\n            </thead>\n            <tbody id=\"six-storage-vehicleInformation_").concat(unitId, "\">\n            </tbody>\n        </table></div>\n        <form onchange=\"sixStorageAddVehicleDetails('six-storage-vehicleAdd_").concat(unitId, "')\" class=\"six-storage-grid-p0 cc six-storage-grid-shadow-none six-storage-form-sign-up-modal six-storage-grid-w-100 six-storage-mx-auto\" id=\"six-storage-vehicle-information-form").concat(unitId, "\" action = \"post\" autocomplete=\"off\">\n        <div class=\"six-storage-grid-form-row six-storage-text-left-vechicle\" id=\"six-storage-showvehicleinfo1\">\n            <div class=\"six-storage-row cc \">        \n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehicleType, " ").concat(requiredvehicleType, " >\n                    <input class=\"cc six-storage-vehicle-info").concat(unitId, "\" ").concat(requiredvehicleType, " type=\"text\"  id=\"six_storage_vehicleType_").concat(unitId, "\" ").concat(hidevehicleType, " style=\"margin:0;\"/>\n                    <label class=\"cc\">").concat(
      /*Vehicle Type*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_type_custom_word, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleType_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Enter Vehicle Type*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_type_validation, "</div>\n                </div>\n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehicleyear, " ").concat(requiredvehicleyear, ">\n                    <select class=\"cc six-storage-vehicle-info").concat(unitId, "\" placeholder=\" \" id=\"six_storage_vehicleYear_").concat(unitId, "\" ").concat(requiredvehicleyear, " >\n                      ").concat(yearHtml, "\n                    </select>\n                    <label class=\"cc\">").concat(
      /*Vehicle Year*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_manufactured_year_custom_word, "\n              \n                    </label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleYear_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Enter Year*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_manufactured_year_validation, "</div>\n                </div>\n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehiclebrand, " ").concat(requiredvehiclebrand, ">\n                    <input class=\"cc six-storage-vehicle-info").concat(unitId, "\" type=\"text\" placeholder=\" \" id=\"six_storage_vehicleBrand_").concat(unitId, "\" ").concat(hidevehiclebrand, " ").concat(requiredvehiclebrand, " />\n                    <label class=\"cc\">").concat(
      /*Brand*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_brand_custom_word, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleBrand_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Enter Brand*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_brand_validation, "</div>\n                </div>\n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehiclemodel, " ").concat(requiredvehiclemodel, ">\n                    <input class=\"cc six-storage-vehicle-info").concat(unitId, "\" type=\"text\" id=\"six_storage_vehicleModel_").concat(unitId, "\" ").concat(hidevehiclemodel, " ").concat(requiredvehiclemodel, " />\n                    <label class=\"cc\">").concat(
      /*Model*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_model_custom_word, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleModel_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Enter Vehicle Model*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_model_validation, "</div>\n                </div>\n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehiclecolor, " ").concat(requiredvehiclecolor, ">\n                    <input class=\"cc six-storage-vehicle-info").concat(unitId, "\" type=\"text\" id=\"six_storage_vehicleColor_").concat(unitId, "\" ").concat(hidevehiclecolor, " ").concat(requiredvehiclecolor, " />\n                    <label class=\"cc\">").concat(
      /*Color*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_make_color_custom_word, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleColor_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Enter Color*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_make_color_validation, "</div>\n                </div>\n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehiclestate, " ").concat(requiredvehiclestate, ">\n                    <input class=\"cc six-storage-vehicle-info").concat(unitId, "\" type=\"text\" id=\"six_storage_vehicleLicenceState_").concat(unitId, "\" ").concat(hidevehiclestate, " ").concat(requiredvehiclestate, " />\n                    <label class=\"cc\">").concat(
      /*License State*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_licence_state_custom_word, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleLicenceState_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Enter License State*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_licence_state_validation, "</div>\n                </div>\n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehicleregno, " ").concat(requiredvehicleregno, ">\n                    <input class=\"cc six-storage-vehicle-info").concat(unitId, "\" type=\"text\" id=\"six_storage_vehicleRegdNumber_").concat(unitId, "\" ").concat(hidevehicleregno, " ").concat(requiredvehicleregno, " />\n                    <label class=\"cc\">").concat(
      /*Registration No*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_registration_number_custom_word, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleRegdNumber_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\"> ").concat(
      /*Please Enter Registration No*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_registration_number_validation, "</div>\n                </div>\n                <div class=\"six-storage-input-field  six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\" ").concat(hidevehiclelicenceno, " ").concat(requiredvehiclelicenceno, ">\n                    <input class=\"cc six-storage-vehicle-info").concat(unitId, "\" type=\"text\" id=\"six_storage_vehicleLcenceNumber_").concat(unitId, "\" ").concat(hidevehiclelicenceno, " ").concat(requiredvehiclelicenceno, " />\n                    <label class=\"cc\">").concat(
      /*License No*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_license_number_custom_word, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_vehicleLcenceNumber_").concat(unitId, "-err\" class=\"six-storage-invalid-feedback\"> ").concat(
      /*Please Enter License No*/
      wordpress_vars.six_storage_online_fs_ad_vehicle_license_number_validation, "</div>\n                </div> \n                ").concat(sixStorageCustomFields, "               \n            </div>\n            <div id =\"six-storage-add_Vechicle_Information_button\"> <center> <button type=\"button\" style=\"display:none;\"  class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color six-storage-addvehicleinfo\" id=\"six-storage-vehicleAdd_").concat(unitId, "\" onclick=\"sixStorageAddVehicleInfo('").concat(unitId, "');\">").concat(
      /*Add*/
      wordpress_vars.six_storage_online_mi_Add, "</button> </center>\n            </div>\n            </div> \n            </form>\n        </div>  \n       <a href=\"javascript:void(0)\"; id =\"six-storage-add_Vechicle_Information_button_Add_More").concat(unitId, "\" style=\"display:none;\"  class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color six-storage-addvehicleinfo six-storage-grid-mt25\"  onclick=\"sixStorageAddVehicleInfoAddmoreBtn('").concat(unitId, "');\">").concat(
      /*Add-More*/
      wordpress_vars.six_storage_online_mi_Add_More, "</a>\n    \n</li>");
      return html;
    }
  }, {
    key: "sixStorageAddVehicleDetails",
    value: function sixStorageAddVehicleDetails(display_add) {
      var vechile_form_div = document.getElementsByClassName("six-storage-text-left-vechicle");
      Array.prototype.forEach.call(vechile_form_div, function (vehicle_fields) {
        if (typeof vehicle_fields !== 'undefined' && vehicle_fields !== null && vehicle_fields !== '') {
          var input_type = vehicle_fields.getElementsByTagName("input");
          var all_fields = [];

          for (var i = 0; i < input_type.length; i++) {
            if (input_type[i].value !== "" && input_type[i].value !== null) {
              all_fields.push(input_type[i].value);
            }
          }

          if (typeof input_type !== 'undefined' && input_type !== '' && input_type !== null) {
            for (var _i2 = 0; _i2 < all_fields.length; _i2++) {
              if (all_fields.length !== 0) {
                document.getElementById("".concat(display_add)).style.display = 'block';
              } else {
                document.getElementById("".concat(display_add)).style.display = 'none';
              }
            }
          }
        }
      });
    }
  }, {
    key: "sixStorageAddVehicleInfoAddmoreBtn",
    value: function sixStorageAddVehicleInfoAddmoreBtn(unitId) {
      //display form none
      document.getElementById("six-storage-vehicle-information-form".concat(unitId)).style.display = 'block'; // Hide addmore btn

      var Addmore = document.getElementById("six-storage-add_Vechicle_Information_button_Add_More".concat(unitId));
      Addmore.style.display = 'none';
    }
  }, {
    key: "sixStorageAddVehicleInfo",
    value: function sixStorageAddVehicleInfo(unitId) {
      //Vehicle Type
      if (wordpress_vars.six_storage_online_fs_ad_vehicle_type_toggle == 1) {
        var displaybdyvehicleType = "style=\"\";";
      } else {
        displaybdyvehicleType = "style=\"display:none\";";
      } //Vehicle Manufactured Year


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_manufactured_year_toggle == 1) {
        var displaybdyvehicleyear = "style=\"\";";
      } else {
        displaybdyvehicleyear = "style=\"display:none\";";
      } //Vehicle Brand


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_brand_toggle == 1) {
        var displaybdyvehiclebrand = "style=\"\";";
      } else {
        displaybdyvehiclebrand = "style=\"display:none\";";
      } //Vehicle Model


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_model_toggle == 1) {
        var displaybdyvehiclemodel = "style=\"\";";
      } else {
        displaybdyvehiclemodel = "style=\"display:none\";";
      } //Vehicle Make Color


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_make_color_toggle == 1) {
        var displaybdyvehiclecolor = "style=\"\";";
      } else {
        displaybdyvehiclecolor = "style=\"display:none\";";
      } //Vehicle Licence State


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_licence_state_toggle == 1) {
        var displaybdyvehiclestate = "style=\"\";";
      } else {
        displaybdyvehiclestate = "style=\"display:none\";";
      } //Vehicle Registration Number


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_registration_number_toggle == 1) {
        var displaybdyvehicleregno = "style=\"\";";
      } else {
        displaybdyvehicleregno = "style=\"display:none\";";
      } //Vehicle Licence Number


      if (wordpress_vars.six_storage_online_fs_ad_vehicle_licence_number_toggle == 1) {
        var displaybdyvehiclelicenceno = "style=\"\";";
      } else {
        displaybdyvehiclelicenceno = "style=\"display:none\";";
      }

      var vehicleHrml = "";
      var vehicleArray = [];

      if (typeof unitId === "undefined" || unitId === null) {
        return "";
      }

      var six_storage_vehicleType_ = document.getElementById("six_storage_vehicleType_".concat(unitId)).value;
      var six_storage_vehicleYear_ = document.getElementById("six_storage_vehicleYear_".concat(unitId)).value;
      var six_storage_vehicleBrand_ = document.getElementById("six_storage_vehicleBrand_".concat(unitId)).value;
      var six_storage_vehicleModel_ = document.getElementById("six_storage_vehicleModel_".concat(unitId)).value;
      var six_storage_vehicleColor_ = document.getElementById("six_storage_vehicleColor_".concat(unitId)).value;
      var six_storage_vehicleLicenceState_ = document.getElementById("six_storage_vehicleLicenceState_".concat(unitId)).value;
      var six_storage_vehicleRegdNumber_ = document.getElementById("six_storage_vehicleRegdNumber_".concat(unitId)).value;
      var six_storage_vehicleLcenceNumber_ = document.getElementById("six_storage_vehicleLcenceNumber_".concat(unitId)).value;
      var vehicleInfo = document.getElementsByClassName("six-storage-vehicle-info".concat(unitId));
      var valid = true;
      var error_count = 0;

      if (typeof vehicleInfo !== "undefined" && vehicleInfo.length > 0) {
        var _required = false;
        Array.prototype.forEach.call(vehicleInfo, function (element) {
          try {
            var field = element;

            if (typeof field != 'undefined' && field != null) {
              _required = field.dataset.element_required == "'true'" ? true : false;
            }

            if (_required === true && (element.value == null || element.value == "" || element.value == "NaN-NaN-NaN")) {
              document.getElementById(element.id + "-err").style.display = "block";
              error_count = error_count + 1;
              return false;
            } else {
              //localStorage.setItem(key, value);
              var elementObj = document.getElementById(element.id + "-display");

              if (elementObj) {
                elementObj.innerHTML = value;
              }

              var ele = document.getElementById(element.id + "-err");

              if (ele) {
                ele.style.display = "none";
              }
            }
          } catch (err) {
            console.error(err);
          }
        });
      }

      var custom_error_count = 0;
      var required = false;
      var checkboxReq = false;
      var radioReq = false;
      custom_error_count = this.sixstorageValidateCustomFields('vehicleDetails');

      if (error_count === 0 && custom_error_count === 0) {
        document.getElementById("six-storage-vehicleInformation-table".concat(unitId)).style.display = 'block';
        document.getElementById("six-storage-vehicleInformation-head".concat(unitId)).style.display = 'block';
        var obj = {
          vehicleType: six_storage_vehicleType_,
          vehicleBrand: six_storage_vehicleBrand_,
          vehicleYear: six_storage_vehicleYear_,
          vehicleColor: six_storage_vehicleColor_,
          vehicleModel: six_storage_vehicleModel_,
          vehicleLicenceSate: six_storage_vehicleLicenceState_,
          vehicleRegNumber: six_storage_vehicleRegdNumber_,
          vehicleLicenceNumber: six_storage_vehicleLcenceNumber_
        };
        var vehicletypeval = typeof obj.vehicleType !== 'undefined' && obj.vehicleType !== null && obj.vehicleType !== "" ? obj.vehicleType : '-';
        var vehiclebrandval = typeof obj.vehicleBrand !== 'undefined' && obj.vehicleBrand !== null && obj.vehicleBrand !== "" ? obj.vehicleBrand : '-';
        var vehiclemodelval = typeof obj.vehicleModel !== 'undefined' && obj.vehicleModel !== null && obj.vehicleModel !== "" ? obj.vehicleModel : '-';
        var vehicleregnumberval = typeof obj.vehicleRegNumber !== 'undefined' && obj.vehicleRegNumber !== null && obj.vehicleRegNumber !== "" ? obj.vehicleRegNumber : '-';
        var vehiclelicnumval = typeof obj.vehicleLicenceNumber !== 'undefined' && obj.vehicleLicenceNumber !== null && obj.vehicleLicenceNumber !== "" ? obj.vehicleLicenceNumber : '-';
        var vehicleyearval = typeof obj.vehicleYear !== 'undefined' && obj.vehicleYear !== null && obj.vehicleYear !== "" ? obj.vehicleYear : '-';
        var vehiclecolorval = typeof obj.vehicleColor !== 'undefined' && obj.vehicleColor !== null && obj.vehicleColor !== "" ? obj.vehicleColor : '-';
        var vehiclestateval = typeof obj.vehicleLicenceSate !== 'undefined' && obj.vehicleLicenceSate !== null && obj.vehicleLicenceSate !== "" ? obj.vehicleLicenceSate : '-';
        var node = document.createElement("tr");
        this.vehicleInfo.forEach(function (item, index) {
          if (item.unitId === unitId) {
            vehicleArray = item.vehicleDetails;
          }
        });
        var vehicletablehead = '';
        this.customFieldsValues.forEach(function (item, index) {
          vehicletablehead = typeof item.value !== 'undefined' && item.value !== null && item.value !== '' ? "<td class=\"cc\">".concat(item.value, "</td>") : '-';
        });
        node.id = "six-storage-trVehicleInfo_".concat(unitId, "_").concat(vehicleArray.length);
        vehicleHrml = "\n        <td class=\"cc\" ".concat(displaybdyvehicleType, ">").concat(vehicletypeval, "</td>\n        <td class=\"cc\" ").concat(displaybdyvehiclebrand, ">").concat(vehiclebrandval, "</td>\n        <td class=\"cc\" ").concat(displaybdyvehiclemodel, ">").concat(vehiclemodelval, "</td>\n        <td class=\"cc\" ").concat(displaybdyvehicleregno, ">").concat(vehicleregnumberval, "</td>\n        <td class=\"cc\" ").concat(displaybdyvehiclelicenceno, ">").concat(vehiclelicnumval, "</td>\n        <td class=\"cc\" ").concat(displaybdyvehicleyear, ">").concat(vehicleyearval, "</td>\n        <td class=\"cc\" ").concat(displaybdyvehiclecolor, ">").concat(vehiclecolorval, "</td>\n        <td class=\"cc\" ").concat(displaybdyvehiclestate, ">").concat(vehiclestateval, "</td>\n        ").concat(vehicletablehead, "\n        <td class=\"cc\"><a class=\"cc\" onclick=\"sixStorageRemoveVehicleInfo('six-storage-trVehicleInfo_").concat(unitId, "_").concat(vehicleArray.length, "')\" href=\"javascript:void(0);\"><i class=\"six-storage-material-icons cc six-storage-tiny actionButtonOpacity notranslate\">close</i></a></td>");
        node.innerHTML = vehicleHrml;
        document.getElementById("six-storage-vehicleInformation_".concat(unitId)).appendChild(node);
        var pos = this.vehicleInfo.map(function (e) {
          return e.unitId;
        }).indexOf(unitId);

        if (pos > -1) {
          this.vehicleInfo[pos].vehicleDetails.push(obj);
        } else {
          this.vehicleInfo.push({
            unitId: unitId,
            vehicleDetails: [obj]
          });
        }

        document.getElementById("six_storage_vehicleType_".concat(unitId)).value = "";
        document.getElementById("six_storage_vehicleYear_".concat(unitId)).value = "";
        document.getElementById("six_storage_vehicleBrand_".concat(unitId)).value = "";
        document.getElementById("six_storage_vehicleModel_".concat(unitId)).value = "";
        document.getElementById("six_storage_vehicleColor_".concat(unitId)).value = "";
        document.getElementById("six_storage_vehicleLicenceState_".concat(unitId)).value = "";
        document.getElementById("six_storage_vehicleRegdNumber_".concat(unitId)).value = "";
        document.getElementById("six_storage_vehicleLcenceNumber_".concat(unitId)).value = "";
        var custom_fields_checkbox_containers = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_vehicleDetails");

        if (typeof custom_fields_checkbox_containers !== 'undefined' && custom_fields_checkbox_containers !== null && custom_fields_checkbox_containers !== '') {
          Array.prototype.forEach.call(custom_fields_checkbox_containers, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null) {
                for (var i = 0; i < check_button_type.length; i++) {
                  document.getElementById("".concat(check_button_type[i].id)).checked = false;
                }
              }
            }
          });
        }

        var custom_fields_radio_button_containers = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_vehicleDetails");

        if (typeof custom_fields_radio_button_containers !== 'undefined' && custom_fields_radio_button_containers !== null && custom_fields_radio_button_containers !== '') {
          Array.prototype.forEach.call(custom_fields_radio_button_containers, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  document.getElementById("".concat(radios_button_type[i].id)).checked = false;
                }
              }
            }
          });
        }

        var formInputFields = document.getElementsByClassName("six-storage-custom_input_fields_vehicleDetails");
        Array.prototype.forEach.call(formInputFields, function (field) {
          document.getElementById("".concat(field.id)).value = "";
        });
        document.getElementById("six-storage-vehicle-information-form".concat(unitId)).style.display = 'none';
        document.getElementById("six-storage-add_Vechicle_Information_button_Add_More".concat(unitId)).style.display = 'block';
      }

      var elems = document.querySelectorAll('select');

      var instances = _materialize["default"].FormSelect.init(elems);
    }
  }, {
    key: "sixStorageRemoveVehicleInfo",
    value: function sixStorageRemoveVehicleInfo(rowId) {
      var unitId = rowId.split("_")[1],
          rowNo = rowId.split("_")[2];
      var row = document.getElementById(rowId);
      row.remove();
      var vehicle = document.querySelector('.six-storage-addedvehicles');

      if (vehicle.rows.length === 1) {
        document.getElementById("six-storage-vehicleInformation-table".concat(unitId)).style.display = "none";
        ;
      } else {
        document.getElementById("six-storage-vehicleInformation-table".concat(unitId)).style.display = "";
      }

      document.getElementById("six-storage-vehicle-information-form".concat(unitId)).style.display = 'block';
      document.getElementById("six-storage-add_Vechicle_Information_button_Add_More".concat(unitId)).style.display = 'none';
    }
  }, {
    key: "sixStorageIncreaseQuantity",
    value: function sixStorageIncreaseQuantity(unitId, itemId, itamName, itemImage, availableStock) {
      var availableProduct = document.getElementById("six-storage-availableproduct_".concat(itemId));

      if (availableProduct.value === '0') {
        this.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_out_of_stock), true);
        return;
      }

      var qnty = document.getElementById("six-storage-merchandiseQnty_".concat(unitId, "_").concat(itemId));
      qnty.value = parseInt(availableProduct.value) === '0' ? qnty.value : parseInt(qnty.value) + 1;
      var addingCart = document.getElementById("six-storage-addedProductCount_".concat(unitId));
      addingCart.value = parseInt(availableProduct.value) === '0' ? addingCart.value : parseInt(addingCart.value) + 1;
      document.getElementById("six-storage-cartItems_".concat(unitId)).innerHTML = addingCart.value;
      var availability = document.getElementsByName("six-storage-availableproduct_".concat(itemId));

      for (var i = 0; i < availability.length; i++) {
        availability[i].value = availability[i].value - 1;
      }

      this.sixStorageAddMerchandiseCart(unitId, itemId, itamName, itemImage);
    }
  }, {
    key: "sixStorageReduceQuantity",
    value: function sixStorageReduceQuantity(unitId, itemId, itamName, itemImage) {
      var qnty = document.getElementById("six-storage-merchandiseQnty_".concat(unitId, "_").concat(itemId));

      if (parseInt(qnty.value) !== 0) {
        qnty.value = parseInt(qnty.value) - 1 < 0 ? qnty.value : parseInt(qnty.value) - 1;
        var addingCart = document.getElementById("six-storage-addedProductCount_".concat(unitId));
        addingCart.value = parseInt(addingCart.value) - 1 < 0 ? addingCart.value : parseInt(addingCart.value) - 1;
        document.getElementById("six-storage-cartItems_".concat(unitId)).innerHTML = addingCart.value;
        var availability = document.getElementsByName("six-storage-availableproduct_".concat(itemId));

        for (var i = 0; i < availability.length; i++) {
          availability[i].value = parseInt(availability[i].value) + 1;
        }
      }

      this.sixStorageAddMerchandiseCart(unitId, itemId, itamName, itemImage);
    }
  }, {
    key: "sixStorageAddMerchandiseCart",
    value: function sixStorageAddMerchandiseCart(unitId, itemId, itamName, itemImage) {
      var qnty = document.getElementById("six-storage-merchandiseQnty_".concat(unitId, "_").concat(itemId)).value;
      var obj = {
        itemId: itemId,
        qnty: parseInt(qnty),
        itemName: itamName,
        itemImage: itemImage
      };
      var pos = -1;

      if (this.merchItems.length > 0) {
        pos = this.merchItems.map(function (e) {
          return e.unitId;
        }).indexOf(unitId);
      }

      if (pos > -1) {
        var addedMerch = this.merchItems[pos];
        var addedItemPos = addedMerch.merchandise.map(function (e) {
          return e.itemId;
        }).indexOf(itemId);

        if (addedItemPos > -1) {
          if (obj.qnty > 0) {
            this.merchItems[pos].merchandise[addedItemPos].qnty = obj.qnty;
          } else {
            this.merchItems[pos].merchandise.splice(addedItemPos, 1);

            if (this.merchItems[pos].merchandise.length <= 0) {
              this.merchItems.splice(pos, 1);
            }
          }
        } else {
          this.merchItems[pos].merchandise.push(obj);
        }
      } else {
        if (obj.qnty > 0) {
          this.merchItems.push({
            unitId: unitId,
            merchandise: [obj]
          });
        }
      }

      if (this.merchItems.length > 0) {
        pos = this.merchItems.map(function (e) {
          return e.unitId;
        }).indexOf(unitId);
      }
    }
  }, {
    key: "sixStorageGoBack",
    value: function sixStorageGoBack() {
      this.selectedThirdPartyInsurance = false;
      this.sixStorageOnlineSelectedInsuranceField = false;
      this.promocodescroll = false;

      if (this.currentStepNumber === 2) {
        this.unitsSelected = [];
        document.getElementById("six-storage-tenantType-err").style.display = "none";
      }

      if (this.currentStepNumber === 3) {
        this.sixStorageChangeSelectedUnits();
        sessionStorage.setItem("goback", false);
      }

      if (this.currentStepNumber === 4) {
        this.reInitiatePhoneNumber = true;
        document.getElementById("six_storage_city-err").style.display = "none";
        document.getElementById("six_storage_lead_source-err").style.display = "none";
        document.getElementById("six_storage_address1-err").style.display = "none";
        document.getElementById("six_storage_zip_code-err").style.display = "none";
        document.getElementById("six_storage_address2-err").style.display = "none";
      }

      this.currentStepNumber -= 1;
      this.sixStorageRenderStepHtml("PREV");
    }
  }, {
    key: "sixStorageNextStep",
    value: function sixStorageNextStep() {
      var _this33 = this;

      if (this.currentStepNumber <= 4) {
        if (this.currentStepNumber === 3) {
          var thirdpartyInsuranceCustomError = this.sixstorageValidateCustomFields('thirdPatyInsuranceDetails');
          var error_count = 0;

          if (this.sixStorageInitialowninsurance == true && this.selectedThirdPartyInsurance == false && wordpress_vars.insuranceMandatory == "1" && wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle == "1") {
            this.helper.sixStorageShowMessage("".concat(
            /*Please Select Insurance*/
            wordpress_vars.six_storage_please_select_insurance), true);
            return;
          }

          if (wordpress_vars.insuranceMandatory === '1' && this.hasInsurance === true && this.sixStorageOnlineSelectedInsuranceField === false) {
            this.helper.sixStorageShowMessage("".concat(
            /*Please Select Insurance*/
            wordpress_vars.six_storage_please_select_insurance), true);
            return;
          } else if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle === '1' && this.selectedThirdPartyInsurance == true) {
            this.saveThirdPartyInsuranceDetailsValues = [];
            this.sixStorageSelectedUnitIdByUnitType.forEach(function (unit) {
              var providerName = document.getElementById("six_storage_insurance_provider_name_".concat(unit));
              var policyNumber = document.getElementById("six_storage_insurance_policy_number_".concat(unit));
              var policyPhoneNumber = document.getElementById("six_storage_insurance_policy_phone_number_".concat(unit));
              var effectivefromDate = document.getElementById("six_storage_insurance_effective_from_date_".concat(unit));
              var effectivetoDate = document.getElementById("six_storage_insurance_effective_to_date_".concat(unit));
              var obj = {
                six_storage_insurance_provider_name: typeof providerName !== 'undefined' && providerName !== null && providerName !== '' && typeof providerName.value !== 'undefined' && providerName.value !== null && providerName.value !== '' ? providerName.value : '',
                six_storage_insurance_policy_number: typeof policyNumber !== 'undefined' && policyNumber !== null && policyNumber !== '' && typeof policyNumber.value !== 'undefined' && policyNumber.value !== null && policyNumber.value !== '' ? policyNumber.value : '',
                six_storage_insurance_policy_phone_number: typeof policyPhoneNumber !== 'undefined' && policyPhoneNumber !== null && policyPhoneNumber !== '' && typeof policyPhoneNumber.value !== 'undefined' && policyPhoneNumber.value !== null && policyPhoneNumber.value !== '' ? policyPhoneNumber.value : '',
                six_storage_insurance_effective_from_date: typeof effectivefromDate !== 'undefined' && effectivefromDate !== null && effectivefromDate !== '' && typeof effectivefromDate.value !== 'undefined' && effectivefromDate.value !== null && effectivefromDate.value !== '' ? _this33.helper.sixStorageReadDate(effectivefromDate.value) : '',
                six_storage_insurance_effective_to_date: typeof effectivetoDate !== 'undefined' && effectivetoDate !== null && effectivetoDate !== '' && typeof effectivetoDate.value !== 'undefined' && effectivetoDate.value !== null && effectivetoDate.value !== '' ? _this33.helper.sixStorageReadDate(effectivetoDate.value) : ''
              };
              var required = false;
              Object.entries(obj).forEach(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    key = _ref4[0],
                    value = _ref4[1];

                var field = document.getElementById(key + "_".concat(unit));

                if (typeof field != 'undefined' && field != null) {
                  required = field.dataset.element_required == "'true'" ? true : false;
                }

                if (required === true && (value === null || value === "undefined" || value === "" || value.length === 0 || value == "NaN-NaN-NaN")) {
                  document.getElementById(key + "_".concat(unit) + "-err").style.display = "block";
                  error_count = error_count + 1;
                  return false;
                } else {
                  var ele = document.getElementById(key + "_".concat(unit) + "-err");

                  if (ele) {
                    ele.style.display = "none";
                  }
                }
              });

              if (error_count === 0) {
                _this33.saveThirdPartyInsuranceDetailsValues.push({
                  "unitId": unit.toString(),
                  "insuranceInfo": {
                    "isThirdParty": true,
                    "providerName": obj.six_storage_insurance_provider_name,
                    "providerPhone": obj.six_storage_insurance_policy_phone_number,
                    "policyNumber": obj.six_storage_insurance_policy_number,
                    "effectiveFrom": obj.six_storage_insurance_effective_from_date == "" ? _this33.helper.sixStorageReadDate(new Date()) : obj.six_storage_insurance_effective_from_date,
                    "effectiveTill": obj.six_storage_insurance_effective_to_date == "" ? _this33.helper.sixStorageReadDate(new Date()) : obj.six_storage_insurance_effective_to_date
                  }
                });
              } else {
                _this33.helper.sixStorageShowMessage("".concat(
                /*Please Select Insurance*/
                wordpress_vars.six_storage_please_select_insurance), true);

                return;
              }
            });
          }

          if (wordpress_vars.six_storage_online_fs_ad_services_is_mandatory === '1' && this.additionalServices.length === 0 && this.hasService === true && this.unitBasedServiceSelected === false) {
            this.helper.sixStorageShowMessage("".concat(
            /*Please select Services*/
            wordpress_vars.six_storage_please_select_service), true);
            return;
          }

          if (wordpress_vars.merchandiseMandatory === '1' && this.merchItems.length === 0 && this.hasMerchandise === true) {
            this.helper.sixStorageShowMessage("".concat(
            /*Please select Merchandise*/
            wordpress_vars.six_storage_please_select_merchandise), true);
            return;
          }

          var custom_error_count = this.sixstorageValidateCustomFields('vehicleDetails');

          if (wordpress_vars.six_storage_online_fs_ad_vehicle_info_is_mandatory === '1' && this.vehicleInfo.length === 0 && this.hasvehicleInformation === true || custom_error_count > 0) {
            this.helper.sixStorageShowMessage("".concat(
            /*Please Add Vehicle Details*/
            wordpress_vars.six_storage_please_add_vehicle_details), true);
            return;
          }

          var sixStorageCustomFields = this.sixStorageCustomFieldsDetails('Vehicle Details');

          if (typeof sixStorageCustomFields !== 'undefined' && sixStorageCustomFields !== null && sixStorageCustomFields !== '') {
            var _custom_error_count = this.sixstorageValidateCustomFields('vehicleDetails');

            if (_custom_error_count > 0) {
              if (this.customVehicleDetailsValues.length === 0 && wordpress_vars.six_storage_online_fs_ad_vehicle_info_toggle === '1' && this.hasvehicleInformation === true) {
                this.helper.sixStorageShowMessage("".concat(
                /*Please Add Vehicle Details*/
                wordpress_vars.six_storage_please_add_vehicle_details), true);
                return;
              }
            } else if (wordpress_vars.six_storage_online_fs_ad_vehicle_info_is_mandatory === '1' && wordpress_vars.six_storage_online_fs_ad_vehicle_info_toggle === '1' && this.vehicleInfo.length === 0 && this.hasvehicleInformation === true) {
              this.helper.sixStorageShowMessage("".concat(
              /*Please Add Vehicle Details*/
              wordpress_vars.six_storage_please_add_vehicle_details), true);
              return;
            }
          }

          if (wordpress_vars.six_storage_online_fs_ad_vehicle_info_is_mandatory === '1' && wordpress_vars.six_storage_online_fs_ad_vehicle_info_toggle === '1' && this.vehicleInfo.length === 0 && this.hasvehicleInformation === true) {
            this.helper.sixStorageShowMessage("".concat(
            /*Please Add Vehicle Details*/
            wordpress_vars.six_storage_please_add_vehicle_details), true);
            return;
          }

          var sixStorageInsuranceCustomFieldHtml = this.sixStorageCustomFieldsDetails('Insurance Details');

          if (wordpress_vars.six_storage_online_fs_ad_third_party_insurance_toggle === '1' && this.selectedThirdPartyInsurance == true) {
            if (error_count === 0 && thirdpartyInsuranceCustomError === 0) {
              var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));

              if (typeof currentSession !== 'undefined' && currentSession !== null && currentSession !== "") {
                if (this.reInitiatePhoneNumber === false) {
                  this.helper.sixStorageInitTelephoneNumber();
                  this.reInitiatePhoneNumber = true;
                }

                this.sixStorageGetUserInfo(currentSession.userId, true, false);
              } else {
                this.sixStorageFnTenantModal();
              }
            }
          } else if (typeof sixStorageInsuranceCustomFieldHtml !== 'undefined' && sixStorageInsuranceCustomFieldHtml !== '' && sixStorageInsuranceCustomFieldHtml !== null) {
            var insuranceCustomField_error = this.sixstorageValidateCustomFields('emergencyContactDetails');

            if (insuranceCustomField_error === 0) {
              var _currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));

              if (typeof _currentSession !== 'undefined' && _currentSession !== null && _currentSession !== "") {
                if (this.reInitiatePhoneNumber === false) {
                  this.helper.sixStorageInitTelephoneNumber();
                  this.reInitiatePhoneNumber = true;
                }

                this.sixStorageGetUserInfo(_currentSession.userId, true, false);
              } else {
                this.sixStorageFnTenantModal();
              }
            }
          } else {
            var _currentSession2 = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));

            if (typeof _currentSession2 !== 'undefined' && _currentSession2 !== null && _currentSession2 !== "") {
              if (this.reInitiatePhoneNumber === false) {
                this.helper.sixStorageInitTelephoneNumber();
                this.reInitiatePhoneNumber = true;
              }

              this.sixStorageGetUserInfo(_currentSession2.userId, true, false);
            } else {
              this.sixStorageFnTenantModal();
            }
          }
        } else if (this.currentStepNumber === 2) {
          this.sixStorageValidateGateAccess();
          document.getElementById("six-storage-additional-months-err").style.display = "none";
        } else {
          this.currentStepNumber += 1;
          this.sixStorageRenderStepHtml();
        }
      }
    }
  }, {
    key: "sixStorageRenderStepHtml",
    value: function sixStorageRenderStepHtml(flag) {
      var _this34 = this;

      switch (this.currentStepNumber) {
        case 1:
          {
            document.getElementById("six-storage-unit-lists").style.display = "block";
            document.getElementById("six-storage-unit-details").style.display = "none";
            document.getElementById("six-storage-stepping-buttons").style.display = "none";
            document.getElementById("six-storage-tenant-details").style.display = "none";
            document.getElementById("six-storage-preview-payment").style.display = "none";
            document.getElementById("six-storage-next-step").style.display = "block";
            document.getElementById("six-storage-cancel-movein").style.display = "none";
            document.getElementById('six-storage-unit-lists').scrollIntoView({
              behavior: 'smooth'
            });
            sessionStorage.removeItem("goback");

            if (this.rentSingleUnit === true && this.groupBySize === true) {
              this.selectedUnitTypes = [];
            }

            _materialize["default"].updateTextFields();

            break;
          }

        case 2:
          {
            document.getElementById("six-storage-unit-lists").style.display = "none";
            document.getElementById("six-storage-unit-details").style.display = "block";
            document.getElementById("six-storage-stepping-buttons").style.display = "flex";
            document.getElementById("six-storage-addons-container").style.display = "none";
            document.getElementById("six-storage-preview-payment").style.display = "none";
            document.getElementById("six-storage-next-step").style.display = "block";
            document.getElementById("six-storage-tenant-details").style.display = "none";
            document.getElementById("six-storage-cancel-movein").style.display = "none";
            var movein_date = document.getElementById("six-storage-movein-date");

            var movein_instance = _materialize["default"].Datepicker.getInstance(movein_date);

            var momentDate = this.helper.sixStorageReadDate(document.getElementById("six-storage-dtmoveindate").value);
            var selectedDate = new Date(momentDate);
            movein_instance.setDate(selectedDate, true);
            var scrollintoview = document.getElementById('six-storage-unit-details');

            if (typeof scrollintoview !== "undefined" && scrollintoview !== null) {
              scrollintoview.scrollIntoView({
                behavior: 'smooth'
              });
            }

            var numberFields = document.getElementsByClassName("number");
            Array.prototype.forEach.call(numberFields, function (element) {
              element.oninput = _this34.helper.sixStorageCheckNumber;
            });

            _materialize["default"].updateTextFields();

            break;
          }

        case 3:
          {
            //let isAddonsAvailable = this.moveinFieldSettings.filter(x => (x.fieldName === "IsEnableInsurance" || x.fieldName === "IsEnableAdditionalServices" || x.fieldName === "Merchandise") && x.customerPortal.isEnabled === true);
            this.saveDesiredMoveOutDateOnline = [];
            this.unitsSelected.forEach(function (unit) {
              var desiredMoveoutDate = document.getElementById("six-storage-desired-moveout-date_".concat(unit));

              if (typeof desiredMoveoutDate !== 'undefined' && desiredMoveoutDate !== '' && desiredMoveoutDate !== null) {
                var tempData = {};
                tempData = {
                  unitId: unit,
                  desiredMoveOut: desiredMoveoutDate.value
                };

                _this34.saveDesiredMoveOutDateOnline.push(tempData);
              }
            });
            var addonsContent = this.sixStorageRenderAddons();

            if (addonsContent !== "") // && isAddonsAvailable.length > 0
              {
                if (wordpress_vars.six_storage_online_fs_ad_insurance_toggle !== '0' || wordpress_vars.six_storage_online_fs_ad_merchandise_toggle !== '0' || wordpress_vars.six_storage_online_fs_ad_vehicle_info_toggle !== '0' || wordpress_vars.six_storage_online_fs_ad_services_toggle !== '0') {
                  document.getElementById("six-storage-addon-details-btn").style.display = "";
                  document.getElementById("six-storage-unit-lists").style.display = "none";
                  document.getElementById("six-storage-unit-details").style.display = "none";
                  document.getElementById("six-storage-stepping-buttons").style.display = "flex";
                  document.getElementById("six-storage-next-step").style.display = "block";
                  document.getElementById("six-storage-cancel-movein").style.display = "none";
                  document.getElementById("six-storage-tenant-details").style.display = "none";
                  document.getElementById("six-storage-preview-payment").style.display = "none";
                  document.getElementById("six-storage-addons-container").innerHTML = addonsContent;
                  document.getElementById("six-storage-addons-container").style.display = "flex";

                  var _numberFields = document.getElementsByClassName("number");

                  Array.prototype.forEach.call(_numberFields, function (element) {
                    element.oninput = _this34.helper.sixStorageCheckNumber;
                  });
                  document.getElementById('six-storage-addons-container').scrollIntoView({
                    behavior: 'smooth'
                  });

                  _materialize["default"].AutoInit();

                  _materialize["default"].updateTextFields();
                } else {
                  document.getElementById("six-storage-addon-details-btn").style.display = "none";

                  if (typeof flag !== 'undefined' && flag === "PREV") {
                    this.currentStepNumber = this.currentStepNumber - 1;
                    this.sixStorageRenderStepHtml();
                  } else {
                    this.sixStorageNextStep();
                  }
                }
              } else {
              document.getElementById("six-storage-addon-details-btn").style.display = "none";

              if (typeof flag !== 'undefined' && flag === "PREV") {
                this.currentStepNumber = this.currentStepNumber - 1;
                this.sixStorageRenderStepHtml();
              } else {
                this.sixStorageNextStep();
              }
            }

            break;
          }

        case 4:
          {
            if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle !== '' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle === '0' && typeof wordpress_vars.six_storage_online_fs_ti_identitydocument_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_identitydocument_toggle !== '' && wordpress_vars.six_storage_online_fs_ti_identitydocument_toggle !== null && wordpress_vars.six_storage_online_fs_ti_identitydocument_toggle === '0') {
              document.getElementById('six-storage-identity-container').classList.add('six-storage-d-none');
              document.getElementById('six-storage-tenant-info-div').setAttribute("class", "six-storage-col six-storage-m12 six-storage-l6 six-storage-tenant-info-div six-storage-grid-border six-storage-grid-p30 six-storage-mx-auto six-storage-grid-xs-p0");
            }

            this.sixStorageMoveinUploadpicture();
            var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
            var checkAccessCode = sessionStorage.getItem("accessCode");
            var accessCode = _typeof(checkAccessCode) !== undefined && checkAccessCode !== null && checkAccessCode !== '' && typeof checkAccessCode !== 'undefined' ? JSON.parse(sessionStorage.getItem("accessCode")) : '';
            var userAccessCode = typeof accessCode !== 'undefined' && accessCode !== null && accessCode !== '' ? accessCode : '';
            var checkSixSecurity = clientConfig.securityGateName;
            var sixSecurityAttr = '';
            var userGateAccessCode = '';

            if (typeof checkSixSecurity !== 'undefined' && checkSixSecurity !== null && (checkSixSecurity === '6SECURITY' || checkSixSecurity === 'LOCKT')) {
              if (typeof userAccessCode !== 'undefined' && userAccessCode !== null && userAccessCode !== '') {
                sixSecurityAttr = 'readonly';
                userGateAccessCode = userAccessCode;
              }

              var html;

              if (checkSixSecurity === 'LOCKT') {
                html = "<div class=\"six-storage-input-field six-storage-col six-storage-m12 six-storage-s12 six-storage-grid-ml0\" data-element_required=\"true\">\n           <span><i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-tiny \" id=\"six-storage-gate-tooltip\">help_outline</i></span>\n                 <input class=\"cc number six-storage-gateaccess\" placeholder=\"\" oninput=\"sixStorageCheckNumber(event)\" ".concat(sixSecurityAttr, " id=\"six-storage-gateAccessCode\" type=\"text\" value=\"").concat(userGateAccessCode, "\" data-element_required=\"true\" maxlength=\"4\">\n                 <label class=\"cc\" id=\"six-storage-ts-gate\">").concat(
                /*Gate Access Code*/
                wordpress_vars.six_storage_online_fs_ti_gate_access_code, "<span class=\"six-storage-text-danger\">*</span></label>\n                 <div style=\"display: none;\" id=\"six-storage-gateAccessCode-err\" class=\"six-storage-invalid-feedback\">").concat(
                /*Please Enter Gate Access Code*/
                wordpress_vars.six_storage_online_fs_ti_please_enter_gate_access_code, "</div>\n            </div>");
                setTimeout(function () {
                  var sixStoragegateaccesstooltip = "<span style=\"font-size:12px\">".concat(
                  /*Gate Access Tooltip Message*/
                  wordpress_vars.six_storage_online_su_gate_access_tooltip_msg, ".</span>");
                  var sisStoragegatetooltip = document.querySelector('#six-storage-gate-tooltip');

                  _materialize["default"].Tooltip.init(sisStoragegatetooltip, {
                    html: "".concat(sixStoragegateaccesstooltip)
                  });
                }, 120);
              } else {
                html = "<div class=\"six-storage-input-field six-storage-col six-storage-m12 six-storage-s12 six-storage-grid-ml0\" id=\"six-storage-tsga-input\" data-element_required=\"true\">\n            \n             <input class=\"cc number six-storage-gateaccess\" placeholder=\"\" oninput=\"sixStorageCheckNumber(event)\" ".concat(sixSecurityAttr, " id=\"six-storage-gateAccessCode\" type=\"text\" value=\"").concat(userGateAccessCode, "\" data-element_required=\"true\" maxlength=\"10\">\n             <label class=\"cc\" id=\"six-storage-ts-gate\" >").concat(
                /*Gate Access Code*/
                wordpress_vars.six_storage_online_fs_ti_gate_access_code, "\n             <span class=\"six-storage-text-danger\">*</span></label>\n             <span class=\"cc\"><i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-tiny \" id=\"six-storage-gate-tooltip\">help_outline</i></span>\n             <div style=\"display: none;\" id=\"six-storage-gateAccessCode-err\" class=\"six-storage-invalid-feedback\">").concat(
                /*Please Enter Gate Access Code*/
                wordpress_vars.six_storage_online_fs_ti_please_enter_gate_access_code, "</div>\n            </div>");
                setTimeout(function () {
                  var sixStoragegateaccesstooltip = "<span style=\"font-size:12px\">".concat(
                  /*Gate Access Tooltip Message*/
                  wordpress_vars.six_storage_online_su_gate_access_tooltip_msg, ".</span>");
                  var sisStoragegatetooltip = document.querySelector('#six-storage-gate-tooltip');

                  _materialize["default"].Tooltip.init(sisStoragegatetooltip, {
                    html: "".concat(sixStoragegateaccesstooltip)
                  });
                }, 120);
              }

              if (typeof this.timeZones !== 'undefined' && this.timeZones !== null && checkSixSecurity !== 'LOCKT') {
                var timezoneMandatoryicon = "<span class=\"six-storage-text-danger\">*</span>";

                if (wordpress_vars.six_storage_online_fs_ti_timezone_is_mandatory === "0") {
                  timezoneMandatoryicon = "";
                }

                if (this.displayTimezones === true) {
                  if (wordpress_vars.six_storage_online_fs_ti_timezone_is_mandatory == 1) {
                    var requiredtimezone = "data-element_required=\"true\"";
                  } else {
                    requiredtimezone = "data-element_required=\"false\"";
                  }

                  html += "<div class=\"six-storage-input-field six-storage-col six-storage-m12 six-storage-s12 six-storage-grid-ml0\" ".concat(requiredtimezone, ">\n               <select class=\"cc six-storage-timezone\" id=\"six-storage-timezone\" ").concat(requiredtimezone, ">\n                 ").concat(this.timeZones, "\n               </select>\n               <label class=\"cc\">").concat(
                  /*Time Zone*/
                  wordpress_vars.six_storage_online_fs_Time_Zone, " ").concat(timezoneMandatoryicon, "</label>\n               <div style=\"display: none;\" id=\"six-storage-timezone-err\" class=\"six-storage-invalid-feedback\">").concat(
                  /*Please Select Timezone*/
                  wordpress_vars.six_storage_online_fs_Please_Select_Timezone, "</div>\n           </div>");
                }
              }

              document.getElementById('six-security-gate-access-field').innerHTML = html;
              document.getElementById('six-security-gate-access-field').style.display = 'block';
            }

            var leadObj = JSON.parse(sessionStorage.getItem("sixStorageleadConfig"));

            if (typeof leadObj === 'undefined' || leadObj === null || leadObj === "") {
              this.sixStorageVTwoCommon("TENANTPAGE");
            } else {
              var leadsourcevtwohtml = this.sixStorageConstructTenLeadSource(leadObj);
              document.getElementById('sixStorage-tenant-lead').innerHTML = leadsourcevtwohtml;
            }

            var sixstoragetenantCustomFieldHtml = this.sixStorageCustomFieldsDetails('Movein Tenant Details');

            if (typeof sixstoragetenantCustomFieldHtml !== 'undefined' && sixstoragetenantCustomFieldHtml !== '' && sixstoragetenantCustomFieldHtml !== null) {
              document.getElementById('six-storage-tenant-custom-field').innerHTML = sixstoragetenantCustomFieldHtml;
              this.sixStorageCustomFieldsBinding();
            }

            if (wordpress_vars.six_storage_online_file_upload_note_toggle != '' && wordpress_vars.six_storage_online_file_upload_note_toggle != null && typeof wordpress_vars.six_storage_online_file_upload_note_toggle != 'undefined' && wordpress_vars.six_storage_online_file_upload_note_toggle == '1') {
              document.getElementById('six-storage-file-upload-note').style.display = "block";
            } else {
              document.getElementById('six-storage-file-upload-note').style.display = "none";
            }

            if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle !== '' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_toggle === '1') {
              var emergencyFieldhtml = this.sixStorageRenderEmergencyhtml();
              document.getElementById('six-storage-render-emergency-info').innerHTML = emergencyFieldhtml;
              this.helper.sixStorageInitTelephoneNumber('#six-storage-emergency_contact_phone');
            }

            document.getElementById('six_storage_documentFiles-err').style.display = 'none';
            document.getElementById('six_storage_company_website-err').style.display = 'none';
            document.getElementById("six-storage-unit-lists").style.display = "none";
            document.getElementById("six-storage-unit-details").style.display = "none";
            document.getElementById("six-storage-stepping-buttons").style.display = "flex";
            document.getElementById("six-storage-addons-container").style.display = "none";
            document.getElementById("six-storage-preview-payment").style.display = "none";
            this.sixStorageFnHideSignInModal();
            var tenant_info = document.getElementById("six-storage-tenant-details");
            tenant_info.style.display = "block";
            this.getsavedemrgtableHtml();
            document.getElementById("six-storage-next-step").style.display = "block";
            document.getElementById("six-storage-cancel-movein").style.display = "none"; //document.getElementById("six_storage_firstname").focus();

            if (typeof this.identityTypes === "undefined" || this.identityTypes == null) {
              this.sixStorageGetIdentityTypes();
            } else {
              this.sixStorageConstructIdentityTypes(this.identityTypes);
            }

            var date = new Date();
            this.sixStorageInitDatepickerClassname("six-storage-date-control-custom-fields", new Date("".concat(date.getFullYear() - 60, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), new Date("".concat(date.getFullYear() + 20, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())));
            var safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (safari) {
              this.sixStorageInitDatepicker("#six_storage_dob", new Date("".concat(date.getFullYear() - 150, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), new Date(), null, null, 'dob');
            } else {
              this.sixStorageInitDatepicker("#six_storage_dob", new Date("".concat(date.getFullYear() - 150, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), new Date("".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), null, null, 'dob');
            } //document.getElementById("six_storage_dob").value = "";


            document.getElementById('six-storage-tenant-details').scrollIntoView({
              behavior: 'smooth'
            });
            var phone1 = document.getElementById("six_storage_phone1");
            var phone2 = document.getElementById("six_storage_phone2");
            var emergency_contact_phone = document.getElementById("six-storage-emergency_contact_phone");
            phone1.oninput = this.helper.sixStorageCheckPhoneNumber;
            phone2.oninput = this.helper.sixStorageCheckPhoneNumber;

            if (typeof emergency_contact_phone !== 'undefined' && emergency_contact_phone !== null && emergency_contact_phone !== '') {
              emergency_contact_phone.oninput = this.helper.sixStorageCheckPhoneNumber;
            }

            _materialize["default"].AutoInit();

            _materialize["default"].updateTextFields();

            break;
          }

        case 5:
          {
            this.wrapper = document.getElementById("six-storage-signature-pad");
            document.getElementById("six-storage-cancel-movein").style.display = "none";
            var proceedToPayment = document.getElementById("six-storage-proceed-payment");

            if (typeof proceedToPayment !== 'undefined' && proceedToPayment !== null && proceedToPayment !== '') {
              document.getElementById("six-storage-proceed-payment").style.display = "";
            }

            document.getElementById("six-storage-card_actions").style.display = "none";
            document.getElementById("six-storage-dvPaymentForm").innerHTML = "";
            this.canvas = this.wrapper.querySelector("canvas");
            this.signaturePad = new SignaturePad(this.canvas, {
              // It's Necessary to use an opaque color when saving image as JPEG;
              // this option can be omitted if only saving as PNG or SVG
              backgroundColor: "rgb(255, 255, 255)"
            });
            this.sixStorageGoToFinal(); //window.scrollTo(0, 0);
          }
      }
    }
  }, {
    key: "getsavedemrgtableHtml",
    value: function getsavedemrgtableHtml() {
      if (this.tentnantDetailsFinal.emergencyContact.length > 0) {
        document.getElementById("six-storage-emergency-details-list").style.display = "";
        document.getElementById("six-storage-emergency-add-more").style.display = "";
        document.getElementById("six-storage-emergency-err").style.display = "none";
        document.getElementById("six-storage-emergency-fields").style.display = "none";
        document.getElementById("six-storage-addemergencydetails").style.display = "none";
        Object.entries(this.tentnantDetailsFinal.emergencyContact).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          var savedemrgbodyHtml_first_name = "";
          var savedemrgbodyHtml_last_name = "";
          var savedemrgbodyHtml_email = "";
          var savedemrgbodyHtml = "";
          var savedemergtr = "";

          if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_toggle) === 1) {
            if (value.firstName == '') {
              savedemrgbodyHtml_first_name += "<td class=\"cc\">-</td>";
            } else {
              savedemrgbodyHtml_first_name += "<td class=\"cc\">".concat(value.firstName, "</td>");
            }
          }

          if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_toggle) === 1) {
            if (value.lastName == '') {
              savedemrgbodyHtml_last_name += "<td class=\"cc\">-</td>";
            } else {
              savedemrgbodyHtml_last_name += "<td class=\"cc\">".concat(value.lastName, "</td>");
            }
          }

          if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_toggle) === 1) {
            if (value.email == '') {
              savedemrgbodyHtml_email += "<td class=\"cc\">-</td>";
            } else {
              savedemrgbodyHtml_email += "<td class=\"cc\">".concat(value.email, "</td>");
            }
          }

          savedemrgbodyHtml = "".concat(savedemrgbodyHtml_first_name, "\n          ").concat(savedemrgbodyHtml_last_name, "\n          ").concat(savedemrgbodyHtml_email, "     \n          <td class=\"cc\">").concat(value.mobile, "</td>");
          var savedtableRef = document.getElementById("six-storage-emergencyContact-tbody");
          savedemergtr = document.createElement("tr");
          savedemergtr.innerHTML = savedemrgbodyHtml;
          savedtableRef.appendChild(savedemergtr);
        });
      }
    }
  }, {
    key: "sixStorageCustomFieldsDetails",
    value: function sixStorageCustomFieldsDetails(pageName, unitId) {
      var _this35 = this;

      var customTenantFieldHtml = "";
      var sixStorageCustomPageName = "";
      var seletedUnitId = "";

      if (typeof unitId !== 'undefined' && unitId !== null) {
        seletedUnitId = unitId;
      } else if (typeof this.unitsSelected !== 'undefined' && this.unitsSelected !== '' && this.unitsSelected !== null && this.unitsSelected.length > 0) {
        seletedUnitId = this.unitsSelected[0];
      } else {
        seletedUnitId = this.sixStorageSelectedUnitIdByUnitType[0];
      }

      if (typeof this.customFieldsResponse.result !== 'undefined' && this.customFieldsResponse.result !== null && this.customFieldsResponse.result !== '') {
        this.customFieldsResponse.result.forEach(function (item, index) {
          var defaultvalues = '';

          if (item.matadata.displayOn === pageName) {
            if (pageName === 'Movein Tenant Details') {
              sixStorageCustomPageName = 'moveInTenantDetails';

              if (_this35.customTenantDetailValues.length > 0) {
                _this35.customTenantDetailValues.forEach(function (key, value) {
                  if (item.fieldId == key.fieldId && seletedUnitId == key.unitId) {
                    defaultvalues = key.value;
                  }
                });
              }
            } else if (pageName === 'Emergency Contact Details') {
              sixStorageCustomPageName = 'emergencyContactDetails';

              if (_this35.customEmgContactValues.length > 0) {
                _this35.customEmgContactValues.forEach(function (key, value) {
                  if (item.fieldId == key.fieldId && seletedUnitId == key.unitId) {
                    defaultvalues = key.value;
                  }
                });
              }
            } else if (pageName === 'Unit specific details') {
              sixStorageCustomPageName = 'unitSpecificDetails';

              if (_this35.customUnitSpecificValues.length > 0) {
                _this35.customUnitSpecificValues.forEach(function (key, value) {
                  if (item.fieldId == key.fieldId && seletedUnitId == key.unitId) {
                    defaultvalues = key.value;
                  }
                });
              }
            } else if (pageName === 'Vehicle Details') {
              sixStorageCustomPageName = 'vehicleDetails';

              if (_this35.customVehicleDetailsValues.length > 0) {
                _this35.customVehicleDetailsValues.forEach(function (key, value) {
                  if (item.fieldId == key.fieldId && seletedUnitId == key.unitId) {
                    defaultvalues = key.value;
                  }
                });
              }
            } else if (pageName === 'Insurance Details') {
              sixStorageCustomPageName = 'insuranceDetails';

              if (_this35.customInsuranceDetailsValues.length > 0) {
                _this35.customInsuranceDetailsValues.forEach(function (key, value) {
                  if (item.fieldId == key.fieldId && seletedUnitId == key.unitId) {
                    defaultvalues = key.value;
                  }
                });
              }
            } else if (pageName === 'Insurance Third Party') {
              sixStorageCustomPageName = 'thirdPatyInsuranceDetails';

              if (_this35.customInsuranceDetailsValues.length > 0) {
                _this35.customInsuranceDetailsValues.forEach(function (key, value) {
                  if (item.fieldId == key.fieldId && seletedUnitId == key.unitId) {
                    defaultvalues = key.value;
                  }
                });
              }
            }

            var fieldclassname = "";
            var fieldReadonly = "";
            var minValue = "";
            var sixStorageDataType = "";
            var fieldDataType = item.matadata.dataType;

            if (typeof fieldDataType !== 'undefined' && fieldDataType !== '' && fieldDataType !== null) {
              if (fieldDataType === 'Alphanumeric') {
                sixStorageDataType = 'sixStorageCheckAlphanumeric(event)';
              } else if (fieldDataType === 'Digits (0-9)') {
                sixStorageDataType = 'sixStorageCheckNumber(event)';
              } else if (fieldDataType === 'Alphabet') {
                sixStorageDataType = 'sixStorageCheckAlphabets(event)';
              }
            }

            var isMandatory = item.matadata.isMandatory;
            var fieldType = item.matadata.type;

            if (fieldType === "textbox" || fieldType === "TEXTBOX") {
              fieldType = "text";
              customTenantFieldHtml = customTenantFieldHtml + "\n            <div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 six-storage-custom-field-parent-div_".concat(item.fieldId, "\" data-element_required=\"").concat(isMandatory, "\" >\n              <input id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "\" maxlength=\"50\" data-unitId=\"").concat(seletedUnitId, "\" data-filename=\"").concat(item.fieldName, "\" oninput=\"").concat(sixStorageDataType, "\" class=\"cc six-storage-custom_input_fields_").concat(sixStorageCustomPageName, " six-storage-custom-field-").concat(item.fieldId, "\" data-fieldid=\"").concat(item.fieldId, "\" type=\"").concat(fieldType, "\" value=\"").concat(defaultvalues, "\" data-element_required=\"").concat(isMandatory, "\" />\n              <label class=\"cc\">").concat(item.fieldName, "</label>\n              <div style=\"display: none;\" id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
              /*Please fill mandatory field*/
              wordpress_vars.six_storage_online_fs_Please_text_fill, "</div>\n            </div>\n            ");
            } else if (fieldType === "DATEPICKER" || fieldType === "date") {
              fieldType = "text";
              fieldclassname = "six-storage-date-control-custom-fields";
              fieldReadonly = "true";
              customTenantFieldHtml = customTenantFieldHtml + "\n            <div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 six-storage-custom-field-parent-div_".concat(item.fieldId, " \" data-element_required=\"").concat(isMandatory, "\" >\n                      <i class=\"six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text\">date_range</i>\n                      <input id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "\" data-unitId=\"").concat(seletedUnitId, "\" placeholder=\"").concat(_this35.helper.dateFormat.toUpperCase(), "\" data-fieldid=\"").concat(item.fieldId, "\" value=\"").concat(defaultvalues, "\" data-filename=\"").concat(item.fieldName, "\" class=\"cc six-storage-custom_input_fields_").concat(sixStorageCustomPageName, " six-storage-identity-fields six-storage-custom-field-").concat(item.fieldId, " ").concat(fieldclassname, "\" \n                        type=\"").concat(fieldType, "\" readonly=\"").concat(fieldReadonly, "\" data-field_type=\"").concat(fieldType, "\" data-element_required=\"").concat(isMandatory, "\" />\n                      <label class=\"six-storage-active cc\">").concat(item.fieldName, "</label>\n                  <div style=\"display: none;\" id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
              /*Please fill mandatory field*/
              wordpress_vars.six_storage_online_fs_Please_text_fill, "</div>\n                  </div>\n            ");
            } else if (fieldType === "radio" || fieldType === "RADIO") {
              fieldType = "radio";
              var fieldsOptions = "";
              var defaultCheckedValues = "";

              if (item.options.length > 0) {
                item.options.forEach(function (i, k) {
                  fieldsOptions = fieldsOptions + "<div class=\"six-storage-col six-storage-s12 six-storage-m12 six-storage-l12 cc six-storage-grid-p0\"><p class=\"cc six-storage-grid-mt15 six-storage-grid-mb0\" six-storage-custom-field-parent-div_".concat(item.fieldId, ">\n                <label class=\"cc\">\n                  <input id=\"six_storage_").concat(item.fieldId, "_").concat(i.option, "\" data-selectedval=\"six_storage_").concat(item.fieldId, "_").concat(i.option, "\" value=\"").concat(i.option, "\" ").concat(defaultCheckedValues, " data-unitId=\"").concat(seletedUnitId, "\" data-filename=\"").concat(item.fieldName, "\" class=\"six-storage-with-gap cc ").concat(item.fieldName, "_").concat(seletedUnitId, " six-storage-custom-field-").concat(item.fieldId, "\" data-fieldid=\"").concat(item.fieldId, "\" name=\"").concat(item.fieldName, "_").concat(seletedUnitId, "\" type=\"radio\" data-element_required=\"").concat(isMandatory, "\" ");

                  if (sixStorageCustomPageName === 'moveInTenantDetails') {
                    if (_this35.customTenantDetailValues.length > 0) {
                      _this35.customTenantDetailValues.forEach(function (key, value) {
                        defaultCheckedValues = '';

                        if (key.fieldType == 'radioBtn' && i.option == key.value && seletedUnitId == key.unitId) {
                          fieldsOptions = fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName === 'emergencyContactDetails') {
                    if (_this35.customEmgContactValues.length > 0) {
                      _this35.customEmgContactValues.forEach(function (key, value) {
                        defaultCheckedValues = '';

                        if (key.fieldType == 'radioBtn' && i.option == key.value && seletedUnitId == key.unitId) {
                          fieldsOptions = fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'unitSpecificDetails') {
                    if (_this35.customUnitSpecificValues.length > 0) {
                      _this35.customUnitSpecificValues.forEach(function (key, value) {
                        defaultCheckedValues = '';

                        if (key.fieldType == 'radioBtn' && i.option == key.value && seletedUnitId == key.unitId) {
                          fieldsOptions = fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'vehicleDetails') {
                    if (_this35.customVehicleDetailsValues.length > 0) {
                      _this35.customVehicleDetailsValues.forEach(function (key, value) {
                        defaultCheckedValues = '';

                        if (key.fieldType == 'radioBtn' && i.option == key.value && seletedUnitId == key.unitId) {
                          fieldsOptions = fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'insuranceDetails') {
                    if (_this35.customInsuranceDetailsValues.length > 0) {
                      _this35.customInsuranceDetailsValues.forEach(function (key, value) {
                        defaultCheckedValues = '';

                        if (key.fieldType == 'radioBtn' && i.option == key.value && seletedUnitId == key.unitId) {
                          fieldsOptions = fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'thirdPatyInsuranceDetails') {
                    if (_this35.customThirdPartyInsuranceDetailsValues.length > 0) {
                      _this35.customThirdPartyInsuranceDetailsValues.forEach(function (key, value) {
                        defaultCheckedValues = '';

                        if (key.fieldType == 'radioBtn' && i.option == key.value && seletedUnitId == key.unitId) {
                          fieldsOptions = fieldsOptions + 'checked';
                        }
                      });
                    }
                  }

                  fieldsOptions = fieldsOptions + " /> <span class=\"six-storage-white-space-nowrap six-storage-check-label-color\">".concat(i.option, "</span>\n                </label>\n              </p></div>");
                });
              } else {
                fieldsOptions = "<div class=\"six-storage-col six-storage-s12 six-storage-m12 six-storage-l12 cc six-storage-grid-p0\"><p class=\"cc six-storage-grid-mt15 six-storage-grid-mb0 six-storage-custom-field-parent-div_".concat(item.fieldId, "\">\n              <label class=\"cc\">\n                <input id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "\" data-filename=\"").concat(item.fieldName, "\" ").concat(defaultCheckedValues, " data-unitId=\"").concat(seletedUnitId, "\" class=\"six-storage-with-gap cc ").concat(item.fieldName, "_").concat(seletedUnitId, " six-storage-custom-field-").concat(item.fieldId, "\" data-fieldid=\"").concat(item.fieldId, "\" name=\"").concat(item.fieldName, "_").concat(seletedUnitId, "\" type=\"radio\" data-element_required=\"").concat(isMandatory, "\"  />\n                <span class=\"six-storage-white-space-nowrap six-storage-check-label-color\"></span>\n              </label>\n            </p></div>");
              }

              customTenantFieldHtml = customTenantFieldHtml + "\n            <div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-l6 six-storage-grid-ml0 six-storage-custom-field-parent-div_".concat(item.fieldId, "\" data-element_required=\"").concat(isMandatory, "\" >\n              <label class=\"cc six-storage-customfield-label\">").concat(item.fieldName, "</label>\n              <div data-unitId=\"").concat(seletedUnitId, "\" data-field_unitId=\"").concat(item.fieldName, "_").concat(seletedUnitId, "\" class=\"six-storage-custom_input_fields_radio_btn six-storage-custom_input_fields_radio_btn_").concat(sixStorageCustomPageName, "\" data-element_required=\"").concat(isMandatory, "\">\n              ").concat(fieldsOptions, "\n              <br/><br/>\n              <div style=\"display: none;\" id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_Please_select_field, "</div>\n              </div>\n            </div>\n            ");
            } else if (fieldType === "checkbox" || fieldType === "checkboxes") {
              fieldType = "checkbox";
              var _fieldsOptions = "";
              var _defaultCheckedValues = "";

              if (item.options.length > 0) {
                item.options.forEach(function (i, k) {
                  _fieldsOptions = _fieldsOptions + "<div class=\"six-storage-col six-storage-s12 six-storage-m12 six-storage-l12 cc six-storage-grid-p0\"><p class=\"cc six-storage-grid-mt0 six-storage-grid-mb0 six-storage-custom-field-parent-div_".concat(item.fieldId, "\" data-element_required=\"").concat(isMandatory, "\">\n                  <label class=\"cc\">\n                    <input id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "\" value=\"").concat(i.option, "\" name=\"").concat(item.fieldName, "_").concat(seletedUnitId, "\" data-unitId=\"").concat(seletedUnitId, "\" data-filename=\"").concat(item.fieldName, "\" class=\"six-storage-customfield-customized-checkbox cc ").concat(item.fieldName, "_").concat(seletedUnitId, " six-storage-custom-field-").concat(item.fieldId, "\" data-fieldid=\"").concat(item.fieldId, "\" type=\"radio\" data-element_required=\"").concat(isMandatory, "\"");

                  if (sixStorageCustomPageName === 'moveInTenantDetails') {
                    if (_this35.customTenantDetailValues.length > 0) {
                      _this35.customTenantDetailValues.forEach(function (key, value) {
                        _defaultCheckedValues = '';

                        if (key.fieldType == 'checkBox' && i.option == key.value && seletedUnitId == key.unitId) {
                          _fieldsOptions = _fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName === 'emergencyContactDetails') {
                    if (_this35.customEmgContactValues.length > 0) {
                      _this35.customEmgContactValues.forEach(function (key, value) {
                        _defaultCheckedValues = '';

                        if (key.fieldType == 'checkBox' && i.option == key.value && seletedUnitId == key.unitId) {
                          _fieldsOptions = _fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'unitSpecificDetails') {
                    if (_this35.customUnitSpecificValues.length > 0) {
                      _this35.customUnitSpecificValues.forEach(function (key, value) {
                        _defaultCheckedValues = '';

                        if (key.fieldType == 'checkBox' && i.option == key.value && seletedUnitId == key.unitId) {
                          _fieldsOptions = _fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'vehicleDetails') {
                    if (_this35.customVehicleDetailsValues.length > 0) {
                      _this35.customVehicleDetailsValues.forEach(function (key, value) {
                        _defaultCheckedValues = '';

                        if (key.fieldType == 'checkBox' && i.option == key.value && seletedUnitId == key.unitId) {
                          _fieldsOptions = _fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'insuranceDetails') {
                    if (_this35.customInsuranceDetailsValues.length > 0) {
                      _this35.customInsuranceDetailsValues.forEach(function (key, value) {
                        _defaultCheckedValues = '';

                        if (key.fieldType == 'checkBox' && i.option == key.value && seletedUnitId == key.unitId) {
                          _fieldsOptions = _fieldsOptions + 'checked';
                        }
                      });
                    }
                  } else if (sixStorageCustomPageName = 'thirdPatyInsuranceDetails') {
                    if (_this35.customThirdPartyInsuranceDetailsValues.length > 0) {
                      _this35.customThirdPartyInsuranceDetailsValues.forEach(function (key, value) {
                        _defaultCheckedValues = '';

                        if (key.fieldType == 'checkBox' && i.option == key.value && seletedUnitId == key.unitId) {
                          _fieldsOptions = _fieldsOptions + 'checked';
                        }
                      });
                    }
                  }

                  _fieldsOptions = _fieldsOptions + " />\n                    <span class=\"six-storage-white-space-nowrap six-storage-check-label-color six-storage-grid-mt20\">".concat(i.option, "</span>\n                  </label>\n                </p></div>");
                });
                customTenantFieldHtml = customTenantFieldHtml + "\n            <div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 six-storage-custom-field-parent-div_".concat(item.fieldId, "\" data-element_required=\"").concat(isMandatory, "\" >\n              <label class=\"cc six-storage-customfield-label\">").concat(item.fieldName, "</label>\n              <div data-unitId=\"").concat(seletedUnitId, "\" data-field_unitId=\"").concat(item.fieldName, "_").concat(seletedUnitId, "\" class=\"six-storage-custom_input_fields_check_btn six-storage-custom_input_fields_check_btn_").concat(sixStorageCustomPageName, "\" data-element_required=\"").concat(isMandatory, "\">\n              ").concat(_fieldsOptions, "\n              <div style=\"display: none;float:left;\" id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_Please_select_field, "</div>\n              </div>\n            </div>\n            ");
              } else {
                _fieldsOptions = _fieldsOptions + "<div class=\"six-storage-col six-storage-s12 six-storage-m12 l12 cc six-storage-grid-p0 six-storage-input-field cc six-storage-customfield-checkbox six-storage-custom-field-parent-div_".concat(item.fieldId, "\" data-element_required=\"'").concat(isMandatory, "'\" ><p class=\"cc six-storage-grid-mt0 six-storage-grid-mb0\" data-element_required=\"'").concat(isMandatory, "'\">\n                  <label class=\"cc six-storage-single-check-box-label\">\n                    <input id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "\" value=\"").concat(item.fieldName, "\" name=\"").concat(item.fieldName, "_").concat(seletedUnitId, "\" data-unitId=\"").concat(seletedUnitId, "\" data-filename=\"").concat(item.fieldName, "\" class=\"cc ").concat(item.fieldName, "_").concat(seletedUnitId, " six-storage-custom-field-").concat(item.fieldId, "\" data-fieldid=\"").concat(item.fieldId, "\" type=\"checkbox\" data-element_required=\"'").concat(isMandatory, "'\"");

                if (sixStorageCustomPageName === 'moveInTenantDetails') {
                  if (_this35.customTenantDetailValues.length > 0) {
                    _this35.customTenantDetailValues.forEach(function (key, value) {
                      _defaultCheckedValues = '';

                      if (key.fieldType == 'checkBox' && item.fieldName == key.value && seletedUnitId == key.unitId) {
                        _fieldsOptions = _fieldsOptions + 'checked';
                      }
                    });
                  }
                } else if (sixStorageCustomPageName === 'emergencyContactDetails') {
                  if (_this35.customEmgContactValues.length > 0) {
                    _this35.customEmgContactValues.forEach(function (key, value) {
                      _defaultCheckedValues = '';

                      if (key.fieldType == 'checkBox' && item.fieldName == key.value && seletedUnitId == key.unitId) {
                        _fieldsOptions = _fieldsOptions + 'checked';
                      }
                    });
                  }
                } else if (sixStorageCustomPageName = 'unitSpecificDetails') {
                  if (_this35.customUnitSpecificValues.length > 0) {
                    _this35.customUnitSpecificValues.forEach(function (key, value) {
                      _defaultCheckedValues = '';

                      if (key.fieldType == 'checkBox' && item.fieldName == key.value && seletedUnitId == key.unitId) {
                        _fieldsOptions = _fieldsOptions + 'checked';
                      }
                    });
                  }
                } else if (sixStorageCustomPageName = 'vehicleDetails') {
                  if (_this35.customVehicleDetailsValues.length > 0) {
                    _this35.customVehicleDetailsValues.forEach(function (key, value) {
                      _defaultCheckedValues = '';

                      if (key.fieldType == 'checkBox' && item.fieldName == key.value && seletedUnitId == key.unitId) {
                        _fieldsOptions = _fieldsOptions + 'checked';
                      }
                    });
                  }
                } else if (sixStorageCustomPageName = 'insuranceDetails') {
                  if (_this35.customInsuranceDetailsValues.length > 0) {
                    _this35.customInsuranceDetailsValues.forEach(function (key, value) {
                      _defaultCheckedValues = '';

                      if (key.fieldType == 'checkBox' && item.fieldName == key.value && seletedUnitId == key.unitId) {
                        _fieldsOptions = _fieldsOptions + 'checked';
                      }
                    });
                  }
                } else if (sixStorageCustomPageName = 'thirdPatyInsuranceDetails') {
                  if (_this35.customThirdPartyInsuranceDetailsValues.length > 0) {
                    _this35.customThirdPartyInsuranceDetailsValues.forEach(function (key, value) {
                      _defaultCheckedValues = '';

                      if (key.fieldType == 'checkBox' && item.fieldName == key.value && seletedUnitId == key.unitId) {
                        _fieldsOptions = _fieldsOptions + 'checked';
                      }
                    });
                  }
                }

                _fieldsOptions = _fieldsOptions + " />\n                        <span class=\"six-storage-white-space-nowrap six-storage-check-label-color six-storage-grid-mt0\">".concat(item.fieldName, "</span>\n                      </label>\n                    </p></div>");
                customTenantFieldHtml = customTenantFieldHtml + "\n            <div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 six-storage-custom-field-parent-div_".concat(item.fieldId, "\">\n              <label class=\"cc six-storage-customfield-label\"></label>\n              <div data-unitId=\"").concat(seletedUnitId, "\" data-field_unitId=\"").concat(item.fieldName, "_").concat(seletedUnitId, "\" class=\"six-storage-custom_input_fields_check_btn six-storage-custom_input_fields_check_btn_").concat(sixStorageCustomPageName, "\" data-element_required=\"").concat(isMandatory, "\">\n              ").concat(_fieldsOptions, "\n              <div style=\"display: none;float:left;\" id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_Please_select_field, "</div>\n              </div>\n            </div>\n            ");
              }
            } else if (fieldType === "textarea" || fieldType === "TEXTAREAS") {
              customTenantFieldHtml = customTenantFieldHtml + "\n            <div class=\"six-storage-input-field cc six-storage-col six-storage-m6 six-storage-s12 six-storage-grid-ml0 six-storage-custom-field-parent-div_".concat(item.fieldId, "\" data-element_required=\"").concat(isMandatory, "\" >\n              <textarea id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "\" oninput=\"").concat(sixStorageDataType, "\" data-unitId=\"").concat(seletedUnitId, "\" maxlength=\"200\" data-fieldid=\"").concat(item.fieldId, "\" value=\"").concat(defaultvalues, "\" data-filename=\"").concat(item.fieldName, "\" class=\"cc six-storage-materialize-textarea six-storage-custom_input_fields_").concat(sixStorageCustomPageName, " six-storage-custom-field-").concat(item.fieldId, "\" data-element_required=\"").concat(isMandatory, "\">").concat(defaultvalues, "</textarea>\n              <label for=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "\" class=\"cc\" id=\"\">").concat(item.fieldName, "</label>\n              <div style=\"display: none;\" id=\"six_storage_").concat(item.fieldId, "_").concat(seletedUnitId, "-err\" class=\"six-storage-invalid-feedback\">").concat(
              /*Please fill mandatory field*/
              wordpress_vars.six_storage_online_fs_Please_text_fill, "</div>\n            </div>\n            ");
            }
          }
        });

        _materialize["default"].updateTextFields();

        return customTenantFieldHtml;
      }
    }
  }, {
    key: "sixstorageValidateCustomFields",
    value: function sixstorageValidateCustomFields(pageName) {
      var _this36 = this;

      var custom_error_count = 0;
      var required = false;
      var checkboxReq = false;
      var radioReq = false;
      this.customFieldsValues = [];
      this.customFieldPreviewValues = [];
      var selectedunitId = '';

      if (pageName === 'moveInTenantDetails') {
        this.customTenantDetailValues = [];
        this.savedCustomTenantDetailValues = [];
        var custom_fields_checkbox_containers = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_".concat(pageName));

        if (typeof custom_fields_checkbox_containers !== 'undefined' && custom_fields_checkbox_containers !== null && custom_fields_checkbox_containers !== '') {
          Array.prototype.forEach.call(custom_fields_checkbox_containers, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));
              var check_btn_val = "";

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null && check_button_type[0].dataset.unitId == fieldContainer_check.dataset.unitId) {
                for (var i = 0; i < check_button_type.length; i++) {
                  if (check_button_type[i].checked === true) {
                    check_btn_val = check_button_type[i].value;
                  }

                  checkboxReq = fieldContainer_check.dataset.element_required == 'true' ? true : false;
                }

                if (checkboxReq === true && (check_btn_val == null || check_btn_val == "" || check_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "none";

                  _this36.customTenantDetailValues.push({
                    fieldId: check_button_type[0].dataset.fieldid,
                    value: check_btn_val,
                    unitId: typeof check_button_type[0].dataset.unitid !== 'undefined' && check_button_type[0].dataset.unitid !== null && check_button_type[0].dataset.unitid !== '' ? check_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'checkBox'
                  });
                }
              }
            }
          });
        }

        var custom_fields_radio_button_containers = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_".concat(pageName));

        if (typeof custom_fields_radio_button_containers !== 'undefined' && custom_fields_radio_button_containers !== null && custom_fields_radio_button_containers !== '') {
          Array.prototype.forEach.call(custom_fields_radio_button_containers, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));
              var radio_btn_val = "";

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  radioReq = fieldContainer_radio.dataset.element_required == 'true' ? true : false;

                  if (radios_button_type[i].checked === true) {
                    radio_btn_val = radios_button_type[i].value;
                  }
                }

                if (radioReq === true && (radio_btn_val == "" || radio_btn_val == "NaN-NaN-NaN")) {
                  var radiobtnerror = document.getElementById("six_storage_".concat(radios_button_type[0].dataset.fieldid, "_").concat(radios_button_type[0].dataset.unitid, "-err"));

                  if (typeof radiobtnerror !== "undefined" && radiobtnerror !== null) {
                    radiobtnerror.style.display = 'block';
                  }

                  custom_error_count = custom_error_count + 1;
                } else {
                  var _radiobtnerror = document.getElementById("six_storage_".concat(radios_button_type[0].dataset.fieldid, "_").concat(radios_button_type[0].dataset.unitid, "-err"));

                  if (typeof _radiobtnerror !== "undefined" && _radiobtnerror !== null) {
                    _radiobtnerror.style.display = 'none';
                  }

                  _this36.customTenantDetailValues.push({
                    fieldId: radios_button_type[0].dataset.fieldid,
                    value: radio_btn_val,
                    unitId: typeof radios_button_type[0].dataset.unitid !== 'undefined' && radios_button_type[0].dataset.unitid !== null && radios_button_type[0].dataset.unitid !== '' ? radios_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'radioBtn'
                  });
                }
              }
            }
          });
        }

        var formInputFields = document.getElementsByClassName("six-storage-custom_input_fields_".concat(pageName));
        Array.prototype.forEach.call(formInputFields, function (field) {
          if (typeof field != 'undefined' && field != null) {
            required = field.dataset.element_required == 'true' ? true : false;
          }

          if (required === true && (field.value == null || field.value == "" || field.value == "NaN-NaN-NaN" || field.value.length === 0)) {
            document.getElementById("".concat(field.id, "-err")).style.display = "block";
            custom_error_count = custom_error_count + 1;
          } else {
            if (typeof field.dataset.field_type !== 'undefined' && field.dataset.field_type !== null && field.dataset.field_type !== '' && field.dataset.field_type === "date") {
              _this36.customTenantDetailValues.push({
                fieldId: field.dataset.fieldid,
                value: _this36.helper.sixStorageReadDate(field.value),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            } else {
              document.getElementById("".concat(field.id, "-err")).style.display = "none";

              _this36.customTenantDetailValues.push({
                fieldId: field.dataset.fieldid,
                value: field.value.replace(/\n/g, ' '),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            }
          }
        });
      } else if (pageName === 'emergencyContactDetails') {
        this.customEmgContactValues = [];
        this.savedCustomEmgContactValues = [];

        var _custom_fields_checkbox_containers = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_".concat(pageName));

        if (typeof _custom_fields_checkbox_containers !== 'undefined' && _custom_fields_checkbox_containers !== null && _custom_fields_checkbox_containers !== '') {
          Array.prototype.forEach.call(_custom_fields_checkbox_containers, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));
              var check_btn_val = "";

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null && check_button_type[0].dataset.unitId == fieldContainer_check.dataset.unitId) {
                for (var i = 0; i < check_button_type.length; i++) {
                  if (check_button_type[i].checked === true) {
                    check_btn_val = check_button_type[i].value;
                  }

                  checkboxReq = fieldContainer_check.dataset.element_required == 'true' ? true : false;
                }

                if (checkboxReq === true && (check_btn_val == null || check_btn_val == "" || check_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "none";

                  _this36.customEmgContactValues.push({
                    fieldId: check_button_type[0].dataset.fieldid,
                    value: check_btn_val,
                    unitId: typeof check_button_type[0].dataset.unitid !== 'undefined' && check_button_type[0].dataset.unitid !== null && check_button_type[0].dataset.unitid !== '' ? check_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'checkBox'
                  });
                }
              }
            }
          });
        }

        var _custom_fields_radio_button_containers = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_".concat(pageName));

        if (typeof _custom_fields_radio_button_containers !== 'undefined' && _custom_fields_radio_button_containers !== null && _custom_fields_radio_button_containers !== '') {
          Array.prototype.forEach.call(_custom_fields_radio_button_containers, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));
              var radio_btn_val = "";

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  radioReq = fieldContainer_radio.dataset.element_required == 'true' ? true : false;

                  if (radios_button_type[i].checked === true) {
                    radio_btn_val = radios_button_type[i].value;
                  }
                }

                if (radioReq === true && (radio_btn_val == null || radio_btn_val == "" || radio_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "none";

                  _this36.customEmgContactValues.push({
                    fieldId: radios_button_type[0].dataset.fieldid,
                    value: radio_btn_val,
                    unitId: typeof radios_button_type[0].dataset.unitid !== 'undefined' && radios_button_type[0].dataset.unitid !== null && radios_button_type[0].dataset.unitid !== '' ? radios_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'radioBtn'
                  });
                }
              }
            }
          });
        }

        var _formInputFields = document.getElementsByClassName("six-storage-custom_input_fields_".concat(pageName));

        Array.prototype.forEach.call(_formInputFields, function (field) {
          if (typeof field != 'undefined' && field != null) {
            required = field.dataset.element_required == 'true' ? true : false;
          }

          if (required === true && (field.value == null || field.value == "" || field.value == "NaN-NaN-NaN")) {
            document.getElementById("".concat(field.id, "-err")).style.display = "block";
            custom_error_count = custom_error_count + 1;
          } else {
            if (typeof field.dataset.field_type !== 'undefined' && field.dataset.field_type !== null && field.dataset.field_type !== '' && field.dataset.field_type === "date") {
              _this36.customEmgContactValues.push({
                fieldId: field.dataset.fieldid,
                value: _this36.helper.sixStorageReadDate(field.value),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            } else {
              document.getElementById("".concat(field.id, "-err")).style.display = "none";

              _this36.customEmgContactValues.push({
                fieldId: field.dataset.fieldid,
                value: field.value,
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            }
          }
        });
      } else if (pageName === 'unitSpecificDetails') {
        this.customUnitSpecificValues = [];
        this.savedCustomUnitSpecificValues = [];

        var _custom_fields_checkbox_containers2 = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_".concat(pageName));

        if (typeof _custom_fields_checkbox_containers2 !== 'undefined' && _custom_fields_checkbox_containers2 !== null && _custom_fields_checkbox_containers2 !== '') {
          Array.prototype.forEach.call(_custom_fields_checkbox_containers2, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));
              var check_btn_val = "";

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null && check_button_type[0].dataset.unitId == fieldContainer_check.dataset.unitId) {
                for (var i = 0; i < check_button_type.length; i++) {
                  if (check_button_type[i].checked === true) {
                    check_btn_val = check_button_type[i].value;
                  }

                  checkboxReq = fieldContainer_check.dataset.element_required == 'true' ? true : false;
                }

                if (checkboxReq === true && (check_btn_val == null || check_btn_val == "" || check_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "none";

                  _this36.customUnitSpecificValues.push({
                    fieldId: check_button_type[0].dataset.fieldid,
                    value: check_btn_val,
                    unitId: typeof check_button_type[0].dataset.unitid !== 'undefined' && check_button_type[0].dataset.unitid !== null && check_button_type[0].dataset.unitid !== '' ? check_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'checkBox'
                  });
                }
              }
            }
          });
        }

        var _custom_fields_radio_button_containers2 = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_".concat(pageName));

        if (typeof _custom_fields_radio_button_containers2 !== 'undefined' && _custom_fields_radio_button_containers2 !== null && _custom_fields_radio_button_containers2 !== '') {
          Array.prototype.forEach.call(_custom_fields_radio_button_containers2, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));
              var radio_btn_val = "";

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  radioReq = fieldContainer_radio.dataset.element_required == 'true' ? true : false;

                  if (radios_button_type[i].checked === true) {
                    radio_btn_val = radios_button_type[i].value;
                  }
                }

                if (radioReq === true && (radio_btn_val == null || radio_btn_val == "" || radio_btn_val == "NaN-NaN-NaN")) {
                  var radiobtnerror = document.getElementById("six_storage_".concat(radios_button_type[0].dataset.fieldid, "_").concat(radios_button_type[0].dataset.unitid, "-err"));

                  if (typeof radiobtnerror !== "undefined" && radiobtnerror !== null) {
                    radiobtnerror.style.display = 'block';
                  }

                  custom_error_count = custom_error_count + 1;
                } else {
                  var _radiobtnerror2 = document.getElementById("six_storage_".concat(radios_button_type[0].dataset.fieldid, "_").concat(radios_button_type[0].dataset.unitid, "-err"));

                  if (typeof _radiobtnerror2 !== "undefined" && _radiobtnerror2 !== null) {
                    _radiobtnerror2.style.display = 'none';
                  }

                  _this36.customUnitSpecificValues.push({
                    fieldId: radios_button_type[0].dataset.fieldid,
                    value: radio_btn_val,
                    unitId: typeof radios_button_type[0].dataset.unitid !== 'undefined' && radios_button_type[0].dataset.unitid !== null && radios_button_type[0].dataset.unitid !== '' ? radios_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'radioBtn'
                  });
                }
              }
            }
          });
        }

        var _formInputFields2 = document.getElementsByClassName("six-storage-custom_input_fields_".concat(pageName));

        Array.prototype.forEach.call(_formInputFields2, function (field) {
          if (typeof field != 'undefined' && field != null) {
            required = field.dataset.element_required == 'true' ? true : false;
          }

          if (required === true && (field.value == null || field.value == "" || field.value == "NaN-NaN-NaN" || field.value.length === 0)) {
            document.getElementById("".concat(field.id, "-err")).style.display = "block";
            custom_error_count = custom_error_count + 1;
          } else {
            if (typeof field.dataset.field_type !== 'undefined' && field.dataset.field_type !== null && field.dataset.field_type !== '' && field.dataset.field_type === "date") {
              _this36.customUnitSpecificValues.push({
                fieldId: field.dataset.fieldid,
                value: _this36.helper.sixStorageReadDate(field.value),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            } else {
              document.getElementById("".concat(field.id, "-err")).style.display = "none";

              _this36.customUnitSpecificValues.push({
                fieldId: field.dataset.fieldid,
                value: field.value.replace(/\n/g, ' '),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            }
          }
        });
      } else if (pageName === 'vehicleDetails') {
        this.customVehicleDetailsValues = []; // this.savedCustomVehicleDetailsValues = [];

        var _custom_fields_checkbox_containers3 = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_".concat(pageName));

        if (typeof _custom_fields_checkbox_containers3 !== 'undefined' && _custom_fields_checkbox_containers3 !== null && _custom_fields_checkbox_containers3 !== '') {
          Array.prototype.forEach.call(_custom_fields_checkbox_containers3, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));
              var check_btn_val = "";

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null && check_button_type[0].dataset.unitId == fieldContainer_check.dataset.unitId) {
                for (var i = 0; i < check_button_type.length; i++) {
                  if (check_button_type[i].checked === true) {
                    check_btn_val = check_button_type[i].value;
                  }

                  checkboxReq = fieldContainer_check.dataset.element_required == 'true' ? true : false;
                }

                if (checkboxReq === true && (check_btn_val == null || check_btn_val == "" || check_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "none";

                  _this36.customVehicleDetailsValues.push({
                    fieldId: check_button_type[0].dataset.fieldid,
                    value: check_btn_val,
                    unitId: typeof check_button_type[0].dataset.unitid !== 'undefined' && check_button_type[0].dataset.unitid !== null && check_button_type[0].dataset.unitid !== '' ? check_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'checkBox'
                  });
                }
              }
            }
          });
        }

        var _custom_fields_radio_button_containers3 = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_".concat(pageName));

        if (typeof _custom_fields_radio_button_containers3 !== 'undefined' && _custom_fields_radio_button_containers3 !== null && _custom_fields_radio_button_containers3 !== '') {
          Array.prototype.forEach.call(_custom_fields_radio_button_containers3, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));
              var radio_btn_val = "";

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  radioReq = fieldContainer_radio.dataset.element_required == 'true' ? true : false;

                  if (radios_button_type[i].checked === true) {
                    radio_btn_val = radios_button_type[i].value;
                  }
                }

                if (radioReq === true && (radio_btn_val == null || radio_btn_val == "" || radio_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "none";

                  _this36.customVehicleDetailsValues.push({
                    fieldId: radios_button_type[0].dataset.fieldid,
                    value: radio_btn_val,
                    unitId: typeof radios_button_type[0].dataset.unitid !== 'undefined' && radios_button_type[0].dataset.unitid !== null && radios_button_type[0].dataset.unitid !== '' ? radios_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'radioBtn'
                  });
                }
              }
            }
          });
        }

        var _formInputFields3 = document.getElementsByClassName("six-storage-custom_input_fields_".concat(pageName));

        Array.prototype.forEach.call(_formInputFields3, function (field) {
          if (typeof field != 'undefined' && field != null) {
            required = field.dataset.element_required == 'true' ? true : false;
          }

          if (required === true && (field.value == null || field.value == "" || field.value == "NaN-NaN-NaN")) {
            document.getElementById("".concat(field.id, "-err")).style.display = "block";
            custom_error_count = custom_error_count + 1;
          } else {
            if (typeof field.dataset.field_type !== 'undefined' && field.dataset.field_type !== null && field.dataset.field_type !== '' && field.dataset.field_type === "date") {
              _this36.customVehicleDetailsValues.push({
                fieldId: field.dataset.fieldid,
                value: _this36.helper.sixStorageReadDate(field.value),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            } else {
              document.getElementById("".concat(field.id, "-err")).style.display = "none";

              _this36.customVehicleDetailsValues.push({
                fieldId: field.dataset.fieldid,
                value: field.value,
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            }
          }
        });
      } else if (pageName === 'insuranceDetails') {
        this.customInsuranceDetailsValues = [];
        this.savedCustomInsuranceDetailsValues = [];

        var _custom_fields_checkbox_containers4 = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_".concat(pageName));

        if (typeof _custom_fields_checkbox_containers4 !== 'undefined' && _custom_fields_checkbox_containers4 !== null && _custom_fields_checkbox_containers4 !== '') {
          Array.prototype.forEach.call(_custom_fields_checkbox_containers4, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));
              var check_btn_val = "";

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null && check_button_type[0].dataset.unitId == fieldContainer_check.dataset.unitId) {
                for (var i = 0; i < check_button_type.length; i++) {
                  if (check_button_type[i].checked === true) {
                    check_btn_val = check_button_type[i].value;
                  }

                  checkboxReq = fieldContainer_check.dataset.element_required == 'true' ? true : false;
                }

                if (checkboxReq === true && (check_btn_val == null || check_btn_val == "" || check_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "none";

                  _this36.customInsuranceDetailsValues.push({
                    fieldId: check_button_type[0].dataset.fieldid,
                    value: check_btn_val,
                    unitId: typeof check_button_type[0].dataset.unitid !== 'undefined' && check_button_type[0].dataset.unitid !== null && check_button_type[0].dataset.unitid !== '' ? check_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'checkBox'
                  });
                }
              }
            }
          });
        }

        var _custom_fields_radio_button_containers4 = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_".concat(pageName));

        if (typeof _custom_fields_radio_button_containers4 !== 'undefined' && _custom_fields_radio_button_containers4 !== null && _custom_fields_radio_button_containers4 !== '') {
          Array.prototype.forEach.call(_custom_fields_radio_button_containers4, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));
              var radio_btn_val = "";

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  radioReq = fieldContainer_radio.dataset.element_required == 'true' ? true : false;

                  if (radios_button_type[i].checked === true) {
                    radio_btn_val = radios_button_type[i].value;
                  }
                }

                if (radioReq === true && (radio_btn_val == null || radio_btn_val == "" || radio_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "none";

                  _this36.customInsuranceDetailsValues.push({
                    fieldId: radios_button_type[0].dataset.fieldid,
                    value: radio_btn_val,
                    unitId: typeof radios_button_type[0].dataset.unitid !== 'undefined' && radios_button_type[0].dataset.unitid !== null && radios_button_type[0].dataset.unitid !== '' ? radios_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'radioBtn'
                  });
                }
              }
            }
          });
        }

        var _formInputFields4 = document.getElementsByClassName("six-storage-custom_input_fields_".concat(pageName));

        Array.prototype.forEach.call(_formInputFields4, function (field) {
          if (typeof field != 'undefined' && field != null) {
            required = field.dataset.element_required == 'true' ? true : false;
          }

          if (required === true && (field.value == null || field.value == "" || field.value == "NaN-NaN-NaN")) {
            document.getElementById("".concat(field.id, "-err")).style.display = "block";
            custom_error_count = custom_error_count + 1;
          } else {
            if (typeof field.dataset.field_type !== 'undefined' && field.dataset.field_type !== null && field.dataset.field_type !== '' && field.dataset.field_type === "date") {
              _this36.customInsuranceDetailsValues.push({
                fieldId: field.dataset.fieldid,
                value: _this36.helper.sixStorageReadDate(field.value),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            } else {
              document.getElementById("".concat(field.id, "-err")).style.display = "none";

              _this36.customInsuranceDetailsValues.push({
                fieldId: field.dataset.fieldid,
                value: field.value,
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            }
          }
        });
      } else if (pageName === 'thirdPatyInsuranceDetails') {
        this.customThirdPartyInsuranceDetailsValues = [];

        var _custom_fields_checkbox_containers5 = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_".concat(pageName));

        if (typeof _custom_fields_checkbox_containers5 !== 'undefined' && _custom_fields_checkbox_containers5 !== null && _custom_fields_checkbox_containers5 !== '') {
          Array.prototype.forEach.call(_custom_fields_checkbox_containers5, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));
              var check_btn_val = "";

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null && check_button_type[0].dataset.unitId == fieldContainer_check.dataset.unitId) {
                for (var i = 0; i < check_button_type.length; i++) {
                  if (check_button_type[i].checked === true) {
                    check_btn_val = check_button_type[i].value;
                  }

                  checkboxReq = fieldContainer_check.dataset.element_required == 'true' ? true : false;
                }

                if (checkboxReq === true && (check_btn_val == null || check_btn_val == "" || check_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(check_button_type[0].id, "-err")).style.display = "none";

                  _this36.customThirdPartyInsuranceDetailsValues.push({
                    fieldId: check_button_type[0].dataset.fieldid,
                    value: check_btn_val,
                    unitId: typeof check_button_type[0].dataset.unitid !== 'undefined' && check_button_type[0].dataset.unitid !== null && check_button_type[0].dataset.unitid !== '' ? check_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'checkBox'
                  });
                }
              }
            }
          });
        }

        var _custom_fields_radio_button_containers5 = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_".concat(pageName));

        if (typeof _custom_fields_radio_button_containers5 !== 'undefined' && _custom_fields_radio_button_containers5 !== null && _custom_fields_radio_button_containers5 !== '') {
          Array.prototype.forEach.call(_custom_fields_radio_button_containers5, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));
              var radio_btn_val = "";

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  radioReq = fieldContainer_radio.dataset.element_required == 'true' ? true : false;

                  if (radios_button_type[i].checked === true) {
                    radio_btn_val = radios_button_type[i].value;
                  }
                }

                if (radioReq === true && (radio_btn_val == null || radio_btn_val == "" || radio_btn_val == "NaN-NaN-NaN")) {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "block";
                  custom_error_count = custom_error_count + 1;
                } else {
                  document.getElementById("".concat(radios_button_type[0].id, "-err")).style.display = "none";

                  _this36.customThirdPartyInsuranceDetailsValues.push({
                    fieldId: radios_button_type[0].dataset.fieldid,
                    value: radio_btn_val,
                    unitId: typeof radios_button_type[0].dataset.unitid !== 'undefined' && radios_button_type[0].dataset.unitid !== null && radios_button_type[0].dataset.unitid !== '' ? radios_button_type[0].dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                    fieldPage: pageName,
                    fieldType: 'radioBtn'
                  });
                }
              }
            }
          });
        }

        var _formInputFields5 = document.getElementsByClassName("six-storage-custom_input_fields_".concat(pageName));

        Array.prototype.forEach.call(_formInputFields5, function (field) {
          if (typeof field != 'undefined' && field != null) {
            required = field.dataset.element_required == 'true' ? true : false;
          }

          if (required === true && (field.value == null || field.value == "" || field.value == "NaN-NaN-NaN")) {
            document.getElementById("".concat(field.id, "-err")).style.display = "block";
            custom_error_count = custom_error_count + 1;
          } else {
            if (typeof field.dataset.field_type !== 'undefined' && field.dataset.field_type !== null && field.dataset.field_type !== '' && field.dataset.field_type === "date") {
              _this36.customThirdPartyInsuranceDetailsValues.push({
                fieldId: field.dataset.fieldid,
                value: _this36.helper.sixStorageReadDate(field.value),
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            } else {
              document.getElementById("".concat(field.id, "-err")).style.display = "none";

              _this36.customThirdPartyInsuranceDetailsValues.push({
                fieldId: field.dataset.fieldid,
                value: field.value,
                unitId: typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== '' ? field.dataset.unitid : _this36.sixStorageSelectedUnitIdByUnitType[0],
                fieldPage: pageName,
                fieldType: 'textField'
              });
            }
          }
        });
      }

      return custom_error_count;
    }
  }, {
    key: "sixStorageGoToFinal",
    value: function sixStorageGoToFinal() {
      var _this37 = this;

      var firstname = document.getElementById("six_storage_firstname");
      var lastname = document.getElementById("six_storage_lastname");
      var email = document.getElementById("six_storage_email");
      var phone1 = document.getElementById("six_storage_phone1");
      var phone2 = document.getElementById("six_storage_phone2");
      var phone1Instance = window.intlTelInputGlobals.getInstance(phone1);
      var phone2Instance = window.intlTelInputGlobals.getInstance(phone2);
      var dob = document.getElementById("six_storage_dob");
      var address1 = document.getElementById("six_storage_address1");
      var address2 = document.getElementById("six_storage_address2");
      var country = document.getElementById("six_storage_country");
      var state = document.getElementById("six_storage_state");
      var city = document.getElementById("six_storage_city");
      var ssn = document.getElementById("six_storage_ssn_number");
      var zip_code = document.getElementById("six_storage_zip_code");
      var lead_source = document.getElementById("six_storage_lead_source");
      var company_name = document.getElementById("six_storage_company_name");
      var company_website = document.getElementById("six_storage_company_website");
      var company_tax_id = document.getElementById("six_storage_company_tax_id");
      var company_codice_fiscale = document.getElementById("six_storage_company_codice_fiscale");
      var company_pec_address = document.getElementById("six_storage_company_pec_address");
      var company_tranmission_channel_id = document.getElementById("six_storage_company_tranmission_channel_id");
      var delivery_address1 = document.getElementById("six_storage_delivery_address1");
      var delivery_address2 = document.getElementById("six_storage_delivery_address2");
      var delivery_country = document.getElementById("six_storage_delivery_country");
      var delivery_state = document.getElementById("six_storage_delivery_state");
      var delivery_city = document.getElementById("six_storage_delivery_city");
      var delivery_zip_code = document.getElementById("six_storage_delivery_zip_code");
      this.identityModel = {};
      var id_details = document.getElementById("six-storage-identity_type");
      var id_enabled = id_details.dataset.element_hidden == 'true' ? true : false;
      var id_required = id_details.dataset.element_required == "'true'" ? true : false;
      var upload_document = document.querySelector(".six-storage-upload-btn-wrapper");
      var upload_document_required = upload_document.dataset.element_required == "'true'" ? true : false;
      var identityTypeError_count = 0;
      var upload_documentError_count = 0;

      if (upload_document_required === true) {
        var upload_file_list = document.getElementById("six_storage_documentFile");
        var documentList = document.getElementById("six-storage-upload-list");

        if (documentList.children.length === 0) {
          document.getElementById('six_storage_documentFiles-err').style.display = 'block';
          document.getElementById("six_storage_documentFiles_valid-err").style.display = "none";
          upload_documentError_count = 1;
        } else {
          upload_documentError_count = 0;
          document.getElementById('six_storage_documentFiles-err').style.display = 'none';
          document.getElementById("six_storage_documentFiles_valid-err").style.display = "none";
        }
      }

      var sixStorageUploadprofilepicError_count = 0;

      if (wordpress_vars.six_storage_online_movein_profile_picture_is_mandatory !== 'undefined' && wordpress_vars.six_storage_online_movein_profile_picture_is_mandatory !== '' && wordpress_vars.six_storage_online_movein_profile_picture_is_mandatory !== null && wordpress_vars.six_storage_online_movein_profile_picture_is_mandatory === '1') {
        if (sessionStorage.getItem("six_storage_sessionObject") != '' && typeof sessionStorage.getItem("six_storage_sessionObject") != 'undefined' && sessionStorage.getItem("six_storage_sessionObject") != null) {
          var sixStorageGetUserdetailval = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
          var photoPath = sixStorageGetUserdetailval.photoPath;

          if (typeof photoPath !== 'undefined' && photoPath !== "" && photoPath === null) {
            sixStorageUploadprofilepicError_count = 1;
            document.getElementById('six_storage_upload_photo_err').style.display = 'block';
          } else {
            sixStorageUploadprofilepicError_count = 0;
            document.getElementById('six_storage_upload_photo_err').style.display = 'none';
          }
        }
      } else {
        sixStorageUploadprofilepicError_count = 0;
        document.getElementById('six_storage_upload_photo_err').style.display = 'none';
      }

      var customFieldError_count = this.sixstorageValidateCustomFields('moveInTenantDetails');

      if (id_required === true) {
        if (typeof id_details.value === 'undefined' || id_details.value === null || id_details.value === "") {
          document.getElementById('six-storage-identity_type-err').style.display = '';
          identityTypeError_count = 1;
        } else {
          identityTypeError_count = 0;
        }
      }

      var identityErrors = this.sixStorageValidateIdentityFields();

      if (id_enabled == false) {
        document.getElementById("six-storage-identity_type-display").innerHTML = typeof this.identityModel["idType"] !== "undefined" && this.identityModel["idType"] != null && this.identityModel["idType"] != "" ? this.identityModel["idType"] : "N/A";
      }

      var fields = this.identityModel["idDetails"];

      if (typeof fields !== "undefined") {
        if (fields.length > 0) {
          var idDetail = document.getElementById("six-storage-user-identification-details");
          idDetail.innerHTML = "";

          for (var i = 0; i < fields.length; i++) {
            var child = document.createElement("tr");
            var name = typeof fields[i]["fieldName"] !== "undefined" && fields[i]["fieldName"] != null && fields[i]["fieldName"] != "" ? fields[i]["fieldName"] : "-";

            var _value = typeof fields[i]["fieldValue"] !== "undefined" && fields[i]["fieldValue"] != null && fields[i]["fieldValue"] != "" ? fields[i]["fieldValue"] : "-";

            child.innerHTML = "<td class=\"cc\">".concat(name, ":</td><td class=\"cc\">").concat(_value, "</td>");
            idDetail.appendChild(child);
          }
        }
      }

      var addressObj = {
        six_storage_firstname: typeof firstname !== "undefined" && firstname !== null && typeof firstname.value !== "undefined" && firstname.value !== null ? firstname.value : null,
        six_storage_lastname: typeof lastname !== "undefined" && lastname !== null && typeof lastname.value !== "undefined" && lastname.value !== null ? lastname.value : null,
        six_storage_email: typeof email !== "undefined" && email !== null && typeof email.value !== "undefined" && email.value !== null ? email.value : null,
        six_storage_phone1: typeof phone1 !== "undefined" && phone1 !== null && typeof phone1Instance.getNumber() !== "undefined" && phone1Instance.getNumber() !== null ? phone1Instance.getNumber() : null,
        six_storage_phone2: typeof phone2 !== "undefined" && phone2 !== null && typeof phone2Instance.getNumber() !== "undefined" && phone2Instance.getNumber() !== null ? phone2Instance.getNumber() : null,
        six_storage_dob: typeof dob !== "undefined" && dob !== null && typeof dob.value !== "undefined" && dob.value !== null ? this.helper.sixStorageReadDate(dob.value) : null,
        six_storage_address1: typeof address1 !== "undefined" && address1 !== null && typeof address1.value !== "undefined" && address1.value !== null ? address1.value : null,
        six_storage_address2: typeof address2 !== "undefined" && address2 !== null && typeof address2.value !== "undefined" && address2.value !== null ? address2.value : null,
        six_storage_country: typeof country !== "undefined" && country !== null && typeof country.value !== "undefined" && country.value !== null ? country.value : null,
        six_storage_state: typeof state !== "undefined" && state !== null && typeof state.value !== "undefined" && state.value !== null ? state.value : null,
        six_storage_city: typeof city !== "undefined" && city !== null && typeof city.value !== "undefined" && city.value !== null ? city.value : null,
        six_storage_zip_code: typeof zip_code !== "undefined" && zip_code !== null && typeof zip_code.value !== "undefined" && zip_code.value !== null ? zip_code.value : null,
        six_storage_lead_source: typeof lead_source !== "undefined" && lead_source !== null && typeof lead_source.value !== "undefined" && lead_source.value !== null ? lead_source.value : null,
        six_storage_company_tax_id: typeof company_tax_id !== "undefined" && company_tax_id !== null && typeof company_tax_id.value !== "undefined" && company_tax_id.value !== null ? company_tax_id.value : null,
        six_storage_company_website: typeof company_website !== "undefined" && company_website !== null && typeof company_website.value !== "undefined" && company_website.value !== null ? company_website.value : null,
        six_storage_ssn_number: typeof ssn !== "undefined" && ssn !== null && typeof ssn.value !== "undefined" && ssn.value !== null ? ssn.value : null
      };
      var address_error_count = this.sixStorageValidateAndSave(addressObj);
      var company_error_count = 0;
      var delivery_error_count = 0;
      var emergency_error_count = 0;
      var document_error_count = 0;
      var emergency_custom_field_error_count = this.sixstorageValidateCustomFields('emergencyContactDetails');
      var documentFile = document.getElementById("six-storage-upload-list").innerHTML;
      var documentObj = {
        six_storage_documentFile: typeof documentFile !== "undefined" && documentFile !== null ? documentFile : null
      };
      document_error_count = this.sixStorageValidateAndSave(documentObj); //let isBusinessUser = document.getElementById("business-user");

      var isDeliveryAddressIsSame = document.getElementById("delivery-address-is-same-as-above");
      this.tentnantDetails["isPrimaryAndDeliveryAddressSame"] = isDeliveryAddressIsSame.checked;

      if (this.helper.sixStorageGetTenantType() == true) {
        var companyObj = {
          six_storage_company_name: typeof company_name !== "undefined" && company_name !== null && typeof company_name.value !== "undefined" && company_name.value !== null ? company_name.value : null,
          six_storage_company_codice_fiscale: typeof company_codice_fiscale !== "undefined" && company_codice_fiscale !== null && typeof company_codice_fiscale.value !== "undefined" && company_codice_fiscale.value !== null ? company_codice_fiscale.value : null,
          six_storage_company_pec_address: typeof company_pec_address !== "undefined" && company_pec_address !== null && typeof company_pec_address.value !== "undefined" && company_pec_address.value !== null ? company_pec_address.value : null,
          six_storage_company_tranmission_channel_id: typeof company_tranmission_channel_id !== "undefined" && company_tranmission_channel_id !== null && typeof company_tranmission_channel_id.value !== "undefined" && company_tranmission_channel_id.value !== null ? company_tranmission_channel_id.value : null
        };
        company_error_count = this.sixStorageValidateAndSave(companyObj);
      }

      if (isDeliveryAddressIsSame.checked == false) {
        var deliveryObj = {
          six_storage_delivery_address1: typeof delivery_address1 !== "undefined" && delivery_address1 !== null && typeof delivery_address1.value !== "undefined" && delivery_address1.value !== null ? delivery_address1.value : null,
          six_storage_delivery_address2: typeof delivery_address2 !== "undefined" && delivery_address2 !== null && typeof delivery_address2.value !== "undefined" && delivery_address2.value !== null ? delivery_address2.value : null,
          six_storage_delivery_country: typeof delivery_country !== "undefined" && delivery_country !== null && typeof delivery_country.value !== "undefined" && delivery_country.value !== null ? delivery_country.value : null,
          six_storage_delivery_state: typeof delivery_state !== "undefined" && delivery_state !== null && typeof delivery_state.value !== "undefined" && delivery_state.value !== null ? delivery_state.value : null,
          six_storage_delivery_city: typeof delivery_city !== "undefined" && delivery_city !== null && typeof delivery_city.value !== "undefined" && delivery_city.value !== null ? delivery_city.value : null,
          six_storage_delivery_zip_code: typeof delivery_zip_code !== "undefined" && delivery_zip_code !== null && typeof delivery_zip_code.value !== "undefined" && delivery_zip_code.value !== null ? delivery_zip_code.value : null
        };
        delivery_error_count = this.sixStorageValidateAndSave(deliveryObj);
      } // Call validation for seprated fields for emergency Contact


      var emergency_contact_phone_error_count = 0;
      var emergencyPhoneRequired = false;
      var emergency_contact_phone = document.getElementById("six-storage-emergency_contact_phone");

      if (typeof emergency_contact_phone !== "undefined" && emergency_contact_phone !== null) {
        emergencyPhoneRequired = emergency_contact_phone.dataset.element_required == "'true'" ? true : false;
      }

      var emergency_contact_firstname_error_count = 0;
      var emergencyFirstNameRequired = false;
      var emergency_contact_firstname = document.getElementById("six-storage-emergency_contact_first_name");

      if (typeof emergency_contact_firstname !== "undefined" && emergency_contact_firstname !== null) {
        emergencyFirstNameRequired = emergency_contact_firstname.dataset.element_required == "'true'" ? true : false;
      }

      var emergency_contact_lastname_error_count = 0;
      var emergencyLastNameRequired = false;
      var emergency_contact_lastname = document.getElementById("six-storage-emergency_contact_last_name");

      if (typeof emergency_contact_lastname !== "undefined" && emergency_contact_lastname !== null) {
        emergencyLastNameRequired = emergency_contact_lastname.dataset.element_required == "'true'" ? true : false;
      }

      var emergency_contact_email_error_count = 0;
      var emergencyEmailRequired = false;
      var emergency_contact_email = document.getElementById("six-storage-emergency_contact_email");

      if (typeof emergency_contact_email !== "undefined" && emergency_contact_email !== null) {
        emergencyEmailRequired = emergency_contact_email.dataset.element_required == "'true'" ? true : false;
      }

      if (document.getElementById("six-storage-emergency-fields") && document.getElementById("six-storage-emergency-fields").style.display != 'none') {
        if (emergencyPhoneRequired == true) {
          if (emergency_contact_phone.value === "") {
            emergency_contact_phone_error_count = 1;
          } else {
            emergency_contact_phone_error_count = 0;
          }

          document.getElementById("six-storage-emergency_contact_phone-err").style.display = "";
        } else {
          emergency_contact_phone_error_count = 0;

          if (typeof document.getElementById("six-storage-emergency_contact_phone-err") !== 'undefined' && document.getElementById("six-storage-emergency_contact_phone-err") !== null && document.getElementById("six-storage-emergency_contact_phone-err") !== '') {
            document.getElementById("six-storage-emergency_contact_phone-err").style.display = "none";
          }
        }

        if (emergencyFirstNameRequired == true) {
          if (emergency_contact_firstname.value === "") {
            emergency_contact_firstname_error_count = 1;
          } else {
            emergency_contact_firstname_error_count = 0;
          }

          document.getElementById("six-storage-emergency_contact_first_name-err").style.display = "";
        } else {
          emergency_contact_firstname_error_count = 0;

          if (typeof document.getElementById("six-storage-emergency_contact_first_name-err") !== 'undefined' && document.getElementById("six-storage-emergency_contact_first_name-err") !== null && document.getElementById("six-storage-emergency_contact_first_name-err") !== '') {
            document.getElementById("six-storage-emergency_contact_first_name-err").style.display = "none";
          }
        }

        if (emergencyLastNameRequired == true) {
          if (emergency_contact_lastname.value === "") {
            emergency_contact_lastname_error_count = 1;
          } else {
            emergency_contact_lastname_error_count = 0;
          }

          document.getElementById("six-storage-emergency_contact_last_name-err").style.display = "";
        } else {
          emergency_contact_lastname_error_count = 0;

          if (typeof document.getElementById("six-storage-emergency_contact_last_name-err") !== 'undefined' && document.getElementById("six-storage-emergency_contact_last_name-err") !== null && document.getElementById("six-storage-emergency_contact_last_name-err") !== '') {
            document.getElementById("six-storage-emergency_contact_last_name-err").style.display = "none";
          }
        }

        if (emergencyEmailRequired == true) {
          if (emergency_contact_email.value === "") {
            emergency_contact_email_error_count = 1;
          } else {
            if (!this.helper.sixStorageValidateEmail(emergency_contact_email)) {
              emergency_contact_email_error_count = 1;
            } else {
              emergency_contact_email_error_count = 0;
            }
          }

          document.getElementById("six-storage-emergency_contact_email-err").style.display = "";
        } else {
          emergency_contact_email_error_count = 0;

          if (emergency_contact_email.value !== "" && !this.helper.sixStorageValidateEmail(emergency_contact_email)) {
            emergency_contact_email_error_count = 1;
          }

          if (typeof document.getElementById("six-storage-emergency_contact_email-err") !== 'undefined' && document.getElementById("six-storage-emergency_contact_email-err") !== null && document.getElementById("six-storage-emergency_contact_email-err") !== '') {
            document.getElementById("six-storage-emergency_contact_email-err").style.display = "none";
          }
        }

        sixStorageAddEmergencyDetails();
      } else {
        emergency_contact_phone_error_count = 0;
        emergency_contact_firstname_error_count = 0;
        emergency_contact_lastname_error_count = 0;
        emergency_contact_email_error_count = 0;
      }

      var six_security_error_count = 0;
      var gateAccessErrorcount = 0;
      var security_error_count = 0;
      var sessionObj = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var checkSixSecurity = sessionObj.securityGateName;

      if (typeof checkSixSecurity !== 'undefined' && checkSixSecurity !== null && (checkSixSecurity === '6SECURITY' || checkSixSecurity === 'LOCKT')) {
        this.geteAccessInfo = [];
        var gateAccessField = document.getElementById("six-storage-gateAccessCode");
        var timezoneField = document.getElementById("six-storage-timezone");
        var timeZoneValue = '';

        if (typeof timezoneField !== 'undefined' && timezoneField !== null && timezoneField !== '') {
          timeZoneValue = timezoneField.value;
        }

        if (typeof gateAccessField !== 'undefined' && gateAccessField !== null) {
          if (typeof gateAccessField.value === 'undefined' || gateAccessField.value === null || gateAccessField.value === "" || gateAccessField.value.length === 0) {
            six_security_error_count = six_security_error_count + 1;
            gateAccessErrorcount = gateAccessErrorcount + 1;
            document.getElementById("six-storage-gateAccessCode-err").style.display = "";
            document.getElementById("six-storage-gateAccessCode-err").innerHTML = "".concat(
            /*Please Enter Gate Access Code*/
            wordpress_vars.six_storage_online_fs_ti_please_enter_gate_access_code, ".");
          } else if (typeof gateAccessField.value === 'undefined' || gateAccessField.value === null || gateAccessField.value.length < 4) {
            six_security_error_count = six_security_error_count + 1;
            gateAccessErrorcount = gateAccessErrorcount + 1;
            document.getElementById("six-storage-gateAccessCode-err").style.display = "";
            document.getElementById("six-storage-gateAccessCode-err").innerHTML = "".concat(
            /*Gate Access Code must be at least 4 digits*/
            wordpress_vars.six_storage_online_mi_Gate_Access_Code_must_digits, " .");
          } else {
            if (this.unitsSelected !== null && this.unitsSelected !== 'undefined' && this.unitsSelected.length > 0) {
              this.unitsSelected.forEach(function (unit) {
                _this37.geteAccessInfo.push({
                  "unitId": unit,
                  "gateAccessCode": gateAccessField.value,
                  "timeZoneId": timeZoneValue
                });
              });
              document.getElementById("six-storage-gateAccessCode-err").style.display = "none";
            }
          }
        }

        var accessCode = JSON.parse(sessionStorage.getItem("accessCode"));
        var userAccessCode = typeof accessCode !== 'undefined' && accessCode !== null && accessCode !== '' ? accessCode : '';

        if (gateAccessErrorcount === 0 && six_security_error_count === 0 && this.geteAccessInfo.length > 0 && (userAccessCode == '' || userAccessCode == null)) {
          // let error_count = 0;
          var formData = new FormData();
          formData.append("action", "six_storage_validate_gate_access");
          formData.append("gateAccessInfo", JSON.stringify(this.geteAccessInfo));
          var header = {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;"
            },
            body: this.helper.sixStorageGetURIParams(formData)
          };
          var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
          document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
          fetch(url, header).then(function (response) {
            return response.json();
          }).then(function (data) {
            document.getElementById("six-storage-loading-container").innerHTML = _this37.helper.sixStorageShowBusyIndicator(false);

            if (typeof data !== "undefined" && data !== null) {
              var _response14 = JSON.parse(data);

              if (typeof _response14.isSuccess !== "undefined" && _response14 !== null && _response14.isSuccess === true) {
                if (typeof wordpress_vars.six_storage_google_analytics_integrated !== "undefined" && wordpress_vars.six_storage_google_analytics_integrated !== null && wordpress_vars.six_storage_google_analytics_integrated !== "" && wordpress_vars.six_storage_google_analytics_integrated === "1") {
                  gtag('event', 'page_view', {
                    page_title: 'Rent Now - Addons',
                    page_location: 'Rent Now',
                    page_path: '/rent-now#addons',
                    send_to: "".concat(wordpress_vars.six_storage_google_analytics_input_key)
                  });
                }

                var invalidGateAccess = _response14.result.filter(function (x) {
                  return x.isValid === false;
                });

                if (invalidGateAccess.length > 0) {
                  _this37.currentStepNumber -= 1; // error_count = error_count + 1;

                  document.getElementById("six-storage-gateAccessCode-err").innerHTML = "".concat(
                  /*Gate access code already exist*/
                  wordpress_vars.six_storage_online_mi_Gate_Access_Already_Exist);
                  document.getElementById("six-storage-gateAccessCode-err").style.display = "";
                } else {
                  document.getElementById("six-storage-gateAccessCode-err").style.display = "none";

                  if (address_error_count == 0 && company_error_count == 0 && delivery_error_count == 0 && emergency_error_count == 0 && identityErrors == 0 && document_error_count == 0 && identityTypeError_count == 0 && customFieldError_count == 0 && emergency_custom_field_error_count == 0 && gateAccessErrorcount === 0 && six_security_error_count === 0 && security_error_count === 0 && sixStorageUploadprofilepicError_count == 0 && emergency_contact_phone_error_count === 0 && emergency_contact_firstname_error_count === 0 && emergency_contact_lastname_error_count === 0 && emergency_contact_email_error_count === 0) {
                    document.getElementById("six-storage-gateAccessCode-err").style.display = "none";
                    _this37.currentSessionVal = {
                      addressone: addressObj.six_storage_address1,
                      addresstwo: addressObj.six_storage_address2,
                      state: addressObj.six_storage_state,
                      zip_code: addressObj.six_storage_zip_code,
                      city: addressObj.six_storage_city,
                      country: addressObj.six_storage_country,
                      ssn: addressObj.six_storage_ssn_number
                    };
                    sessionStorage.setItem("currentSessionVal", JSON.stringify(_this37.currentSessionVal));

                    _this37.sixStorageSaveLeaseProfile();
                  } else {
                    _this37.currentStepNumber -= 1;
                  }
                }
              }
            }
          })["catch"](function (err) {
            console.error(err);
          });
        } else {
          if (address_error_count == 0 && company_error_count == 0 && delivery_error_count == 0 && emergency_error_count == 0 && identityErrors == 0 && document_error_count == 0 && identityTypeError_count == 0 && customFieldError_count == 0 && emergency_custom_field_error_count == 0 && gateAccessErrorcount === 0 && six_security_error_count === 0 && security_error_count === 0 && upload_documentError_count === 0 && sixStorageUploadprofilepicError_count == 0 && emergency_contact_phone_error_count === 0 && emergency_contact_firstname_error_count === 0 && emergency_contact_lastname_error_count === 0 && emergency_contact_email_error_count === 0) {
            this.currentSessionVal = {
              addressone: addressObj.six_storage_address1,
              addresstwo: addressObj.six_storage_address2,
              state: addressObj.six_storage_state,
              zip_code: addressObj.six_storage_zip_code,
              city: addressObj.six_storage_city,
              country: addressObj.six_storage_country,
              ssn: addressObj.six_storage_ssn_number
            };
            sessionStorage.setItem("currentSessionVal", JSON.stringify(this.currentSessionVal));
            this.sixStorageSaveLeaseProfile();
          } else {
            this.currentStepNumber -= 1;
          }
        }
      } else {
        if (address_error_count == 0 && company_error_count == 0 && delivery_error_count == 0 && emergency_error_count == 0 && identityErrors == 0 && document_error_count == 0 && identityTypeError_count == 0 && customFieldError_count == 0 && emergency_custom_field_error_count == 0 && gateAccessErrorcount === 0 && six_security_error_count === 0 && security_error_count === 0 && upload_documentError_count === 0 && sixStorageUploadprofilepicError_count == 0 && emergency_contact_phone_error_count === 0 && emergency_contact_firstname_error_count === 0 && emergency_contact_lastname_error_count === 0 && emergency_contact_email_error_count === 0) {
          this.currentSessionVal = {
            addressone: addressObj.six_storage_address1,
            addresstwo: addressObj.six_storage_address2,
            state: addressObj.six_storage_state,
            zip_code: addressObj.six_storage_zip_code,
            city: addressObj.six_storage_city,
            country: addressObj.six_storage_country,
            ssn: addressObj.six_storage_ssn_number
          };
          sessionStorage.setItem("currentSessionVal", JSON.stringify(this.currentSessionVal));
          this.sixStorageSaveLeaseProfile();
        } else {
          this.currentStepNumber -= 1;
        }
      }
    }
  }, {
    key: "sixStorageValidateIdentityFields",
    value: function sixStorageValidateIdentityFields() {
      var _this38 = this;

      var error_count = 0;
      var identitytype = document.getElementById("six-storage-identity_type");

      if (identitytype.options.length === 0) {
        return error_count;
      }

      var selectedIdentity = identitytype.options[identitytype.selectedIndex];

      if (typeof selectedIdentity !== 'undefined' && selectedIdentity !== null && typeof selectedIdentity.value !== "undefined" && selectedIdentity.value !== "" && selectedIdentity.value !== null) {
        document.getElementById("six-storage-identity_type-err").style.display = "none";
        var fields = document.getElementsByClassName("six-storage-identity-fields_".concat(selectedIdentity.value));
        this.identityModel["id"] = selectedIdentity.value;
        this.identityModel["idType"] = selectedIdentity.text;

        if (fields.length > 0) {
          this.identityModel["idDetails"] = [];
          Array.prototype.forEach.call(fields, function (element) {
            if (typeof element.value !== "undefined" && element.value !== "" && element.value !== null) {
              document.getElementById("".concat(element.id, "-err")).style.display = "none";

              _this38.identityModel["idDetails"].push({
                fieldName: element.dataset.fieldname,
                fieldValue: element.value
              });
            } else {
              error_count++;
              document.getElementById("".concat(element.id, "-err")).style.display = "";
            }
          });
        }
      } else {
        if (identitytype.dataset.element_required === true) {
          error_count++;
          document.getElementById("six-storage-identity_type-err").style.display = "";
        }
      }

      return error_count;
    }
  }, {
    key: "sixStorageValidateAndSave",
    value: function sixStorageValidateAndSave(obj) {
      var _this39 = this;

      var error_count = 0;
      var required = false;
      Object.entries(obj).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        try {
          var field = document.getElementById(key);

          if (typeof field != 'undefined' && field != null) {
            required = field.dataset.element_required == "'true'" ? true : false;
          }

          if (required === true && (value == null || value == "" || value == "NaN-NaN-NaN")) {
            document.getElementById(key + "-err").style.display = "block";
            error_count = error_count + 1;
            return false;
          } else {
            _this39.tentnantDetails[key] = value;

            if (key.toLowerCase().indexOf("email") > -1) {
              if (!_this39.helper.sixStorageValidateEmail(document.getElementById("six-storage-" + key))) {
                error_count = error_count + 1;
              } else {
                var elementObj = document.getElementById(key + "-display");

                if (elementObj) {
                  elementObj.innerHTML = value;
                }
              }
            } else if (required === true && key === 'six_storage_company_website') {
              if (_this39.helper.sixStorageValidURL(value) === false) {
                document.getElementById(key + "-err").innerHTML = "".concat(
                /*Please Enter Valid URL*/
                wordpress_vars.six_storage_online_fc_please_enter_valid_URL);
                document.getElementById(key + "-err").style.display = "block";
                error_count = error_count + 1;
                return false;
              } else {
                document.getElementById(key + "-err").style.display = "none";
              }
            } else if (required === true && key === 'six_storage_ssn_number') {
              if (value.length <= 5) {
                document.getElementById("six_storage_ssn_number-err").style.display = "";
                document.getElementById("six_storage_ssn_number-err").innerHTML = "".concat(wordpress_vars.six_storage_online_please_enter_atleast_six_characters);
                error_count = error_count + 1;
              } else {
                document.getElementById(key + "-err").style.display = "none";
              }
            } else if (required === false && key === 'six_storage_ssn_number') {
              if (value.length <= 5 && value.length !== 0) {
                document.getElementById("six_storage_ssn_number-err").style.display = "";
                document.getElementById("six_storage_ssn_number-err").innerHTML = "".concat(wordpress_vars.six_storage_online_please_enter_atleast_six_characters);
                error_count = error_count + 1;
              } else {
                document.getElementById(key + "-err").style.display = "none";
              }
            } else {
              var _elementObj = document.getElementById(key + "-display");

              if (_elementObj) {
                _elementObj.innerHTML = value;
              }

              var ele = document.getElementById(key + "-err");

              if (ele) {
                ele.style.display = "none";
              }
            }
          }
        } catch (err) {//console.error(err);
        }
      });
      return error_count;
    }
  }, {
    key: "sixStorageRemoveDocument",
    value: function sixStorageRemoveDocument(len) {
      localStorage.removeItem("document_file_name");
      localStorage.removeItem("document_file_path");
      var documentList = document.getElementById("six-storage-upload-list");

      if (typeof documentList.children[len] !== "undefined" && documentList.children[len] !== "" && documentList.children[len] !== null) {
        documentList.children[len].remove();
      }

      document.getElementById("six_storage_documentFiles-err").style.display = 'none';
      document.getElementById("six_storage_documentFiles_valid-err").style.display = 'none';
      document.getElementById("six_storage_documentFiles_size-err").style.display = 'none';
      document.getElementById("six_storage_size_exceeded-err").style.display = 'none';
      document.getElementById("six_storage_server_size_mismatch").style.display = 'none';
      document.getElementById("six_storage_size_indication_msg").style.display = 'block';
    }
  }, {
    key: "sixStorageUploadDocuments",
    value: function sixStorageUploadDocuments(e) {
      var identity_type = document.getElementById("six-storage-identity_type");
      var documentFile = document.getElementById("six_storage_documentFile");
      var obj = {
        identity_type: typeof identity_type !== "undefined" && identity_type !== null && typeof identity_type.value !== "undefined" && identity_type.value !== null ? identity_type.value : null,
        documentFile: typeof documentFile !== "undefined" && documentFile !== null && typeof documentFile.files !== "undefined" && documentFile.files !== null ? documentFile.files : null
      };
      var error_count = this.sixStorageValidateAndSave(obj);
      var six_Storage_server_upload_file_limit = wordpress_vars.six_storage_server_upload_limit;
      var six_Storage_server_upload_file_value = parseInt(six_Storage_server_upload_file_limit.match(/\d+/g));
      var six_Storage_total_upload_size = six_Storage_server_upload_file_value * 1048576;

      if (error_count == 0) {
        document.getElementById('six_storage_documentFiles-err').style.display = 'none';
        var documentList = document.getElementById("six-storage-upload-list");
        documentList.innerHTML = "";

        for (var i = 0; i < documentFile.files.length; i++) {
          if (documentFile.files[i].size < six_Storage_total_upload_size) {
            if (documentFile.files[i].size <= 5347737) {
              if (documentFile.files[i].size > 0) {
                var sixStoragerawfileName = documentFile.files[i].name;

                var _fileName = sixStoragerawfileName.replace(/[&\\\^+()~%'":?<>{}!@#]/g, '');

                var sixStorageCheckFileExtension = '.'.concat(_fileName.split('.').pop());

                if (_fileName == sixStorageCheckFileExtension) {
                  document.getElementById("six_storage_documentFiles_valid-err").style.display = "block";
                  document.getElementById("six_storage_documentFiles_size-err").style.display = "none";
                  document.getElementById('six_storage_documentFiles-err').style.display = 'none';
                  document.getElementById("six_storage_size_exceeded-err").style.display = "none";
                  document.getElementById("six_storage_size_indication_msg").style.display = "none";
                } else {
                  var sixStorageNewUploadedFileNameVal = this.helper.sixStorageFileNameChange(_fileName);
                  document.getElementById("six_storage_documentFiles_valid-err").style.display = "none";
                  document.getElementById('six_storage_documentFiles-err').style.display = 'none';
                  document.getElementById("six_storage_size_exceeded-err").style.display = "none";
                  document.getElementById("six_storage_server_size_mismatch").style.display = "none";
                  documentList.innerHTML = "".concat(documentList.innerHTML, "<li class=\"cc six-storage-grid-mr10 six-storage-grid-mt10\" id=\"document_").concat(i, "\">").concat(sixStorageNewUploadedFileNameVal, " <i class=\"six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grid-mr10 six-storage-cursor-pointer six-storage-document-close\" onclick=\"sixStorageRemoveDocument(").concat(i, ")\">cancel</i></li>");
                }
              } else {
                document.getElementById("six_storage_documentFiles_size-err").style.display = "block";
                document.getElementById("six_storage_size_exceeded-err").style.display = "none";
                document.getElementById("six_storage_size_indication_msg").style.display = "none";
                document.getElementById("six_storage_server_size_mismatch").style.display = "none";
                document.getElementById("six_storage_documentFiles_valid-err").style.display = "none";
              }
            } else {
              document.getElementById("six_storage_size_exceeded-err").style.display = "block";
              document.getElementById("six_storage_documentFiles_size-err").style.display = "none";
              document.getElementById("six_storage_size_indication_msg").style.display = "none";
              document.getElementById("six-storage-user-document-upload-err").style.display = 'none';
            }
          } else if (six_Storage_total_upload_size === 5242880 && documentFile.files[i].size > six_Storage_total_upload_size) {
            document.getElementById("six_storage_size_indication_msg").style.display = "none";
            document.getElementById("six_storage_server_size_mismatch").style.display = "none";
            document.getElementById("six_storage_documentFiles-err").style.display = "none";
            document.getElementById("six_storage_documentFiles_valid-err").style.display = "none";
            document.getElementById("six_storage_documentFiles_size-err").style.display = "none";
            document.getElementById("six_storage_size_exceeded-err").style.display = "block";
          } else if (six_Storage_total_upload_size < 5242880 && documentFile.files[i].size > six_Storage_total_upload_size) {
            document.getElementById("six_storage_server_size_mismatch").style.display = "block";
            document.getElementById("six_storage_size_indication_msg").style.display = 'none';
            document.getElementById("six_storage_documentFiles-err").style.display = "none";
            document.getElementById("six_storage_documentFiles_valid-err").style.display = "none";
            document.getElementById("six_storage_documentFiles_size-err").style.display = "none";
            document.getElementById("six_storage_size_exceeded-err").style.display = "none";
          } else {
            document.getElementById("six_storage_server_size_mismatch").style.display = "none";
            document.getElementById("six_storage_size_indication_msg").style.display = 'none';
            document.getElementById("six_storage_documentFiles-err").style.display = "none";
            document.getElementById("six_storage_documentFiles_valid-err").style.display = "none";
            document.getElementById("six_storage_documentFiles_size-err").style.display = "none";
            document.getElementById("six_storage_size_exceeded-err").style.display = "block";
          }
        }
      }
    }
  }, {
    key: "sixStorageRenderEmergencyhtml",
    value: function sixStorageRenderEmergencyhtml() {
      var sixstorageemergCustomFieldHtml = this.sixStorageCustomFieldsDetails('Emergency Contact Details');
      sixstorageemergCustomFieldHtml = typeof sixstorageemergCustomFieldHtml !== 'undefined' && sixstorageemergCustomFieldHtml !== '' && sixstorageemergCustomFieldHtml !== null ? sixstorageemergCustomFieldHtml : '';
      var customemergencyFieldheadtable = "";

      if (typeof sixstorageemergCustomFieldHtml !== 'undefined' && sixstorageemergCustomFieldHtml !== '' && sixstorageemergCustomFieldHtml !== null) {
        this.customFieldsResponse.result.forEach(function (item, index) {
          if (item.matadata.displayOn === 'Emergency Contact Details') {
            customemergencyFieldheadtable += "<th class=\"cc\">".concat(item.fieldName, "</th>");
          }
        });
      }

      var emgFirstNameMandatory = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_is_mandatory !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_is_mandatory !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_is_mandatory !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_is_mandatory) === 1) {
        emgFirstNameMandatory = 'data-element_required="\'true\'"';
      } else {
        emgFirstNameMandatory = 'data-element_required="\'false\'"';
      }

      var emgLastNameMandatory = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_is_mandatory !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_is_mandatory !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_is_mandatory !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_is_mandatory) === 1) {
        emgLastNameMandatory = 'data-element_required="\'true\'"';
      } else {
        emgLastNameMandatory = 'data-element_required="\'false\'"';
      }

      var emgMobileMandatory = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_is_mandatory !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_is_mandatory !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_is_mandatory !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_is_mandatory) === 1) {
        emgMobileMandatory = 'data-element_required="\'true\'"';
      } else {
        emgMobileMandatory = 'data-element_required="\'false\'"';
      }

      var emgEmailMandatory = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_is_mandatory !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_is_mandatory !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_is_mandatory !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_is_mandatory) === 1) {
        emgEmailMandatory = 'data-element_required="\'true\'"';
      } else {
        emgEmailMandatory = 'data-element_required="\'false\'"';
      }

      var emgFirstName = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_toggle !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_toggle !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_toggle) === 1) {
        emgFirstName = 'data-element_hidden="\'false\'"';
      } else {
        emgFirstName = 'data-element_hidden="\'true\'"';
      }

      var emgLastName = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_toggle !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_toggle !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_toggle) === 1) {
        emgLastName = 'data-element_hidden="\'false\'"';
      } else {
        emgLastName = 'data-element_hidden="\'true\'"';
      }

      var emgMobile = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_toggle !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_toggle !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_mobile_toggle) === 1) {
        emgMobile = 'data-element_hidden="\'false\'"';
      } else {
        emgMobile = 'data-element_hidden="\'true\'"';
      }

      var emgEmail = '';

      if (typeof wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_toggle !== 'undefined' && wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_toggle !== null && wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_toggle !== '' && parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_toggle) === 1) {
        emgEmail = 'data-element_hidden="\'false\'"';
      } else {
        emgEmail = 'data-element_hidden="\'true\'"';
      }

      var html = "<div class=\"six-storage-clearfix six-storage-clearfix-w-100 six-storage-row  cc six-storage-grid-mt30\" id=\"six-storage-emergency-contact-fields\">\n    <h6 class=\"six-storage-col six-storage-m12 six-storage-grid-w-100 cc six-storage-grid-mt0 six-storage-grid-mb25\">\n      ".concat(wordpress_vars.six_storage_online_fc_emergency_contact, "\n    </h6>\n    <div style=\"display: none;\" id=\"six-storage-emergency-err\" class=\"six-storage-invalid-feedback six-storage-col six-storage-grid-mb20\">").concat(wordpress_vars.six_storage_online_please_enter_emergency_contact_details, "</div>\n    <div class=\"six-storage-grid-table-responsive six-storage-leasetab\">\n      <table id=\"six-storage-emergency-details-list\" class=\"six-storage-word-break-table cc six-storage-addedvehicles six-storage-table-header-fixed six-storage-text-center six-storage-grid-table six-storage-grid-table-borderless six-storage-grid-mt20\" style=\"display:none;\">\n        <thead class=\"six-storage-grid-thead-light six-storage-grey six-storage-lighten-4\" id=\"six-storage-emergency-details-list-head\" >\n          <tr class=\"cc\">");

      if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_toggle) === 1) {
        html += "<th class=\"cc\">".concat(wordpress_vars.six_storage_online_fs_First_Name, "</th>");
      }

      if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_toggle) === 1) {
        html += "<th class=\"cc\">".concat(wordpress_vars.six_storage_online_fs_Last_Name, "</th>");
      }

      if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_toggle) === 1) {
        html += "<th class=\"cc\">".concat(wordpress_vars.six_storage_online_fs_Email, "</th>");
      }

      html += "<th class=\"cc\" colspan=\"2\">".concat(wordpress_vars.six_storage_online_fs_Mobile, "</th>\n          </tr>\n        </thead>\n        <tbody id=\"six-storage-emergencyContact-tbody\" class=\"six-storage-custom-scroller\">\n        </tbody>\n      </table>\n    </div>\n    <div class=\"six-storage-row  cc six-storage-grid-m0\" id=\"six-storage-emergency-fields\">\n      <div class=\"six-storage-input-field six-storage-col six-storage-m6 six-storage-s12\" ").concat(emgFirstNameMandatory, " ").concat(emgFirstName, ">\n        <input id=\"six-storage-emergency_contact_first_name\" class=\"cc\" type=\"text\" ").concat(emgFirstNameMandatory, ">\n        <label class=\"cc\">").concat(wordpress_vars.six_storage_online_fs_First_Name, "</label>\n        <div style=\"display: none;\" id=\"six-storage-emergency_contact_first_name-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_Please_Enter_First_Name, "</div>\n      </div>\n      <div class=\"six-storage-input-field six-storage-col six-storage-m6 six-storage-s12\" ").concat(emgLastNameMandatory, " ").concat(emgLastName, ">\n        <input id=\"six-storage-emergency_contact_last_name\" class=\"cc\" type=\"text\" ").concat(emgLastNameMandatory, ">\n        <label class=\"cc\">").concat(wordpress_vars.six_storage_online_fs_Last_Name, "</label>\n        <div style=\"display: none;\" id=\"six-storage-emergency_contact_last_name-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_fs_Please_Enter_Last_Name, "</div>\n      </div>\n      <div class=\"six-storage-input-field six-storage-col six-storage-m6 six-storage-s12 six-storage-phone-input\" ").concat(emgMobileMandatory, " ").concat(emgMobile, ">\n        <input id=\"six-storage-emergency_contact_phone\" class=\"cc six-storage-telephone\" type=\"tel\" ").concat(emgMobileMandatory, ">\n        <label class=\"six-storage-active cc\" id=\"six-storage-mobilelabel\">").concat(wordpress_vars.six_storage_online_fs_Mobile, "</label>\n        <div style=\"display: none;\" id=\"six-storage-emergency_contact_phone-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_please_enter_mobile, "</div>\n      </div>\n      <div class=\"six-storage-input-field six-storage-col six-storage-m6 six-storage-s12\" ").concat(emgEmailMandatory, " ").concat(emgEmail, ">\n        <input id=\"six-storage-emergency_contact_email\" class=\"cc\" type=\"email\" ").concat(emgEmailMandatory, ">\n        <label class=\"cc\">").concat(wordpress_vars.six_storage_online_fs_Email, "</label>\n        <div style=\"display: none;\" id=\"six-storage-emergency_contact_email-err\" class=\"six-storage-invalid-feedback\">").concat(wordpress_vars.six_storage_online_please_enter_email, "</div>\n      </div>\n    </div>\n    <div class=\"six-storage-row cc\">\n      <div class=\"six-storage-float-none six-storage-text-center\">\n        <button type=\"button\" class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color\" onclick=\"return sixStorageAddEmergencyDetails();\" id=\"six-storage-addemergencydetails\">").concat(wordpress_vars.six_storage_online_fc_Save, "</button>\n        <button type=\"button\" class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color\" id=\"six-storage-emergency-add-more\" style=\"display: none\" onclick=\"sixStorageDisplayEmergencyContact();\">").concat(wordpress_vars.six_storage_online_fc_add_more, "</button>\n      </div>\n    </div>\n</div>");
      return html;
    }
  }, {
    key: "sixStorageAddEmergencyDetails",
    value: function sixStorageAddEmergencyDetails() {
      var _this40 = this;

      var emergency_contact_first_name = document.getElementById("six-storage-emergency_contact_first_name");
      var emergency_contact_last_name = document.getElementById("six-storage-emergency_contact_last_name");
      var emergency_contact_email = document.getElementById("six-storage-emergency_contact_email");
      var emergency_contact_phone = document.getElementById("six-storage-emergency_contact_phone");
      var emergency_contact_phone_instance = window.intlTelInputGlobals.getInstance(emergency_contact_phone);
      var obj = {
        emergency_contact_phone: typeof emergency_contact_phone_instance !== "undefined" && emergency_contact_phone_instance !== null && typeof emergency_contact_phone_instance.getNumber() !== "undefined" && emergency_contact_phone_instance.getNumber() !== null ? emergency_contact_phone_instance.getNumber() : null,
        emergency_contact_email: typeof emergency_contact_email !== "undefined" && emergency_contact_email !== null && typeof emergency_contact_email.value !== "undefined" && emergency_contact_email.value !== null ? emergency_contact_email.value : null,
        emergency_contact_last_name: typeof emergency_contact_last_name !== "undefined" && emergency_contact_last_name !== null && typeof emergency_contact_last_name.value !== "undefined" && emergency_contact_last_name.value !== null ? emergency_contact_last_name.value : null,
        emergency_contact_first_name: typeof emergency_contact_first_name !== "undefined" && emergency_contact_first_name !== null && typeof emergency_contact_first_name.value !== "undefined" && emergency_contact_first_name.value !== null ? emergency_contact_first_name.value : null
      };
      var error_count = 0;
      Object.entries(obj).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            key = _ref10[0],
            value = _ref10[1];

        var field = document.getElementById('six-storage-' + key);
        required = field.dataset.element_required == "'true'" ? true : false;

        if (required === true && (value == null || value == "undefined" || value == "")) {
          document.getElementById("six-storage-" + key + "-err").style.display = "Block";
          error_count = error_count + 1;
          return false;
        } else if (required === true && key === 'emergency_contact_email') {
          if (!_this40.helper.sixStorageValidateEmail(document.getElementById("six-storage-" + key))) {
            document.getElementById("six-storage-" + key + "-err").style.display = "Block";
            error_count = error_count + 1;
            return false;
          } else {
            document.getElementById("six-storage-" + key + "-err").style.display = "none";
          }
        } else if (emergency_contact_email.value !== '' && required === false && key === 'emergency_contact_email') {
          if (!_this40.helper.sixStorageValidateEmail(document.getElementById("six-storage-" + key))) {
            document.getElementById("six-storage-" + key + "-err").style.display = "Block";
            error_count = error_count + 1;
            return false;
          } else {
            document.getElementById("six-storage-" + key + "-err").style.display = "none";
          }
        } else {
          var ele = document.getElementById("six-storage-" + key + "-err");

          if (ele) {
            ele.style.display = "none";
          }
        }
      });
      var custom_field_error_count = 0;
      var required = false;
      var checkboxReq = false;
      var radioReq = false;
      custom_field_error_count = this.sixstorageValidateCustomFields('emergencyContactDetails');

      if (error_count == 0 && custom_field_error_count == 0) {
        var emergencyDetails = {
          id: null,
          firstName: emergency_contact_first_name.value,
          lastName: emergency_contact_last_name.value,
          email: emergency_contact_email.value,
          mobile: emergency_contact_phone.value
        };
        this.tentnantDetailsFinal["emergencyContact"].push(emergencyDetails);
        var emergencytablehead = '';
        this.customEmgContactValues.forEach(function (item, index) {
          if (item.value !== 'undefined' && item.value !== null && item.value !== '') {
            emergencytablehead = emergencytablehead + "<td class=\"cc\">".concat(item.value, "</td>");
          } else {
            emergencytablehead = emergencytablehead + "-";
          } // emergencytablehead = typeof item.value !== 'undefined' && item.value !== null && item.value !== ''
          //   ? `<td class="cc">${item.value}</td>`
          //   : '-';

        }); //let node = document.createElement("tr");

        var emrgbodyHtml = "";
        var emrgbodyHtml_first_name = "";
        var emrgbodyHtml_last_name = "";
        var emrgbodyHtml_email = "";

        if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_first_name_toggle) === 1) {
          if (emergency_contact_first_name.value == '') {
            emrgbodyHtml_first_name += "<td class=\"cc\">-</td>";
          } else {
            emrgbodyHtml_first_name += "<td class=\"cc\">".concat(obj.emergency_contact_first_name, "</td>");
          }
        }

        if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_last_name_toggle) === 1) {
          if (emergency_contact_last_name.value == '') {
            emrgbodyHtml_last_name += "<td class=\"cc\">-</td>";
          } else {
            emrgbodyHtml_last_name += "<td class=\"cc\">".concat(obj.emergency_contact_last_name, "</td>");
          }
        }

        if (parseInt(wordpress_vars.six_storage_online_fs_ti_emergencycontact_email_toggle) === 1) {
          if (emergency_contact_email.value == '') {
            emrgbodyHtml_email += "<td class=\"cc\">-</td>";
          } else {
            emrgbodyHtml_email += "<td class=\"cc\">".concat(obj.emergency_contact_email, "</td>");
          }
        }

        emrgbodyHtml = "".concat(emrgbodyHtml_first_name, "\n      ").concat(emrgbodyHtml_last_name, "\n      ").concat(emrgbodyHtml_email, "     \n      <td class=\"cc\">").concat(obj.emergency_contact_phone, "</td>\n      ").concat(emergencytablehead);
        var tableRef = document.getElementById("six-storage-emergencyContact-tbody");
        var emergtr = document.createElement("tr");
        emergtr.id = "six-storage-trVehicleInfo_".concat(this.customEmgContactValues.length);
        emergtr.innerHTML = emrgbodyHtml;
        tableRef.appendChild(emergtr);
        emergency_contact_first_name.value = "", emergency_contact_last_name.value = "", emergency_contact_email.value = "", emergency_contact_phone.value = "";
        document.getElementById("six-storage-emergency-fields").style.display = "none";
        document.getElementById("six-storage-addemergencydetails").style.display = "none";
        var custom_fields_checkbox_containers = document.getElementsByClassName("six-storage-custom_input_fields_check_btn_emergencyContactDetails");

        if (typeof custom_fields_checkbox_containers !== 'undefined' && custom_fields_checkbox_containers !== null && custom_fields_checkbox_containers !== '') {
          Array.prototype.forEach.call(custom_fields_checkbox_containers, function (fieldContainer_check) {
            if (typeof fieldContainer_check !== 'undefined' && fieldContainer_check !== null && fieldContainer_check !== '') {
              var dataSet_value = fieldContainer_check.dataset.field_unitid;
              var check_button_type = fieldContainer_check.getElementsByClassName("".concat(dataSet_value));

              if (typeof check_button_type !== 'undefined' && check_button_type !== '' && check_button_type !== null) {
                for (var i = 0; i < check_button_type.length; i++) {
                  document.getElementById("".concat(check_button_type[i].id)).checked = false;
                }
              }
            }
          });
        }

        var custom_fields_radio_button_containers = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_emergencyContactDetails");

        if (typeof custom_fields_radio_button_containers !== 'undefined' && custom_fields_radio_button_containers !== null && custom_fields_radio_button_containers !== '') {
          Array.prototype.forEach.call(custom_fields_radio_button_containers, function (fieldContainer_radio) {
            if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
              var dataSet_value = fieldContainer_radio.dataset.field_unitid;
              var radios_button_type = fieldContainer_radio.getElementsByClassName("".concat(dataSet_value));

              if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                for (var i = 0; i < radios_button_type.length; i++) {
                  document.getElementById("".concat(radios_button_type[i].id)).checked = false;
                }
              }
            }
          });
        }

        var formInputFields = document.getElementsByClassName("six-storage-custom_input_fields_emergencyContactDetails");
        Array.prototype.forEach.call(formInputFields, function (field) {
          document.getElementById("".concat(field.id)).value = "";
        });
        var contactTable = document.getElementById("six-storage-emergencyContact-tbody");

        if (contactTable.children.length > 0) {
          document.getElementById("six-storage-emergency-details-list").style.display = "";
          document.getElementById("six-storage-emergency-add-more").style.display = "";
          document.getElementById("six-storage-emergency-err").style.display = "none";
        }

        document.getElementById("six-storage-emergency-err").style.display = "none";
      }
    }
  }, {
    key: "businessUser",
    value: function businessUser() {
      var checkBox = document.getElementById("business-user");
      var text = document.getElementById("six-storage-company-details");

      if (checkBox.checked == true) {
        text.style.display = "contents";
      } else {
        text.style.display = "none";
      }
    }
  }, {
    key: "sixStorageDeliveryAddressIsSame",
    value: function sixStorageDeliveryAddressIsSame() {
      var checkBox = document.getElementById("delivery-address-is-same-as-above");
      var text = document.getElementById("six-storage-deliveryaddress-1");

      if (checkBox.checked === true) {
        text.style.display = "none";
      } else {
        text.style.display = "";
      }
    }
  }, {
    key: "sixStorageFnTenantModal",
    value: function sixStorageFnTenantModal() {
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var signInModal = document.getElementById("six-storage-movein-modal");

      var instances = _materialize["default"].Modal.init(signInModal, {
        dismissible: false
      });

      var instance = _materialize["default"].Modal.getInstance(signInModal);

      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = "".concat(
      /*Please signup to create a new account or log in*/
      wordpress_vars.six_storage_online_fs_Please_signup_to_create);
      instance.open();
      signInModal.classList.remove("six-storage-Reservation-model");
      var overlay = document.getElementById("six-storage-overlay");
      modalBody.innerHTML = "<div class=\"six-storage-text-center six-storage-grid-pt0\" style=\"padding:30px;\">\n    <button type=\"button\" class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn six-storage-secondary-background-color six-storage-grid-pt15 six-storage-loginbtn six-storage-grid-m10\" onclick=\"sixStorageNewLoginModal();\">\n        <i class=\"six-storage-material-icons notranslate six-storage-userlogin\" aria-hidden=\"true\">person_outline</i> ".concat(
      /*Login*/
      wordpress_vars.six_storage_online_fs_Login, "\n        </button>\n        <button type=\"button\" class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn six-storage-primary-background-color six-storage-grid-pt15 six-storage-signupbtn six-storage-grid-m10\" onclick=\"sixStorageNewSignupModal();\">\n        <i class=\"six-storage-material-icons notranslate six-storage-userlogin\" aria-hidden=\"true\">person_add</i>").concat(
      /*Signup*/
      wordpress_vars.six_storage_online_fs_Signup, "\n        </button></div>");
    }
  }, {
    key: "sixStorageFnHideSignInModal",
    value: function sixStorageFnHideSignInModal() {
      var signInModal = document.getElementById("six-storage-movein-modal");

      var instance = _materialize["default"].Modal.getInstance(signInModal);

      instance.close();
    }
  }, {
    key: "sixStorageNewLoginModal",
    value: function sixStorageNewLoginModal() {
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = "".concat(
      /*Login*/
      wordpress_vars.six_storage_online_fs_Login);
      modalBody.innerHTML = "<form onsubmit=\"event.preventDefault()\" class=\"six-storage-grid-shadow-none cc six-storage-grid-p0 border-0\" id=\"six-storage-sign-in-form\" action=\"post\" autocomplete=\"off\">\n        <div class=\"six-storage-text-center\" style=\"display: none;position:relative;bottom:20px;\" id=\"six-storage-sign-in-response\"></div>\n        <div class=\"six-storage-form-row six-storage-grid-mb0 six-storage-grid-pb0\">\n            <div class=\"six-storage-col-md-12 \">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom cc\" autocomplete=\"none\" id=\"six-storage-username\" placeholder=\"".concat(
      /*User Name*/
      wordpress_vars.six_storage_online_fs_User_Name, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    <div style=\"display: none;\" id=\"six-storage-username-err\" class=\"six-storage-invalid-feedback\">\n                        ").concat(
      /*Please Enter User Name*/
      wordpress_vars.six_storage_online_fs_Please_Enter_User_Name, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col-md-12 \">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend\"><i class=\"six-storage-material-icons notranslate\">fingerprint</i></span>\n                    </div>\n                    <input type=\"password\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom cc\" autocomplete=\"none\" placeholder=\"").concat(
      /*Password*/
      wordpress_vars.six_storage_online_fs_Password, "\" id=\"six-storage-password\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    <a class=\"six-storage-waves-effect six-storage-btn-small six-storage-eye-icon-align six-storage-prefix six-storage-suffix six-storage-password-eye-align six-storage-grid-shadow-none six-storage-transparent\"><i class=\"six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grey-text\" toggle=\"six-storage-password\" onclick=\"return sixStorageTogglePasswordVisibility(this);\">remove_red_eye</i></a>\n                    <div style=\"display: none;\" id=\"six-storage-password-err\" class=\"six-storage-invalid-feedback\">\n                        ").concat(
      /*Please Enter Password*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Password, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col-md-12\">\n                <div id=\"six-storage-business_usr-err\" style=\"display: none;\" class=\"six-storage-invalid-feedback\">\n                ").concat(
      /*You have been registered as Business User with the above email*/
      wordpress_vars.six_storage_online_fs_You_have_been_registered, ".\n                </div>\n                <div id=\"six-storage-personal_usr-err\" style=\"display: none;\" class=\"six-storage-invalid-feedback\">\n                  ").concat(
      /*You have been registered as Personal user with the above email*/
      wordpress_vars.six_storage_online_fs_You_have_been_registered_the_above_email, ".\n                </div>\n            </div>\n        </div>\n        <div class=\"six-storage-grid-row six-storage-text-center six-storage-clearfix\">\n            <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-secondary-background-color  six-storage-signupsubmit-btn\" id=\"six-storage-sign-in-btn\" type=\"submit\" onclick=\"sixStorageTenantLogin();\"><span class=\"show-default\">").concat(
      /*Login*/
      wordpress_vars.six_storage_online_fs_Login, "</span></button>\n            <p class=\"six-storage-text-center six-storage-grid-mb0\"><a class=\"six-storage-grid-col-md-12 six-storage-modal-footer-text\" id=\"sign\" href=\"javascript:void(0)\" onclick=\"sixStorageNewSignupModal();\">").concat(
      /*Don’t have an account, click here to Signup*/
      wordpress_vars.six_storage_online_fs_Dont_have_account_click, "</a></p>\n            <p class=\"six-storage-text-center six-storage-grid-mb0\"><a class=\"six-storage-grid-col-md-12 six-storage-modal-footer-text\" id=\"six-storage-forgotpwd\" href=\"javascript:void(0)\" onclick=\"sixStorageForgotPasswordModal();\">").concat(
      /*Forgot Password*/
      wordpress_vars.six_storage_online_mi_Forgot_Password, "?</a></p>\n        </div>\n    </form>");
      document.getElementById("six-storage-username").value = "";
      document.getElementById("six-storage-password").value = "";

      _materialize["default"].updateTextFields();

      this.sixStorageAllInputHighlight();
      this.sixStorageHighlightInputLabel("six-storage-floating-input");
    }
  }, {
    key: "sixStorageConstructTenLeadSource",
    value: function sixStorageConstructTenLeadSource(data) {
      var _this41 = this;

      var html = "";
      data.forEach(function (item, index) {
        html += _this41.sixStorageConstructTenLeadSourceHtml(item, index);
      });
      return html;
    }
  }, {
    key: "sixStorageConstructTenLeadSourceHtml",
    value: function sixStorageConstructTenLeadSourceHtml(item, index) {
      var leadCategoryLabel = item.labelText;
      var sources = typeof item.sources !== 'undefined' && item.sources !== null && item.sources !== '' && item.sources.length > 0 ? item.sources.map(function (item, i) {
        return typeof item.id !== "undefined" && item.id !== null && item.id !== "" && typeof item.leadSource !== "undefined" && item.leadSource !== null && item.leadSource !== "" ? "<option value=\"".concat(item.id, "\">").concat(item.leadSource, "</option>") : '';
      }) : '';
      sources = typeof sources !== 'undefined' && sources !== null ? "".concat(sources.join('')) : '';
      var html = "<li class=\"cc\">\n      <div class=\"six-storage-collapsible-header cc six-storage-grey-text six-storage-text-darken-3 six-storage-font-weight-bold six-storage-justify-content-between six-storage-align-items-center six-storage-grey six-storage-lighten-5 grid-mb0\">".concat(leadCategoryLabel, "<svg width=\"1.5em\"  height=\"1.5em\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/>\n  </svg></div>\n      <div class=\"six-storage-collapsible-body cc\" id=\"six-storage-collapsible-body\">\n      <select id=\"\" autocomplete=\"off\" class=\"cc selectedvtwoLeadsource\" onchange=\"sixStorageStorageTenSelectedLead(event);\">\n      <option value=\"\" disabled selected>").concat(
      /*Select*/
      wordpress_vars.six_storage_online_fs_Select, "</option>\n      ").concat(sources, "\n    </select>\n      </div>\n    </li>");
      return html;
    }
  }, {
    key: "sixStorageConstructLeadSource",
    value: function sixStorageConstructLeadSource(data) {
      var _this42 = this;

      var html = "";
      data.forEach(function (item, index) {
        html += _this42.sixStorageConstructLeadSourceHtml(item, index);
      });
      return html;
    }
  }, {
    key: "sixStorageConstructLeadSourceHtml",
    value: function sixStorageConstructLeadSourceHtml(item, index) {
      var leadCategoryLabel = item.labelText;
      var sources = typeof item.sources !== 'undefined' && item.sources !== null && item.sources !== '' && item.sources.length > 0 ? item.sources.map(function (item, i) {
        return typeof item.id !== "undefined" && item.id !== null && item.id !== "" && typeof item.leadSource !== "undefined" && item.leadSource !== null && item.leadSource !== "" ? "<option value=\"".concat(item.id, "\">").concat(item.leadSource, "</option>") : '';
      }) : '';
      sources = typeof sources !== 'undefined' && sources !== null ? "".concat(sources.join('')) : '';
      var html = "<li class=\"cc\">\n      <div class=\"six-storage-collapsible-header cc six-storage-grey-text six-storage-text-darken-3  six-storage-justify-content-between six-storage-align-items-center six-storage-grey six-storage-lighten-5 grid-mb0\">".concat(leadCategoryLabel, "<svg width=\"1em\"  height=\"1em\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\"/>\n  </svg></div>\n      <div class=\"six-storage-collapsible-body cc\" id=\"six-storage-collapsible-body\">\n          <select id=\"\" class=\"cc selectedvtwoLeadsource\" onchange=\"sixStorageStorageSelectedLead(event);\">\n            <option value=\"\" disabled selected>").concat(
      /*Select*/
      wordpress_vars.six_storage_online_fs_Select, "</option>\n            ").concat(sources, "\n          </select>\n      </div>\n    </li>");
      return html;
    }
  }, {
    key: "sixStorageStorageTenSelectedLead",
    value: function sixStorageStorageTenSelectedLead(event) {
      document.getElementById('six_storage_lead_sourcetext').disabled = false;
      document.getElementById('six_storage_lead_sourceaccord').style.display = 'none';
      document.getElementById('six_storage_lead_sourcetext').value = event.target.selectedOptions[0].innerHTML;
      document.getElementById('six_storage_lead_source').value = event.target.value;
    }
  }, {
    key: "sixStorageStorageSelectedLead",
    value: function sixStorageStorageSelectedLead(event) {
      document.getElementById('six-storage-Enqleadsourcetext').disabled = false;
      document.getElementById('six-storage-enquiryLeadaccord').style.display = 'none';
      document.getElementById('six-storage-Enqleadsourcetext').value = event.target.selectedOptions[0].innerHTML;
      document.getElementById('six-storage-Enqleadsource').value = event.target.value;
    }
  }, {
    key: "sixStorageNewEnquiryModal",
    value: function sixStorageNewEnquiryModal(unitTypeId) {
      document.getElementById('six-storage-rent-now-err').style.display = 'none';
      document.getElementById("six-storage-movein-modal").classList.remove("six-storage-sm");
      var enquiryModal = document.getElementById("six-storage-movein-modal");

      var instancess = _materialize["default"].Modal.init(enquiryModal, {
        dismissible: false
      });

      var instance = _materialize["default"].Modal.getInstance(enquiryModal);

      instance.open();
      var sessionObj = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var leadoptions = sessionObj.leadSources;
      var smsconfig = sessionObj.smsConfigured;
      var leadObj = JSON.parse(sessionStorage.getItem("sixStorageleadConfig"));
      var leadsourcehtml = this.sixStorageConstructLeadSource(leadObj);
      var smsCheck = smsconfig !== 'undefined' && smsconfig !== null && smsconfig !== false && smsconfig !== undefined && smsconfig !== "" ? "display:block;" : "display:none;";
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = "".concat(
      /*Inquire Now*/
      wordpress_vars.six_storage_online_mi_Inquiry_Now);
      modalBody.innerHTML = "\n    <form onsubmit=\"event.preventDefault()\" class=\"six-storage-grid-p0 cc six-storage-grid-shadow-none six-storage-form-sign-up-modal six-storage-grid-w-100 six-storage-mx-auto\" id =\"six-storage-enquiry-form\" action = \"post\" autocomplete=\"off\">\n      <div class=\"six-storage-col-md-12\">\n        <div class=\"six-storage-col six-storage-l6 six-storage-m6 six-storage-s12\"> <div id=\"six-storage-selected-units-contianer\" class=\"six-storage-grid-d-flex six-storage-flex-wrap\"></div></div>\n          <div class=\"six-storage-form-row six-storage-row cc six-storage-grid-pb0  six-storage-grid-mb0\">\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n              <div class=\"six-storage-grid-input-group  six-storage-required\">\n                <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                  <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                </div>\n                <input type=\"text\" class=\"cc six-storage-floating-input six-storage-grid-form-control six-storage-border0 \" autocomplete=\"none\" id=\"six-storage-EnqfirstName\" tabindex=\"1\" placeholder=\"".concat(
      /*First Name*/
      wordpress_vars.six_storage_online_fs_First_Name, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                <div style=\"display: none;\" id=\"six-storage-EnqfirstName-err\" class=\"six-storage-font-size-14 six-storage-grid-mt0 six-storage-invalid-feedback\">\n                  ").concat(
      /*Please Enter First Name*/
      wordpress_vars.six_storage_online_fs_Please_Enter_First_Name, "\n                </div>\n              </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n              <div class=\"six-storage-grid-input-group  six-storage-required\">\n                <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                  <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                </div>\n                <input type=\"text\" class=\"cc six-storage-floating-input six-storage-grid-form-control six-storage-border0 \" autocomplete=\"none\" id=\"six-storage-EnqlastName\" tabindex=\"2\" placeholder=\"").concat(
      /*Last Name*/
      wordpress_vars.six_storage_online_fs_Last_Name, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                <div style=\"display: none;\" id= \"six-storage-EnqlastName-err\" class=\"six-storage-invalid-feedback\">\n                  ").concat(
      /*Please Enter Last Name*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Last_Name, "\n                </div>\n              </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n              <div class=\"six-storage-grid-input-group  six-storage-required \">\n                <div class=\"six-storage-flex-nowrap six-storage-grid-d-flex\">\n                  <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                    <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">phone</i></span>\n                  </div>\n                  <input type=\"tel\" maxlength=\"15\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 six-storage-telephone\" autocomplete=\"none\" id=\"six-storage-Enqphone\" tabindex=\"4\" placeholder=\"").concat(
      /*Phone*/
      wordpress_vars.six_storage_online_fs_Phone, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                </div>\n                <div style=\"display: none;\" id=\"six-storage-Enqphone-err\" class=\"six-storage-invalid-feedback\">\n                  ").concat(
      /*Please Enter Phone Number*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Phone_Number, "\n                </div>\n              </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n              <div class=\"six-storage-grid-input-group  six-storage-required\">\n                <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                  <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">email</i></span>\n                </div>\n                <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-Enqemail\" tabindex=\"4\" placeholder=\"").concat(
      /*Email*/
      wordpress_vars.six_storage_online_fs_Email, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                <div style=\"display: none;\" id=\"six-storage-Enqemail-err\" class=\" six-storage-grid-mt0 six-storage-invalid-feedback\">\n                  ").concat(
      /*Please Enter Email*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Email, "\n                </div>\n              </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six-storage-grid-mt10 six-storage-grid-pl15\">\n              <div class=\"six-storage-input-field cc six-storage-leadsource-alignment\">\n                <label class=\"six-storage-active cc\">").concat(
      /*How do you know about us*/
      wordpress_vars.six_storage_online_mi_How_do_you_know_about_us, "</label>\n                <div class=\"six-storage-flex-grow-1 six-storage-row cc six-storage-grid-pl0\">\n                  <div class=\"six-storage-col six-storage-s12 six-storage-m6 cc six-storage-grid-pl0\" id=\"six-storage-lead-div\">\n                    <input class=\"six-storage-file-path six-storage-validate cc\" id=\"six-storage-Enqleadsourcetext\" onfocus=\"sixStorageLoadLeadSource()\" type=\"text\" />\n                    <i class=\"six-storage-material-icons six-storage-tiny six-storage-leadv2iconmodal six-storage-leadinquiry\">arrow_drop_down</i>\n                    <input type=\"hidden\" id=\"six-storage-Enqleadsource\" />\n                    <div class=\"six-storage-unit-accordion six-storage-grid-w-100 six-storage-col six-storage-s12 six-storage-m12 six-storage-l12 cc six-storage-custom-scroller\" id=\"six-storage-enquiryLeadaccord\" style=\"display:none\">\n                      <ul class=\"six-storage-collapsible cc six-storage-custom-scroller six-storage-enquiryLeadaccord six-storage-addon-collapsible\">\n                      ").concat(leadsourcehtml, "\n                      </ul>\n                    </div>\n                  <div style=\"display: none;\" id=\"six-storage-Enqleadsource-err\" class=\"six-storage-invalid-feedback-contact-email\">\n                    ").concat(
      /*Please Select Lead Source*/
      wordpress_vars.six_storage_online_fs_Please_Select_Lead_Source, "\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-row cc\">\n            <div class=\"six-storage-col six-storage-s12 six-storage-m12\">\n              <p class=\"six-storage-six-storage-font-size-15 cc six-storage-text-center\"><b> ").concat(
      /*Contact Preference*/
      wordpress_vars.six_storage_online_fs_Contact_Preference, " </b></p>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six-storage-grid-pl15 six-storage-mobile-margin-bottom\">\n              <div class=\"six-storage-row cc\">\n                <div class=\"six-storage-col six-storage-s12 six-storage-m6 six-storage-grid-pl15 six-storage-mobile-margin-bottom\">\n                  <p class=\"six-storage-contact-through-label cc\">").concat(
      /*Contact Through*/
      wordpress_vars.six_storage_online_fs_Contact_Through, "</p>\n                  <div class=\"six-storage-contact-through-label-div\">\n                    <p class=\"six-storage-grid-mb0\">\n                      <label class=\"six-storage-contact-through\">\n                        <input type=\"checkbox\" value=\"EMAIL\" name=\"contactType\" class=\"cc\" id=\"six-storage-leadsourceEmail\" />\n                        <span style=\"white-space:nowrap\">").concat(
      /*Email*/
      wordpress_vars.six_storage_online_fs_Email, "</span>\n                      </label>\n                    </p>\n                  </div>\n                </div>\n                <div class=\"six-storage-col six-storage-s12 six-storage-m6\" style=\"").concat(smsCheck, "\">\n                  <p class=\"six-storage-grid-mb0\">\n                    <label>\n                      <input type=\"checkbox\" value=\"SMS\" name=\"contactType\" class=\"cc six-storage-input-field\" id=\"six-storage-leadsourceSms\" />\n                      <span>").concat(
      /*SMS*/
      wordpress_vars.six_storage_online_fs_SMS, "</span>\n                    </label>\n                  </p>\n                </div>\n                <div class=\"six-storage-col six-storage-s12 six-storage-m12\">\n                  <div class=\"sixstorageontactPreferencesData\">\n                    <div style=\"display: none;\" id=\"six-storage-ContactPreference-err\" class=\"six-storage-invalid-feedback-contact-email\">").concat(
      /*Please Select Contact Prefernce*/
      wordpress_vars.six_storage_online_mi_Please_Select_Contact_Prefernce, "</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6\">\n              <div class=\"six-storage-row\">\n                <div class=\"six-storage-input-field six-storage-col six-storage-s12 cc\">\n                  <i class=\"six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text\">date_range</i>\n                  <input class=\"cc six-storage-date-control-contact-date\" id=\"six-storage-dtcontactdate\" type=\"text\" readonly=\"readonly\" placeholder=\"").concat(this.helper.dateFormat, "\"/>\n                  <label class=\"six-storage-active\">").concat(
      /*Contact Me On*/
      wordpress_vars.six_storage_online_fs_Contact_Me_On, "</label>\n                  <div style=\"display: none;\" id=\"dtcontactdate-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Select Contact Me On Date*/
      wordpress_vars.six_storage_online_fs_Please_Select_Contact_Me, "</div>\n                </div>\n              </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m12\">\n              <div class=\"six-storage-input-field cc\">\n                <i class=\"six-storage-material-icons notranslate six-storage-prefix six-storage-secondary-text\">insert_comment</i>\n                <input type=\"text\" class=\"cc\" id=\"six-storage-Leadsourcecomment\" tabindex=\"5\" aria-describedby=\"six-storage-inputGroupPrepend\" autocomplete=\"none\"/>\n                <label  for=\"six-storage-Leadsourcecomment\">").concat(
      /*Comment*/
      wordpress_vars.six_storage_online_fs_Comment, "</label>\n                <div style=\"display: none;\" id=\"six-storage-Leadsourcecomment-err\" class=\"six-storage-invalid-feedback\">\n                  ").concat(
      /*Please Enter Comment*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Comment, "\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"six-storage-text-center six-storage-clearfix\">\n          <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background six-storage-signupsubmit-btn six-storage-grid-mb10 six-storage-white-text\" id=\"six-storage-enquiry-submit-btn\" tabindex=\"6\" type=\"submit\" onclick=\"sixStorageEnquiry('").concat(unitTypeId, "');\" >\n            ").concat(
      /*Submit*/
      wordpress_vars.six_storage_online_fs_Submit, "\n          </button>\n        </div>\n        <div style=\"padding: 10px 6px; margin:10px 0; border:solid 1px #cdcdcd;text-align: center; display: none;\" id=\"six-storage-enquiry-response\"></div>\n        </div>\n      </div>\n    </form>");
      var elems = document.querySelectorAll('select');

      _materialize["default"].FormSelect.init(elems);

      var pos = document.querySelectorAll('.six-storage-collapsible');

      _materialize["default"].Collapsible.init(pos);

      document.getElementById("six-storage-enquiry-form").addEventListener('keypress', function (event) {
        if (event.code === "Space" && (event.target.value === undefined || event.target.value === null || event.target.value === "")) {
          event.preventDefault();
        }
      });
      window.addEventListener('click', function (e) {
        var leadDiv = document.getElementById('six-storage-lead-div');

        if (typeof leadDiv !== 'undefined' && leadDiv !== null && leadDiv !== '') {
          if (document.getElementById('six-storage-lead-div').contains(e.target)) {
            document.getElementById('six-storage-enquiryLeadaccord').style.display = 'block';
          } else {
            document.getElementById('six-storage-enquiryLeadaccord').style.display = 'none';
          }
        }
      });
      var date = new Date();
      var contactDate = this.sixStorageInitDatepickerClassname("six-storage-date-control-contact-date", new Date("".concat(date.getFullYear() - 60, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())));
      this.sixStorageInitDatepicker("#six-storage-dtcontactdate", date, contactDate, null, date);
      this.sixStorageHighlightInputLabel("six-storage-date-control-contact-date");
      var enqphone = document.getElementById("six-storage-Enqphone");
      enqphone.oninput = this.helper.sixStorageCheckPhoneNumber;

      _materialize["default"].updateTextFields();

      this.sixStorageAllInputHighlight();
      this.sixStorageHighlightInputLabel("six-storage-floating-input");
      this.helper.sixStorageInitTelephoneNumber("#six-storage-Enqphone");
    }
  }, {
    key: "sixStorageLoadLeadSource",
    value: function sixStorageLoadLeadSource() {
      document.getElementById('six-storage-Enqleadsourcetext').disabled = true;
      document.getElementById('six-storage-enquiryLeadaccord').style.display = 'block';
    }
  }, {
    key: "sixStorageTenLoadLeadSource",
    value: function sixStorageTenLoadLeadSource() {
      document.getElementById('six_storage_lead_sourcetext').disabled = true;
      document.getElementById('six_storage_lead_sourceaccord').style.display = 'block';
    }
  }, {
    key: "sixStorageNewReservationModal",
    value: function sixStorageNewReservationModal(data) {
      var _this43 = this;

      if (typeof data === "undefined" || data === null) {
        return "";
      }

      var unitInfo = data.unitsInfo;
      var reservationCharge = typeof unitInfo !== null && unitInfo !== 'undefined' && unitInfo.length > 0 ? unitInfo.map(function (item, i) {
        return "<tr class=\"cc\"><td class=\"cc\"><span class=\"six-storage-grey-text six-storage-text-darken-3\">".concat(
        /*Reservation Fee*/
        wordpress_vars.six_storage_online_reservation_fee_modal, " </span> </td><td class=\"cc\"><span>").concat(_this43.helper.sixStorageDisplayCurrency(item.reservationFee), "</span></td></tr>");
      }) : "";
      reservationCharge = typeof reservationCharge !== 'undefined' && reservationCharge !== null ? "".concat(reservationCharge.join('')) : "";
      var unitdetails = typeof unitInfo !== null && unitInfo !== 'undefined' && unitInfo.length > 0 ? unitInfo.map(function (item, i) {
        return "<tr class=\"cc\"><td class=\"cc\"><span class=\"six-storage-grey-text six-storage-text-darken-3\">".concat(item.unitNumber, " (").concat(item.unitType.name, ") ").concat(
        /*Rental Price*/
        wordpress_vars.six_storage_rental_Price, "</span> </td><td><span>").concat(_this43.helper.sixStorageDisplayCurrency(item.unitPrice), "</span></td></tr>");
      }) : "";
      unitdetails = typeof unitdetails !== 'undefined' && unitdetails !== null ? "".concat(unitdetails.join('')) : "";
      var preferedUnitTypeName = typeof unitInfo !== null && unitInfo !== 'undefined' && unitInfo.length > 0 ? unitInfo.map(function (item, i) {
        return typeof item.unitType.name !== 'undefined' && item.unitType.name !== null && item.unitType.name !== '' ? "(".concat(item.unitType.name, ")") : "";
      }) : "";
      var preferedunit = typeof unitInfo !== null && unitInfo !== 'undefined' && unitInfo.length > 0 ? unitInfo.map(function (item, i) {
        return "".concat(item.unitNumber, " ").concat(preferedUnitTypeName, " ");
      }) : "";
      var netAmount = typeof data.netAmount !== "undefined" && data.netAmount !== null ? data.netAmount : "";
      var grossAmount = typeof data.grossAmount !== "undefined" && data.grossAmount !== null ? data.grossAmount : "";
      var taxAmount = typeof data.taxAmount !== "undefined" && data.taxAmount !== null ? data.taxAmount : "";
      var taxPercentage = typeof data.taxPercentage !== "undefined" && data.taxPercentage !== null ? data.taxPercentage : "";
      var unitdetailinfo = {
        unitsInfo: unitInfo,
        netAmount: netAmount,
        grossAmount: grossAmount,
        taxAmount: taxAmount,
        taxPercentage: taxPercentage
      };
      this.unitinfoDetails = unitdetailinfo;
      sessionStorage.setItem("unitInfodetails", JSON.stringify(this.unitinfoDetails));
      var taxamount = typeof taxAmount !== 'undefined' && taxAmount !== null && taxAmount !== "" && taxAmount > 0 ? "<td class=\"cc\"><span class=\"six-storage-grey-text six-storage-text-darken-3\">".concat(
      /*Tax*/
      wordpress_vars.six_storage_online_fs_Tax, " (").concat(taxPercentage, "%) </span></td><td class=\"cc\"><span>").concat(this.helper.sixStorageDisplayCurrency(taxAmount), "</span></td>") : "";
      var enquiryModal = document.getElementById("six-storage-movein-modal");

      _materialize["default"].Modal.init(enquiryModal, {
        dismissible: false
      });

      var instance = _materialize["default"].Modal.getInstance(enquiryModal);

      instance.open();
      enquiryModal.classList.add("six-storage-Reservation-model");
      var sessionObj = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var leadoptions = sessionObj.leadSources;
      var leadsourcevtwohtml = "";
      var leadObj = JSON.parse(sessionStorage.getItem("sixStorageleadConfig"));
      leadsourcevtwohtml = this.sixStorageConstructLeadSource(leadObj);
      var smsconfig = sessionObj.smsConfigured;
      var smsCheck = smsconfig !== 'undefined' && smsconfig !== null && smsconfig !== false && smsconfig !== undefined && smsconfig !== "" ? "display:block;" : "display:none;";
      var reservationCharges = typeof grossAmount !== null && grossAmount !== 'undefined' && grossAmount !== "" && grossAmount !== 0 ? "<div class=\"six-storage-col six-storage-s12 six-storage-m12 six-storage-grid-mt30 six-storage-grid-mb30 six-storage-reservationContent\">\n        <table class=\"six-storage-grid-table cc six-storage-grid-bg-light six-storage-grid-shadow-sm\">\n          <thead>\n            <tr class=\"cc\">\n              <th colspan=\"2\" class=\"cc six-storage-grey-text six-storage-grey six-storage-lighten-2 six-storage-text-darken-3\">".concat(
      /*Reservation Charges*/
      wordpress_vars.six_storage_online_fs_Reservation_Charges, "</th>\n            </tr>\n          </thead>\n          <tbody>\n            ").concat(unitdetails, "\n            ").concat(reservationCharge, "\n            <tr class=\"cc\">\n              ").concat(taxamount, "\n            </tr>\n            <tr class=\"cc\">\n              <td class=\"cc\"><span><b> ").concat(
      /*Total Payable*/
      wordpress_vars.six_storage_online_fs_Total_Payable, " </span> </b></td>\n              <td class=\"cc\"><span><b> ").concat(this.helper.sixStorageDisplayCurrency(grossAmount), "</span> </b> </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>") : "";
      document.getElementById("six-storage-movein-modal").classList.remove("six-storage-sm");
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = "".concat(
      /*Reserve Unit*/
      wordpress_vars.six_storage_online_fs_Reserve_Units);
      modalBody.innerHTML = "\n    <form onsubmit=\"event.preventDefault()\" class=\"six-storage-grid-p0 cc six-storage-grid-shadow-none six-storage-form-sign-up-modal six-storage-grid-w-100 six-storage-mx-auto\" id=\"six-storage-reservation-form\" action = \"post\" autocomplete=\"off\">\n      <div class=\"six-storage-form-row cc six-storage-grid-pb0  six-storage-grid-mb0\">\n        <div class=\"six-storage-row cc six-storage-reservation-tenant-details\">\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-input-field cc six-storage-grid-mb0\">\n              <input type=\"text\" class=\"six-storage-floating-input cc six-storage-grid-m0\" disabled value=\"".concat(preferedunit, "\"/>\n              <label  style=\"font-size: 15px;top:0\">").concat(
      /*Prefered Unit*/
      wordpress_vars.six_storage_online_fs_Prefered_Unit, "</label>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-input-field cc six-storage-grid-mb0\">\n              <i class=\"six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text\">date_range</i>\n              <input class=\"cc six-storage-date-control-contact-date\" id=\"six-storage-dtPreferredmoveindate\" type=\"text\" readonly=\"readonly\" placeholder=\"").concat(this.helper.sixStorageDisplayDate(), "\"/>\n              <label class=\"six-storage-active\">").concat(
      /*Prefered Movein Date*/
      wordpress_vars.six_storage_online_fs_Prefered_Movein_Date, "</label>\n              <div style=\"display: none;\" id=\"six-storage-dtPreferredmoveindate-err\" class=\"six-storage-date-feedback-msg six-storage-invalid-feedback\">").concat(
      /*Please Select Prefered Movein Date*/
      wordpress_vars.six_storage_online_fs_Please_Select_Prefered, "</div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required\">\n              <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n              </div>\n              <input type=\"text\" class=\"cc six-storage-floating-input six-storage-grid-form-control six-storage-border0 \" autocomplete=\"none\" id=\"six-storage-reservationfirstName\" tabindex=\"1\" placeholder=\" ").concat(
      /* First Name*/
      wordpress_vars.six_storage_online_fs_sf_first_name_custom_word, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n              <div style=\"display: none;\" id=\"six-storage-reservationfirstName-err\" class=\"six-storage-invalid-feedback\">\n              ").concat(
      /*Please Enter First Name*/
      wordpress_vars.six_storage_online_fs_Please_Enter_First_Name, "\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required\">\n                <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                    <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                </div>\n                <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-reservationlastName\" tabindex=\"2\" placeholder=\"").concat(
      /*Last Name*/
      wordpress_vars.six_storage_online_fs_Last_Name, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                <div style=\"display: none;\" id= \"six-storage-reservationlastName-err\" class=\"six-storage-invalid-feedback\">\n                  ").concat(
      /*Please Enter Last Name*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Last_Name, "\n                </div>\n            </div>     \n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required \">\n              <div class=\"six-storage-flex-nowrap six-storage-grid-d-flex\">\n                <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                  <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">phone</i></span>\n                </div>\n                <input type=\"tel\" maxlength=\"15\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 six-storage-telephone\" autocomplete=\"none\" id=\"six-storage-reservationphone\" tabindex=\"3\" placeholder=\"").concat(
      /*Phone*/
      wordpress_vars.six_storage_online_fs_Phone, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n              </div>\n              <div style=\"display: none;\" id=\"six-storage-reservationphone-err\" class=\"six-storage-invalid-feedback\">\n                ").concat(
      /*Please Enter Phone Number*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Phone_Number, "\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required\">\n              <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">email</i></span>\n              </div>\n              <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-reservationemail\" tabindex=\"3\" placeholder=\"").concat(
      /*Email*/
      wordpress_vars.six_storage_online_fs_Email, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n              <div style=\"display: none;\" id=\"six-storage-reservationemail-err\" class=\"six-storage-invalid-feedback\" style=\"margin:0;\">\n                ").concat(
      /*Please Enter Email*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Email, "\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required\">\n              <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">home</i></span>\n              </div>\n              <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-reservationAddress\" tabindex=\"4\" placeholder=\"").concat(
      /*Address*/
      wordpress_vars.six_storage_online_fs_Address, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n              <div style=\"display: none;\" id=\"six-storage-reservationAddress-err\" class=\"six-storage-invalid-feedback\">\n                ").concat(
      /*Please Enter Address*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Address, "\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required\">\n              <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">location_city</i></span>\n              </div>\n              <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-reservationCity\" tabindex=\"5\" placeholder=\"").concat(
      /*City*/
      wordpress_vars.six_storage_online_fs_City, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n              <div style=\"display: none;\" id=\"six-storage-reservationCity-err\" class=\"six-storage-invalid-feedback\">\n                ").concat(
      /*Please Enter City*/
      wordpress_vars.six_storage_online_fs_Please_Enter_City, "\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required\">\n              <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">location_on</i></span>\n              </div>\n              <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-reservationCountry\" tabindex=\"5\" placeholder=\"").concat(
      /*Country*/
      wordpress_vars.six_storage_online_fs_Country, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n              <div style=\"display: none;\" id=\"six-storage-reservationCountry-err\" class=\"six-storage-invalid-feedback\">\n                ").concat(
      /*Please Enter Country*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Country, "\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n            <div class=\"six-storage-grid-input-group  six-storage-required\">\n              <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">fiber_pin</i></span>\n              </div>\n              <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-reservationZipcode\" tabindex=\"5\" placeholder=\"").concat(
      /*Zipcode*/
      wordpress_vars.six_storage_online_fs_Zipcode, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n              <div style=\"display: none;\" id=\"six-storage-reservationZipcode-err\" class=\"six-storage-invalid-feedback\">\n                ").concat(
      /*Please Enter Zipcode*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Zipcode, "\n              </div>\n            </div>\n          </div>\n        </div> \n        <div class=\"six-storage-row cc\">\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six-storage-grid-mt20 six-storage-grid-pl15\">\n            <div class=\"six-storage-input-field cc six-storage-leadsource-alignment\" data-element_required=\"true\">\n              <label class=\"cc six-storage-active\">").concat(
      /*How do you know about us*/
      wordpress_vars.six_storage_online_mi_How_do_you_know_about_us, " &nbsp </label>\n              <div class=\"six-storage-flex-grow-1 six-storage-row cc six-storage-grid-pl0\">\n                <div class=\"six-storage-col six-storage-s12 six-storage-m6 six-storage-l6 cc six-storage-grid-pl0\" id=\"six-storage-lead-div\">\n                  <input class=\"six-storage-file-path six-storage-validate cc six-storage-grid-mb0\" id=\"six-storage-Enqleadsourcetext\" onfocus=\"sixStorageLoadLeadSource()\" type=\"text\" />\n                  <i class=\"six-storage-material-icons six-storage-tiny six-storage-leadv2iconmodal six-storage-reserve-dropdown-icon\">arrow_drop_down</i>\n                  <div style=\"display: none;\" id=\"six-storage-reservationleadsource-err\" class=\"six-storage-invalid-feedback-contact-email\">\n                    ").concat(
      /*Please Select Lead Source*/
      wordpress_vars.six_storage_online_fs_Please_Select_Lead_Source, "\n                  </div>\n                  <input type=\"hidden\" id=\"six-storage-Enqleadsource\" /><div class=\"six-storage-unit-accordion six-storage-grid-w-100 six-storage-col six-storage-s12 six-storage-m12 six-storage-l12 cc six-storage-custom-scroller\" id=\"six-storage-enquiryLeadaccord\" style=\"display:none \">\n                  <ul class=\"six-storage-collapsible cc six-storage-enquiryLeadaccord six-storage-custom-scroller six-storage-addon-collapsible\">\n                    ").concat(leadsourcevtwohtml, "\n                  </ul> \n                </div>\n              </div>\n            </div>\n            </div>\n          </div>\n          ").concat(reservationCharges, "\n          <div class=\"six-storage-col six-storage-s12 six-storage-m12\">\n            <p class=\"six-storage-six-storage-font-size-15 cc six-storage-text-center\"><b> ").concat(
      /*Contact Preference*/
      wordpress_vars.six_storage_online_fs_Contact_Preference, " </b></p>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6 six-storage-grid-pl15 six-storage-mobile-margin-bottom\">\n            <div class=\"six-storage-row cc\">\n              <div class=\"six-storage-col six-storage-s12 six-storage-m6 six-storage-grid-pl15 six-storage-mobile-margin-bottom\">\n                <p class=\"cc six-storage-contact-through-label\">").concat(
      /*Contact Through*/
      wordpress_vars.six_storage_online_fs_Contact_Through, "</p>\n                <div class=\"six-storage-contact-through-label-div\">\n                  <p class=\"six-storage-grid-mb0\">\n                    <label class=\"six-storage-contact-through\">\n                      <input type=\"checkbox\" value=\"EMAIL\" name=\"six-storage-contactTypeName\" class=\"cc\" id=\"reservationsourceEmail\" />\n                      <span style=\"white-space:nowrap\">").concat(
      /*Email*/
      wordpress_vars.six_storage_online_fs_Email, "</span>\n                    </label>\n                  </p>\n                </div>\n              </div>\n              <div class=\"six-storage-col six-storage-s12 six-storage-m6\" style=\"").concat(smsCheck, "\">\n                <p class=\"six-storage-grid-mb0\">\n                  <label>\n                    <input type=\"checkbox\" value=\"SMS\" name=\"six-storage-contactTypeName\" class=\"cc\" id=\"reservationsourceSms\" />\n                    <span>").concat(
      /*SMS*/
      wordpress_vars.six_storage_online_fs_SMS, "</span>\n                  </label>\n                </p>\n              </div>\n              <div class=\"six-storage-col six-storage-s12 six-storage-m12\">\n                <div class=\"sixstorageontactPreferencesData\">\n                  <div style=\"display: none;\" id=\"six-storage-contactPreferencesData-err\" class=\"six-storage-invalid-feedback-contact-email\">").concat(
      /*Please Select Contact Prefernce*/
      wordpress_vars.six_storage_online_mi_Please_Select_Contact_Prefernce, "</div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m6\">\n            <div class=\"six-storage-row\">\n              <div class=\"six-storage-input-field six-storage-col six-storage-s12 cc\">\n                <i class=\"six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text\">date_range</i>\n                <input class=\"cc six-storage-date-control-contact-date\" id=\"six-storage-dtreservecontactdate\" tabindex=\"10\" type=\"text\" readonly=\"readonly\" placeholder=\"").concat(this.helper.dateFormat, "\"/>\n                <label class=\" six-storage-active\">").concat(
      /*Contact Me On*/
      wordpress_vars.six_storage_online_fs_Contact_Me_On, "</label>\n                <div style=\"display: none;\" id=\"six-storage-dtreservecontactdate-err\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Select Contact Me On Date*/
      wordpress_vars.six_storage_online_fs_Please_Select_Contact_Me, "</div>\n              </div>\n            </div>\n          </div>\n          <div class=\"six-storage-col six-storage-s12 six-storage-m12\">\n            <div class=\"six-storage-input-field cc\">\n              <i class=\"six-storage-material-icons notranslate six-storage-prefix six-storage-secondary-text\">insert_comment</i>\n              <input type=\"text\" class=\"cc\" id=\"six-storage-reservationsourcecomment\" tabindex=\"11\" aria-describedby=\"six-storage-inputGroupPrepend\" autocomplete=\"none\"/>\n              <label class=\"\" for=\"six-storage-reservationsourcecomment\">").concat(
      /*Comment*/
      wordpress_vars.six_storage_online_fs_Comment, "</label>\n              <div style=\"display: none;\" id=\"six-storage-reservationsourcecomment-err\" class=\"six-storage-invalid-feedback\">\n                ").concat(
      /*Please Enter Comment*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Comment, "\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n    <div class=\"six-storage-text-center six-storage-clearfix\">\n      <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background six-storage-signupsubmit-btn six-storage-grid-mb10 six-storage-white-text\" id=\"six-storage-reserve-pay-btn\" onclick =\"sixStorageReservationPaymentForm()\" tabindex=\"12\" type=\"submit\">\n        ").concat(
      /*Reserve Unit*/
      wordpress_vars.six_storage_online_fs_Reserve_Units, "\n      </button>\n    </div>\n    <div class=\"six-storage-col six-storage-l12 six-storage-s12 six-storage-grid-p0 cc\" id=\"six-storage-creditgrid-card-payment\">\n      <div class=\"six-storage-payment-form\" id=\"six-storage-reservationpaymentform\" style=\"display:none;\">\n      </div>\n    </div>\n    <div style=\"padding: 10px 6px; margin:10px 0; border:solid 1px #cdcdcd;text-align: center; display: none;\" id=\"reservation-response\"></div>\n    </div>");
      var res = document.querySelectorAll('.six-storage-dropdown-trigger');

      var instances = _materialize["default"].Dropdown.init(res, {
        closeOnClick: false
      });

      var elems = document.querySelectorAll('select');

      var instances = _materialize["default"].FormSelect.init(elems);

      var pos = document.querySelectorAll('.six-storage-collapsible');

      var instances = _materialize["default"].Collapsible.init(pos);

      document.getElementById("six-storage-reservation-form").addEventListener('keypress', function (event) {
        if (event.code === "Space" && (event.target.value === undefined || event.target.value === null || event.target.value === "")) {
          event.preventDefault();
        }
      });
      document.getElementById("six-storage-reservation-form").addEventListener('change', function (event) {
        document.getElementById("six-storage-reservationpaymentform").style.display = "none";
        document.getElementById("six-storage-reserve-pay-btn").style.display = "";
      });
      var date = new Date();
      var contactdate = this.sixStorageInitDatepickerClassname("six-storage-date-control-contact-date", new Date("".concat(date.getFullYear() - 60, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())));

      function addDays(days) {
        var result = new Date();
        result.setDate(result.getDate() + parseInt(days - 1));
        return result;
      } // let moveInSettingDate = typeof wordpress_vars.six_storage_online_fc_moveindate_custom_word !== 'undefined' && wordpress_vars.six_storage_online_fc_moveindate_custom_word !== ''
      //   && wordpress_vars.six_storage_online_fc_moveindate_custom_word !== null && wordpress_vars.six_storage_online_fc_moveindate_custom_word > 0 ?
      //   wordpress_vars.six_storage_online_fc_moveindate_custom_word : 30;


      var moveInAfter = typeof wordpress_vars.six_storage_online_fc_move_in_after !== 'undefined' && wordpress_vars.six_storage_online_fc_move_in_after !== '' && wordpress_vars.six_storage_online_fc_move_in_after !== null && wordpress_vars.six_storage_online_fc_move_in_after > 0 ? wordpress_vars.six_storage_online_fc_move_in_after : 1;
      var moveInUpto = typeof wordpress_vars.six_storage_online_fc_move_in_upto !== 'undefined' && wordpress_vars.six_storage_online_fc_move_in_upto !== '' && wordpress_vars.six_storage_online_fc_move_in_upto !== null && wordpress_vars.six_storage_online_fc_move_in_upto > 0 ? wordpress_vars.six_storage_online_fc_move_in_upto : 30;
      var moveinMinDate = addDays(moveInAfter);
      var moveinUpto = addDays(moveInUpto);
      var momentDate = document.getElementById("six-storage-dtmoveindate").value; //var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      var iOS = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent);
      var safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      var selectedDate;

      if (safari) {
        selectedDate = new Date();
      } else {
        selectedDate = new Date(this.helper.sixStorageReadDate(momentDate));
      }

      this.sixStorageInitDatepicker("#six-storage-dtPreferredmoveindate", moveinMinDate, moveinUpto, null, selectedDate);
      var preferedMoveIn = document.getElementById('six-storage-dtPreferredmoveindate');
      var momentDatecont = preferedMoveIn.value;
      var selectedDatecont;

      if (safari) {
        var newDate = momentDatecont;
        selectedDatecont = new Date(newDate);
      } else {
        selectedDatecont = new Date(this.helper.sixStorageReadDate(momentDatecont));
      }

      this.sixStorageInitDatepicker("#six-storage-dtreservecontactdate", date, selectedDatecont, null, date);
      this.sixStorageHighlightInputLabel("six-storage-date-control-contact-date");
      var desired_movein_date = document.getElementById("six-storage-dtPreferredmoveindate");

      var desired_movein_instance = _materialize["default"].Datepicker.getInstance(desired_movein_date);

      desired_movein_instance.setDate(selectedDate, true);
      preferedMoveIn.addEventListener('change', function () {
        var momentDates = preferedMoveIn.value;
        var selectedDate;

        if (safari) {
          var _newDate = momentDates;
          selectedDate = new Date(_newDate);
        } else {
          selectedDate = new Date(_this43.helper.sixStorageReadDate(momentDates));
        }

        _this43.sixStorageInitDatepicker("#six-storage-dtreservecontactdate", date, selectedDate, null, date);
      });
      var reservationphone = document.getElementById("six-storage-reservationphone");
      reservationphone.oninput = this.helper.sixStorageCheckPhoneNumber;
      var reservationAddress = document.getElementById('six-storage-reservationAddress');
      reservationAddress.oninput = this.helper.sixStorageRestictNumber;
      var reservationCity = document.getElementById('six-storage-reservationCity');
      reservationCity.oninput = this.helper.sixStorageRestictNumber;
      var reservationCountry = document.getElementById('six-storage-reservationCountry');
      reservationCountry.oninput = this.helper.sixStorageRestictNumber;
      var reservationZipcode = document.getElementById('six-storage-reservationZipcode');
      reservationZipcode.oninput = this.helper.sixStorageRestictNumber;

      _materialize["default"].updateTextFields();

      this.sixStorageAllInputHighlight();
      this.sixStorageHighlightInputLabel("six-storage-floating-input");
      this.helper.sixStorageInitTelephoneNumber();
    }
  }, {
    key: "sixStorageReservationPaymentForm",
    value: function sixStorageReservationPaymentForm() {
      var _this44 = this;

      var paymentgateway;

      if (this.unitsSelected !== 'undefined' && this.unitsSelected !== null && this.unitsSelected.length > 0) {
        document.getElementById('six-storage-reservationemail-err').innerHTML = "".concat(wordpress_vars.six_storage_online_fs_Please_Enter_Email);
        document.getElementById("six-storage-reservationphone-err").innerHTML = "".concat(
        /*Please Enter Phone Number*/
        wordpress_vars.six_storage_online_fs_Please_Enter_Phone_Number);
        var dtPreferredmoveindate = document.getElementById("six-storage-dtPreferredmoveindate");
        var reservationfirstName = document.getElementById("six-storage-reservationfirstName");
        var reservationlastName = document.getElementById("six-storage-reservationlastName");
        var reservationemail = document.getElementById("six-storage-reservationemail");
        var reservationphone = document.getElementById("six-storage-reservationphone");
        var reservationAddress = document.getElementById("six-storage-reservationAddress");
        var reservationCity = document.getElementById("six-storage-reservationCity");
        var reservationCountry = document.getElementById("six-storage-reservationCountry");
        var reservationZipcode = document.getElementById("six-storage-reservationZipcode");
        var reservationleadsource = document.getElementById("six-storage-Enqleadsource");
        var dtreservecontactdate = document.getElementById("six-storage-dtreservecontactdate");
        var reservationsourcecomment = document.getElementById("six-storage-reservationsourcecomment");
        var checkboxContactby = document.getElementsByName('six-storage-contactTypeName');
        var contactPreferencesData = [];

        for (var i = 0; i < checkboxContactby.length; i++) {
          if (checkboxContactby[i].checked) {
            contactPreferencesData.push(checkboxContactby[i].value);
          }
        }

        var phoneInstance = window.intlTelInputGlobals.getInstance(reservationphone);
        var obj = {
          dtPreferredmoveindate: typeof dtPreferredmoveindate !== null && dtPreferredmoveindate !== "undefined" && dtPreferredmoveindate !== "" && dtPreferredmoveindate.value !== null && dtPreferredmoveindate.value !== "undefined" && dtPreferredmoveindate.value !== "" ? dtPreferredmoveindate.value : null,
          reservationfirstName: typeof reservationfirstName !== null && reservationfirstName !== "undefined" && reservationfirstName !== undefined && reservationfirstName !== "" && reservationfirstName.value !== null && reservationfirstName.value !== "undefined" && reservationfirstName.value !== undefined && reservationfirstName.value !== "" ? reservationfirstName.value : null,
          reservationlastName: reservationlastName !== null && reservationlastName !== "undefined" && reservationlastName !== undefined && reservationlastName !== "" && reservationlastName.value !== null && reservationlastName.value !== "undefined" && reservationlastName.value !== undefined && reservationlastName.value !== "" ? reservationlastName.value : null,
          reservationemail: typeof reservationemail !== null && reservationemail !== "undefined" && reservationemail !== undefined && reservationemail !== "" && reservationemail.value !== null && reservationemail.value !== "undefined" && reservationemail.value !== undefined && reservationemail.value !== "" ? reservationemail.value : null,
          reservationphone: typeof phoneInstance !== null && phoneInstance !== "undefined" && phoneInstance.getNumber() !== null && phoneInstance.getNumber() !== "undefined" ? phoneInstance.getNumber() : null,
          reservationAddress: typeof reservationAddress !== null && reservationAddress !== "undefined" && reservationAddress !== undefined && reservationAddress !== "" && reservationAddress.value !== null && reservationAddress.value !== "undefined" && reservationAddress.value !== null && reservationAddress.value !== "" ? reservationAddress.value : null,
          reservationCity: typeof reservationCity !== null && reservationCity !== "undefined" && reservationCity !== undefined && reservationCity !== "" && reservationCity.value !== null && reservationCity.value !== "undefined" && reservationCity.value !== undefined && reservationCity.value !== "" ? reservationCity.value : null,
          reservationCountry: typeof reservationCountry !== null && reservationCountry !== "undefined" && reservationCountry !== undefined && reservationCountry !== "" && reservationCountry.value !== null && reservationCountry.value !== "undefined" && reservationCountry.value !== undefined && reservationCountry.value !== "" ? reservationCountry.value : null,
          reservationZipcode: typeof reservationZipcode !== null && reservationZipcode !== "undefined" && reservationZipcode !== undefined && reservationZipcode !== "" && reservationZipcode.value !== null && reservationZipcode.value !== "undefined" && reservationZipcode ? reservationZipcode.value : null,
          reservationleadsource: typeof reservationleadsource !== null && reservationleadsource !== "undefined" && reservationleadsource.value !== null && reservationleadsource.value !== "undefined" ? reservationleadsource.value : null,
          // reservationsource: typeof reservationsource !== null && reservationsource !== "undefined"
          //  && reservationsource.value !== null && reservationsource.value !== "undefined"
          //  ? reservationsource.value : null,
          dtreservecontactdate: typeof dtreservecontactdate !== null && dtreservecontactdate !== "undefined" && dtreservecontactdate.value !== null && dtreservecontactdate.value !== "undefined" ? dtreservecontactdate.value : null,
          reservationsourcecomment: typeof reservationsourcecomment !== null && reservationsourcecomment !== "undefined" && reservationsourcecomment.value !== null && reservationsourcecomment.value !== "undefined" ? reservationsourcecomment.value : null,
          contactPreferencesData: typeof contactPreferencesData !== null && contactPreferencesData !== "undefined" && contactPreferencesData.value !== null && contactPreferencesData.value !== "undefined" ? contactPreferencesData : null
        };
        var leadsource = typeof obj.reservationleadsource !== "" && typeof obj.reservationleadsource !== null && obj.reservationleadsource !== "" ? obj.reservationleadsource : "00000000-0000-0000-0000-000000000000";
        var error_count = 0;
        Object.entries(obj).forEach(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
              key = _ref12[0],
              value = _ref12[1];

          if ((value === null || value === "undefined" || value === "" || value.length === 0) && key !== "reservationsource" && key !== "reservationsourcecomment") {
            document.getElementById("six-storage-" + key + "-err").style.display = "block";
            error_count = error_count + 1;
            return false;
          } else {
            if (key === "reservationemail") {
              if (!_this44.helper.sixStorageValidateEmail(document.getElementById("six-storage-" + key))) {
                error_count = error_count + 1;
              } else {
                var ele = document.getElementById("six-storage-" + key + "-err");

                if (ele) {
                  ele.style.display = "none";
                }
              }
            } else if (key === "reservationZipcode") {
              if (value.length === 1) {
                document.getElementById("six-storage-" + key + "-err").style.display = "block";
                document.getElementById("six-storage-" + key + "-err").innerHTML = "".concat(wordpress_vars.six_storage_online_Please_Enter_Valid_Zipcode);
              } else {
                var _ele = document.getElementById("six-storage-" + key + "-err");

                if (_ele) {
                  _ele.style.display = "none";
                }
              }
            } else {
              var _ele2 = document.getElementById("six-storage-" + key + "-err");

              if (_ele2) {
                _ele2.style.display = "none";
              }
            }
          }
        });

        if (reservationphone.value.length === 1) {
          document.getElementById("six-storage-reservationphone-err").style.display = 'block';
          document.getElementById("six-storage-reservationphone-err").innerHTML = "".concat(wordpress_vars.six_storage_online_Please_Enter_Valid_Number);
          error_count = error_count + 1;
        }

        if (error_count > 0) {
          return;
        }

        var userInformation = {
          firstName: obj.reservationfirstName,
          lastName: obj.reservationlastName,
          email: obj.reservationemail,
          mobile: obj.reservationphone,
          address: obj.reservationAddress,
          city: obj.reservationCity,
          country: obj.reservationCountry,
          zipCode: obj.reservationZipcode,
          leadSource: leadsource,
          contactPreferences: {
            contactDate: this.helper.sixStorageReadDate(obj.dtreservecontactdate),
            message: obj.reservationsourcecomment,
            contactPreference: obj.contactPreferencesData
          },
          preferredMoveinDate: this.helper.sixStorageReadDate(obj.dtPreferredmoveindate)
        };
        var paymentformInfo = {
          platform: "WEB",
          hostURL: this.helper.sixStorageGetHostURL()
        };
        var reservinform = {
          unitId: this.unitsSelected,
          paymentFormInfo: paymentformInfo,
          userInformation: userInformation
        };
        var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
        var result = clientConfig.paymentModes.filter(function (i) {
          return i.value == 'CreditCard';
        }); // let payloadobject = `"paymentFormInfo": ${JSON.stringify(paymentformInfo)} , "userInformation": ${JSON.stringify(userInformation)}`;
        // console.log(payloadobject);

        if (typeof clientConfig !== "undefined" && clientConfig !== null) {
          paymentgateway = clientConfig.culture.paymentGateway;
        }

        sessionStorage.setItem("userInformation", JSON.stringify(userInformation));

        if (result.length === 0) {
          this.reservationUserDetails = userInformation;

          if (wordpress_vars.six_storage_online_setup_preloader === "0") {
            var initialloaders = document.getElementById("six-storage-loading-container");
            initialloaders.style.display = 'block';
          }

          this.sixStorageReservenow();
        } else {
          if (wordpress_vars.six_storage_online_setup_preloader === "0") {
            var _initialloaders10 = document.getElementById("six-storage-loading-container");

            _initialloaders10.style.display = 'block';
          }

          var formData = new FormData();
          formData.append("action", "six_storage_get_reservation_payment_form");
          formData.append("unitId", this.unitsSelected);
          formData.append("paymentFormInfo", JSON.stringify(paymentformInfo));
          formData.append("userInformation", JSON.stringify(userInformation));

          if (typeof clientConfig !== "undefined" && clientConfig !== null && clientConfig.culture.paymentGateway === "PAYA") {
            formData.append('paymentgateway', paymentgateway);
            formData.append("callPlace", "RESERVATION"); // formData.append("PayloadObject", payloadobject);

            var newObj = this.unitinfoDetails;
            newObj.userInformation = userInformation;
            formData.append("PayloadObject", JSON.stringify(newObj));
          }

          var header = {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;"
            },
            body: this.helper.sixStorageGetURIParams(formData)
          };
          var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
          document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
          fetch(url, header).then(function (response) {
            return response.json();
          }).then(function (data) {
            document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(false);

            if (typeof data !== 'undefined' && data !== null) {
              var _response15 = JSON.parse(data);

              if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                var _initialloaders11 = document.getElementById("six-storage-loading-container");

                _initialloaders11.style.display = 'none';
              }

              if (typeof _response15.isSuccess !== 'undefined' && _response15 !== null && _response15.isSuccess === true && _response15.returnMessage !== "No Reservation Fee") {
                document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(true);
                _this44.reservationUserDetails = userInformation;

                if (_response15.additionalResource == "P24" || _response15.additionalResource == "SQUARE-UP") {
                  var rentnowurl = document.getElementById("six-storage-location-list-row-container").dataset.url;

                  if (typeof rentnowurl !== "undefined" && rentnowurl !== null) {
                    sessionStorage.setItem("rentnowurl", rentnowurl);
                  }

                  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                    // document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
                    // document.getElementById('six-storage-reservationpaymentform').style.display = 'block';
                    // document.getElementById("six-storage-reservationpaymentform").innerHTML = `<button class="six-storage-btn cc" style="position:relative;top:50%;left:10%;" onclick="window.open('${response.result}','_blank');sixStorageShowLoader();">
                    // ${wordpress_vars.six_storage_online_mi_click_here_to_pay}
                    window.location = _response15.result; // </button>`;
                  } else {
                    //this.helper.sixStorageOpenNewWindow(response.result, '', 768, 580);
                    // let newTab = window.open();
                    // if(typeof newTab !=="undefined" && newTab !==null){
                    //   newTab.location.href = response.result;
                    // }else{
                    //   newTab.location.href = response.result;
                    // }
                    // this.ptwofourformredirection(response.result);
                    window.location = _response15.result;
                  } //document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
                  //   this.helper.sixStorageOpenNewWindow(response.result, '', 768, 580);
                  //window.open(response.result);

                } else {
                  document.getElementById("six-storage-reservationpaymentform").style.display = "";
                  document.getElementById("six-storage-reservationpaymentform").innerHTML = "<iframe name=\"iframePaymentForm\" id=\"six-storage-iframePaymentFormReservation\"style=\"width:100%;height:385px;border:none;\"></iframe>";
                  var paymentForm = document.getElementById("six-storage-iframePaymentFormReservation");
                  _this44.paymentGateway = _response15.additionalResource;
                  _this44.reservationPayment = true;

                  if (_response15.additionalResource == "STRIPE") {
                    document.getElementById("six-storage-iframePaymentFormReservation").style.height = "385px";
                  }

                  if (typeof paymentForm !== "undefined" && paymentForm !== null) {
                    paymentForm.setAttribute("src", encodeURI(_response15.result));
                  }

                  paymentForm.onload = function () {
                    document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(false);
                  };

                  document.getElementById("six-storage-reserve-pay-btn").style.display = "none";
                  _this44.reservationUserDetails = userInformation;

                  paymentForm.onload = function () {
                    document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(false);
                    var movein_modal = document.getElementById("six-storage-movein-modal");

                    if (typeof movein_modal !== "undefined" && movein_modal !== null) {
                      movein_modal.scrollTo(0, movein_modal.scrollHeight);
                    }
                  };

                  if (_response15.additionalResource == "RAPYD") {
                    document.getElementById('six-storage-movein-modal').style.width = '80%';
                    document.getElementById('six-storage-reservation-form').style.maxWidth = '1040px';
                  }

                  document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(false);
                }
              } else if (typeof _response15.isSuccess !== 'undefined' && _response15 !== null && _response15.isSuccess === true) {
                _this44.reservationUserDetails = userInformation;

                _this44.sixStorageReservenow();
              } else {
                document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(false);
              }
            } else {
              document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(false);
            }
          })["catch"](function (err) {
            console.log(err);
            document.getElementById("six-storage-loading-container").innerHTML = _this44.helper.sixStorageShowBusyIndicator(false);
          });
        }
      }
    }
  }, {
    key: "ptwofourformredirection",
    value: function ptwofourformredirection(url) {
      window.open(url, "_blank");
    }
  }, {
    key: "sixStorageNewSignupModal",
    value: function sixStorageNewSignupModal() {
      document.getElementById("six-storage-movein-modal").classList.remove("six-storage-sm");
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = "".concat(
      /*Sign Up*/
      wordpress_vars.six_storage_online_fs_Sign_up);
      modalBody.innerHTML = "<form onsubmit=\"event.preventDefault()\" class=\"six-storage-grid-p0 cc six-storage-grid-shadow-none six-storage-form-sign-up-modal six-storage-grid-w-100 six-storage-mx-auto\" id =\"six-storage-sign-up-form\" action = \"post\" autocomplete=\"off\">\n        <div class=\"six-storage-col six-storage-m12\">\n        <div class=\"six-storage-form-row six-storage-row cc six-storage-grid-pb0  six-storage-grid-mb0\">\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                  <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                      <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                  </div>\n                  <input type=\"text\" class=\"cc six-storage-floating-input six-storage-grid-form-control six-storage-border0 \" autocomplete=\"none\" id=\"six-storage-signupfirstName\" tabindex=\"1\" placeholder=\" ".concat(
      /* First Name*/
      wordpress_vars.six_storage_online_fs_sf_first_name_custom_word, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                  <div style=\"display: none;\" id=\"six-storage-signupfirstName-err\" class=\"six-storage-invalid-feedback\">\n                  ").concat(
      /*Please Enter First Name*/
      wordpress_vars.six_storage_online_fs_sf_first_name_validation, "\n                  </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-signuplastName\" tabindex=\"2\" placeholder=\"").concat(
      /*Last Name*/
      wordpress_vars.six_storage_online_fs_Last_Name, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    <div style=\"display: none;\" id= \"six-storage-signuplastName-err\" class=\"six-storage-invalid-feedback\">\n                        ").concat(
      /*Please Enter Last Name*/
      wordpress_vars.six_storage_online_fs_sf_last_name_validation, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">email</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-signupemail\" tabindex=\"3\" placeholder=\"").concat(
      /*Email*/
      wordpress_vars.six_storage_online_mi_Email, "\" aria-describedby=\"six-storage-inputGroupPrepend\"  maxlength=\"100\">\n                    <div style=\"display: none;\" id=\"six-storage-signupemail-err\" class=\"six-storage-invalid-feedback\">\n                        ").concat(
      /*Please Enter Email*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Email, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">email</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" autocomplete=\"none\" id=\"six-storage-signupConfirmemail\" tabindex=\"4\" placeholder=\" ").concat(
      /*Confirm Email*/
      wordpress_vars.six_storage_online_mi_Confirm_Email, "\" aria-describedby=\"six-storage-inputGroupPrepend\" maxlength=\"100\" >\n                    <div style=\"display: none;\" id=\"six-storage-signupConfirmemail-err\" class=\"six-storage-invalid-feedback\">\n                    ").concat(
      /*Please Confirm Email*/
      wordpress_vars.six_storage_online_mi_Please_Confirm_Email, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group  six-storage-required \">\n                    <div class=\"six-storage-flex-nowrap six-storage-grid-d-flex\">\n                      <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">phone</i></span>\n                      </div>\n                      <input type=\"tel\" maxlength=\"15\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 six-storage-telephone\" autocomplete=\"none\" id=\"six-storage-signupphone\" tabindex=\"6\" placeholder=\" ").concat(
      /*Phone*/
      wordpress_vars.six_storage_online_fs_sf_phone_number_custom_word, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    </div>\n                    <div style=\"display: none;\" id=\"six-storage-signupphone-err\" class=\"six-storage-invalid-feedback\">\n                    ").concat(
      /*Please Enter Phone Number*/
      wordpress_vars.six_storage_online_fs_sf_phone_number_validation, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend\"><i class=\"six-storage-material-icons notranslate\">person</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-floating-input cc six-storage-grid-form-control six-storage-border0\" autocomplete=\"none\" id=\"six-storage-signupUserName\" tabindex=\"5\" placeholder=\" ").concat(
      /*Username*/
      wordpress_vars.six_storage_online_mi_Username, "\" aria-describedby=\"six-storage-inputGroupPrepend\" ").concat(wordpress_vars.sso_enabled === true || wordpress_vars.sso_enabled === "1" ? "disabled" : "", " />\n                    <div style=\"display: none;\" id=\"six-storage-signupUserName-err\" class=\"six-storage-invalid-feedback\">\n                    ").concat(
      /*Please Enter Username*/
      wordpress_vars.six_storage_online_fs_sf_user_name_validation, "\n                    </div>\n                </div>\n            </div>        \n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group six-storage-required six-storage-border0 six-storage-bg-white\">\n                    <div class=\"six-storage-grid-input-group-prepend\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend\"><i class=\"six-storage-material-icons notranslate\">fingerprint</i></span>\n                    </div>\n                    <input type=\"password\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" maxlength =\"12\" autocomplete=\"none\" tabindex=\"7\" placeholder=\"").concat(
      /*Password*/
      wordpress_vars.six_storage_online_fs_Password, "\" id=\"six-storage-signuppassword\" >\n                    <a class=\"six-storage-waves-effect six-storage-btn-small six-storage-eye-icon-align six-storage-prefix six-storage-suffix six-storage-password-eye-align six-storage-grid-shadow-none six-storage-transparent\"><i class=\"six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grey-text\" toggle=\"six-storage-signuppassword\" onclick=\"return sixStorageTogglePasswordVisibility(this);\">remove_red_eye</i></a>\n                    <div style=\"display: none;\" id=\"six-storage-signuppassword-err\" class=\"six-storage-invalid-feedback\">\n                        ").concat(
      /*Please Enter Password*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Password, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend\"><i class=\"six-storage-material-icons notranslate\">fingerprint</i></span>\n                    </div>\n                    <input type=\"password\" class=\"six-storage-floating-input six-storage-grid-form-control six-storage-border0 cc\" maxlength =\"12\" autocomplete=\"none\" tabindex=\"8\" placeholder=\"").concat(
      /*Confirm Password*/
      wordpress_vars.six_storage_online_fs_Confirm_Password, "\" id=\"six-storage-signupconfirmPassword\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    <a class=\"six-storage-waves-effect six-storage-btn-small six-storage-eye-icon-align six-storage-prefix six-storage-suffix six-storage-password-eye-align six-storage-grid-shadow-none six-storage-transparent\"><i class=\"six-storage-grid-position-relative six-storage-material-icons notranslate six-storage-grey-text\" toggle=\"six-storage-signupconfirmPassword\" onclick=\"return sixStorageTogglePasswordVisibility(this);\">remove_red_eye</i></a>\n                    <div style=\"display: none;\" id=\"six-storage-signupconfirmPassword-err\" class=\"six-storage-invalid-feedback\">\n                        ").concat(
      /*Please Enter Confirm Password*/
      wordpress_vars.six_storage_online_please_enter_confirm_password, "\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col six-storage-s12 six-storage-m6 six_storage_signup_align\">\n              <div class=\"six-storage-grid-input-group six-storage-required\">\n                <div class=\"six-storage-input-field cc six-storage-checkbox-msg six-storage-move-in-sign-up\">\n                  <p class=\"cc sixStorageTerms six-storage-grid-mb0 six-storage-grid-ml15\">\n                    <label class=\"cc\" for=\"six-storage-terms-checkbox\"> \n                    <input type=\"checkbox\" value='1' id='six-storage-terms-checkbox' class=\"cc six-storage-grid-mb0\" />\n                    <span class=\"six-storage-field_label cc\"><a href=\"javascript:void(0)\" class=\"six-storage-terms-and-conditions-model cc\" id=\"six-storage-movein-signup-terms-modal-btn\">").concat(
      /*Terms and Conditions*/
      wordpress_vars.six_storage_online_fs_Terms_and_Conditions, "</a></span>\n                        <div style=\"display: none;\" id=\"six-storage-terms-checkbox-err\" class=\"six-storage-invalid-feedback\">\n                       ").concat(
      /*Please Accept the Terms and Conditions*/
      wordpress_vars.six_storage_online_fs_Please_Accept_the_Terms_and_Conditions, "\n                        </div>\n                    </label>\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n        <div class=\"six-storage-text-center six-storage-clearfix\">\n            <button class=\"six-storage-waves-effect six-storage-btn cc six-storage-waves-light six-storage-primary-background six-storage-signupsubmit-btn six-storage-grid-mb10 six-storage-white-text\" id=\"six-storage-sign-up-btn\" tabindex=\"9\" type=\"submit\" onclick=\"sixStorageTenantSignUp();\">\n                ").concat(
      /*Sign Up*/
      wordpress_vars.six_storage_online_fs_Sign_up, "\n            </button>\n        </div>\n        <div class=\"six-storage-font-size-14 six-storage-text-center\" style=\"display: none;position:relative;bottom:20px;\" id=\"six-storage-sign-up-response\"></div>\n         </div>\n    </form>\n    <p class=\"six-storage-text-center six-storage-grid-mb0 six-storage-grid-mt10\"><a class=\"six-storage-text-center six-storage-modal-footer-text\" id=\"six-storage-forgotpwd\" href=\"#\" onclick=\"sixStorageNewLoginModal();\">").concat(
      /*Already having an account click here to login*/
      wordpress_vars.six_storage_online_fs_of_Already_having_an_account_click_here_to_login, "</a></p>"); //M.AutoInit();

      var storageTerms = document.querySelector(".sixStorageTerms");

      if (window.sixStorage_online_region == "eu") {
        storageTerms.style.display = "none";
      } //this.helper.showIconsOnLoad();


      var modal = document.getElementById("six-storage-movein-signup-modal-term"); // Get the button that opens the modal

      var btn = document.getElementById("six-storage-movein-signup-terms-modal-btn"); // Get the <span> element that closes the modal

      var span = document.getElementsByClassName("six-storage-movein-signup-terms-close")[0]; // When the user clicks the button, open the modal 

      document.getElementById("six-storage-movein-signup-terms-modal-btn").addEventListener("click", function (event) {
        modal.style.display = "block";
      }); // When the user clicks on <span> (x), close the modal

      span.addEventListener('click', function (event) {
        modal.style.display = "none";
      }); // When the user clicks anywhere outside of the modal, close it

      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      };

      document.getElementById("six-storage-signupfirstName").value = "";
      document.getElementById("six-storage-signuplastName").value = "";
      document.getElementById("six-storage-signupemail").value = "";
      document.getElementById("six-storage-signupConfirmemail").value = "";
      document.getElementById("six-storage-signupUserName").value = "";
      document.getElementById("six-storage-signupphone").value = "";
      document.getElementById("six-storage-signuppassword").value = "";
      document.getElementById("six-storage-signupconfirmPassword").value = "";

      _materialize["default"].updateTextFields();

      this.sixStorageAllInputHighlight();
      this.sixStorageHighlightInputLabel("six-storage-floating-input");
      var signupphone = document.getElementById("six-storage-signupphone");
      var signupemail = document.getElementById("six-storage-signupemail");
      document.getElementById("six-storage-sign-up-form").addEventListener('keypress', function (event) {
        if (event.code === "Space" && (event.target.value === undefined || event.target.value === null || event.target.value === "")) {
          event.preventDefault();
        }
      });
      signupphone.oninput = this.helper.sixStorageCheckPhoneNumber;
      signupemail.onkeyup = this.updateUsernameField;
      this.helper.sixStorageInitTelephoneNumber("#six-storage-signupphone");
    }
  }, {
    key: "sixStorageForgotPasswordModal",
    value: function sixStorageForgotPasswordModal() {
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = "".concat(
      /*Forgot password*/
      wordpress_vars.six_storage_online_mi_Forgot_Password);
      modalBody.innerHTML = "\n        <form onsubmit=\"event.preventDefault()\" class=\" six-storage-loginform-validation six-storage-grid-p20 cc six-storage-bg-white six-storage-show-forgotpwd\" id=\"six-storage-forgot-password-form\" novalidate=\"\">\n            <div class=\"six-storage-col-md-12\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                    <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-secondary-color six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom cc\" id=\"six-storage-forgot-password-username\" placeholder=\"".concat(
      /*Enter Registered Username*/
      wordpress_vars.six_storage_online_fs_Enter_Registered_Username, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    <div class=\"six-storage-invalid-feedback\" id=\"six-storage-forgot-password-username-err\" style=\"display:none\">\n                        ").concat(
      /*Please Enter Username*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Username, "\n                    </div>\n                    <div class=\"six-storage-invalid-feedback\" id=\"six-storage-forgot-password-msg\" style=\"display:none\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"six-storage-col-md-12 six-storage-clearfix six-storage-bg-white six-storage-show-forgotpwd six-storage-grid-pt0 six-storage-text-center\">\n              <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc  six-storage-primary-background-color six-storage-forgotpwd-submit six-storage-grid-mb10\" type=\"submit\" onclick=\"return sixStorageForgotPassword();\" >").concat(
      /*Submit*/
      wordpress_vars.six_storage_online_fs_Submit, "</button>\n            </div>\n            <p class=\"six-storage-text-center six-storage-grid-mb0 six-storage-grid-mt20\"><a class=\"six-storage-text-center six-storage-grid-col-md-12 six-storage-modal-footer-text\" id=\"six-storage-forgotpwd\" href=\"#\" onclick=\"sixStorageNewLoginModal();\">").concat(
      /*Already having an account click here to login*/
      wordpress_vars.six_storage_online_fs_of_Already_having_an_account_click_here_to_login, "</a></p>\n        </form>");

      _materialize["default"].updateTextFields();

      this.sixStorageAllInputHighlight();
      this.sixStorageHighlightInputLabel("six-storage-floating-input");
    }
  }, {
    key: "sixStorageForgotPasswordconfirmationCodeModal",
    value: function sixStorageForgotPasswordconfirmationCodeModal(flag, username) {
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = flag === "sign_up" ? "".concat(
      /*Confirm Signup*/
      wordpress_vars.six_storage_online_si_Confirm_Signup) : "".concat(
      /*Forgot password*/
      wordpress_vars.six_storage_online_mi_Forgot_Password);
      modalBody.innerHTML = "\n        <form class=\" six-storage-loginform-validation cc six-storage-bg-white six-storage-show-forgotpwd\" novalidate=\"\">\n            <div class=\"six-storage-col-md-12\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                  <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom \" id=\"six-storage-password_confirmation_username\" placeholder=\"".concat(
      /*Enter Registered Username*/
      wordpress_vars.six_storage_online_fs_Enter_Registered_Username, "\" aria-describedby=\"six-storage-inputGroupPrepend\" value=\"").concat(typeof username !== 'undefined' && username !== null ? username : "", "\" disabled=\"disabled\"/>\n                    <div class=\"six-storage-invalid-feedback\" id=\"six-storage-password_confirmation_username-err\" style=\"display:none\">\n                        ").concat(
      /*Please Enter Registered Username*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Registered, ".\n                    </div>\n                  </div>\n            </div>\n            <div class=\"six-storage-col-md-12\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                  <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">fingerprint</i></span>\n                    </div>\n                    <input type=\"password\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom \" id=\"six-storage-password_confirmation_newpassword\" placeholder=\"").concat(
      /*Enter New Passrword*/
      wordpress_vars.six_storage_online_fs_Enter_New_Passrword, "\" aria-describedby=\"six-storage-inputGroupPrepend\" />\n                    <div class=\"six-storage-invalid-feedback\" id=\"six-storage-password_confirmation_newpassword-err\" style=\"display:none\">\n                        ").concat(
      /*Please Enter New Password*/
      wordpress_vars.six_storage_online_fs_Please_Enter_New_Password, "\n                    </div>\n                  </div>\n            </div>\n            <div class=\"six-storage-col-md-12\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                  <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">fingerprint</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom \" id=\"six-storage-password_confirmation_code\" placeholder=\"").concat(
      /*Enter Confirmation Code*/
      wordpress_vars.six_storage_online_fs_Enter_Confirmation_Code, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    <div class=\"six-storage-invalid-feedback\" id=\"six-storage-password_confirmation_code-err\" style=\"display:none\">\n                        ").concat(
      /*Please Enter Confirmation Code*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Confirmation_Code, "\n                    </div>\n                </div>\n            </div>\n        </form>\n        <div class=\"six-storage-s12 six-storage-clearfix six-storage-grid-pt15 six-storage-grid-pb15 six-storage-grid-p10 six-storage-font-weight-bold six-storage-text-center\" id=\"six-storage-password_confirmation_code-msg\" style=\"display:none\">\n\n        </div>\n        <div class=\"six-storage-col-md-12 six-storage-clearfix six-storage-bg-white six-storage-show-forgotpwd six-storage-grid-pt0\">\n            <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background six-storage-forgotpwd-submit six-storage-grid-mb10\" type=\"submit\" onclick=\"return sixStorageSubmitPasswordConfirmationCode();\" >").concat(
      /*Submit*/
      wordpress_vars.six_storage_online_fs_Submit, "</button>\n        </div>");

      _materialize["default"].updateTextFields();
    }
  }, {
    key: "sixStorageConfirmationCodeModal",
    value: function sixStorageConfirmationCodeModal(flag, username, password, codeDelivery) {
      var modalBody = document.getElementById("six-storage-movein-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle");
      modalTitle.innerHTML = flag === "sign_up" ? "".concat(
      /*Confirm Signup*/
      wordpress_vars.six_storage_online_si_Confirm_Signup) : "".concat(
      /*Forgot password*/
      wordpress_vars.six_storage_online_mi_Forgot_Password);
      modalBody.innerHTML = "\n        <form class=\" six-storage-loginform-validation cc six-storage-bg-white six-storage-show-forgotpwd\" novalidate=\"\">\n            <div class=\"six-storage-col\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                  <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">perm_identity</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom \" id=\"six-storage-confirmation_username\" placeholder=\"".concat(
      /*Enter Registered Username*/
      wordpress_vars.six_storage_online_fs_Enter_Registered_Username, ".\" aria-describedby=\"six-storage-inputGroupPrepend\" value=\"").concat(typeof username !== 'undefined' && username !== null ? username : "", "\" disabled=\"disabled\"/>\n                    <div class=\"six-storage-invalid-feedback\" id=\"six-storage-confirmation_username-err\" style=\"display:none\">\n                        ").concat(
      /*Please Enter Registered Username*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Registered_Username, "\n                    </div>\n                  </div>\n            </div>\n            <div class=\"six-storage-col-md-12\">\n                <div class=\"six-storage-grid-input-group  six-storage-required\">\n                  <div class=\"six-storage-grid-input-group-prepend six-storage-border0 six-storage-bg-white\">\n                        <span class=\"six-storage-grid-input-group-text six-storage-border0 six-storage-bg-white\" id=\"six-storage-inputGroupPrepend \"><i class=\"six-storage-material-icons notranslate\">fingerprint</i></span>\n                    </div>\n                    <input type=\"text\" class=\"six-storage-grid-form-control six-storage-border0 six-storage-border-bottom \" id=\"confirmation_code\" placeholder=\"").concat(
      /*Enter Confirmation Code*/
      wordpress_vars.six_storage_online_fs_Enter_Confirmation_Code, "\" aria-describedby=\"six-storage-inputGroupPrepend\" >\n                    <div class=\"six-storage-invalid-feedback\" id=\"confirmation_code-err\" style=\"display:none\">\n                        ").concat(
      /*Please Enter Confirmation Code*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Confirmation_Code, "\n                    </div>\n                </div>\n            </div>\n        </form>\n        <div class=\"six-storage-s12 six-storage-clearfix six-storage-grid-pt5 six-storage-grid-pb5  six-storage-font-weight-bold six-storage-text-center\" id=\"confirmation_code-msg\">\n            Please check your inbox and submit the confirmation code.\n            ").concat(codeDelivery["deliveryMedium"]["value"], " has been sent to ").concat(codeDelivery["destination"], ".\n        </div>\n        <div class=\"six-storage-col-md-12 six-storage-clearfix six-storage-bg-white six-storage-show-forgotpwd six-storage-grid-pt0 six-storage-text-center six-storage-grid-mt10 six-storage-grid-mb10\">\n            <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background six-storage-forgotpwd-submit six-storage-grid-mb0\" type=\"submit\" onclick=\"return sixStorageSubmitConfirmationCode('").concat(password, "');\" >").concat(
      /*Submit*/
      wordpress_vars.six_storage_online_fs_Submit, "</button>\n        </div>\n        <p class=\"six-storage-text-center six-storage-grid-mb0\">").concat(
      /*Didnt receive confirmation code*/
      wordpress_vars.six_storage_online_fs_Didnt_receive_confirmation, "? <a class=\"six-storage-text-center six-storage-grid-col-md-12 six-storage-modal-footer-text\" id=\"six-storage-forgotpwd\" href=\"javascript:void(0)\" onclick=\"sixStorageResendConfirmationCode();\">").concat(
      /*Resend confirmation code*/
      wordpress_vars.six_storage_online_fs_Resend_confirmation_code, " w</a></p>");

      _materialize["default"].updateTextFields();
    }
  }, {
    key: "sixStorageResendConfirmationCode",
    value: function sixStorageResendConfirmationCode() {
      var _this45 = this;

      var confirmation_username = document.getElementById("six-storage-confirmation_username");
      document.getElementById("confirmation_code-msg").style.display = "none";
      var obj = {
        confirmation_username: typeof confirmation_username !== "undefined" && confirmation_username !== null && confirmation_username.value !== null ? confirmation_username.value : null
      };
      var error_count = 0;
      Object.entries(obj).forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
            key = _ref14[0],
            value = _ref14[1];

        if (value == null || value == "" || value.length < 3) {
          document.getElementById("six-storage-" + key + "-err").style.display = "block";
          error_count = error_count + 1;
          return false;
        } else {
          var ele = document.getElementById("six-storage-" + key + "-err");

          if (ele) {
            ele.style.display = "none";
          }
        }
      });

      if (error_count > 0) {
        return;
      }

      var formData = new FormData();
      formData.append("action", "six_storage_resend_confirmation_code");
      formData.append("confirmation_username", obj.confirmation_username);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this45.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response16 = JSON.parse(data);

          if (typeof _response16.isSuccess !== 'undefined' && _response16 !== null && _response16.isSuccess === true) {
            var codeDelivery = _response16["result"]["codeDeliveryDetails"];
            document.getElementById("confirmation_code-msg").classList.add("six-storage-green-text");
            document.getElementById("confirmation_code-msg").innerHTML = "".concat(
            /*Please check your inbox and submit the confirmation code*/
            wordpress_vars.six_storage_online_su_Please_check_your_inbox_and_submit, ". ").concat(codeDelivery["deliveryMedium"]["value"], " has been sent to ").concat(codeDelivery["destination"]);
          } else {
            document.getElementById("confirmation_code-msg").classList.add("six-storage-red-text");
            document.getElementById("confirmation_code-msg").innerHTML = _response16.returnMessage; //"Unable to submit confirmation code, please contact storage owner.";
          }
        } else {
          document.getElementById("confirmation_code-msg").classList.add("six-storage-red-text");
          document.getElementById("confirmation_code-msg").innerHTML = "".concat(
          /*Unable to submit confirmation code, please contact storage owner*/
          wordpress_vars.six_storage_online_su_Unable_to_submit_confirmation);
        }
      })["catch"](function (err) {
        console.error(err);
        document.getElementById("six-storage-loading-container").innerHTML = _this45.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageSubmitConfirmationCode",
    value: function sixStorageSubmitConfirmationCode(password) {
      var _this46 = this;

      var confirmation_username = document.getElementById("confirmation_username");
      var confirmation_code = document.getElementById("confirmation_code");
      document.getElementById("confirmation_code-msg").style.display = "none";
      var obj = {
        confirmation_username: typeof confirmation_username !== "undefined" && confirmation_username !== null && typeof confirmation_username.value !== "undefined" && confirmation_username.value !== null ? confirmation_username.value : null,
        confirmation_code: typeof confirmation_code !== "undefined" && confirmation_code !== null && typeof confirmation_code.value !== "undefined" && confirmation_code.value !== null ? confirmation_code.value : null
      };
      var error_count = 0;
      Object.entries(obj).forEach(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
            key = _ref16[0],
            value = _ref16[1];

        if (value == null || value == "" || value.length < 3) {
          document.getElementById("six-storage-" + key + "-err").style.display = "block";
          error_count = error_count + 1;
          return false;
        } else {
          var ele = document.getElementById("six-storage-" + key + "-err");

          if (ele) {
            ele.style.display = "none";
          }
        }
      });

      if (error_count > 0) {
        return;
      }

      var formData = new FormData();
      formData.append("action", "six_storage_submit_confirmation_code");
      formData.append("confirmation_username", obj.confirmation_username);
      formData.append("confirmation_code", obj.confirmation_code);
      formData.append("password", password);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this46.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response17 = JSON.parse(data);

          if (typeof _response17.isSuccess !== 'undefined' && _response17 !== null && _response17.isSuccess === true) {
            var authResponse = _response17["result"]["authenticationResult"];

            if (typeof authResponse !== 'undefined' && authResponse !== null) {
              sessionStorage.setItem("six-storage-security_token", authResponse["accessToken"]);
            }

            _this46.sixStorageGoToTenantDetails(_this46.signUpReponse);
          } else {
            document.getElementById("confirmation_code-msg").classList.add("six-storage-red-text");

            _this46.helper.sixStorageShowMessage(_response17.returnMessage, true);

            document.getElementById("confirmation_code-msg").innerHTML = _response17.returnMessage; //"Unable to submit confirmation code, please contact storage owner.";
          }
        } else {
          document.getElementById("confirmation_code-msg").classList.add("six-storage-red-text");
          document.getElementById("confirmation_code-msg").innerHTML = "".concat(
          /*Unable to submit confirmation code, please contact storage owner*/
          wordpress_vars.six_storage_online_su_Unable_to_submit_confirmation, ".");
        }
      })["catch"](function () {
        document.getElementById("six-storage-loading-container").innerHTML = _this46.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageSubmitPasswordConfirmationCode",
    value: function sixStorageSubmitPasswordConfirmationCode() {
      var _this47 = this;

      var password_confirmation_username = document.getElementById("six-storage-password_confirmation_username");
      var password_confirmation_newpassword = document.getElementById("six-storage-password_confirmation_newpassword");
      var password_confirmation_code = document.getElementById("six-storage-password_confirmation_code");
      document.getElementById("password_confirmation_code-msg").style.display = "none";
      var obj = {
        password_confirmation_username: typeof password_confirmation_username !== "undefined" && password_confirmation_username !== null && typeof password_confirmation_username.value !== "undefined" && password_confirmation_username.value !== null ? password_confirmation_username.value : null,
        password_confirmation_newpassword: typeof password_confirmation_newpassword !== "undefined" && password_confirmation_newpassword !== null && typeof password_confirmation_newpassword.value !== "undefined" && password_confirmation_newpassword.value !== null ? password_confirmation_newpassword.value : null,
        password_confirmation_code: typeof password_confirmation_code !== "undefined" && password_confirmation_code !== null && typeof password_confirmation_code.value !== "undefined" && password_confirmation_code.value !== null ? password_confirmation_code.value : null
      };
      var error_count = 0;
      Object.entries(obj).forEach(function (_ref17) {
        var _ref18 = _slicedToArray(_ref17, 2),
            key = _ref18[0],
            value = _ref18[1];

        if (value == null || value == "" || value.length < 3) {
          document.getElementById("six-storage-" + key + "-err").style.display = "block";
          error_count = error_count + 1;
          return false;
        } else {
          var ele = document.getElementById(key + "-err");

          if (ele) {
            ele.style.display = "none";
          }
        }
      });

      if (error_count > 0) {
        return;
      }

      var errors = [];
      var re = /^\w+$/;

      if (obj.password_confirmation_newpassword != "" && obj.password_confirmation_newpassword == obj.password_confirmation_newpassword) {
        if (obj.password_confirmation_newpassword.length < 8) {
          errors.push("".concat(
          /*Error: Password must contain at least six characters!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_six_characters));
        }

        if (obj.password_confirmation_newpassword == obj.password_confirmation_username) {
          errors.push("".concat(
          /*Error: Password must be different from Username!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_be_different_Username));
        }

        re = /[0-9]/;

        if (!re.test(obj.password_confirmation_newpassword)) {
          errors.push("".concat(
          /*Error: Password must contain at least one number (0-9)!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_one_number));
        }

        re = /[a-z]/;

        if (!re.test(obj.password_confirmation_newpassword)) {
          errors.push("".concat(
          /*Error: Password must contain at least one lowercase letter (a-z)!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_one_lowercase_letter));
        }

        re = /[A-Z]/;

        if (!re.test(obj.password_confirmation_newpassword)) {
          errors.push("".concat(
          /*Error: Password must contain at least one uppercase letter (A-Z)!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_one_uppercase_letter));
        }
      } else {
        errors.push("".concat(
        /*Error: Please check that you have entered and confirmed your Password!*/
        wordpress_vars.six_storage_online_su_Error_Please_check_entered_confirmed_Password));
      }

      if (errors.length > 0) {
        document.getElementById('six-storage-password_confirmation_code-msg').innerHTML = " ";
        document.getElementById('six-storage-password_confirmation_code-msg').appendChild(this.sixStorageGenerateListFromArray(errors));
        document.getElementById('six-storage-password_confirmation_code-msg').style.display = "block";
        return false;
      }

      var formData = new FormData();
      formData.append("action", "six_storage_submit_password_confirmation_code");
      formData.append("newPassword", obj.password_confirmation_newpassword);
      formData.append("userName", obj.password_confirmation_username);
      formData.append("confirmationCode", obj.password_confirmation_code);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this47.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response18 = JSON.parse(data);

          if (typeof _response18.isSuccess !== 'undefined' && _response18 !== null && _response18.isSuccess === true) {
            document.getElementById("six-storage-password_confirmation_code-msg").classList.add("six-storage-green");
            document.getElementById("six-storage-password_confirmation_code-msg").innerHTML = "".concat(
            /*Password has been successfully reset to new password*/
            wordpress_vars.six_storage_online_fs_of_Password_has_been_successfully_reset_to_new_password, ".");
            setTimeout(function () {
              _this47.sixStorageNewLoginModal();
            }, 3000);
          } else {
            document.getElementById("six-storage-password_confirmation_code-msg").classList.add("six-storage-red-text");
            document.getElementById("six-storage-password_confirmation_code-msg").innerHTML = _response18.returnMessage; //"Unable to submit confirmation code, please contact storage owner.";
          }
        } else {
          document.getElementById("six-storage-password_confirmation_code-msg").classList.add("six-storage-red-text");
          document.getElementById("six-storage-password_confirmation_code-msg").innerHTML = "".concat(
          /*Unable to submit confirmation code, please contact storage owner*/
          wordpress_vars.six_storage_online_su_Unable_to_submit_confirmation);
        }
      })["catch"](function (err) {
        console.error(err);
        document.getElementById("six-storage-loading-container").innerHTML = _this47.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageSignIn",
    value: function sixStorageSignIn() {
      var _this48 = this;

      var username = document.getElementById("six-storage-username");
      var password = document.getElementById("six-storage-password");
      var obj = {
        username: typeof username !== "undefined" && username !== null && typeof username.value !== "undefined" && username.value !== null ? username.value : null,
        password: typeof password !== "undefined" && password !== null && typeof password.value !== "undefined" && password.value !== null ? password.value : null
      };
      var error_count = 0;
      Object.entries(obj).forEach(function (_ref19) {
        var _ref20 = _slicedToArray(_ref19, 2),
            key = _ref20[0],
            value = _ref20[1];

        if (value == null || value == "" || value.length < 0) {
          document.getElementById("six-storage-" + key + "-err").style.display = "block";
          error_count = error_count + 1;
          return false;
        } else {
          var ele = document.getElementById("six-storage-" + key + "-err");

          if (ele) {
            ele.style.display = "none";
          }
        }
      });

      if (error_count == 0) {
        if (wordpress_vars.six_storage_online_setup_preloader === "0") {
          var initialloaders = document.getElementById("six-storage-loading-container");
          initialloaders.style.display = 'block';
        }

        var formData = new FormData();
        formData.append("action", "six_storage_sign_in");
        formData.append("username", obj.username);
        formData.append("password", obj.password);

        if (typeof wordpress_vars.six_storage_online_tenant_activity_enable !== 'undefined' && wordpress_vars.six_storage_online_tenant_activity_enable !== null && wordpress_vars.six_storage_online_tenant_activity_enable !== '' && wordpress_vars.six_storage_online_tenant_activity_enable !== '0') {
          formData.append('log', JSON.stringify(this.helper.userAccessInfo));
        }

        var header = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;"
          },
          body: this.helper.sixStorageGetURIParams(formData)
        };
        var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
        document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
        fetch(url, header).then(function (response) {
          return response.json();
        }).then(function (data) {
          document.getElementById("six-storage-loading-container").innerHTML = _this48.helper.sixStorageShowBusyIndicator(false);

          if (typeof data !== "undefined" && data !== null) {
            var _response19 = JSON.parse(data);

            if (typeof _response19.isSuccess !== "undefined" && _response19 !== null && _response19.isSuccess === true && _response19.returnMessage == "SUCCESS") {
              if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                var _initialloaders12 = document.getElementById("six-storage-loading-container");

                _initialloaders12.style.display = 'none';
              }

              if (_response19.result.businessUser == _this48.helper.sixStorageGetTenantType()) {
                _this48.sixStorageGetUserInfo(_response19.result.userId, false, false);
              }

              if (typeof wordpress_vars !== 'undefined' && wordpress_vars !== null && typeof wordpress_vars.sso_enabled !== 'undefined' && wordpress_vars.sso_enabled !== null && (wordpress_vars.sso_enabled === true || wordpress_vars.sso_enabled === "1")) {
                var sso_response = _response19.additionalResource;
                sessionStorage.setItem("six-storage-security_token", sso_response["authenticationResult"]["accessToken"]);
              }

              if (typeof Storage !== "undefined") {
                if (_this48.reInitiatePhoneNumber === false) {
                  _this48.helper.sixStorageInitTelephoneNumber();
                }

                document.getElementById("six_storage_firstname").value = _response19.result.firstName;
                document.getElementById("six_storage_lastname").value = _response19.result.lastName;
                document.getElementById("six_storage_email").value = _response19.result.email;
                document.getElementById("six_storage_email").setAttribute("disabled", "disabled");
                var phone1Field = document.getElementById("six_storage_phone1");
                sessionStorage.setItem("userId", _response19.result.userId);

                if (typeof _response19.result.accessCode !== 'undefined' && _response19.result.accessCode !== null && _response19.result.accessCode !== '') {
                  sessionStorage.setItem("accessCode", _response19.result.accessCode);
                }

                sessionStorage.setItem("six_storage_sessionObject", JSON.stringify(_response19.result));
                _this48.currentStepNumber += 1;
                var sessionObj = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
                var businessUser = sessionObj.businessUser;

                var tenanttype = _this48.helper.sixStorageGetTenantType();

                if (_this48.businessUserEnabled === true) {
                  if (tenanttype == false && businessUser == false) {
                    _this48.sixStorageRenderStepHtml();
                  } else if (tenanttype == true && businessUser == true) {
                    _this48.sixStorageRenderStepHtml();
                  } else if (tenanttype == true && businessUser == false) {
                    _this48.sixStorageRemoveAuthentication();

                    sessionStorage.removeItem("six_storage_sessionObject");
                    _this48.currentStepNumber -= 1;
                    document.getElementById('six-storage-personal_usr-err').style.display = '';
                  } else if (tenanttype == false && businessUser == true) {
                    _this48.sixStorageRemoveAuthentication();

                    sessionStorage.removeItem("six_storage_sessionObject");
                    _this48.currentStepNumber -= 1;
                    document.getElementById('six-storage-business_usr-err').style.display = '';
                  }
                } else {
                  _this48.sixStorageRenderStepHtml();
                }

                var phoneInstance = window.intlTelInputGlobals.getInstance(phone1Field);
                phoneInstance.setNumber(_response19.result.phoneNumber);
                phone1Field.setAttribute("disabled", "disabled");
                document.getElementById("six-storage-phone1Label").classList.add("six-storage-active");
                document.getElementById("six-storage-phone2Label").classList.add("six-storage-active"); //document.getElementById("six-storage-mobilelabel").classList.add("six-storage-active");

                document.querySelector('.six-storage-phone-field-1 .iti__selected-flag').setAttribute('tabindex', '-1');
                var profileInfo = _response19.result;

                if (typeof profileInfo !== 'undefined' && profileInfo !== null) {
                  document.getElementById("six_storage_address1").value = typeof profileInfo.addressLineOne !== "undefined" && profileInfo.addressLineOne != null && profileInfo.addressLineOne != "null" && profileInfo.addressLineOne != "" ? profileInfo.addressLineOne : "";
                  document.getElementById("six_storage_address2").value = typeof profileInfo.addressLineTwo !== "undefined" && profileInfo.addressLineTwo != null && profileInfo.addressLineTwo != "null" && profileInfo.addressLineTwo != "" ? profileInfo.addressLineTwo : "";
                  document.getElementById("six_storage_state").value = typeof profileInfo.state !== "undefined" && profileInfo.state != null && profileInfo.state != "null" && profileInfo.state != "" ? profileInfo.state : "";
                  document.getElementById("six_storage_zip_code").value = typeof profileInfo.zipCode !== "undefined" && profileInfo.zipCode != null && profileInfo.zipCode != "null" && profileInfo.zipCode != "" ? profileInfo.zipCode : "";
                  document.getElementById("six_storage_city").value = typeof profileInfo.city !== "undefined" && profileInfo.city != null && profileInfo.city != "null" && profileInfo.city != "" ? profileInfo.city : "";
                  document.getElementById("six_storage_country").value = typeof profileInfo.country !== "undefined" && profileInfo.country != null && profileInfo.country != "null" && profileInfo.country != "" ? profileInfo.country : "";
                }

                _materialize["default"].updateTextFields();
              }
            } else {
              if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                var _initialloaders13 = document.getElementById("six-storage-loading-container");

                _initialloaders13.style.display = 'none';
              }

              document.getElementById("six-storage-sign-in-response").style.display = "block";

              if (_response19.returnMessage !== 'Failed') {
                document.getElementById("six-storage-sign-in-response").innerHTML = _response19.returnMessage;
              } else {
                document.getElementById("six-storage-sign-in-response").style.display = 'none';
              }
            }
          } else {
            document.getElementById("six-storage-sign-in-response").style.display = "block";

            if (response.returnMessage !== 'Failed') {
              document.getElementById("six-storage-sign-in-response").innerHTML = response.returnMessage;
            } else {
              document.getElementById("six-storage-sign-in-response").style.display = 'none';
            }
          }
        })["catch"](function (error) {
          document.getElementById("six-storage-loading-container").innerHTML = _this48.helper.sixStorageShowBusyIndicator(false);

          if (wordpress_vars.six_storage_online_setup_preloader === "0") {
            var _initialloaders14 = document.getElementById("six-storage-loading-container");

            _initialloaders14.style.display = 'none';
          }

          document.getElementById("six-storage-sign-in-response").innerHTML = "".concat(wordpress_vars.six_storage_online_fs_invalid_user_name_password);
        });
      }
    }
  }, {
    key: "sixStorageConstructreservepage",
    value: function sixStorageConstructreservepage(reserveunitsSelected) {
      var _this49 = this;

      if (this.listedUnit.length > 0) {
        this.unitsSelected = this.listedUnit;
      }

      if (this.unitsSelected.length === 0) {
        // document.getElementById("six-storage-rent-now-err").innerHTML = `${/*Please Select Units To Reserve*/ wordpress_vars.six_storage_online_mi_Please_Select_Units_Reserve}`;
        this.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_mi_Please_Select_Units_Reserve), true);
        document.getElementById("six-storage-rent-now-err").style.display = "";
        return;
      }

      if (this.unitsSelected.length > 1) {
        this.helper.sixStorageShowMessage("".concat(
        /*Please Select One Unit To Reserve*/
        wordpress_vars.six_storage_online_fc_please_select_one_unit_to_reserve), true);
        return;
      }

      var leadObj = JSON.parse(sessionStorage.getItem("leadConfig"));

      if (leadObj === null || typeof leadObj === 'undefined' || leadObj === "") {
        var formData = new FormData();
        formData.append("action", "six_storage_get_lead_config");
        var header = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;"
          },
          body: this.helper.sixStorageGetURIParams(formData)
        };
        var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
        document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
        fetch(url, header).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (typeof data !== "undefined" && data !== null) {
            var _response20 = JSON.parse(data);

            sessionStorage.setItem("sixStorageleadConfig", JSON.stringify(_response20.result));

            var _formData = new FormData();

            _formData.append("action", "six_storage_construct_reservation_page");

            _formData.append("unitId", _this49.unitsSelected);

            var _header = {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded;"
              },
              body: _this49.helper.sixStorageGetURIParams(_formData)
            };
            var _url = document.getElementById("six-storage-template-ajax-url").dataset.url;
            fetch(_url, _header).then(function (response) {
              return response.json();
            }).then(function (data) {
              document.getElementById("six-storage-loading-container").innerHTML = _this49.helper.sixStorageShowBusyIndicator(false);

              if (typeof data !== 'undefined' && data !== null) {
                var _response21 = JSON.parse(data);

                if (typeof _response21.isSuccess !== 'undefined' && _response21 !== null && _response21.isSuccess === true) {
                  if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                    var initialloaders = document.getElementById("six-storage-loading-container");
                    initialloaders.style.display = 'none';
                  }

                  _this49.sixStorageNewReservationModal(_response21.result);
                } else {
                  if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                    var _initialloaders15 = document.getElementById("six-storage-loading-container");

                    _initialloaders15.style.display = 'none';
                  }

                  document.getElementById("six-storage-loading-container").innerHTML = _this49.helper.sixStorageShowBusyIndicator(false);
                }
              } else {
                document.getElementById("six-storage-loading-container").innerHTML = _this49.helper.sixStorageShowBusyIndicator(false);
              }
            })["catch"](function (err) {
              console.log(err);
              document.getElementById("six-storage-loading-container").innerHTML = _this49.helper.sixStorageShowBusyIndicator(false);
            });
          }
        });
      }
    }
  }, {
    key: "sixStorageReservenowptwofour",
    value: function sixStorageReservenowptwofour(paymentresponse, unitInfodetails) {
      var _this50 = this;

      var userInformation = JSON.parse(sessionStorage.getItem("userInformation"));

      if (paymentresponse !== 'undefined' && paymentresponse !== undefined && paymentresponse !== null && paymentresponse !== "" && typeof paymentresponse.transaction !== 'undefined' && paymentresponse.transaction !== null && paymentresponse.transaction === "RESERVATION") {
        unitInfodetails["paymentInformation"] = {
          paymentMode: "CREDIT CARD",
          referenceNumber: paymentresponse.referenceNumber !== null ? paymentresponse.referenceNumber : paymentresponse.type,
          paidAmount: unitInfodetails.grossAmount,
          paymentReferenceId: paymentresponse.token
        };
      } else if (paymentresponse !== 'undefined' && paymentresponse !== undefined && paymentresponse !== null && paymentresponse !== "") {
        var paymentinformation = {
          paymentMode: "CREDIT CARD",
          referenceNumber: paymentresponse.last4Digit ? paymentresponse.last4Digit : paymentresponse.type,
          paidAmount: unitInfodetails.grossAmount,
          paymentReferenceId: paymentresponse.transactionId ? paymentresponse.transactionId : paymentresponse.token
        };
        unitInfodetails["paymentInformation"] = paymentinformation;
      }

      unitInfodetails["userInformation"] = this.reservationUserDetails;
      var reserveUnit = unitInfodetails;
      reserveUnit.userInformation = userInformation;
      console.log("reserveUnit", reserveUnit);
      var formData = new FormData();
      formData.append("action", "six_storage_reserve_unit_now");
      formData.append("unitsInfo", JSON.stringify(reserveUnit));
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== 'undefined' && data !== null) {
          var _response22 = JSON.parse(data);

          if (typeof _response22.isSuccess !== 'undefined' && _response22 !== null && _response22.isSuccess === true) {
            _this50.helper.sixStorageShowMessage("".concat(
            /*Reserved Units Sucessfully Updated*/
            wordpress_vars.six_storage_online_fs_Reserved_Units_Sucessfully), false);

            if (_this50.unitsSelectedInfo !== null && _this50.unitsSelectedInfo !== 'undefined' && _this50.unitsSelectedInfo.length > 0) {
              _this50.unitsSelectedInfo.map(function (item, i) {
                var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

                if (typeof checkbox !== "undefined" && checkbox !== null) {
                  checkbox.checked = false;
                }

                _this50.sixStorageUpdateUnitSelection(item.id);

                _this50.reservationPayment = false;
              });
            }

            _this50.reservationPayment = false;
            var redirectrentnowurl = sessionStorage.getItem("rentnowurl");

            if (typeof redirectrentnowurl !== "undefined" && redirectrentnowurl !== null) {
              window.location = redirectrentnowurl;
            }
          } else {
            _this50.helper.sixStorageShowMessage("".concat(
            /*Something went wrong please contact support team*/
            wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);

            _this50.reservationPayment = false;
          }
        }
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "sixStorageReservenow",
    value: function sixStorageReservenow(paymentresponse) {
      var _this51 = this;

      if (paymentresponse !== 'undefined' && paymentresponse !== undefined && paymentresponse !== null && paymentresponse !== "" && typeof paymentresponse.transaction !== 'undefined' && paymentresponse.transaction !== null && paymentresponse.transaction === "RESERVATION") {
        this.unitinfoDetails["paymentInformation"] = {
          paymentMode: "CREDIT CARD",
          referenceNumber: paymentresponse.referenceNumber !== null ? paymentresponse.referenceNumber : paymentresponse.type,
          paidAmount: this.unitinfoDetails.grossAmount,
          paymentReferenceId: paymentresponse.token
        };
      } else if (paymentresponse !== 'undefined' && paymentresponse !== undefined && paymentresponse !== null && paymentresponse !== "") {
        var paymentinformation = {
          paymentMode: "CREDIT CARD",
          referenceNumber: paymentresponse.last4Digit ? paymentresponse.last4Digit : paymentresponse.type,
          paidAmount: this.unitinfoDetails.grossAmount,
          paymentReferenceId: paymentresponse.transactionId ? paymentresponse.transactionId : paymentresponse.token
        };
        this.unitinfoDetails["paymentInformation"] = paymentinformation;
      } // const redirectrentnowurl = sessionStorage.getItem("rentnowurl");
      // console.log(redirectrentnowurl);
      // if(typeof redirectrentnowurl !=="undefined" && redirectrentnowurl !==null){
      //      window.location = redirectrentnowurl;
      // }
      // const clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      // if(clientConfig.culture.paymentGateway === "P24"){
      //   if (paymentresponse !== 'undefined' && paymentresponse !== undefined && paymentresponse !== null && paymentresponse !== "" && typeof paymentresponse.transaction !== 'undefined' && paymentresponse.transaction !== null && paymentresponse.transaction === "RESERVATION") {
      //   }
      // }


      this.unitinfoDetails["userInformation"] = this.reservationUserDetails;
      var reserveUnit = this.unitinfoDetails;
      var formData = new FormData();
      formData.append("action", "six_storage_reserve_unit_now");
      formData.append("unitsInfo", JSON.stringify(reserveUnit));
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this51.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response23 = JSON.parse(data);

          if (typeof _response23.isSuccess !== 'undefined' && _response23 !== null && _response23.isSuccess === true) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var initialloaders = document.getElementById("six-storage-loading-container");
              initialloaders.style.display = 'none';
            }

            if (_this51.unitsSelectedInfo !== null && _this51.unitsSelectedInfo !== 'undefined' && _this51.unitsSelectedInfo.length > 0) {
              _this51.unitsSelectedInfo.map(function (item, i) {
                var checkbox = document.getElementById("six-storage-unit-selection-" + item.id);

                if (typeof checkbox !== "undefined" && checkbox !== null) {
                  checkbox.checked = false;
                }

                _this51.sixStorageUpdateUnitSelection(item.id);

                _this51.reservationPayment = false;
              });
            }

            _this51.helper.sixStorageShowMessage("".concat(
            /*Reserved Units Sucessfully Updated*/
            wordpress_vars.six_storage_online_fs_Reserved_Units_Sucessfully), false); // setTimeout(() => {


            var enquiryModal = document.getElementById("six-storage-movein-modal");

            var instance = _materialize["default"].Modal.getInstance(enquiryModal);

            instance.close(); //}, 4500);

            _this51.reservationPayment = false;

            _this51.sixStorageSearchUnits();
          } else {
            _this51.helper.sixStorageShowMessage("".concat(
            /*Something went wrong please contact support team*/
            wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true); // setTimeout(() => {


            var _enquiryModal = document.getElementById("six-storage-movein-modal");

            var instance = _materialize["default"].Modal.getInstance(_enquiryModal);

            instance.close(); // }, 4500);

            _this51.reservationPayment = false;
          }
        } else {
          _this51.helper.sixStorageShowMessage("".concat(
          /*Something went wrong please contact support team*/
          wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true); //setTimeout(() => {


          var _enquiryModal2 = document.getElementById("six-storage-movein-modal");

          var instance = _materialize["default"].Modal.getInstance(_enquiryModal2);

          instance.close(); //}, 4500);

          _this51.reservationPayment = false;
        }
      })["catch"](function (err) {
        console.log(err);
        document.getElementById("six-storage-loading-container").innerHTML = _this51.helper.sixStorageShowBusyIndicator(false);

        _this51.helper.sixStorageShowMessage("".concat(
        /*Something went wrong please contact support team*/
        wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true); //setTimeout(() => {


        var enquiryModal = document.getElementById("six-storage-movein-modal");

        var instance = _materialize["default"].Modal.getInstance(enquiryModal);

        instance.close(); //}, 4500);

        _this51.reservationPayment = false;
      });
    }
  }, {
    key: "sixStorageEnquiry",
    value: function sixStorageEnquiry(unittypeId) {
      var _this52 = this;

      document.getElementById('six-storage-Enqemail-err').innerHTML = "".concat(wordpress_vars.six_storage_online_fs_Please_Enter_Email);
      document.getElementById("six-storage-Enqphone-err").innerHTML = "".concat(
      /*Please Enter Phone Number*/
      wordpress_vars.six_storage_online_fs_Please_Enter_Phone_Number);
      var storagetypeId = document.getElementById("six-storage-storage-type");
      var locationId = document.getElementById("six-storage-location");
      var unitTypeId = document.getElementById("six-storage-unit-type");
      var EnqfirstName = document.getElementById("six-storage-EnqfirstName");
      var EnqlastName = document.getElementById("six-storage-EnqlastName");
      var Enqemail = document.getElementById("six-storage-Enqemail");
      var Enqphone = document.getElementById("six-storage-Enqphone");
      var Enqleadsource = document.getElementById("six-storage-Enqleadsource"); //const Enqsource = document.getElementById("Enqsource");

      var dtcontactdate = document.getElementById("six-storage-dtcontactdate");
      var Leadsourcecomment = document.getElementById("six-storage-Leadsourcecomment");
      var els = document.getElementsByName('contactType');
      var contactPreference = [];

      for (var i = 0; i < els.length; i++) {
        if (els[i].checked) {
          contactPreference.push(els[i].value);
        }
      }

      if (this.rentSingleUnit === true && this.groupBySize === true) {
        var unitTypeID = unittypeId;
      } else if (this.rentSingleUnit === false && this.groupBySize === true) {
        unitTypeID = unitTypeId.value;
      } else {
        unitTypeID = unitTypeId.value;
      }

      var phoneInstance = window.intlTelInputGlobals.getInstance(Enqphone);
      var obj = {
        storagetypeId: typeof storagetypeId !== null && storagetypeId !== "undefined" && storagetypeId.value !== null && storagetypeId.value !== "undefined" ? storagetypeId.value : null,
        locationId: typeof locationId !== null && locationId !== "undefined" ? locationId.value : null,
        unittypeID: typeof unitTypeID !== null && unitTypeID !== "undefined" ? unitTypeID : null,
        EnqfirstName: typeof EnqfirstName !== null && EnqfirstName !== "undefined" && EnqfirstName.value !== null && EnqfirstName.value !== "undefined" ? EnqfirstName.value : null,
        EnqlastName: typeof EnqlastName !== null && EnqlastName !== "undefined" && EnqlastName.value !== null && EnqlastName.value !== "undefined" ? EnqlastName.value : null,
        Enqemail: typeof Enqemail !== null && Enqemail !== "undefined" && Enqemail.value !== null && Enqemail.value !== "undefined" ? Enqemail.value : null,
        Enqphone: typeof phoneInstance !== null && phoneInstance !== "undefined" && phoneInstance.getNumber() !== null && phoneInstance.getNumber() !== "undefined" ? phoneInstance.getNumber() : null,
        Enqleadsource: typeof Enqleadsource !== null && Enqleadsource !== "undefined" && Enqleadsource !== "" && Enqleadsource.value !== null && Enqleadsource.value !== "undefined" && Enqleadsource.value !== "" ? Enqleadsource.value : "",
        dtcontactdate: typeof dtcontactdate !== null && dtcontactdate !== "undefined" && dtcontactdate.value !== null && dtcontactdate.value !== "undefined" ? dtcontactdate.value : null,
        Leadsourcecomment: typeof Leadsourcecomment !== null && Leadsourcecomment !== "undefined" && Leadsourcecomment.value !== null && Leadsourcecomment.value !== "undefined" ? Leadsourcecomment.value : null,
        ContactPreference: typeof contactPreference !== null && contactPreference !== "undefined" && contactPreference.value !== null && contactPreference.value !== "undefined" ? contactPreference : null
      };
      var error_count = 0;
      Object.entries(obj).forEach(function (_ref21) {
        var _ref22 = _slicedToArray(_ref21, 2),
            key = _ref22[0],
            value = _ref22[1];

        if (key === "Enqemail" || key === "EnqfirstName" || key === "Enqphone" || key === "ContactPreference") {
          if (value == null || value == "undefined" || value == "") {
            document.getElementById("six-storage-" + key + "-err").style.display = "Block";
            error_count = error_count + 1;
            return false;
          } else {
            if (key === "Enqemail") {
              if (!_this52.helper.sixStorageValidateEmail(document.getElementById("six-storage-" + key))) {
                error_count = error_count + 1;
              }
            } else {
              var ele = document.getElementById("six-storage-" + key + "-err");

              if (ele) {
                ele.style.display = "none";
              }
            }
          }
        }
      });

      if (Enqphone.value.length === 1) {
        document.getElementById("six-storage-Enqphone-err").style.display = 'block';
        document.getElementById("six-storage-Enqphone-err").innerHTML = "".concat(wordpress_vars.six_storage_online_Please_Enter_Valid_Number);
        error_count = error_count + 1;
      }

      var leadsource = typeof obj.Enqleadsource !== "" && typeof obj.Enqleadsource !== null && obj.Enqleadsource !== "" ? obj.Enqleadsource : "00000000-0000-0000-0000-000000000000";
      this.preferredStorage = {
        storageTypeId: obj.storagetypeId,
        locationId: obj.locationId,
        unitTypeId: obj.unittypeID
      };
      this.contactPreferences = {
        contactDate: this.helper.sixStorageReadDate(obj.dtcontactdate),
        message: obj.Leadsourcecomment,
        contactPreference: contactPreference
      };

      if (error_count > 0) {
        return;
      }

      var enqinformation = {
        preferredStorage: this.preferredStorage,
        firstName: obj.EnqfirstName,
        lastName: obj.EnqlastName,
        email: obj.Enqemail,
        mobile: obj.Enqphone,
        leadSource: leadsource,
        contactPreferences: this.contactPreferences
      };
      var formData = new FormData();
      formData.append("action", "six_storage_enquiry_now");
      formData.append("enqinformation", JSON.stringify(enqinformation));
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      } // setTimeout(() => {


      var enquiryModal = document.getElementById("six-storage-movein-modal");

      var instance = _materialize["default"].Modal.getInstance(enquiryModal);

      instance.close(); //  },);

      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this52.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response24 = JSON.parse(data);

          if (wordpress_vars.six_storage_online_setup_preloader === "0") {
            var _initialloaders16 = document.getElementById("six-storage-loading-container");

            _initialloaders16.style.display = 'none';
          }

          if (typeof _response24.isSuccess !== 'undefined' && _response24 !== null && _response24.isSuccess === true) {
            _this52.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_fs_Your_enquiry_Sucessfully_Updated), false);
          } else {
            _this52.helper.sixStorageShowMessage("".concat(
            /*Something went wrong please contact support team*/
            wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);

            document.getElementById('six-storage-enquiry-response').style.display = "block";
            document.getElementById('six-storage-enquiry-response').innerHTML = 'Failed';
          }
        } else {
          _this52.helper.sixStorageShowMessage("".concat(
          /*Something went wrong please contact support team*/
          wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);

          document.getElementById('six-storage-enquiry-response').style.display = "block";
          document.getElementById('six-storage-enquiry-response').innerHTML = 'Failed';
        }
      })["catch"](function (err) {
        console.log(err);

        _this52.helper.sixStorageShowMessage("".concat(
        /*Something went wrong please contact support team*/
        wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);

        document.getElementById("six-storage-loading-container").innerHTML = _this52.helper.sixStorageShowBusyIndicator(false);
        document.getElementById('six-storage-enquiry-response').style.display = "block";
        document.getElementById('six-storage-enquiry-response').innerHTML = "".concat(
        /*Something went wrong please contact support team*/
        wordpress_vars.six_storage_online_fs_Something_went_wrong_please);
      });
    }
  }, {
    key: "sixStorageSignUp",
    value: function sixStorageSignUp() {
      var _this53 = this;

      document.getElementById("six-storage-signupConfirmemail-err").innerHTML = "".concat(wordpress_vars.six_storage_online_please_enter_email);
      document.getElementById("six-storage-signupconfirmPassword-err").innerHTML = "".concat(wordpress_vars.six_storage_online_please_enter_confirm_password);
      document.getElementById('six-storage-signupUserName-err').innerHTML = "".concat(wordpress_vars.six_storage_online_fs_sf_user_name_validation);
      document.getElementById('six-storage-terms-checkbox-err').innerHTML = "".concat(wordpress_vars.six_storage_online_fs_Please_Accept_the_Terms_and_Conditions);
      var signupfirstName = document.getElementById("six-storage-signupfirstName");
      var signuplastName = document.getElementById("six-storage-signuplastName");
      var signupemail = document.getElementById("six-storage-signupemail");
      var signupConfirmemail = document.getElementById("six-storage-signupConfirmemail");
      var signupphone = document.getElementById("six-storage-signupphone");
      var signuppassword = document.getElementById("six-storage-signuppassword");
      var signupconfirmPassword = document.getElementById("six-storage-signupconfirmPassword");
      var signupUserName = document.getElementById("six-storage-signupUserName");
      var chkmsg = document.getElementById('six-storage-terms-checkbox');
      var phoneInstance = window.intlTelInputGlobals.getInstance(signupphone);
      var obj = {
        signupfirstName: typeof signupfirstName !== "undefined" && signupfirstName !== null && typeof signupfirstName.value !== "undefined" && signupfirstName.value !== null ? signupfirstName.value : null,
        signuplastName: typeof signuplastName !== "undefined" && signuplastName !== null && typeof signuplastName.value !== "undefined" && signuplastName.value !== null ? signuplastName.value : null,
        signupemail: typeof signupemail !== "undefined" && signupemail !== null && typeof signupemail.value !== "undefined" && signupemail.value !== null ? signupemail.value : null,
        signupConfirmemail: typeof signupConfirmemail !== "undefined" && signupConfirmemail !== null && typeof signupConfirmemail.value !== "undefined" && signupConfirmemail.value !== null ? signupConfirmemail.value : null,
        signupphone: typeof phoneInstance !== "undefined" && phoneInstance !== null && typeof phoneInstance.getNumber() !== "undefined" && phoneInstance.getNumber() !== null ? phoneInstance.getNumber() : null,
        signuppassword: typeof signuppassword !== "undefined" && signuppassword !== null && typeof signuppassword.value !== "undefined" && signuppassword.value !== null ? signuppassword.value : null,
        signupconfirmPassword: typeof signupconfirmPassword !== "undefined" && signupconfirmPassword !== null && typeof signupconfirmPassword.value !== "undefined" && signupconfirmPassword.value !== null ? signupconfirmPassword.value : null,
        signupUserName: typeof signupUserName !== "undefined" && signupUserName !== null && typeof signupUserName.value !== "undefined" && signupUserName.value !== null ? signupUserName.value : null,
        chkmsg: typeof chkmsg !== 'undefined' && chkmsg !== null && typeof chkmsg.value !== 'undefined' && chkmsg.value !== null ? chkmsg.value : null,
        action: "six_storage_sign_up"
      };
      var error_count = 0;
      Object.entries(obj).forEach(function (_ref23) {
        var _ref24 = _slicedToArray(_ref23, 2),
            key = _ref24[0],
            value = _ref24[1];

        if (value == null || value == "" || key !== "signupUserName" && value.length < 1 || key === "signupUserName" && value.length < 3) {
          if (key === "signupConfirmemail") {
            document.getElementById("six-storage-" + key + "-err").innerHTML = "".concat(
            /*Please Confirm Email*/
            wordpress_vars.six_storage_online_fs_sf_confirm_email_validation);
          } else if (key === "signupUserName" && value.length !== 0 && value.length < 3) {
            document.getElementById("six-storage-" + key + "-err").innerHTML = "".concat(
            /*signupusernmae validation*/
            wordpress_vars.six_storage_online_fs_sf_signupUsername_validation);
          }

          document.getElementById("six-storage-" + key + "-err").style.display = "block";
          error_count = error_count + 1;
          return false;
        } else {
          if (key === "signupemail") {
            if (!_this53.helper.sixStorageValidateEmail(document.getElementById("six-storage-" + key))) {
              error_count = error_count + 1;
            }
          } else {
            var ele = document.getElementById("six-storage-" + key + "-err");

            if (ele) {
              ele.style.display = "none";
            }
          }
        }
      });

      if (obj["signupemail"].length !== 0 && obj["signupConfirmemail"].length !== 0) {
        if (obj["signupemail"] !== obj["signupConfirmemail"]) {
          var ele = document.getElementById("six-storage-signupConfirmemail-err");

          if (ele) {
            ele.innerHTML = "".concat(
            /*Email Not Matched*/
            wordpress_vars.six_storage_online_email_mismatched);
            error_count = error_count + 1;
            ele.style.display = "";
          } else {
            if (ele) {
              ele.style.display = "none";
            }
          }
        }
      } else {
        if (signupemail.value.length === 0) {
          document.getElementById('six-storage-signupemail-err').innerHTML = "".concat(wordpress_vars.six_storage_online_fs_Please_Enter_Email);
        } else if (signupConfirmemail.value.length === 0) {
          document.getElementById('six-storage-signupConfirmemail-err').innerHTML = "".concat(
          /*Please Confirm Email*/
          wordpress_vars.six_storage_online_mi_Please_Confirm_Email);
        }
      }

      if (chkmsg.checked == false) {
        if (window.sixStorage_online_region === 'us') {
          error_count = error_count + 1;
          document.getElementById('six-storage-terms-checkbox-err').innerHTML = "".concat(wordpress_vars.six_storage_online_fs_Please_Accept_the_Terms_and_Conditions, " ");
          document.getElementById('six-storage-terms-checkbox-err').style.display = "block";
        }
      } else {
        document.getElementById('six-storage-terms-checkbox-err').style.display = "none";
      }

      if (signupconfirmPassword.value.length !== 0 && signuppassword.value.length !== 0) {
        if (signupconfirmPassword.value !== signuppassword.value) {
          document.getElementById("six-storage-signupconfirmPassword-err").innerHTML = "".concat(wordpress_vars.six_storage_online_fs_Password_Mismatched);
          document.getElementById("six-storage-signupconfirmPassword-err").style.display = "block";
        }
      } else {
        if (signupconfirmPassword.value.length === 0) {
          document.getElementById('six-storage-signupconfirmPassword-err').innerHTML = "".concat(wordpress_vars.six_storage_online_please_enter_confirm_password);
        } else if (signuppassword.value.length === 0) {
          document.getElementById('six-storage-signuppassword-err').innerHTML = "".concat(wordpress_vars.six_storage_online_fs_Please_Enter_Password);
        }
      }

      if (error_count == 0) {
        if (wordpress_vars.six_storage_online_setup_preloader === "0") {
          var initialloaders = document.getElementById("six-storage-loading-container");
          initialloaders.style.display = 'block';
        }

        if (this.sixStorageValidateUsernamePaswordPolicy(signupUserName, signuppassword.value, document.getElementById("six-storage-sign-up-response"))) {
          document.getElementById("six-storage-sign-up-response").style.display = "none";
          var formData = new FormData();
          formData.append("action", "six_storage_sign_up");
          formData.append("firstName", obj.signupfirstName);
          formData.append("lastName", obj.signuplastName);
          formData.append("email", obj.signupemail);
          formData.append("phone", obj.signupphone);
          formData.append("password", obj.signuppassword);
          formData.append("confirmPassword", obj.signupconfirmPassword);
          formData.append("signupUserName", obj.signupUserName);
          var header = {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;"
            },
            body: this.helper.sixStorageGetURIParams(formData)
          };
          var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
          document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
          fetch(url, header).then(function (response) {
            return response.json();
          }).then(function (data) {
            document.getElementById("six-storage-loading-container").innerHTML = _this53.helper.sixStorageShowBusyIndicator(false);

            if (typeof data !== "undefined" && data !== null) {
              var _response25 = JSON.parse(data);

              if (typeof _response25.isSuccess !== "undefined" && _response25 !== null && _response25.isSuccess === true && _response25.returnCode === "SUCCESS") {
                if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                  var _initialloaders17 = document.getElementById("six-storage-loading-container");

                  _initialloaders17.style.display = 'none';
                }

                var sessionObj = {
                  firstName: obj.signupfirstName,
                  lastName: obj.signuplastName,
                  email: obj.signupemail,
                  phoneNumber: obj.signupphone,
                  userId: _response25.result,
                  userName: obj.signupUserName
                };
                _this53.signUpReponse = sessionObj;

                if (typeof wordpress_vars !== 'undefined' && wordpress_vars !== null && typeof wordpress_vars.sso_enabled !== 'undefined' && wordpress_vars.sso_enabled !== null && (wordpress_vars.sso_enabled === true || wordpress_vars.sso_enabled === "1")) {
                  var codeDeliveryMedia = _response25["additionalResource"]["codeDeliveryDetails"];

                  _this53.sixStorageConfirmationCodeModal("sign_up", _this53.signUpReponse.userName, obj.signuppassword, codeDeliveryMedia);
                } else {
                  _this53.sixStorageGetUserInfo(_response25.result, false, false);

                  _this53.sixStorageGoToTenantDetails(_this53.signUpReponse);
                }
              } else {
                if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                  var _initialloaders18 = document.getElementById("six-storage-loading-container");

                  _initialloaders18.style.display = 'none';
                }

                document.getElementById("six-storage-sign-up-response").style.display = "block";

                if (typeof _response25.errors !== "undefined" && _response25.errors !== null && _response25.errors.length > 0) {
                  document.getElementById("six-storage-sign-up-response").innerHTML = _response25.errors.join("\n");
                } else {
                  if (_response25.returnMessage !== 'Failed') {
                    document.getElementById("six-storage-sign-up-response").innerHTML = _response25.returnMessage;
                  } else {
                    document.getElementById("six-storage-sign-up-response").style.display = 'none';
                  }
                }
              }
            } else {
              document.getElementById("six-storage-sign-up-response").style.display = "block";
              document.getElementById("six-storage-sign-up-response").innerHTML = "".concat(
              /*Something went wrong, please contact administrator*/
              wordpress_vars.six_storage_online_su_Something_went_wrong, ". ");
            }
          })["catch"](function () {
            document.getElementById("six-storage-loading-container").innerHTML = _this53.helper.sixStorageShowBusyIndicator(false);
          });
        } else {
          document.getElementById("six-storage-sign-up-response").style.display = "block";
        }
      }
    }
  }, {
    key: "sixStorageGoToTenantDetails",
    value: function sixStorageGoToTenantDetails(obj) {
      this.helper.sixStorageInitTelephoneNumber("#six_storage_phone1");
      this.helper.sixStorageInitTelephoneNumber("#six_storage_phone2");
      this.helper.sixStorageInitTelephoneNumber("#six-storage-emergency_contact_phone");
      sessionStorage.setItem("userId", obj.userId);
      sessionStorage.setItem("firstName", obj.firstName);
      sessionStorage.setItem("lastName", obj.lastName);
      sessionStorage.setItem("email", obj.email);
      sessionStorage.setItem("phone", obj.phoneNumber);
      sessionStorage.setItem("userName", obj.userName);
      sessionStorage.setItem("six_storage_sessionObject", JSON.stringify(obj)); // document.getElementById("six-storage-sign-up-response").style.display = "block";
      // document.getElementById("six-storage-sign-up-response").innerHTML = "Successfully Registered !...";

      document.getElementById("six_storage_firstname").value = obj.firstName;
      document.getElementById("six_storage_lastname").value = obj.lastName;
      document.getElementById("six_storage_email").value = obj.email;
      document.getElementById("six_storage_address1").value = "";
      document.getElementById("six_storage_address2").value = "";
      document.getElementById("six_storage_state").value = "";
      document.getElementById("six_storage_zip_code").value = "";
      document.getElementById("six_storage_city").value = "";
      document.getElementById("six_storage_country").value = "";
      document.getElementById("six_storage_email").setAttribute("disabled", "disabled");
      var sixStoragePhone1 = document.getElementById("six_storage_phone1");
      var phoneInstance = window.intlTelInputGlobals.getInstance(sixStoragePhone1);

      if (phoneInstance !== null && typeof phoneInstance !== 'undefined') {
        _materialize["default"].updateTextFields();

        phoneInstance.setNumber(obj.phoneNumber);
        document.getElementById("six_storage_phone1").setAttribute("disabled", "disabled");
      }

      document.getElementById("six-storage-phone1Label").classList.add("six-storage-active");
      document.getElementById("six-storage-phone2Label").classList.add("six-storage-active"); //document.getElementById("six-storage-mobilelabel").classList.add("six-storage-active");

      this.currentStepNumber += 1;
      this.sixStorageRenderStepHtml();
    }
  }, {
    key: "sixStorageSafeBox",
    value: function sixStorageSafeBox() {
      var safeBox = document.getElementById("six-storage-unit-key-in-safe-box");

      if (safeBox.checked == true) {
        this.tentnantDetails["unit_key_in_safe_box"] = true; //console.log("safeBox", this.tentnantDetails);
      } else {
        this.tentnantDetails["unit_key_in_safe_box"] = false; //console.log("safeBox", this.tentnantDetails);
      }
    }
  }, {
    key: "sixStorageUploadIdDocumentFiles",
    value: function sixStorageUploadIdDocumentFiles(fileType) {
      var _this54 = this;

      var documentFile = document.getElementById("six_storage_documentFile");
      var leaseProfileId = this.tentnantDetailsId;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      if (fileType === "IDNTY") {
        var formData = new FormData();
        formData.append("leaseProfileId", leaseProfileId);
        formData.append("fileType", fileType);

        for (var i = 0; i < documentFile.files.length; i++) {
          formData.append("files", documentFile.files[i]);
          var sixStoragerawFilename = documentFile.files[i].name;
          var sixStorageUploadFileNewName = this.helper.sixStorageFileNameChange(sixStoragerawFilename); //console.log(sixStorageUploadFileNewName);

          formData.append("fileName", sixStorageUploadFileNewName);
        }

        formData.append('action', 'six_storage_upload_document_files');
        var header = {
          method: "POST",
          headers: {
            "processData": false
          },
          body: formData
        };
        var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
        document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
        fetch(url, header).then(function (response) {
          return response.json();
        }).then(function (data) {
          document.getElementById("six-storage-loading-container").innerHTML = _this54.helper.sixStorageShowBusyIndicator(false);

          if (typeof data !== "undefined" && data !== null) {
            var _response26 = JSON.parse(data);

            if (typeof _response26.isSuccess !== "undefined" && _response26 !== null && _response26.isSuccess === true && _response26.returnMessage == "SUCCESS") {
              if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                var _initialloaders19 = document.getElementById("six-storage-loading-container");

                _initialloaders19.style.display = 'none';
              }
            } else {
              if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                var _initialloaders20 = document.getElementById("six-storage-loading-container");

                _initialloaders20.style.display = 'none';
              }
            }
          } else {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders21 = document.getElementById("six-storage-loading-container");

              _initialloaders21.style.display = 'none';
            }
          }
        })["catch"](function (err) {
          console.error(err);
          document.getElementById("six-storage-loading-container").innerHTML = _this54.helper.sixStorageShowBusyIndicator(false);
        });
      }
    }
  }, {
    key: "sixStoragePaymentFormAllListing",
    value: function sixStoragePaymentFormAllListing(paymentModeText, paymentModeId) {
      var _this55 = this;

      sessionStorage.setItem("paymentModeType", paymentModeText);
      var payapaymentform;
      var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));

      if (typeof clientConfig !== "undefined" && clientConfig !== null) {
        payapaymentform = clientConfig.culture.paymentGateway;
      }

      var autoPayEnabled = false;
      var saveCard = false;
      var autoPay = document.getElementById("six-storage-turn_on_autopay");
      var save_card_autopay = document.getElementById("six-storage-save_card_autopay");

      if (typeof autoPay !== 'undefined' && autoPay !== null && autoPay.checked === true) {
        autoPayEnabled = true;
      }

      if (typeof save_card_autopay !== 'undefined' && save_card_autopay !== null && save_card_autopay.checked === true) {
        saveCard = true;
      }

      var userId = sessionStorage.getItem("userId");
      document.getElementById('six-storage-dvPaymentForm').style.display = '';
      document.getElementById('six-storage-promo_six-storage-discount_carousel').style.display = 'none';
      var leaseProfileId = this.tentnantDetailsId;
      var moveInPayloadData = this.moveInData;
      moveInPayloadData.saveCard = saveCard;
      moveInPayloadData.enableAutopay = autoPayEnabled;
      var payloadobject = JSON.stringify({
        "ProfileId": leaseProfileId,
        "MoveinParam": moveInPayloadData
      });

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append("action", "six_storage_lease_payment_form");
      formData.append("chargeableAmount", this.moveInData.grossAmount);
      formData.append("leaseProfileId", leaseProfileId);
      formData.append("paymentModeId", paymentModeId);

      if (paymentModeText === "CreditCard" && payapaymentform === "PAYA") {
        formData.append("callPlace", 'MOVEIN');
        formData.append("payloadObject", payloadobject);
        formData.append("transactionType", 'sale');
        formData.append("userId", userId);
        formData.append("paymentModeText", paymentModeText);
      }

      formData.append("hostURL", this.helper.sixStorageGetHostURL());
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response27 = JSON.parse(data);

          if (typeof _response27.isSuccess !== "undefined" && _response27 !== null && _response27.isSuccess === true) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders22 = document.getElementById("six-storage-loading-container");

              _initialloaders22.style.display = 'none';
            }

            document.getElementById("six-storage-payment-form-div").style.display = 'block';
            var sixstoragepaymentform = document.getElementById("six-storage-payment-form-div").classList;
            sixstoragepaymentform.remove('six-storage-d-none');
            sixstoragepaymentform.add('six-storage-flexbox-important'); // if(this.esignEnabled === true){
            //   document.getElementById("six-storage-canvas-clear").style.display="none";
            //   }

            document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(true);

            if (_response27.additionalResource == "P24" || _response27.additionalResource === "SQUARE-UP") {
              var dashboardUrl = document.getElementById("six-storage-dashboard-url").value;
              sessionStorage.setItem("Dashboardurl", dashboardUrl);

              var _clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));

              if (_response27.additionalResource === "SQUARE-UP") {
                if (_clientConfig.culture.isSavedCardsByDefault == true) {
                  document.getElementById("six-storage-autopay-notes").style.display = "block";
                  document.getElementById("six-storage-card_actions").style.display = "none";
                } else {
                  document.getElementById("six-storage-card_actions").style.display = "block";
                  document.getElementById("six-storage-autopay-notes").style.display = "none";
                }
              }

              document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(false);

              if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                // document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
                // document.getElementById('six-storage-dvPaymentForm').style.display = 'block';
                // document.getElementById("six-storage-dvPaymentForm").innerHTML = `<button class="six-storage-btn cc" style="position:relative;left:25%;" onclick="window.open('${response.result}','_blank');sixStorageShowLoader();">
                //   ${wordpress_vars.six_storage_online_mi_click_here_to_pay}
                //   </button>`;
                document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(true);
                window.location = _response27.result;
              } else {
                //this.helper.sixStorageOpenNewWindow(response.result, '', 768, 580);
                window.location = _response27.result;
              } //window.open(response.result);

            } else {
              var _clientConfig2 = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));

              document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(true);
              document.getElementById("six-storage-dvPaymentForm").innerHTML = "<iframe name=\"iframePaymentForm\" id=\"six-storage-iframePaymentFormMoveIn\"style=\"width:100%;height:850px;\"></iframe>";
              var paymentForm = document.getElementById("six-storage-iframePaymentFormMoveIn");
              _this55.paymentGateway = _response27.additionalResource;

              if (_response27.additionalResource !== "P24" && _clientConfig2.culture.isSavedCardsByDefault == true) {
                document.getElementById("six-storage-card_actions").style.display = "none";

                if (_response27.additionalResource === "HYPERPAY" || _response27.additionalResource === "RAPYD") {
                  document.getElementById("six-storage-autopay-notes").style.display = "block";
                }
              } else if (_response27.additionalResource !== "P24" && _clientConfig2.culture.isSavedCardsByDefault == false) {
                document.getElementById("six-storage-card_actions").style.display = "block";
              } else if (_response27.additionalResource === "NETS" || _response27.additionalResource.indexOf("EMERCH") > -1 || paymentModeText !== 'CreditCard') {
                document.getElementById("six-storage-card_actions").style.display = "none";
                _this55.sepaPaymentclicked = true;
              } else {
                _this55.sepaPaymentclicked = false;
                document.getElementById("six-storage-card_actions").style.display = "block";
                document.getElementById('six-storage-iban-notes').style.display = 'none';
              }

              if (paymentModeText == 'DirectDebit') {
                _this55.sepaPaymentclicked = true;
                _this55.autopaynotes = true;
                document.getElementById('six-storage-autopay-notes').style.display = 'none';
                document.getElementById("six-storage-card_actions").style.display = "none";
              } else {
                _this55.autopaynotes = false;
              }

              if (_response27.additionalResource == "STRIPE") {
                document.getElementById("six-storage-iframePaymentFormMoveIn").style.height = "450px";
              }

              if (_response27.additionalResource == "RAPYD") {
                document.getElementById("six-storage-rapyd-alignment").style.width = "100%";
              }

              if (typeof paymentForm !== "undefined" && paymentForm !== null) {
                paymentForm.setAttribute("src", encodeURI(_response27.result));
              }

              _this55.helper.sixStorageResizeIframe("#six-storage-iframePaymentFormMoveIn");

              if (wordpress_vars.paylater_enabled !== true && wordpress_vars.paylater_enabled !== "1") {// document.getElementById("six-storage-proceed-payment").style.display = "none";
              }

              var result = _clientConfig2.paymentModes.filter(function (i) {
                return i.value !== 'PayLater';
              });

              document.getElementById("six-storage-cancel-movein").style.display = "block";
              document.getElementById("six-storage-go-back").style.display = "none";
              document.getElementById("six-storage-creditgrid-card-payment").style.display = "";
              var booknowPaylater = document.getElementById("six-storage-book-now-pay-later");

              if (typeof booknowPaylater !== 'undefined' && booknowPaylater !== null) {
                document.getElementById("six-storage-book-now-pay-later").style.display = "none";
              }

              if (typeof paymentForm !== "undefined" && paymentForm !== null) {
                paymentForm.onload = function () {
                  document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(false);
                };
              }
            }
          } else {
            //console.log(data);
            document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(false);
            document.getElementById("six-storage-dvPaymentForm").innerHTML = "".concat(
            /*Unable to load payment form*/
            wordpress_vars.six_storage_online_fc_Unable_to_load_payment_form);
          }
        } else {
          //console.log(data);
          document.getElementById("six-storage-loading-container").innerHTML = _this55.helper.sixStorageShowBusyIndicator(false);
          document.getElementById("six-storage-dvPaymentForm").innerHTML = "".concat(
          /*Unable to load payment form*/
          wordpress_vars.six_storage_online_fc_Unable_to_load_payment_form);
        }
      });
    }
  }, {
    key: "sixStorageUploadEsignatureFiles",
    value: function sixStorageUploadEsignatureFiles(fileType, esignImg, fileName, isPaylater, paymentModeId) {
      var _this56 = this;

      var formData = new FormData();
      var leaseProfileId = this.tentnantDetailsId; // formData.append('files', blob, `ESIGN_${tenantId}_${Date.now()}.png`);

      formData.append("leaseProfileId", leaseProfileId);
      formData.append("fileType", fileType);
      formData.append('files', esignImg); //formData.append("fileName", fileName);

      formData.append('action', 'six_storage_upload_esign_files');
      var header = {
        method: "POST",
        headers: {
          "processData": false
        },
        body: formData
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this56.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response28 = JSON.parse(data);

          if (typeof _response28.isSuccess !== "undefined" && _response28 !== null && _response28.isSuccess === true && _response28.returnMessage == "SUCCESS") {
            if (typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater !== '' && isPaylater !== "CreditCard" && isPaylater === "paymentGateway" && isPaylater !== true && isPaylater !== false) {
              _this56.sixStorageSaveMoveinDetails();
            } else if (typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater !== '' && isPaylater !== "CreditCard" && isPaylater === true) {
              _this56.sixStorageSaveMoveinDetails(true, null, true);
            } else if (typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater !== '' && isPaylater !== "CreditCard" && isPaylater === false) {
              _this56.sixStorageSaveMoveinDetails(false, paymentModeId);
            } else {
              _this56.sixStoragePaymentFormAllListing(isPaylater, paymentModeId);
            }
          } else {
            if (typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater !== '' && isPaylater !== "CreditCard" && isPaylater === "paymentGateway" && isPaylater !== true && isPaylater !== false) {
              _this56.sixStorageSaveMoveinDetails();
            } else if (typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater !== '' && isPaylater !== "CreditCard" && isPaylater === true) {
              _this56.sixStorageSaveMoveinDetails(true, null, true);
            } else if (typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater !== '' && isPaylater !== "CreditCard" && isPaylater === false) {
              _this56.sixStorageSaveMoveinDetails(false, paymentModeId);
            } else {
              _this56.sixStoragePaymentFormAllListing(isPaylater, paymentModeId);
            }
          }
        }
      })["catch"](function (err) {
        console.error(err);
        document.getElementById("six-storage-loading-container").innerHTML = _this56.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageUploadDocumentsToServer",
    value: function sixStorageUploadDocumentsToServer(idType) {
      var _this57 = this;

      var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
      var tenantId = currentSession.userId;
      var leaseProfileId = this.tentnantDetailsId;
      var identity_type = document.getElementById("six-storage-identity_type");
      var documentTypeId = identity_type.value;

      if (idType === "ESIGN") {
        fileData = this.signaturePad.toDataURL();
        fileName = "ESIGN_".concat(tenantId, "_").concat(Date.now(), ".png");
      }

      if (typeof fileData == "undefined" || fileData == null || fileData == "" || typeof fileName == "undefined" || fileName == null || fileName == "") {
        return null;
      } else {
        var formData = new FormData();
        formData.append("action", "six_storage_upload_documents_to_server");
        formData.append("leaseProfileId", leaseProfileId);
        formData.append("fileType", idType);
        formData.append("fileData", fileData);
        formData.append("fileName", fileName);
        var header = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;"
          },
          body: this.helper.sixStorageGetURIParams(formData)
        };
        var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
        fetch(url, header).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (typeof data !== "undefined" && data !== null) {
            var _response29 = JSON.parse(data);

            if (typeof _response29.isSuccess !== "undefined" && _response29.isSuccess !== null && _response29.isSuccess === true) {
              _this57.identityDocumentId = _response29.result;
            } else {//document.getElementById("six_storage_documentFile-err").style.display = "block";
              //console.log(response);
            }
          } else {//document.getElementById("six_storage_documentFile-err").style.display = "block";
            }
        })["catch"](function (error) {//document.getElementById("six_storage_documentFile-err").style.display = "block";
          //console.log(error);
        });
      }
    }
  }, {
    key: "sixStorageUploadIdDocumentDetails",
    value: function sixStorageUploadIdDocumentDetails() {
      var _this58 = this;

      //console.log(this.documentsPath);
      var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject")); //console.log(currentSession);

      var tenantId = currentSession.userId; //console.log("tenantId = " + tenantId);

      var leaseProfileId = this.tentnantDetailsId;
      var identity_type = document.getElementById("six-storage-identity_type");
      var identityInformation = [];
      var idFields = document.getElementsByClassName("six-storage-identity-fields_".concat(identity_type.value));

      if (idFields.length > 0) {
        Array.prototype.forEach.call(idFields, function (field) {
          if (typeof field.value == "undefined" || field.value == null || field.value == "") {
            document.getElementById(field.id + "-err").style.display = "block";
          } else {
            identityInformation.push({
              fieldId: field.dataset.fieldid,
              fieldValue: field.value
            });
            document.getElementById(field.id + "-err").style.display = "none";
          }
        });
      }

      var documentTypeId = identity_type.value;

      if (identityInformation.length === 0) {
        return;
      } else {
        var formData = new FormData();
        formData.append("action", "six_storage_upload_document_details");
        formData.append("leaseProfileId", leaseProfileId);
        formData.append("documentTypeId", documentTypeId);
        formData.append("identityFields", JSON.stringify(identityInformation));
        formData.append("documentId", this.identityDocumentId);
        var header = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;"
          },
          body: this.helper.sixStorageGetURIParams(formData)
        };
        var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
        document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
        fetch(url, header).then(function (response) {
          return response.json();
        }).then(function (data) {
          document.getElementById("six-storage-loading-container").innerHTML = _this58.helper.sixStorageShowBusyIndicator(false);

          if (typeof data !== "undefined" && data !== null) {
            var _response30 = JSON.parse(data);

            if (typeof _response30.isSuccess !== "undefined" && _response30.isSuccess !== null && _response30.isSuccess === true) {
              _this58.identityDocumentId = _response30.result;
            } else {//document.getElementById("six_storage_documentFile-err").style.display = "block";
              //console.log(response);
            }
          } else {//document.getElementById("six_storage_documentFile-err").style.display = "block";
              //console.log(data);
            }
        })["catch"](function (error) {//document.getElementById("six_storage_documentFile-err").style.display = "block";
          //console.log(error);
        });
      }
    }
  }, {
    key: "sixStorageOnChangePaymentMode",
    value: function sixStorageOnChangePaymentMode(message) {
      var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      document.getElementById("six-storage-autopay-notes").style.display = "none";

      if (message === true && this.paymentGateway !== "P24" && clientConfig.culture.isSavedCardsByDefault == true) {
        document.getElementById("six-storage-card_actions").style.display = "none";

        if (this.autopaynotes == false) {
          document.getElementById("six-storage-autopay-notes").style.display = "";
        } else if (this.autopaynotes == true) {
          document.getElementById("six-storage-iban-notes").style.display = "none";
          document.getElementById("six-storage-autopay-notes").style.display = "";
        }
      } else if (message === false && this.paymentGateway === 'WORLDPAY') {
        document.getElementById("six-storage-card_actions").style.display = "none";
        document.getElementById("six-storage-save_card_autopay").checked = false;
        document.getElementById("six-storage-turn_on_autopay").checked = false;
      } else if (message === true && this.paymentGateway !== "NETS" && this.sepaPaymentclicked == false) {
        document.getElementById("six-storage-card_actions").style.display = "";
      } else {
        document.getElementById("six-storage-card_actions").style.display = "none";

        if (this.autopaynotes == true && clientConfig.culture.isSavedCardsByDefault == false) {
          document.getElementById("six-storage-iban-notes").style.display = "block";
        }
      }
    }
  }, {
    key: "sixStorageOnMessage",
    value: function sixStorageOnMessage(event) {
      var origin = location.hostname; // Check sender origin to be trusted

      if (event.origin.indexOf("localhost") > -1 || event.origin.indexOf("8storage") > -1 || event.origin.indexOf("6storage") > -1 || event.origin.indexOf("mystoragedemo")) {
        var data = event.data;

        if (typeof window[data.func] === "function") {
          window[data.func].call(null, data.message);
        }
      }
    }
  }, {
    key: "sixStorageOnPaymentProcessed",
    value: function sixStorageOnPaymentProcessed(jsonResponse) {
      var _this59 = this;

      var paymentResponse = JSON.parse(jsonResponse);
      var payapaymentgateway = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      this.paymentTransactionResponse = paymentResponse;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      var payapaymentform = sessionStorage.getItem("paymentModeType");

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      if (paymentResponse.paymentStatus.toUpperCase() === "SUCCESS" && this.reservationPayment === true) {
        if (typeof payapaymentgateway !== "undefined" && payapaymentgateway !== null && payapaymentgateway.culture.paymentGateway === "STRIPE") {
          document.getElementById("six-storage-iframePaymentFormReservation").style.display = "none";
        }

        if (typeof payapaymentgateway !== "undefined" && payapaymentgateway !== null && payapaymentgateway.culture.paymentGateway === "PAYA") {
          this.helper.sixStorageShowMessage("".concat(
          /*Reserved Units Sucessfully Updated*/
          wordpress_vars.six_storage_online_fs_Reserved_Units_Sucessfully), false);
          var reservationmodal = document.getElementById('six-storage-movein-modal');

          var instance = _materialize["default"].Modal.getInstance(reservationmodal);

          instance.close();
          document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
          this.sixStorageSearchUnits(true);
          this.reservationPayment = false;
        } else {
          this.sixStorageReservenow(this.paymentTransactionResponse);
        }
      } else if (paymentResponse.paymentStatus.toUpperCase() === "SUCCESS") {
        if (typeof payapaymentgateway !== "undefined" && payapaymentgateway !== null && payapaymentgateway.culture.paymentGateway === "STRIPE") {
          document.getElementById("six-storage-iframePaymentFormMoveIn").style.display = "none";
        }

        if (typeof payapaymentform !== "undefined" && payapaymentform !== null && payapaymentform === "CreditCard" && payapaymentgateway.culture.paymentGateway === "PAYA") {
          setTimeout(function () {
            document.getElementById("six-storage-loading-container").innerHTML = _this59.helper.sixStorageShowBusyIndicator(false);
            var dashboardUrl = document.getElementById("six-storage-dashboard-url").value;

            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders23 = document.getElementById("six-storage-loading-container");

              _initialloaders23.style.display = 'block';
            }

            window.location.href = dashboardUrl;
          }, 8000);
        } else {
          var eSignEnabled = true;
          var canvasebabled = true;
          var canvasValue = document.getElementById('six-storage-signature-canvas');
          var esignatureFile = this.signaturePad._data;

          if (this.esignEnabled === true && typeof esignatureFile !== 'undefined' && esignatureFile !== null && esignatureFile !== "" && esignatureFile.length > 0) {
            var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
            var tenantId = currentSession.userId;

            if (typeof canvasValue !== "undefined" && canvasValue !== null && canvasValue !== "") {
              canvasValue.toBlob(function (blob) {
                _this59.esignfile = new File([blob], "ESIGN_".concat(tenantId, "_").concat(Date.now(), ".png"), {
                  type: "image/png"
                });
                var fileName = "ESIGN_".concat(tenantId, "_").concat(Date.now(), ".png");

                _this59.sixStorageUploadEsignatureFiles("ESIGN", _this59.esignfile, fileName, "paymentGateway");
              });
            }
          } else {
            this.sixStorageSaveMoveinDetails();
          }
        }
      } else if (paymentResponse.paymentStatus.toUpperCase() === "FAILED") {
        document.getElementById("six-storage-proceed-payment").innerHTML = "".concat(
        /*Try Again*/
        wordpress_vars.six_storage_online_fs_Try_Again);
        document.getElementById("six-storage-proceed-payment").style.display = "";
        document.getElementById("six-storage-card_actions").style.display = "none";
      }
    }
  }, {
    key: "sixStorageAddCardDetails",
    value: function sixStorageAddCardDetails(paymentResponse) {
      var _this60 = this;

      var userId = sessionStorage.getItem("userId");
      var cardNumber = '';

      if (typeof paymentResponse !== 'undefined' && paymentResponse !== null && paymentResponse !== '' && typeof paymentResponse.type !== 'undefined' && paymentResponse.type !== null && paymentResponse.type !== '' && typeof paymentResponse.status !== 'undefined' && paymentResponse.status !== null && paymentResponse.status !== '' && paymentResponse.status === 'success') {
        cardNumber = paymentResponse.referenceNumber;
      } else {
        cardNumber = paymentResponse["last4Digit"];
      }

      var formData = new FormData();
      formData.append("action", "six_storage_add_user_card");
      formData.append("cardLastFour", cardNumber);
      formData.append("userId", userId);

      if (typeof wordpress_vars.six_storage_online_tenant_activity_enable !== 'undefined' && wordpress_vars.six_storage_online_tenant_activity_enable !== null && wordpress_vars.six_storage_online_tenant_activity_enable !== '' && wordpress_vars.six_storage_online_tenant_activity_enable !== '0') {
        formData.append("logger", JSON.stringify(this.helper.userAccessInfo));
      }

      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this60.helper.sixStorageShowBusyIndicator(false);
      })["catch"](function (error) {
        document.getElementById("six-storage-loading-container").innerHTML = _this60.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "paymentForm",
    value: function paymentForm(paymentModeId, paymentModeText, savecard) {
      var _this61 = this;

      var payapaymentform;
      var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));

      if (typeof clientConfig !== "undefined" && clientConfig !== null) {
        payapaymentform = clientConfig.culture.paymentGateway;

        if (payapaymentform === "PAYA" && paymentModeText === "CreditCard") {
          if (typeof this.geteAccessInfo !== 'undefined' && this.geteAccessInfo !== null && this.geteAccessInfo.length > 0) {
            this.geteAccessInfo.forEach(function (unit) {
              var unitIndex = _this61.moveInData.units.findIndex(function (x) {
                return x.unitInfo.id.toUpperCase() === unit.unitId.toUpperCase();
              });

              if (unitIndex > -1) {
                _this61.moveInData.units[unitIndex]["securityGate"] = unit;
              }
            });
          }

          var eSignEnabled = true;
          var canvasValue = document.getElementById('six-storage-signature-canvas');
          var esignatureFile = this.signaturePad._data;

          if (this.esignEnabled === true && typeof esignatureFile !== 'undefined' && esignatureFile !== null && esignatureFile !== "" && esignatureFile.length > 0) {
            var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
            var tenantId = currentSession.userId;

            if (typeof canvasValue !== "undefined" && canvasValue !== null && canvasValue !== "") {
              canvasValue.toBlob(function (blob) {
                _this61.esignfile = new File([blob], "ESIGN_".concat(tenantId, "_").concat(Date.now(), ".png"), {
                  type: "image/png"
                });
                var fileName = "ESIGN_".concat(tenantId, "_").concat(Date.now(), ".png");

                if (typeof savecard !== "undefined" && savecard !== null && savecard !== "" && savecard === true) {
                  _this61.sixStoragePaymentFormAllListing(paymentModeText, paymentModeId);
                } else {
                  _this61.sixStorageUploadEsignatureFiles("ESIGN", _this61.esignfile, fileName, paymentModeText, paymentModeId);
                }
              });
            }
          } else {
            this.sixStoragePaymentFormAllListing(paymentModeText, paymentModeId);
          }
        } else if (payapaymentform === "P24" || payapaymentform === "SQUARE-UP") {
          var _eSignEnabled = true;

          var _canvasValue = document.getElementById('six-storage-signature-canvas');

          var _esignatureFile = this.signaturePad._data;

          if (this.esignEnabled === true && typeof _esignatureFile !== 'undefined' && _esignatureFile !== null && _esignatureFile !== "" && _esignatureFile.length > 0) {
            var _currentSession3 = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));

            var _tenantId = _currentSession3.userId;

            if (typeof _canvasValue !== "undefined" && _canvasValue !== null && _canvasValue !== "") {
              _canvasValue.toBlob(function (blob) {
                _this61.esignfile = new File([blob], "ESIGN_".concat(_tenantId, "_").concat(Date.now(), ".png"), {
                  type: "image/png"
                });
                var fileName = "ESIGN_".concat(_tenantId, "_").concat(Date.now(), ".png");

                _this61.sixStorageptwofourTenantesign("ESIGN", _this61.esignfile, fileName, paymentModeText, paymentModeId);
              });
            }
          } else {
            this.sixStoragePaymentFormAllListing(paymentModeText, paymentModeId);
          }
        } else {
          this.sixStoragePaymentFormAllListing(paymentModeText, paymentModeId);
        }
      }
    }
  }, {
    key: "sixStorageptwofourTenantesign",
    value: function sixStorageptwofourTenantesign(files, esignfile, filename, paymentModeText, paymentModeId) {
      var _this62 = this;

      var formData = new FormData();
      var leaseProfileId = this.tentnantDetailsId;
      formData.append("leaseProfileId", leaseProfileId);
      formData.append("fileType", files);
      formData.append('files', esignfile);
      formData.append('action', 'six_storage_upload_esign_files');
      var header = {
        method: "POST",
        headers: {
          "processData": false
        },
        body: formData
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this62.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response31 = JSON.parse(data);

          if (typeof _response31.isSuccess !== "undefined" && _response31 !== null && _response31.isSuccess === true && _response31.returnMessage == "SUCCESS") {
            _this62.sixStoragePaymentFormAllListing(paymentModeText, paymentModeId);
          } else {
            _this62.sixStoragePaymentFormAllListing(paymentModeText, paymentModeId);
          }
        }
      })["catch"](function (err) {
        console.error(err);
        document.getElementById("six-storage-loading-container").innerHTML = _this62.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageLoadAddCardPaymentForm",
    value: function sixStorageLoadAddCardPaymentForm(paymentTypeId, isDirectDebit) {
      var _this63 = this;

      var userId = sessionStorage.getItem("userId");
      var clientConfigs = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var formData = new FormData();
      formData.append("action", "six_storage_add_credit_card_form");
      formData.append("hostURL", this.helper.sixStorageGetHostURL());
      formData.append("userId", userId);
      formData.append("paymentModeId", paymentTypeId);

      if (typeof wordpress_vars.six_storage_online_tenant_activity_enable !== 'undefined' && wordpress_vars.six_storage_online_tenant_activity_enable !== null && wordpress_vars.six_storage_online_tenant_activity_enable !== '' && wordpress_vars.six_storage_online_tenant_activity_enable !== '0') {
        formData.append('log', JSON.stringify(this.helper.userAccessInfo));
      }

      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this63.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response32 = JSON.parse(data);

          if (typeof _response32.isSuccess !== "undefined" && _response32 !== null && _response32.isSuccess === true) {
            var canvasValue = document.getElementById('six-storage-signature-canvas');
            document.getElementById("six-storage-loading-container").innerHTML = _this63.helper.sixStorageShowBusyIndicator(true);

            if (_response32.additionalResource == "P24") {
              if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                document.getElementById("six-storage-loading-container").innerHTML = _this63.helper.sixStorageShowBusyIndicator(false);
                document.getElementById('six-storage-dvPaymentForm').style.display = 'block';
                document.getElementById("six-storage-dvPaymentForm").innerHTML = "<button class=\"six-storage-btn cc\" style=\"position:relative;left:25%;\" onclick=\"window.open('".concat(_response32.result, "','_blank');sixStorageShowLoader();\">\n                        ").concat(wordpress_vars.six_storage_online_mi_click_here_to_pay, "\n                        </button>");
              } else {
                _this63.helper.sixStorageOpenNewWindow(_response32.result, '', 768, 580);
              } //window.open(response.result);

            } else {
              document.getElementById("six-storage-loading-container").innerHTML = _this63.helper.sixStorageShowBusyIndicator(true);
              document.getElementById("six-storage-dvPaymentForm").innerHTML = "<iframe name=\"iframePaymentForm\" id=\"six-storage-iframePaymentFormMoveIn\"style=\"width:100%;height:850px;\"></iframe>";

              if (typeof clientConfigs !== "undefined" && clientConfigs !== null && clientConfigs !== "") {
                var movinApprovalProcess = clientConfigs.customSettings.filter(function (i) {
                  return i.settingName === "ENABLE_MOVEIN_APPROVAL";
                });

                if (typeof movinApprovalProcess !== "undefined" && movinApprovalProcess !== null && movinApprovalProcess.length > 0) {
                  if (movinApprovalProcess[0].settingValue === "YES") {
                    _this63.notecarddetails = true;
                  }

                  if (_this63.notecarddetails === true) {
                    var sixstoragemovinapprovalnote = document.getElementById("six-storagemovinapproval-note");
                    var sixstoragesavecardmovinapproval = document.getElementById("six-storage-save-card-movin-approval");

                    if (typeof sixstoragemovinapprovalnote !== "undefined" && sixstoragemovinapprovalnote !== null) {
                      sixstoragemovinapprovalnote.style.display = 'none';
                    }

                    if (typeof sixstoragesavecardmovinapproval !== "undefined" && sixstoragesavecardmovinapproval !== null) {
                      sixstoragesavecardmovinapproval.style.display = 'none';
                    }
                  } else {
                    var _sixstoragemovinapprovalnote = document.getElementById("six-storagemovinapproval-note");

                    var _sixstoragesavecardmovinapproval = document.getElementById("six-storage-save-card-movin-approval");

                    if (typeof _sixstoragemovinapprovalnote !== "undefined" && _sixstoragemovinapprovalnote !== null) {
                      _sixstoragemovinapprovalnote.style.display = 'block';
                    }

                    if (typeof _sixstoragesavecardmovinapproval !== "undefined" && _sixstoragesavecardmovinapproval !== null) {
                      _sixstoragesavecardmovinapproval.style.display = 'block';
                    }
                  }
                }
              }

              var paymentForm = document.getElementById("six-storage-iframePaymentFormMoveIn");
              paymentForm.setAttribute("src", encodeURI(_response32.result));

              _this63.helper.sixStorageResizeIframe("#six-storage-iframePaymentFormMoveIn");

              if (wordpress_vars.paylater_enabled !== true && wordpress_vars.paylater_enabled !== "1") {
                document.getElementById("six-storage-proceed-payment").style.display = "none";
              }

              var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
              var result = clientConfig.paymentModes.filter(function (i) {
                return i.value !== 'PayLater';
              });
              document.getElementById("six-storage-cancel-movein").style.display = "block";
              document.getElementById("six-storage-go-back").style.display = "none";
              document.getElementById("six-storage-creditgrid-card-payment").style.display = "";
              var booknowPaylater = document.getElementById("six-storage-book-now-pay-later");

              if (typeof booknowPaylater !== 'undefined' && booknowPaylater !== null) {
                document.getElementById("six-storage-book-now-pay-later").style.display = "none";
              }

              paymentForm.onload = function () {
                document.getElementById("six-storage-loading-container").innerHTML = _this63.helper.sixStorageShowBusyIndicator(false);
              };
            }
          } else {
            _this63.helper.sixStorageShowMessage("".concat(
            /*Unable to load credit card form, please contact storage facility*/
            wordpress_vars.six_storage_online_fc_Unable_to_load_credit, "."), true);
          }
        } else {
          _this63.helper.sixStorageShowMessage("".concat(
          /*Unable to load credit card form, please contact storage facility*/
          wordpress_vars.six_storage_online_fc_Unable_to_load_credit, "."), true);
        }
      })["catch"](function () {
        document.getElementById("six-storage-loading-container").innerHTML = _this63.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "SixStorageUpdateprofile",
    value: function SixStorageUpdateprofile() {
      var _this64 = this;

      var userId = sessionStorage.getItem("userId");
      ;
      var firstName = document.getElementById("six_storage_firstname");
      var lastName = document.getElementById("six_storage_lastname");
      var email = document.getElementById("six_storage_email");
      var phoneNumber = document.getElementById("six_storage_phone1");
      var phoneNumbertwo = document.getElementById("six_storage_phone2");
      var addressLineOne = document.getElementById("six_storage_address1");
      var ssn = document.getElementById("six_storage_ssn_number");
      var phoneInstance = window.intlTelInputGlobals.getInstance(phoneNumber);
      var phoneInstancetwo = window.intlTelInputGlobals.getInstance(phoneNumbertwo);
      var obj = {
        firstName: typeof firstName !== 'undefined' && firstName !== null && typeof firstName.value !== 'undefined' && firstName.value !== null ? firstName.value : null,
        lastName: typeof lastName !== 'undefined' && lastName !== null && typeof lastName.value !== 'undefined' && lastName.value !== null ? lastName.value : null,
        email: typeof email !== 'undefined' && email !== null && typeof email.value !== 'undefined' && email.value !== null ? email.value : null,
        profilephoneNumber: typeof phoneInstance !== 'undefined' && phoneInstance !== null && typeof phoneInstance.getNumber() !== 'undefined' && phoneInstance.getNumber() !== null ? phoneInstance.getNumber() : null,
        phoneNumbertwo: typeof phoneInstancetwo !== 'undefined' && phoneInstancetwo !== null && typeof phoneInstancetwo.getNumber() !== 'undefined' && phoneInstancetwo.getNumber() !== null ? phoneInstancetwo.getNumber() : null,
        addressLineOne: typeof addressLineOne !== 'undefined' && addressLineOne !== null && typeof addressLineOne.value !== 'undefined' && addressLineOne.value !== null ? addressLineOne.value : null,
        ssn: typeof ssn !== 'undefined' && ssn !== null && typeof ssn.value !== 'undefined' && ssn.value !== null ? ssn.value : null
      };

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append('action', "six_storage_update_profile");
      formData.append('userId', userId);
      formData.append('firstName', obj.firstName);
      formData.append('lastName', obj.lastName);
      formData.append('email', obj.email);
      formData.append('phoneNumber', obj.profilephoneNumber);
      formData.append('phoneNumber2', obj.phoneNumbertwo);
      formData.append('ssn', obj.ssn);
      formData.append('addressLineOne', obj.addressLineOne);
      var header = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;'
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById('six-storage-template-ajax-url').dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this64.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response33 = JSON.parse(data);

          if (typeof _response33.isSuccess !== 'undefined' && _response33 !== null && _response33.isSuccess === true) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders24 = document.getElementById("six-storage-loading-container");

              _initialloaders24.style.display = 'none';
            }

            document.getElementById("six-storage-btnPromocode").style.display = 'block';
            document.getElementById("six-storage-promoCodetext").removeAttribute("disabled");
            document.getElementById("six-storage-btnPromocodeRemove").style.display = 'none'; //console.log(response);
          } else {}
        } else {}
      })["catch"](function () {// document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageSaveLeaseProfile",
    value: function sixStorageSaveLeaseProfile() {
      var _this65 = this;

      var storagetypeId;
      var locationId;
      var unitTypeId;

      if (typeof this.unitsRentInformation !== 'undefined' && this.unitsRentInformation !== null && this.unitsRentInformation !== '' && this.unitsRentInformation.length > 0) {
        storagetypeId = this.unitsRentInformation[0].unitInfo.storageType.id;
        locationId = this.unitsRentInformation[0].unitInfo.location.id;
        unitTypeId = this.unitsRentInformation[0].unitInfo.unitType.id;
      } // if (typeof this.tentnantDetails["six_storage_phone1"] !== 'undefined' && this.tentnantDetails["six_storage_phone1"] !== '' && this.tentnantDetails["six_storage_phone1"] !== null) {
      //   this.tentnantDetails["six_storage_phone1"] = this.tentnantDetails["six_storage_phone1"].replace("+", "#");
      // }
      // if (typeof this.tentnantDetails["six_storage_phone2"] !== 'undefined' && this.tentnantDetails["six_storage_phone2"] !== '' && this.tentnantDetails["six_storage_phone2"] !== null) {
      //   this.tentnantDetails["six_storage_phone2"] = this.tentnantDetails["six_storage_phone2"].replace("+", "#");
      // }


      var preferedStorage = {
        storagetypeId: typeof storagetypeId !== 'undefined' && storagetypeId !== null && storagetypeId !== "" ? storagetypeId : "00000000-0000-0000-0000-000000000000",
        locationId: typeof locationId !== 'undefined' && locationId !== null && locationId !== "" ? locationId : "00000000-0000-0000-0000-000000000000",
        unitTypeId: typeof unitTypeId !== 'undefined' && unitTypeId !== null && unitTypeId !== "" ? unitTypeId : "00000000-0000-0000-0000-000000000000"
      };
      var unitTypeID = preferedStorage.unitTypeId;

      if (this.groupBySize === true && this.rentSingleUnit === true) {
        unitTypeID = this.selectedunitTypeId;
      } else if (this.groupBySize === true && this.rentSingleUnit === false) {
        unitTypeID = this.groupBasedUnitID;
      }

      document.getElementById('six-storage-promoCodetext').value = '';
      var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
      this.tentnantDetailsFinal["id"] = this.tentnantDetailsId;
      this.tentnantDetailsFinal["tenantId"] = currentSession.userId;
      this.tentnantDetailsFinal["firstName"] = this.tentnantDetails["six_storage_firstname"];
      this.tentnantDetailsFinal["lastName"] = this.tentnantDetails["six_storage_lastname"];
      this.tentnantDetailsFinal["email"] = this.tentnantDetails["six_storage_email"];
      this.tentnantDetailsFinal["isBusinessUser"] = this.helper.sixStorageGetTenantType();
      this.tentnantDetailsFinal["phoneNumberOne"] = this.tentnantDetails["six_storage_phone1"];
      this.tentnantDetailsFinal["phoneNumberTwo"] = this.tentnantDetails["six_storage_phone2"];
      this.tentnantDetailsFinal["dob"] = this.tentnantDetails["six_storage_dob"] == "" || this.tentnantDetails["six_storage_dob"] == "NaN-NaN-NaN" ? null : this.tentnantDetails["six_storage_dob"];
      this.tentnantDetailsFinal["leadSourceId"] = this.tentnantDetails["six_storage_lead_source"] == "" ? "00000000-0000-0000-0000-000000000000" : this.tentnantDetails["six_storage_lead_source"];
      this.tentnantDetailsFinal["isUnitKeyInSafeBox"] = this.tentnantDetails["unit_key_in_safe_box"];
      this.tentnantDetailsFinal["isPrimaryAndDeliveryAddressSame"] = this.tentnantDetails["isPrimaryAndDeliveryAddressSame"];
      this.tentnantDetailsFinal["companyDetails"]["taxId"] = this.tentnantDetails["six_storage_company_tax_id"];
      this.tentnantDetailsFinal["companyDetails"]["companyWebsite"] = this.tentnantDetails["six_storage_company_website"];
      this.tentnantDetailsFinal["preferredStorage"] = {
        "storageTypeId": preferedStorage.storagetypeId,
        "locationId": preferedStorage.locationId,
        "unitTypeId": unitTypeID
      };
      this.tentnantDetailsFinal["profileAddress"]["id"] = null;
      this.tentnantDetailsFinal["profileAddress"]["addressLineOne"] = this.tentnantDetails["six_storage_address1"];
      this.tentnantDetailsFinal["profileAddress"]["addressLineTwo"] = this.tentnantDetails["six_storage_address2"];
      this.tentnantDetailsFinal["profileAddress"]["country"] = this.tentnantDetails["six_storage_country"];
      this.tentnantDetailsFinal["profileAddress"]["state"] = this.tentnantDetails["six_storage_state"];
      this.tentnantDetailsFinal["profileAddress"]["city"] = this.tentnantDetails["six_storage_city"];
      this.tentnantDetailsFinal["profileAddress"]["zipCode"] = this.tentnantDetails["six_storage_zip_code"];
      this.tentnantDetailsFinal["profileAddress"]["isDeliveryAddress"] = true;

      if (this.tentnantDetails["isPrimaryAndDeliveryAddressSame"]) {
        this.tentnantDetailsFinal["deliveryAddress"]["id"] = null;
        this.tentnantDetailsFinal["deliveryAddress"]["addressLineOne"] = this.tentnantDetails["six_storage_delivery_address1"];
        this.tentnantDetailsFinal["deliveryAddress"]["addressLineTwo"] = this.tentnantDetails["six_storage_delivery_address2"];
        this.tentnantDetailsFinal["deliveryAddress"]["country"] = this.tentnantDetails["six_storage_delivery_country"];
        this.tentnantDetailsFinal["deliveryAddress"]["state"] = this.tentnantDetails["six_storage_delivery_state"];
        this.tentnantDetailsFinal["deliveryAddress"]["city"] = this.tentnantDetails["six_storage_delivery_city"];
        this.tentnantDetailsFinal["deliveryAddress"]["zipCode"] = this.tentnantDetails["six_storage_delivery_zip_code"];
        this.tentnantDetailsFinal["deliveryAddress"]["isDeliveryAddress"] = true;
      }

      if (this.helper.sixStorageGetTenantType() == true) {
        this.tentnantDetailsFinal["companyDetails"]["companyName"] = this.tentnantDetails["six_storage_company_name"]; // this.tentnantDetailsFinal["companyDetails"]["companyWebsite"] = this.tentnantDetails["company_website"];
        // this.tentnantDetailsFinal["companyDetails"]["taxId"] = this.tentnantDetails["company_tax_id"];

        this.tentnantDetailsFinal["companyDetails"]["codiceFiscale"] = this.tentnantDetails["six_storage_company_codice_fiscale"];
        this.tentnantDetailsFinal["companyDetails"]["pecAddress"] = this.tentnantDetails["six_storage_company_pec_address"];
        this.tentnantDetailsFinal["companyDetails"]["transmissionChannelId"] = this.tentnantDetails["six_storage_company_tranmission_channel_id"];
      }

      if (this.customTenantDetailValues.length > 0 || this.customEmgContactValues.length > 0 || this.customUnitSpecificValues.length > 0 || this.customVehicleDetailsValues > 0 || this.customInsuranceDetailsValues.length > 0 || this.customThirdPartyInsuranceDetailsValues.length > 0) {
        this.tentnantDetailsFinal["customFields"] = this.customFieldsValues.concat(this.customTenantDetailValues, this.customEmgContactValues, this.customUnitSpecificValues, this.customVehicleDetailsValues, this.customInsuranceDetailsValues || this.customThirdPartyInsuranceDetailsValues);
      }

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append("action", "six_storage_lease_profile");
      formData.append("tentnantDetails", JSON.stringify(this.tentnantDetailsFinal));
      formData.append("tentnantDetailsId", this.tentnantDetailsId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this65.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response34 = JSON.parse(data);

          if (typeof _response34.isSuccess !== "undefined" && _response34.isSuccess !== null && _response34.isSuccess === true) {
            sessionStorage.removeItem("goback");

            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders25 = document.getElementById("six-storage-loading-container");

              _initialloaders25.style.display = 'none';
            }

            _this65.tentnantDetailsId = _response34.result;
            sessionStorage.setItem("profileId", JSON.stringify(_this65.tentnantDetailsId));
            var deliveryAddress = document.getElementById("delivery-address-is-same-as-above");
            document.getElementById("six-storage-name-display").innerHTML = _this65.tentnantDetails["six_storage_firstname"] + " " + _this65.tentnantDetails["six_storage_lastname"];
            document.getElementById("six-storage-email-display").innerHTML = _this65.tentnantDetails["six_storage_email"];

            var displayPhoneNumber = _this65.tentnantDetails["six_storage_phone1"].replace("#", "+");

            document.getElementById("six-storage-phone1-display").innerHTML = displayPhoneNumber;

            var address = _this65.getConcatinatedValue("", _this65.tentnantDetails["six_storage_address1"], ",");

            address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_address2"], ",");
            address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_city"], ",");
            address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_state"], ",");
            address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_country"], ",");

            if (_this65.tentnantDetails["six_storage_country"] === "") {
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_zip_code"], "");
            } else if (_this65.tentnantDetails["six_storage_country"] !== "" && _this65.tentnantDetails["six_storage_zip_code"] !== "") {
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_zip_code"], "");
            } else {
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_zip_code"], "");
            }

            document.getElementById("six-storage-address-display").innerHTML = address === "" ? "-" : address;

            if (deliveryAddress.checked) {
              document.getElementById("six-storage-delivery-address-display").innerHTML = address === "" ? "-" : address;
            } else {
              address = "";
              address = _this65.getConcatinatedValue("", _this65.tentnantDetails["six_storage_delivery_address1"], ",");
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_delivery_address2"], ",");
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_delivery_city"], ",");
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_delivery_state"], ",");
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_delivery_zip_code"], ",");
              address = _this65.getConcatinatedValue(address, _this65.tentnantDetails["six_storage_delivery_country"], "");
              document.getElementById("six-storage-delivery-address-display").innerHTML = address === "" ? "-" : address;
            }

            var _currentSession4 = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));

            if (typeof _currentSession4 !== "undefined" && _currentSession4 !== null) {
              _currentSession4.addressLineOne = _this65.tentnantDetailsFinal["profileAddress"]["addressLineOne"];
              _currentSession4.addressLineTwo = _this65.tentnantDetailsFinal["profileAddress"]["addressLineTwo"];
              _currentSession4.state = _this65.tentnantDetailsFinal["profileAddress"]["state"];
              _currentSession4.zipCode = _this65.tentnantDetailsFinal["profileAddress"]["zipCode"];
              _currentSession4.city = _this65.tentnantDetailsFinal["profileAddress"]["city"];
              _currentSession4.country = _this65.tentnantDetailsFinal["profileAddress"]["country"];
              sessionStorage.setItem("six_storage_sessionObject", JSON.stringify(_currentSession4));
            }

            if (_this65.vehicleInfo.length > 0) {
              _this65.sixStorageSaveVehicleInformation();
            }

            _this65.SixStorageUpdateprofile();

            _this65.sixStorageConstructterms();

            _this65.sixStorageUploadIdDocumentFiles("IDNTY");

            _this65.sixStorageRenderFinalUnitDetails(false);

            _this65.sixStorageUploadIdDocumentDetails();

            _materialize["default"].updateTextFields();
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this65.helper.sixStorageShowBusyIndicator(false); //console.log("save lease profile failed response", response);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this65.helper.sixStorageShowBusyIndicator(false); //console.log("data", data);
        }
      })["catch"](function (error) {
        document.getElementById("six-storage-loading-container").innerHTML = _this65.helper.sixStorageShowBusyIndicator(false); //console.log("error", error);
      });
    }
  }, {
    key: "getConcatinatedValue",
    value: function getConcatinatedValue(result, value, delimiter) {
      if (typeof value !== 'undefined' && value !== null && value !== "") {
        result = "".concat(result, " ").concat(value).concat(delimiter);
      } else {
        var n = result.lastIndexOf(delimiter);
        result = result.slice(0, n) + result.slice(n).replace(delimiter, "");
      }

      return result;
    }
  }, {
    key: "sixStorageClearConfidential",
    value: function sixStorageClearConfidential() {
      var ssntext = document.getElementById("six_storage_ssn_number").value;
      var ssnstringtextlength = document.getElementById("six_storage_ssn_number").value.length;
      var result = ssntext.replace(/[^X]/g, "").length;

      if (ssnstringtextlength === result) {
        document.getElementById("six_storage_ssn_number").value = "";
      }
    }
  }, {
    key: "sixStorageChangeTab",
    value: function sixStorageChangeTab(id) {
      document.getElementById("six-storage-user-details").style.display = "none";
      document.getElementById("six-storage-final-unit-details").style.display = "none";
      document.getElementById("six-storage-addon-details").style.display = "none";
      document.getElementById("six-storage-agreement-signature").style.display = "none";
      document.getElementById("six-storage-go-back").style.display = "block";
      document.getElementById("six-storage-cancel-movein").style.display = "none";
      document.getElementById(id).style.display = "block";
      document.querySelectorAll(".six-storage-btn-link.six-storage-collapsed").forEach(function (ele) {
        ele.classList.remove("six-storage-active");
      });
      document.querySelector("#".concat(id, "-btn")).classList.add("six-storage-active");
    }
  }, {
    key: "sixStorageRenderFinalUnitDetails",
    value: function sixStorageRenderFinalUnitDetails(applypromo) {
      var _this66 = this;

      this.reservationPayment = false;
      var units;

      if (typeof this.unitsSelected !== 'undefined' && this.unitsSelected !== '' && this.unitsSelected !== null && this.unitsSelected.length > 0) {
        units = this.unitsSelected;
      } else {
        units = this.sixStorageSelectedUnitIdByUnitType;
      }

      var promocode = document.getElementById('six-storage-promoCodetext');
      var moveInDate = this.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value);
      var invoice_period = document.getElementById("six-storage-invoice-period-new");
      var invoice_reccuring = document.getElementById("six-storage-invoice-reccuring-new");
      var additional_months = document.getElementById("six-storage-additional-months"); // const moveInDate = this.helper.sixStorageReadDate(document.getElementById("six-storage-movein-date").value);
      // const invoice_period = document.getElementById("six-storage-invoice-period");
      // const invoice_reccuring = document.getElementById("six-storage-invoice-reccuring");
      // const additional_months = document.getElementById("six-storage-additional-months");

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append("action", "six_storage_lease_calculation");

      if (wordpress_vars.six_storage_grouping_enable === "1" && wordpress_vars.six_storage_grouping_single_units !== "1") {
        formData.append("units", this.discountBasedUnit);
      } else {
        formData.append("units", units);
      }

      formData.append("moveInDate", moveInDate);
      formData.append("recurringPeriodId", invoice_period.value);
      formData.append("recurringTypeId", invoice_reccuring.value);
      formData.append("additionalMonths", additional_months.value);
      formData.append("promocode", promocode.value);
      formData.append("additionalServices", JSON.stringify(this.additionalServices));
      formData.append("merchItems", JSON.stringify(this.merchItems));
      formData.append("insuranceInfo", JSON.stringify(this.insuranceInfo));
      formData.append("isBusinessUser", this.helper.sixStorageGetTenantType());
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this66.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response35 = JSON.parse(data);

          if (typeof _response35 !== "undefined" && _response35 !== null && _response35.isSuccess === true) {
            _this66.moveInData = _response35.result;

            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders26 = document.getElementById("six-storage-loading-container");

              _initialloaders26.style.display = 'none';
            }

            sessionStorage.setItem("moveInData", JSON.stringify(_this66.moveInData));

            if (typeof applypromo !== "undefined" && applypromo !== null && applypromo !== "" && applypromo !== true) {
              _this66.sixStorageRenderLincesneAgreement();
            }

            _this66.sixStoragePaymentsection();

            document.getElementById("six-storage-tenant-details").style.display = "none";
            document.getElementById("six-storage-next-step").style.display = "none";
            var preview_payment = document.getElementById("six-storage-preview-payment");
            preview_payment.style.display = "block";

            if (_this66.promocodescroll !== true) {
              document.getElementById('six-storage-preview-payment').scrollIntoView({
                behavior: 'smooth'
              });
            }

            var html = _this66.generateUnitsDetails(_this66.moveInData);

            document.getElementById("six-storage-units-details-display").innerHTML = html;

            var serviceHtml = _this66.sixStorageGenerateCommodityDetails("SERVICE");

            var merchandiseHtml = _this66.sixStorageGenerateMerchandiseDetails();

            var insuranceHtml = _this66.sixStorageGenerateCommodityDetails("INSURANCE");

            if (typeof wordpress_vars.six_storage_google_analytics_integrated !== "undefined" && wordpress_vars.six_storage_google_analytics_integrated !== null && wordpress_vars.six_storage_google_analytics_integrated !== "" && wordpress_vars.six_storage_google_analytics_integrated === "1") {
              gtag('event', 'page_view', {
                page_title: 'Rent Now - Preview & Payment',
                page_location: 'Rent Now',
                page_path: '/rent-now#Payment',
                send_to: "".concat(wordpress_vars.six_storage_google_analytics_input_key)
              });
            } // Multibox custom text for insurance preview
            // document.getElementById('six-storage-addon-details').innerHTML = "<div style='text-align:center;'>Dodatkowe ubezpieczenie Allianz Agent Ubezpieczeniowy Dorota Pruszak" +
            //   "<h3>Kontakt:</h3>" + "<p>Tel: 601 176 997</p>" + "<p>e-mail: dorota.pruszak@port.allianz.pl</p></div>";
            // Below line need to comment for showing multibox custom text


            document.getElementById("six-storage-service-details").innerHTML = serviceHtml;
            document.getElementById("six-storage-merchandise-details-preview").innerHTML = merchandiseHtml;
            document.getElementById("six-storage-tbodyInsurancePreview").innerHTML = insuranceHtml;

            if (wordpress_vars.six_storage_online_fs_ad_insurance_toggle === "1") {
              if (_this66.moveInData.insuranceCharges > 0) {
                document.getElementById("six-storage-insurance_rate").innerHTML = _this66.helper.sixStorageDisplayCurrency(_this66.moveInData.insuranceCharges);
                document.getElementById("sixStorageInsurancehide").style.display = "";
                document.getElementById("six-storage-insurance_rate").style.display = "";

                if (typeof _this66.moveInData.nextInvoice !== "undefined" && _this66.moveInData.nextInvoice !== null) {
                  if (_this66.moveInData.nextInvoice.insuranceCharges > 0) {
                    document.getElementById("six-storage-nextinvoice_insurance_rate").innerHTML = _this66.helper.sixStorageDisplayCurrency(_this66.moveInData.nextInvoice.insuranceCharges);
                    document.getElementById("six-storage-nextinvoice_insurance_rate").style.display = "";
                    document.getElementById("sixStorageInsurancehide-summary").style.display = "";
                  } else {
                    document.getElementById("six-storage-nextinvoice_insurance_rate").style.display = "none";
                    document.getElementById("sixStorageInsurancehide-summary").style.display = "none";
                    document.getElementById("sixStorageInsurancehide-summary").style.display = "none";
                  }
                }
              } else {
                document.getElementById("six-storage-insurance_rate").style.display = "none";
                document.getElementById("sixStorageInsurancehide").style.display = "none";
                document.getElementById("six-storage-nextinvoice_insurance_rate").style.display = "none";
              }
            }

            if (wordpress_vars.six_storage_online_fs_ad_services_toggle === "1") {
              if (_this66.moveInData.serviceCharges > 0) {
                document.getElementById("six-storage-service_rate").innerHTML = _this66.helper.sixStorageDisplayCurrency(_this66.moveInData.serviceCharges);
                document.getElementById("six-storage-services_toggle_id").style.display = "";
                document.getElementById("six-storage-service_rate").style.display = "";

                if (typeof _this66.moveInData.nextInvoice !== "undefined" && _this66.moveInData.nextInvoice !== null) {
                  if (_this66.moveInData.nextInvoice.serviceCharges > 0) {
                    document.getElementById("six-storage-nextinvoice_service_rate").innerHTML = _this66.helper.sixStorageDisplayCurrency(_this66.moveInData.nextInvoice.serviceCharges);
                    document.getElementById("six-storage-nextinvoice_service_rate").style.display = "";
                    document.getElementById("six-storage-services_toggle_id-summary").style.display = "";
                  } else {
                    document.getElementById("six-storage-services_toggle_id-summary").style.display = "none";
                    document.getElementById("six-storage-nextinvoice_service_rate").style.display = "none";
                  }
                }
              } else {
                document.getElementById("six-storage-service_rate").style.display = "none";
                document.getElementById("six-storage-services_toggle_id").style.display = "none";
                document.getElementById("six-storage-nextinvoice_service_rate").style.display = "none";
                document.getElementById("six-storage-services_toggle_id-summary").style.display = "none";
              }
            }

            if (wordpress_vars.six_storage_online_fs_ad_merchandise_toggle === "1") {
              if (_this66.moveInData.merchandise > 0) {
                document.getElementById("six-storage-merchandise_rate").innerHTML = _this66.helper.sixStorageDisplayCurrency(_this66.moveInData.merchandise);
                document.getElementById("merchandise_row").style.display = "block";
                document.getElementById("six-storage-merchandise_rate").style.display = "";
              } else {
                document.getElementById("six-storage-merchandise_rate").style.display = "none";
                document.getElementById("merchandise_row").style.display = "none";
              }
            }

            document.getElementById("six-storage-subTotal").innerHTML = "".concat(_this66.helper.sixStorageDisplayCurrency(parseFloat(_this66.moveInData.rentAmount).toFixed(2))); //this.helper.showIconsOnLoadDashboard();

            var moveInunits = typeof _this66.moveInData.units !== 'undefined' && _this66.moveInData.units !== null && _this66.moveInData.units.length > 0 ? _this66.moveInData.units : "";
            var unitDetails = typeof moveInunits !== 'undefined' && moveInunits !== null && moveInunits.length > 0 ? moveInunits[0].unitInfo : '';

            var _unitTaxDetails = typeof unitDetails.taxes !== 'undefined' && unitDetails.taxes !== null && unitDetails.taxes.length > 0 ? unitDetails.taxes.map(function (item, i) {
              return typeof item.name !== 'undefined' && item.name !== null && item.name !== '' && typeof item.value !== 'undefined' && item.value !== null && item.value !== '' ? "<span><b>".concat(item.name, ": </b> <span>").concat(_this66.helper.sixStorageDisplayPercent(item.value), "</span></span><br/>") : "";
            }) : "";

            var unitTaxDetailstooltip = typeof _unitTaxDetails !== 'undefined' && _unitTaxDetails !== null && _unitTaxDetails !== '' && _unitTaxDetails.length > 0 && _unitTaxDetails !== undefined ? "<i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-multipleTaxtoolTip six-storage-icon-align six-storage-tiny six-storage-tooltipped\">info_outline</i>" : '';
            setTimeout(function () {
              var taxTooltip = document.querySelectorAll('.six-storage-multipleTaxtoolTip');

              _materialize["default"].Tooltip.init(taxTooltip, {
                html: _unitTaxDetails
              });
            }, 120); // Below line need to comment for showing multibox custom text

            document.getElementById("six-storage-serviceTaxtooltip").innerHTML = "".concat(unitTaxDetailstooltip);
            document.getElementById("six-storage-productTaxtooltip").innerHTML = "".concat(unitTaxDetailstooltip);
            document.getElementById("six-storage-currentInvoice").innerHTML = "".concat(unitTaxDetailstooltip);
            document.getElementById("six-storage-currentInvoiceRentTaxPrev").innerHTML = "".concat(unitTaxDetailstooltip); // +
            //     this.moveInData.serviceCharges +
            //     this.moveInData.insuranceCharges +
            //     this.moveInData.merchandise +
            //     this.moveInData.deposit -
            //     this.moveInData.discount

            if (typeof _this66.moveInData.nextInvoice !== 'undefined' && _this66.moveInData.nextInvoice !== null) {
              var nextInvoice = _this66.moveInData.nextInvoice;
              document.getElementById("six-storage-nextinvoice_billing_date").innerHTML = _this66.helper.sixStorageDisplayDate(new Date(nextInvoice.startsOn));
              document.getElementById("six-storage-nextinvoice_rental_rate").innerHTML = _this66.helper.sixStorageDisplayCurrency(nextInvoice.rentAmount);
              document.getElementById("six-storage-nextinvoice_tax_amount").innerHTML = _this66.helper.sixStorageDisplayCurrency(nextInvoice.taxAmount);
              document.getElementById("six-storage-nextinvoice_net_amount").innerHTML = _this66.helper.sixStorageDisplayCurrency(nextInvoice.netAmount);
              document.getElementById("six-storage-nextinvoice_discount").innerHTML = _this66.helper.sixStorageDisplayCurrency(nextInvoice.discount);
              document.getElementById("six-storage-nextinvoice_gross_amount").innerHTML = _this66.helper.sixStorageDisplayCurrency(nextInvoice.grossAmount);

              if (nextInvoice.discount > 0) {
                document.getElementById("six-storage-nextInvoice_discount_amount_table_row").style.display = "";
              } else {
                document.getElementById("six-storage-nextInvoice_discount_amount_table_row").style.display = "none";
              }

              var unitnextTaxDetails = typeof nextInvoice.taxes !== 'undefined' && nextInvoice.taxes !== null && nextInvoice.taxes.length > 0 ? nextInvoice.taxes.map(function (item, i) {
                return typeof item.name !== 'undefined' && item.name !== null && item.name !== '' && typeof item.value !== 'undefined' && item.value !== null && item.value !== '' ? "<span><b>".concat(item.name, ": </b> <span>").concat(_this66.helper.sixStorageDisplayPercent(item.value), "</span></span><br/>") : "";
              }) : "";
              var unitnextTaxDetailstooltip = typeof unitnextTaxDetails !== 'undefined' && unitnextTaxDetails !== null && unitnextTaxDetails !== '' && unitnextTaxDetails.length > 0 && unitnextTaxDetails !== undefined ? "<i class=\"six-storage-material-icons notranslate six-storage-cursor-pointer six-storage-icon-align six-storage-tiny six-storage-tooltipped\" id=\"multiplenextTax\">info_outline</i>" : '';
              setTimeout(function () {
                var taxTooltip = document.querySelectorAll('#multiplenextTax');

                _materialize["default"].Tooltip.init(taxTooltip, {
                  html: unitnextTaxDetails
                });
              }, 120);
              document.getElementById('six-storage-nextInvoiceTax').innerHTML = "".concat(unitnextTaxDetailstooltip);
            }

            document.getElementById("six-storage-taxAmount").innerHTML = "".concat(_this66.helper.sixStorageDisplayCurrency(_this66.moveInData.taxAmount));
            document.getElementById("six-storage-netAmount").innerHTML = "".concat(_this66.helper.sixStorageDisplayCurrency(_this66.moveInData.netAmount));
            document.getElementById("six-storage-totalAmount").innerHTML = "".concat(_this66.helper.sixStorageDisplayCurrency(_this66.moveInData.grossAmount));
            document.getElementById("six-storage-discountAmount").innerHTML = "".concat(_this66.helper.sixStorageDisplayCurrency(_this66.moveInData.discount));
            document.getElementById("six-storage-depositamount").innerHTML = "".concat(_this66.helper.sixStorageDisplayCurrency(_this66.moveInData.deposit));

            if (_this66.moveInData.grossAmount == 0) {
              _this66.moveinWithoutPayment = true;
              document.getElementById('six-storage-section-paylater').style.display = 'none';
              document.getElementById('six-storage-MoveInWithoutPayment').style.display = 'none';
              document.getElementById('six-storage-dvPaymentForm').style.display = 'none';
              document.getElementById('six-storage-rdbtn_pay_now').checked = false;
              document.getElementById('six-storage-rdbtn_pay_later').checked = false;
            } else {
              document.getElementById('six-storage-section-paylater').style.display = '';
              document.getElementById('six-storage-MoveInWithoutPayment').style.display = 'none';
            }

            if (_this66.moveInData.deposit > 0) {
              document.getElementById("six-storage-deposit_amount_table_row").style.display = "";
            } else {
              document.getElementById("six-storage-deposit_amount_table_row").style.display = "none";
            }

            if (_this66.moveInData.discount > 0) {
              document.getElementById("six-storage-discount_amount_table_row").style.display = "";
            } else {
              document.getElementById("six-storage-discount_amount_table_row").style.display = "none";
            }
          }
        }
      })["catch"](function (error) {
        document.getElementById("six-storage-loading-container").innerHTML = _this66.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "generateUnitsDetails",
    value: function generateUnitsDetails() {
      var html = "";
      this.moveInData.units.forEach(function (item, index) {
        var unitTypeName = item.unitInfo.unitType.name;
        var unitMeasurement = item.unitInfo.unitMeasurement;
        var measurementType = typeof item.unitInfo.measurementType !== "undefined" && item.unitInfo.measurementType !== null ? this.helper.sixStorageMeasurementDisplayFormat(item.unitInfo.measurementType) : "";
        var unitNumber = item.unitInfo.unitNumber;
        var storageType = item.unitInfo.storageType.name;
        var location = item.unitInfo.location.name;
        var building = item.unitInfo.building.name;
        var startsOn = "";
        var endsOn = "";
        var netAmount = "";
        item.estimation.transactions.forEach(function (item2, index2) {
          if (item2.type == "RENT") {
            startsOn = item2.startsOn;
            endsOn = item2.endsOn;
            netAmount = item2.price.netAmount;
          }
        });
        html += "<div class=\"six-storage-col six-storage-m7 six-storage-s12 six-storage-grid-m0\">\n               <table class=\"six-storage-grid-table cc six-storage-grid-bg-light six-storage-grid-table-borderless six-storage-grid-shadow-sm six-storage-table-left\">\n                  <thead>\n                     <tr class=\"cc\">\n                        <th colspan=\"2\" class=\"cc six-storage-grid-border-bottom grid-thead-light six-storage-grey six-storage-lighten-4\"> ".concat(
        /*Storage Details*/
        wordpress_vars.six_storage_online_fs_Storage_Details, "\n                        <i class=\"six-storage-material-icons notranslate six-storage-grey-text six-storage-cursor-pointer six-storage-edit-icon\"  onclick=\"sixStorageGoToUnits();\">edit</i>\n                     </tr>\n                  </thead>\n                  <tbody>\n                     <tr class=\"cc\">\n                        <td class=\"cc\">").concat(storageType, " #:</td>\n                        <td class=\"cc\">").concat(unitNumber, "</td>\n                     </tr>\n                     <tr class=\"cc\">\n                        <td class=\"cc\">").concat(
        /*Location*/
        wordpress_vars.six_storage_online_fs_Location, ":</td>\n                        <td class=\"cc\">").concat(location, "</td>\n                     </tr>\n                     <tr class=\"cc\">\n                        <td class=\"cc\">").concat(
        /*Building*/
        wordpress_vars.six_storage_online_fs_Building, ":</td>\n                        <td class=\"cc\">").concat(building, "</td>\n                     </tr>\n                     <tr class=\"cc\">\n                        <td class=\"cc\">").concat(
        /*Size*/
        wordpress_vars.six_storage_online_fs_Size, ":</td>\n                        <td class=\"cc\"><span>").concat(unitTypeName, "</span><br/>(").concat(unitMeasurement, "&nbsp;").concat(measurementType, ")\n                     </tr>\n                     <tr class=\"cc\">\n                        <td class=\"cc\">").concat(
        /*Invoice Period*/
        wordpress_vars.six_storage_online_fs_Invoice_Period, ":</td>\n                        <td class=\"cc\">").concat(this.helper.sixStorageDisplayDate(new Date(startsOn)), " <span>").concat(
        /*to*/
        wordpress_vars.six_storage_online_mi_to, "</span> ").concat(this.helper.sixStorageDisplayDate(new Date(endsOn)), "</td>\n                     </tr>\n                     <tr class=\"cc\">\n                        <td class=\"cc\">").concat(
        /*Initial Rent*/
        wordpress_vars.six_storage_online_fs_Initial_Rent, ":</td>\n                        <td class=\"cc\">").concat(this.helper.sixStorageDisplayCurrency(netAmount), "</td>\n                     </tr>\n                     <tr class=\"cc six-storage-d-none\">\n                        <td class=\"cc\">").concat(
        /*Deposit*/
        wordpress_vars.six_storage_online_fs_Deposit, "</td>\n                        <td class=\"cc\">").concat(this.helper.sixStorageDisplayCurrency(0), "</td>\n                     </tr>\n                  </tbody>\n               </table>\n            </div>");
      }.bind(this));
      return html;
    }
  }, {
    key: "sixStorageGenerateCommodityDetails",
    value: function sixStorageGenerateCommodityDetails(comodityType) {
      var html = "";
      this.moveInData.units.forEach(function (item, index) {
        var unitNumber = item.unitInfo.unitNumber;
        var commodityName = "";
        var netAmount = "";
        item.estimation.transactions.forEach(function (trans, indexer) {
          if (trans.type == comodityType) {
            commodityName = trans.commodityName;
            netAmount = trans.price.netAmount;
            html = html + "<tr class=\"cc\">\n                <td class=\"cc\">".concat(unitNumber, "</td>\n                <td class=\"cc\">").concat(commodityName, "</td>\n                <td class=\"cc\">").concat(window.sixStorageDisplayCurrency(netAmount), "</td>\n              </tr>");
          }
        });
      }.bind(this));

      if (html === "") {
        if (comodityType === "SERVICE") {
          html = "<tr class=\"cc\"><td class=\"cc\" colspan=\"3\">".concat(
          /*No services selected*/
          wordpress_vars.six_storage_online_fs_No_services_selected, "</td></tr>");
        } else {
          html = "<tr class=\"cc\"><td class=\"cc\" colspan=\"3\">".concat(
          /*No insurance plans selected*/
          wordpress_vars.six_storage_online_fs_No_insurance_plans_selected, "</td></tr>");
        }
      }

      return html;
    }
  }, {
    key: "sixStorageGenerateMerchandiseDetails",
    value: function sixStorageGenerateMerchandiseDetails() {
      var html = "";
      this.moveInData.units.forEach(function (item, index) {
        var unitNumber = item.unitInfo.unitNumber;
        var commodityName = "";
        var netAmount = "";
        var qnty = "";
        item.estimation.transactions.forEach(function (merch, index2) {
          //console.log("type", merch.type);
          if (merch.type == "MERCHANDISE") {
            commodityName = merch.commodityName;
            netAmount = merch.price.netAmount;
            qnty = merch.quantity;
            html += "<tr class=\"cc\">\n                        <td class=\"cc\">".concat(unitNumber, "</td>\n                        <td class=\"cc\">").concat(commodityName, "</td>\n                        <td class=\"cc\">").concat(qnty, "</td>\n                        <td class=\"cc\">").concat(window.sixStorageDisplayCurrency(netAmount), "</td>\n                     </tr>");
          }
        });
      }.bind(this));

      if (html === "") {
        html = "<tr class=\"cc\"><td class=\"cc\" colspan=\"4\">".concat(
        /*No merchandise selected*/
        wordpress_vars.six_storage_online_fs_No_merchandise_selected, "</td></tr>");
      }

      return html;
    }
  }, {
    key: "sixStorageRenderLincesneAgreement",
    value: function sixStorageRenderLincesneAgreement() {
      var _this67 = this;

      if (typeof this.saveThirdPartyInsuranceDetailsValues !== 'undefined' && this.saveThirdPartyInsuranceDetailsValues !== null && this.saveThirdPartyInsuranceDetailsValues.length > 0) {
        this.saveThirdPartyInsuranceDetailsValues.forEach(function (unit) {
          var unitIndex = _this67.moveInData.units.findIndex(function (x) {
            return x.unitInfo.id === unit.unitId;
          });

          if (unitIndex > -1) {
            _this67.moveInData.units[unitIndex]["insuranceInfo"] = unit["insuranceInfo"];
          }
        });
      }

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append("action", "six_storage_lease_preview_agreement");
      formData.append("moveInParamAPIModel", JSON.stringify(this.moveInData));
      formData.append("leaseProfileId", this.tentnantDetailsId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this67.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response36 = JSON.parse(data);

          if (typeof _response36.isSuccess !== "undefined" && _response36.isSuccess !== null && _response36.isSuccess === true) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders27 = document.getElementById("six-storage-loading-container");

              _initialloaders27.style.display = 'none';
            }

            var previewData = _response36.result;
            var leaseAgreementButton = '';
            var renderByDefault = '';
            _this67.sixStorageOnlineSaveLeaseAgreementResponseValues = previewData.previewLease;
            _this67.sixStorageOnlineSaveInvoiceResponseValues = previewData.previewInvoice;

            if (typeof _this67.sixStorageOnlineSaveLeaseAgreementResponseValues !== 'undefined' && _this67.sixStorageOnlineSaveLeaseAgreementResponseValues !== undefined && _this67.sixStorageOnlineSaveLeaseAgreementResponseValues !== null && _this67.sixStorageOnlineSaveLeaseAgreementResponseValues !== '' && _this67.sixStorageOnlineSaveLeaseAgreementResponseValues.length > 0) {
              previewData.previewLease[0].leaseFilePath.map(function (data) {
                var safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                var android = /android/i.test(navigator.userAgent);

                if (safari) {
                  renderByDefault += "<div style=\"height:500px; margin-bottom:30px;\"><iframe id=\"iframePreviewLicense\"  scrolling=\"auto\" type='application/pdf' loading=\"lazy\" src=\"".concat(data, "\" style=\"width:100%;height:100%;\"></iframe></div><div class=\"six-storage-grid-text-center six-storage-iphone-view-document\"><a href=\"").concat(data, "\" target=\"_blank\">").concat(
                  /*lease agreement link*/
                  wordpress_vars.six_storage_online_fs_click_here_to_view_document, "</a></div>");
                } else if (android) {
                  renderByDefault += "<div style=\"height:500px; margin-bottom:30px;\"><iframe id=\"iframePreviewLicense\"  scrolling=\"auto\" type='application/pdf' loading=\"lazy\" src=\"".concat(data, "\" style=\"width:100%;height:100%;\"></iframe></div><div class=\"six-storage-grid-text-center six-storage-iphone-view-document\"><a href=\"").concat(data, "\" target=\"_blank\">").concat(
                  /*lease agreement link*/
                  wordpress_vars.six_storage_online_fs_click_here_to_view_document, "</a></div>");
                } else {
                  renderByDefault += "<div style=\"height:500px; margin-bottom:30px;\"><iframe id=\"iframePreviewLicense\"  scrolling=\"auto\" type='application/pdf' loading=\"lazy\" src=\"".concat(data, "\" style=\"width:100%;height:100%;\"></iframe></div>");
                }
              });
              document.getElementById('six-storage-dvLicenceAgreement').innerHTML = renderByDefault;

              _this67.sixStorageOnlineSaveLeaseAgreementResponseValues.map(function (res) {
                leaseAgreementButton += "<Button class=\"six-storage-waves-effect six-storage-waves-light six-storage-shadow-none six-storage-btn six-storage-secondary-background-color cc six-storage-grid-mr10\" onclick=\"sixStorageRenderleaseAgreementOnClick('".concat(res.unitNumber, "')\">").concat(res.unitNumber, "</Button>");
              });

              document.getElementById('six-storage-online-render-unit-button-leaseagreement').innerHTML = "".concat(leaseAgreementButton);
            } else {
              document.getElementById("six-storage-dvLicenceAgreement").innerHTML = "<strong class=\"six-storage-grid-text-danger\">".concat(
              /*Please contact storage admin to get your lease agreement*/
              wordpress_vars.six_storage_online_fs_Please_contact_storage_admin, "</strong>");
            } // leaseAgreementButton = `<Button onclick="renderPreviewLeaseUnitButton()">Move In Document</Button> <Button onclick="renderPreviewInvoiceUnitButton()">Invoices</Button>`;
            // document.getElementById('six-storage-online-render-button-leaseagreement').innerHTML = `${leaseAgreementButton}`;
            // previewData.previewLease.forEach((value, index) => {
            //   if(value.leaseFilePath.length > 1){
            //     value.leaseFilePath.map((data)=>{
            //       leaseAgreementButton += `<div style="height:500px; margin-bottom:30px;"><iframe id="iframePreviewLicense" src="${data}" style="width:100%;height:100%;"></iframe></div>`;
            //     })
            //   document.getElementById('six-storage-dvLicenceAgreement').innerHTML = leaseAgreementButton;
            //   } else {
            //     // let licenseAgreement = previewData.previewLease[0].leaseFilePath;
            //     // let path = "";
            //     licenseAgreement.forEach((value, index) => {
            //       if (value.toLowerCase().indexOf("agreement")) {
            //         path = licenseAgreement[index];
            //       }
            //     });
            //     if (typeof licenseAgreement !== "undefined" && licenseAgreement !== null && licenseAgreement !== "" && path !== "") {
            //       //document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
            //       document.getElementById("six-storage-dvLicenceAgreement").innerHTML = `<iframe id="iframePreviewLicense"style="width:100%;height:100%;"></iframe>`;
            //       document.getElementById("iframePreviewLicense").setAttribute("src", path);
            //       // document.getElementById("iframePreviewLicense").onload = () => {
            //       //   document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
            //       // };
            //       this.helper.sixStorageResizeIframe("#iframePreviewLicense");
            //     } else {
            //       document.getElementById("six-storage-dvLicenceAgreement").innerHTML = `<strong class="six-storage-grid-text-danger">${/*Please contact storage admin to get your lease agreement*/ wordpress_vars.six_storage_online_fs_Please_contact_storage_admin}.</strong>`;
            //     }
            //   }
            // });

          } else {
            document.getElementById("six-storage-dvLicenceAgreement").innerHTML = "<strong class=\"six-storage-grid-text-danger\">".concat(
            /*Please contact storage admin to get your lease agreement*/
            wordpress_vars.six_storage_online_fs_Please_contact_storage_admin, "</strong>");
          }
        } else {
          document.getElementById("six-storage-dvLicenceAgreement").innerHTML = "<strong class=\"six-storage-grid-text-danger\">".concat(
          /*Please contact storage admin to get your lease agreement*/
          wordpress_vars.six_storage_online_fs_Please_contact_storage_admin, "</strong>");
        }
      })["catch"](function (error) {//document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(false);
        //console.log("error", error);
      });
    }
  }, {
    key: "sixStorageRenderleaseAgreementOnClick",
    value: function sixStorageRenderleaseAgreementOnClick(data) {
      if (typeof data !== 'undefined' && data !== null && data != '') {
        this.sixStorageOnlineLeaseAgrePath = this.sixStorageOnlineSaveLeaseAgreementResponseValues.filter(function (i) {
          return i.unitNumber === data;
        });
        var leaseAgreementButton = '';

        if (typeof this.sixStorageOnlineLeaseAgrePath !== 'undefined' && this.sixStorageOnlineLeaseAgrePath !== undefined && this.sixStorageOnlineLeaseAgrePath !== null && this.sixStorageOnlineLeaseAgrePath !== '' && this.sixStorageOnlineLeaseAgrePath.length > 0 && typeof this.sixStorageOnlineLeaseAgrePath[0].leaseFilePath !== 'undefined' && this.sixStorageOnlineLeaseAgrePath[0].leaseFilePath !== '' && this.sixStorageOnlineLeaseAgrePath[0].leaseFilePath !== null && this.sixStorageOnlineLeaseAgrePath[0].leaseFilePath.length > 0) {
          document.getElementById('six-storage-online-render-unit-button-leaseagreement').style.display = 'block';
          this.sixStorageOnlineLeaseAgrePath[0].leaseFilePath.map(function (data) {
            var safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            var android = /android/i.test(navigator.userAgent);

            if (safari) {
              leaseAgreementButton += "<div style=\"height:500px; margin-bottom:30px;\"><iframe id=\"iframePreviewLicense\" src=\"".concat(data, "\" loading=\"lazy\" style=\"width:100%;height:100%;\"></iframe></div><div class=\"six-storage-grid-text-center six-storage-iphone-view-document\"><a href=\"").concat(data, "\" target=\"_blank\">").concat(
              /*lease agreement link*/
              wordpress_vars.six_storage_online_fs_click_here_to_view_document, "</a></div>");
            } else if (android) {
              leaseAgreementButton += "<div style=\"height:500px; margin-bottom:30px;\"><iframe id=\"iframePreviewLicense\" src=\"".concat(data, "\" loading=\"lazy\" style=\"width:100%;height:100%;\"></iframe></div><div class=\"six-storage-grid-text-center six-storage-iphone-view-document\"><a href=\"").concat(data, "\" target=\"_blank\">").concat(
              /*lease agreement link*/
              wordpress_vars.six_storage_online_fs_click_here_to_view_document, "</a></div>");
            } else {
              leaseAgreementButton += "<div style=\"height:500px; margin-bottom:30px;\"><iframe id=\"iframePreviewLicense\" src=\"".concat(data, "\" loading=\"lazy\" style=\"width:100%;height:100%;\"></iframe></div>");
            }
          });
          document.getElementById('six-storage-dvLicenceAgreement').innerHTML = leaseAgreementButton;
        } else {
          //document.getElementById('six-storage-online-render-unit-button-leaseagreement').style.display = 'none';
          document.getElementById("six-storage-dvLicenceAgreement").innerHTML = "<strong class=\"six-storage-grid-text-danger\">".concat(
          /*Please contact storage admin to get your lease agreement*/
          wordpress_vars.six_storage_online_fs_Please_contact_storage_admin, "</strong>");
        }
      } else {
        //document.getElementById('six-storage-online-render-unit-button-leaseagreement').style.display = 'none';
        document.getElementById("six-storage-dvLicenceAgreement").innerHTML = "<strong class=\"six-storage-grid-text-danger\">".concat(
        /*Please contact storage admin to get your lease agreement*/
        wordpress_vars.six_storage_online_fs_Please_contact_storage_admin, "</strong>");
      }
    }
  }, {
    key: "sixStorageSaveptwofourMoveinDetails",
    value: function sixStorageSaveptwofourMoveinDetails(isPaylater, ptwofourRes) {
      var _this68 = this;

      var movinDataptwofour = JSON.parse(sessionStorage.getItem("moveInData"));
      var leaseprofileId = JSON.parse(sessionStorage.getItem("profileId"));
      var dashboardurl = sessionStorage.getItem("Dashboardurl");
      var paymentModeId = document.getElementById('six-storage-payment-option');
      var obj = {
        paymentmodeId: typeof paymentModeId !== 'undefined' && paymentModeId !== null && paymentModeId !== '' && typeof paymentModeId.value !== 'undefined' && paymentModeId.value !== null ? paymentModeId.value : ''
      };
      var formData = new FormData();

      if (typeof this.geteAccessInfo !== 'undefined' && this.geteAccessInfo !== null && this.geteAccessInfo.length > 0) {
        this.geteAccessInfo.forEach(function (unit) {
          var unitIndex = movinDataptwofour.units.findIndex(function (x) {
            return x.unitInfo.id.toUpperCase() === unit.unitId.toUpperCase();
          });

          if (unitIndex > -1) {
            movinDataptwofour.units[unitIndex]["securityGate"] = unit;
          }
        });
      }

      if (typeof this.saveThirdPartyInsuranceDetailsValues !== 'undefined' && this.saveThirdPartyInsuranceDetailsValues !== null && this.saveThirdPartyInsuranceDetailsValues.length > 0) {
        this.saveThirdPartyInsuranceDetailsValues.forEach(function (unit) {
          var unitIndex = movinDataptwofour.units.findIndex(function (x) {
            return x.unitInfo.id === unit.unitId;
          });

          if (unitIndex > -1) {
            movinDataptwofour.units[unitIndex]["insuranceInfo"] = unit["insuranceInfo"];
          }
        });
      }

      movinDataptwofour.units.forEach(function (unit) {
        var desiredMoveoutDate = document.getElementById("six-storage-desired-moveout-date_".concat(unit.unitInfo.id));
        var unitIndex = movinDataptwofour.units.findIndex(function (x) {
          return x.unitInfo.id === unit.unitInfo.id;
        });

        if (unitIndex > -1) {
          if (typeof desiredMoveoutDate !== 'undefined' && desiredMoveoutDate !== null && typeof desiredMoveoutDate.value !== 'undefined' && desiredMoveoutDate.value !== null && desiredMoveoutDate.value !== "") {
            movinDataptwofour.units[unitIndex]["desiredMoveOutDate"] = _this68.helper.sixStorageReadDate(desiredMoveoutDate.value);
          } else {
            movinDataptwofour.units[unitIndex]["desiredMoveOutDate"] = null;
          }
        }
      });
      var autoPayEnabled = false;
      var saveCard = false;
      var autoPay = document.getElementById("six-storage-turn_on_autopay");
      var save_card_autopay = document.getElementById("six-storage-save_card_autopay");

      if (typeof autoPay !== 'undefined' && autoPay !== null && autoPay.checked === true) {
        autoPayEnabled = true;
      }

      if (typeof save_card_autopay !== 'undefined' && save_card_autopay !== null && save_card_autopay.checked === true) {
        saveCard = true;
      }

      movinDataptwofour["payLater"] = typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater ? true : false;
      movinDataptwofour["paidAmount"] = this.moveInData["payLater"] ? 0 : this.moveInData.grossAmount;

      if (!movinDataptwofour["payLater"] && typeof ptwofourRes !== 'undefined' && ptwofourRes !== '' && ptwofourRes !== null) {
        movinDataptwofour["paymentReference"] = ptwofourRes.referenceNumber;
        movinDataptwofour["paymentTransactionResponse"] = {
          "last4Digit": ptwofourRes.referenceNumber,
          "paymentStatus": ptwofourRes.status,
          "transactionId": ptwofourRes.token,
          "amountCharged": movinDataptwofour["grossAmount"],
          "paymentMethodId": obj.paymentmodeId
        };
        movinDataptwofour["enableAutopay"] = autoPayEnabled;
        movinDataptwofour["saveCard"] = saveCard;
        movinDataptwofour["paymentModeId"] = obj.paymentmodeId;
      } else if (!movinDataptwofour["payLater"]) {
        movinDataptwofour["paymentReference"] = this.paymentTransactionResponse.last4Digit;
        movinDataptwofour["paymentTransactionResponse"] = this.paymentTransactionResponse;
        movinDataptwofour["enableAutopay"] = autoPayEnabled;
        movinDataptwofour["saveCard"] = saveCard;
        movinDataptwofour["paymentModeId"] = obj.paymentmodeId;
      }

      if (typeof wordpress_vars.six_storage_online_tenant_activity_enable !== 'undefined' && wordpress_vars.six_storage_online_tenant_activity_enable !== null && wordpress_vars.six_storage_online_tenant_activity_enable !== '' && wordpress_vars.six_storage_online_tenant_activity_enable !== '0') {
        movinDataptwofour["logger"] = this.helper.userAccessInfo;
      }

      movinDataptwofour["userId"] = sessionStorage.getItem("userId");

      if (typeof wordpress_vars !== 'undefined' && wordpress_vars.six_storage_google_analytics_integrated === '1' && typeof gtag !== 'undefined' && gtag !== null && gtag !== '' && typeof gtag === 'function') {
        var transactionId = null;

        if (typeof movinDataptwofour["paymentTransactionResponse"] !== 'undefined' && movinDataptwofour["paymentTransactionResponse"] !== null && movinDataptwofour["paymentTransactionResponse"] !== '' && typeof movinDataptwofour["paymentTransactionResponse"]["transactionId"] !== 'undefined' && movinDataptwofour["paymentTransactionResponse"]["transactionId"] !== null && movinDataptwofour["paymentTransactionResponse"]["transactionId"] !== '') {
          transactionId = movinDataptwofour["paymentTransactionResponse"]["transactionId"];
        }

        var totalGrossAmount = movinDataptwofour.paidAmount;
        var currency_format = this.helper.currency;
        var itemList = [];
        movinDataptwofour.units.forEach(function (unit) {
          var unitIndex = movinDataptwofour.units.findIndex(function (x) {
            return x.unitInfo.id === unit.unitInfo.id;
          });
          var unitTypeName = movinDataptwofour.units[unitIndex]['unitInfo']['unitType']['name'];
          var unitId = movinDataptwofour.units[unitIndex]['unitInfo']['id'];
          var unitMeasurement = movinDataptwofour.units[unitIndex]['unitInfo']['unitMeasurement'];
          var unitNumber = movinDataptwofour.units[unitIndex]['unitInfo']['unitNumber'];
          var storageTypeName = movinDataptwofour.units[unitIndex]['unitInfo']['storageType']['name'];
          var locationName = movinDataptwofour.units[unitIndex]['unitInfo']['location']['name'];
          var unitPrice = movinDataptwofour.units[unitIndex]['unitInfo']['grossAmount'];
          itemList.push({
            item_id: unitId,
            // Unit Id
            item_name: "".concat(unitNumber),
            // Unit Number
            item_category: storageTypeName,
            // Storage Category
            location_id: locationName,
            // Location Name
            item_variant: unitTypeName,
            // Unit Type
            price: unitPrice // UNit Price

          });
        });
        gtag("event", "purchase", {
          transaction_id: transactionId,
          value: totalGrossAmount,
          //Gross Amount
          currency: currency_format,
          items: itemList
        });
      }

      if (typeof wordpress_vars !== 'undefined' && wordpress_vars.six_storage_google_analytics_integrated === '1') {
        var quantity = movinDataptwofour.units.length;

        if (typeof quantity !== 'undefined' && quantity !== null && quantity !== '' && quantity.length > 0) {
          gtag('event', 'Move In', {
            'event_category': 'Online MoveIn',
            'event_label': 'QuantiTy',
            'value': "".concat(quantity)
          });
        }
      }

      formData.append("action", "six_storage_lease_details_save");
      formData.append("moveinData", JSON.stringify(movinDataptwofour));
      formData.append("leaseProfileId", leaseprofileId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== 'undefined' && data !== null) {
          var _response37 = JSON.parse(data);

          if (typeof _response37.isSuccess !== 'undefined' && _response37 !== null && _response37.isSuccess === true) {
            window.location = dashboardurl;
          } else {
            document.getElementById("six-storage-movein-container").innerHTML = "<div class=\"six-storage-grid-row  six-storage-moveinSuccess six-storage-white\">\n                <div class=\"six-storage-grid-col-md-12\">\n                   <img src=\"".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/undraw_house_searching_n8mp.svg\" width=\"400\" class=\"six-storage-online-margin-auto cc six-storage-grid-p35\">\n                    <div class=\"six-storage-font-weight-bold\">\n                        <h5 class=\"cc six-storage-grid-mb10 six-storage-red-text six-storage-font-size-20\">\n                            ").concat(
            /*Technical error*/
            wordpress_vars.six_storage_online_fs_Technical_error, ".\n                        </h5>\n                        <p class=\"six-storage-grey-text  six-storage-grid-mb15\">").concat(
            /*Please contact storage facility for further information*/
            wordpress_vars.six_storage_online_fs_Please_contact_storage, "</p>\n                        <a class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc primary six-storage-grid-mt15 six-storage-grid-mb15 six-storage-grid-pr20 six-storage-grid-pl20\" href=\"").concat(window.location.href, "\">Try Again</a>\n                    </div>\n                </div>\n            </div>");
          }
        } else {
          document.getElementById("six-storage-stepping-buttons").style.display = "none";

          if (typeof discountCourouselSlider !== 'undefined' && discountCourouselSlider !== null && discountCourouselSlider !== "") {
            discountCourouselSlider.style.display = "none";
          }

          window.scrollTo(0, 0);
        }
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "sixStorageSaveMoveinDetails",
    value: function sixStorageSaveMoveinDetails(isPaylater, ptwofourRes, validatePaylater) {
      var _this69 = this;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var validate_Paylater_Count = 0;
      var status = true;

      if (validatePaylater === true) {
        document.getElementById('six-storage-promoCodetext-err').style.display = 'none';
        var agreement = document.getElementById("six-storage-lease-agreement");
        document.getElementById("six-storage-card_actions").style.display = "none";
        document.getElementById("six-storage-dvPaymentForm").innerHTML = "";
        document.getElementById("six-storage-creditgrid-card-payment").style.display = "none";
        var terms = document.getElementsByClassName("terms_");
        Array.prototype.forEach.call(terms, function (item) {
          if (!item.checked) {
            status = false;
            validate_Paylater_Count = validate_Paylater_Count + 1;
            document.getElementById("".concat(item.id, "-err")).style.display = "";
          } else {
            document.getElementById("".concat(item.id, "-err")).style.display = "none";
          }
        });
        var esignURL = this.signaturePad._data;

        if (agreement.checked && status === true) {
          if (typeof this.esignMandatory === 'undefined' || this.esignMandatory === false || this.esignMandatory === null) {
            document.getElementById("six-storage-esign-error").style.display = "none"; // this.sixStorageSaveMoveinDetails(true);
            // validate_Paylater_Count = validate_Paylater_Count+1;

            document.getElementById("six-storage-book-now-pay-later").style.display = "";
            document.getElementById("six-storage-payment-selection").style.display = "none";
          } else if (typeof esignURL !== 'undefined' && esignURL !== null && esignURL !== "" && esignURL.length > 0) {
            document.getElementById("six-storage-esign-error").style.display = "none"; // this.sixStorageSaveMoveinDetails(true);
            // validate_Paylater_Count =  validate_Paylater_Count+1;

            document.getElementById("six-storage-book-now-pay-later").style.display = "";
            document.getElementById("six-storage-payment-selection").style.display = "none";
          } else {
            validate_Paylater_Count = validate_Paylater_Count + 1;
            document.getElementById("six-storage-esign-error").style.display = "";
            document.getElementById('six-storage-rdbtn_pay_now').checked = false;
            var sixStoragerdbtnpaylater = document.getElementById('six-storage-rdbtn_pay_later');

            if (typeof sixStoragerdbtnpaylater !== 'undefined' && sixStoragerdbtnpaylater !== null) {
              document.getElementById('six-storage-rdbtn_pay_later').checked = false;
            }
          }
        } else {
          var _sixStoragerdbtnpaylater = document.getElementById('six-storage-rdbtn_pay_later');

          if (typeof _sixStoragerdbtnpaylater !== 'undefined' && _sixStoragerdbtnpaylater !== null && _sixStoragerdbtnpaylater !== " ") {
            document.getElementById('six-storage-rdbtn_pay_later').checked = false;
          }

          validate_Paylater_Count = validate_Paylater_Count + 1;
          document.getElementById('six-storage-termsAndCondition-error').style.display = "";

          if (agreement.checked === false) {
            validate_Paylater_Count = validate_Paylater_Count + 1;
            document.getElementById("six-storage-lease-agreement-err").style.display = "";
          } else {
            document.getElementById("six-storage-lease-agreement-err").style.display = "none";
          }
        }
      }

      if (validate_Paylater_Count > 0) {
        return;
      }

      var paymentModeId = document.getElementById('six-storage-payment-option');
      var obj = {
        paymentmodeId: typeof paymentModeId !== 'undefined' && paymentModeId !== null && paymentModeId !== '' && typeof paymentModeId.value !== 'undefined' && paymentModeId.value !== null ? paymentModeId.value : ''
      };
      var formData = new FormData();

      if (typeof this.geteAccessInfo !== 'undefined' && this.geteAccessInfo !== null && this.geteAccessInfo.length > 0) {
        this.geteAccessInfo.forEach(function (unit) {
          var unitIndex = _this69.moveInData.units.findIndex(function (x) {
            return x.unitInfo.id.toUpperCase() === unit.unitId.toUpperCase();
          });

          if (unitIndex > -1) {
            _this69.moveInData.units[unitIndex]["securityGate"] = unit;
          }
        });
      }

      if (typeof this.saveThirdPartyInsuranceDetailsValues !== 'undefined' && this.saveThirdPartyInsuranceDetailsValues !== null && this.saveThirdPartyInsuranceDetailsValues.length > 0) {
        this.saveThirdPartyInsuranceDetailsValues.forEach(function (unit) {
          var unitIndex = _this69.moveInData.units.findIndex(function (x) {
            return x.unitInfo.id === unit.unitId;
          });

          if (unitIndex > -1) {
            _this69.moveInData.units[unitIndex]["insuranceInfo"] = unit["insuranceInfo"];
          }
        });
      }

      this.moveInData.units.forEach(function (unit) {
        var desiredMoveoutDate = document.getElementById("six-storage-desired-moveout-date_".concat(unit.unitInfo.id));

        var unitIndex = _this69.moveInData.units.findIndex(function (x) {
          return x.unitInfo.id === unit.unitInfo.id;
        });

        if (unitIndex > -1) {
          if (typeof desiredMoveoutDate !== 'undefined' && typeof desiredMoveoutDate.value !== 'undefined' && desiredMoveoutDate.value !== null && desiredMoveoutDate.value !== "") {
            _this69.moveInData.units[unitIndex]["desiredMoveOutDate"] = _this69.helper.sixStorageReadDate(desiredMoveoutDate.value);
          } else {
            _this69.moveInData.units[unitIndex]["desiredMoveOutDate"] = null;
          }
        }
      });
      var autoPayEnabled = false;
      var saveCard = false;
      var autoPay = document.getElementById("six-storage-turn_on_autopay");
      var save_card_autopay = document.getElementById("six-storage-save_card_autopay");

      if (typeof autoPay !== 'undefined' && autoPay !== null && autoPay.checked === true) {
        autoPayEnabled = true;
      }

      if (typeof save_card_autopay !== 'undefined' && save_card_autopay !== null && save_card_autopay.checked === true) {
        saveCard = true;
      }

      this.moveInData["payLater"] = typeof isPaylater !== 'undefined' && isPaylater !== null && isPaylater ? true : false;
      this.moveInData["paidAmount"] = this.moveInData["payLater"] ? 0 : this.moveInData.grossAmount;

      if (!this.moveInData["payLater"] && typeof ptwofourRes !== 'undefined' && ptwofourRes !== '' && ptwofourRes !== null) {
        this.moveInData["paymentReference"] = ptwofourRes.referenceNumber;
        this.moveInData["paymentTransactionResponse"] = {
          "last4Digit": ptwofourRes.referenceNumber,
          "paymentStatus": ptwofourRes.status,
          "transactionId": ptwofourRes.token,
          "amountCharged": this.moveInData["grossAmount"],
          "paymentMethodId": obj.paymentmodeId
        };
        this.moveInData["enableAutopay"] = autoPayEnabled;
        this.moveInData["saveCard"] = saveCard;
        this.moveInData["paymentModeId"] = obj.paymentmodeId;
      } else if (!this.moveInData["payLater"]) {
        this.moveInData["paymentReference"] = this.paymentTransactionResponse.last4Digit;
        this.moveInData["paymentTransactionResponse"] = this.paymentTransactionResponse;
        this.moveInData["enableAutopay"] = autoPayEnabled;
        this.moveInData["saveCard"] = saveCard;
        this.moveInData["paymentModeId"] = obj.paymentmodeId;
      }

      if (typeof wordpress_vars.six_storage_online_tenant_activity_enable !== 'undefined' && wordpress_vars.six_storage_online_tenant_activity_enable !== null && wordpress_vars.six_storage_online_tenant_activity_enable !== '' && wordpress_vars.six_storage_online_tenant_activity_enable !== '0') {
        this.moveInData["logger"] = this.helper.userAccessInfo;
      }

      this.moveInData["userId"] = sessionStorage.getItem("userId");

      if (typeof wordpress_vars !== 'undefined' && wordpress_vars.six_storage_google_analytics_integrated === '1' && typeof gtag !== 'undefined' && gtag !== null && gtag !== '' && typeof gtag === 'function') {
        var transactionId = null;

        if (typeof this.moveInData["paymentTransactionResponse"] !== 'undefined' && this.moveInData["paymentTransactionResponse"] !== null && this.moveInData["paymentTransactionResponse"] !== '' && typeof this.moveInData["paymentTransactionResponse"]["transactionId"] !== 'undefined' && this.moveInData["paymentTransactionResponse"]["transactionId"] !== null && this.moveInData["paymentTransactionResponse"]["transactionId"] !== '') {
          transactionId = this.moveInData["paymentTransactionResponse"]["transactionId"];
        }

        var totalGrossAmount = this.moveInData.paidAmount;
        var currency_format = this.helper.currency;
        var itemList = [];
        this.moveInData.units.forEach(function (unit) {
          var unitIndex = _this69.moveInData.units.findIndex(function (x) {
            return x.unitInfo.id === unit.unitInfo.id;
          });

          var unitTypeName = _this69.moveInData.units[unitIndex]['unitInfo']['unitType']['name'];
          var unitId = _this69.moveInData.units[unitIndex]['unitInfo']['id'];
          var unitMeasurement = _this69.moveInData.units[unitIndex]['unitInfo']['unitMeasurement'];
          var unitNumber = _this69.moveInData.units[unitIndex]['unitInfo']['unitNumber'];
          var storageTypeName = _this69.moveInData.units[unitIndex]['unitInfo']['storageType']['name'];
          var locationName = _this69.moveInData.units[unitIndex]['unitInfo']['location']['name'];
          var unitPrice = _this69.moveInData.units[unitIndex]['unitInfo']['grossAmount'];
          itemList.push({
            item_id: unitId,
            // Unit Id
            item_name: "".concat(unitNumber),
            // Unit Number
            item_category: storageTypeName,
            // Storage Category
            location_id: locationName,
            // Location Name
            item_variant: unitTypeName,
            // Unit Type
            price: unitPrice // UNit Price

          });
        });
        gtag("event", "purchase", {
          transaction_id: transactionId,
          value: totalGrossAmount,
          //Gross Amount
          currency: currency_format,
          items: itemList
        });
      }

      if (typeof wordpress_vars !== 'undefined' && wordpress_vars.six_storage_google_analytics_integrated === '1') {
        var quantity = this.moveInData.units.length;

        if (typeof quantity !== 'undefined' && quantity !== null && quantity !== '' && quantity.length > 0) {
          gtag('event', 'Move In', {
            'event_category': 'Online MoveIn',
            'event_label': 'QuantiTy',
            'value': "".concat(quantity)
          });
        }
      }

      formData.append("action", "six_storage_lease_details_save");
      formData.append("moveinData", JSON.stringify(this.moveInData));
      formData.append("leaseProfileId", this.tentnantDetailsId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this69.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response38 = JSON.parse(data);

          if (wordpress_vars.six_storage_online_setup_preloader === "0") {
            var _initialloaders28 = document.getElementById("six-storage-loading-container");

            _initialloaders28.style.display = 'none';
          }

          var dashboardUrl = document.getElementById("six-storage-dashboard-url").value;

          if (typeof _response38.isSuccess !== 'undefined' && _response38 !== null && _response38.isSuccess === true && _response38.returnCode === 'REQUEST_SUBMITTED_AND_WAITING_FOR_APPROVAL') {
            var corousel = document.getElementById("six-storage-discount_carousel");

            if (typeof corousel !== 'undefined' && corousel !== null && corousel !== "") {
              corousel.style.display = 'none';
            }

            document.getElementById("six-storage-movein-container").innerHTML = "<div class=\"six-storage-grid-row  six-storage-moveinSuccess six-storage-white\">\n                <div class=\"six-storage-grid-col-md-12\">\n                   <img src=\"".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/undraw_business_shop_qw5t.svg\" width=\"400\" class=\"six-storage-online-margin-auto cc six-storage-grid-p35\">\n                    <div class=\"six-storage-font-weight-bold\">\n                        <h5 class=\"cc six-storage-grid-mb10 six-storage-green-text six-storage-font-size-20\">\n                            ").concat(wordpress_vars.six_storage_move_in_approval_success_message, ".\n                        </h5>\n                        <p class=\"six-storage-grey-text  six-storage-grid-mb15\">").concat(
            /*Please contact storage facility for further information*/
            wordpress_vars.six_storage_move_in_approval_success_message_two, "</p>\n                    </div>\n                </div>\n            </div>");
          } else if (typeof _response38.isSuccess !== 'undefined' && _response38 !== null && _response38.isSuccess === true) {
            if (isPaylater === false && _this69.fullDiscount === false) {//this.helper.setCookie("rental-payment-response", JSON.stringify(this.paymentTransactionResponse), 1);
            }

            window.location.href = dashboardUrl;
          } else {
            document.getElementById("six-storage-movein-container").innerHTML = "<div class=\"six-storage-grid-row  six-storage-moveinSuccess six-storage-white\">\n                <div class=\"six-storage-grid-col-md-12\">\n                   <img src=\"".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/undraw_house_searching_n8mp.svg\" width=\"400\" class=\"six-storage-online-margin-auto cc six-storage-grid-p35\">\n                    <div class=\"six-storage-font-weight-bold\">\n                        <h5 class=\"cc six-storage-grid-mb10 six-storage-red-text six-storage-font-size-20\">\n                            ").concat(
            /*Technical error*/
            wordpress_vars.six_storage_online_fs_Technical_error, ".\n                        </h5>\n                        <p class=\"six-storage-grey-text  six-storage-grid-mb15\">").concat(
            /*Please contact storage facility for further information*/
            wordpress_vars.six_storage_online_fs_Please_contact_storage, "</p>\n                        <a class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc primary six-storage-grid-mt15 six-storage-grid-mb15 six-storage-grid-pr20 six-storage-grid-pl20\" href=\"").concat(window.location.href, "\">Try Again</a>\n                    </div>\n                </div>\n            </div>");
          }
        } else {
          document.getElementById("six-storage-stepping-buttons").style.display = "none";

          if (typeof discountCourouselSlider !== 'undefined' && discountCourouselSlider !== null && discountCourouselSlider !== "") {
            discountCourouselSlider.style.display = "none";
          }

          window.scrollTo(0, 0);
        }
      })["catch"](function (err) {
        document.getElementById("six-storage-movein-container").innerHTML = "<div class=\"six-storage-grid-row  six-storage-moveinSuccess six-storage-white\">\n        <div class=\"six-storage-grid-col-md-12\">\n           <img src=\"".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/undraw_house_searching_n8mp.svg\" width=\"400\" class=\"six-storage-online-margin-auto cc six-storage-grid-p35\">\n            <div class=\"six-storage-font-weight-bold\">\n                <h5 class=\"cc six-storage-grid-mb10 six-storage-red-text six-storage-font-size-20\">\n                    ").concat(
        /*Technical error*/
        wordpress_vars.six_storage_online_fs_Technical_error, ".\n                </h5>\n                <p class=\"six-storage-grey-text  six-storage-grid-mb15\">").concat(
        /*Please contact storage facility for further information*/
        wordpress_vars.six_storage_online_fs_Please_contact_storage, "</p>\n                <a class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc primary six-storage-grid-mt15 six-storage-grid-mb15 six-storage-grid-pr20 six-storage-grid-pl20\" href=\"").concat(window.location.href, "\">").concat(
        /*Try Again*/
        wordpress_vars.six_storage_online_fs_Try_Again, "</a>\n            </div>\n        </div>\n    </div>");

        if (typeof discountCourouselSlider !== 'undefined' && discountCourouselSlider !== null && discountCourouselSlider !== "") {
          discountCourouselSlider.style.display = "none";
        }

        window.scrollTo(0, 0);
        console.log(err);
      });
    }
  }, {
    key: "SixStorageDashboard",
    value: function SixStorageDashboard() {
      window.location.href = document.getElementById("six-storage-dashboard-url").value;
    }
  }, {
    key: "sixStorageMoveinPaymentModeChange",
    value: function sixStorageMoveinPaymentModeChange(id) {
      document.getElementById("creditcard-payment").style.display = "none";
      document.getElementById("six-storage-proceed-cash-payment").style.display = "none";
      document.getElementById(id).style.display = "block";
    }
  }, {
    key: "sixStorageValidateUsernamePaswordPolicy",
    value: function sixStorageValidateUsernamePaswordPolicy(userName, password, messageContainer) {
      var listItem = document.createElement("ul");
      var errors = [];
      var re = /^\w+$/;

      if (wordpress_vars.sso_enabled !== true && wordpress_vars.sso_enabled !== "1") {
        if (!this.helper.sixStorageValidateEmail(userName)) {
          if (!re.test(userName.value)) {
            //messageContainer.innerHTML = "Error: Username must contain only letters, numbers and underscores!";
            errors.push("".concat(
            /*Error: Username must contain only letters, numbers and underscores!*/
            wordpress_vars.six_storage_online_su_Error_Username_must_contain_only_letters_numbers_underscores));
          } else {
            document.getElementById('six-storage-signupUserName-err').style.display = "none";
          }
        }
      }

      if (password != "" && password == password) {
        if (password.length < 8) {
          errors.push("".concat(
          /*Error: Password must contain at least six characters!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_six_characters));
        }

        if (password == userName) {
          errors.push("".concat(
          /*Error: Password must be different from Username!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_be_different_Username));
        }

        re = /[0-9]/;

        if (!re.test(password)) {
          errors.push("".concat(
          /*Error: Password must contain at least one number (0-9)!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_one_number));
        }

        re = /[a-z]/;

        if (!re.test(password)) {
          errors.push("".concat(
          /*Error: Password must contain at least one lowercase letter (a-z)!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_one_lowercase_letter));
        }

        re = /[A-Z]/;

        if (!re.test(password)) {
          errors.push("".concat(
          /*Error: Password must contain at least one uppercase letter (A-Z)!*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_one_uppercase_letter));
        }

        re = /[*@!#%&()$^~{}]/;

        if (!re.test(password)) {
          errors.push("".concat(
          /*Error: The password must contain at least one special character Example(!@#$^*)*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_One_Special_characters));
        }

        if (password.includes('\\') || password.includes('%') || password.includes('<') || password.includes('>') || password.includes('&') || password.includes("'") || password.includes('"') || password.includes("/")) {
          errors.push("".concat(
          /*Please remove these symbols in password (<>/\\&")*/
          wordpress_vars.six_storage_online_su_Error_Password_must_contain_remove_special_characters + '(%,<>,/,\\,",&")'));
        }
      } else {
        errors.push("".concat(
        /*Error: Please check that you have entered and confirmed your Password!*/
        wordpress_vars.six_storage_online_su_Error_Please_check_entered_confirmed_Password));
      }

      if (errors.length > 0) {
        messageContainer.innerHTML = " ";
        messageContainer.appendChild(this.sixStorageGenerateListFromArray(errors));
        document.getElementById('six-storage-sign-up-response').style.display = "block";
        return false;
      }

      return true;
    }
  }, {
    key: "sixStorageGenerateListFromArray",
    value: function sixStorageGenerateListFromArray(array) {
      var list = document.createElement('ul');

      for (var i = 0; i < array.length; i++) {
        var item = document.createElement('li');
        item.appendChild(document.createTextNode(array[i]));
        list.appendChild(item);
      }

      return list;
    }
  }, {
    key: "sixStorageGetIdentityTypes",
    value: function sixStorageGetIdentityTypes() {
      var _this70 = this;

      var formData = new FormData();
      formData.append("action", "six_storage_identity_types");
      formData.append("activeStatus", 1);
      formData.append("visibility", 1);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this70.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response39 = JSON.parse(data);

          if (typeof _response39.isSuccess !== "undefined" && _response39 !== null && _response39.isSuccess === true) {
            if (typeof _response39.result !== "undefined" && _response39 !== null && _response39.result !== null) {
              _this70.identityTypes = _response39.result;

              _this70.sixStorageConstructIdentityTypes(_this70.identityTypes);
            } else {
              document.getElementById("six-storage-loading-container").innerHTML = _this70.helper.sixStorageShowBusyIndicator(false);
            }
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this70.helper.sixStorageShowBusyIndicator(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this70.helper.sixStorageShowBusyIndicator(false);
        }

        _materialize["default"].AutoInit();

        _materialize["default"].updateTextFields();
      });
    }
  }, {
    key: "sixStorageConstructIdentityTypes",
    value: function sixStorageConstructIdentityTypes(identityTypes) {
      var identity_type = document.getElementById("six-storage-identity_type");

      if (identityTypes.length > 0 && identity_type.options.length === 0) {
        identity_type.innerHTML = "";
        var identity = document.createElement("option");
        identity.value = "";
        identity.text = "".concat(
        /*Select Identity*/
        wordpress_vars.six_storage_online_mi_Select_Identity);
        identity_type.append(identity);
        identityTypes.forEach(function (value, index) {
          var identity = document.createElement("option");
          identity.value = value["id"];
          identity.text = value["identification"];
          identity_type.append(identity);
        });
      }

      _materialize["default"].AutoInit();
    }
  }, {
    key: "sixStorageChangeIdentityType",
    value: function sixStorageChangeIdentityType() {
      var _this71 = this;

      var identity_type = document.getElementById("six-storage-identity_type");
      var selectedIdentity = identity_type.options[identity_type.selectedIndex].value;

      if (typeof selectedIdentity !== "undefined" && selectedIdentity !== null && selectedIdentity !== null) {
        var identity = {};
        this.identityTypes.forEach(function (value, index) {
          if (value.id === selectedIdentity) {
            identity = _this71.identityTypes[index];
          }
        });

        if (typeof identity !== "undefined" && identity !== null && identity !== null) {
          document.getElementById('six-storage-identity_type-err').style.display = 'none';

          var _fieldsContainer = document.getElementById("six-storage-identity-fields-container");

          var identityHtml = "";
          identity.identityFields.forEach(function (value, index) {
            var fieldclassname = "";
            var fieldReadonly = "";
            var minValue = "";
            var dateicon = "";
            var sixStorageDataType = "";
            var fieldType = value.fieldType;

            if (fieldType === "Alpha Numeric" || fieldType === "ALPHANUMERIC") {
              fieldType = "text";
              sixStorageDataType = 'sixStorageCheckAlphanumeric(event)';
            } else if (fieldType === "Alphabet" || fieldType === "LETTER") {
              sixStorageDataType = 'sixStorageCheckAlphabets(event)';
              fieldType = "text";
            } else if (fieldType === "DATEPICKER" || fieldType === "Date") {
              fieldType = "text";
              fieldclassname = "six-storage-date-control-id-fields";
              fieldReadonly = "readonly";
              dateicon = '<i class="six-storage-material-icons notranslate six-storage-dateicon-append six-storage-grey-text">date_range</i>';
            } else if (fieldType === "Numeric" || fieldType === "NUMERIC") {
              fieldType = "number";
              minValue = "min=\"0\"";
              sixStorageDataType = 'sixStorageCheckNumber(event)';
            }

            identityHtml = identityHtml + "<div class=\"six-storage-col six-storage-l6 six-storage-m6 six-storage-s12 six-storage-input-field cc\">\n               ".concat(dateicon, "\n                        <input id=\"six_storage_id_number_").concat(index, "\" oninput=\"").concat(sixStorageDataType, "\"  class=\"cc six-storage-id_fields six-storage-identity-fields six-storage-identity-fields_").concat(selectedIdentity, " ").concat(fieldclassname, "\" data-fieldName=\"").concat(value.fieldName, "\"\n                         data-fieldId=\"").concat(value.fieldId, "\" type=\"").concat(fieldType, "\" ").concat(fieldReadonly, " ").concat(minValue, "/>\n                        <span class=\"six-storage-highlight\"></span>\n                        <label class=\"cc\">").concat(value.fieldName, "</label>\n                    <div style=\"display: none;\" id=\"six_storage_id_number_").concat(index, "-err\" class=\"six-storage-invalid-feedback\">").concat(
            /*Please Enter*/
            wordpress_vars.six_storage_online_fs_Please_Enter, " ").concat(value.fieldName, "</div>\n                    </div>\n                ");
          });
          _fieldsContainer.innerHTML = identityHtml;
          var date = new Date();
          this.sixStorageInitDatepickerClassname("six-storage-date-control-id-fields", new Date("".concat(date.getFullYear() - 60, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())), new Date("".concat(date.getFullYear() + 20, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())));
          var formInputFields = document.getElementsByClassName("six-storage-id_fields");
          Array.prototype.forEach.call(formInputFields, function (field) {
            field.addEventListener("change", function (event) {
              _this71.sixStorageFieldChange(event);
            });
          });
          this.sixStorageAllInputHighlight();
          this.sixStorageHighlightInputLabel("six-storage-floating-input");

          _materialize["default"].updateTextFields();
        }
      } else {
        fieldsContainer.innerHTML = "";
      }
    }
  }, {
    key: "sixStorageSaveVehicleInformation",
    value: function sixStorageSaveVehicleInformation() {
      var _this72 = this;

      var formData = new FormData();
      formData.append("action", "six_storage_save_vehicle_information");
      formData.append("vehicleInformation", JSON.stringify(this.vehicleInfo));
      formData.append("leaseProfileId", this.tentnantDetailsId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this72.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response40 = JSON.parse(data);

          if (typeof _response40.isSuccess !== "undefined" && _response40 !== null && _response40.isSuccess === true) {
            if (typeof _response40.result !== "undefined" && _response40 !== null && _response40.result !== null) {//console.log("vehicleinformation => " + JSON.stringify(response));
            } else {
              document.getElementById("six-storage-loading-container").innerHTML = _this72.helper.sixStorageShowBusyIndicator(false);
            }
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this72.helper.sixStorageShowBusyIndicator(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this72.helper.sixStorageShowBusyIndicator(false);
        }
      });
    }
  }, {
    key: "sixStorageGetBufferTime",
    value: function sixStorageGetBufferTime() {
      var _this73 = this;

      var formData = new FormData();
      var move_in_date = this.helper.sixStorageReadDate(document.getElementById("six-storage-dtmoveindate").value);
      formData.append("action", "six_storage_get_buffer_time");
      formData.append("moveindate", move_in_date);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this73.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response41 = JSON.parse(data);

          if (typeof _response41.isSuccess !== "undefined" && _response41 !== null && _response41.isSuccess === true) {
            if (typeof _response41.result !== "undefined" && _response41 !== null && _response41.result !== null) {
              _this73.setBuffertimeDescription(false, _response41.result);
            } else {
              document.getElementById("six-storage-loading-container").innerHTML = _this73.helper.sixStorageShowBusyIndicator(false);
            }
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this73.helper.sixStorageShowBusyIndicator(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this73.helper.sixStorageShowBusyIndicator(false);
        }
      });
    }
  }, {
    key: "setBuffertimeDescription",
    value: function setBuffertimeDescription(reset, nextDate) {
      if (reset === true) {
        document.getElementById("six-storage-bufferTimeDescription").innerHTML = "";
      } else if (typeof nextDate !== "undefined" && nextDate !== null) {
        document.getElementById("bufferTimeDescription").innerHTML = "Access till : ".concat(this.helper.sixStorageDisplayDate(nextDate));
      }
    } // Adjust canvas coordinate space taking into account pixel ratio,
    // to make it look crisp on mobile devices.
    // This also causes canvas to be cleared.

  }, {
    key: "sixStorageResizeCanvas",
    value: function sixStorageResizeCanvas() {
      // When zoomed out to less than 100%, for some very strange reason,
      // some browsers report devicePixelRatio as less than 1
      // and only part of the canvas is cleared then.
      var ratio = Math.max(window.devicePixelRatio || 1, 1); // This part causes the canvas to be cleared

      this.canvas.width = this.canvas.offsetWidth * ratio;
      this.canvas.height = this.canvas.offsetHeight * ratio;
      this.canvas.getContext("2d").scale(ratio, ratio); // This library does not listen for canvas changes, so after the canvas is automatically
      // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
      // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
      // that the state of this library is consistent with visual state of the canvas, you
      // have to clear it manually.
      //this.signaturePad.clear();
    }
  }, {
    key: "download",
    value: function download(dataURL, filename) {
      if (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") === -1) {
        window.open(dataURL);
      } else {
        var blob = dataURLToBlob(dataURL);
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.style = "display: none";
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } // One could simply use Canvas#toBlob method instead, but it's just to show
    // that it can be done using result of SignaturePad#toDataURL.

  }, {
    key: "dataURLToBlob",
    value: function dataURLToBlob(dataURL) {
      var parts = dataURL.split(";base64,");
      var contentType = parts[0].split(":")[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;
      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], {
        type: contentType
      });
    }
  }, {
    key: "sixStorageDisplayEmergencyContact",
    value: function sixStorageDisplayEmergencyContact() {
      document.getElementById("six-storage-emergency-fields").style.display = "";
      document.getElementById("six-storage-addemergencydetails").style.display = ""; //document.getElementById("add-emergencyFields").style.display = "none";

      document.getElementById("six-storage-emergency-err").style.display = "none";
      var contactTable = document.getElementById("six-storage-emergencyContact-tbody");

      if (contactTable.children.length > 0) {
        document.getElementById("six-storage-emergency-add-more").style.display = "none";
      }

      var emergency_contact_phone = document.getElementById("six-storage-emergency_contact_phone");
      emergency_contact_phone.oninput = this.helper.sixStorageCheckPhoneNumber;
    }
  }, {
    key: "sixStorageInitDatepicker",
    value: function sixStorageInitDatepicker(id, mindate, maxdate, selectCallback, selectedDate, range) {
      // console.log(`${id}, ${mindate}, ${maxdate}, ${selectCallback}, ${selectedDate}`);
      var date = new Date();
      var elems = document.querySelector(id);
      var format = this.helper.sixStorageSanitizeMaterialDateFormat(this.helper.dateFormat); // let culturecode = this.helper.culture;

      var rangeFormat = range == 'dob' ? [1910, new Date().getFullYear()] : 10;
      var translation = this.helper.sixStorageCalenderTranslaton();

      var instance = _materialize["default"].Datepicker.init(elems, {
        autoClose: true,
        defaultDate: selectedDate,
        // typeof selectedDate !== "undefined" && selectedDate !== "" && selectedDate !== null ? selectedDate : new Date(),
        setDefaultDate: true,
        container: 'body',
        minDate: typeof mindate !== "undefined" && mindate !== "" && mindate !== null ? mindate : new Date("".concat(date.getFullYear() - 10, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())),
        maxDate: typeof maxdate !== "undefined" && maxdate !== "" && maxdate !== null ? maxdate : new Date("".concat(date.getFullYear() + 50, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())),
        format: format,
        showClearBtn: false,
        onSelect: _typeof(selectCallback) !== undefined && selectCallback !== "" && selectCallback !== null ? selectCallback : window.sixStorageAllInputHighlight,
        yearRange: rangeFormat,
        i18n: translation
      });
    }
  }, {
    key: "sixStorageInitDatepickerClassname",
    value: function sixStorageInitDatepickerClassname(classname, mindate, maxdate) {
      var elems = document.querySelectorAll('.' + classname);
      var format = this.helper.sixStorageSanitizeMaterialDateFormat(this.helper.dateFormat); // let culturecode = this.helper.culture;

      var translation = this.helper.sixStorageCalenderTranslaton();

      if (elems.length > 0) {
        var instance = _materialize["default"].Datepicker.init(elems, {
          autoClose: true,
          minDate: typeof mindate !== "undefined" && mindate !== "" && mindate !== null ? mindate : mindate,
          maxDate: typeof maxdate !== "undefined" && maxdate !== "" && maxdate !== null ? maxdate : maxdate,
          format: format,
          showClearBtn: false,
          container: 'body',
          onSelect: window.sixStorageAllInputHighlight,
          i18n: translation,
          yearRange: 10
        });
      }
    }
  }, {
    key: "sixStorageDisplayEsign",
    value: function sixStorageDisplayEsign() {
      var agreement = document.getElementById("six-storage-lease-agreement");
      var sixstoragepaymentform = document.getElementById("six-storage-payment-form-div").classList; //let acceptConditions = document.getElementById("terms-and-conditions");

      var terms = document.getElementsByClassName("terms_");
      var status = true;
      Array.prototype.forEach.call(terms, function (item) {
        if (!item.checked) {
          status = false;
        } else {
          document.getElementById("six-storage-signature-pad").style.display = "none";
        }
      });

      if (agreement.checked === true && status === true) {
        Array.prototype.forEach.call(terms, function (item) {
          if (!item.checked) {
            document.getElementById("".concat(item.id, "-err")).style.display = "";
          } else {
            document.getElementById("".concat(item.id, "-err")).style.display = "none";
          }
        });
        document.getElementById('six-storage-termsAndCondition-error').style.display = "none";
        document.getElementById("six-storage-lease-agreement-err").style.display = "none";
        document.getElementById("six-storage-signature-pad").style.display = "";
        sixstoragepaymentform.remove('six-storage-d-none');
        sixstoragepaymentform.add('six-storage-flexbox-important');

        if (this.moveinWithoutPayment == true) {
          document.getElementById("six-storage-section-paylater").style.display = "none";
          document.getElementById('six-storage-MoveInWithoutPayment').style.display = '';
        } else {
          document.getElementById("six-storage-section-paylater").style.display = "";
          document.getElementById('six-storage-MoveInWithoutPayment').style.display = 'none';
        } // this.sixStorageResizeCanvas();

      } else {
        sixstoragepaymentform.add('six-storage-d-none');
        sixstoragepaymentform.remove('six-storage-flexbox-important');
        document.getElementById("six-storage-section-paylater").style.display = "none";
        document.getElementById("six-storage-signature-pad").style.display = "none";
        document.getElementById("six-storage-payment-form-div").style.display = "";
        document.getElementById("six-storage-no-payment-gateway-msg").style.display = "none";
      }
    }
  }, {
    key: "sixStorageGotoAddon",
    value: function sixStorageGotoAddon() {
      this.currentStepNumber = 3;
      this.sixStorageRenderStepHtml();
    }
  }, {
    key: "sixStorageFieldChange",
    value: function sixStorageFieldChange(event) {
      if (event.target.value !== "") {
        document.getElementById("".concat(event.target.id, "-err")).style.display = "none";
      }
    }
  }, {
    key: "sixStorageLoadPaymentForm",
    value: function sixStorageLoadPaymentForm(fullDiscountMovein) {
      this.fullDiscount = fullDiscountMovein;
      document.getElementById('six-storage-promoCodetext-err').style.display = 'none';
      document.getElementById('six-storage-book-now-pay-later').style.display = 'none';
      var agreement = document.getElementById("six-storage-lease-agreement"); // let tenant_esign = document.getElementById("tenant-esign");
      // let esignEnabled = tenant_esign.dataset.element_hidden;
      // let esignMandatory = tenant_esign.dataset.element_required;

      var terms = document.getElementsByClassName("terms_");
      var status = true;
      Array.prototype.forEach.call(terms, function (item) {
        if (!item.checked) {
          status = false;
          document.getElementById("".concat(item.id, "-err")).style.display = "";
        } else {
          document.getElementById("".concat(item.id, "-err")).style.display = "none";
        }
      });
      var esignURL = this.signaturePad._data;

      if (agreement.checked && status === true) {
        document.getElementById("six-storage-lease-agreement-err").style.display = "none"; // if (typeof esignEnabled === 'undefined' || esignEnabled === null || esignEnabled === "false" || esignMandatory === "false") {

        if (typeof this.esignMandatory === 'undefined' || this.esignMandatory === false || this.esignMandatory === null) {
          document.getElementById("six-storage-esign-error").style.display = "none";

          if (fullDiscountMovein == true) {
            this.sixStorageSaveMoveinDetails(false);
          } else if (fullDiscountMovein == false) {
            var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
            var paymentmode = clientConfig.paymentModes;

            for (var i = 0; i < paymentmode.length; i++) {
              var obj = paymentmode[i];
            }

            var result = clientConfig.paymentModes.filter(function (i) {
              return i.value !== 'PayLater';
            });

            if (result.length !== 0) {
              this.sixStoragePaymentOption();
            }
          }
        } else if (typeof esignURL !== 'undefined' && esignURL !== null && esignURL !== "" && esignURL.length > 0) {
          document.getElementById("six-storage-esign-error").style.display = "none";

          if (fullDiscountMovein == true) {
            this.sixStorageSaveMoveinDetails(false);
          } else if (fullDiscountMovein == false) {
            var _clientConfig3 = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));

            var customSettings = _clientConfig3.customSettings.filter(function (i) {
              return i.settingName === 'ENABLE_MOVEIN_APPROVAL';
            });

            var _result = _clientConfig3.paymentModes.filter(function (i) {
              return i.value !== 'PayLater';
            });

            if (_result.length !== 0) {
              this.sixStoragePaymentOption();
            }
          }
        } else {
          document.getElementById("six-storage-esign-error").style.display = "";
          document.getElementById('six-storage-rdbtn_pay_now').checked = false;
          document.getElementById('six-storage-rdbtn_pay_later').checked = false;
        }
      } else {
        document.getElementById('six-storage-termsAndCondition-error').style.display = "";
        var paynowRadioButton = document.getElementById('six-storage-rdbtn_pay_now');

        if (typeof paynowRadioButton !== 'undefined' && paynowRadioButton !== null) {
          document.getElementById('six-storage-rdbtn_pay_now').checked = false;
        }

        if (agreement.checked === false) {
          document.getElementById("six-storage-lease-agreement-err").style.display = "";
        } else {
          document.getElementById("six-storage-lease-agreement-err").style.display = "none";
        }
      }
    }
    /* Code for Cache Issue */

  }, {
    key: "sixStoragePaymentsection",
    value: function sixStoragePaymentsection() {
      var html = '';
      var sixStoragePaymentarray = [];
      var sixStorageconfigdetail = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var sixStoragepaymentmode = sixStorageconfigdetail.paymentModes;
      sixStoragepaymentmode.map(function (result) {
        sixStoragePaymentarray.push(result["value"]);
      });
      var sixStoragecustomsettingvalarray = [];
      var sixStoragecustomsettingval = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var sixStoragecustomdetail = sixStoragecustomsettingval.customSettings;

      if (typeof sixStoragecustomdetail !== 'undefined' && sixStoragecustomdetail !== "" && sixStoragecustomdetail !== null && sixStoragecustomdetail.length > 0) {
        sixStoragecustomsettingvalarray = sixStoragecustomdetail.filter(function (i) {
          return i.settingName === "ENABLE_MOVEIN_APPROVAL";
        });
      }

      if (typeof sixStoragecustomsettingvalarray !== "undefined" && sixStoragecustomsettingvalarray !== null && sixStoragecustomsettingvalarray !== "" && sixStoragecustomsettingvalarray.length > 0 && sixStoragecustomsettingvalarray[0].settingValue == 'YES') {
        html = "<button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color\" id=\"six-storage-proceed-payment\" onclick=\"sixStorageLoadPaymentForm(false);\">".concat(wordpress_vars.six_storage_online_confirm_booking_text, "</button>");
      } else {
        if (sixStoragePaymentarray.includes('PayLater') == true && sixStoragePaymentarray.includes('DirectDebit') == false && sixStoragePaymentarray.includes('CreditCard') == false) {
          if (this.esignEnabled == false || this.esignEnabled == true && this.esignMandatory == false) {
            document.getElementById('six-storage-book-now-pay-later').style.display = 'block';
          } else {
            var sixStorageEsignVal = document.getElementById('six-storage-signature-canvas');
            var sixStorageEsignData = this.signaturePad.toDataURL();

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              sixStorageEsignVal.addEventListener('touchstart', function (event) {
                if (typeof sixStorageEsignData != "undefined" && sixStorageEsignData != null && sixStorageEsignData != "" && typeof sixStorageEsignData != "undefined") {
                  document.getElementById('six-storage-book-now-pay-later').style.display = 'block';
                  document.getElementById('six-storage-esign-error').style.display = 'none';
                }
              });
            } else {
              sixStorageEsignVal.addEventListener('mouseup', function (event) {
                if (typeof sixStorageEsignData != "undefined" && sixStorageEsignData != null && sixStorageEsignData != "" && typeof sixStorageEsignData != "undefined") {
                  document.getElementById('six-storage-book-now-pay-later').style.display = 'block';
                  document.getElementById('six-storage-esign-error').style.display = 'none';
                }
              });
            }
          }
        } else if (sixStoragePaymentarray.includes('CreditCard') == true && sixStoragePaymentarray.includes('DirectDebit') == true && sixStoragePaymentarray.includes('PayLater') == false) {
          html = "<button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color\" id=\"six-storage-proceed-payment\" onclick=\"sixStorageLoadPaymentForm(false);\">".concat(wordpress_vars.six_storage_online_fc_Pay_Now, "</button>");
        } else if (sixStoragePaymentarray.includes('CreditCard') == false && sixStoragePaymentarray.includes('DirectDebit') == true && sixStoragePaymentarray.includes('PayLater') == false) {
          html = "<button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color\" id=\"six-storage-proceed-payment\" onclick=\"sixStorageLoadPaymentForm(false);\">".concat(wordpress_vars.six_storage_online_fc_Pay_Now, "</button>");
        } else if (sixStoragePaymentarray.includes('CreditCard') == true && sixStoragePaymentarray.includes('DirectDebit') == false && sixStoragePaymentarray.includes('PayLater') == false) {
          html = "<button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color\" id=\"six-storage-proceed-payment\" onclick=\"sixStorageLoadPaymentForm(false);\">".concat(wordpress_vars.six_storage_online_fc_Pay_Now, "</button>");
        } else if (sixStoragePaymentarray.includes('CreditCard') == true && sixStoragePaymentarray.includes('DirectDebit') == true && sixStoragePaymentarray.includes('PayLater') == true) {
          html = "<label class=\"cc six-storage-col six-storage-s6 six-storage-m6 six-storage-l6\" id=\"six-storage-proceed-payment\" >\n        <input class=\"six-storage-with-gap six-storage-input-field cc\" onclick=\"sixStorageLoadPaymentForm(false,event);\" id=\"six-storage-rdbtn_pay_now\" name=\"group3\" type=\"radio\" />\n        <span style=\"white-space:nowrap;\">".concat(wordpress_vars.six_storage_online_fc_Pay_Now, "</span>\n    </label>\n    <label class=\"cc six-storage-col six-storage-s6 six-storage-m6 six-storage-l6\" id=\"six-storage-proceed-cash-payment\" onclick=\"sixStorageSaveMoveinPayLater();\">\n        <input class=\"six-storage-with-gap six-storage-input-field cc\" id=\"six-storage-rdbtn_pay_later\" name=\"group3\" type=\"radio\" />\n        <span style=\"white-space:nowrap;\">").concat(wordpress_vars.six_storage_online_Pay_Later_text, "</span>\n    </label>\n    ");
        } else if (sixStoragePaymentarray.includes('CreditCard') == true && sixStoragePaymentarray.includes('DirectDebit') == false && sixStoragePaymentarray.includes('PayLater') == true) {
          html = "<label class=\"cc six-storage-col six-storage-s6 six-storage-m6 six-storage-l6\" id=\"six-storage-proceed-payment\" >\n        <input class=\"six-storage-with-gap six-storage-input-field cc\" onclick=\"sixStorageLoadPaymentForm(false,event);\" id=\"six-storage-rdbtn_pay_now\" name=\"group3\" type=\"radio\" />\n        <span style=\"white-space:nowrap;\">".concat(wordpress_vars.six_storage_online_fc_Pay_Now, "</span>\n    </label>\n    <label class=\"cc six-storage-col six-storage-s6 six-storage-m6 six-storage-l6\" id=\"six-storage-proceed-cash-payment\" onclick=\"sixStorageSaveMoveinPayLater();\">\n        <input class=\"six-storage-with-gap six-storage-input-field cc\" id=\"six-storage-rdbtn_pay_later\" name=\"group3\" type=\"radio\" />\n        <span style=\"white-space:nowrap;\">").concat(wordpress_vars.six_storage_online_Pay_Later_text, "</span>\n    </label>");
        } else if (sixStoragePaymentarray.includes('CreditCard') == false && sixStoragePaymentarray.includes('DirectDebit') == true && sixStoragePaymentarray.includes('PayLater') == true) {
          html = "<label class=\"cc six-storage-col six-storage-s6 six-storage-m6 six-storage-l6\" id=\"six-storage-proceed-payment\" >\n        <input class=\"six-storage-with-gap six-storage-input-field cc\" onclick=\"sixStorageLoadPaymentForm(false,event);\" id=\"six-storage-rdbtn_pay_now\" name=\"group3\" type=\"radio\" />\n        <span style=\"white-space:nowrap;\">".concat(wordpress_vars.six_storage_online_fc_Pay_Now, "</span>\n    </label>\n    <label class=\"cc six-storage-col six-storage-s6 six-storage-m6 six-storage-l6\" id=\"six-storage-proceed-cash-payment\" onclick=\"sixStorageSaveMoveinPayLater();\">\n        <input class=\"six-storage-with-gap six-storage-input-field cc\" id=\"six-storage-rdbtn_pay_later\" name=\"group3\" type=\"radio\" />\n        <span style=\"white-space:nowrap;\">").concat(wordpress_vars.six_storage_online_Pay_Later_text, "</span>\n    </label>");
        } else {
          html = "<button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn cc six-storage-primary-background-color\" id=\"six-storage-proceed-payment\" onclick=\"sixStorageLoadPaymentForm(false);\">".concat(wordpress_vars.six_storage_online_fc_Pay_Now, "</button>");
        }
      }

      document.getElementById("six-storage-section-paylater").innerHTML = html;
    }
    /* Code for cache issue */

  }, {
    key: "sixStoragePaymentOption",
    value: function sixStoragePaymentOption() {
      var _this74 = this;

      var currentSession = sessionStorage.getItem("SixStorageclientConfig");

      if (currentSession !== null) {
        var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
        var result = clientConfig.paymentModes.filter(function (i) {
          return i.value !== 'PayLater';
        });
        var nopaymentgateway = clientConfig.culture;
        var paymentgatewayselect = nopaymentgateway.paymentGateway;

        if (typeof paymentgatewayselect !== "undefined" && paymentgatewayselect !== "" && paymentgatewayselect !== "") {
          if (paymentgatewayselect === "EMERCHANT") {
            document.getElementById("six-storage-payment-selection").style.display = 'none';
            document.getElementById("six-storage-no-payment-gateway-msg").style.display = 'block';
            document.getElementById("six-storage-no-payment-gateway-msg").innerHTML = "Payment Gateway is not configured, payments cannot be processed at this time";
          } else {
            document.getElementById("six-storage-payment-selection").style.display = 'block';
          }
        }

        if (typeof result !== 'undefined' && result !== null && result.length > 1) {
          var optionValuesHtml = result.map(function (i) {
            return "<option data-value=\"".concat(i.value, "\" value=\"").concat(i.id, "\">").concat(i.text, "</option>");
          });
          var paymentSelectionHtml = "<div class=\"six-storage-input-field six-storage-col six-storage-s12 cc\">\n          <select class=\"cc\" id=\"six-storage-payment-option\">\n          <option value=\"\" disabled selected>".concat(wordpress_vars.six_storage_online_select_payment_option, "</option>\n            ").concat(optionValuesHtml.join(''), "\n          </select>\n          <label class=\"cc\" for=\"six-storage-location\">").concat(wordpress_vars.six_storage_online_choose_payment_type, "</label>\n          <div style=\"display: none;\" id=\"six-storage-payment-option-err\" class=\"six-storage-invalid-feedback\">Please Select Payment Option</div>\n        </div>");

          if (!paymentgatewayselect === "EMERCHANT" && typeof paymentgatewayselect !== "undefined" && paymentgatewayselect !== "" && paymentgatewayselect !== "") {
            document.getElementById('six-storage-payment-selection').style.display = 'block';
          }

          document.getElementById('six-storage-payment-selection').innerHTML = "".concat(paymentSelectionHtml);
          var paymentSelection = document.getElementById('six-storage-payment-option');

          if (typeof paymentSelection !== "" && paymentSelection !== null) {
            paymentSelection.addEventListener('change', function (event) {
              _this74.sixStoragePaymentModeSelection();
            });
          }

          var elems = document.querySelectorAll('select');

          var instances = _materialize["default"].FormSelect.init(elems);
        } else if (typeof result !== 'undefined' && result !== null && result.length === 1) {
          var paymentmodeId = result[0].id;
          var paymentModeText = result[0].value;

          var _clientConfig4 = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));

          var customSettings = _clientConfig4.customSettings.filter(function (i) {
            return i.settingName === 'ENABLE_MOVEIN_APPROVAL';
          });

          if (typeof customSettings !== 'undefined' && customSettings !== null && customSettings !== '' && customSettings.length > 0) {
            var settingvalue = customSettings[0].settingValue;

            if (settingvalue !== 'YES') {
              this.paymentForm(paymentmodeId, paymentModeText);
            } else {
              this.sixStorageLoadAddCardPaymentForm(paymentmodeId);
            }
          } else {
            this.paymentForm(paymentmodeId, paymentModeText);
          }
        }
      }

      _materialize["default"].updateTextFields();
    }
  }, {
    key: "sixStoragePaymentModeSelection",
    value: function sixStoragePaymentModeSelection() {
      var paymentModeIdVal = document.getElementById('six-storage-payment-option');
      var paymentText = paymentModeIdVal.options[paymentModeIdVal.selectedIndex].getAttribute('data-value');
      var obj = {
        paymentmodeId: typeof paymentModeIdVal !== 'undefined' && paymentModeIdVal !== null && paymentModeIdVal !== '' && typeof paymentModeIdVal.value !== 'undefined' && paymentModeIdVal.value !== null ? paymentModeIdVal.value : '',
        paymentmodeText: typeof paymentText !== 'undefined' && paymentText !== null && paymentText !== '' ? paymentText : ''
      };
      var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var customSettings = clientConfig.customSettings.filter(function (i) {
        return i.settingName === 'ENABLE_MOVEIN_APPROVAL';
      });

      if (typeof customSettings !== 'undefined' && customSettings !== null && customSettings !== '' && customSettings.length > 0) {
        var settingvalue = customSettings[0].settingValue;

        if (settingvalue !== 'YES') {
          this.paymentForm(obj.paymentmodeId, obj.paymentmodeText);
        } else {
          this.sixStorageLoadAddCardPaymentForm(obj.paymentmodeId);
        }
      } else {
        this.paymentForm(obj.paymentmodeId, obj.paymentmodeText);
      }
    }
  }, {
    key: "sixStorageSaveMoveinPayLater",
    value: function sixStorageSaveMoveinPayLater() {
      document.getElementById('six-storage-promoCodetext-err').style.display = 'none';
      document.getElementById("six-storage-no-payment-gateway-msg").style.display = 'none';
      var agreement = document.getElementById("six-storage-lease-agreement");
      var sixstoragepaymentform = document.getElementById("six-storage-payment-form-div").classList;
      sixstoragepaymentform.remove('six-storage-d-none');
      sixstoragepaymentform.add('six-storage-flexbox-important');
      document.getElementById("six-storage-card_actions").style.display = "none";
      document.getElementById("six-storage-iban-notes").style.display = "none";
      document.getElementById("six-storage-dvPaymentForm").innerHTML = "";
      document.getElementById("six-storage-creditgrid-card-payment").style.display = "none"; // let tenant_esign = document.getElementById("tenant-esign");
      // let esignEnabled = tenant_esign.dataset.element_hidden;
      // let esignMandatory = tenant_esign.dataset.element_required;
      // let esignURL = this.signaturePad._data;

      var terms = document.getElementsByClassName("terms_");
      var status = true;
      Array.prototype.forEach.call(terms, function (item) {
        if (!item.checked) {
          status = false;
          document.getElementById("".concat(item.id, "-err")).style.display = "";
        } else {
          document.getElementById("".concat(item.id, "-err")).style.display = "none";
        }
      });
      var esignURL = this.signaturePad._data;

      if (agreement.checked && status === true) {
        if (typeof this.esignMandatory === 'undefined' || this.esignMandatory === false || this.esignMandatory === null) {
          document.getElementById("six-storage-esign-error").style.display = "none";
          document.getElementById("six-storage-book-now-pay-later").style.display = "";
          document.getElementById("six-storage-autopay-notes").style.display = "none";
          document.getElementById("six-storage-payment-selection").style.display = "none";
          document.getElementById("six-storage-paylater-book-now").style.display = "";
        } else if (typeof esignURL !== 'undefined' && esignURL !== null && esignURL !== "" && esignURL.length > 0) {
          document.getElementById("six-storage-esign-error").style.display = "none";
          document.getElementById("six-storage-book-now-pay-later").style.display = "";
          document.getElementById("six-storage-payment-selection").style.display = "none";
          document.getElementById("six-storage-autopay-notes").style.display = "none";
          document.getElementById("six-storage-paylater-book-now").style.display = "";
        } else {
          document.getElementById("six-storage-esign-error").style.display = "";
          document.getElementById('six-storage-rdbtn_pay_now').checked = false;
          var sixStoragerdbtnpaylater = document.getElementById('six-storage-rdbtn_pay_later');

          if (typeof sixStoragerdbtnpaylater !== 'undefined' && sixStoragerdbtnpaylater !== null) {
            document.getElementById('six-storage-rdbtn_pay_later').checked = false;
          }
        }
      } else {
        var _sixStoragerdbtnpaylater2 = document.getElementById('six-storage-rdbtn_pay_later');

        if (typeof _sixStoragerdbtnpaylater2 !== 'undefined' && _sixStoragerdbtnpaylater2 !== null && _sixStoragerdbtnpaylater2 !== " ") {
          document.getElementById('six-storage-rdbtn_pay_later').checked = false;
        }

        document.getElementById('six-storage-termsAndCondition-error').style.display = "";

        if (agreement.checked === false) {
          document.getElementById("six-storage-lease-agreement-err").style.display = "";
        }

        document.getElementById('six-storage-rdbtn_pay_later').checked = false;
        document.getElementById('six-storage-termsAndCondition-error').style.display = "";

        if (agreement.checked === false) {
          document.getElementById("six-storage-lease-agreement-err").style.display = "";
        } else {
          document.getElementById("six-storage-lease-agreement-err").style.display = "none";
        }
      }
    }
  }, {
    key: "sixStorageIsNumber",
    value: function sixStorageIsNumber(event) {
      if (event.which !== 8 && isNaN(String.fromCharCode(event.which))) {
        event.preventDefault();
      }
    }
  }, {
    key: "sixStorageAllInputHighlight",
    value: function sixStorageAllInputHighlight() {
      var floatingInputs = document.querySelectorAll(".six-storage-floating-input");
      floatingInputs.forEach(function (ele, index) {
        if (ele.value != "") {
          ele.classList.add("six-storage-floating-active");
        } else {
          ele.classList.remove("six-storage-floating-active");
        }
      });
    }
  }, {
    key: "sixStorageClickInputHiglight",
    value: function sixStorageClickInputHiglight(ele) {
      ele.classList.add("six-storage-floating-active");
    }
  }, {
    key: "sixStorageBlurInputHighlight",
    value: function sixStorageBlurInputHighlight(ele) {
      if (ele.value == "") {
        ele.classList.remove("six-storage-floating-active");
      }
    }
  }, {
    key: "sixStorageHighlightInputLabel",
    value: function sixStorageHighlightInputLabel(classname) {
      var _this75 = this;

      var floatingInputs = document.getElementsByClassName(classname);
      Array.prototype.forEach.call(floatingInputs, function (ele) {
        ele.onkeydown = _this75.sixStorageValidateSpecialChar;
        ele.onpaste = _this75.sixStorageValidateSpecialCharOnPaste;
        ele.addEventListener("focus", function (event) {
          _this75.sixStorageClickInputHiglight(ele);
        });
        ele.addEventListener("blur", function (event) {
          _this75.sixStorageBlurInputHighlight(ele);
        });
      });
    }
  }, {
    key: "sixStorageGridRemove",
    value: function sixStorageGridRemove() {
      var ele = document.querySelector('.six-storage-grid-btn');

      if (ele.classList.contains('six-storage-active')) {
        document.querySelector("#six-storage-online-unit-collection-contianer").classList.remove('six-storage-grid-d-grid');
        ele.classList.remove('six-storage-active');
        ele.innerText = "".concat(
        /*Grid*/
        wordpress_vars.six_storage_online_mi_Grid);
      }

      ele.classList.add('six-storage-d-none');
    }
  }, {
    key: "sixStorageGridToggle",
    value: function sixStorageGridToggle(ele) {
      document.querySelector("#six-storage-online-unit-collection-contianer").classList.toggle('six-storage-grid-d-grid');
      ele.classList.toggle('six-storage-active');
      ele.innerText = '';
      if (ele.classList.contains('six-storage-active')) ele.innerText = "".concat(
      /*List*/
      wordpress_vars.six_storage_online_mi_List);else ele.innerText = "".concat(
      /*Grid*/
      wordpress_vars.six_storage_online_mi_Grid);
    }
  }, {
    key: "updateUsernameField",
    value: function updateUsernameField() {
      var signupemail = document.getElementById('six-storage-signupemail');
      document.getElementById("six-storage-signupUserName").value = signupemail.value;
    }
  }, {
    key: "sixStorageValidateSpecialChar",
    value: function sixStorageValidateSpecialChar(e) {
      var event = e || window.event;
      var key = event.key ? event.key : event.keyCode || event.which; //key = String.fromCharCode(key);

      var regex = /[^;]+$/;

      if (!regex.test(key)) {
        event.returnValue = false;

        if (event.preventDefault) {
          event.preventDefault();
        }
      }
    }
  }, {
    key: "sixStorageValidateSpecialCharOnPaste",
    value: function sixStorageValidateSpecialCharOnPaste(e) {
      var data = e.clipboardData.getData('text/plain');
      var regex = /[^;]+$/;

      if (!regex.test(data)) {
        e.returnValue = false;

        if (e.preventDefault) {
          e.preventDefault();
        }
      }
    }
  }, {
    key: "sixStorageGetMoveinFieldsSettings",
    value: function sixStorageGetMoveinFieldsSettings() {
      var _this76 = this;

      var formData = new FormData();
      var settingsSessionValue = sessionStorage.getItem("moveinFieldSettings");

      if (typeof settingsSessionValue !== 'undefined' && settingsSessionValue !== null) {
        this.moveinFieldSettings = JSON.parse(settingsSessionValue); //return;
      }

      formData.append("action", "six_storage_get_movein_field_settings");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this76.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response42 = JSON.parse(data);

          if (typeof _response42.isSuccess !== "undefined" && _response42 !== null && _response42.isSuccess === true) {
            if (typeof _response42.result !== "undefined" && _response42 !== null && _response42.result !== null) {
              _this76.moveinFieldSettings = _response42.result;
              sessionStorage.setItem("moveinFieldSettings", JSON.stringify(_this76.moveinFieldSettings));
            } else {
              document.getElementById("six-storage-loading-container").innerHTML = _this76.helper.sixStorageShowBusyIndicator(false);
            }
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this76.helper.sixStorageShowBusyIndicator(false);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this76.helper.sixStorageShowBusyIndicator(false);
        }
      });
    }
  }, {
    key: "sixStorageAddUnitCount",
    value: function sixStorageAddUnitCount(unitTypeindex, unitTypeId, vacant, hasDiscount, isSingleUnit) {
      this.groupBasedUnitID = unitTypeId;

      if (this.groupBySize === true && this.rentSingleUnit === true) {
        this.selectedUnitTypes = [];
        this.unitsSelected = [];
      }

      if (hasDiscount == true) {
        var unitCount = document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML;
        var quantityOfUnits = 0;

        if (parseInt(unitCount) === vacant) {
          return;
        }

        if (typeof unitCount !== 'undefined' && unitCount !== null && unitCount !== "") {
          quantityOfUnits = parseInt(unitCount) + 1;
        }

        var unitGroup = this.units[unitTypeindex];

        if (typeof unitGroup !== 'undefined' && unitGroup != null && unitGroup != "") {
          var discountedUnit = unitGroup["discountBasedUnitIds"][quantityOfUnits - 1];
          this.discountBasedUnit.push(discountedUnit["unitId"]);
          document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = quantityOfUnits;
        }
      } else if (isSingleUnit == true) {
        var index = this.selectedUnitTypes.findIndex(function (item, index) {
          return item.index == unitTypeindex && item.unitTypeId == unitTypeId;
        });

        if (index < 0) {
          this.selectedUnitTypes.push({
            index: unitTypeindex,
            unitTypeId: unitTypeId,
            quantity: 1,
            price: this.unitRentInclusiveTax === true ? this.units[unitTypeindex]["netAmount"] : this.units[unitTypeindex]["unitPrice"]
          });

          if (this.rentSingleUnit === false) {
            document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = 1;
          }
        } else {
          var count = parseInt(this.selectedUnitTypes[index]["quantity"]);

          if (count < vacant) {
            this.selectedUnitTypes[index]["quantity"] = count + 1;

            if (this.rentSingleUnit === false) {
              document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = count + 1;
            }
          }
        }
      } else {
        var unitCountHtml = document.getElementById("six-storage-unitCount_".concat(unitTypeindex));

        var _unitCount;

        if (typeof unitCountHtml !== 'undefined' && unitCountHtml !== null && unitCountHtml !== '') {
          _unitCount = document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML;
        }

        var _quantityOfUnits = 0;

        if (parseInt(_unitCount) === vacant) {
          return;
        }

        if (typeof _unitCount !== 'undefined' && _unitCount !== null && _unitCount !== "") {
          _quantityOfUnits = parseInt(_unitCount) + 1;
        }

        var _unitGroup = this.units[unitTypeindex];

        if (typeof _unitGroup !== 'undefined' && _unitGroup != null && _unitGroup != "") {
          var _discountedUnit = _unitGroup["unitIds"][_quantityOfUnits - 1];
          this.discountBasedUnit.push(_discountedUnit);
          document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = _quantityOfUnits;
        } // console.log("this.selectedunitTypeIdcounts", this.selectedunitTypeIdcounts);

      }
    }
  }, {
    key: "sixStorageRemoveUnitCount",
    value: function sixStorageRemoveUnitCount(unitTypeindex, unitTypeId, hasDiscount) {
      var unitCount = document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML;
      var quantityOfUnits = 0;

      if (typeof unitCount !== 'undefined' && unitCount !== null && unitCount !== "") {
        quantityOfUnits = parseInt(unitCount) - 1;
      }

      if (hasDiscount == true) {
        var unitGroup = this.units[unitTypeindex];

        if (typeof unitGroup !== 'undefined' && unitGroup != null && unitGroup != "") {
          var discountedUnit = unitGroup["discountBasedUnitIds"][quantityOfUnits];
          var unitId = discountedUnit["unitId"];
          this.discountBasedUnit.splice(unitId, 1);

          if (quantityOfUnits > 0) {
            document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = quantityOfUnits;
          } else {
            document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = 0;
          }
        }
      } else {
        var _unitGroup2 = this.units[unitTypeindex];

        if (typeof _unitGroup2 !== 'undefined' && _unitGroup2 != null && _unitGroup2 != "") {
          var _discountedUnit2 = _unitGroup2["unitIds"][quantityOfUnits];
          var _unitId = _discountedUnit2;
          var unitsindex = this.discountBasedUnit.indexOf(_unitId);

          if (unitsindex !== -1) {
            this.discountBasedUnit.splice(unitsindex, 1);
          }

          if (quantityOfUnits > 0) {
            document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = quantityOfUnits;
          } else {
            document.getElementById("six-storage-unitCount_".concat(unitTypeindex)).innerHTML = 0;
          }
        } // var index = this.selectedUnitTypes.findIndex((item, index) => { return item.index == unitTypeindex && item.unitTypeId == unitTypeId });
        // if (index > -1) {
        //   if (this.selectedUnitTypes[index]["quantity"] > 1) {
        //     this.selectedUnitTypes[index]["quantity"] = this.selectedUnitTypes[index]["quantity"] - 1;
        //     document.getElementById(`six-storage-unitCount_${unitTypeindex}`).innerHTML = this.selectedUnitTypes[index]["quantity"];
        //   } else {
        //     this.selectedUnitTypes.splice(index, 1);
        //     document.getElementById(`six-storage-unitCount_${unitTypeindex}`).innerHTML = 0;
        //   }
        // }

      }
    }
  }, {
    key: "sixStorageRentSingleUnitGetSelected",
    value: function sixStorageRentSingleUnitGetSelected(unitTypeindex, unitTypeId, vacant, unitId, isSingleUnit) {
      var sixStorageLocationValLength = sessionStorage.getItem("sixStorageLocationLength");

      if (wordpress_vars.six_storage_online_fc_location_toggle != "" && wordpress_vars.six_storage_online_fc_location_toggle != null && typeof wordpress_vars.six_storage_online_fc_location_toggle != "undefined" && wordpress_vars.six_storage_online_fc_location_toggle == '1' && sixStorageLocationValLength > 1) {
        var _location = document.getElementById("six-storage-location");

        if (_location.value === null || typeof _location.value === 'undefined' || _location.value === '') {
          // let sixStorageFocusElement = document.getElementById('six-storage-location');
          // let y = sixStorageFocusElement.offsetTop;
          // window.scrollTo(0, y);
          var sixStoragelocationdiv = document.getElementById('six-storage-dvLocation');
          sixStoragelocationdiv.scrollIntoView(true);
          document.getElementById("six-storage-tenantLocation-err").style.display = "";
          return;
        } else {
          document.getElementById("six-storage-tenantLocation-err").style.display = "none";
        }
      }

      if (this.businessUserEnabled === true) {
        var tenantType = document.getElementById("six-storage-tenant_type");

        if (tenantType.value === null || tenantType.value === "undefined" || tenantType.value === "") {
          var sixStorageFocusElement = document.getElementById('six-storage-dvTenantType');
          var y = sixStorageFocusElement.offsetTop;
          window.scrollTo(0, y);
          document.getElementById("six-storage-tenantType-err").style.display = "";
          return;
        } else {
          document.getElementById("six-storage-tenantType-err").style.display = "none";
        }
      }

      this.reservesingleunit = false;

      if (unitId !== 'null' && unitId !== "undefined" && unitId !== "") {
        this.unitsSelected = [];
        this.unitsSelected = [unitId];
        this.selectedunitTypeIdcounts = unitTypeId;
        this.sixStorageRentNow();
      } else {
        this.sixStorageAddUnitCount(unitTypeindex, unitTypeId, vacant, false, isSingleUnit);

        if (this.selectedUnitTypes.length > 0) {
          this.selectedunitTypeIdcounts = unitTypeId;
          this.sixStorageGetAutoSelectedUnits(true);
        }
      }
    }
  }, {
    key: "sixStorageReserveSingleUnit",
    value: function sixStorageReserveSingleUnit(unitTypeId, price, unitId) {
      this.reservesingleunit = true;

      if (unitId !== 'null' && unitId !== "undefined" && unitId !== "") {
        this.selectedunitTypeId = [];
        this.unitsSelected = [];
        this.unitsSelected = [unitId];
        this.selectedunitTypeId = unitTypeId;
        this.sixStorageConstructreservepage();
      } else {
        this.selectedUnitTypes = [];
        this.selectedUnitTypes.push({
          unitTypeId: unitTypeId,
          quantity: 1,
          price: price
        });
        this.sixStorageGetAutoSelectedUnits(true);
      }
    }
  }, {
    key: "sixStorageGetAutoSelectedUnits",
    value: function sixStorageGetAutoSelectedUnits(isExcludeDiscountUnits) {
      var _this77 = this;

      this.unitsSelected = this.unitsSelected.concat(this.discountBasedUnit);
      this.unitsSelected = this.unitsSelected.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index;
      });

      if (this.unitsSelected.length === 0 && this.selectedUnitTypes.length === 0) {
        //document.getElementById("six-storage-rent-now-err").innerHTML = `${/*Please Select Units To Rent*/ wordpress_vars.six_storage_online_fs_Please_Select_Units_To_Rent}`;
        this.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_fs_Please_Select_Units_To_Rent), true);
        document.getElementById("six-storage-rent-now-err").style.display = "";
        return;
      } else if (this.unitsSelected.length > 0 && this.selectedUnitTypes.length === 0) {
        document.getElementById("six-storage-rent-now-err").style.display = "none";
        this.sixStorageRentNow();
        return;
      } else {
        document.getElementById("six-storage-rent-now-err").style.display = "none";
        var storageType = document.getElementById("six-storage-storage-type");

        var _location2 = document.getElementById("six-storage-location");

        var building = document.getElementById("six-storage-building");
        document.getElementById("six-storage-no-units-data").style.display = "none";
        var obj = {
          storageType: typeof storageType !== "undefined" && storageType !== null && typeof storageType.value !== "undefined" && storageType.value !== null ? storageType.value : null,
          location: typeof _location2 !== "undefined" && _location2 !== null ? _location2.value : null,
          building: typeof building !== "undefined" && building !== null ? building.value : null,
          unitType: typeof unitType !== "undefined" && unitType !== null ? unitType.value : null,
          isExcludediscountunits: typeof isExcludeDiscountUnits !== "undefined" && isExcludeDiscountUnits !== null ? isExcludeDiscountUnits : true,
          action: "six_storage_get_auto_selected_units"
        };
        var formData = new FormData();
        formData.append("action", "six_storage_get_auto_selected_units");
        formData.append("storageType", obj.storageType);
        formData.append("location", obj.location);
        formData.append("building", obj.building);
        formData.append("isExcludeDiscountUnits", obj.isExcludediscountunits);
        formData.append("isBusinessUser", this.helper.sixStorageGetTenantType());
        formData.append("selectedUnitTypes", JSON.stringify(this.selectedUnitTypes));
        var header = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;"
          },
          body: this.helper.sixStorageGetURIParams(formData)
        };
        var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
        document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
        fetch(url, header).then(function (response) {
          return response.json();
        }).then(function (data) {
          var response = JSON.parse(data);
          document.getElementById("six-storage-loading-container").innerHTML = _this77.helper.sixStorageShowBusyIndicator(false);

          if (typeof data !== "undefined" && data !== null) {
            if (typeof response.isSuccess !== "undefined" && response !== null && response.isSuccess === true) {
              if (response.result && response.result.length > 0) {
                var unitValue = response.result.map(function (element) {
                  return element.toLowerCase();
                });

                _this77.sixStorageSelectedUnitIdByUnitType.push(unitValue);

                if (typeof _this77.unitsSelected !== 'undefined' && _this77.unitsSelected !== null && _this77.unitsSelected.length > 0) {
                  if (_this77.rentSingleUnit === true && _this77.groupBySize === true && _this77.unitsSelected.length > 0 && _this77.reservesingleunit == true) {
                    // this.unitsSelected = [];
                    _this77.unitsSelected = response.result;
                  } else {
                    _this77.unitsSelected.push(response.result);
                  }
                } else {
                  _this77.unitsSelected = response.result;
                }

                if (_this77.rentSingleUnit === true && _this77.groupBySize === true && _this77.unitsSelected.length > 0 && _this77.reservesingleunit == true) {
                  _this77.sixStorageConstructreservepage(_this77.unitsSelected);
                } else if (_this77.unitsSelected.length > 0) {
                  _this77.sixStorageRentNow();
                }
              } else {
                document.getElementById("six-storage-no-units-data").style.display = "block";
                document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;

                _this77.sixStorageShowUnitsMessage(false);
              }
            } else {
              document.getElementById("six-storage-no-units-data").style.display = "block";
              document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;
            }
          } else {
            document.getElementById("six-storage-no-units-data").style.display = "block";
            document.getElementById("six-storage-no-units").innerHTML = response.returnMessage;
          }
        })["catch"](function (err) {
          document.getElementById("six-storage-no-units-data").style.display = "block";
          document.getElementById("six-storage-no-units").innerHTML = "".concat(
          /*Something went wrong please contact support team*/
          wordpress_vars.six_storage_online_fs_Something_went_wrong_please);
        });
      }
    }
  }, {
    key: "changeInvoicePeriod",
    value: function changeInvoicePeriod() {
      var _this78 = this;

      var currentsession = sessionStorage.getItem("SixStorageclientConfig");

      if (currentsession !== null) {
        var sessionObj = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
        var recurringType = sessionObj.recurringTypes;
        typeof recurringType !== 'undefined' && recurringType !== null && recurringType !== '' && recurringType.length > 0 ? recurringType.map(function (item, i) {
          if (typeof item.recurringTypeId !== 'undefined' && item.recurringTypeId !== null && item.recurringTypeId == '1') {
            _this78.firstOfMonthEnabled = true;
          }

          if (typeof item.recurringTypeId !== 'undefined' && item.recurringTypeId !== null && item.recurringTypeId == '3') {
            _this78.anniversaryenabled = true;
          }
        }) : '';
        var invoice_period = document.getElementById("six-storage-invoice-period-new");
        var invoice_recurring = document.getElementById("six-storage-invoice-reccuring-new");
        var additional_months = document.getElementById("six-storage-additional-months");
        var additional_months_div = document.getElementById("six-storage-additional-months-div");

        if (parseInt(invoice_period.value) <= 4) {
          if (this.anniversaryenabled === true) {
            invoice_recurring.value = 3;
            additional_months.value = 0;
            additional_months.style.display = 'none';
            additional_months_div.style.display = "none";
            additional_months.setAttribute("disabled", "disabled");
            invoice_recurring.setAttribute("disabled", "disabled");
          } else if (this.firstOfMonthEnabled === true) {
            invoice_recurring.value = 1;
            additional_months.value = 0;
            additional_months.style.display = 'none';
            additional_months_div.style.display = "none";
            additional_months.setAttribute("disabled", "disabled");
            invoice_recurring.setAttribute("disabled", "disabled");
          }
        } else {
          if (this.firstOfMonthEnabled === true) {
            invoice_recurring.value = 1;
            additional_months.value = wordpress_vars.six_storage_online_fc_additional_month_custom_word;
            additional_months.style.display = 'block';

            if (wordpress_vars.six_storage_online_fs_of_additional_months_toggle == "1") {
              var _additional_months_div = document.getElementById("six-storage-additional-months-div");

              _additional_months_div.style.display = 'block';
            }

            additional_months.removeAttribute("disabled");
            invoice_recurring.removeAttribute("disabled");
          } else if (this.anniversaryenabled === true) {
            invoice_recurring.value = 3;
            additional_months.value = wordpress_vars.six_storage_online_fc_additional_month_custom_word;
            additional_months.style.display = 'block';

            if (wordpress_vars.six_storage_online_fs_of_additional_months_toggle == "1") {
              var _additional_months_div2 = document.getElementById("six-storage-additional-months-div");

              _additional_months_div2.style.display = 'block';
            }

            additional_months.removeAttribute("disabled");
            invoice_recurring.removeAttribute("disabled");
          }
        }

        _materialize["default"].FormSelect.init();

        this.sixStorageChangeSelectedUnits();
      }
    }
  }, {
    key: "sixStorageForgotPassword",
    value: function sixStorageForgotPassword() {
      var _this79 = this;

      event.preventDefault();
      var forgot_password_username = document.getElementById("six-storage-forgot-password-username");

      if (typeof forgot_password_username === 'undefined' || forgot_password_username === null || forgot_password_username.value === "" || typeof forgot_password_username.value === 'undefined') {
        document.getElementById("six-storage-forgot-password-username-err").style.display = "";
        document.getElementById("six-storage-forgot-password-msg").style.display = "none";
        return;
      } else {
        document.getElementById("six-storage-forgot-password-username-err").style.display = "none";
        var formData = new FormData();
        formData.append("action", "six_storage_forgot_user_password");
        formData.append("userName", forgot_password_username.value);
        var header = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;"
          },
          body: this.helper.sixStorageGetURIParams(formData)
        };
        var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
        document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
        fetch(url, header).then(function (response) {
          return response.json();
        }).then(function (data) {
          document.getElementById("six-storage-loading-container").innerHTML = _this79.helper.sixStorageShowBusyIndicator(false);

          if (typeof data !== "undefined" && data !== null) {
            var _response43 = JSON.parse(data);

            if (typeof _response43.isSuccess !== "undefined" && _response43 !== null && _response43.isSuccess === true) {
              var messageFOrgetPassword = "".concat(wordpress_vars.six_storage_online_fs_Password_has_been_successfully);

              if (typeof wordpress_vars !== 'undefined' && wordpress_vars !== null && typeof wordpress_vars.sso_enabled !== 'undefined' && wordpress_vars.sso_enabled !== null && (wordpress_vars.sso_enabled === true || wordpress_vars.sso_enabled === "1")) {
                messageFOrgetPassword = "Confirmation code has been sent to your registered phone number/email, please check your inbox.";
              }

              document.getElementById("six-storage-forgot-password-msg").innerHTML = messageFOrgetPassword;
              document.getElementById("six-storage-forgot-password-msg").style.display = "";
              document.getElementById("six-storage-forgot-password-msg").classList.add("six-storage-green-text");
              document.getElementById("six-storage-forgot-password-msg").classList.remove("six-storage-red-text");
              setTimeout(function () {
                if (typeof wordpress_vars !== 'undefined' && wordpress_vars !== null && typeof wordpress_vars.sso_enabled !== 'undefined' && wordpress_vars.sso_enabled !== null && (wordpress_vars.sso_enabled === true || wordpress_vars.sso_enabled === "1")) {
                  _this79.sixStorageForgotPasswordconfirmationCodeModal("FORGOTPASSWOD", forgot_password_username.value);
                } else {
                  _this79.sixStorageNewLoginModal();
                }
              }, 3000);
            } else {
              document.getElementById("six-storage-forgot-password-msg").classList.remove("six-storage-green-text");
              document.getElementById("six-storage-forgot-password-msg").classList.add("six-storage-red-text");
              document.getElementById("six-storage-forgot-password-msg").innerHTML = _response43.returnMessage;
              document.getElementById("six-storage-forgot-password-msg").style.display = "";
            }
          }
        })["catch"](function (err) {
          document.getElementById("six-storage-loading-container").innerHTML = _this79.helper.sixStorageShowBusyIndicator(false);
          console.error(err);
        });
      }
    }
  }, {
    key: "sixStorageValidateGateAccess",
    value: function sixStorageValidateGateAccess() {
      var _this80 = this;

      var unitsSelected = this.unitsSelected;
      var error_count = 0;
      var gateAccessErrorcount = 0;
      var custom_error_count = 0;
      var gateAccessFields = document.getElementsByClassName("six-storage-gateaccess");
      var timezoneFields = document.getElementsByClassName("six-storage-timezone");
      var moveout_dates = document.getElementsByClassName("six-storage-date-control-desired-moveout"); // let moveoutDateEnabled = this.moveinFieldSettings.filter(x => x.fieldName === "ScheduleMoveOutDate")[0];

      var moveoutDateEnabled = wordpress_vars.six_storage_online_fs_of_schedule_move_out_date_toggle;
      var moveoutDateRequired = wordpress_vars.six_storage_online_fs_of_schedule_move_out_date_is_mandatory;
      this.geteAccessInfo = [];

      if (typeof gateAccessFields !== 'undefined' && gateAccessFields !== null && gateAccessFields.length > 0) {
        Array.prototype.forEach.call(gateAccessFields, function (field) {
          if (field.dataset.hasgateaccess == "true" && (typeof field.value === 'undefined' || field.value === null || field.value === "")) {
            error_count = error_count + 1;
            gateAccessErrorcount = gateAccessErrorcount + 1;

            if (typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== "") {
              document.getElementById("six-storage-gateAccessCode_".concat(field.dataset.unitid, "-err")).style.display = "";
              document.getElementById("six-storage-gateAccessCode_".concat(field.dataset.unitid, "-err")).innerHTML = "".concat(
              /*Please Enter Gate Access Code*/
              wordpress_vars.six_storage_online_fs_ti_please_enter_gate_access_code);
            }
          } else if (field.dataset.hasgateaccess == "true" && (typeof field.value === 'undefined' || field.value === null || field.value.length < 4)) {
            error_count = error_count + 1;
            gateAccessErrorcount = gateAccessErrorcount + 1;

            if (typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== "") {
              document.getElementById("six-storage-gateAccessCode_".concat(field.dataset.unitid, "-err")).style.display = "";
              document.getElementById("six-storage-gateAccessCode_".concat(field.dataset.unitid, "-err")).innerHTML = "".concat(
              /*Gate Access Code must be at least 4 digits*/
              wordpress_vars.six_storage_online_mi_Gate_Access_Code_must_digits);
            }
          } else {
            if (typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== "") {
              _this80.geteAccessInfo.push({
                "unitId": field.dataset.unitid,
                "gateAccessCode": field.value
              });

              document.getElementById("six-storage-gateAccessCode_".concat(field.dataset.unitid, "-err")).style.display = "none";
            }
          }
        });
      }

      if (typeof timezoneFields !== 'undefined' && timezoneFields !== null && timezoneFields.length > 0) {
        Array.prototype.forEach.call(timezoneFields, function (field) {
          if (field.dataset.hastimezone == "true" && (typeof field.value === 'undefined' || field.value === null || field.value === "")) {
            error_count = error_count + 1;
            if (typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== "") document.getElementById("six-storage-timezone_".concat(field.dataset.unitid, "-err")).style.display = "";
          } else {
            if (typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== "") {
              document.getElementById("six-storage-timezone_".concat(field.dataset.unitid, "-err")).style.display = "none";

              var unitIndex = _this80.geteAccessInfo.findIndex(function (x) {
                return x.unitId === field.dataset.unitid;
              });

              if (unitIndex > -1) {
                _this80.geteAccessInfo[unitIndex]["timeZoneId"] = field.value;
              }
            }
          }
        });
      } // if (typeof moveoutDateEnabled["customerPortal"] !== 'undefined' && moveoutDateEnabled["customerPortal"] !== null && moveoutDateEnabled["customerPortal"]["isEnabled"] === true && moveoutDateEnabled["customerPortal"]["isMandatory"] === true) {


      if (typeof moveoutDateEnabled !== 'undefined' && moveoutDateEnabled !== null && moveoutDateEnabled === '1' && typeof moveoutDateRequired !== 'undefined' && moveoutDateRequired !== null && moveoutDateRequired === '1') {
        if (typeof moveout_dates !== 'undefined' && moveout_dates !== null && moveout_dates.length > 0) {
          Array.prototype.forEach.call(moveout_dates, function (field) {
            if (field.dataset.element_required == "'true'" && (typeof field.value === 'undefined' || field.value === null || field.value === "")) {
              error_count = error_count + 1;
              if (typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== "") document.getElementById("six-storage-desired-moveout-date_".concat(field.dataset.unitid, "-err")).style.display = "";
            } else {
              if (typeof field.dataset.unitid !== 'undefined' && field.dataset.unitid !== null && field.dataset.unitid !== "") document.getElementById("six-storage-desired-moveout-date_".concat(field.dataset.unitid, "-err")).style.display = "none";
            }
          });
        }
      }

      var sixStorageCustomFields = this.sixStorageCustomFieldsDetails('Unit specific details');

      if (typeof sixStorageCustomFields !== 'undefined' && sixStorageCustomFields !== null && sixStorageCustomFields !== '') {
        custom_error_count = this.sixstorageValidateCustomFields('unitSpecificDetails');
      }

      if (error_count > 0 || custom_error_count > 0) {
        return false;
      } else if (error_count === 0 && custom_error_count === 0 && gateAccessErrorcount === 0 && gateAccessFields.length > 0 && this.geteAccessInfo.length > 0) {
        this.sixStorageValidateGateAccessTenant();
      } else {
        this.currentStepNumber += 1;
        this.sixStorageRenderStepHtml();
      }
    }
  }, {
    key: "sixStorageSixSecurityValidateGateAccess",
    value: function sixStorageSixSecurityValidateGateAccess() {
      var _this81 = this;

      var error_count = 0;
      var formData = new FormData();
      formData.append("action", "six_storage_validate_gate_access");
      formData.append("gateAccessInfo", JSON.stringify(this.geteAccessInfo));
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this81.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response44 = JSON.parse(data);

          if (typeof _response44.isSuccess !== "undefined" && _response44 !== null && _response44.isSuccess === true) {
            var invalidGateAccess = _response44.result.filter(function (x) {
              return x.isValid === false;
            });

            if (invalidGateAccess.length > 0) {
              invalidGateAccess.forEach(function (item) {
                document.getElementById("six-storage-gateAccessCode-err").innerHTML = "".concat(
                /*Gate Access Code Is Invalid*/
                wordpress_vars.six_storage_online_mi_Gate_Access_Code_Is_Invalid);
                document.getElementById("six-storage-gateAccessCode-err").style.display = "";
                return;
              });
            } else {
              _response44.result.forEach(function (item) {
                document.getElementById("six-storage-gateAccessCode-err").style.display = "none";
              });
            }
          } else {
            document.getElementById("six-storage-gateAccessCode-err").innerHTML = "".concat(
            /*Gate Access Code Is Invalid*/
            wordpress_vars.six_storage_online_mi_Gate_Access_Code_Is_Invalid);
            document.getElementById("six-storage-gateAccessCode-err").style.display = "";
          }
        }
      })["catch"](function (err) {
        console.error(err);
      });
      return error_count;
    }
  }, {
    key: "sixStorageValidateGateAccessTenant",
    value: function sixStorageValidateGateAccessTenant() {
      var _this82 = this;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append("action", "six_storage_validate_gate_access");
      formData.append("gateAccessInfo", JSON.stringify(this.geteAccessInfo));
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this82.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response45 = JSON.parse(data);

          if (typeof _response45.isSuccess !== "undefined" && _response45 !== null && _response45.isSuccess === true) {
            if (_response45.result && _response45.result.length > 0) {
              if (wordpress_vars.six_storage_online_setup_preloader === "0") {
                var _initialloaders29 = document.getElementById("six-storage-loading-container");

                _initialloaders29.style.display = 'none';
              }

              var invalidGateAccess = _response45.result.filter(function (x) {
                return x.isValid === false;
              });

              if (invalidGateAccess.length > 0) {
                invalidGateAccess.forEach(function (item) {
                  document.getElementById("six-storage-gateAccessCode_".concat(item.unitId, "-err")).style.display = "";
                  document.getElementById("six-storage-gateAccessCode_".concat(item.unitId, "-err")).innerHTML = "".concat(
                  /*Gate Access Code Is Invalid*/
                  wordpress_vars.six_storage_online_mi_Gate_Access_Code_Is_Invalid);
                });
              } else {
                _response45.result.forEach(function (item) {
                  document.getElementById("six-storage-gateAccessCode_".concat(item.unitId, "-err")).style.display = "none";
                });

                _this82.currentStepNumber += 1;

                _this82.sixStorageRenderStepHtml();
              }
            } else {
              _this82.currentStepNumber += 1;

              _this82.sixStorageRenderStepHtml();
            }
          } else {
            _this82.currentStepNumber += 1;

            _this82.sixStorageRenderStepHtml();
          }
        } else {
          _this82.currentStepNumber += 1;

          _this82.sixStorageRenderStepHtml();
        }
      })["catch"](function (err) {
        console.error(err);
      });
    }
  }, {
    key: "getTerms",
    value: function getTerms() {
      var _this83 = this;

      var formData = new FormData();
      formData.append("action", "six_storage_get_terms");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this83.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== 'undefined' && data !== null) {
          var _response46 = JSON.parse(data);

          if (typeof _response46.isSuccess !== 'undefined' && _response46 !== null && _response46.isSuccess === true) {
            _this83.sixStorageConstructterms(_response46.result);
          }
        }
      })["catch"](function () {
        document.getElementById("six-storage-loading-container").innerHTML = _this83.helper.sixStorageShowBusyIndicator(false);
      });
    }
  }, {
    key: "sixStorageConstructterms",
    value: function sixStorageConstructterms() {
      var terms = JSON.parse(this.termsandconditionValue);
      var termhtml = document.getElementById("six-storage-terms_conditions");
      var baseUrl = window.location.href;
      var insuranceSelected = this.insuranceInfo.length > 0;

      if (terms.length > 0) {
        termhtml.innerHTML = "";
        terms.forEach(function (arr, index) {
          if (insuranceSelected === true && arr.termsType === "Insurance" && arr.webURL === baseUrl || arr.termsType === "General" && arr.webURL === baseUrl || arr.termsType === "Auto Pay" && arr.webURL === baseUrl && wordpress_vars.autoPayEnabled === "1" && wordpress_vars.autoPayEnabled !== "") {
            var termInnerHtml = "<label class=\"cc six-storage-grid-mb0\">\n                                  <input type=\"checkbox\" class=\"cc terms_ six-storage-input-field\" id=\"terms_".concat(index, "\" onchange=\"sixStorageDisplayEsign();\" />\n                                  <span><a class=\"cc\" href=\"").concat(arr.termsLink, "\" target=\"_blank\">").concat(arr.termsText, "</a></span>\n                              </label>\n                              <div style=\"display: none;\" id=\"terms_").concat(index, "-err\" class=\"six-storage-invalid-feedback\">Please Read ").concat(arr.termsText, ".</div><br/>");
            termhtml.innerHTML += termInnerHtml;
          }
        });
      }
    }
  }, {
    key: "sixStorageGetUserInfo",
    value: function sixStorageGetUserInfo(userId, flag, sixStorageusertype) {
      var _this84 = this;

      if (wordpress_vars.six_storage_online_setup_preloader === "0") {
        var initialloaders = document.getElementById("six-storage-loading-container");
        initialloaders.style.display = 'block';
      }

      var formData = new FormData();
      formData.append("action", "six_storage_get_user_info");
      formData.append("userId", userId);
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.helper.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.getElementById("six-storage-loading-container").innerHTML = _this84.helper.sixStorageShowBusyIndicator(false);

        if (typeof data !== "undefined" && data !== null) {
          var _response47 = JSON.parse(data);

          document.getElementById("six-storage-loading-container").innerHTML = _this84.helper.sixStorageShowBusyIndicator(false);

          if (typeof _response47.isSuccess !== "undefined" && _response47 !== null && _response47.isSuccess === true) {
            if (wordpress_vars.six_storage_online_setup_preloader === "0") {
              var _initialloaders30 = document.getElementById("six-storage-loading-container");

              _initialloaders30.style.display = 'none';
            }

            if (typeof _response47.result !== 'undefined' && _response47.result !== null) {
              if (typeof wordpress_vars.six_storage_google_analytics_integrated !== "undefined" && wordpress_vars.six_storage_google_analytics_integrated !== null && wordpress_vars.six_storage_google_analytics_integrated !== "" && wordpress_vars.six_storage_google_analytics_integrated === "1") {
                gtag('event', 'page_view', {
                  page_title: 'Rent Now - Tenant Details',
                  page_location: 'Rent Now',
                  page_path: '/rent-now#TenantDetails',
                  send_to: "".concat(wordpress_vars.six_storage_google_analytics_input_key)
                });
              }

              sessionStorage.setItem("userId", _response47.result.userId);

              if (typeof _response47.result.accessCode !== 'undefined' && _response47.result.accessCode !== null && _response47.result.accessCode !== '') {
                sessionStorage.setItem("accessCode", _response47.result.accessCode);
              }

              sessionStorage.setItem("currentSessionVal", JSON.stringify(_response47.result));
              var currentsession = sessionStorage.getItem("currentSessionVal");
              sessionStorage.setItem("six_storage_sessionObject", JSON.stringify(_response47.result));

              if (typeof wordpress_vars.six_storage_online_movein_profile_picture_toggle !== 'undefined' && wordpress_vars.six_storage_online_movein_profile_picture_toggle !== '' && wordpress_vars.six_storage_online_movein_profile_picture_toggle !== null && wordpress_vars.six_storage_online_movein_profile_picture_toggle === '1') {
                _this84.sixStorageMoveinUploadpicture();
              }

              var tenanttypedropdown = document.getElementById('six-storage-tenant_type');

              if (currentsession !== null && sixStorageusertype === false) {
                var sessionObj = JSON.parse(sessionStorage.getItem("currentSessionVal"));

                if (typeof sessionObj.businessUser !== 'undefined' && sessionObj.businessUser !== null) {
                  var businessuserval = sessionObj.businessUser;

                  var sixStorageRentnowTenantType = _this84.helper.sixStorageGetTenantType(); // console.log(businessuserval);//true
                  // console.log(sixStorageRentnowTenantType);//false


                  if (sixStorageRentnowTenantType != businessuserval) {
                    var businessuser = sixStorageRentnowTenantType; // document.getElementById("six-storage-tenant_type").disabled = true;

                    tenanttypedropdown.value = sixStorageRentnowTenantType;
                  } else {
                    var businessuser = sessionObj.businessUser; //document.getElementById("six-storage-tenant_type").disabled = true;

                    tenanttypedropdown.value = businessuser;
                  }

                  if (businessuser === true) {
                    document.getElementById('six-storage-company-details').style.display = '';
                  } else {
                    document.getElementById('six-storage-company-details').style.display = 'none';
                  }
                }
              } else {
                var _sessionObj = JSON.parse(sessionStorage.getItem("currentSessionVal"));

                if (typeof _sessionObj.businessUser !== 'undefined' && _sessionObj.businessUser !== null) {
                  var _businessuser = _sessionObj.businessUser;
                  document.getElementById("six-storage-tenant_type").disabled = true;
                  tenanttypedropdown.value = _businessuser;

                  if (_businessuser === true) {
                    document.getElementById('six-storage-company-details').style.display = '';
                  } else {
                    document.getElementById('six-storage-company-details').style.display = 'none';
                  }
                }
              }
            }
          }
        }

        _materialize["default"].updateTextFields();

        _materialize["default"].AutoInit();

        if (typeof flag !== 'undefined' && flag !== null && flag !== '' && flag === true) {
          var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));

          _this84.sixStorageCustomFieldsBinding();

          _this84.sixStorageSetProfileDetails(currentSession);

          _this84.currentStepNumber += 1;

          _this84.sixStorageRenderStepHtml();
        }
      })["catch"](function (err) {
        console.error(err);
      });
    }
  }, {
    key: "sixStorageSetProfileDetails",
    value: function sixStorageSetProfileDetails(userInfo) {
      document.getElementById("six_storage_firstname").value = userInfo.firstName;
      document.getElementById("six_storage_lastname").value = userInfo.lastName;
      document.getElementById("six_storage_email").value = userInfo.email;
      var currentsessionval = JSON.parse(sessionStorage.getItem("currentSessionVal"));

      if (currentsessionval !== null) {
        document.getElementById("six_storage_address1").value = typeof currentsessionval.addressLineOne !== "undefined" && currentsessionval.addressLineOne != null && currentsessionval.addressLineOne != "null" && currentsessionval.addressLineOne != "" ? currentsessionval.addressLineOne : "";
        document.getElementById("six_storage_address2").value = typeof currentsessionval.addressLineTwo !== "undefined" && currentsessionval.addressLineTwo != null && currentsessionval.addressLineTwo != "null" && currentsessionval.addressLineTwo != "" ? currentsessionval.addressLineTwo : "";
        document.getElementById("six_storage_state").value = typeof currentsessionval.state !== "undefined" && currentsessionval.state != null && currentsessionval.state != "null" && currentsessionval.state != "" ? currentsessionval.state : "";
        document.getElementById("six_storage_zip_code").value = typeof currentsessionval.zip_code !== "undefined" && currentsessionval.zip_code != null && currentsessionval.zip_code != "null" && currentsessionval.zip_code != "" ? currentsessionval.zip_code : "";
        document.getElementById("six_storage_city").value = typeof currentsessionval.city !== "undefined" && currentsessionval.city != null && currentsessionval.city != "null" && currentsessionval.city != "" ? currentsessionval.city : "";
        document.getElementById("six_storage_country").value = typeof currentsessionval.country !== "undefined" && currentsessionval.country != null && currentsessionval.country != "" ? currentsessionval.country : "";
        document.getElementById("six_storage_ssn_number").value = typeof userInfo.ssn !== "undefined" && userInfo.ssn != null && userInfo.ssn != "" ? userInfo.ssn : "";
      } else {
        document.getElementById("six_storage_address1").value = typeof userInfo.addressLineOne !== "undefined" && userInfo.addressLineOne != null && userInfo.addressLineOne != "null" && userInfo.addressLineOne != "" ? userInfo.addressLineOne : "";
        document.getElementById("six_storage_address2").value = typeof userInfo.addressLineTwo !== "undefined" && userInfo.addressLineTwo != null && userInfo.addressLineTwo != "null" && userInfo.addressLineTwo != "" ? userInfo.addressLineTwo : "";
        document.getElementById("six_storage_state").value = typeof userInfo.state !== "undefined" && userInfo.state != null && userInfo.state != "null" && userInfo.state != "" ? userInfo.state : "";
        document.getElementById("six_storage_zip_code").value = typeof userInfo.zipCode !== "undefined" && userInfo.zipCode != null && userInfo.zipCode != "null" && userInfo.zipCode != "" ? userInfo.zipCode : "";
        document.getElementById("six_storage_city").value = typeof userInfo.city !== "undefined" && userInfo.city != null && userInfo.city != "null" && userInfo.city != "" ? userInfo.city : "";
        document.getElementById("six_storage_country").value = typeof userInfo.country !== "undefined" && userInfo.country != null && userInfo.country != "" ? userInfo.country : "";
        document.getElementById("six_storage_ssn_number").value = typeof userInfo.ssn !== "undefined" && userInfo.ssn != null && userInfo.ssn != "" ? userInfo.ssn : "";
      }

      document.getElementById("six_storage_email").setAttribute("disabled", "disabled");
      document.getElementById("six_storage_phone1").setAttribute("disabled", "disabled");
      var phone1Field = document.getElementById("six_storage_phone1");
      var phoneInstance = window.intlTelInputGlobals.getInstance(phone1Field);
      phoneInstance.setNumber(typeof userInfo.phoneNumber !== "undefined" && userInfo.phoneNumber != null && userInfo.phoneNumber != "" ? userInfo.phoneNumber : "");
      document.getElementById("six-storage-phone1Label").classList.add("six-storage-active");
      document.getElementById("six-storage-phone2Label").classList.add("six-storage-active"); //document.getElementById("six-storage-mobilelabel").classList.add("six-storage-active");

      document.querySelector('.six-storage-phone-field-1 .iti__selected-flag').setAttribute('tabindex', '-1');

      _materialize["default"].updateTextFields();
    }
  }, {
    key: "sixStorageChangeSavecard",
    value: function sixStorageChangeSavecard() {
      var save_card = document.getElementById("six-storage-save_card_autopay");
      var autopay = document.getElementById("six-storage-turn_on_autopay");

      if (autopay.checked === true) {
        save_card.checked = true;
      } else {
        document.getElementById("six-storage-saveCardSection").style.display = "";
      }

      _materialize["default"].updateTextFields();

      var SixStorageclientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var paymentModes = SixStorageclientConfig.paymentModes;

      if (typeof paymentModes !== "undefined" && paymentModes !== null && paymentModes !== "" && paymentModes.length > 0) {
        var creditcardoptions = paymentModes.filter(function (i) {
          return i.value === "CreditCard";
        });
        var creditpaymentmodeId = creditcardoptions[0].id;
        var creditcardvalue = creditcardoptions[0].value;
        this.paymentForm(creditpaymentmodeId, creditcardvalue, true);
      }
    }
  }, {
    key: "sixStorageSavedCardCheckBox",
    value: function sixStorageSavedCardCheckBox() {
      var save_card = document.getElementById("six-storage-save_card_autopay");
      var autopay = document.getElementById("six-storage-turn_on_autopay");

      if (save_card.checked === false) {
        autopay.checked = false;
      }

      _materialize["default"].updateTextFields();

      var SixStorageclientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var paymentModes = SixStorageclientConfig.paymentModes;

      if (typeof paymentModes !== "undefined" && paymentModes !== null && paymentModes !== "" && paymentModes.length > 0) {
        var creditcardoptions = paymentModes.filter(function (i) {
          return i.value === "CreditCard";
        });
        var creditpaymentmodeId = creditcardoptions[0].id;
        var creditcardvalue = creditcardoptions[0].value;
        this.paymentForm(creditpaymentmodeId, creditcardvalue, true);
      }
    }
  }, {
    key: "sixStorageSignatureCheck",
    value: function sixStorageSignatureCheck() {
      if (this.esignMandatory) {
        var esignURL = this.signaturePad._data;
        var sixstoragepaymentform = document.getElementById("six-storage-payment-form-div").classList;
        var paynowButton = document.getElementById('six-storage-rdbtn_pay_now');
        var paylaterbutton = document.getElementById('six-storage-rdbtn_pay_later');

        if (typeof esignURL !== 'undefined' && esignURL !== null && esignURL !== "" && esignURL.length > 0) {
          sixstoragepaymentform.remove('six-storage-d-none');
          sixstoragepaymentform.add('six-storage-flexbox-important');
          document.getElementById('six-storage-esign-error').style.display = "none";
        } else {
          sixstoragepaymentform.add('six-storage-d-none');
          sixstoragepaymentform.remove('six-storage-flexbox-important');
          document.getElementById('six-storage-esign-error').style.display = "block";

          if (typeof paynowButton !== 'undefined' && paynowButton !== null || typeof paylaterbutton !== 'undefined' && paylaterbutton !== null) {
            paynowButton.checked = false;
            paylaterbutton.checked = false;
          }
        }
      }
    }
  }, {
    key: "sixstorageSelectIphone",
    value: function sixstorageSelectIphone() {
      var win = window.innerWidth;

      if (navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('iPad') > -1 || navigator.userAgent.indexOf('Macintosh') > -1) {
        document.addEventListener('click', function (params) {
          document.querySelectorAll('li[id^="six-storage-select-options"]').forEach(function (ele) {
            ele.addEventListener('touchend', function (e) {
              e.stopPropagation();
            });
          });
        });
      }

      if (navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('iPad') > -1 || navigator.userAgent.indexOf('Macintosh') > -1) {
        document.addEventListener('click', function (params) {
          document.querySelectorAll('li[id^="six-storage-select-options"]').forEach(function (ele) {
            ele.addEventListener('touchend', function (e) {
              e.stopPropagation();
            });
          });
        });
      }
    }
  }, {
    key: "sixStorageShowLoader",
    value: function sixStorageShowLoader() {
      this.helper.sixStorageShowBusyIndicator(true);
    }
  }, {
    key: "sixStorageCloseAlert",
    value: function sixStorageCloseAlert() {
      document.getElementById('six-storage-success-msg').classList.add('six-storage-d-none');
    }
  }, {
    key: "sixStorageSortIcon",
    value: function sixStorageSortIcon() {
      var sortIconValue = document.getElementById('six-storage-sort-icon').dataset.sortvalue;

      if (sortIconValue === 'Ascending') {
        document.getElementById('six-storage-sort-icon-itag').style.transform = "rotate(360deg)";
        document.getElementById('six-storage-sort-icon').dataset.sortvalue = "Descending";
        document.getElementById('six-storage-sort-icon').dataset.tooltip = "".concat(wordpress_vars.six_storage_online_fs_filter_descending);
      } else {
        document.getElementById('six-storage-sort-icon-itag').style.transform = "rotate(180deg)";
        document.getElementById('six-storage-sort-icon').dataset.sortvalue = "Ascending";
        document.getElementById('six-storage-sort-icon').dataset.tooltip = "".concat(wordpress_vars.six_storage_online_fs_filter_ascending);
      }

      this.sixStorageSearchUnits();
    }
  }, {
    key: "sixStorageClearUploadFile",
    value: function sixStorageClearUploadFile() {
      var documentName = document.getElementById("six-storage-user-document-name").value;
      document.getElementById("six-storage-upload-file-input").reset();
      document.getElementById("six-storage-user-document-name").value = documentName;

      _materialize["default"].updateTextFields();
    }
  }, {
    key: "sixStorageTakePhoto",
    value: function sixStorageTakePhoto() {
      var _navigator,
          _navigator$userAgentD,
          _navigator2,
          _this85 = this;

      document.getElementById("six-storage-dashboard-modal").classList.remove("six-storage-sm");
      var modalBody = document.getElementById("six-storage-dashboard-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle-photo");
      modalTitle.innerHTML = "".concat(
      /*take Photo*/
      wordpress_vars.six_storage_online_profile_photo_take_photo);
      modalBody.innerHTML = " \n    <div class=\"six-storage-video-wrap\">\n        <video id=\"six-storage-videoStream\" playsinline autoplay></video>\n    </div>\n    <div class=\"six-storage-controller six-storage-text-center\">\n        <button class=\"six-storage-waves-effect six-storage-secondary-background six-storage-waves-light six-storage-btn cc\" id=\"six-storage-captureImage\">".concat(
      /*Capture*/
      wordpress_vars.six_storage_online_text_capture, "</button>\n    </div>\n    <p class=\"cc\"><img id=\"six-storage-imageprev\" class=\"cc\" width=\"240\" src=\"\" style=\"display: none;\"> </img></p>\n    <canvas id=\"six-storage-canvaselement\" width=\"640\" height=\"480\" style=\"display: none;\"></canvas>\n    <div class=\"six-storage-col six-storage-s12 six-storage-m12 six-storage-l12 six-storage-text-center\">\n        <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-secondary-background six-storage-btn cc\" id=\"six-storage-crop_file_movein\" style=\"display:none;\">").concat(
      /*Save*/
      wordpress_vars.six_storage_online_fc_Save, "</button>\n    </div>");
      var video = document.getElementById('six-storage-videoStream');
      var canvas = document.getElementById('six-storage-canvaselement');
      var snap = document.getElementById("six-storage-captureImage");
      var imgResult = document.getElementById('six-storage-item-img-output');
      var imgPrev = document.getElementById('six-storage-imageprev');
      var video_constraints = {
        audio: false,
        video: true
      };
      var platform = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$userAgentD = _navigator.userAgentData) === null || _navigator$userAgentD === void 0 ? void 0 : _navigator$userAgentD.platform) || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.platform) || 'unknown';

      if (navigator.userAgent.toLowerCase().indexOf('safari') != -1 && platform.toLowerCase().indexOf('mac') != -1) {
        video_constraints = {
          video: {
            width: 320
          },
          audio: false
        };
      }

      if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
        video_constraints = {
          video: {
            width: 1280,
            height: 720
          }
        };
      }

      navigator.mediaDevices.getUserMedia(video_constraints).then(function (stream) {
        window.stream = stream;
        video.srcObject = stream;
        var LiveTrack = stream.getVideoTracks()[0];

        window.onblur = function () {
          LiveTrack.stop();
        };

        var takePhotoModal = document.getElementById("six-storage-dashboard-modal");

        var instance = _materialize["default"].Modal.getInstance(takePhotoModal);

        instance.open();
      })["catch"](function (err) {
        alert(err);
        return;
      }); // navigator.mediaDevices.getUserMedia({ video: true, audio: false })
      //   .then(function (stream) {
      //     window.stream = stream;
      //     video.srcObject = stream;
      //     var LiveTrack = stream.getVideoTracks()[0];
      //     window.onblur = function () {
      //       LiveTrack.stop();
      //     };
      //     let takePhotoModal = document.getElementById("six-storage-dashboard-modal");
      //     var instance = M.Modal.getInstance(takePhotoModal);
      //     instance.open();
      //   })
      //   .catch(function (err) {
      //     alert(err);
      //     return;
      //   });

      var context = canvas.getContext('2d');
      snap.addEventListener('click', function (event) {
        context.drawImage(video, 0, 0, 640, 480);
        console.log(context.canvas.toDataURL());
        imgPrev.src = context.canvas.toDataURL();
        var crop = new _croppie["default"](imgPrev, {
          viewport: {
            width: 350,
            height: 220
          },
          boundary: {
            width: 350,
            height: 220
          },
          enableResize: true,
          enableOrientation: true,
          enableExif: true
        });
        crop.bind({
          url: imgPrev.src
        }).then(function () {
          video.style.display = 'none';
          console.log('Image bind complete');
        });
        document.getElementById('six-storage-captureImage').style.display = 'none';
        document.getElementById('six-storage-crop_file_movein').style.display = '';
        document.getElementById('six-storage-crop_file_movein').addEventListener('click', function (event) {
          crop.result('blob').then(function (dataImg) {
            _this85.sixStorageSaveTenantPhoto(dataImg); // imgResult.src = URL.createObjectURL(dataImg);


            var videoStream = document.getElementById('six-storage-videoStream');
            var mediaStream = videoStream.srcObject;
            var tracks = mediaStream.getTracks();
            tracks.forEach(function (track) {
              return track.stop();
            });
            var uploadpicModal = document.getElementById("six-storage-dashboard-modal");

            var instance = _materialize["default"].Modal.getInstance(uploadpicModal);

            instance.close();
            LiveTrack.stop();
          }, 4500);
          event.preventDefault();
        });
      });
    }
  }, {
    key: "sixStorageUploadPhoto",
    value: function sixStorageUploadPhoto() {
      document.getElementById("six-storage-dashboard-modal").classList.remove("six-storage-sm");
      var uploadPhotoModal = document.getElementById("six-storage-dashboard-modal");

      var instance = _materialize["default"].Modal.getInstance(uploadPhotoModal);

      instance.open();
      document.getElementsByTagName('body')[0].style.overflow = 'unset';
      var modalBody = document.getElementById("six-storage-dashboard-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle-photo");
      modalTitle.innerHTML = "".concat(
      /*Upload Photo*/
      wordpress_vars.six_storage_online_profile_upload_photo);
      modalBody.innerHTML = "     \n  <form action=\"#\" class=\"six-storage-grid-p10 cc six-storage-grid-shadow-none six-storage-form-image-upload-modal six-storage-grid-w-100 six-storage-mx-auto\">\n      <div class=\"cc six-storage-grid-d-flex six-storage-align-items-center\" id=\"six-storage-upload-image-file\">\n          <div class=\"cc six-storage-file-field six-storage-input-field six-storage-grid-d-flex six-storage-align-items-center six-storage-flex-grow-1\">\n              <div class=\"six-stoarge-choose-file six-storage-secondary-background six-storage-choose-div\">\n                  <span class=\"six-stoarge-choose-file-span six-storage-white-space-nowrap\">".concat(
      /*Choose a file*/
      wordpress_vars.six_storage_online_profile_choose_file, "</span>\n                  <input type=\"file\" class=\"cc\" id=\"six-storage-uploadImage\" onchange=\"sixStorageCroppingFile(event);\" accept=\".jpg, .jpeg, .png\" />\n              </div>\n              <div class=\"six-storage-file-path-wrapper six-storage-flex-grow-1\">\n                  <input class=\"six-storage-file-path six-storage-validate cc\" type=\"text\" placeholder=\"").concat(
      /*Choose a file*/
      wordpress_vars.six_storage_online_profile_choose_file, "\" />\n                  <div style=\"display: none;\" id=\"six_storage_upload_profile_pic_size-err\" class=\"six-storage-invalid-feedback\"> Uploaded File Size is Empty </div>\n              </div>\n          </div>\n      </div>\n      <span id=\"six-storage-img-note-text\">").concat(
      /*Note*/
      wordpress_vars.six_storage_online_mi_Note, ": ").concat(
      /*Please Upload below 2mb image*/
      wordpress_vars.six_storage_online_profile_photo_two_mb, "</span>\n      <div id=\"six-storage-file-size-err\" style=\"display:none;\" class=\"six-storage-invalid-feedback\">").concat(
      /*Please Upload Small Size Image*/
      wordpress_vars.six_storage_online_profile_photo_small_size, "</div>\n      <div id=\"six-storage-upload-demo\" class=\"six-storage-center-block\" style=\"display:none;\"></div>\n      <div class=\"cc six-storage-shopping-counter six-storage-text-center six-storage-grid-position-relative\" id=\"six-storage-crop-file\" style=\"display:none;\">\n          <button class=\"six-storage-waves-effect six-storage-waves-light six-storage-btn six-storage-secondary-background cc\" onclick=\"sixStorageSaveTenantPhoto()\" id=\"six-storage-crop-file-btn\">").concat(
      /*Save*/
      wordpress_vars.six_storage_online_fc_Save, "</button>\n      </div>\n  </form>");
    }
  }, {
    key: "sixStorageCroppingFile",
    value: function sixStorageCroppingFile(event) {
      var _this86 = this;

      // const uploadedpic = document.getElementById('six-storage-uploadImage');
      var sixStorageUploadedFileSize = document.getElementById('six-storage-uploadImage').files[0].size;
      var imgPrev = document.getElementById('six-storage-upload-demo');
      var imgResult = document.getElementById('six-storage-item-img-output');

      if (sixStorageUploadedFileSize > 0) {
        var rawImg;
        var input = event.target;
        var FileSize = input.files[0].size / 1024 / 1024; // in MiB

        if (FileSize > 2) {
          document.getElementById('six-storage-img-note-text').style.display = "none";
          document.getElementById('six-storage-file-size-err').style.display = "";
          return;
        }

        document.getElementById('six-storage-img-note-text').style.display = "none";
        document.getElementById('six-storage-file-size-err').style.display = "none";
        document.getElementById('six-storage-upload-demo').style.display = '';
        document.getElementById('six-storage-crop-file').style.display = '';
        document.getElementById('six-storage-upload-image-file').style.display = 'none';
        var reader = new FileReader();

        reader.onload = function (e) {
          var dataURL = reader.result;
          imgPrev.src = dataURL;
          rawImg = e.target.result;
          var crop = new _croppie["default"](imgPrev, {
            viewport: {
              width: 420,
              height: 250
            },
            boundary: {
              width: 420,
              height: 250
            },
            enableResize: true,
            enableOrientation: true,
            enableExif: true
          });
          crop.bind({
            url: rawImg
          }).then(function () {
            console.log('Image bind complete');
          });

          document.getElementById('six-storage-crop-file-btn').onclick = function (event) {
            crop.result('blob').then(function (dataImg) {
              _this86.sixStorageSaveTenantPhoto(dataImg);

              var uploadpicModal = document.getElementById("six-storage-dashboard-modal");

              var instance = _materialize["default"].Modal.getInstance(uploadpicModal);

              instance.close();
              document.getElementsByTagName('body')[0].style.overflow = 'unset';
              document.getElementById('six-storage-select-options-view-btn').style.display = '';
              document.getElementById('six-storage-select-options-remove-btn').style.display = '';
            }, 4500);
            event.preventDefault();
          };
        };

        reader.readAsDataURL(input.files[0]);
      } else {
        document.getElementById('six_storage_upload_profile_pic_size-err').style.display = 'block';
      }
    }
  }, {
    key: "sixStorageViewPhoto",
    value: function sixStorageViewPhoto() {
      document.getElementById("six-storage-dashboard-modal").classList.remove("six-storage-sm");
      var viewPhotoModal = document.getElementById("six-storage-dashboard-modal");

      var instance = _materialize["default"].Modal.getInstance(viewPhotoModal);

      instance.open();
      var profileImage = document.getElementById('six-storage-item-img-output').src;
      var modalBody = document.getElementById("six-storage-dashboard-modal-Body");
      var modalTitle = document.getElementById("six-storage-modalTitle-photo");
      modalTitle.innerHTML = "".concat(
      /*View Photo*/
      wordpress_vars.six_storage_online_profile_photo_view_photo);
      modalBody.innerHTML = "\n  <form action=\"#\" class=\"six-storage-grid-p0 cc six-storage-grid-shadow-none six-storage-form-image-upload-modal six-storage-grid-w-100 six-storage-mx-auto\">\n      <div style=\"display: flex;justify-content: center;padding:20px;\">     \n          <img src=\"".concat(profileImage, "\" class=\"six-storage-gambar cc six-storage-img-responsive six-storage-img-thumbnail\" style=\"height:auto;width:350px;\" />\n      </div>\n  </div>\n  ");
      document.getElementsByTagName('body')[0].style.overflow = 'unset';
    }
  }, {
    key: "sixStorageRemovePhoto",
    value: function sixStorageRemovePhoto() {
      var _this87 = this;

      var userId = sessionStorage.getItem('userId');
      var formData = new FormData();
      formData.append('action', 'six_storage_remove_tenant_photo_movein');
      formData.append('userId', userId);
      var header = {
        method: "POST",
        headers: {
          "processData": false
        },
        body: formData
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response48 = JSON.parse(data);

          if (typeof _response48.isSuccess !== "undefined" && _response48.isSuccess !== null && _response48.isSuccess === true) {
            document.getElementById("six-storage-loading-container").innerHTML = _this87.helper.sixStorageShowBusyIndicator(false);

            _this87.sixStorageGetUserInfo(userId, false, false);

            _this87.helper.sixStorageShowMessage("".concat(
            /*Removed Photo Successfully*/
            wordpress_vars.six_storage_online_profile_photo_removed_photo_successfully), false);

            document.getElementById('six-storage-select-options-view-btn').style.display = '';
            document.getElementById('six-storage-select-options-remove-btn').style.display = '';
          } else {
            document.getElementById("six-storage-loading-container").innerHTML = _this87.helper.sixStorageShowBusyIndicator(false);

            _this87.helper.sixStorageShowMessage("".concat(
            /*Something went wrong please contact support team*/
            wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);
          }
        } else {
          document.getElementById("six-storage-loading-container").innerHTML = _this87.helper.sixStorageShowBusyIndicator(false);

          _this87.helper.sixStorageShowMessage("".concat(
          /*Something went wrong please contact support team*/
          wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);
        }
      })["catch"](function (error) {
        document.getElementById("six-storage-loading-container").innerHTML = _this87.helper.sixStorageShowBusyIndicator(false);
        console.log(error);

        _this87.helper.sixStorageShowMessage("".concat(
        /*Something went wrong please contact support team*/
        wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);
      });
    }
  }, {
    key: "sixStorageSaveTenantPhoto",
    value: function sixStorageSaveTenantPhoto(dataImg) {
      var _this88 = this;

      var userId = sessionStorage.getItem('userId'); // let userLocationInformation = this.helper.userAccessInfo;

      var file = new File([dataImg], "".concat(userId, "_.png"), {
        type: "image/png"
      });
      var timestamp = new Date().getTime();
      var fileName = "".concat(userId, "_").concat(timestamp, ".png");
      var formData = new FormData();
      formData.append('action', 'six_storage_post_save_tenant_photo_movein');
      formData.append('six_storage_profile_image', file);
      formData.append('userId', userId);
      formData.append('fileName', fileName);

      if (typeof wordpress_vars.six_storage_online_tenant_activity_enable !== 'undefined' && wordpress_vars.six_storage_online_tenant_activity_enable !== null && wordpress_vars.six_storage_online_tenant_activity_enable !== '' && wordpress_vars.six_storage_online_tenant_activity_enable !== '0') {
        formData.append('log', JSON.stringify(this.helper.userAccessInfo));
      }

      var header = {
        method: "POST",
        headers: {
          "processData": false
        },
        body: formData
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      document.getElementById("six-storage-loading-container").innerHTML = this.helper.sixStorageShowBusyIndicator(true);
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var _response49 = JSON.parse(data);

          if (typeof _response49.isSuccess !== "undefined" && _response49.isSuccess !== null && _response49.isSuccess === true) {
            document.getElementById("six-storage-loading-container").innerHTML = _this88.helper.sixStorageShowBusyIndicator(false);

            _this88.sixStorageGetUserInfo(userId, false, false); //document.getElementById('six_storage_move_in_upload_photo-success').style.display = "block";


            _this88.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_dp_Profile_Updated_Successfully), false);

            document.getElementById('six-storage-select-options-view-btn').style.display = '';
            document.getElementById('six-storage-select-options-remove-btn').style.display = '';
          } else {
            //document.getElementById('six_storage_move_in_upload_profile_picture-err').style.display = "block";
            document.getElementById("six-storage-loading-container").innerHTML = _this88.helper.sixStorageShowBusyIndicator(false);

            _this88.helper.sixStorageShowMessage("".concat(
            /*Something went wrong please contact support team*/
            wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);
          }
        } else {
          //document.getElementById('six_storage_move_in_upload_profile_picture-err').style.display = "block";
          document.getElementById("six-storage-loading-container").innerHTML = _this88.helper.sixStorageShowBusyIndicator(false);

          _this88.helper.sixStorageShowMessage("".concat(
          /*Something went wrong please contact support team*/
          wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);
        }
      })["catch"](function (error) {
        document.getElementById("six-storage-loading-container").innerHTML = _this88.helper.sixStorageShowBusyIndicator(false);
        console.log(error);

        _this88.helper.sixStorageShowMessage("".concat(
        /*Something went wrong please contact support team*/
        wordpress_vars.six_storage_online_fs_Something_went_wrong_please), true);
      });
    }
  }, {
    key: "sixStorageMoveinUploadpicture",
    value: function sixStorageMoveinUploadpicture() {
      var sixStorageUploadPictureToggleval = wordpress_vars.six_storage_online_movein_profile_picture_toggle;

      if (typeof sixStorageUploadPictureToggleval != 'undefined' && sixStorageUploadPictureToggleval != null && sixStorageUploadPictureToggleval != '' && sixStorageUploadPictureToggleval === '1') {
        document.getElementById('six-storage-movein-profile-picture-upload-div').style.display = "block";
        var sixStorageGetUserdetailval = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
        var photoPath = sixStorageGetUserdetailval.photoPath;
        var photoPathUrl = typeof photoPath !== 'undefined' && photoPath !== null && photoPath !== "" ? photoPath : "".concat(wordpress_vars.six_storage_plugin_url, "/assets/images/Profile_Img.png");

        if (photoPath !== 'undefined' && photoPath !== null && photoPath !== "") {
          document.getElementById('six-storage-select-options-remove-btn').style.display = '';
          document.getElementById('six-storage-select-options-view-btn').style.display = '';
          document.getElementById('six_storage_upload_photo_err').style.display = 'none';
        } else {
          document.getElementById('six-storage-select-options-remove-btn').style.display = 'none';
          document.getElementById('six-storage-select-options-view-btn').style.display = 'none';
        }

        document.getElementById('six-storage-item-img-output').src = photoPathUrl;
      } else {
        document.getElementById('six-storage-movein-profile-picture-upload-div').style.display = "none";
      }
    }
  }, {
    key: "sixStorageCustomFieldsBinding",
    value: function sixStorageCustomFieldsBinding() {
      var _this89 = this;

      var currentSession = JSON.parse(sessionStorage.getItem("six_storage_sessionObject"));
      var currentsessionval = JSON.parse(sessionStorage.getItem("currentSessionVal"));
      var customfield = currentSession.customFormFields;

      if (typeof customfield !== "undefined" && customfield !== null) {
        customfield.forEach(function (result, index) {
          var data = _this89.customFieldsResponse.result.filter(function (i) {
            return i.fieldId === result.fieldId;
          });

          var unitSelected = _this89.unitsSelected[0];

          if (typeof data !== null && data.length > 0 && typeof unitSelected !== null && unitSelected !== undefined) {
            if (data[0].matadata.type === 'textbox') {
              if (typeof document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== 'undefined' && document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== null) {
                document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)).value = "".concat(result.fieldValue);

                _materialize["default"].updateTextFields();
              }
            } else if (data[0].matadata.type === 'date') {
              if (typeof document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== 'undefined' && document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== null) {
                document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)).value = "".concat(result.fieldValue);
              }
            } else if (data[0].matadata.type === 'checkbox' && result.fieldValue !== '') {
              if (typeof document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== 'undefined' && document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== null) {
                document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)).checked = true;
              }
            } else if (data[0].matadata.type === 'radio' && result.fieldValue !== '') {
              if (typeof document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(result.fieldValue)) !== 'undefined' && document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(result.fieldValue)) !== null && document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(result.fieldValue)).value !== null) {
                if (document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(result.fieldValue)).value === result.fieldValue) {
                  document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(result.fieldValue)).checked = true;
                }
              }
            } else if (data[0].matadata.type === 'checkbox' && result.fieldValue !== '') {
              if (typeof document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== 'undefined' && document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== null) {
                if (document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)).value === result.fieldValue) {
                  document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)).checked = true;
                }
              }

              var custom_fields_radio_button_containers = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_moveInTenantDetails");
              Array.prototype.forEach.call(custom_fields_radio_button_containers, function (fieldContainer_radio) {
                if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
                  var radios_button_type = document.getElementsByClassName("six-storage-custom-field-".concat(data[0].fieldId));

                  if (typeof radios_button_type !== 'undefined' && radios_button_type !== '' && radios_button_type !== null) {
                    for (var i = 0; i < radios_button_type.length; i++) {
                      if (radios_button_type[i].value === result.fieldValue) {
                        radios_button_type[i].checked = true;
                      }
                    }
                  }
                }
              });
            } else if (data[0].matadata.type === 'checkboxes') {
              var _custom_fields_radio_button_containers6 = document.getElementsByClassName("six-storage-custom_input_fields_radio_btn_moveInTenantDetails");

              Array.prototype.forEach.call(_custom_fields_radio_button_containers6, function (fieldContainer_radio) {
                if (typeof fieldContainer_radio !== 'undefined' && fieldContainer_radio !== null && fieldContainer_radio !== '') {
                  var checkbox_button_type = document.getElementsByClassName("six-storage-custom-field-".concat(data[0].fieldId));

                  if (typeof checkbox_button_type !== 'undefined' && checkbox_button_type !== '' && checkbox_button_type !== null) {
                    for (var i = 0; i < checkbox_button_type.length; i++) {
                      if (checkbox_button_type[i].value === result.fieldValue) {
                        checkbox_button_type[i].checked = true;
                      }
                    }
                  }
                }
              });
            } else if (data[0].matadata.type === 'textarea') {
              if (typeof document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== 'undefined' && document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)) !== null) {
                document.getElementById("six_storage_".concat(data[0].fieldId, "_").concat(unitSelected)).value = "".concat(result.fieldValue);
              }

              _materialize["default"].updateTextFields();
            }
          }
        });
      }
    }
  }]);

  return MoveInApp;
}();

var _default = MoveInApp;
exports["default"] = _default;

},{"../materialize":12,"./Discountslider":13,"./helper.js":15,"croppie":1,"regenerator-runtime/runtime":9,"sweetalert":10}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _intlTelInput = _interopRequireDefault(require("intl-tel-input"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Helper = /*#__PURE__*/function () {
  function Helper() {
    _classCallCheck(this, Helper);

    _defineProperty(this, "culture", void 0);

    _defineProperty(this, "currency", void 0);

    _defineProperty(this, "dateFormat", void 0);

    _defineProperty(this, "cultureInfo", void 0);

    _defineProperty(this, "numberFormatter", void 0);

    _defineProperty(this, "numberParser", void 0);

    _defineProperty(this, "dateFormatter", void 0);

    _defineProperty(this, "datepickerTranslation", void 0);

    _defineProperty(this, "dateParser", void 0);

    _defineProperty(this, "currencyFormatter", void 0);

    _defineProperty(this, "percentageFormatter", void 0);

    _defineProperty(this, "userLocationInfo", void 0);

    _defineProperty(this, "userAccessInfo", void 0);

    _defineProperty(this, "sixStorageOverrideCultureCurrency", void 0);

    _defineProperty(this, "gtagConfig", {
      TRACE_ID: typeof wordpress_vars !== 'undefined' && wordpress_vars !== '' && typeof wordpress_vars.gtag_config !== 'undefined' && wordpress_vars.gtag_config !== '' && wordpress_vars.gtag_config !== null ? wordpress_vars.gtag_config : '',
      MOVE_IN_PAGE: typeof wordpress_vars !== 'undefined' && wordpress_vars !== '' && typeof wordpress_vars.gtag_move_in_page !== 'undefined' && wordpress_vars.gtag_move_in_page !== '' && wordpress_vars.gtag_move_in_page !== null ? wordpress_vars.gtag_move_in_page : ''
    });

    this.dialCodes = [];
    this.datepickerTranslation = {};
    this.userLocationInfo = {};

    if (wordpress_vars.six_storage_online_tenant_activity_enable == '1') {
      this.userAccessInfo = {
        browserName: this.sixStorageGetUserBrowsername(),
        ipAddress: "".concat(
        /*To get Ip*/
        wordpress_vars.six_storage_online_to_get_ip_val),
        locationInfo: this.userLocationInfo
      };
    } else {
      this.userAccessInfo = {
        browserName: this.sixStorageGetUserBrowsername(),
        ipAddress: "",
        locationInfo: this.userLocationInfo
      };
    }

    if (typeof wordpress_vars !== 'undefined' && wordpress_vars !== '' && wordpress_vars.six_storage_online_tenant_location_enable == '1' && wordpress_vars.six_storage_online_tenant_location_api_key != '') {//this.sixStorageInitGeoLocation();
    }

    this.sixStorageInternetActivityStatus();
  }

  _createClass(Helper, [{
    key: "sixStorageInternetActivityStatus",
    value: function sixStorageInternetActivityStatus() {
      var _this = this;

      window.addEventListener("offline", function (event) {
        var html = '';
        html += "<div class=\"six-storage-internet-activity-modal-content six-storage-primary-background-color\">\n        <div class=\"six-storage-internet-activity-msg six-storage-primary-background-color\">   \n         <p class =\"six-storage-white-text six-storage-center-align\">".concat(
        /*Please Internet Connection lost message*/
        wordpress_vars.six_storage_online_su_Internet_lost, "</p>\n         <p class =\"six-storage-white-text six-storage-center-align\">").concat(
        /*Please Internet Connection Check message*/
        wordpress_vars.six_storage_online_su_Check_internet_connection, " <a class=\"six-storage-white-text\" href=\"javascript:void(0);\" onclick=\"").concat(_this.sixStorageInternetActivityStatus(), "\">").concat(
        /*Please try again message*/
        wordpress_vars.six_storage_online_su_try_again, "</a>.</p>\n        <div>\n   </div>");
        document.getElementById('six-storage-internet-activity-mymodal').innerHTML = html;
        document.getElementById('six-storage-internet-activity-mymodal').style.display = "block";
      });
      window.addEventListener("online", function (event) {
        var html = '';
        html += "<div class=\"six-storage-internet-activity-modal-content six-storage-primary-background-color\">\n        <div class=\"six-storage-internet-activity-msg six-storage-primary-background-color\">\n        </div>\n        </div>";
        document.getElementById('six-storage-internet-activity-mymodal').innerHTML = html;
        document.getElementById('six-storage-internet-activity-mymodal').style.display = "none";
      });
    } //This function is for Globalise test formatters; Don't remove.

  }, {
    key: "sixStorageInitFormatters",
    value: function sixStorageInitFormatters() {
      Globalize.locale("da-DK");
      this.numberFormatter = Globalize.numberFormatter({
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      });
      this.numberParser = Globalize.numberParser();
      console.log("numberFormatter ", this.numberFormatter(1250.99));
      console.log("numberParser ", this.numberParser(this.numberFormatter(1250.99)));
      this.percentageFormatter = Globalize.numberFormatter({
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      });
      console.log("this.percentageFormatter ", this.percentageFormatter(10.25));
      this.dateFormatter = Globalise.dateFormatter();
      this.dateParser = Globalise.dateParser();
      console.log("this.dateFormatter ", this.dateFormatter(new Date()));
      console.log("this.dateParser ", this.dateParser(this.dateFormatter(new Date())));
      this.currencyFormatter = Globalize.currencyFormatter("DKK");
      console.log("this.currencyFormatter ", this.currencyFormatter(1250.99));
    }
  }, {
    key: "sixStorageShowMessage",
    value: function sixStorageShowMessage(message) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (isError === false) {
        M.toast({
          html: "<div class=\"six-storage-text-section six-storage-grid-d-flex six-storage-align-items-center\">\n                <div class=\"six-storage-icon-alert-box2 green six-storage-rounded-circle six-storage-grid-mr10 six-storage-grid-d-flex six-storage-align-items-center six-storage-justify-content-center\">\n                     <i class=\"six-storage-material-icons notranslate six-storage-white-text six-storage-font-size-30\" id=\"alert-icon\">thumb_up</i>\n                </div>\n                <p class=\"cc six-storage-alert-text six-storage-font-weight-bold six-storage-grid-m0 six-storage-white-text six-storage-alert-message\" id=\"six-storage-alert-message\"> ".concat(message, "</p>\n             </div>"),
          classes: 'six-storage-green sixstoragetoast'
        });
      } // let alert = document.getElementById("six-storage-success-msg");
      // let alertIcon = document.getElementsByClassName("six-storage-icon-alert-box")[0];
      //  const alertDiv = document.getElementById("six-storage-dv-alert");
      // alert.classList.remove('six-storage-d-none')
      // alert.classList.add('six-storage-active-alert')
      // alertDiv.classList.remove("six-storage-red");
      // alertIcon.classList.remove("six-storage-red");
      // alertDiv.classList.remove("six-storage-green");
      // alertDiv.classList.add("six-storage-green");
      // alertIcon.classList.add("six-storage-green");
      // document.getElementById("six-storage-alert-message").innerHTML = message;
      // document.getElementById("six-storage-alert-icon").innerHTML = "thumb_up";


      if (isError) {
        // alertDiv.classList.remove("six-storage-green");
        // alertIcon.classList.remove("six-storage-green");
        // alertDiv.classList.add("six-storage-red");
        // alertIcon.classList.add("six-storage-red");
        // document.getElementById("six-storage-alert-icon").innerHTML = "mood_bad";
        M.toast({
          html: "<div class=\"six-storage-text-section six-storage-grid-d-flex six-storage-align-items-center\">\n                <div class=\"six-storage-icon-alert-box six-storage-rounded-circle six-storage-grid-mr10 six-storage-grid-d-flex six-storage-align-items-center six-storage-justify-content-center\">\n                     <i class=\"six-storage-material-icons notranslate six-storage-white-text six-storage-font-size-30 red\">mood_bad</i>\n                </div>\n                <p class=\"cc six-storage-alert-text six-storage-font-weight-bold six-storage-grid-m0 six-storage-white-text six-storage-alert-message\" id=\"six-storage-alert-message\"> ".concat(message, "</p>\n             </div>"),
          classes: 'six-storage-red sixstoragetoast'
        });
      } // setTimeout(() => {
      //     this.sixStorageCloseAlert();
      // }, 8000);

    }
  }, {
    key: "sixStorageCalenderTranslaton",
    value: function sixStorageCalenderTranslaton() {
      return this.datepickerTranslation = {
        cancel: "".concat(
        /*Cancel*/
        wordpress_vars.six_storage_online_su_Cancel),
        clear: "".concat(
        /*Clear*/
        wordpress_vars.six_storage_online_hj_clear),
        done: "".concat(
        /*Done*/
        wordpress_vars.six_storage_online_hj_done),
        months: ["".concat(
        /*January*/
        wordpress_vars.six_storage_online_hj_January), "".concat(
        /*February*/
        wordpress_vars.six_storage_online_hj_February), "".concat(
        /*March*/
        wordpress_vars.six_storage_online_hj_March), "".concat(
        /*April*/
        wordpress_vars.six_storage_online_hj_April), "".concat(
        /*May*/
        wordpress_vars.six_storage_online_hj_May), "".concat(
        /*June*/
        wordpress_vars.six_storage_online_hj_June), "".concat(
        /*July*/
        wordpress_vars.six_storage_online_hj_July), "".concat(
        /*August*/
        wordpress_vars.six_storage_online_hj_August), "".concat(
        /*September*/
        wordpress_vars.six_storage_online_hj_September), "".concat(
        /*October*/
        wordpress_vars.six_storage_online_hj_October), "".concat(
        /*November*/
        wordpress_vars.six_storage_online_hj_November), "".concat(
        /*December*/
        wordpress_vars.six_storage_online_hj_December)],
        monthsShort: ["".concat(
        /*Jan*/
        wordpress_vars.six_storage_online_hj_Jan), "".concat(
        /*Feb*/
        wordpress_vars.six_storage_online_hj_Feb), "".concat(
        /*Mar*/
        wordpress_vars.six_storage_online_hj_Mar), "".concat(
        /*Apr*/
        wordpress_vars.six_storage_online_hj_Apr), "".concat(
        /*May*/
        wordpress_vars.six_storage_online_hj_May), "".concat(
        /*Jun*/
        wordpress_vars.six_storage_online_hj_Jun), "".concat(
        /*Jul*/
        wordpress_vars.six_storage_online_hj_Jul), "".concat(
        /*Aug*/
        wordpress_vars.six_storage_online_hj_Aug), "".concat(
        /*Sep*/
        wordpress_vars.six_storage_online_hj_Sep), "".concat(
        /*Oct*/
        wordpress_vars.six_storage_online_hj_Oct), "".concat(
        /*Nov*/
        wordpress_vars.six_storage_online_hj_Nov), "".concat(
        /*Dec*/
        wordpress_vars.six_storage_online_hj_Dec)],
        weekdays: ["".concat(
        /*Sunday*/
        wordpress_vars.six_storage_online_hj_Sunday), "".concat(
        /*Monday*/
        wordpress_vars.six_storage_online_hj_Monday), "".concat(
        /*Tuesday*/
        wordpress_vars.six_storage_online_hj_Tuesday), "".concat(
        /*Wednesday*/
        wordpress_vars.six_storage_online_hj_Wednesday), "".concat(
        /*Thursday*/
        wordpress_vars.six_storage_online_hj_Thursday), "".concat(
        /*Friday*/
        wordpress_vars.six_storage_online_hj_Friday), "".concat(
        /*Saturday*/
        wordpress_vars.six_storage_online_hj_Saturday)],
        weekdaysShort: ["".concat(
        /*Sun*/
        wordpress_vars.six_storage_online_hj_Sun), "".concat(
        /*Mon*/
        wordpress_vars.six_storage_online_hj_Mon), "".concat(
        /*Tue*/
        wordpress_vars.six_storage_online_hj_Tue), "".concat(
        /*Wed*/
        wordpress_vars.six_storage_online_hj_Wed), "".concat(
        /*Thu*/
        wordpress_vars.six_storage_online_hj_Thu), "".concat(
        /*Fri*/
        wordpress_vars.six_storage_online_hj_Fri), "".concat(
        /*Sat*/
        wordpress_vars.six_storage_online_hj_Sat)],
        weekdaysAbbrev: ["".concat(
        /*S*/
        wordpress_vars.six_storage_online_hj_Sunday_short), "".concat(
        /*M*/
        wordpress_vars.six_storage_online_hj_M), "".concat(
        /*T*/
        wordpress_vars.six_storage_online_hj_T), "".concat(
        /*W*/
        wordpress_vars.six_storage_online_hj_W), "".concat(
        /*T*/
        wordpress_vars.six_storage_online_hj_Thursday_short_form), "".concat(
        /*F*/
        wordpress_vars.six_storage_online_hj_F), "".concat(
        /*S*/
        wordpress_vars.six_storage_online_hj_S)]
      };
    }
  }, {
    key: "sixStorageCloseAlert",
    value: function sixStorageCloseAlert() {
      var alert = document.getElementById("six-storage-success-msg");
      alert.classList.remove('six-storage-active-alert');
      alert.classList.add('six-storage-d-none');
    }
  }, {
    key: "sixStorageCheckPhoneNumber",
    value: function sixStorageCheckPhoneNumber(event) {
      var inputValue = event.target.value;
      var numbers = inputValue.replace(/[^0-9]/g, '');
      event.target.value = numbers;
    }
  }, {
    key: "sixStorageCheckNumber",
    value: function sixStorageCheckNumber(event) {
      var inputValue = event.target.value;
      var numbers = inputValue.replace(/[^0-9]/g, '');
      event.target.value = numbers;
    }
  }, {
    key: "sixStorageRestictNumber",
    value: function sixStorageRestictNumber(event) {
      var symbol = event.target.value;
      var expression = symbol.replace(/<|>/g, '');
      event.target.value = expression;
    }
  }, {
    key: "sixStorageCheckAlphanumeric",
    value: function sixStorageCheckAlphanumeric(event) {
      var inputValue = event.target.value;
      var numbers = inputValue.replace(/^^ *$/g, '');
      /*[^a-zA-Z0-9!@#$&()\\-`.+,/\"]*$*/

      event.target.value = numbers;
    }
  }, {
    key: "sixStorageCheckOnlyAlphaNumeric",
    value: function sixStorageCheckOnlyAlphaNumeric(event) {
      var inputValue = event.target.value;
      var numbers = inputValue.replace(/[^a-zA-Z0-9]*$/g, '');
      /*[^a-zA-Z0-9!@#$&()\\-`.+,/\"]*$*/

      event.target.value = numbers;
    }
  }, {
    key: "sixStorageCheckAlphabets",
    value: function sixStorageCheckAlphabets(event) {
      var inputValue = event.target.value;
      var numbers = inputValue.replace(/[^a-zA-Z\-_\s]/g, '');
      event.target.value = numbers;
    }
  }, {
    key: "sixStorageIsNumber",
    value: function sixStorageIsNumber(event) {
      if (event.which !== 8 && isNaN(String.fromCharCode(event.which))) {
        event.preventDefault();
      }
    }
  }, {
    key: "sixStorageCheckEmail",
    value: function sixStorageCheckEmail(event) {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      var inputValue = this.value;

      if (inputValue.match(mailformat)) {
        return true;
      } else {
        var err = document.getElementById("".concat(this.id, "-err"));

        if (typeof err !== "undefined" && err != null) {
          err.style.display = "";
          err.innerHTML = "".concat(
          /*Please Enter Valid Email*/
          wordpress_vars.six_storage_online_su_Please_Enter_Valid_Email);
        }

        return false;
      }
    }
  }, {
    key: "sixStorageValidURL",
    value: function sixStorageValidURL(str) {
      var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      var url = new RegExp(regexp, "g");

      if (url.test(str)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "sixStorageValidateEmail",
    value: function sixStorageValidateEmail(input) {
      var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var inputValue = input.value;

      if (inputValue.match(mailformat)) {
        var err = document.getElementById("".concat(input.id, "-err"));
        err.style.display = "none";
        return true;
      } else {
        var _err = document.getElementById("".concat(input.id, "-err"));

        if (typeof _err !== "undefined" && _err != null) {
          _err.style.display = "";
          _err.innerHTML = "".concat(
          /*Please Enter Valid Email*/
          wordpress_vars.six_storage_online_su_Please_Enter_Valid_Email);
        }

        return false;
      }
    }
  }, {
    key: "sixStorageGetURIParams",
    value: function sixStorageGetURIParams(formData) {
      debugger; // let parameters = [];
      // const data = [...formData.entries()];
      // const asString = data
      //     .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
      //     .join('&');
      //   [...formData.entries()] // expand the elements from the .entries() iterator into an actual array
      //     .map(e => encodeURIComponent(e[0]) + "=" + encodeURIComponent(e[1]));

      var parameters = _toConsumableArray(formData.entries()) // expand the elements from the .entries() iterator into an actual array
      .map(function (e) {
        return encodeURIComponent(e[0]) + "=" + encodeURIComponent(e[1]);
      }); // transform the elements into encoded key-value-pairs


      return parameters.join("&"); //return asString;
    }
  }, {
    key: "sixStorageGetClientCulture",
    value: function sixStorageGetClientCulture() {
      var _this2 = this;

      if (typeof Storage !== "undefined") {
        this.cultureInfo = JSON.parse(sessionStorage.getItem("cultureInfo"));

        if (typeof this.cultureInfo !== 'undefined' && this.cultureInfo !== null) {
          return;
        }
      }

      var formData = new FormData();
      formData.append("action", "six_storage_get_client_culture");
      var header = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;"
        },
        body: this.sixStorageGetURIParams(formData)
      };
      var url = document.getElementById("six-storage-template-ajax-url").dataset.url;
      fetch(url, header).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof data !== "undefined" && data !== null) {
          var response = JSON.parse(data);

          if (typeof Storage !== "undefined") {
            sessionStorage.setItem("cultureInfo", JSON.stringify(response));
          }

          _this2.cultureInfo = response;
        }
      });
    } //DIsplay Date In Localised Format

  }, {
    key: "sixStorageDisplayDate",
    value: function sixStorageDisplayDate(date) {
      //US TimeZone Issue Temporary Fix
      //let returnFormat = momentjs.tz(date, "Central America Standard Time").utc().format(this.sixStorageConvertMomentDateFormat(this.dateFormat));
      var clientConfig = JSON.parse(sessionStorage.getItem("SixStorageclientConfig"));
      var timezone = clientConfig.culture.timezone;
      var returnFormat; //TimeZone Issue Fixed

      if (typeof timezone !== "undefined" && timezone !== null) {
        returnFormat = _momentTimezone["default"].tz(date, timezone).utc().format(this.sixStorageConvertMomentDateFormat(this.dateFormat));
      } else {
        returnFormat = (0, _moment["default"])(date).format(this.sixStorageConvertMomentDateFormat(this.dateFormat));
      } // if (typeof this.cultureInfo !== 'undefined' && this.cultureInfo !== null) {
      //     //new Intl.DateTimeFormat(this.cultureInfo.culture).format(date)
      //     dateFormat = this.cultureInfo.shortDate.replace("d", "D").replace("d", "D");
      // }


      return returnFormat;
    } //Read Date From Localised Format

  }, {
    key: "sixStorageReadDate",
    value: function sixStorageReadDate(date) {
      // let dateFormat = '';
      // if (typeof this.cultureInfo !== 'undefined' && this.cultureInfo !== null) {
      //     dateFormat = this.sixStorageConvertMomentDateFormat(this.cultureInfo.shortDate);//.replace("d", "D").replace("d", "D");
      // }
      var momentDate = (0, _moment["default"])(date, this.sixStorageConvertMomentDateFormat(this.dateFormat));
      return "".concat(momentDate.year(), "-").concat(momentDate.month() + 1, "-").concat(momentDate.date());
    }
  }, {
    key: "sixStorageDateMonthYear",
    value: function sixStorageDateMonthYear(date) {
      // let dateFormat = '';
      // if (typeof this.cultureInfo !== 'undefined' && this.cultureInfo !== null) {
      //     dateFormat = this.sixStorageConvertMomentDateFormat(this.cultureInfo.shortDate);//.replace("d", "D").replace("d", "D");
      // }
      var momentDate = (0, _moment["default"])(date, this.sixStorageConvertMomentDateFormat(this.dateFormat)); // return `${momentDate.year()}-${momentDate.month() + 1}-${momentDate.date()}`;

      return "".concat(momentDate.date(), "-").concat(momentDate.month() + 1, "-").concat(momentDate.year());
    }
  }, {
    key: "sixStorageMonthDateYear",
    value: function sixStorageMonthDateYear(date) {
      var momentDate = (0, _moment["default"])(date, this.sixStorageConvertMomentDateFormat(this.dateFormat));
      return "".concat(momentDate.month() + 1, "-").concat(momentDate.date(), "-").concat(momentDate.year());
    } //Display Float In Localised Currency

  }, {
    key: "sixStorageDisplayCurrency",
    value: function sixStorageDisplayCurrency(amount) {
      var returnFormat;

      if (this.culture === 'is-IS') {
        returnFormat = new Intl.NumberFormat(this.culture, {
          style: "currency",
          currency: "ISK",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } else {
        returnFormat = new Intl.NumberFormat(this.culture, {
          style: "currency",
          currency: typeof this.currency !== 'undefined' && this.currency != null ? this.currency : 'USD',
          currencyDisplay: 'narrowSymbol',
          maximumFractionDigits: 2
        }).format(amount);

        if (this.culture === 'ar-SA') {
          returnFormat = "SAR &nbsp;" + amount;
        } else if (this.culture === 'nn-NO') {
          returnFormat = amount + 'kr';
        }
      }

      return returnFormat;
    } //Display Number In Localised Format

  }, {
    key: "sixStorageDisplayNumber",
    value: function sixStorageDisplayNumber(number) {
      var returnFormat = new Intl.NumberFormat(this.culture, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      }).format(number);

      if (this.culture === 'ar-SA') {
        returnFormat = number;
      }

      return returnFormat;
    } //Display Number In Localised Percentage

  }, {
    key: "sixStorageDisplayPercent",
    value: function sixStorageDisplayPercent(number) {
      var returnFormat = new Intl.NumberFormat(this.culture, {
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      }).format(number > 0 ? number / 100 : number);

      if (this.culture === 'ar-SA') {
        returnFormat = number + "&nbsp;% ";
      }

      return returnFormat;
    }
  }, {
    key: "sixStorageInitTelephoneNumber",
    value: function sixStorageInitTelephoneNumber(id) {
      //const country = typeof this.culture !== 'undefined' && this.culture !== null && this.culture !== '' ? this.culture.substring(this.culture.indexOf('-') + 1, this.culture.length).toLowerCase() : '';
      var culturenamearr = [];
      var country;

      if (typeof this.culture !== "undefined" && this.culture !== null) {
        culturenamearr.push(this.culture);
        var cultureJoin = culturenamearr.join("-");
        var cultureplit = cultureJoin.split("-");
        var culturecountry = cultureplit[cultureplit.length - 1];
        country = culturecountry.toLowerCase();
      }

      var fields = document.querySelectorAll(typeof id !== 'undefined' && id !== null && id !== "" ? id : ".six-storage-telephone");

      if (fields.length > 0) {
        Array.prototype.forEach.call(fields, function (item) {
          var intl = (0, _intlTelInput["default"])(item, {
            separateDialCode: "true",
            initialCountry: country,
            utilsScript: "".concat(wordpress_vars.six_storage_plugin_url, "assets/js/utils.js"),
            preferredCountries: [country]
          });
        });
      }
    }
  }, {
    key: "sixStorageTogglePasswordVisibility",
    value: function sixStorageTogglePasswordVisibility(field) {
      field.innerHTML = field.innerHTML === "remove_red_eye" ? "visibility_off" : "remove_red_eye";
      var input = document.getElementById(field.getAttribute('toggle'));

      if (input.getAttribute('type') == 'password') {
        input.setAttribute('type', 'text');
      } else {
        input.setAttribute('type', 'password');
      }
    }
  }, {
    key: "sixStorageShowBusyIndicator",
    value: function sixStorageShowBusyIndicator(flag) {
      if (typeof wordpress_vars !== 'undefined' && wordpress_vars !== null && wordpress_vars !== '' && typeof wordpress_vars.preloaderEnabled !== 'undefined' && wordpress_vars.preloaderEnabled !== null && wordpress_vars.preloaderEnabled !== 'false' && wordpress_vars.preloaderEnabled !== '') {
        var sixStorageLoader = document.getElementById('six-storage-loading-container');

        if (typeof sixStorageLoader !== "undefined" && sixStorageLoader !== null) {
          sixStorageLoader.classList.add("six-storage-position-fixed");
          sixStorageLoader.classList.remove("six-storage-background-fade-loader");
        }

        var loading = "<div id=\"six-storage-spinner_background\">\n            <div class=\"six-storage-preloader-wrapper six-storage-big six-storage-active\" id=\"six-storage-spinnerLoader\">\n                <div class=\"six-storage-spinner-layer six-storage-spinner-blue-only\">\n                <div class=\"six-storage-circle-clipper six-storage-left\">\n                    <div class=\"six-storage-circle\"></div>\n                </div><div class=\"six-storage-gap-patch\">\n                    <div class=\"six-storage-circle\"></div>\n                </div><div class=\"six-storage-circle-clipper six-storage-right\">\n                    <div class=\"six-storage-circle\"></div>\n                </div>\n                </div>\n            </div></div>";

        var _sixstorageloadingcontainer = document.getElementById("six-storage-loading-container");

        if (typeof flag !== "undefined" && flag !== null && flag === true) {
          if (typeof _sixstorageloadingcontainer !== "undefined" && _sixstorageloadingcontainer !== null) {
            _sixstorageloadingcontainer.style.display = "";
          }

          return loading;
        } else {
          if (typeof _sixstorageloadingcontainer !== "undefined" && _sixstorageloadingcontainer !== null) {
            _sixstorageloadingcontainer.style.display = "none";
          }
        }

        return "";
      } else {
        var _sixStorageLoader = document.getElementById('six-storage-loading-container');

        if (typeof _sixStorageLoader !== "undefined" && _sixStorageLoader !== null) {
          _sixStorageLoader.classList.add("six-storage-position-fixed", "six-storage-background-fade-loader");

          _sixStorageLoader.classList.remove("six-storage-position-absolute");
        }

        var _loading = "<div class=\"six-storage-progress\" id=\"line-pre-loader\">\n                            <div class=\"six-storage-indeterminate\"></div>\n                        </div>";

        if (typeof flag !== "undefined" && flag !== null && flag === true) {
          if (typeof sixstorageloadingcontainer !== "undefined" && sixstorageloadingcontainer !== null) {
            sixstorageloadingcontainer.style.display = "";
          }

          return _loading;
        } else {
          if (typeof sixstorageloadingcontainer !== "undefined" && sixstorageloadingcontainer !== null) {
            sixstorageloadingcontainer.style.display = "none";
          }
        }

        return "";
      }
    }
  }, {
    key: "sixStorageGetMomentLocaleData",
    value: function sixStorageGetMomentLocaleData() {
      debugger; // Get user locale

      var locale = this.culture || window.navigator.userLanguage || window.navigator.language; // Set locale to moment

      _moment["default"].locale(locale); // Get locale data


      return _moment["default"].localeData();
    }
  }, {
    key: "sixStorageSanitizeMaterialDateFormat",
    value: function sixStorageSanitizeMaterialDateFormat(inputstring) {
      return inputstring.toLowerCase();
    }
  }, {
    key: "sixStorageConvertMomentDateFormat",
    value: function sixStorageConvertMomentDateFormat(inputstring) {
      return inputstring.toUpperCase();
    }
  }, {
    key: "sixStorageGetYearList",
    value: function sixStorageGetYearList(from, to) {
      var select = document.createElement("select");
      var option = document.createElement("option");
      option.value = "";
      option.innerHTML = "".concat(
      /*Select Year*/
      wordpress_vars.six_storage_online_dp_Select_Year);
      select.appendChild(option);

      for (var i = from; i <= to; i++) {
        option = document.createElement("option");
        option.value = i;
        option.innerHTML = i;
        select.appendChild(option);
      }

      return select.innerHTML;
    }
  }, {
    key: "sixStorageResizeIframe",
    value: function sixStorageResizeIframe(selector) {
      iFrameResize({
        //log: true,
        bodyPadding: 10,
        heightCalculationMethod: 'documentElementOffset',
        scrolling: true
      }, selector);
    }
  }, {
    key: "sixStorageGetHostURL",
    value: function sixStorageGetHostURL() {
      return window.location.href;
    }
  }, {
    key: "sixStorageGetTenantType",
    value: function sixStorageGetTenantType() {
      var tenant_type = document.getElementById("six-storage-tenant_type");
      var isBusinessUser = typeof tenant_type !== "undefined" && tenant_type !== null && typeof tenant_type.value !== "undefined" && tenant_type.value !== null && tenant_type.value === "true" ? true : false;
      return isBusinessUser;
    }
  }, {
    key: "sixStorageGetParameterByName",
    value: function sixStorageGetParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }, {
    key: "sixStorageMeasurementDisplayFormat",
    value: function sixStorageMeasurementDisplayFormat(format) {
      var returnResult = "";

      switch (format) {
        case "M2":
          {
            returnResult = "m<sup class=\"cc\">2</sup>";
            break;
          }

        case "MQ":
          {
            returnResult = "m<sup class=\"cc\">3</sup>";
            break;
          }

        case "QCM":
          {
            returnResult = "cm<sup class=\"cc\">3</sup>";
            break;
          }

        case "QFT":
          {
            returnResult = "ft<sup class=\"cc\">3</sup>";
            break;
          }

        case "QMT":
          {
            returnResult = "m<sup class=\"cc\">3</sup>";
            break;
          }

        case "QSIZE":
          {
            returnResult = "WxLxH";
            break;
          }

        case "SIZE":
          {
            returnResult = "WxL";
            break;
          }

        case "SQFT":
          {
            returnResult = "ft<sup class=\"cc\">2</sup>";
            break;
          }

        default:
          {
            returnResult = "";
            break;
          }
      }

      return returnResult;
    }
  }, {
    key: "sixStorageDisplayMeasurementSize",
    value: function sixStorageDisplayMeasurementSize(value, format) {
      var returnResult = value;

      switch (format) {
        case "M2":
          {
            returnResult = this.sixStorageDisplayNumber(returnResult);
            break;
          }

        case "MQ":
          {
            returnResult = this.sixStorageDisplayNumber(returnResult);
            break;
          }

        case "QCM":
          {
            returnResult = this.sixStorageDisplayNumber(returnResult);
            break;
          }

        case "QFT":
          {
            returnResult = this.sixStorageDisplayNumber(returnResult);
            break;
          }

        case "QMT":
          {
            returnResult = this.sixStorageDisplayNumber(returnResult);
            break;
          }

        case "QSIZE":
          {
            var dimensionArr = returnResult.split('x');
            returnResult = "".concat(this.sixStorageDisplayNumber(dimensionArr[0]), "x").concat(this.sixStorageDisplayNumber(dimensionArr[1]), "x").concat(this.sixStorageDisplayNumber(dimensionArr[2]));
            break;
          }

        case "SIZE":
          {
            var _dimensionArr = returnResult.split('x');

            returnResult = "".concat(this.sixStorageDisplayNumber(_dimensionArr[0]), "x").concat(this.sixStorageDisplayNumber(_dimensionArr[1]));
            break;
          }

        case "SQFT":
          {
            returnResult = this.sixStorageDisplayNumber(returnResult);
            break;
          }

        default:
          {
            break;
          }
      }

      return returnResult;
    } // sixStorageInitGeoLocation() {
    //     geo.config({
    //         language: "en",
    //         google: {
    //             version: "3",
    //             key: wordpress_vars.six_storage_online_tenant_location_api_key,
    //         }
    //     });
    //     this.sixStorageGetGeoInformation()
    // }
    // sixStorageGetGeoInformation() {
    //     let options = {
    //         enableHighAccuracy: true,
    //         timeout: 5000,
    //         maximumWait: 10000,     // max wait time for desired accuracy
    //         maximumAge: 0,          // disable cache
    //         desiredAccuracy: 30,    // meters
    //         fallbackToIP: true,     // fallback to IP if Geolocation fails or rejected
    //         addressLookup: true,    // requires Google API key if true
    //         timezone: true,         // requires Google API key if true
    //         //map: "map-canvas",      // interactive map element id (or options object)
    //         staticMap: true         // get a static map image URL (boolean or options object)
    //     };
    //     geo.locate(options, (err, location) => {
    //         if (typeof location !== 'undefined' & location !== null) {
    //             this.userLocationInfo = {
    //                 address: location["address"],
    //                 timestamp: location["timestamp"],
    //                 formattedAddress: location["formattedAddress"],
    //                 flag: location["flag"]
    //             };
    //             this.userAccessInfo["locationInfo"] = this.userLocationInfo;
    //         }
    //     });
    //     geo.getIP((err, result) => {
    //         if (typeof result !== 'undefined' && result !== null) {
    //             this.userAccessInfo["ipAddress"] = result["ip"];
    //         }
    //     });
    //}

  }, {
    key: "sixStorageGetUserBrowsername",
    value: function sixStorageGetUserBrowsername() {
      var agent = {
        browser: {
          name: null,
          version: null,
          v: null,
          userAgent: null,
          app: null,
          os: null
        },
        mobile: false,
        pointlock: false
      };
      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browserName = navigator.appName;
      var fullVersion = '' + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;
      agent.pointlock = 'pointerLockElement' in document || 'mozPointerLockElement' in document || 'webkitPointerLockElement' in document; // In Opera, the true version is after "Opera" or after "Version"

      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
      } else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      } else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      } else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
      } else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);

        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      } // trim the fullVersion string at semicolon/space if present


      if ((ix = fullVersion.indexOf(";")) != -1) fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1) fullVersion = fullVersion.substring(0, ix);
      majorVersion = parseInt('' + fullVersion, 10);

      if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }

      agent.browser.name = browserName;
      agent.browser.version = fullVersion;
      agent.browser.v = majorVersion;
      agent.browser.app = navigator.appName;
      agent.browser.userAgent = navigator.userAgent;
      var OSName = "Unknown OS";
      if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
      if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
      if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";
      agent.browser.os = OSName;
      agent.mobile = typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1;
      return "".concat(agent.browser.name, "/").concat(agent.browser.version, "-").concat(agent.browser.os);
    }
  }, {
    key: "sixStorageOpenNewWindow",
    value: function sixStorageOpenNewWindow(url, title, w, h) {
      // Fixes dual-screen position                             Most browsers      Firefox
      var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
      var systemZoom = width / window.screen.availWidth;
      var left = (width - w) / 2 / systemZoom + dualScreenLeft;
      var top = (height - h) / 2 / systemZoom + dualScreenTop;
      var newWindow = window.open(url, title, "scrollbars=yes,width=".concat(w / systemZoom, ", height=").concat(h / systemZoom, ", top=").concat(top, ", left=").concat(left));
      if (window.focus) newWindow.focus(); //setInterval(this.checkChild(newWindow), 500);

      var timer = setInterval(checkChild, 500);

      function checkChild() {
        if (newWindow.closed) {
          document.getElementById("six-storage-loading-container").style.display = "none";
          clearInterval(timer);
        }
      }

      return newWindow;
    }
  }, {
    key: "sixStorageInitDatepicker",
    value: function sixStorageInitDatepicker(id, mindate, maxdate, selectCallback, selectedDate, range) {
      var date = new Date();
      var elems = document.querySelector(id);
      var format = this.sixStorageSanitizeMaterialDateFormat(this.helper.dateFormat);
      var rangeFormat = range == 'dob' ? [1951, new Date().getFullYear()] : 10;
      var translation = this.sixStorageCalenderTranslaton();
      var instance = M.Datepicker.init(elems, {
        autoClose: true,
        defaultDate: selectedDate,
        setDefaultDate: true,
        container: 'body',
        minDate: typeof mindate !== "undefined" && mindate !== "" && mindate !== null ? mindate : new Date("".concat(date.getFullYear() - 10, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())),
        maxDate: typeof maxdate !== "undefined" && maxdate !== "" && maxdate !== null ? maxdate : new Date("".concat(date.getFullYear() + 50, "-").concat(date.getMonth() + 1, "-").concat(date.getDate())),
        format: format,
        showClearBtn: false,
        onSelect: _typeof(selectCallback) !== undefined && selectCallback !== "" && selectCallback !== null ? selectCallback : window.sixStorageAllInputHighlight,
        yearRange: rangeFormat,
        i18n: translation
      });
    }
  }, {
    key: "sixStorageFileNameChange",
    value: function sixStorageFileNameChange(sixStoragefilerawname) {
      var sixStorageReplaceFileName = sixStoragefilerawname.replace(/[&\\\^+()~%'":?<>{}!@#]/g, '');
      var sixStorageUploadFileName = sixStorageReplaceFileName.split(".");

      if (sixStorageUploadFileName.length <= 2) {
        var sixStorageRandomVal = (0, _moment["default"])().format('YYYY/MM/DD [T] HH:mm:ss');
        var sixStorageFinalDocuName = sixStorageRandomVal.replace(/[&/\\\^+()~%'":?<>{}!@#/ /g]/g, '');
        var sixStorageNewFileName = sixStorageUploadFileName[0].concat("-", sixStorageFinalDocuName, ".", sixStorageUploadFileName[1]);
        return sixStorageNewFileName;
      } else {
        return sixStorageReplaceFileName;
      }
    }
  }]);

  return Helper;
}();

var _default = Helper;
exports["default"] = _default;

},{"intl-tel-input":3,"moment":7,"moment-timezone":5}],16:[function(require,module,exports){
"use strict";

var _MoveInApp = _interopRequireDefault(require("./modules/MoveInApp.js"));

var _materialize = _interopRequireDefault(require("./materialize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import M from "materialize-css";
isIEModal();
var app = new _MoveInApp["default"]();
document.addEventListener('DOMContentLoaded', function (params) {
  app.sixStorageAuthentication(); //app.sixStorageTenantTypeDefault();

  app.sixStorageAllInputHighlight();
  app.sixStorageHighlightInputLabel("six-storage-floating-input");
  app.sixstorageSelectIphone(); // app.sixStorageCheckPromocode();

  window.addEventListener('resize', function () {
    app.sixstorageSelectIphone();
  });
});

function isIEModal() {
  var myNav = window.navigator.userAgent;

  if (typeof myNav != "undefined" || myNav != null || myNav != " ") {
    var ieVersion = myNav.toLowerCase().indexOf("msie ") > -1 || myNav.toLowerCase().indexOf("trident/") > -1 ? true : false;

    if (ieVersion) {
      var ieBrowser = localStorage.getItem("ieBrowserLoaded");
      console.log(ieBrowser, ieVersion);

      if (typeof ieBrowser == "undefined" || ieBrowser == null || ieBrowser == " ") {
        var browserModal = document.getElementById('six-storage-browser-compatibility-modal');

        var instances = _materialize["default"].Modal.init(browserModal);

        instances.open();
      }
    }
  }
}

window.helper = app.helper;

window.paymentStatusMoveInCallback = function (paymentResponse) {
  if (typeof paymentResponse !== 'undefined' && paymentResponse !== '' && paymentResponse !== null && paymentResponse['status'] === 'success') {
    document.getElementById("six-storage-loading-container").innerHTML = app.helper.sixStorageShowBusyIndicator(false);
    app.sixStorageP24TenantEsign(false, paymentResponse); // app.sixStorageSaveMoveinDetails(false, paymentResponse);
    // app.helper.sixStorageShowMessage('Payment has been successfully processed', true);
    //app.sixStorageSaveMoveinDetails(false, paymentResponse);
  } else {
    document.getElementById("six-storage-loading-container").innerHTML = helper.sixStorageShowBusyIndicator(false);
    app.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_fs_payment_failed_message), true);
  }
};

if (wordpress_vars.eSignatureRequired == "1") {
  var esignclearbtnform = document.getElementById("six-storage-canvas-clear");
  esignclearbtnform.addEventListener("click", function () {
    document.getElementById("six-storage-payment-selection").style.display = 'none';
    document.getElementById("six-storage-payment-form-div").style.display = 'block';
    document.getElementById("six-storage-creditgrid-card-payment").style.display = 'none';
    document.getElementById("six-storage-use-save-card-container").style.display = 'none';
    document.getElementById("six-storage-no-payment-gateway-msg").style.display = 'none';
    document.getElementById("six-storage-book-now-pay-later").style.display = 'none';
  });
} // let esignclearbtnform = document.getElementById("six-storage-canvas-clear");
// esignclearbtnform.addEventListener("click", function () {
//     if (typeof app.esignMandatory !== 'undefined' && app.esignMandatory !== null && app.esignMandatory !== "" && app.esignMandatory === true) {
//        document.getElementById("six-storage-payment-form-div").style.display = 'block';
//         document.getElementById("six-storage-payment-selection").style.display = 'none';
//         document.getElementById("six-storage-paylater-book-now").style.display = 'none';
//     }
// })


window.paymentStatusReserveCallback = function (ptwofourRes) {
  if (typeof ptwofourRes !== 'undefined' && ptwofourRes !== '' && ptwofourRes !== null && ptwofourRes['status'] === 'success') {
    document.getElementById("six-storage-loading-container").innerHTML = app.helper.sixStorageShowBusyIndicator(false);
    app.sixStorageReservenow(ptwofourRes);
  } else {
    document.getElementById("six-storage-loading-container").innerHTML = app.helper.sixStorageShowBusyIndicator(false);
    app.helper.sixStorageShowMessage("".concat(wordpress_vars.six_storage_online_fs_payment_failed_message), true);
    var reservationModal = document.getElementById("six-storage-movein-modal");

    var instance = _materialize["default"].Modal.getInstance(reservationModal);

    instance.close();
  }
};

window.sixStorageValidateSpecialChar = function (e) {
  return app.sixStorageValidateSpecialChar(e);
};

var enquiry = document.getElementById('six-storage-enquiry');
enquiry.addEventListener('click', function (event) {
  event.preventDefault();
});
var reservation = document.getElementById('six-storage-reserve-now');
reservation.addEventListener('click', function (event) {
  app.sixStorageConstructreservepage();
});
var paynowradio = document.getElementById('six-storage-rdbtn_pay_now');

if (typeof paynowradio !== 'undefined' && paynowradio !== null) {
  paynowradio.addEventListener('change', function (event) {
    document.getElementById('six-storage-book-now-pay-later').style.display = 'none';
  });
}

var storage_type = document.getElementById('six-storage-storage-type');
storage_type.addEventListener('change', function (event) {
  app.sixStorageFilterLocation();
});
var location = document.getElementById('six-storage-location');
location.addEventListener('change', function (event) {
  app.sixStorageFilterLocationBuilding();
  app.sixStorageConstructAmenitiesOptions();
  var sixStoragetenantSelectedLocationVal = document.getElementById("six-storage-location").value;

  if (sixStoragetenantSelectedLocationVal != '' && sixStoragetenantSelectedLocationVal != null && typeof sixStoragetenantSelectedLocationVal != 'undefined') {
    document.getElementById("six-storage-tenantLocation-err").style.display = 'none';
  } else {
    document.getElementById("six-storage-tenantLocation-err").style.display = 'block';
  }
});
var unitSize = document.getElementById('six-storage-unit-type-dimensions');
unitSize.addEventListener('change', function (event) {
  app.sixStorageOnChangeDimensionValue();
});
var filterhead = document.getElementById('six-storage-filter-head');

if (typeof filterhead !== 'undefined' && filterhead !== '' && filterhead !== null) {
  filterhead.addEventListener('click', function (event) {
    app.SixStoargeFilterbody();
  });
}

var unit_type = document.getElementById('six-storage-unit-type');
unit_type.addEventListener('change', function (event) {
  app.sixStorageOnOptionSelect(event.target.selectedOptions[0].dataset.unittype_name, event.target.value);
});
var tenant_type = document.getElementById('six-storage-tenant_type');
tenant_type.addEventListener('change', function (event) {
  app.sixStorageChangeTenantType();
  app.sixStorageSearchUnits();
  document.getElementById("six-storage-tenantType-err").style.display = "none";
});

window.sixStorageSelectedUnits = function (unitId) {
  app.sixStorageUpdateUnitSelection(unitId);
};

window.sixStorageDeSelectedUnits = function (unitId) {
  app.sixStorageDeSelectedUnits(unitId);
};

window.sixStorageLoadMoreUnits = function (flag) {
  var sixstorageloadmore = document.getElementById("six-storage-online-unit-collection-contianer");

  if (typeof sixstorageloadmore !== "undefined" && sixstorageloadmore !== null) {
    sixstorageloadmore.scrollIntoView({
      behavior: 'smooth'
    }, true);
  }

  if (typeof app.sixReckonerRedirection["storageTypeID"] !== 'undefined' && app.sixReckonerRedirection["storageTypeID"] !== null && app.sixReckonerRedirection["storageTypeID"] !== "" && typeof app.sixReckonerRedirection["unitTypeID"] !== 'undefined' && app.sixReckonerRedirection["unitTypeID"] !== null && app.sixReckonerRedirection["unitTypeID"] !== "") {
    var storageTypeId = app.sixReckonerRedirection["storageTypeID"].split(',');
    var unitTypeId = app.sixReckonerRedirection["unitTypeID"].split(',');
    app.pageNumber += 1;
    app.sixStorageGetUnits(flag, [storageTypeId], [unitTypeId]);
  } else {
    //app.pageNumber += 1;
    var countdata;
    var unitypeid = document.getElementById("six-storage-unit-type");
    var pagenumber = document.getElementById("six-storage-load-more");
    var dataPagenum = pagenumber.getAttribute("data-page");
    var datacount = pagenumber.getAttribute("data-count");
    var PageNumber = Number(dataPagenum);
    var previousNumber = Number(datacount);
    var addPageNum = PageNumber += 1;
    var countsval = previousNumber -= 10;

    if (countsval > 0) {
      countdata = countsval;
    } else {
      countdata = 0;
    }

    app.sixStorageGetUnits(flag, null, unitypeid.value, addPageNum, countdata);
  }
};

window.sixStoragePreviousbtn = function (data) {
  var previousNum = document.getElementById("sixstoragepreviousbutton");
  var dataprevbutton = previousNum.getAttribute("data-page");
  var datacount = previousNum.getAttribute("data-count");
  var previousNumber = Number(datacount);
  var countsval = previousNumber += 10;
  var unitypeid = document.getElementById("six-storage-unit-type");
  var PageNumber = dataprevbutton -= 1;
  app.sixStorageGetUnits(data, null, unitypeid.value, PageNumber, countsval);
};

var rent_now = document.getElementById('six-storage-rent-now');

if (typeof rent_now !== "undefined" && rent_now !== null && rent_now !== "") {
  rent_now.addEventListener('click', function (event) {
    var sixStorageLocationValLength = sessionStorage.getItem("sixStorageLocationLength");

    if (wordpress_vars.six_storage_online_fc_location_toggle != "" && wordpress_vars.six_storage_online_fc_location_toggle != null && typeof wordpress_vars.six_storage_online_fc_location_toggle != "undefined" && wordpress_vars.six_storage_online_fc_location_toggle == '1' && sixStorageLocationValLength >= 1) {
      var _location = document.getElementById("six-storage-location");

      if (_location.value === null || typeof _location.value === 'undefined' || _location.value === '') {
        var sixStoragelocationdiv = document.getElementById('six-storage-dvLocation');
        sixStoragelocationdiv.scrollIntoView(true);
        document.getElementById("six-storage-tenantLocation-err").style.display = "";
        return;
      } else {
        document.getElementById("six-storage-tenantLocation-err").style.display = "none";
      }
    }

    if (app.businessUserEnabled === true) {
      var tenantType = document.getElementById("six-storage-tenant_type");

      if (tenantType.value === null || tenantType.value === "undefined" || tenantType.value === "") {
        // tenantType.scrollIntoView(true);
        var sixStorageFocusElement = document.getElementById('six-storage-dvTenantType');
        var y = sixStorageFocusElement.offsetTop;
        window.scrollTo(0, y);
        document.getElementById("six-storage-tenantType-err").style.display = "";
        return;
      } else {
        document.getElementById("six-storage-tenantType-err").style.display = "none";
      }
    }

    if (app.groupBySize) {
      app.sixStorageGetAutoSelectedUnits(true);
    } else {
      app.sixStorageRentNow();
    }
  });
}

window.sixStorageReserveSingleUnit = function (unitTypeId, price, unitId) {
  app.sixStorageReserveSingleUnit(unitTypeId, price, unitId);
};

var go_back = document.getElementById('six-storage-go-back');
go_back.addEventListener('click', function (event) {
  app.sixStorageGoBack();
});

window.sixStorageRemoveUnit = function (unitId) {
  app.sixStorageRemoveUnit(unitId);
};

var next_step = document.getElementById('six-storage-next-step');
next_step.addEventListener('click', function (event) {
  app.sixStorageNextStep();
});
var movein_date = document.getElementById('six-storage-movein-date');
movein_date.addEventListener('change', function (event) {
  sessionStorage.setItem("goback", false);
  app.sixStorageChangeSelectedUnits();
});
var invoice_period = document.getElementById('six-storage-invoice-period-new');
invoice_period.addEventListener('change', function (event) {
  sessionStorage.setItem("goback", false);
  app.changeInvoicePeriod();
  app.sixStoragePromoDiscounts();
});
var invoice_reccuring = document.getElementById('six-storage-invoice-reccuring-new');
invoice_reccuring.addEventListener('change', function (event) {
  sessionStorage.setItem("goback", false);
  app.sixStorageChangeSelectedUnits();
});
var additional_months = document.getElementById('six-storage-additional-months');
additional_months.addEventListener('change', function (event) {
  var additional_months = document.getElementById("six-storage-additional-months");
  sessionStorage.setItem("goback", false);

  if (additional_months.value > 12) {
    additional_months.value = 12;
    document.getElementById('six-storage-additional-months-err').style.display = 'block';
    document.getElementById('six-storage-additional-months-err').innerHTML = "".concat(wordpress_vars.additional_month_validation_text);
    return;
  } else {
    document.getElementById('six-storage-additional-months-err').style.display = 'none';
    app.sixStorageChangeSelectedUnits();
  }
});

window.sixStorageChangeSelectedUnits = function () {
  app.sixStorageChangeSelectedUnits();
};

window.sixStorageIncreaseQuantity = function (unitId, itemId, itamName, itemImage, availableStock) {
  app.sixStorageIncreaseQuantity(unitId, itemId, itamName, itemImage, availableStock);
};

window.sixStorageReduceQuantity = function (unitId, itemId) {
  app.sixStorageReduceQuantity(unitId, itemId);
};

window.sixStorageAddVehicleInfo = function (unitId) {
  app.sixStorageAddVehicleInfo(unitId);
};

window.sixStorageAddVehicleInfoAddmoreBtn = function (unitId) {
  app.sixStorageAddVehicleInfoAddmoreBtn(unitId);
};

window.sixStorageRemoveVehicleInfo = function (id) {
  app.sixStorageRemoveVehicleInfo(id);
};

var documents = document.getElementById('six_storage_documentFile');
documents.addEventListener('change', function (event) {
  app.sixStorageUploadDocuments(event);
  document.getElementById("six_storage_size_indication_msg").style.display = "none";
}); // const addemergencydetails = document.getElementById('six-storage-addemergencydetails');
// addemergencydetails.addEventListener('click', (event) => {
//     app.sixStorageAddEmergencyDetails();
// });

window.sixStorageAddEmergencyDetails = function () {
  app.sixStorageAddEmergencyDetails();
}; // const businessUser = document.getElementById('business-user');
// businessUser.addEventListener('click', (event) => {
//     app.businessUser();
// });


var deliveryAddressIsSame = document.getElementById('delivery-address-is-same-as-above');
deliveryAddressIsSame.addEventListener('onchange', function (event) {
  app.sixStorageDeliveryAddressIsSame();
});

window.sixStorageDeliveryAddressIsSame = function () {
  app.sixStorageDeliveryAddressIsSame();
};

var closeModalButtonss = document.querySelectorAll('[data-close-button]');
var overlay = document.getElementById('six-storage-overlay');
closeModalButtonss.forEach(function (button) {
  button.addEventListener('click', function () {
    var modal = button.closest('#six-storage-movein-modal');
    modal.classList.remove('six-storage-active');
    overlay.classList.remove('six-storage-active');
  });
});

window.sixStorageCheckedRadioInsurance = function (tr) {
  app.sixStorageCheckedRadioInsurance(tr);
};

window.sixStorageNewLoginModal = function () {
  app.sixStorageNewLoginModal();
};

window.sixStorageNewSignupModal = function () {
  app.sixStorageNewSignupModal();
};

window.sixStorageForgotPasswordModal = function () {
  app.sixStorageForgotPasswordModal();
};

window.sixStorageResetPasswordModal = function () {
  app.sixStorageResetPasswordModal();
};

window.sixStorageSetResetPasswordModal = function () {
  app.sixStorageSetResetPasswordModal();
};

window.sixStorageTenantLogin = function () {
  app.sixStorageSignIn();
};

window.sixStorageClearConfidential = function () {
  app.sixStorageClearConfidential();
};

window.sixStorageTenantSignUp = function () {
  app.sixStorageSignUp();
};

var safeBox = document.getElementById('six-storage-unit-key-in-safe-box');
safeBox.addEventListener('click', function (event) {
  app.sixStorageSafeBox();
});
var editTenantDetails = document.getElementById('six-storage-edit-tenant-details');
editTenantDetails.addEventListener('click', function (event) {
  app.currentStepNumber = 4;
  app.sixStorageRenderStepHtml();
});
var editDeliveryDetails = document.getElementById('six-storage-edit-delivery-details');
editDeliveryDetails.addEventListener('click', function (event) {
  app.currentStepNumber = 4;
  app.sixStorageRenderStepHtml();
});
var editIdDetails = document.getElementById('six-storage-edit-id-details');
editIdDetails.addEventListener('click', function (event) {
  app.currentStepNumber = 4;
  app.sixStorageRenderStepHtml();
});

window.editUnitDetails = function (unitId) {
  app.currentStepNumber = 2;
  app.sixStorageRenderStepHtml();
};

var userDetailsBtn = document.getElementById('six-storage-user-details-btn');
userDetailsBtn.addEventListener('click', function (event) {
  app.sixStorageChangeTab('six-storage-user-details');
});
var finalUnitDetailsBtn = document.getElementById('six-storage-final-unit-details-btn');
finalUnitDetailsBtn.addEventListener('click', function (event) {
  app.sixStorageChangeTab('six-storage-final-unit-details');
});
var addonDetailsBtn = document.getElementById('six-storage-addon-details-btn');
addonDetailsBtn.addEventListener('click', function (event) {
  app.sixStorageChangeTab('six-storage-addon-details');
});
var agreementSignatureBtn = document.getElementById('six-storage-agreement-signature-btn');
agreementSignatureBtn.addEventListener('click', function (event) {
  app.sixStorageChangeTab('six-storage-agreement-signature');
});
var validatePromocode = document.getElementById('six-storage-btnPromocode');
validatePromocode.addEventListener('click', function (event) {
  app.sixStorageValidatePromocode();
});
var removePromocode = document.getElementById('six-storage-btnPromocodeRemove');
removePromocode.addEventListener('click', function (event) {
  app.sixStoragePromoRemove();
}); // const paymentSelection = document.getElementById('six-storage-payment-option');
// paymentSelection.addEventListener('change',(event)=>{
//     app.sixStoragePaymentModeSelection();
// })

var takePhoto = document.getElementById('six-storage-select-options-take-photo');
takePhoto.addEventListener('click', function (event) {
  app.sixStorageTakePhoto();
});
var uploadPhoto = document.getElementById('six-storage-select-options-upload-photo');
uploadPhoto.addEventListener('click', function (event) {
  app.sixStorageUploadPhoto();
});
var removePhoto = document.getElementById('six-storage-remove-photo');
removePhoto.addEventListener('click', function (event) {
  app.sixStorageRemovePhoto();
});
var viewPhoto = document.getElementById('six-storage-select-options-view-photo');
viewPhoto.addEventListener('click', function (event) {
  app.sixStorageViewPhoto();
});

window.sixStorageCroppingFile = function (event) {
  app.sixStorageCroppingFile(event);
};

window.sixStorageInsuranceSelectionChange = function (unitId, insuranceId) {
  app.sixStorageInsuranceSelectionChange(unitId, insuranceId);
};

window.sixStorageServicesSelected = function (unitId, serviceId) {
  app.sixStorageServicesSelected(unitId, serviceId);
};

if (window.addEventListener) {
  window.addEventListener("message", app.sixStorageOnMessage, false);
} else if (window.attachEvent) {
  window.attachEvent("onmessage", app.sixStorageOnMessage, false);
}

window.ReceiveIframeResponse = function (message) {
  app.sixStorageOnPaymentProcessed(message);
};

window.ReceiveIframeResponseForRbn = function (message) {
  app.sixStorageOnChangePaymentMode(message);
};

window.paymentModeChange = function (id) {
  app.sixStorageMoveinPaymentModeChange(id);
}; // window.bookNow = () => {
//     app.uploadDocumentsToServer("ESIGN");
//     app.sixStorageSaveMoveinDetails();
// }


window.sixStorageGoToUnits = function () {
  app.currentStepNumber = 2;
  app.sixStorageRenderStepHtml();
};

var identity_type = document.getElementById("six-storage-identity_type");
identity_type.addEventListener("change", function () {
  app.sixStorageChangeIdentityType();
}); // const dtmoveindate = document.getElementById('six-storage-dtmoveindate');
// dtmoveindate.addEventListener('change', (event) => {
//     app.sixStorageGetBufferTime();
// });

window.sixStorageRemoveDocument = function (id) {
  app.sixStorageRemoveDocument(id);
};

var clearButton = document.getElementById("six-storage-canvas-clear");
var changeColorButton = document.getElementById("six-storage-canvas-change-color");
var undoButton = document.getElementById("six-storage-canvas-undo");
var savePNGButton = document.getElementById("six-storage-canvas-save-png");
var saveJPGButton = document.getElementById("six-storage-canvas-save-jpg");
var saveSVGButton = document.getElementById("six-storage-canvas-save-svg"); // On mobile devices it might make more sense to listen to orientation change,
// rather than window resize events.
// window.onresize = () => {
//     app.sixStorageResizeCanvas();
// };

clearButton.addEventListener("click", function (event) {
  app.signaturePad.clear();
  app.sixStorageSignatureCheck();
});
undoButton.addEventListener("click", function (event) {
  var data = app.signaturePad.toData();

  if (data) {
    data.pop(); // remove the last dot or line

    app.signaturePad.fromData(data);
  }
});
changeColorButton.addEventListener("click", function (event) {
  var r = Math.round(Math.random() * 255);
  var g = Math.round(Math.random() * 255);
  var b = Math.round(Math.random() * 255);
  var color = "rgb(" + r + "," + g + "," + b + ")";
  app.signaturePad.penColor = color;
});
savePNGButton.addEventListener("click", function (event) {
  if (app.signaturePad.isEmpty()) {
    alert("Please provide a signature first.");
  } else {
    var dataURL = app.signaturePad.toDataURL();
    app.download(dataURL, "signature.png");
  }
});
saveJPGButton.addEventListener("click", function (event) {
  if (app.signaturePad.isEmpty()) {
    alert("Please provide a signature first.");
  } else {
    var dataURL = app.signaturePad.toDataURL("image/jpeg");
    app.download(dataURL, "signature.jpg");
  }
});
saveSVGButton.addEventListener("click", function (event) {
  if (app.signaturePad.isEmpty()) {
    alert("Please provide a signature first.");
  } else {
    var dataURL = app.signaturePad.toDataURL('image/svg+xml');
    app.download(dataURL, "signature.svg");
  }
});
var cancel_movein = document.getElementById("six-storage-cancel-movein");
cancel_movein.addEventListener("click", function () {
  window.location.reload();
});

window.sixStorageDisplayEmergencyContact = function () {
  app.sixStorageDisplayEmergencyContact();
};

window.sixStorageDisplayEsign = function () {
  app.sixStorageDisplayEsign();
};

window.sixStorageGotoAddon = function () {
  app.sixStorageGotoAddon();
};

window.sixStorageCheckPhoneNumber = function (event) {
  app.helper.sixStorageCheckPhoneNumber(event);
};

window.sixStorageRestictNumber = function (event) {
  app.helper.sixStorageRestictNumber(event);
};

var phone1 = document.getElementById("six_storage_phone1");
var phone2 = document.getElementById("six_storage_phone2");
var email = document.getElementById("six_storage_email"); //let emergency_contact_email = document.getElementById("emergency_contact_email");

phone1.oninput = app.helper.sixStorageCheckPhoneNumber;
phone2.oninput = app.helper.sixStorageCheckPhoneNumber;
email.onchange = app.helper.sixStorageCheckEmail; //emergency_contact_email.onchange = app.helper.sixStorageCheckEmail;

window.sixStorageCheckEmail = function () {
  app.helper.sixStorageCheckEmail();
};

var formInputFields = document.getElementsByClassName("six-storage-floating-input");
Array.prototype.forEach.call(formInputFields, function (field) {
  field.addEventListener('change', function (event) {
    app.sixStorageFieldChange(event);
  });
});
var formSelectFields = document.getElementsByClassName("six-storage-floating-select");
Array.prototype.forEach.call(formSelectFields, function (field) {
  field.addEventListener('change', function (event) {
    app.sixStorageFieldChange(event);
  });
}); // Restricting symbols <>

var address1 = document.getElementById('six_storage_address1');
address1.oninput = app.helper.sixStorageRestictNumber;
var address2 = document.getElementById('six_storage_address2');
address2.oninput = app.helper.sixStorageRestictNumber;
var state = document.getElementById('six_storage_state');
state.oninput = app.helper.sixStorageRestictNumber;
var zipcode = document.getElementById('six_storage_zip_code');
zipcode.oninput = app.helper.sixStorageRestictNumber;
var city = document.getElementById('six_storage_city');
city.oninput = app.helper.sixStorageRestictNumber;
var contry = document.getElementById('six_storage_country');
contry.oninput = app.helper.sixStorageRestictNumber; //        Restricting symbols  ///ENd ///

window.sixStorageLoadPaymentForm = function (e) {
  app.sixStorageLoadPaymentForm(e);
};

window.sixStorageIsNumber = function (event) {
  app.sixStorageIsNumber(event);
};

window.sixStorageGetBufferTime = function () {
  app.sixStorageGetBufferTime();
};

window.sixStorageGenerateUnitsInfo = function (units, move_in_date, invoice_period, invoice_reccuring, additional_months, change) {
  app.sixStorageGenerateUnitsInfo(units, move_in_date, invoice_period, invoice_reccuring, additional_months, change);
};

window.sixStorageClickInputHiglight = function (ele) {
  app.sixStorageClickInputHiglight(ele);
};

window.sixStorageBlurInputHighlight = function (ele) {
  app.sixStorageBlurInputHighlight(ele);
};

window.sixStorageAddMerchandiseCart = function (unitId, itemId, itamName, itemImage) {
  app.sixStorageAddMerchandiseCart(unitId, itemId, itamName, itemImage);
};

window.sixStorageDisplayDate = function (date) {
  return app.sixStorageDisplayDate(date);
};

window.sixStorageDisplayCurrency = function (amount) {
  return app.sixStorageDisplayCurrency(amount);
};

window.sixStorageDisplayNumber = function (number) {
  return app.sixStorageDisplayNumber(number);
};

window.sixStorageDisplayPercent = function (number) {
  return app.sixStorageDisplayPercent(number);
};

window.sixStorageGridToggle = function (ele) {
  app.sixStorageGridToggle(ele);
};

window.sixStorageRemoveUnitCount = function (index, unitTypeId, hasDiscount) {
  app.sixStorageRemoveUnitCount(index, unitTypeId, hasDiscount);
};

window.sixStorageAddUnitCount = function (index, unitTypeId, vacant, hasDiscount) {
  app.sixStorageAddUnitCount(index, unitTypeId, vacant, hasDiscount);
};

window.sixStorageRentSingleUnitGetSelected = function (index, unitTypeId, vacant, unitId, isSingleUnit) {
  app.sixStorageRentSingleUnitGetSelected(index, unitTypeId, vacant, unitId, isSingleUnit);
};

window.sixStorageCheckNumber = function (event) {
  return app.helper.sixStorageCheckNumber(event);
};

window.sixStorageForgotPassword = function () {
  return app.sixStorageForgotPassword();
};

window.sixStorageResetPassword = function () {
  return app.sixStorageResetPassword();
};

window.sixStorageSetResetPassword = function () {
  return app.sixStorageSetResetPassword();
};

window.sixStoragesetResetPasswordSave = function () {
  return app.sixStoragesetResetPasswordSave();
};

window.validatePassword = function () {
  return app.validatePassword();
};

window.sixStorageChangeSavecard = function () {
  return app.sixStorageChangeSavecard();
};

window.sixStorageSavedCardCheckBox = function () {
  return app.sixStorageSavedCardCheckBox();
};

window.sixStorageSubmitConfirmationCode = function (password) {
  return app.sixStorageSubmitConfirmationCode(password);
};

window.sixStorageResendConfirmationCode = function () {
  return app.sixStorageResendConfirmationCode();
};

window.sixStorageSubmitPasswordConfirmationCode = function () {
  return app.sixStorageSubmitPasswordConfirmationCode();
};

window.sixStorageTogglePasswordVisibility = function (field) {
  app.helper.sixStorageTogglePasswordVisibility(field);
};

window.sixStorageSaveMoveinPayLater = function () {
  app.sixStorageSaveMoveinPayLater();
};

window.sixStorageSaveMoveinDetails = function (isPaylater) {
  app.sixStorageSaveMoveinDetails(isPaylater);
};

window.sixStorageEnquiry = function (unittypeId) {
  app.sixStorageEnquiry(unittypeId);
};

window.sixStorageReservenow = function (flag) {
  app.sixStorageReservenow(flag);
};

window.sixStorageNewEnquiryModal = function (flag) {
  app.sixStorageNewEnquiryModal(flag);
};

window.sixStorageConstructreservepage = function (unitSelected) {
  app.sixStorageConstructreservepage(unitSelected);
};

window.sixStorageLoadLeadSource = function () {
  app.sixStorageLoadLeadSource();
};

window.sixStorageTenLoadLeadSource = function () {
  app.sixStorageTenLoadLeadSource();
};

window.sixStorageStorageSelectedLead = function (event) {
  app.sixStorageStorageSelectedLead(event);
};

window.sixStorageStorageTenSelectedLead = function (event) {
  app.sixStorageStorageTenSelectedLead(event);
};

window.sixStorageReservationPaymentForm = function () {
  app.sixStorageReservationPaymentForm();
};

window.closeAlert = function () {
  app.closeAlert();
};

window.sixStorageThirdPartyInsurnaceSelected = function (unitId) {
  app.sixStorageThirdPartyInsurnaceSelected(unitId);
};

window.sixStorageAddThirdPartyDetails = function () {
  app.sixStorageAddThirdPartyDetails();
};

window.sixstorageValidateCustomFields = function () {
  app.sixstorageValidateCustomFields();
};

window.addEventListener('click', function (e) {
  if (document.getElementById('sixStorageRentLeadSource').contains(e.target)) {
    document.getElementById('six_storage_lead_sourceaccord').style.display = 'block';
  } else {
    document.getElementById('six_storage_lead_sourceaccord').style.display = 'none';
  }
});

window.sixStorageCheckAlphanumeric = function (event) {
  app.helper.sixStorageCheckAlphanumeric(event);
};

window.sixStorageCheckOnlyAlphaNumeric = function (event) {
  app.helper.sixStorageCheckOnlyAlphaNumeric(event);
};

window.sixStorageCheckNumber = function (event) {
  app.helper.sixStorageCheckNumber(event);
};

window.sixStorageCheckAlphabets = function (event) {
  app.helper.sixStorageCheckAlphabets(event);
};

window.sixStorageAddVehicleDetails = function (display_add) {
  app.sixStorageAddVehicleDetails(display_add);
};

document.getElementById('six-storage-sort-icon').addEventListener('click', function (event) {
  app.sixStorageSortIcon();
});
document.getElementById('six-storage-applyfilter').addEventListener('click', function (event) {
  app.sixStorageSearchUnits();
});
document.getElementById('six-storage-location').addEventListener('change', function (event) {
  sessionStorage.removeItem("Locationlist");
  app.sixStorageSearchUnits();
});
var sixstorahebuidlinglist = document.getElementById('six-storage-building');

if (typeof sixstorahebuidlinglist !== "undefined" && sixstorahebuidlinglist !== null) {
  sixstorahebuidlinglist.addEventListener('change', function (event) {
    app.sixStorageSearchUnits();
    app.sixStorageConstructAmenitiesOptions();
  });
}

window.sixStorageShowLoader = function () {
  app.sixStorageShowLoader();
};

window.SixStorageDashboard = function () {
  app.SixStorageDashboard();
};

window.sixStorageRenderleaseAgreementOnClick = function (data) {
  app.sixStorageRenderleaseAgreementOnClick(data);
};

},{"./materialize":12,"./modules/MoveInApp.js":14}]},{},[16]);
